import { IDominioResponseQA } from "../../interfaces/dados-pessoais/dominio-qa-response.interface";

export const PROFISSOES:IDominioResponseQA ={
  codigo_dominio:0,
  descricao_conceito_dominio:'',
  headers:null,
  nome_dominio:'',
  nome_referencia_dominio:'',
  valores_dominio:[
    {
      "codigo_valor_dominio": 1265,
      "codigo_referencia_valor_dominio": "010115",
      "nome_resumido_valor_dominio": "OFICIAL GENERAL DA MARINHA",
      "nome_completo_valor_dominio": "OFICIAL GENERAL DA MARINHA",
      "descricao_conceito_valor_dominio": "OFICIAL GENERAL DA MARINHA"
    },
    {
      "codigo_valor_dominio": 1266,
      "codigo_referencia_valor_dominio": "215205",
      "nome_resumido_valor_dominio": "OFICIAL SUPERIOR DE MAQUINAS DA MARINHA MERCANTE",
      "nome_completo_valor_dominio": "OFICIAL SUPERIOR DE MAQUINAS DA MARINHA MERCANTE",
      "descricao_conceito_valor_dominio": "OFICIAL SUPERIOR DE MAQUINAS DA MARINHA MERCANTE"
    },
    {
      "codigo_valor_dominio": 1267,
      "codigo_referencia_valor_dominio": "010110",
      "nome_resumido_valor_dominio": "OFICIAL GENERAL DO EXERCITO",
      "nome_completo_valor_dominio": "OFICIAL GENERAL DO EXERCITO",
      "descricao_conceito_valor_dominio": "OFICIAL GENERAL DO EXERCITO"
    },
    {
      "codigo_valor_dominio": 1268,
      "codigo_referencia_valor_dominio": "010215",
      "nome_resumido_valor_dominio": "OFICIAL DA MARINHA",
      "nome_completo_valor_dominio": "OFICIAL DA MARINHA",
      "descricao_conceito_valor_dominio": "OFICIAL DA MARINHA"
    },
    {
      "codigo_valor_dominio": 1269,
      "codigo_referencia_valor_dominio": "241310",
      "nome_resumido_valor_dominio": "OFICIAL DO REGISTRO CIVIL DE PESSOAS JURIDICAS",
      "nome_completo_valor_dominio": "OFICIAL DO REGISTRO CIVIL DE PESSOAS JURIDICAS",
      "descricao_conceito_valor_dominio": "OFICIAL DO REGISTRO CIVIL DE PESSOAS JURIDICAS"
    },
    {
      "codigo_valor_dominio": 1270,
      "codigo_referencia_valor_dominio": "242905",
      "nome_resumido_valor_dominio": "OFICIAL DE INTELIGENCIA",
      "nome_completo_valor_dominio": "OFICIAL DE INTELIGENCIA",
      "descricao_conceito_valor_dominio": "OFICIAL DE INTELIGENCIA"
    },
    {
      "codigo_valor_dominio": 1271,
      "codigo_referencia_valor_dominio": "010315",
      "nome_resumido_valor_dominio": "PRACA DA MARINHA",
      "nome_completo_valor_dominio": "PRACA DA MARINHA",
      "descricao_conceito_valor_dominio": "PRACA DA MARINHA"
    },
    {
      "codigo_valor_dominio": 1272,
      "codigo_referencia_valor_dominio": "215145",
      "nome_resumido_valor_dominio": "PRATICO DE PORTOS DA MARINHA MERCANTE",
      "nome_completo_valor_dominio": "PRATICO DE PORTOS DA MARINHA MERCANTE",
      "descricao_conceito_valor_dominio": "PRATICO DE PORTOS DA MARINHA MERCANTE"
    },
    {
      "codigo_valor_dominio": 1273,
      "codigo_referencia_valor_dominio": "010310",
      "nome_resumido_valor_dominio": "PRACA DO EXERCITO",
      "nome_completo_valor_dominio": "PRACA DO EXERCITO",
      "descricao_conceito_valor_dominio": "PRACA DO EXERCITO"
    },
    {
      "codigo_valor_dominio": 1274,
      "codigo_referencia_valor_dominio": "354605",
      "nome_resumido_valor_dominio": "CORRETOR DE IMOVEIS",
      "nome_completo_valor_dominio": "CORRETOR DE IMOVEIS",
      "descricao_conceito_valor_dominio": "CORRETOR DE IMOVEIS"
    },
    {
      "codigo_valor_dominio": 1275,
      "codigo_referencia_valor_dominio": "263115",
      "nome_resumido_valor_dominio": "TEOLOGO",
      "nome_completo_valor_dominio": "TEOLOGO",
      "descricao_conceito_valor_dominio": "TEOLOGO"
    },
    {
      "codigo_valor_dominio": 1276,
      "codigo_referencia_valor_dominio": "376240",
      "nome_resumido_valor_dominio": "MALABARISTA",
      "nome_completo_valor_dominio": "MALABARISTA",
      "descricao_conceito_valor_dominio": "MALABARISTA"
    },
    {
      "codigo_valor_dominio": 1277,
      "codigo_referencia_valor_dominio": "020205",
      "nome_resumido_valor_dominio": "CAPITAO DA POLICIA MILITAR",
      "nome_completo_valor_dominio": "CAPITAO DA POLICIA MILITAR",
      "descricao_conceito_valor_dominio": "CAPITAO DA POLICIA MILITAR"
    },
    {
      "codigo_valor_dominio": 1278,
      "codigo_referencia_valor_dominio": "842110",
      "nome_resumido_valor_dominio": "PROCESSADOR DE FUMO",
      "nome_completo_valor_dominio": "PROCESSADOR DE FUMO",
      "descricao_conceito_valor_dominio": "PROCESSADOR DE FUMO"
    },
    {
      "codigo_valor_dominio": 1279,
      "codigo_referencia_valor_dominio": "519210",
      "nome_resumido_valor_dominio": "SELECIONADOR DE MATERIAL RECICLAVEL",
      "nome_completo_valor_dominio": "SELECIONADOR DE MATERIAL RECICLAVEL",
      "descricao_conceito_valor_dominio": "SELECIONADOR DE MATERIAL RECICLAVEL"
    },
    {
      "codigo_valor_dominio": 1280,
      "codigo_referencia_valor_dominio": "215220",
      "nome_resumido_valor_dominio": "SUPERINTENDENTE TECNICO NO TRANSPORTE AQUAVIARIO",
      "nome_completo_valor_dominio": "SUPERINTENDENTE TECNICO NO TRANSPORTE AQUAVIARIO",
      "descricao_conceito_valor_dominio": "SUPERINTENDENTE TECNICO NO TRANSPORTE AQUAVIARIO"
    },
    {
      "codigo_valor_dominio": 1281,
      "codigo_referencia_valor_dominio": "772115",
      "nome_resumido_valor_dominio": "SECADOR DE MADEIRA",
      "nome_completo_valor_dominio": "SECADOR DE MADEIRA",
      "descricao_conceito_valor_dominio": "SECADOR DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 1282,
      "codigo_referencia_valor_dominio": "021205",
      "nome_resumido_valor_dominio": "CABO DA POLICIA MILITAR",
      "nome_completo_valor_dominio": "CABO DA POLICIA MILITAR",
      "descricao_conceito_valor_dominio": "CABO DA POLICIA MILITAR"
    },
    {
      "codigo_valor_dominio": 1283,
      "codigo_referencia_valor_dominio": "724315",
      "nome_resumido_valor_dominio": "SOLDADOR",
      "nome_completo_valor_dominio": "SOLDADOR",
      "descricao_conceito_valor_dominio": "SOLDADOR"
    },
    {
      "codigo_valor_dominio": 1284,
      "codigo_referencia_valor_dominio": "020105",
      "nome_resumido_valor_dominio": "CORONEL DA POLICIA MILITAR",
      "nome_completo_valor_dominio": "CORONEL DA POLICIA MILITAR",
      "descricao_conceito_valor_dominio": "CORONEL DA POLICIA MILITAR"
    },
    {
      "codigo_valor_dominio": 1285,
      "codigo_referencia_valor_dominio": "020115",
      "nome_resumido_valor_dominio": "MAJOR DA POLICIA MILITAR",
      "nome_completo_valor_dominio": "MAJOR DA POLICIA MILITAR",
      "descricao_conceito_valor_dominio": "MAJOR DA POLICIA MILITAR"
    },
    {
      "codigo_valor_dominio": 1286,
      "codigo_referencia_valor_dominio": "020110",
      "nome_resumido_valor_dominio": "TENENTE-CORONEL DA POLICIA MILITAR",
      "nome_completo_valor_dominio": "TENENTE-CORONEL DA POLICIA MILITAR",
      "descricao_conceito_valor_dominio": "TENENTE-CORONEL DA POLICIA MILITAR"
    },
    {
      "codigo_valor_dominio": 1287,
      "codigo_referencia_valor_dominio": "030205",
      "nome_resumido_valor_dominio": "CAPITAO BOMBEIRO MILITAR",
      "nome_completo_valor_dominio": "CAPITAO BOMBEIRO MILITAR",
      "descricao_conceito_valor_dominio": "CAPITAO BOMBEIRO MILITAR"
    },
    {
      "codigo_valor_dominio": 1288,
      "codigo_referencia_valor_dominio": "030115",
      "nome_resumido_valor_dominio": "TENENTE-CORONEL BOMBEIRO MILITAR",
      "nome_completo_valor_dominio": "TENENTE-CORONEL BOMBEIRO MILITAR",
      "descricao_conceito_valor_dominio": "TENENTE-CORONEL BOMBEIRO MILITAR"
    },
    {
      "codigo_valor_dominio": 1289,
      "codigo_referencia_valor_dominio": "021105",
      "nome_resumido_valor_dominio": "SUBTENENTE DA POLICIA MILITAR",
      "nome_completo_valor_dominio": "SUBTENENTE DA POLICIA MILITAR",
      "descricao_conceito_valor_dominio": "SUBTENENTE DA POLICIA MILITAR"
    },
    {
      "codigo_valor_dominio": 1290,
      "codigo_referencia_valor_dominio": "021110",
      "nome_resumido_valor_dominio": "SARGENTO DA POLICIA MILITAR",
      "nome_completo_valor_dominio": "SARGENTO DA POLICIA MILITAR",
      "descricao_conceito_valor_dominio": "SARGENTO DA POLICIA MILITAR"
    },
    {
      "codigo_valor_dominio": 1291,
      "codigo_referencia_valor_dominio": "031205",
      "nome_resumido_valor_dominio": "CABO BOMBEIRO MILITAR",
      "nome_completo_valor_dominio": "CABO BOMBEIRO MILITAR",
      "descricao_conceito_valor_dominio": "CABO BOMBEIRO MILITAR"
    },
    {
      "codigo_valor_dominio": 1292,
      "codigo_referencia_valor_dominio": "021210",
      "nome_resumido_valor_dominio": "SOLDADO DA POLICIA MILITAR",
      "nome_completo_valor_dominio": "SOLDADO DA POLICIA MILITAR",
      "descricao_conceito_valor_dominio": "SOLDADO DA POLICIA MILITAR"
    },
    {
      "codigo_valor_dominio": 1293,
      "codigo_referencia_valor_dominio": "516610",
      "nome_resumido_valor_dominio": "SEPULTADOR",
      "nome_completo_valor_dominio": "SEPULTADOR",
      "descricao_conceito_valor_dominio": "SEPULTADOR"
    },
    {
      "codigo_valor_dominio": 1294,
      "codigo_referencia_valor_dominio": "762110",
      "nome_resumido_valor_dominio": "DESCARNADOR DE COUROS E PELES, A MAQUINA",
      "nome_completo_valor_dominio": "DESCARNADOR DE COUROS E PELES, A MAQUINA",
      "descricao_conceito_valor_dominio": "DESCARNADOR DE COUROS E PELES, A MAQUINA"
    },
    {
      "codigo_valor_dominio": 1295,
      "codigo_referencia_valor_dominio": "111110",
      "nome_resumido_valor_dominio": "DEPUTADO FEDERAL",
      "nome_completo_valor_dominio": "DEPUTADO FEDERAL",
      "descricao_conceito_valor_dominio": "DEPUTADO FEDERAL"
    },
    {
      "codigo_valor_dominio": 1296,
      "codigo_referencia_valor_dominio": "717025",
      "nome_resumido_valor_dominio": "VIBRADORISTA",
      "nome_completo_valor_dominio": "VIBRADORISTA",
      "descricao_conceito_valor_dominio": "VIBRADORISTA"
    },
    {
      "codigo_valor_dominio": 1297,
      "codigo_referencia_valor_dominio": "215210",
      "nome_resumido_valor_dominio": "PRIMEIRO OFICIAL DE MAQUINAS DA MARINHA MERCANTE",
      "nome_completo_valor_dominio": "PRIMEIRO OFICIAL DE MAQUINAS DA MARINHA MERCANTE",
      "descricao_conceito_valor_dominio": "PRIMEIRO OFICIAL DE MAQUINAS DA MARINHA MERCANTE"
    },
    {
      "codigo_valor_dominio": 1298,
      "codigo_referencia_valor_dominio": "716305",
      "nome_resumido_valor_dominio": "VIDRACEIRO",
      "nome_completo_valor_dominio": "VIDRACEIRO",
      "descricao_conceito_valor_dominio": "VIDRACEIRO"
    },
    {
      "codigo_valor_dominio": 1299,
      "codigo_referencia_valor_dominio": "111320",
      "nome_resumido_valor_dominio": "MINISTRO DO SUPERIOR TRIBUNAL DO TRABALHO",
      "nome_completo_valor_dominio": "MINISTRO DO SUPERIOR TRIBUNAL DO TRABALHO",
      "descricao_conceito_valor_dominio": "MINISTRO DO SUPERIOR TRIBUNAL DO TRABALHO"
    },
    {
      "codigo_valor_dominio": 1300,
      "codigo_referencia_valor_dominio": "215215",
      "nome_resumido_valor_dominio": "SEGUNDO OFICIAL DE MAQUINAS DA MARINHA MERCANTE",
      "nome_completo_valor_dominio": "SEGUNDO OFICIAL DE MAQUINAS DA MARINHA MERCANTE",
      "descricao_conceito_valor_dominio": "SEGUNDO OFICIAL DE MAQUINAS DA MARINHA MERCANTE"
    },
    {
      "codigo_valor_dominio": 1301,
      "codigo_referencia_valor_dominio": "781705",
      "nome_resumido_valor_dominio": "MERGULHADOR PROFISSIONAL (RASO E PROFUNDO)",
      "nome_completo_valor_dominio": "MERGULHADOR PROFISSIONAL (RASO E PROFUNDO)",
      "descricao_conceito_valor_dominio": "MERGULHADOR PROFISSIONAL (RASO E PROFUNDO)"
    },
    {
      "codigo_valor_dominio": 1302,
      "codigo_referencia_valor_dominio": "111235",
      "nome_resumido_valor_dominio": "GOVERNADOR DO DISTRITO FEDERAL",
      "nome_completo_valor_dominio": "GOVERNADOR DO DISTRITO FEDERAL",
      "descricao_conceito_valor_dominio": "GOVERNADOR DO DISTRITO FEDERAL"
    },
    {
      "codigo_valor_dominio": 1303,
      "codigo_referencia_valor_dominio": "513115",
      "nome_resumido_valor_dominio": "GOVERNANTA DE HOTELARIA",
      "nome_completo_valor_dominio": "GOVERNANTA DE HOTELARIA",
      "descricao_conceito_valor_dominio": "GOVERNANTA DE HOTELARIA"
    },
    {
      "codigo_valor_dominio": 1304,
      "codigo_referencia_valor_dominio": "111245",
      "nome_resumido_valor_dominio": "VICE-GOVERNADOR DO DISTRITO FEDERAL",
      "nome_completo_valor_dominio": "VICE-GOVERNADOR DO DISTRITO FEDERAL",
      "descricao_conceito_valor_dominio": "VICE-GOVERNADOR DO DISTRITO FEDERAL"
    },
    {
      "codigo_valor_dominio": 1305,
      "codigo_referencia_valor_dominio": "111255",
      "nome_resumido_valor_dominio": "VICE-PREFEITO",
      "nome_completo_valor_dominio": "VICE-PREFEITO",
      "descricao_conceito_valor_dominio": "VICE-PREFEITO"
    },
    {
      "codigo_valor_dominio": 1306,
      "codigo_referencia_valor_dominio": "762330",
      "nome_resumido_valor_dominio": "PRENSADOR DE COUROS E PELES",
      "nome_completo_valor_dominio": "PRENSADOR DE COUROS E PELES",
      "descricao_conceito_valor_dominio": "PRENSADOR DE COUROS E PELES"
    },
    {
      "codigo_valor_dominio": 1307,
      "codigo_referencia_valor_dominio": "111210",
      "nome_resumido_valor_dominio": "VICE-PRESIDENTE DA REPUBLICA",
      "nome_completo_valor_dominio": "VICE-PRESIDENTE DA REPUBLICA",
      "descricao_conceito_valor_dominio": "VICE-PRESIDENTE DA REPUBLICA"
    },
    {
      "codigo_valor_dominio": 1308,
      "codigo_referencia_valor_dominio": "263110",
      "nome_resumido_valor_dominio": "MISSIONARIO",
      "nome_completo_valor_dominio": "MISSIONARIO",
      "descricao_conceito_valor_dominio": "MISSIONARIO"
    },
    {
      "codigo_valor_dominio": 1309,
      "codigo_referencia_valor_dominio": "111305",
      "nome_resumido_valor_dominio": "MINISTRO DO SUPREMO TRIBUNAL FEDERAL",
      "nome_completo_valor_dominio": "MINISTRO DO SUPREMO TRIBUNAL FEDERAL",
      "descricao_conceito_valor_dominio": "MINISTRO DO SUPREMO TRIBUNAL FEDERAL"
    },
    {
      "codigo_valor_dominio": 1310,
      "codigo_referencia_valor_dominio": "111310",
      "nome_resumido_valor_dominio": "MINISTRO DO SUPERIOR TRIBUNAL DE JUSTICA",
      "nome_completo_valor_dominio": "MINISTRO DO SUPERIOR TRIBUNAL DE JUSTICA",
      "descricao_conceito_valor_dominio": "MINISTRO DO SUPERIOR TRIBUNAL DE JUSTICA"
    },
    {
      "codigo_valor_dominio": 1311,
      "codigo_referencia_valor_dominio": "111315",
      "nome_resumido_valor_dominio": "MINISTRO DO SUPERIOR TRIBUNAL MILITAR",
      "nome_completo_valor_dominio": "MINISTRO DO SUPERIOR TRIBUNAL MILITAR",
      "descricao_conceito_valor_dominio": "MINISTRO DO SUPERIOR TRIBUNAL MILITAR"
    },
    {
      "codigo_valor_dominio": 1312,
      "codigo_referencia_valor_dominio": "111345",
      "nome_resumido_valor_dominio": "JUIZ DO TRABALHO",
      "nome_completo_valor_dominio": "JUIZ DO TRABALHO",
      "descricao_conceito_valor_dominio": "JUIZ DO TRABALHO"
    },
    {
      "codigo_valor_dominio": 1313,
      "codigo_referencia_valor_dominio": "415125",
      "nome_resumido_valor_dominio": "KARDEXISTA",
      "nome_completo_valor_dominio": "KARDEXISTA",
      "descricao_conceito_valor_dominio": "KARDEXISTA"
    },
    {
      "codigo_valor_dominio": 1314,
      "codigo_referencia_valor_dominio": "111325",
      "nome_resumido_valor_dominio": "JUIZ DE DIREITO",
      "nome_completo_valor_dominio": "JUIZ DE DIREITO",
      "descricao_conceito_valor_dominio": "JUIZ DE DIREITO"
    },
    {
      "codigo_valor_dominio": 1315,
      "codigo_referencia_valor_dominio": "111335",
      "nome_resumido_valor_dominio": "JUIZ AUDITOR FEDERAL - JUSTICA MILITAR",
      "nome_completo_valor_dominio": "JUIZ AUDITOR FEDERAL - JUSTICA MILITAR",
      "descricao_conceito_valor_dominio": "JUIZ AUDITOR FEDERAL - JUSTICA MILITAR"
    },
    {
      "codigo_valor_dominio": 1316,
      "codigo_referencia_valor_dominio": "111330",
      "nome_resumido_valor_dominio": "JUIZ FEDERAL",
      "nome_completo_valor_dominio": "JUIZ FEDERAL",
      "descricao_conceito_valor_dominio": "JUIZ FEDERAL"
    },
    {
      "codigo_valor_dominio": 1317,
      "codigo_referencia_valor_dominio": "111415",
      "nome_resumido_valor_dominio": "DIRIGENTE DO SERVICO PUBLICO MUNICIPAL",
      "nome_completo_valor_dominio": "DIRIGENTE DO SERVICO PUBLICO MUNICIPAL",
      "descricao_conceito_valor_dominio": "DIRIGENTE DO SERVICO PUBLICO MUNICIPAL"
    },
    {
      "codigo_valor_dominio": 1318,
      "codigo_referencia_valor_dominio": "111405",
      "nome_resumido_valor_dominio": "DIRIGENTE DO SERVICO PUBLICO FEDERAL",
      "nome_completo_valor_dominio": "DIRIGENTE DO SERVICO PUBLICO FEDERAL",
      "descricao_conceito_valor_dominio": "DIRIGENTE DO SERVICO PUBLICO FEDERAL"
    },
    {
      "codigo_valor_dominio": 1319,
      "codigo_referencia_valor_dominio": "114405",
      "nome_resumido_valor_dominio": "DIRIGENTE E ADMINISTRADOR DE ORGANIZACAO DA SOCIEDADE CIVIL",
      "nome_completo_valor_dominio": "DIRIGENTE E ADMINISTRADOR DE ORGANIZACAO DA SOCIEDADE CIVIL SEM FINS LUCRATIVOS",
      "descricao_conceito_valor_dominio": "DIRIGENTE E ADMINISTRADOR DE ORGANIZACAO DA SOCIEDADE CIVIL SEM FINS LUCRATIVOS"
    },
    {
      "codigo_valor_dominio": 1320,
      "codigo_referencia_valor_dominio": "201210",
      "nome_resumido_valor_dominio": "ESPECIALISTA EM CALIBRACOES METROLOGICAS",
      "nome_completo_valor_dominio": "ESPECIALISTA EM CALIBRACOES METROLOGICAS",
      "descricao_conceito_valor_dominio": "ESPECIALISTA EM CALIBRACOES METROLOGICAS"
    },
    {
      "codigo_valor_dominio": 1321,
      "codigo_referencia_valor_dominio": "111510",
      "nome_resumido_valor_dominio": "ANALISTA DE PLANEJAMENTO E ORCAMENTO - APO",
      "nome_completo_valor_dominio": "ANALISTA DE PLANEJAMENTO E ORCAMENTO - APO",
      "descricao_conceito_valor_dominio": "ANALISTA DE PLANEJAMENTO E ORCAMENTO - APO"
    },
    {
      "codigo_valor_dominio": 1322,
      "codigo_referencia_valor_dominio": "113005",
      "nome_resumido_valor_dominio": "CACIQUE",
      "nome_completo_valor_dominio": "CACIQUE",
      "descricao_conceito_valor_dominio": "CACIQUE"
    },
    {
      "codigo_valor_dominio": 1323,
      "codigo_referencia_valor_dominio": "732135",
      "nome_resumido_valor_dominio": "LIGADOR DE LINHAS TELEFONICAS",
      "nome_completo_valor_dominio": "LIGADOR DE LINHAS TELEFONICAS",
      "descricao_conceito_valor_dominio": "LIGADOR DE LINHAS TELEFONICAS"
    },
    {
      "codigo_valor_dominio": 1324,
      "codigo_referencia_valor_dominio": "111225",
      "nome_resumido_valor_dominio": "MEMBRO SUPERIOR DO PODER EXECUTIVO",
      "nome_completo_valor_dominio": "MEMBRO SUPERIOR DO PODER EXECUTIVO",
      "descricao_conceito_valor_dominio": "MEMBRO SUPERIOR DO PODER EXECUTIVO"
    },
    {
      "codigo_valor_dominio": 1325,
      "codigo_referencia_valor_dominio": "111410",
      "nome_resumido_valor_dominio": "DIRIGENTE DO SERVICO PUBLICO ESTADUAL E DISTRITAL",
      "nome_completo_valor_dominio": "DIRIGENTE DO SERVICO PUBLICO ESTADUAL E DISTRITAL",
      "descricao_conceito_valor_dominio": "DIRIGENTE DO SERVICO PUBLICO ESTADUAL E DISTRITAL"
    },
    {
      "codigo_valor_dominio": 1326,
      "codigo_referencia_valor_dominio": "114210",
      "nome_resumido_valor_dominio": "DIRIGENTES DE ENTIDADES PATRONAIS",
      "nome_completo_valor_dominio": "DIRIGENTES DE ENTIDADES PATRONAIS",
      "descricao_conceito_valor_dominio": "DIRIGENTES DE ENTIDADES PATRONAIS"
    },
    {
      "codigo_valor_dominio": 1327,
      "codigo_referencia_valor_dominio": "261210",
      "nome_resumido_valor_dominio": "DOCUMENTALISTA",
      "nome_completo_valor_dominio": "DOCUMENTALISTA",
      "descricao_conceito_valor_dominio": "DOCUMENTALISTA"
    },
    {
      "codigo_valor_dominio": 1328,
      "codigo_referencia_valor_dominio": "114205",
      "nome_resumido_valor_dominio": "DIRIGENTES DE ENTIDADES DE TRABALHADORES",
      "nome_completo_valor_dominio": "DIRIGENTES DE ENTIDADES DE TRABALHADORES",
      "descricao_conceito_valor_dominio": "DIRIGENTES DE ENTIDADES DE TRABALHADORES"
    },
    {
      "codigo_valor_dominio": 1329,
      "codigo_referencia_valor_dominio": "114305",
      "nome_resumido_valor_dominio": "DIRIGENTE E ADMINISTRADOR DE ORGANIZACAO RELIGIOSA",
      "nome_completo_valor_dominio": "DIRIGENTE E ADMINISTRADOR DE ORGANIZACAO RELIGIOSA",
      "descricao_conceito_valor_dominio": "DIRIGENTE E ADMINISTRADOR DE ORGANIZACAO RELIGIOSA"
    },
    {
      "codigo_valor_dominio": 1330,
      "codigo_referencia_valor_dominio": "122205",
      "nome_resumido_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES DA INDUSTRIA DE TRANSFORMACA",
      "nome_completo_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES DA INDUSTRIA DE TRANSFORMACAO, EXTRACAO MINERAL E UTILIDADES",
      "descricao_conceito_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES DA INDUSTRIA DE TRANSFORMACAO, EXTRACAO MINERAL E UTILIDADES"
    },
    {
      "codigo_valor_dominio": 1331,
      "codigo_referencia_valor_dominio": "262220",
      "nome_resumido_valor_dominio": "DIRETOR TEATRAL",
      "nome_completo_valor_dominio": "DIRETOR TEATRAL",
      "descricao_conceito_valor_dominio": "DIRETOR TEATRAL"
    },
    {
      "codigo_valor_dominio": 1332,
      "codigo_referencia_valor_dominio": "122110",
      "nome_resumido_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES EM EMPRESA AQUICOLA",
      "nome_completo_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES EM EMPRESA AQUICOLA",
      "descricao_conceito_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES EM EMPRESA AQUICOLA"
    },
    {
      "codigo_valor_dominio": 1333,
      "codigo_referencia_valor_dominio": "122115",
      "nome_resumido_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES EM EMPRESA FLORESTAL",
      "nome_completo_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES EM EMPRESA FLORESTAL",
      "descricao_conceito_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES EM EMPRESA FLORESTAL"
    },
    {
      "codigo_valor_dominio": 1334,
      "codigo_referencia_valor_dominio": "122120",
      "nome_resumido_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES EM EMPRESA PESQUEIRA",
      "nome_completo_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES EM EMPRESA PESQUEIRA",
      "descricao_conceito_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES EM EMPRESA PESQUEIRA"
    },
    {
      "codigo_valor_dominio": 1335,
      "codigo_referencia_valor_dominio": "122710",
      "nome_resumido_valor_dominio": "DIRETOR DE PRODUTOS BANCARIOS",
      "nome_completo_valor_dominio": "DIRETOR DE PRODUTOS BANCARIOS",
      "descricao_conceito_valor_dominio": "DIRETOR DE PRODUTOS BANCARIOS"
    },
    {
      "codigo_valor_dominio": 1336,
      "codigo_referencia_valor_dominio": "122105",
      "nome_resumido_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES EM EMPRESA AGROPECUARIA",
      "nome_completo_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES EM EMPRESA AGROPECUARIA",
      "descricao_conceito_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES EM EMPRESA AGROPECUARIA"
    },
    {
      "codigo_valor_dominio": 1337,
      "codigo_referencia_valor_dominio": "122610",
      "nome_resumido_valor_dominio": "DIRETOR DE OPERACOES DE SERVICOS DE ARMAZENAMENTO",
      "nome_completo_valor_dominio": "DIRETOR DE OPERACOES DE SERVICOS DE ARMAZENAMENTO",
      "descricao_conceito_valor_dominio": "DIRETOR DE OPERACOES DE SERVICOS DE ARMAZENAMENTO"
    },
    {
      "codigo_valor_dominio": 1338,
      "codigo_referencia_valor_dominio": "122605",
      "nome_resumido_valor_dominio": "DIRETOR DE OPERACOES DE CORREIOS",
      "nome_completo_valor_dominio": "DIRETOR DE OPERACOES DE CORREIOS",
      "descricao_conceito_valor_dominio": "DIRETOR DE OPERACOES DE CORREIOS"
    },
    {
      "codigo_valor_dominio": 1339,
      "codigo_referencia_valor_dominio": "122510",
      "nome_resumido_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES DE HOTEL",
      "nome_completo_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES DE HOTEL",
      "descricao_conceito_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES DE HOTEL"
    },
    {
      "codigo_valor_dominio": 1340,
      "codigo_referencia_valor_dominio": "122515",
      "nome_resumido_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES DE TURISMO",
      "nome_completo_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES DE TURISMO",
      "descricao_conceito_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES DE TURISMO"
    },
    {
      "codigo_valor_dominio": 1341,
      "codigo_referencia_valor_dominio": "262330",
      "nome_resumido_valor_dominio": "DIRETOR DE ARTE",
      "nome_completo_valor_dominio": "DIRETOR DE ARTE",
      "descricao_conceito_valor_dominio": "DIRETOR DE ARTE"
    },
    {
      "codigo_valor_dominio": 1342,
      "codigo_referencia_valor_dominio": "214130",
      "nome_resumido_valor_dominio": "URBANISTA",
      "nome_completo_valor_dominio": "URBANISTA",
      "descricao_conceito_valor_dominio": "URBANISTA"
    },
    {
      "codigo_valor_dominio": 1343,
      "codigo_referencia_valor_dominio": "122305",
      "nome_resumido_valor_dominio": "DIRETOR DE OPERACOES DE OBRAS PUBLICA E CIVIL",
      "nome_completo_valor_dominio": "DIRETOR DE OPERACOES DE OBRAS PUBLICA E CIVIL",
      "descricao_conceito_valor_dominio": "DIRETOR DE OPERACOES DE OBRAS PUBLICA E CIVIL"
    },
    {
      "codigo_valor_dominio": 1344,
      "codigo_referencia_valor_dominio": "122615",
      "nome_resumido_valor_dominio": "DIRETOR DE OPERACOES DE SERVICOS DE TELECOMUNICACOES",
      "nome_completo_valor_dominio": "DIRETOR DE OPERACOES DE SERVICOS DE TELECOMUNICACOES",
      "descricao_conceito_valor_dominio": "DIRETOR DE OPERACOES DE SERVICOS DE TELECOMUNICACOES"
    },
    {
      "codigo_valor_dominio": 1345,
      "codigo_referencia_valor_dominio": "122620",
      "nome_resumido_valor_dominio": "DIRETOR DE OPERACOES DE SERVICOS DE TRANSPORTE",
      "nome_completo_valor_dominio": "DIRETOR DE OPERACOES DE SERVICOS DE TRANSPORTE",
      "descricao_conceito_valor_dominio": "DIRETOR DE OPERACOES DE SERVICOS DE TRANSPORTE"
    },
    {
      "codigo_valor_dominio": 1346,
      "codigo_referencia_valor_dominio": "123705",
      "nome_resumido_valor_dominio": "DIRETOR DE PESQUISA E DESENVOLVIMENTO (P&D)",
      "nome_completo_valor_dominio": "DIRETOR DE PESQUISA E DESENVOLVIMENTO (P&D)",
      "descricao_conceito_valor_dominio": "DIRETOR DE PESQUISA E DESENVOLVIMENTO (P&D)"
    },
    {
      "codigo_valor_dominio": 1347,
      "codigo_referencia_valor_dominio": "122505",
      "nome_resumido_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES DE ALIMENTACAO",
      "nome_completo_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES DE ALIMENTACAO",
      "descricao_conceito_valor_dominio": "DIRETOR DE PRODUCAO E OPERACOES DE ALIMENTACAO"
    },
    {
      "codigo_valor_dominio": 1348,
      "codigo_referencia_valor_dominio": "262210",
      "nome_resumido_valor_dominio": "DIRETOR DE PROGRAMAS DE RADIO",
      "nome_completo_valor_dominio": "DIRETOR DE PROGRAMAS DE RADIO",
      "descricao_conceito_valor_dominio": "DIRETOR DE PROGRAMAS DE RADIO"
    },
    {
      "codigo_valor_dominio": 1349,
      "codigo_referencia_valor_dominio": "372105",
      "nome_resumido_valor_dominio": "DIRETOR DE FOTOGRAFIA",
      "nome_completo_valor_dominio": "DIRETOR DE FOTOGRAFIA",
      "descricao_conceito_valor_dominio": "DIRETOR DE FOTOGRAFIA"
    },
    {
      "codigo_valor_dominio": 1350,
      "codigo_referencia_valor_dominio": "262205",
      "nome_resumido_valor_dominio": "DIRETOR DE CINEMA",
      "nome_completo_valor_dominio": "DIRETOR DE CINEMA",
      "descricao_conceito_valor_dominio": "DIRETOR DE CINEMA"
    },
    {
      "codigo_valor_dominio": 1351,
      "codigo_referencia_valor_dominio": "122730",
      "nome_resumido_valor_dominio": "DIRETOR DE CREDITO (EXCETO CREDITO IMOBILIARIO)",
      "nome_completo_valor_dominio": "DIRETOR DE CREDITO (EXCETO CREDITO IMOBILIARIO)",
      "descricao_conceito_valor_dominio": "DIRETOR DE CREDITO (EXCETO CREDITO IMOBILIARIO)"
    },
    {
      "codigo_valor_dominio": 1352,
      "codigo_referencia_valor_dominio": "122735",
      "nome_resumido_valor_dominio": "DIRETOR DE CREDITO IMOBILIARIO",
      "nome_completo_valor_dominio": "DIRETOR DE CREDITO IMOBILIARIO",
      "descricao_conceito_valor_dominio": "DIRETOR DE CREDITO IMOBILIARIO"
    },
    {
      "codigo_valor_dominio": 1353,
      "codigo_referencia_valor_dominio": "122715",
      "nome_resumido_valor_dominio": "DIRETOR DE CREDITO RURAL",
      "nome_completo_valor_dominio": "DIRETOR DE CREDITO RURAL",
      "descricao_conceito_valor_dominio": "DIRETOR DE CREDITO RURAL"
    },
    {
      "codigo_valor_dominio": 1354,
      "codigo_referencia_valor_dominio": "123805",
      "nome_resumido_valor_dominio": "DIRETOR DE MANUTENCAO",
      "nome_completo_valor_dominio": "DIRETOR DE MANUTENCAO",
      "descricao_conceito_valor_dominio": "DIRETOR DE MANUTENCAO"
    },
    {
      "codigo_valor_dominio": 1355,
      "codigo_referencia_valor_dominio": "122405",
      "nome_resumido_valor_dominio": "DIRETOR DE OPERACOES COMERCIAIS (COMERCIO ATACADISTA E VAREJ",
      "nome_completo_valor_dominio": "DIRETOR DE OPERACOES COMERCIAIS (COMERCIO ATACADISTA E VAREJISTA)",
      "descricao_conceito_valor_dominio": "DIRETOR DE OPERACOES COMERCIAIS (COMERCIO ATACADISTA E VAREJISTA)"
    },
    {
      "codigo_valor_dominio": 1356,
      "codigo_referencia_valor_dominio": "123205",
      "nome_resumido_valor_dominio": "DIRETOR DE RECURSOS HUMANOS",
      "nome_completo_valor_dominio": "DIRETOR DE RECURSOS HUMANOS",
      "descricao_conceito_valor_dominio": "DIRETOR DE RECURSOS HUMANOS"
    },
    {
      "codigo_valor_dominio": 1357,
      "codigo_referencia_valor_dominio": "131105",
      "nome_resumido_valor_dominio": "DIRETOR DE SERVICOS CULTURAIS",
      "nome_completo_valor_dominio": "DIRETOR DE SERVICOS CULTURAIS",
      "descricao_conceito_valor_dominio": "DIRETOR DE SERVICOS CULTURAIS"
    },
    {
      "codigo_valor_dominio": 1358,
      "codigo_referencia_valor_dominio": "123110",
      "nome_resumido_valor_dominio": "DIRETOR ADMINISTRATIVO E FINANCEIRO",
      "nome_completo_valor_dominio": "DIRETOR ADMINISTRATIVO E FINANCEIRO",
      "descricao_conceito_valor_dominio": "DIRETOR ADMINISTRATIVO E FINANCEIRO"
    },
    {
      "codigo_valor_dominio": 1359,
      "codigo_referencia_valor_dominio": "123305",
      "nome_resumido_valor_dominio": "DIRETOR COMERCIAL",
      "nome_completo_valor_dominio": "DIRETOR COMERCIAL",
      "descricao_conceito_valor_dominio": "DIRETOR COMERCIAL"
    },
    {
      "codigo_valor_dominio": 1360,
      "codigo_referencia_valor_dominio": "121010",
      "nome_resumido_valor_dominio": "DIRETOR GERAL DE EMPRESA E ORGANIZACOES (EXCETO DE INTERESSE",
      "nome_completo_valor_dominio": "DIRETOR GERAL DE EMPRESA E ORGANIZACOES (EXCETO DE INTERESSE PUBLICO)",
      "descricao_conceito_valor_dominio": "DIRETOR GERAL DE EMPRESA E ORGANIZACOES (EXCETO DE INTERESSE PUBLICO)"
    },
    {
      "codigo_valor_dominio": 1361,
      "codigo_referencia_valor_dominio": "261115",
      "nome_resumido_valor_dominio": "DIRETOR DE REDACAO",
      "nome_completo_valor_dominio": "DIRETOR DE REDACAO",
      "descricao_conceito_valor_dominio": "DIRETOR DE REDACAO"
    },
    {
      "codigo_valor_dominio": 1362,
      "codigo_referencia_valor_dominio": "122755",
      "nome_resumido_valor_dominio": "DIRETOR DE RISCOS DE MERCADO",
      "nome_completo_valor_dominio": "DIRETOR DE RISCOS DE MERCADO",
      "descricao_conceito_valor_dominio": "DIRETOR DE RISCOS DE MERCADO"
    },
    {
      "codigo_valor_dominio": 1363,
      "codigo_referencia_valor_dominio": "122705",
      "nome_resumido_valor_dominio": "DIRETOR COMERCIAL EM OPERACOES DE INTERMEDIACAO FINANCEIRA",
      "nome_completo_valor_dominio": "DIRETOR COMERCIAL EM OPERACOES DE INTERMEDIACAO FINANCEIRA",
      "descricao_conceito_valor_dominio": "DIRETOR COMERCIAL EM OPERACOES DE INTERMEDIACAO FINANCEIRA"
    },
    {
      "codigo_valor_dominio": 1364,
      "codigo_referencia_valor_dominio": "122745",
      "nome_resumido_valor_dominio": "DIRETOR DE MERCADO DE CAPITAIS",
      "nome_completo_valor_dominio": "DIRETOR DE MERCADO DE CAPITAIS",
      "descricao_conceito_valor_dominio": "DIRETOR DE MERCADO DE CAPITAIS"
    },
    {
      "codigo_valor_dominio": 1365,
      "codigo_referencia_valor_dominio": "123410",
      "nome_resumido_valor_dominio": "DIRETOR DE SUPRIMENTOS NO SERVICO PUBLICO",
      "nome_completo_valor_dominio": "DIRETOR DE SUPRIMENTOS NO SERVICO PUBLICO",
      "descricao_conceito_valor_dominio": "DIRETOR DE SUPRIMENTOS NO SERVICO PUBLICO"
    },
    {
      "codigo_valor_dominio": 1366,
      "codigo_referencia_valor_dominio": "123115",
      "nome_resumido_valor_dominio": "DIRETOR FINANCEIRO",
      "nome_completo_valor_dominio": "DIRETOR FINANCEIRO",
      "descricao_conceito_valor_dominio": "DIRETOR FINANCEIRO"
    },
    {
      "codigo_valor_dominio": 1367,
      "codigo_referencia_valor_dominio": "131205",
      "nome_resumido_valor_dominio": "DIRETOR DE SERVICOS DE SAUDE",
      "nome_completo_valor_dominio": "DIRETOR DE SERVICOS DE SAUDE",
      "descricao_conceito_valor_dominio": "DIRETOR DE SERVICOS DE SAUDE"
    },
    {
      "codigo_valor_dominio": 1368,
      "codigo_referencia_valor_dominio": "121005",
      "nome_resumido_valor_dominio": "DIRETOR DE PLANEJAMENTO ESTRATEGICO",
      "nome_completo_valor_dominio": "DIRETOR DE PLANEJAMENTO ESTRATEGICO",
      "descricao_conceito_valor_dominio": "DIRETOR DE PLANEJAMENTO ESTRATEGICO"
    },
    {
      "codigo_valor_dominio": 1369,
      "codigo_referencia_valor_dominio": "123310",
      "nome_resumido_valor_dominio": "DIRETOR DE MARKETING",
      "nome_completo_valor_dominio": "DIRETOR DE MARKETING",
      "descricao_conceito_valor_dominio": "DIRETOR DE MARKETING"
    },
    {
      "codigo_valor_dominio": 1370,
      "codigo_referencia_valor_dominio": "123605",
      "nome_resumido_valor_dominio": "DIRETOR DE SERVICOS DE INFORMATICA",
      "nome_completo_valor_dominio": "DIRETOR DE SERVICOS DE INFORMATICA",
      "descricao_conceito_valor_dominio": "DIRETOR DE SERVICOS DE INFORMATICA"
    },
    {
      "codigo_valor_dominio": 1371,
      "codigo_referencia_valor_dominio": "123405",
      "nome_resumido_valor_dominio": "DIRETOR DE SUPRIMENTOS",
      "nome_completo_valor_dominio": "DIRETOR DE SUPRIMENTOS",
      "descricao_conceito_valor_dominio": "DIRETOR DE SUPRIMENTOS"
    },
    {
      "codigo_valor_dominio": 1372,
      "codigo_referencia_valor_dominio": "131210",
      "nome_resumido_valor_dominio": "GERENTE DE SERVICOS DE SAUDE",
      "nome_completo_valor_dominio": "GERENTE DE SERVICOS DE SAUDE",
      "descricao_conceito_valor_dominio": "GERENTE DE SERVICOS DE SAUDE"
    },
    {
      "codigo_valor_dominio": 1373,
      "codigo_referencia_valor_dominio": "142530",
      "nome_resumido_valor_dominio": "GERENTE DE SUPORTE TECNICO DE TECNOLOGIA DA INFORMACAO",
      "nome_completo_valor_dominio": "GERENTE DE SUPORTE TECNICO DE TECNOLOGIA DA INFORMACAO",
      "descricao_conceito_valor_dominio": "GERENTE DE SUPORTE TECNICO DE TECNOLOGIA DA INFORMACAO"
    },
    {
      "codigo_valor_dominio": 1374,
      "codigo_referencia_valor_dominio": "131110",
      "nome_resumido_valor_dominio": "DIRETOR DE SERVICOS SOCIAIS",
      "nome_completo_valor_dominio": "DIRETOR DE SERVICOS SOCIAIS",
      "descricao_conceito_valor_dominio": "DIRETOR DE SERVICOS SOCIAIS"
    },
    {
      "codigo_valor_dominio": 1375,
      "codigo_referencia_valor_dominio": "131320",
      "nome_resumido_valor_dominio": "GERENTE DE SERVICOS EDUCACIONAIS DA AREA PUBLICA",
      "nome_completo_valor_dominio": "GERENTE DE SERVICOS EDUCACIONAIS DA AREA PUBLICA",
      "descricao_conceito_valor_dominio": "GERENTE DE SERVICOS EDUCACIONAIS DA AREA PUBLICA"
    },
    {
      "codigo_valor_dominio": 1376,
      "codigo_referencia_valor_dominio": "342125",
      "nome_resumido_valor_dominio": "TECNOLOGO EM LOGISTICA DE TRANSPORTE",
      "nome_completo_valor_dominio": "TECNOLOGO EM LOGISTICA DE TRANSPORTE",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM LOGISTICA DE TRANSPORTE"
    },
    {
      "codigo_valor_dominio": 1377,
      "codigo_referencia_valor_dominio": "131310",
      "nome_resumido_valor_dominio": "DIRETOR DE INSTITUICAO EDUCACIONAL PUBLICA",
      "nome_completo_valor_dominio": "DIRETOR DE INSTITUICAO EDUCACIONAL PUBLICA",
      "descricao_conceito_valor_dominio": "DIRETOR DE INSTITUICAO EDUCACIONAL PUBLICA"
    },
    {
      "codigo_valor_dominio": 1378,
      "codigo_referencia_valor_dominio": "122740",
      "nome_resumido_valor_dominio": "DIRETOR DE LEASING",
      "nome_completo_valor_dominio": "DIRETOR DE LEASING",
      "descricao_conceito_valor_dominio": "DIRETOR DE LEASING"
    },
    {
      "codigo_valor_dominio": 1379,
      "codigo_referencia_valor_dominio": "141615",
      "nome_resumido_valor_dominio": "GERENTE DE LOGISTICA (ARMAZENAGEM E DISTRIBUICAO)",
      "nome_completo_valor_dominio": "GERENTE DE LOGISTICA (ARMAZENAGEM E DISTRIBUICAO)",
      "descricao_conceito_valor_dominio": "GERENTE DE LOGISTICA (ARMAZENAGEM E DISTRIBUICAO)"
    },
    {
      "codigo_valor_dominio": 1380,
      "codigo_referencia_valor_dominio": "131120",
      "nome_resumido_valor_dominio": "GERENTE DE SERVICOS SOCIAIS",
      "nome_completo_valor_dominio": "GERENTE DE SERVICOS SOCIAIS",
      "descricao_conceito_valor_dominio": "GERENTE DE SERVICOS SOCIAIS"
    },
    {
      "codigo_valor_dominio": 1381,
      "codigo_referencia_valor_dominio": "141110",
      "nome_resumido_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES FLORESTAIS",
      "nome_completo_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES FLORESTAIS",
      "descricao_conceito_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES FLORESTAIS"
    },
    {
      "codigo_valor_dominio": 1382,
      "codigo_referencia_valor_dominio": "141115",
      "nome_resumido_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES AGROPECUARIAS",
      "nome_completo_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES AGROPECUARIAS",
      "descricao_conceito_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES AGROPECUARIAS"
    },
    {
      "codigo_valor_dominio": 1383,
      "codigo_referencia_valor_dominio": "141305",
      "nome_resumido_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES DA CONSTRUCAO CIVIL E OBRAS",
      "nome_completo_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES DA CONSTRUCAO CIVIL E OBRAS PUBLICAS",
      "descricao_conceito_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES DA CONSTRUCAO CIVIL E OBRAS PUBLICAS"
    },
    {
      "codigo_valor_dominio": 1384,
      "codigo_referencia_valor_dominio": "141705",
      "nome_resumido_valor_dominio": "GERENTE DE PRODUTOS BANCARIOS",
      "nome_completo_valor_dominio": "GERENTE DE PRODUTOS BANCARIOS",
      "descricao_conceito_valor_dominio": "GERENTE DE PRODUTOS BANCARIOS"
    },
    {
      "codigo_valor_dominio": 1385,
      "codigo_referencia_valor_dominio": "141105",
      "nome_resumido_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES AQUICOLAS",
      "nome_completo_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES AQUICOLAS",
      "descricao_conceito_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES AQUICOLAS"
    },
    {
      "codigo_valor_dominio": 1386,
      "codigo_referencia_valor_dominio": "141120",
      "nome_resumido_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES PESQUEIRAS",
      "nome_completo_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES PESQUEIRAS",
      "descricao_conceito_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES PESQUEIRAS"
    },
    {
      "codigo_valor_dominio": 1387,
      "codigo_referencia_valor_dominio": "141405",
      "nome_resumido_valor_dominio": "COMERCIANTE ATACADISTA",
      "nome_completo_valor_dominio": "COMERCIANTE ATACADISTA",
      "descricao_conceito_valor_dominio": "COMERCIANTE ATACADISTA"
    },
    {
      "codigo_valor_dominio": 1388,
      "codigo_referencia_valor_dominio": "141410",
      "nome_resumido_valor_dominio": "COMERCIANTE VAREJISTA",
      "nome_completo_valor_dominio": "COMERCIANTE VAREJISTA",
      "descricao_conceito_valor_dominio": "COMERCIANTE VAREJISTA"
    },
    {
      "codigo_valor_dominio": 1389,
      "codigo_referencia_valor_dominio": "142315",
      "nome_resumido_valor_dominio": "GERENTE DE MARKETING",
      "nome_completo_valor_dominio": "GERENTE DE MARKETING",
      "descricao_conceito_valor_dominio": "GERENTE DE MARKETING"
    },
    {
      "codigo_valor_dominio": 1390,
      "codigo_referencia_valor_dominio": "141605",
      "nome_resumido_valor_dominio": "GERENTE DE OPERACOES DE TRANSPORTES",
      "nome_completo_valor_dominio": "GERENTE DE OPERACOES DE TRANSPORTES",
      "descricao_conceito_valor_dominio": "GERENTE DE OPERACOES DE TRANSPORTES"
    },
    {
      "codigo_valor_dominio": 1391,
      "codigo_referencia_valor_dominio": "131315",
      "nome_resumido_valor_dominio": "GERENTE DE INSTITUICAO EDUCACIONAL DA AREA PRIVADA",
      "nome_completo_valor_dominio": "GERENTE DE INSTITUICAO EDUCACIONAL DA AREA PRIVADA",
      "descricao_conceito_valor_dominio": "GERENTE DE INSTITUICAO EDUCACIONAL DA AREA PRIVADA"
    },
    {
      "codigo_valor_dominio": 1392,
      "codigo_referencia_valor_dominio": "142110",
      "nome_resumido_valor_dominio": "GERENTE DE RISCOS",
      "nome_completo_valor_dominio": "GERENTE DE RISCOS",
      "descricao_conceito_valor_dominio": "GERENTE DE RISCOS"
    },
    {
      "codigo_valor_dominio": 1393,
      "codigo_referencia_valor_dominio": "141715",
      "nome_resumido_valor_dominio": "GERENTE DE CAMBIO E COMERCIO EXTERIOR",
      "nome_completo_valor_dominio": "GERENTE DE CAMBIO E COMERCIO EXTERIOR",
      "descricao_conceito_valor_dominio": "GERENTE DE CAMBIO E COMERCIO EXTERIOR"
    },
    {
      "codigo_valor_dominio": 1394,
      "codigo_referencia_valor_dominio": "142605",
      "nome_resumido_valor_dominio": "GERENTE DE PESQUISA E DESENVOLVIMENTO (P&D)",
      "nome_completo_valor_dominio": "GERENTE DE PESQUISA E DESENVOLVIMENTO (P&D)",
      "descricao_conceito_valor_dominio": "GERENTE DE PESQUISA E DESENVOLVIMENTO (P&D)"
    },
    {
      "codigo_valor_dominio": 1395,
      "codigo_referencia_valor_dominio": "142320",
      "nome_resumido_valor_dominio": "GERENTE DE VENDAS",
      "nome_completo_valor_dominio": "GERENTE DE VENDAS",
      "descricao_conceito_valor_dominio": "GERENTE DE VENDAS"
    },
    {
      "codigo_valor_dominio": 1396,
      "codigo_referencia_valor_dominio": "141520",
      "nome_resumido_valor_dominio": "GERENTE DE PENSAO",
      "nome_completo_valor_dominio": "GERENTE DE PENSAO",
      "descricao_conceito_valor_dominio": "GERENTE DE PENSAO"
    },
    {
      "codigo_valor_dominio": 1397,
      "codigo_referencia_valor_dominio": "141420",
      "nome_resumido_valor_dominio": "GERENTE DE OPERACOES DE SERVICOS DE ASSISTENCIA TECNICA",
      "nome_completo_valor_dominio": "GERENTE DE OPERACOES DE SERVICOS DE ASSISTENCIA TECNICA",
      "descricao_conceito_valor_dominio": "GERENTE DE OPERACOES DE SERVICOS DE ASSISTENCIA TECNICA"
    },
    {
      "codigo_valor_dominio": 1398,
      "codigo_referencia_valor_dominio": "141415",
      "nome_resumido_valor_dominio": "GERENTE DE LOJA E SUPERMERCADO",
      "nome_completo_valor_dominio": "GERENTE DE LOJA E SUPERMERCADO",
      "descricao_conceito_valor_dominio": "GERENTE DE LOJA E SUPERMERCADO"
    },
    {
      "codigo_valor_dominio": 1399,
      "codigo_referencia_valor_dominio": "142520",
      "nome_resumido_valor_dominio": "GERENTE DE PROJETOS DE TECNOLOGIA DA INFORMACAO",
      "nome_completo_valor_dominio": "GERENTE DE PROJETOS DE TECNOLOGIA DA INFORMACAO",
      "descricao_conceito_valor_dominio": "GERENTE DE PROJETOS DE TECNOLOGIA DA INFORMACAO"
    },
    {
      "codigo_valor_dominio": 1400,
      "codigo_referencia_valor_dominio": "142415",
      "nome_resumido_valor_dominio": "GERENTE DE ALMOXARIFADO",
      "nome_completo_valor_dominio": "GERENTE DE ALMOXARIFADO",
      "descricao_conceito_valor_dominio": "GERENTE DE ALMOXARIFADO"
    },
    {
      "codigo_valor_dominio": 1401,
      "codigo_referencia_valor_dominio": "253205",
      "nome_resumido_valor_dominio": "GERENTE DE CAPTACAO (FUNDOS E INVESTIMENTOS INSTITUCIONAIS)",
      "nome_completo_valor_dominio": "GERENTE DE CAPTACAO (FUNDOS E INVESTIMENTOS INSTITUCIONAIS)",
      "descricao_conceito_valor_dominio": "GERENTE DE CAPTACAO (FUNDOS E INVESTIMENTOS INSTITUCIONAIS)"
    },
    {
      "codigo_valor_dominio": 1402,
      "codigo_referencia_valor_dominio": "141725",
      "nome_resumido_valor_dominio": "GERENTE DE CREDITO IMOBILIARIO",
      "nome_completo_valor_dominio": "GERENTE DE CREDITO IMOBILIARIO",
      "descricao_conceito_valor_dominio": "GERENTE DE CREDITO IMOBILIARIO"
    },
    {
      "codigo_valor_dominio": 1403,
      "codigo_referencia_valor_dominio": "141730",
      "nome_resumido_valor_dominio": "GERENTE DE CREDITO RURAL",
      "nome_completo_valor_dominio": "GERENTE DE CREDITO RURAL",
      "descricao_conceito_valor_dominio": "GERENTE DE CREDITO RURAL"
    },
    {
      "codigo_valor_dominio": 1404,
      "codigo_referencia_valor_dominio": "142210",
      "nome_resumido_valor_dominio": "GERENTE DE DEPARTAMENTO PESSOAL",
      "nome_completo_valor_dominio": "GERENTE DE DEPARTAMENTO PESSOAL",
      "descricao_conceito_valor_dominio": "GERENTE DE DEPARTAMENTO PESSOAL"
    },
    {
      "codigo_valor_dominio": 1405,
      "codigo_referencia_valor_dominio": "142205",
      "nome_resumido_valor_dominio": "GERENTE DE RECURSOS HUMANOS",
      "nome_completo_valor_dominio": "GERENTE DE RECURSOS HUMANOS",
      "descricao_conceito_valor_dominio": "GERENTE DE RECURSOS HUMANOS"
    },
    {
      "codigo_valor_dominio": 1406,
      "codigo_referencia_valor_dominio": "142305",
      "nome_resumido_valor_dominio": "GERENTE COMERCIAL",
      "nome_completo_valor_dominio": "GERENTE COMERCIAL",
      "descricao_conceito_valor_dominio": "GERENTE COMERCIAL"
    },
    {
      "codigo_valor_dominio": 1407,
      "codigo_referencia_valor_dominio": "142525",
      "nome_resumido_valor_dominio": "GERENTE DE SEGURANCA DE TECNOLOGIA DA INFORMACAO",
      "nome_completo_valor_dominio": "GERENTE DE SEGURANCA DE TECNOLOGIA DA INFORMACAO",
      "descricao_conceito_valor_dominio": "GERENTE DE SEGURANCA DE TECNOLOGIA DA INFORMACAO"
    },
    {
      "codigo_valor_dominio": 1408,
      "codigo_referencia_valor_dominio": "716405",
      "nome_resumido_valor_dominio": "GESSEIRO",
      "nome_completo_valor_dominio": "GESSEIRO",
      "descricao_conceito_valor_dominio": "GESSEIRO"
    },
    {
      "codigo_valor_dominio": 1409,
      "codigo_referencia_valor_dominio": "142535",
      "nome_resumido_valor_dominio": "TECNOLOGO EM GESTAO DA TECNOLOGIA DA INFORMACAO",
      "nome_completo_valor_dominio": "TECNOLOGO EM GESTAO DA TECNOLOGIA DA INFORMACAO",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM GESTAO DA TECNOLOGIA DA INFORMACAO"
    },
    {
      "codigo_valor_dominio": 1410,
      "codigo_referencia_valor_dominio": "142505",
      "nome_resumido_valor_dominio": "GERENTE DE REDE",
      "nome_completo_valor_dominio": "GERENTE DE REDE",
      "descricao_conceito_valor_dominio": "GERENTE DE REDE"
    },
    {
      "codigo_valor_dominio": 1411,
      "codigo_referencia_valor_dominio": "142510",
      "nome_resumido_valor_dominio": "GERENTE DE DESENVOLVIMENTO DE SISTEMAS",
      "nome_completo_valor_dominio": "GERENTE DE DESENVOLVIMENTO DE SISTEMAS",
      "descricao_conceito_valor_dominio": "GERENTE DE DESENVOLVIMENTO DE SISTEMAS"
    },
    {
      "codigo_valor_dominio": 1412,
      "codigo_referencia_valor_dominio": "342520",
      "nome_resumido_valor_dominio": "GERENTE DA ADMINISTRACAO DE AEROPORTOS",
      "nome_completo_valor_dominio": "GERENTE DA ADMINISTRACAO DE AEROPORTOS",
      "descricao_conceito_valor_dominio": "GERENTE DA ADMINISTRACAO DE AEROPORTOS"
    },
    {
      "codigo_valor_dominio": 1413,
      "codigo_referencia_valor_dominio": "253215",
      "nome_resumido_valor_dominio": "GERENTE DE CONTAS - PESSOA FISICA E JURIDICA",
      "nome_completo_valor_dominio": "GERENTE DE CONTAS - PESSOA FISICA E JURIDICA",
      "descricao_conceito_valor_dominio": "GERENTE DE CONTAS - PESSOA FISICA E JURIDICA"
    },
    {
      "codigo_valor_dominio": 1414,
      "codigo_referencia_valor_dominio": "141610",
      "nome_resumido_valor_dominio": "GERENTE DE OPERACOES DE CORREIOS E TELECOMUNICACOES",
      "nome_completo_valor_dominio": "GERENTE DE OPERACOES DE CORREIOS E TELECOMUNICACOES",
      "descricao_conceito_valor_dominio": "GERENTE DE OPERACOES DE CORREIOS E TELECOMUNICACOES"
    },
    {
      "codigo_valor_dominio": 1415,
      "codigo_referencia_valor_dominio": "142115",
      "nome_resumido_valor_dominio": "GERENTE FINANCEIRO",
      "nome_completo_valor_dominio": "GERENTE FINANCEIRO",
      "descricao_conceito_valor_dominio": "GERENTE FINANCEIRO"
    },
    {
      "codigo_valor_dominio": 1416,
      "codigo_referencia_valor_dominio": "142310",
      "nome_resumido_valor_dominio": "GERENTE DE COMUNICACAO",
      "nome_completo_valor_dominio": "GERENTE DE COMUNICACAO",
      "descricao_conceito_valor_dominio": "GERENTE DE COMUNICACAO"
    },
    {
      "codigo_valor_dominio": 1417,
      "codigo_referencia_valor_dominio": "141525",
      "nome_resumido_valor_dominio": "GERENTE DE TURISMO",
      "nome_completo_valor_dominio": "GERENTE DE TURISMO",
      "descricao_conceito_valor_dominio": "GERENTE DE TURISMO"
    },
    {
      "codigo_valor_dominio": 1418,
      "codigo_referencia_valor_dominio": "141515",
      "nome_resumido_valor_dominio": "GERENTE DE BAR",
      "nome_completo_valor_dominio": "GERENTE DE BAR",
      "descricao_conceito_valor_dominio": "GERENTE DE BAR"
    },
    {
      "codigo_valor_dominio": 1419,
      "codigo_referencia_valor_dominio": "141510",
      "nome_resumido_valor_dominio": "GERENTE DE RESTAURANTE",
      "nome_completo_valor_dominio": "GERENTE DE RESTAURANTE",
      "descricao_conceito_valor_dominio": "GERENTE DE RESTAURANTE"
    },
    {
      "codigo_valor_dominio": 1420,
      "codigo_referencia_valor_dominio": "342525",
      "nome_resumido_valor_dominio": "GERENTE DE EMPRESA AEREA EM AEROPORTOS",
      "nome_completo_valor_dominio": "GERENTE DE EMPRESA AEREA EM AEROPORTOS",
      "descricao_conceito_valor_dominio": "GERENTE DE EMPRESA AEREA EM AEROPORTOS"
    },
    {
      "codigo_valor_dominio": 1421,
      "codigo_referencia_valor_dominio": "141205",
      "nome_resumido_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES",
      "nome_completo_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES",
      "descricao_conceito_valor_dominio": "GERENTE DE PRODUCAO E OPERACOES"
    },
    {
      "codigo_valor_dominio": 1422,
      "codigo_referencia_valor_dominio": "142705",
      "nome_resumido_valor_dominio": "GERENTE DE PROJETOS E SERVICOS DE MANUTENCAO",
      "nome_completo_valor_dominio": "GERENTE DE PROJETOS E SERVICOS DE MANUTENCAO",
      "descricao_conceito_valor_dominio": "GERENTE DE PROJETOS E SERVICOS DE MANUTENCAO"
    },
    {
      "codigo_valor_dominio": 1423,
      "codigo_referencia_valor_dominio": "131115",
      "nome_resumido_valor_dominio": "GERENTE DE SERVICOS CULTURAIS",
      "nome_completo_valor_dominio": "GERENTE DE SERVICOS CULTURAIS",
      "descricao_conceito_valor_dominio": "GERENTE DE SERVICOS CULTURAIS"
    },
    {
      "codigo_valor_dominio": 1424,
      "codigo_referencia_valor_dominio": "142410",
      "nome_resumido_valor_dominio": "GERENTE DE SUPRIMENTOS",
      "nome_completo_valor_dominio": "GERENTE DE SUPRIMENTOS",
      "descricao_conceito_valor_dominio": "GERENTE DE SUPRIMENTOS"
    },
    {
      "codigo_valor_dominio": 1425,
      "codigo_referencia_valor_dominio": "131215",
      "nome_resumido_valor_dominio": "TECNOLOGO EM GESTAO HOSPITALAR",
      "nome_completo_valor_dominio": "TECNOLOGO EM GESTAO HOSPITALAR",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM GESTAO HOSPITALAR"
    },
    {
      "codigo_valor_dominio": 1426,
      "codigo_referencia_valor_dominio": "142515",
      "nome_resumido_valor_dominio": "GERENTE DE PRODUCAO DE TECNOLOGIA DA INFORMACAO",
      "nome_completo_valor_dominio": "GERENTE DE PRODUCAO DE TECNOLOGIA DA INFORMACAO",
      "descricao_conceito_valor_dominio": "GERENTE DE PRODUCAO DE TECNOLOGIA DA INFORMACAO"
    },
    {
      "codigo_valor_dominio": 1427,
      "codigo_referencia_valor_dominio": "201215",
      "nome_resumido_valor_dominio": "ESPECIALISTA EM ENSAIOS METROLOGICOS",
      "nome_completo_valor_dominio": "ESPECIALISTA EM ENSAIOS METROLOGICOS",
      "descricao_conceito_valor_dominio": "ESPECIALISTA EM ENSAIOS METROLOGICOS"
    },
    {
      "codigo_valor_dominio": 1428,
      "codigo_referencia_valor_dominio": "141735",
      "nome_resumido_valor_dominio": "GERENTE DE RECUPERACAO DE CREDITO",
      "nome_completo_valor_dominio": "GERENTE DE RECUPERACAO DE CREDITO",
      "descricao_conceito_valor_dominio": "GERENTE DE RECUPERACAO DE CREDITO"
    },
    {
      "codigo_valor_dominio": 1429,
      "codigo_referencia_valor_dominio": "214370",
      "nome_resumido_valor_dominio": "TECNOLOGO EM TELECOMUNICACOES",
      "nome_completo_valor_dominio": "TECNOLOGO EM TELECOMUNICACOES",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM TELECOMUNICACOES"
    },
    {
      "codigo_valor_dominio": 1430,
      "codigo_referencia_valor_dominio": "201105",
      "nome_resumido_valor_dominio": "BIOENGENHEIRO",
      "nome_completo_valor_dominio": "BIOENGENHEIRO",
      "descricao_conceito_valor_dominio": "BIOENGENHEIRO"
    },
    {
      "codigo_valor_dominio": 1431,
      "codigo_referencia_valor_dominio": "201110",
      "nome_resumido_valor_dominio": "BIOTECNOLOGISTA",
      "nome_completo_valor_dominio": "BIOTECNOLOGISTA",
      "descricao_conceito_valor_dominio": "BIOTECNOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1432,
      "codigo_referencia_valor_dominio": "213415",
      "nome_resumido_valor_dominio": "GEOFISICO",
      "nome_completo_valor_dominio": "GEOFISICO",
      "descricao_conceito_valor_dominio": "GEOFISICO"
    },
    {
      "codigo_valor_dominio": 1433,
      "codigo_referencia_valor_dominio": "203525",
      "nome_resumido_valor_dominio": "PESQUISADOR EM PSICOLOGIA",
      "nome_completo_valor_dominio": "PESQUISADOR EM PSICOLOGIA",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM PSICOLOGIA"
    },
    {
      "codigo_valor_dominio": 1434,
      "codigo_referencia_valor_dominio": "142610",
      "nome_resumido_valor_dominio": "ESPECIALISTA EM DESENVOLVIMENTO DE CIGARROS",
      "nome_completo_valor_dominio": "ESPECIALISTA EM DESENVOLVIMENTO DE CIGARROS",
      "descricao_conceito_valor_dominio": "ESPECIALISTA EM DESENVOLVIMENTO DE CIGARROS"
    },
    {
      "codigo_valor_dominio": 1435,
      "codigo_referencia_valor_dominio": "201220",
      "nome_resumido_valor_dominio": "ESPECIALISTA EM INSTRUMENTACAO METROLOGICA",
      "nome_completo_valor_dominio": "ESPECIALISTA EM INSTRUMENTACAO METROLOGICA",
      "descricao_conceito_valor_dominio": "ESPECIALISTA EM INSTRUMENTACAO METROLOGICA"
    },
    {
      "codigo_valor_dominio": 1436,
      "codigo_referencia_valor_dominio": "201225",
      "nome_resumido_valor_dominio": "ESPECIALISTA EM MATERIAIS DE REFERENCIA METROLOGICA",
      "nome_completo_valor_dominio": "ESPECIALISTA EM MATERIAIS DE REFERENCIA METROLOGICA",
      "descricao_conceito_valor_dominio": "ESPECIALISTA EM MATERIAIS DE REFERENCIA METROLOGICA"
    },
    {
      "codigo_valor_dominio": 1437,
      "codigo_referencia_valor_dominio": "211110",
      "nome_resumido_valor_dominio": "ESPECIALISTA EM PESQUISA OPERACIONAL",
      "nome_completo_valor_dominio": "ESPECIALISTA EM PESQUISA OPERACIONAL",
      "descricao_conceito_valor_dominio": "ESPECIALISTA EM PESQUISA OPERACIONAL"
    },
    {
      "codigo_valor_dominio": 1438,
      "codigo_referencia_valor_dominio": "214610",
      "nome_resumido_valor_dominio": "ENGENHEIRO METALURGISTA",
      "nome_completo_valor_dominio": "ENGENHEIRO METALURGISTA",
      "descricao_conceito_valor_dominio": "ENGENHEIRO METALURGISTA"
    },
    {
      "codigo_valor_dominio": 1439,
      "codigo_referencia_valor_dominio": "203010",
      "nome_resumido_valor_dominio": "PESQUISADOR EM BIOLOGIA ANIMAL",
      "nome_completo_valor_dominio": "PESQUISADOR EM BIOLOGIA ANIMAL",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM BIOLOGIA ANIMAL"
    },
    {
      "codigo_valor_dominio": 1440,
      "codigo_referencia_valor_dominio": "203015",
      "nome_resumido_valor_dominio": "PESQUISADOR EM BIOLOGIA DE MICROORGANISMOS E PARASITAS",
      "nome_completo_valor_dominio": "PESQUISADOR EM BIOLOGIA DE MICROORGANISMOS E PARASITAS",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM BIOLOGIA DE MICROORGANISMOS E PARASITAS"
    },
    {
      "codigo_valor_dominio": 1441,
      "codigo_referencia_valor_dominio": "203020",
      "nome_resumido_valor_dominio": "PESQUISADOR EM BIOLOGIA HUMANA",
      "nome_completo_valor_dominio": "PESQUISADOR EM BIOLOGIA HUMANA",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM BIOLOGIA HUMANA"
    },
    {
      "codigo_valor_dominio": 1442,
      "codigo_referencia_valor_dominio": "203025",
      "nome_resumido_valor_dominio": "PESQUISADOR EM BIOLOGIA VEGETAL",
      "nome_completo_valor_dominio": "PESQUISADOR EM BIOLOGIA VEGETAL",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM BIOLOGIA VEGETAL"
    },
    {
      "codigo_valor_dominio": 1443,
      "codigo_referencia_valor_dominio": "203405",
      "nome_resumido_valor_dominio": "PESQUISADOR EM CIENCIAS AGRONOMICAS",
      "nome_completo_valor_dominio": "PESQUISADOR EM CIENCIAS AGRONOMICAS",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM CIENCIAS AGRONOMICAS"
    },
    {
      "codigo_valor_dominio": 1444,
      "codigo_referencia_valor_dominio": "203515",
      "nome_resumido_valor_dominio": "PESQUISADOR EM CIENCIAS DA EDUCACAO",
      "nome_completo_valor_dominio": "PESQUISADOR EM CIENCIAS DA EDUCACAO",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM CIENCIAS DA EDUCACAO"
    },
    {
      "codigo_valor_dominio": 1445,
      "codigo_referencia_valor_dominio": "203415",
      "nome_resumido_valor_dominio": "PESQUISADOR EM CIENCIAS DA ZOOTECNIA",
      "nome_completo_valor_dominio": "PESQUISADOR EM CIENCIAS DA ZOOTECNIA",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM CIENCIAS DA ZOOTECNIA"
    },
    {
      "codigo_valor_dominio": 1446,
      "codigo_referencia_valor_dominio": "203520",
      "nome_resumido_valor_dominio": "PESQUISADOR EM HISTORIA",
      "nome_completo_valor_dominio": "PESQUISADOR EM HISTORIA",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM HISTORIA"
    },
    {
      "codigo_valor_dominio": 1447,
      "codigo_referencia_valor_dominio": "203315",
      "nome_resumido_valor_dominio": "PESQUISADOR EM MEDICINA VETERINARIA",
      "nome_completo_valor_dominio": "PESQUISADOR EM MEDICINA VETERINARIA",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM MEDICINA VETERINARIA"
    },
    {
      "codigo_valor_dominio": 1448,
      "codigo_referencia_valor_dominio": "203320",
      "nome_resumido_valor_dominio": "PESQUISADOR EM SAUDE COLETIVA",
      "nome_completo_valor_dominio": "PESQUISADOR EM SAUDE COLETIVA",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM SAUDE COLETIVA"
    },
    {
      "codigo_valor_dominio": 1449,
      "codigo_referencia_valor_dominio": "203210",
      "nome_resumido_valor_dominio": "PESQUISADOR DE ENGENHARIA E TECNOLOGIA (OUTRAS AREAS DA ENGE",
      "nome_completo_valor_dominio": "PESQUISADOR DE ENGENHARIA E TECNOLOGIA (OUTRAS AREAS DA ENGENHARIA)",
      "descricao_conceito_valor_dominio": "PESQUISADOR DE ENGENHARIA E TECNOLOGIA (OUTRAS AREAS DA ENGENHARIA)"
    },
    {
      "codigo_valor_dominio": 1450,
      "codigo_referencia_valor_dominio": "203215",
      "nome_resumido_valor_dominio": "PESQUISADOR DE ENGENHARIA ELETRICA E ELETRONICA",
      "nome_completo_valor_dominio": "PESQUISADOR DE ENGENHARIA ELETRICA E ELETRONICA",
      "descricao_conceito_valor_dominio": "PESQUISADOR DE ENGENHARIA ELETRICA E ELETRONICA"
    },
    {
      "codigo_valor_dominio": 1451,
      "codigo_referencia_valor_dominio": "203220",
      "nome_resumido_valor_dominio": "PESQUISADOR DE ENGENHARIA MECANICA",
      "nome_completo_valor_dominio": "PESQUISADOR DE ENGENHARIA MECANICA",
      "descricao_conceito_valor_dominio": "PESQUISADOR DE ENGENHARIA MECANICA"
    },
    {
      "codigo_valor_dominio": 1452,
      "codigo_referencia_valor_dominio": "203225",
      "nome_resumido_valor_dominio": "PESQUISADOR DE ENGENHARIA METALURGICA, DE MINAS E DE MATERIA",
      "nome_completo_valor_dominio": "PESQUISADOR DE ENGENHARIA METALURGICA, DE MINAS E DE MATERIA",
      "descricao_conceito_valor_dominio": "PESQUISADOR DE ENGENHARIA METALURGICA, DE MINAS E DE MATERIA"
    },
    {
      "codigo_valor_dominio": 1453,
      "codigo_referencia_valor_dominio": "203230",
      "nome_resumido_valor_dominio": "PESQUISADOR DE ENGENHARIA QUIMICA",
      "nome_completo_valor_dominio": "PESQUISADOR DE ENGENHARIA QUIMICA",
      "descricao_conceito_valor_dominio": "PESQUISADOR DE ENGENHARIA QUIMICA"
    },
    {
      "codigo_valor_dominio": 1454,
      "codigo_referencia_valor_dominio": "203310",
      "nome_resumido_valor_dominio": "PESQUISADOR DE MEDICINA BASICA",
      "nome_completo_valor_dominio": "PESQUISADOR DE MEDICINA BASICA",
      "descricao_conceito_valor_dominio": "PESQUISADOR DE MEDICINA BASICA"
    },
    {
      "codigo_valor_dominio": 1455,
      "codigo_referencia_valor_dominio": "203205",
      "nome_resumido_valor_dominio": "PESQUISADOR DE ENGENHARIA CIVIL",
      "nome_completo_valor_dominio": "PESQUISADOR DE ENGENHARIA CIVIL",
      "descricao_conceito_valor_dominio": "PESQUISADOR DE ENGENHARIA CIVIL"
    },
    {
      "codigo_valor_dominio": 1456,
      "codigo_referencia_valor_dominio": "203005",
      "nome_resumido_valor_dominio": "PESQUISADOR EM BIOLOGIA AMBIENTAL",
      "nome_completo_valor_dominio": "PESQUISADOR EM BIOLOGIA AMBIENTAL",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM BIOLOGIA AMBIENTAL"
    },
    {
      "codigo_valor_dominio": 1457,
      "codigo_referencia_valor_dominio": "201205",
      "nome_resumido_valor_dominio": "PESQUISADOR EM METROLOGIA",
      "nome_completo_valor_dominio": "PESQUISADOR EM METROLOGIA",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM METROLOGIA"
    },
    {
      "codigo_valor_dominio": 1458,
      "codigo_referencia_valor_dominio": "213435",
      "nome_resumido_valor_dominio": "PETROGRAFO",
      "nome_completo_valor_dominio": "PETROGRAFO",
      "descricao_conceito_valor_dominio": "PETROGRAFO"
    },
    {
      "codigo_valor_dominio": 1459,
      "codigo_referencia_valor_dominio": "203105",
      "nome_resumido_valor_dominio": "PESQUISADOR EM CIENCIAS DA COMPUTACAO E INFORMATICA",
      "nome_completo_valor_dominio": "PESQUISADOR EM CIENCIAS DA COMPUTACAO E INFORMATICA",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM CIENCIAS DA COMPUTACAO E INFORMATICA"
    },
    {
      "codigo_valor_dominio": 1460,
      "codigo_referencia_valor_dominio": "203110",
      "nome_resumido_valor_dominio": "PESQUISADOR EM CIENCIAS DA TERRA E MEIO AMBIENTE",
      "nome_completo_valor_dominio": "PESQUISADOR EM CIENCIAS DA TERRA E MEIO AMBIENTE",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM CIENCIAS DA TERRA E MEIO AMBIENTE"
    },
    {
      "codigo_valor_dominio": 1461,
      "codigo_referencia_valor_dominio": "203420",
      "nome_resumido_valor_dominio": "PESQUISADOR EM CIENCIAS FLORESTAIS",
      "nome_completo_valor_dominio": "PESQUISADOR EM CIENCIAS FLORESTAIS",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM CIENCIAS FLORESTAIS"
    },
    {
      "codigo_valor_dominio": 1462,
      "codigo_referencia_valor_dominio": "203505",
      "nome_resumido_valor_dominio": "PESQUISADOR EM CIENCIAS SOCIAIS E HUMANAS",
      "nome_completo_valor_dominio": "PESQUISADOR EM CIENCIAS SOCIAIS E HUMANAS",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM CIENCIAS SOCIAIS E HUMANAS"
    },
    {
      "codigo_valor_dominio": 1463,
      "codigo_referencia_valor_dominio": "203510",
      "nome_resumido_valor_dominio": "PESQUISADOR EM ECONOMIA",
      "nome_completo_valor_dominio": "PESQUISADOR EM ECONOMIA",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM ECONOMIA"
    },
    {
      "codigo_valor_dominio": 1464,
      "codigo_referencia_valor_dominio": "203115",
      "nome_resumido_valor_dominio": "PESQUISADOR EM FISICA",
      "nome_completo_valor_dominio": "PESQUISADOR EM FISICA",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM FISICA"
    },
    {
      "codigo_valor_dominio": 1465,
      "codigo_referencia_valor_dominio": "203410",
      "nome_resumido_valor_dominio": "PESQUISADOR EM CIENCIAS DA PESCA E AQUICULTURA",
      "nome_completo_valor_dominio": "PESQUISADOR EM CIENCIAS DA PESCA E AQUICULTURA",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM CIENCIAS DA PESCA E AQUICULTURA"
    },
    {
      "codigo_valor_dominio": 1466,
      "codigo_referencia_valor_dominio": "203120",
      "nome_resumido_valor_dominio": "PESQUISADOR EM MATEMATICA",
      "nome_completo_valor_dominio": "PESQUISADOR EM MATEMATICA",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM MATEMATICA"
    },
    {
      "codigo_valor_dominio": 1467,
      "codigo_referencia_valor_dominio": "203125",
      "nome_resumido_valor_dominio": "PESQUISADOR EM QUIMICA",
      "nome_completo_valor_dominio": "PESQUISADOR EM QUIMICA",
      "descricao_conceito_valor_dominio": "PESQUISADOR EM QUIMICA"
    },
    {
      "codigo_valor_dominio": 1468,
      "codigo_referencia_valor_dominio": "631105",
      "nome_resumido_valor_dominio": "PESCADOR ARTESANAL DE AGUA DOCE",
      "nome_completo_valor_dominio": "PESCADOR ARTESANAL DE AGUA DOCE",
      "descricao_conceito_valor_dominio": "PESCADOR ARTESANAL DE AGUA DOCE"
    },
    {
      "codigo_valor_dominio": 1469,
      "codigo_referencia_valor_dominio": "211105",
      "nome_resumido_valor_dominio": "ATUARIO",
      "nome_completo_valor_dominio": "ATUARIO",
      "descricao_conceito_valor_dominio": "ATUARIO"
    },
    {
      "codigo_valor_dominio": 1470,
      "codigo_referencia_valor_dominio": "761410",
      "nome_resumido_valor_dominio": "ESTAMPADOR DE TECIDO",
      "nome_completo_valor_dominio": "ESTAMPADOR DE TECIDO",
      "descricao_conceito_valor_dominio": "ESTAMPADOR DE TECIDO"
    },
    {
      "codigo_valor_dominio": 1471,
      "codigo_referencia_valor_dominio": "211120",
      "nome_resumido_valor_dominio": "MATEMATICO APLICADO",
      "nome_completo_valor_dominio": "MATEMATICO APLICADO",
      "descricao_conceito_valor_dominio": "MATEMATICO APLICADO"
    },
    {
      "codigo_valor_dominio": 1472,
      "codigo_referencia_valor_dominio": "762320",
      "nome_resumido_valor_dominio": "MATIZADOR DE COUROS E PELES",
      "nome_completo_valor_dominio": "MATIZADOR DE COUROS E PELES",
      "descricao_conceito_valor_dominio": "MATIZADOR DE COUROS E PELES"
    },
    {
      "codigo_valor_dominio": 1473,
      "codigo_referencia_valor_dominio": "211210",
      "nome_resumido_valor_dominio": "ESTATISTICO (ESTATISTICA APLICADA)",
      "nome_completo_valor_dominio": "ESTATISTICO (ESTATISTICA APLICADA)",
      "descricao_conceito_valor_dominio": "ESTATISTICO (ESTATISTICA APLICADA)"
    },
    {
      "codigo_valor_dominio": 1474,
      "codigo_referencia_valor_dominio": "211215",
      "nome_resumido_valor_dominio": "ESTATISTICO TEORICO",
      "nome_completo_valor_dominio": "ESTATISTICO TEORICO",
      "descricao_conceito_valor_dominio": "ESTATISTICO TEORICO"
    },
    {
      "codigo_valor_dominio": 1475,
      "codigo_referencia_valor_dominio": "776425",
      "nome_resumido_valor_dominio": "ESTEIREIRO",
      "nome_completo_valor_dominio": "ESTEIREIRO",
      "descricao_conceito_valor_dominio": "ESTEIREIRO"
    },
    {
      "codigo_valor_dominio": 1476,
      "codigo_referencia_valor_dominio": "214910",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE CONTROLE DE QUALIDADE",
      "nome_completo_valor_dominio": "ENGENHEIRO DE CONTROLE DE QUALIDADE",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE CONTROLE DE QUALIDADE"
    },
    {
      "codigo_valor_dominio": 1477,
      "codigo_referencia_valor_dominio": "214335",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE MANUTENCAO DE TELECOMUNICACOES",
      "nome_completo_valor_dominio": "ENGENHEIRO DE MANUTENCAO DE TELECOMUNICACOES",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE MANUTENCAO DE TELECOMUNICACOES"
    },
    {
      "codigo_valor_dominio": 1478,
      "codigo_referencia_valor_dominio": "519915",
      "nome_resumido_valor_dominio": "ENGRAXATE",
      "nome_completo_valor_dominio": "ENGRAXATE",
      "descricao_conceito_valor_dominio": "ENGRAXATE"
    },
    {
      "codigo_valor_dominio": 1479,
      "codigo_referencia_valor_dominio": "212305",
      "nome_resumido_valor_dominio": "ADMINISTRADOR DE BANCO DE DADOS",
      "nome_completo_valor_dominio": "ADMINISTRADOR DE BANCO DE DADOS",
      "descricao_conceito_valor_dominio": "ADMINISTRADOR DE BANCO DE DADOS"
    },
    {
      "codigo_valor_dominio": 1480,
      "codigo_referencia_valor_dominio": "212310",
      "nome_resumido_valor_dominio": "ADMINISTRADOR DE REDES",
      "nome_completo_valor_dominio": "ADMINISTRADOR DE REDES",
      "descricao_conceito_valor_dominio": "ADMINISTRADOR DE REDES"
    },
    {
      "codigo_valor_dominio": 1481,
      "codigo_referencia_valor_dominio": "212315",
      "nome_resumido_valor_dominio": "ADMINISTRADOR DE SISTEMAS OPERACIONAIS",
      "nome_completo_valor_dominio": "ADMINISTRADOR DE SISTEMAS OPERACIONAIS",
      "descricao_conceito_valor_dominio": "ADMINISTRADOR DE SISTEMAS OPERACIONAIS"
    },
    {
      "codigo_valor_dominio": 1482,
      "codigo_referencia_valor_dominio": "212320",
      "nome_resumido_valor_dominio": "ADMINISTRADOR EM SEGURANCA DA INFORMACAO",
      "nome_completo_valor_dominio": "ADMINISTRADOR EM SEGURANCA DA INFORMACAO",
      "descricao_conceito_valor_dominio": "ADMINISTRADOR EM SEGURANCA DA INFORMACAO"
    },
    {
      "codigo_valor_dominio": 1483,
      "codigo_referencia_valor_dominio": "212405",
      "nome_resumido_valor_dominio": "ANALISTA DE DESENVOLVIMENTO DE SISTEMAS",
      "nome_completo_valor_dominio": "ANALISTA DE DESENVOLVIMENTO DE SISTEMAS",
      "descricao_conceito_valor_dominio": "ANALISTA DE DESENVOLVIMENTO DE SISTEMAS"
    },
    {
      "codigo_valor_dominio": 1484,
      "codigo_referencia_valor_dominio": "212410",
      "nome_resumido_valor_dominio": "ANALISTA DE REDES E DE COMUNICACAO DE DADOS",
      "nome_completo_valor_dominio": "ANALISTA DE REDES E DE COMUNICACAO DE DADOS",
      "descricao_conceito_valor_dominio": "ANALISTA DE REDES E DE COMUNICACAO DE DADOS"
    },
    {
      "codigo_valor_dominio": 1485,
      "codigo_referencia_valor_dominio": "212415",
      "nome_resumido_valor_dominio": "ANALISTA DE SISTEMAS DE AUTOMACAO",
      "nome_completo_valor_dominio": "ANALISTA DE SISTEMAS DE AUTOMACAO",
      "descricao_conceito_valor_dominio": "ANALISTA DE SISTEMAS DE AUTOMACAO"
    },
    {
      "codigo_valor_dominio": 1486,
      "codigo_referencia_valor_dominio": "212420",
      "nome_resumido_valor_dominio": "ANALISTA DE SUPORTE COMPUTACIONAL",
      "nome_completo_valor_dominio": "ANALISTA DE SUPORTE COMPUTACIONAL",
      "descricao_conceito_valor_dominio": "ANALISTA DE SUPORTE COMPUTACIONAL"
    },
    {
      "codigo_valor_dominio": 1487,
      "codigo_referencia_valor_dominio": "213110",
      "nome_resumido_valor_dominio": "FISICO (ACUSTICA)",
      "nome_completo_valor_dominio": "FISICO (ACUSTICA)",
      "descricao_conceito_valor_dominio": "FISICO (ACUSTICA)"
    },
    {
      "codigo_valor_dominio": 1488,
      "codigo_referencia_valor_dominio": "213115",
      "nome_resumido_valor_dominio": "FISICO (ATOMICA E MOLECULAR)",
      "nome_completo_valor_dominio": "FISICO (ATOMICA E MOLECULAR)",
      "descricao_conceito_valor_dominio": "FISICO (ATOMICA E MOLECULAR)"
    },
    {
      "codigo_valor_dominio": 1489,
      "codigo_referencia_valor_dominio": "213120",
      "nome_resumido_valor_dominio": "FISICO (COSMOLOGIA)",
      "nome_completo_valor_dominio": "FISICO (COSMOLOGIA)",
      "descricao_conceito_valor_dominio": "FISICO (COSMOLOGIA)"
    },
    {
      "codigo_valor_dominio": 1490,
      "codigo_referencia_valor_dominio": "213125",
      "nome_resumido_valor_dominio": "FISICO (ESTATISTICA E MATEMATICA)",
      "nome_completo_valor_dominio": "FISICO (ESTATISTICA E MATEMATICA)",
      "descricao_conceito_valor_dominio": "FISICO (ESTATISTICA E MATEMATICA)"
    },
    {
      "codigo_valor_dominio": 1491,
      "codigo_referencia_valor_dominio": "213130",
      "nome_resumido_valor_dominio": "FISICO (FLUIDOS)",
      "nome_completo_valor_dominio": "FISICO (FLUIDOS)",
      "descricao_conceito_valor_dominio": "FISICO (FLUIDOS)"
    },
    {
      "codigo_valor_dominio": 1492,
      "codigo_referencia_valor_dominio": "213135",
      "nome_resumido_valor_dominio": "FISICO (INSTRUMENTACAO)",
      "nome_completo_valor_dominio": "FISICO (INSTRUMENTACAO)",
      "descricao_conceito_valor_dominio": "FISICO (INSTRUMENTACAO)"
    },
    {
      "codigo_valor_dominio": 1493,
      "codigo_referencia_valor_dominio": "213140",
      "nome_resumido_valor_dominio": "FISICO (MATERIA CONDENSADA)",
      "nome_completo_valor_dominio": "FISICO (MATERIA CONDENSADA)",
      "descricao_conceito_valor_dominio": "FISICO (MATERIA CONDENSADA)"
    },
    {
      "codigo_valor_dominio": 1494,
      "codigo_referencia_valor_dominio": "213145",
      "nome_resumido_valor_dominio": "FISICO (MATERIAIS)",
      "nome_completo_valor_dominio": "FISICO (MATERIAIS)",
      "descricao_conceito_valor_dominio": "FISICO (MATERIAIS)"
    },
    {
      "codigo_valor_dominio": 1495,
      "codigo_referencia_valor_dominio": "213150",
      "nome_resumido_valor_dominio": "FISICO (MEDICINA)",
      "nome_completo_valor_dominio": "FISICO (MEDICINA)",
      "descricao_conceito_valor_dominio": "FISICO (MEDICINA)"
    },
    {
      "codigo_valor_dominio": 1496,
      "codigo_referencia_valor_dominio": "213155",
      "nome_resumido_valor_dominio": "FISICO (NUCLEAR E REATORES)",
      "nome_completo_valor_dominio": "FISICO (NUCLEAR E REATORES)",
      "descricao_conceito_valor_dominio": "FISICO (NUCLEAR E REATORES)"
    },
    {
      "codigo_valor_dominio": 1497,
      "codigo_referencia_valor_dominio": "213160",
      "nome_resumido_valor_dominio": "FISICO (OPTICA)",
      "nome_completo_valor_dominio": "FISICO (OPTICA)",
      "descricao_conceito_valor_dominio": "FISICO (OPTICA)"
    },
    {
      "codigo_valor_dominio": 1498,
      "codigo_referencia_valor_dominio": "213165",
      "nome_resumido_valor_dominio": "FISICO (PARTICULAS E CAMPOS)",
      "nome_completo_valor_dominio": "FISICO (PARTICULAS E CAMPOS)",
      "descricao_conceito_valor_dominio": "FISICO (PARTICULAS E CAMPOS)"
    },
    {
      "codigo_valor_dominio": 1499,
      "codigo_referencia_valor_dominio": "213170",
      "nome_resumido_valor_dominio": "FISICO (PLASMA)",
      "nome_completo_valor_dominio": "FISICO (PLASMA)",
      "descricao_conceito_valor_dominio": "FISICO (PLASMA)"
    },
    {
      "codigo_valor_dominio": 1500,
      "codigo_referencia_valor_dominio": "213175",
      "nome_resumido_valor_dominio": "FISICO (TERMICA)",
      "nome_completo_valor_dominio": "FISICO (TERMICA)",
      "descricao_conceito_valor_dominio": "FISICO (TERMICA)"
    },
    {
      "codigo_valor_dominio": 1501,
      "codigo_referencia_valor_dominio": "223660",
      "nome_resumido_valor_dominio": "FISIOTERAPEUTA DO TRABALHO",
      "nome_completo_valor_dominio": "FISIOTERAPEUTA DO TRABALHO",
      "descricao_conceito_valor_dominio": "FISIOTERAPEUTA DO TRABALHO"
    },
    {
      "codigo_valor_dominio": 1502,
      "codigo_referencia_valor_dominio": "213210",
      "nome_resumido_valor_dominio": "QUIMICO INDUSTRIAL",
      "nome_completo_valor_dominio": "QUIMICO INDUSTRIAL",
      "descricao_conceito_valor_dominio": "QUIMICO INDUSTRIAL"
    },
    {
      "codigo_valor_dominio": 1503,
      "codigo_referencia_valor_dominio": "762125",
      "nome_resumido_valor_dominio": "RACHADOR DE COUROS E PELES",
      "nome_completo_valor_dominio": "RACHADOR DE COUROS E PELES",
      "descricao_conceito_valor_dominio": "RACHADOR DE COUROS E PELES"
    },
    {
      "codigo_valor_dominio": 1504,
      "codigo_referencia_valor_dominio": "262135",
      "nome_resumido_valor_dominio": "TECNOLOGO EM PRODUCAO AUDIOVISUAL",
      "nome_completo_valor_dominio": "TECNOLOGO EM PRODUCAO AUDIOVISUAL",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM PRODUCAO AUDIOVISUAL"
    },
    {
      "codigo_valor_dominio": 1505,
      "codigo_referencia_valor_dominio": "213305",
      "nome_resumido_valor_dominio": "ASTRONOMO",
      "nome_completo_valor_dominio": "ASTRONOMO",
      "descricao_conceito_valor_dominio": "ASTRONOMO"
    },
    {
      "codigo_valor_dominio": 1506,
      "codigo_referencia_valor_dominio": "251305",
      "nome_resumido_valor_dominio": "GEOGRAFO",
      "nome_completo_valor_dominio": "GEOGRAFO",
      "descricao_conceito_valor_dominio": "GEOGRAFO"
    },
    {
      "codigo_valor_dominio": 1507,
      "codigo_referencia_valor_dominio": "352305",
      "nome_resumido_valor_dominio": "METROLOGISTA",
      "nome_completo_valor_dominio": "METROLOGISTA",
      "descricao_conceito_valor_dominio": "METROLOGISTA"
    },
    {
      "codigo_valor_dominio": 1508,
      "codigo_referencia_valor_dominio": "213410",
      "nome_resumido_valor_dominio": "GEOLOGO DE ENGENHARIA",
      "nome_completo_valor_dominio": "GEOLOGO DE ENGENHARIA",
      "descricao_conceito_valor_dominio": "GEOLOGO DE ENGENHARIA"
    },
    {
      "codigo_valor_dominio": 1509,
      "codigo_referencia_valor_dominio": "213420",
      "nome_resumido_valor_dominio": "GEOQUIMICO",
      "nome_completo_valor_dominio": "GEOQUIMICO",
      "descricao_conceito_valor_dominio": "GEOQUIMICO"
    },
    {
      "codigo_valor_dominio": 1510,
      "codigo_referencia_valor_dominio": "213310",
      "nome_resumido_valor_dominio": "GEOFISICO ESPACIAL",
      "nome_completo_valor_dominio": "GEOFISICO ESPACIAL",
      "descricao_conceito_valor_dominio": "GEOFISICO ESPACIAL"
    },
    {
      "codigo_valor_dominio": 1511,
      "codigo_referencia_valor_dominio": "142105",
      "nome_resumido_valor_dominio": "GERENTE ADMINISTRATIVO",
      "nome_completo_valor_dominio": "GERENTE ADMINISTRATIVO",
      "descricao_conceito_valor_dominio": "GERENTE ADMINISTRATIVO"
    },
    {
      "codigo_valor_dominio": 1512,
      "codigo_referencia_valor_dominio": "632115",
      "nome_resumido_valor_dominio": "IDENTIFICADOR FLORESTAL",
      "nome_completo_valor_dominio": "IDENTIFICADOR FLORESTAL",
      "descricao_conceito_valor_dominio": "IDENTIFICADOR FLORESTAL"
    },
    {
      "codigo_valor_dominio": 1513,
      "codigo_referencia_valor_dominio": "376245",
      "nome_resumido_valor_dominio": "PALHACO",
      "nome_completo_valor_dominio": "PALHACO",
      "descricao_conceito_valor_dominio": "PALHACO"
    },
    {
      "codigo_valor_dominio": 1514,
      "codigo_referencia_valor_dominio": "761366",
      "nome_resumido_valor_dominio": "PICOTADOR DE CARTOES JACQUARD",
      "nome_completo_valor_dominio": "PICOTADOR DE CARTOES JACQUARD",
      "descricao_conceito_valor_dominio": "PICOTADOR DE CARTOES JACQUARD"
    },
    {
      "codigo_valor_dominio": 1515,
      "codigo_referencia_valor_dominio": "010205",
      "nome_resumido_valor_dominio": "OFICIAL DA AERONAUTICA",
      "nome_completo_valor_dominio": "OFICIAL DA AERONAUTICA",
      "descricao_conceito_valor_dominio": "OFICIAL DA AERONAUTICA"
    },
    {
      "codigo_valor_dominio": 1516,
      "codigo_referencia_valor_dominio": "214810",
      "nome_resumido_valor_dominio": "ENGENHEIRO CARTOGRAFO",
      "nome_completo_valor_dominio": "ENGENHEIRO CARTOGRAFO",
      "descricao_conceito_valor_dominio": "ENGENHEIRO CARTOGRAFO"
    },
    {
      "codigo_valor_dominio": 1517,
      "codigo_referencia_valor_dominio": "214615",
      "nome_resumido_valor_dominio": "TECNOLOGO EM METALURGIA",
      "nome_completo_valor_dominio": "TECNOLOGO EM METALURGIA",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM METALURGIA"
    },
    {
      "codigo_valor_dominio": 1518,
      "codigo_referencia_valor_dominio": "214105",
      "nome_resumido_valor_dominio": "ARQUITETO DE EDIFICACOES",
      "nome_completo_valor_dominio": "ARQUITETO DE EDIFICACOES",
      "descricao_conceito_valor_dominio": "ARQUITETO DE EDIFICACOES"
    },
    {
      "codigo_valor_dominio": 1519,
      "codigo_referencia_valor_dominio": "214110",
      "nome_resumido_valor_dominio": "ARQUITETO DE INTERIORES",
      "nome_completo_valor_dominio": "ARQUITETO DE INTERIORES",
      "descricao_conceito_valor_dominio": "ARQUITETO DE INTERIORES"
    },
    {
      "codigo_valor_dominio": 1520,
      "codigo_referencia_valor_dominio": "214115",
      "nome_resumido_valor_dominio": "ARQUITETO DE PATRIMONIO",
      "nome_completo_valor_dominio": "ARQUITETO DE PATRIMONIO",
      "descricao_conceito_valor_dominio": "ARQUITETO DE PATRIMONIO"
    },
    {
      "codigo_valor_dominio": 1521,
      "codigo_referencia_valor_dominio": "214120",
      "nome_resumido_valor_dominio": "ARQUITETO PAISAGISTA",
      "nome_completo_valor_dominio": "ARQUITETO PAISAGISTA",
      "descricao_conceito_valor_dominio": "ARQUITETO PAISAGISTA"
    },
    {
      "codigo_valor_dominio": 1522,
      "codigo_referencia_valor_dominio": "214125",
      "nome_resumido_valor_dominio": "ARQUITETO URBANISTA",
      "nome_completo_valor_dominio": "ARQUITETO URBANISTA",
      "descricao_conceito_valor_dominio": "ARQUITETO URBANISTA"
    },
    {
      "codigo_valor_dominio": 1523,
      "codigo_referencia_valor_dominio": "762345",
      "nome_resumido_valor_dominio": "VAQUEADOR DE COUROS E PELES",
      "nome_completo_valor_dominio": "VAQUEADOR DE COUROS E PELES",
      "descricao_conceito_valor_dominio": "VAQUEADOR DE COUROS E PELES"
    },
    {
      "codigo_valor_dominio": 1524,
      "codigo_referencia_valor_dominio": "214210",
      "nome_resumido_valor_dominio": "ENGENHEIRO CIVIL (AEROPORTOS)",
      "nome_completo_valor_dominio": "ENGENHEIRO CIVIL (AEROPORTOS)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO CIVIL (AEROPORTOS)"
    },
    {
      "codigo_valor_dominio": 1525,
      "codigo_referencia_valor_dominio": "214215",
      "nome_resumido_valor_dominio": "ENGENHEIRO CIVIL (EDIFICACOES)",
      "nome_completo_valor_dominio": "ENGENHEIRO CIVIL (EDIFICACOES)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO CIVIL (EDIFICACOES)"
    },
    {
      "codigo_valor_dominio": 1526,
      "codigo_referencia_valor_dominio": "214220",
      "nome_resumido_valor_dominio": "ENGENHEIRO CIVIL (ESTRUTURAS METALICAS)",
      "nome_completo_valor_dominio": "ENGENHEIRO CIVIL (ESTRUTURAS METALICAS)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO CIVIL (ESTRUTURAS METALICAS)"
    },
    {
      "codigo_valor_dominio": 1527,
      "codigo_referencia_valor_dominio": "214225",
      "nome_resumido_valor_dominio": "ENGENHEIRO CIVIL (FERROVIAS E METROVIAS)",
      "nome_completo_valor_dominio": "ENGENHEIRO CIVIL (FERROVIAS E METROVIAS)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO CIVIL (FERROVIAS E METROVIAS)"
    },
    {
      "codigo_valor_dominio": 1528,
      "codigo_referencia_valor_dominio": "214230",
      "nome_resumido_valor_dominio": "ENGENHEIRO CIVIL (GEOTECNIA)",
      "nome_completo_valor_dominio": "ENGENHEIRO CIVIL (GEOTECNIA)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO CIVIL (GEOTECNIA)"
    },
    {
      "codigo_valor_dominio": 1529,
      "codigo_referencia_valor_dominio": "214240",
      "nome_resumido_valor_dominio": "ENGENHEIRO CIVIL (HIDRAULICA)",
      "nome_completo_valor_dominio": "ENGENHEIRO CIVIL (HIDRAULICA)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO CIVIL (HIDRAULICA)"
    },
    {
      "codigo_valor_dominio": 1530,
      "codigo_referencia_valor_dominio": "214245",
      "nome_resumido_valor_dominio": "ENGENHEIRO CIVIL (PONTES E VIADUTOS)",
      "nome_completo_valor_dominio": "ENGENHEIRO CIVIL (PONTES E VIADUTOS)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO CIVIL (PONTES E VIADUTOS)"
    },
    {
      "codigo_valor_dominio": 1531,
      "codigo_referencia_valor_dominio": "214235",
      "nome_resumido_valor_dominio": "ENGENHEIRO CIVIL (HIDROLOGIA)",
      "nome_completo_valor_dominio": "ENGENHEIRO CIVIL (HIDROLOGIA)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO CIVIL (HIDROLOGIA)"
    },
    {
      "codigo_valor_dominio": 1532,
      "codigo_referencia_valor_dominio": "214250",
      "nome_resumido_valor_dominio": "ENGENHEIRO CIVIL (PORTOS E VIAS NAVEGAVEIS)",
      "nome_completo_valor_dominio": "ENGENHEIRO CIVIL (PORTOS E VIAS NAVEGAVEIS)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO CIVIL (PORTOS E VIAS NAVEGAVEIS)"
    },
    {
      "codigo_valor_dominio": 1533,
      "codigo_referencia_valor_dominio": "214255",
      "nome_resumido_valor_dominio": "ENGENHEIRO CIVIL (RODOVIAS)",
      "nome_completo_valor_dominio": "ENGENHEIRO CIVIL (RODOVIAS)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO CIVIL (RODOVIAS)"
    },
    {
      "codigo_valor_dominio": 1534,
      "codigo_referencia_valor_dominio": "214260",
      "nome_resumido_valor_dominio": "ENGENHEIRO CIVIL (SANEAMENTO)",
      "nome_completo_valor_dominio": "ENGENHEIRO CIVIL (SANEAMENTO)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO CIVIL (SANEAMENTO)"
    },
    {
      "codigo_valor_dominio": 1535,
      "codigo_referencia_valor_dominio": "214270",
      "nome_resumido_valor_dominio": "ENGENHEIRO CIVIL (TRANSPORTES E TRANSITO)",
      "nome_completo_valor_dominio": "ENGENHEIRO CIVIL (TRANSPORTES E TRANSITO)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO CIVIL (TRANSPORTES E TRANSITO)"
    },
    {
      "codigo_valor_dominio": 1536,
      "codigo_referencia_valor_dominio": "222205",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE ALIMENTOS",
      "nome_completo_valor_dominio": "ENGENHEIRO DE ALIMENTOS",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE ALIMENTOS"
    },
    {
      "codigo_valor_dominio": 1537,
      "codigo_referencia_valor_dominio": "214265",
      "nome_resumido_valor_dominio": "ENGENHEIRO CIVIL (TUNEIS)",
      "nome_completo_valor_dominio": "ENGENHEIRO CIVIL (TUNEIS)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO CIVIL (TUNEIS)"
    },
    {
      "codigo_valor_dominio": 1538,
      "codigo_referencia_valor_dominio": "214360",
      "nome_resumido_valor_dominio": "TECNOLOGO EM ELETRICIDADE",
      "nome_completo_valor_dominio": "TECNOLOGO EM ELETRICIDADE",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM ELETRICIDADE"
    },
    {
      "codigo_valor_dominio": 1539,
      "codigo_referencia_valor_dominio": "214315",
      "nome_resumido_valor_dominio": "ENGENHEIRO ELETRICISTA DE MANUTENCAO",
      "nome_completo_valor_dominio": "ENGENHEIRO ELETRICISTA DE MANUTENCAO",
      "descricao_conceito_valor_dominio": "ENGENHEIRO ELETRICISTA DE MANUTENCAO"
    },
    {
      "codigo_valor_dominio": 1540,
      "codigo_referencia_valor_dominio": "214325",
      "nome_resumido_valor_dominio": "ENGENHEIRO ELETRONICO DE MANUTENCAO",
      "nome_completo_valor_dominio": "ENGENHEIRO ELETRONICO DE MANUTENCAO",
      "descricao_conceito_valor_dominio": "ENGENHEIRO ELETRONICO DE MANUTENCAO"
    },
    {
      "codigo_valor_dominio": 1541,
      "codigo_referencia_valor_dominio": "214320",
      "nome_resumido_valor_dominio": "ENGENHEIRO ELETRICISTA DE PROJETOS",
      "nome_completo_valor_dominio": "ENGENHEIRO ELETRICISTA DE PROJETOS",
      "descricao_conceito_valor_dominio": "ENGENHEIRO ELETRICISTA DE PROJETOS"
    },
    {
      "codigo_valor_dominio": 1542,
      "codigo_referencia_valor_dominio": "214310",
      "nome_resumido_valor_dominio": "ENGENHEIRO ELETRONICO",
      "nome_completo_valor_dominio": "ENGENHEIRO ELETRONICO",
      "descricao_conceito_valor_dominio": "ENGENHEIRO ELETRONICO"
    },
    {
      "codigo_valor_dominio": 1543,
      "codigo_referencia_valor_dominio": "214330",
      "nome_resumido_valor_dominio": "ENGENHEIRO ELETRONICO DE PROJETOS",
      "nome_completo_valor_dominio": "ENGENHEIRO ELETRONICO DE PROJETOS",
      "descricao_conceito_valor_dominio": "ENGENHEIRO ELETRONICO DE PROJETOS"
    },
    {
      "codigo_valor_dominio": 1544,
      "codigo_referencia_valor_dominio": "222120",
      "nome_resumido_valor_dominio": "ENGENHEIRO FLORESTAL",
      "nome_completo_valor_dominio": "ENGENHEIRO FLORESTAL",
      "descricao_conceito_valor_dominio": "ENGENHEIRO FLORESTAL"
    },
    {
      "codigo_valor_dominio": 1545,
      "codigo_referencia_valor_dominio": "214605",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE MATERIAIS",
      "nome_completo_valor_dominio": "ENGENHEIRO DE MATERIAIS",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE MATERIAIS"
    },
    {
      "codigo_valor_dominio": 1546,
      "codigo_referencia_valor_dominio": "214925",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE TEMPOS E MOVIMENTOS",
      "nome_completo_valor_dominio": "ENGENHEIRO DE TEMPOS E MOVIMENTOS",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE TEMPOS E MOVIMENTOS"
    },
    {
      "codigo_valor_dominio": 1547,
      "codigo_referencia_valor_dominio": "214505",
      "nome_resumido_valor_dominio": "ENGENHEIRO QUIMICO",
      "nome_completo_valor_dominio": "ENGENHEIRO QUIMICO",
      "descricao_conceito_valor_dominio": "ENGENHEIRO QUIMICO"
    },
    {
      "codigo_valor_dominio": 1548,
      "codigo_referencia_valor_dominio": "214920",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE RISCOS",
      "nome_completo_valor_dominio": "ENGENHEIRO DE RISCOS",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE RISCOS"
    },
    {
      "codigo_valor_dominio": 1549,
      "codigo_referencia_valor_dominio": "212210",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE EQUIPAMENTOS EM COMPUTACAO",
      "nome_completo_valor_dominio": "ENGENHEIRO DE EQUIPAMENTOS EM COMPUTACAO",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE EQUIPAMENTOS EM COMPUTACAO"
    },
    {
      "codigo_valor_dominio": 1550,
      "codigo_referencia_valor_dominio": "214365",
      "nome_resumido_valor_dominio": "TECNOLOGO EM ELETRONICA",
      "nome_completo_valor_dominio": "TECNOLOGO EM ELETRONICA",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM ELETRONICA"
    },
    {
      "codigo_valor_dominio": 1551,
      "codigo_referencia_valor_dominio": "214435",
      "nome_resumido_valor_dominio": "TECNOLOGO EM FABRICACAO MECANICA",
      "nome_completo_valor_dominio": "TECNOLOGO EM FABRICACAO MECANICA",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM FABRICACAO MECANICA"
    },
    {
      "codigo_valor_dominio": 1552,
      "codigo_referencia_valor_dominio": "422205",
      "nome_resumido_valor_dominio": "TELEFONISTA",
      "nome_completo_valor_dominio": "TELEFONISTA",
      "descricao_conceito_valor_dominio": "TELEFONISTA"
    },
    {
      "codigo_valor_dominio": 1553,
      "codigo_referencia_valor_dominio": "214415",
      "nome_resumido_valor_dominio": "ENGENHEIRO MECANICO (ENERGIA NUCLEAR)",
      "nome_completo_valor_dominio": "ENGENHEIRO MECANICO (ENERGIA NUCLEAR)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO MECANICO (ENERGIA NUCLEAR)"
    },
    {
      "codigo_valor_dominio": 1554,
      "codigo_referencia_valor_dominio": "214420",
      "nome_resumido_valor_dominio": "ENGENHEIRO MECANICO INDUSTRIAL",
      "nome_completo_valor_dominio": "ENGENHEIRO MECANICO INDUSTRIAL",
      "descricao_conceito_valor_dominio": "ENGENHEIRO MECANICO INDUSTRIAL"
    },
    {
      "codigo_valor_dominio": 1555,
      "codigo_referencia_valor_dominio": "214410",
      "nome_resumido_valor_dominio": "ENGENHEIRO MECANICO AUTOMOTIVO",
      "nome_completo_valor_dominio": "ENGENHEIRO MECANICO AUTOMOTIVO",
      "descricao_conceito_valor_dominio": "ENGENHEIRO MECANICO AUTOMOTIVO"
    },
    {
      "codigo_valor_dominio": 1556,
      "codigo_referencia_valor_dominio": "202105",
      "nome_resumido_valor_dominio": "ENGENHEIRO MECATRONICO",
      "nome_completo_valor_dominio": "ENGENHEIRO MECATRONICO",
      "descricao_conceito_valor_dominio": "ENGENHEIRO MECATRONICO"
    },
    {
      "codigo_valor_dominio": 1557,
      "codigo_referencia_valor_dominio": "222105",
      "nome_resumido_valor_dominio": "ENGENHEIRO AGRICOLA",
      "nome_completo_valor_dominio": "ENGENHEIRO AGRICOLA",
      "descricao_conceito_valor_dominio": "ENGENHEIRO AGRICOLA"
    },
    {
      "codigo_valor_dominio": 1558,
      "codigo_referencia_valor_dominio": "214345",
      "nome_resumido_valor_dominio": "ENGENHEIRO PROJETISTA DE TELECOMUNICACOES",
      "nome_completo_valor_dominio": "ENGENHEIRO PROJETISTA DE TELECOMUNICACOES",
      "descricao_conceito_valor_dominio": "ENGENHEIRO PROJETISTA DE TELECOMUNICACOES"
    },
    {
      "codigo_valor_dominio": 1559,
      "codigo_referencia_valor_dominio": "271110",
      "nome_resumido_valor_dominio": "TECNOLOGO EM GASTRONOMIA",
      "nome_completo_valor_dominio": "TECNOLOGO EM GASTRONOMIA",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM GASTRONOMIA"
    },
    {
      "codigo_valor_dominio": 1560,
      "codigo_referencia_valor_dominio": "214510",
      "nome_resumido_valor_dominio": "ENGENHEIRO QUIMICO (INDUSTRIA QUIMICA)",
      "nome_completo_valor_dominio": "ENGENHEIRO QUIMICO (INDUSTRIA QUIMICA)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO QUIMICO (INDUSTRIA QUIMICA)"
    },
    {
      "codigo_valor_dominio": 1561,
      "codigo_referencia_valor_dominio": "214515",
      "nome_resumido_valor_dominio": "ENGENHEIRO QUIMICO (MINERACAO, METALURGIA, SIDERURGIA, CIMEN",
      "nome_completo_valor_dominio": "ENGENHEIRO QUIMICO (MINERACAO, METALURGIA, SIDERURGIA, CIMENTEIRA E CERAMICA)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO QUIMICO (MINERACAO, METALURGIA, SIDERURGIA, CIMENTEIRA E CERAMICA)"
    },
    {
      "codigo_valor_dominio": 1562,
      "codigo_referencia_valor_dominio": "214520",
      "nome_resumido_valor_dominio": "ENGENHEIRO QUIMICO (PAPEL E CELULOSE)",
      "nome_completo_valor_dominio": "ENGENHEIRO QUIMICO (PAPEL E CELULOSE)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO QUIMICO (PAPEL E CELULOSE)"
    },
    {
      "codigo_valor_dominio": 1563,
      "codigo_referencia_valor_dominio": "214525",
      "nome_resumido_valor_dominio": "ENGENHEIRO QUIMICO (PETROLEO E BORRACHA)",
      "nome_completo_valor_dominio": "ENGENHEIRO QUIMICO (PETROLEO E BORRACHA)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO QUIMICO (PETROLEO E BORRACHA)"
    },
    {
      "codigo_valor_dominio": 1564,
      "codigo_referencia_valor_dominio": "214530",
      "nome_resumido_valor_dominio": "ENGENHEIRO QUIMICO (UTILIDADES E MEIO AMBIENTE)",
      "nome_completo_valor_dominio": "ENGENHEIRO QUIMICO (UTILIDADES E MEIO AMBIENTE)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO QUIMICO (UTILIDADES E MEIO AMBIENTE)"
    },
    {
      "codigo_valor_dominio": 1565,
      "codigo_referencia_valor_dominio": "212215",
      "nome_resumido_valor_dominio": "ENGENHEIROS DE SISTEMAS OPERACIONAIS EM COMPUTACAO",
      "nome_completo_valor_dominio": "ENGENHEIROS DE SISTEMAS OPERACIONAIS EM COMPUTACAO",
      "descricao_conceito_valor_dominio": "ENGENHEIROS DE SISTEMAS OPERACIONAIS EM COMPUTACAO"
    },
    {
      "codigo_valor_dominio": 1566,
      "codigo_referencia_valor_dominio": "324120",
      "nome_resumido_valor_dominio": "TECNOLOGO EM RADIOLOGIA",
      "nome_completo_valor_dominio": "TECNOLOGO EM RADIOLOGIA",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM RADIOLOGIA"
    },
    {
      "codigo_valor_dominio": 1567,
      "codigo_referencia_valor_dominio": "214705",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE MINAS",
      "nome_completo_valor_dominio": "ENGENHEIRO DE MINAS",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE MINAS"
    },
    {
      "codigo_valor_dominio": 1568,
      "codigo_referencia_valor_dominio": "214430",
      "nome_resumido_valor_dominio": "ENGENHEIRO NAVAL",
      "nome_completo_valor_dominio": "ENGENHEIRO NAVAL",
      "descricao_conceito_valor_dominio": "ENGENHEIRO NAVAL"
    },
    {
      "codigo_valor_dominio": 1569,
      "codigo_referencia_valor_dominio": "214745",
      "nome_resumido_valor_dominio": "TECNOLOGO EM PETROLEO E GAS",
      "nome_completo_valor_dominio": "TECNOLOGO EM PETROLEO E GAS",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM PETROLEO E GAS"
    },
    {
      "codigo_valor_dominio": 1570,
      "codigo_referencia_valor_dominio": "214710",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE MINAS (BENEFICIAMENTO)",
      "nome_completo_valor_dominio": "ENGENHEIRO DE MINAS (BENEFICIAMENTO)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE MINAS (BENEFICIAMENTO)"
    },
    {
      "codigo_valor_dominio": 1571,
      "codigo_referencia_valor_dominio": "214715",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE MINAS (LAVRA A CEU ABERTO)",
      "nome_completo_valor_dominio": "ENGENHEIRO DE MINAS (LAVRA A CEU ABERTO)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE MINAS (LAVRA A CEU ABERTO)"
    },
    {
      "codigo_valor_dominio": 1572,
      "codigo_referencia_valor_dominio": "214720",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE MINAS (LAVRA SUBTERRANEA)",
      "nome_completo_valor_dominio": "ENGENHEIRO DE MINAS (LAVRA SUBTERRANEA)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE MINAS (LAVRA SUBTERRANEA)"
    },
    {
      "codigo_valor_dominio": 1573,
      "codigo_referencia_valor_dominio": "214725",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE MINAS (PESQUISA MINERAL)",
      "nome_completo_valor_dominio": "ENGENHEIRO DE MINAS (PESQUISA MINERAL)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE MINAS (PESQUISA MINERAL)"
    },
    {
      "codigo_valor_dominio": 1574,
      "codigo_referencia_valor_dominio": "214730",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE MINAS (PLANEJAMENTO)",
      "nome_completo_valor_dominio": "ENGENHEIRO DE MINAS (PLANEJAMENTO)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE MINAS (PLANEJAMENTO)"
    },
    {
      "codigo_valor_dominio": 1575,
      "codigo_referencia_valor_dominio": "214735",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE MINAS (PROCESSO)",
      "nome_completo_valor_dominio": "ENGENHEIRO DE MINAS (PROCESSO)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE MINAS (PROCESSO)"
    },
    {
      "codigo_valor_dominio": 1576,
      "codigo_referencia_valor_dominio": "214740",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE MINAS (PROJETO)",
      "nome_completo_valor_dominio": "ENGENHEIRO DE MINAS (PROJETO)",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE MINAS (PROJETO)"
    },
    {
      "codigo_valor_dominio": 1577,
      "codigo_referencia_valor_dominio": "222115",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE PESCA",
      "nome_completo_valor_dominio": "ENGENHEIRO DE PESCA",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE PESCA"
    },
    {
      "codigo_valor_dominio": 1578,
      "codigo_referencia_valor_dominio": "213215",
      "nome_resumido_valor_dominio": "TECNOLOGO EM PROCESSOS QUIMICOS",
      "nome_completo_valor_dominio": "TECNOLOGO EM PROCESSOS QUIMICOS",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM PROCESSOS QUIMICOS"
    },
    {
      "codigo_valor_dominio": 1579,
      "codigo_referencia_valor_dominio": "252320",
      "nome_resumido_valor_dominio": "TECNOLOGO EM SECRETARIADO ESCOLAR",
      "nome_completo_valor_dominio": "TECNOLOGO EM SECRETARIADO ESCOLAR",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM SECRETARIADO ESCOLAR"
    },
    {
      "codigo_valor_dominio": 1580,
      "codigo_referencia_valor_dominio": "222110",
      "nome_resumido_valor_dominio": "ENGENHEIRO AGRONOMO",
      "nome_completo_valor_dominio": "ENGENHEIRO AGRONOMO",
      "descricao_conceito_valor_dominio": "ENGENHEIRO AGRONOMO"
    },
    {
      "codigo_valor_dominio": 1581,
      "codigo_referencia_valor_dominio": "214205",
      "nome_resumido_valor_dominio": "ENGENHEIRO CIVIL",
      "nome_completo_valor_dominio": "ENGENHEIRO CIVIL",
      "descricao_conceito_valor_dominio": "ENGENHEIRO CIVIL"
    },
    {
      "codigo_valor_dominio": 1582,
      "codigo_referencia_valor_dominio": "214350",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE REDES DE COMUNICACAO",
      "nome_completo_valor_dominio": "ENGENHEIRO DE REDES DE COMUNICACAO",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE REDES DE COMUNICACAO"
    },
    {
      "codigo_valor_dominio": 1583,
      "codigo_referencia_valor_dominio": "214355",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE CONTROLE E AUTOMACAO",
      "nome_completo_valor_dominio": "ENGENHEIRO DE CONTROLE E AUTOMACAO",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE CONTROLE E AUTOMACAO"
    },
    {
      "codigo_valor_dominio": 1584,
      "codigo_referencia_valor_dominio": "214340",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE TELECOMUNICACOES",
      "nome_completo_valor_dominio": "ENGENHEIRO DE TELECOMUNICACOES",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE TELECOMUNICACOES"
    },
    {
      "codigo_valor_dominio": 1585,
      "codigo_referencia_valor_dominio": "214915",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE SEGURANCA DO TRABALHO",
      "nome_completo_valor_dominio": "ENGENHEIRO DE SEGURANCA DO TRABALHO",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE SEGURANCA DO TRABALHO"
    },
    {
      "codigo_valor_dominio": 1586,
      "codigo_referencia_valor_dominio": "214305",
      "nome_resumido_valor_dominio": "ENGENHEIRO ELETRICISTA",
      "nome_completo_valor_dominio": "ENGENHEIRO ELETRICISTA",
      "descricao_conceito_valor_dominio": "ENGENHEIRO ELETRICISTA"
    },
    {
      "codigo_valor_dominio": 1587,
      "codigo_referencia_valor_dominio": "214535",
      "nome_resumido_valor_dominio": "TECNOLOGO EM PRODUCAO SULCROALCOOLEIRA",
      "nome_completo_valor_dominio": "TECNOLOGO EM PRODUCAO SULCROALCOOLEIRA",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM PRODUCAO SULCROALCOOLEIRA"
    },
    {
      "codigo_valor_dominio": 1588,
      "codigo_referencia_valor_dominio": "142710",
      "nome_resumido_valor_dominio": "TECNOLOGO EM SISTEMAS BIOMEDICOS",
      "nome_completo_valor_dominio": "TECNOLOGO EM SISTEMAS BIOMEDICOS",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM SISTEMAS BIOMEDICOS"
    },
    {
      "codigo_valor_dominio": 1589,
      "codigo_referencia_valor_dominio": "215105",
      "nome_resumido_valor_dominio": "AGENTE DE MANOBRA E DOCAGEM",
      "nome_completo_valor_dominio": "AGENTE DE MANOBRA E DOCAGEM",
      "descricao_conceito_valor_dominio": "AGENTE DE MANOBRA E DOCAGEM"
    },
    {
      "codigo_valor_dominio": 1590,
      "codigo_referencia_valor_dominio": "215110",
      "nome_resumido_valor_dominio": "CAPITAO DE MANOBRA DA MARINHA MERCANTE",
      "nome_completo_valor_dominio": "CAPITAO DE MANOBRA DA MARINHA MERCANTE",
      "descricao_conceito_valor_dominio": "CAPITAO DE MANOBRA DA MARINHA MERCANTE"
    },
    {
      "codigo_valor_dominio": 1591,
      "codigo_referencia_valor_dominio": "215115",
      "nome_resumido_valor_dominio": "COMANDANTE DA MARINHA MERCANTE",
      "nome_completo_valor_dominio": "COMANDANTE DA MARINHA MERCANTE",
      "descricao_conceito_valor_dominio": "COMANDANTE DA MARINHA MERCANTE"
    },
    {
      "codigo_valor_dominio": 1592,
      "codigo_referencia_valor_dominio": "239405",
      "nome_resumido_valor_dominio": "COORDENADOR PEDAGOGICO",
      "nome_completo_valor_dominio": "COORDENADOR PEDAGOGICO",
      "descricao_conceito_valor_dominio": "COORDENADOR PEDAGOGICO"
    },
    {
      "codigo_valor_dominio": 1593,
      "codigo_referencia_valor_dominio": "772110",
      "nome_resumido_valor_dominio": "IMPREGNADOR DE MADEIRA",
      "nome_completo_valor_dominio": "IMPREGNADOR DE MADEIRA",
      "descricao_conceito_valor_dominio": "IMPREGNADOR DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 1594,
      "codigo_referencia_valor_dominio": "710215",
      "nome_resumido_valor_dominio": "INSPETOR DE TERRAPLENAGEM",
      "nome_completo_valor_dominio": "INSPETOR DE TERRAPLENAGEM",
      "descricao_conceito_valor_dominio": "INSPETOR DE TERRAPLENAGEM"
    },
    {
      "codigo_valor_dominio": 1595,
      "codigo_referencia_valor_dominio": "523105",
      "nome_resumido_valor_dominio": "INSTALADOR DE CORTINAS E PERSIANAS, PORTAS SANFONADAS E BOXE",
      "nome_completo_valor_dominio": "INSTALADOR DE CORTINAS E PERSIANAS, PORTAS SANFONADAS E BOXE",
      "descricao_conceito_valor_dominio": "INSTALADOR DE CORTINAS E PERSIANAS, PORTAS SANFONADAS E BOXE"
    },
    {
      "codigo_valor_dominio": 1596,
      "codigo_referencia_valor_dominio": "241305",
      "nome_resumido_valor_dominio": "OFICIAL DE REGISTRO DE CONTRATOS MARITIMOS",
      "nome_completo_valor_dominio": "OFICIAL DE REGISTRO DE CONTRATOS MARITIMOS",
      "descricao_conceito_valor_dominio": "OFICIAL DE REGISTRO DE CONTRATOS MARITIMOS"
    },
    {
      "codigo_valor_dominio": 1597,
      "codigo_referencia_valor_dominio": "111250",
      "nome_resumido_valor_dominio": "PREFEITO",
      "nome_completo_valor_dominio": "PREFEITO",
      "descricao_conceito_valor_dominio": "PREFEITO"
    },
    {
      "codigo_valor_dominio": 1598,
      "codigo_referencia_valor_dominio": "375115",
      "nome_resumido_valor_dominio": "VISUAL MERCHANDISER",
      "nome_completo_valor_dominio": "VISUAL MERCHANDISER",
      "descricao_conceito_valor_dominio": "VISUAL MERCHANDISER"
    },
    {
      "codigo_valor_dominio": 1599,
      "codigo_referencia_valor_dominio": "242910",
      "nome_resumido_valor_dominio": "OFICIAL TECNICO DE INTELIGENCIA",
      "nome_completo_valor_dominio": "OFICIAL TECNICO DE INTELIGENCIA",
      "descricao_conceito_valor_dominio": "OFICIAL TECNICO DE INTELIGENCIA"
    },
    {
      "codigo_valor_dominio": 1600,
      "codigo_referencia_valor_dominio": "020305",
      "nome_resumido_valor_dominio": "PRIMEIRO TENENTE DE POLICIA MILITAR",
      "nome_completo_valor_dominio": "PRIMEIRO TENENTE DE POLICIA MILITAR",
      "descricao_conceito_valor_dominio": "PRIMEIRO TENENTE DE POLICIA MILITAR"
    },
    {
      "codigo_valor_dominio": 1601,
      "codigo_referencia_valor_dominio": "020310",
      "nome_resumido_valor_dominio": "SEGUNDO TENENTE DE POLICIA MILITAR",
      "nome_completo_valor_dominio": "SEGUNDO TENENTE DE POLICIA MILITAR",
      "descricao_conceito_valor_dominio": "SEGUNDO TENENTE DE POLICIA MILITAR"
    },
    {
      "codigo_valor_dominio": 1602,
      "codigo_referencia_valor_dominio": "760405",
      "nome_resumido_valor_dominio": "SUPERVISOR (INDUSTRIA DE CALCADOS E ARTEFATOS DE COURO)",
      "nome_completo_valor_dominio": "SUPERVISOR (INDUSTRIA DE CALCADOS E ARTEFATOS DE COURO)",
      "descricao_conceito_valor_dominio": "SUPERVISOR (INDUSTRIA DE CALCADOS E ARTEFATOS DE COURO)"
    },
    {
      "codigo_valor_dominio": 1603,
      "codigo_referencia_valor_dominio": "377135",
      "nome_resumido_valor_dominio": "PILOTO DE COMPETICAO AUTOMOBILISTICA",
      "nome_completo_valor_dominio": "PILOTO DE COMPETICAO AUTOMOBILISTICA",
      "descricao_conceito_valor_dominio": "PILOTO DE COMPETICAO AUTOMOBILISTICA"
    },
    {
      "codigo_valor_dominio": 1604,
      "codigo_referencia_valor_dominio": "341230",
      "nome_resumido_valor_dominio": "PILOTO FLUVIAL",
      "nome_completo_valor_dominio": "PILOTO FLUVIAL",
      "descricao_conceito_valor_dominio": "PILOTO FLUVIAL"
    },
    {
      "codigo_valor_dominio": 1605,
      "codigo_referencia_valor_dominio": "261410",
      "nome_resumido_valor_dominio": "INTERPRETE",
      "nome_completo_valor_dominio": "INTERPRETE",
      "descricao_conceito_valor_dominio": "INTERPRETE"
    },
    {
      "codigo_valor_dominio": 1606,
      "codigo_referencia_valor_dominio": "221105",
      "nome_resumido_valor_dominio": "BIOLOGO",
      "nome_completo_valor_dominio": "BIOLOGO",
      "descricao_conceito_valor_dominio": "BIOLOGO"
    },
    {
      "codigo_valor_dominio": 1607,
      "codigo_referencia_valor_dominio": "221205",
      "nome_resumido_valor_dominio": "BIOMEDICO",
      "nome_completo_valor_dominio": "BIOMEDICO",
      "descricao_conceito_valor_dominio": "BIOMEDICO"
    },
    {
      "codigo_valor_dominio": 1608,
      "codigo_referencia_valor_dominio": "214805",
      "nome_resumido_valor_dominio": "ENGENHEIRO AGRIMENSOR",
      "nome_completo_valor_dominio": "ENGENHEIRO AGRIMENSOR",
      "descricao_conceito_valor_dominio": "ENGENHEIRO AGRIMENSOR"
    },
    {
      "codigo_valor_dominio": 1609,
      "codigo_referencia_valor_dominio": "214005",
      "nome_resumido_valor_dominio": "ENGENHEIRO AMBIENTAL",
      "nome_completo_valor_dominio": "ENGENHEIRO AMBIENTAL",
      "descricao_conceito_valor_dominio": "ENGENHEIRO AMBIENTAL"
    },
    {
      "codigo_valor_dominio": 1610,
      "codigo_referencia_valor_dominio": "214905",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE PRODUCAO",
      "nome_completo_valor_dominio": "ENGENHEIRO DE PRODUCAO",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE PRODUCAO"
    },
    {
      "codigo_valor_dominio": 1611,
      "codigo_referencia_valor_dominio": "214405",
      "nome_resumido_valor_dominio": "ENGENHEIRO MECANICO",
      "nome_completo_valor_dominio": "ENGENHEIRO MECANICO",
      "descricao_conceito_valor_dominio": "ENGENHEIRO MECANICO"
    },
    {
      "codigo_valor_dominio": 1612,
      "codigo_referencia_valor_dominio": "212205",
      "nome_resumido_valor_dominio": "ENGENHEIRO DE APLICATIVOS EM COMPUTACAO",
      "nome_completo_valor_dominio": "ENGENHEIRO DE APLICATIVOS EM COMPUTACAO",
      "descricao_conceito_valor_dominio": "ENGENHEIRO DE APLICATIVOS EM COMPUTACAO"
    },
    {
      "codigo_valor_dominio": 1613,
      "codigo_referencia_valor_dominio": "214280",
      "nome_resumido_valor_dominio": "TECNOLOGO EM CONSTRUCAO CIVIL",
      "nome_completo_valor_dominio": "TECNOLOGO EM CONSTRUCAO CIVIL",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM CONSTRUCAO CIVIL"
    },
    {
      "codigo_valor_dominio": 1614,
      "codigo_referencia_valor_dominio": "223204",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - AUDITOR",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - AUDITOR",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - AUDITOR"
    },
    {
      "codigo_valor_dominio": 1615,
      "codigo_referencia_valor_dominio": "223208",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - CLINICO GERAL",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - CLINICO GERAL",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - CLINICO GERAL"
    },
    {
      "codigo_valor_dominio": 1616,
      "codigo_referencia_valor_dominio": "223212",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - ENDODONTISTA",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - ENDODONTISTA",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - ENDODONTISTA"
    },
    {
      "codigo_valor_dominio": 1617,
      "codigo_referencia_valor_dominio": "223216",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - EPIDEMIOLOGISTA",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - EPIDEMIOLOGISTA",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - EPIDEMIOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1618,
      "codigo_referencia_valor_dominio": "223220",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - ESTOMATOLOGISTA",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - ESTOMATOLOGISTA",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - ESTOMATOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1619,
      "codigo_referencia_valor_dominio": "223224",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - IMPLANTODONTISTA",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - IMPLANTODONTISTA",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - IMPLANTODONTISTA"
    },
    {
      "codigo_valor_dominio": 1620,
      "codigo_referencia_valor_dominio": "223228",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - ODONTOGERIATRA",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - ODONTOGERIATRA",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - ODONTOGERIATRA"
    },
    {
      "codigo_valor_dominio": 1621,
      "codigo_referencia_valor_dominio": "223232",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - ODONTOLOGISTA LEGAL",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - ODONTOLOGISTA LEGAL",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - ODONTOLOGISTA LEGAL"
    },
    {
      "codigo_valor_dominio": 1622,
      "codigo_referencia_valor_dominio": "223236",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - ODONTOPEDIATRA",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - ODONTOPEDIATRA",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - ODONTOPEDIATRA"
    },
    {
      "codigo_valor_dominio": 1623,
      "codigo_referencia_valor_dominio": "223240",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - ORTOPEDISTA E ORTODONTISTA",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - ORTOPEDISTA E ORTODONTISTA",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - ORTOPEDISTA E ORTODONTISTA"
    },
    {
      "codigo_valor_dominio": 1624,
      "codigo_referencia_valor_dominio": "223244",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - PATOLOGISTA BUCAL",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - PATOLOGISTA BUCAL",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - PATOLOGISTA BUCAL"
    },
    {
      "codigo_valor_dominio": 1625,
      "codigo_referencia_valor_dominio": "223248",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - PERIODONTISTA",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - PERIODONTISTA",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - PERIODONTISTA"
    },
    {
      "codigo_valor_dominio": 1626,
      "codigo_referencia_valor_dominio": "223252",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - PROTESIOLOGO BUCOMAXILOFACIAL",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - PROTESIOLOGO BUCOMAXILOFACIAL",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - PROTESIOLOGO BUCOMAXILOFACIAL"
    },
    {
      "codigo_valor_dominio": 1627,
      "codigo_referencia_valor_dominio": "223256",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - PROTESISTA",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - PROTESISTA",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - PROTESISTA"
    },
    {
      "codigo_valor_dominio": 1628,
      "codigo_referencia_valor_dominio": "223260",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - RADIOLOGISTA",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - RADIOLOGISTA",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - RADIOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1629,
      "codigo_referencia_valor_dominio": "223264",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - REABILITADOR ORAL",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - REABILITADOR ORAL",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - REABILITADOR ORAL"
    },
    {
      "codigo_valor_dominio": 1630,
      "codigo_referencia_valor_dominio": "223268",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - TRAUMATOLOGISTA BUCOMAXILOFACIAL",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - TRAUMATOLOGISTA BUCOMAXILOFACIAL",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - TRAUMATOLOGISTA BUCOMAXILOFACIAL"
    },
    {
      "codigo_valor_dominio": 1631,
      "codigo_referencia_valor_dominio": "223272",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA DE SAUDE COLETIVA",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA DE SAUDE COLETIVA",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA DE SAUDE COLETIVA"
    },
    {
      "codigo_valor_dominio": 1632,
      "codigo_referencia_valor_dominio": "223276",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - ODONTOLOGIA DO TRABALHO",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - ODONTOLOGIA DO TRABALHO",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - ODONTOLOGIA DO TRABALHO"
    },
    {
      "codigo_valor_dominio": 1633,
      "codigo_referencia_valor_dominio": "223280",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - DENTISTICA",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - DENTISTICA",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - DENTISTICA"
    },
    {
      "codigo_valor_dominio": 1634,
      "codigo_referencia_valor_dominio": "223284",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - DISFUNCAO TEMPOROMANDIBULAR E DOR OROFA",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - DISFUNCAO TEMPOROMANDIBULAR E DOR OROFACIAL",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - DISFUNCAO TEMPOROMANDIBULAR E DOR OROFACIAL"
    },
    {
      "codigo_valor_dominio": 1635,
      "codigo_referencia_valor_dominio": "223288",
      "nome_resumido_valor_dominio": "CIRURGIAO DENTISTA - ODONTOLOGIA PARA PACIENTES COM NECESSID",
      "nome_completo_valor_dominio": "CIRURGIAO DENTISTA - ODONTOLOGIA PARA PACIENTES COM NECESSIDADES ESPECIAIS",
      "descricao_conceito_valor_dominio": "CIRURGIAO DENTISTA - ODONTOLOGIA PARA PACIENTES COM NECESSIDADES ESPECIAIS"
    },
    {
      "codigo_valor_dominio": 1636,
      "codigo_referencia_valor_dominio": "223293",
      "nome_resumido_valor_dominio": "CIRURGIAO-DENTISTA DA ESTRATEGIA DE SAUDE DA FAMILIA",
      "nome_completo_valor_dominio": "CIRURGIAO-DENTISTA DA ESTRATEGIA DE SAUDE DA FAMILIA",
      "descricao_conceito_valor_dominio": "CIRURGIAO-DENTISTA DA ESTRATEGIA DE SAUDE DA FAMILIA"
    },
    {
      "codigo_valor_dominio": 1637,
      "codigo_referencia_valor_dominio": "113015",
      "nome_resumido_valor_dominio": "MEMBRO DE LIDERANCA QUILOMBOLA",
      "nome_completo_valor_dominio": "MEMBRO DE LIDERANCA QUILOMBOLA",
      "descricao_conceito_valor_dominio": "MEMBRO DE LIDERANCA QUILOMBOLA"
    },
    {
      "codigo_valor_dominio": 1638,
      "codigo_referencia_valor_dominio": "223410",
      "nome_resumido_valor_dominio": "FARMACEUTICO BIOQUIMICO",
      "nome_completo_valor_dominio": "FARMACEUTICO BIOQUIMICO",
      "descricao_conceito_valor_dominio": "FARMACEUTICO BIOQUIMICO"
    },
    {
      "codigo_valor_dominio": 1639,
      "codigo_referencia_valor_dominio": "514320",
      "nome_resumido_valor_dominio": "FAXINEIRO",
      "nome_completo_valor_dominio": "FAXINEIRO",
      "descricao_conceito_valor_dominio": "FAXINEIRO"
    },
    {
      "codigo_valor_dominio": 1640,
      "codigo_referencia_valor_dominio": "223510",
      "nome_resumido_valor_dominio": "ENFERMEIRO AUDITOR",
      "nome_completo_valor_dominio": "ENFERMEIRO AUDITOR",
      "descricao_conceito_valor_dominio": "ENFERMEIRO AUDITOR"
    },
    {
      "codigo_valor_dominio": 1641,
      "codigo_referencia_valor_dominio": "223565",
      "nome_resumido_valor_dominio": "ENFERMEIRO DA ESTRATEGIA DE SAUDE DA FAMILIA",
      "nome_completo_valor_dominio": "ENFERMEIRO DA ESTRATEGIA DE SAUDE DA FAMILIA",
      "descricao_conceito_valor_dominio": "ENFERMEIRO DA ESTRATEGIA DE SAUDE DA FAMILIA"
    },
    {
      "codigo_valor_dominio": 1642,
      "codigo_referencia_valor_dominio": "223520",
      "nome_resumido_valor_dominio": "ENFERMEIRO DE CENTRO CIRURGICO",
      "nome_completo_valor_dominio": "ENFERMEIRO DE CENTRO CIRURGICO",
      "descricao_conceito_valor_dominio": "ENFERMEIRO DE CENTRO CIRURGICO"
    },
    {
      "codigo_valor_dominio": 1643,
      "codigo_referencia_valor_dominio": "223525",
      "nome_resumido_valor_dominio": "ENFERMEIRO DE TERAPIA INTENSIVA",
      "nome_completo_valor_dominio": "ENFERMEIRO DE TERAPIA INTENSIVA",
      "descricao_conceito_valor_dominio": "ENFERMEIRO DE TERAPIA INTENSIVA"
    },
    {
      "codigo_valor_dominio": 1644,
      "codigo_referencia_valor_dominio": "223530",
      "nome_resumido_valor_dominio": "ENFERMEIRO DO TRABALHO",
      "nome_completo_valor_dominio": "ENFERMEIRO DO TRABALHO",
      "descricao_conceito_valor_dominio": "ENFERMEIRO DO TRABALHO"
    },
    {
      "codigo_valor_dominio": 1645,
      "codigo_referencia_valor_dominio": "223535",
      "nome_resumido_valor_dominio": "ENFERMEIRO NEFROLOGISTA",
      "nome_completo_valor_dominio": "ENFERMEIRO NEFROLOGISTA",
      "descricao_conceito_valor_dominio": "ENFERMEIRO NEFROLOGISTA"
    },
    {
      "codigo_valor_dominio": 1646,
      "codigo_referencia_valor_dominio": "223540",
      "nome_resumido_valor_dominio": "ENFERMEIRO NEONATOLOGISTA",
      "nome_completo_valor_dominio": "ENFERMEIRO NEONATOLOGISTA",
      "descricao_conceito_valor_dominio": "ENFERMEIRO NEONATOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1647,
      "codigo_referencia_valor_dominio": "223545",
      "nome_resumido_valor_dominio": "ENFERMEIRO OBSTETRICO",
      "nome_completo_valor_dominio": "ENFERMEIRO OBSTETRICO",
      "descricao_conceito_valor_dominio": "ENFERMEIRO OBSTETRICO"
    },
    {
      "codigo_valor_dominio": 1648,
      "codigo_referencia_valor_dominio": "223550",
      "nome_resumido_valor_dominio": "ENFERMEIRO PSIQUIATRICO",
      "nome_completo_valor_dominio": "ENFERMEIRO PSIQUIATRICO",
      "descricao_conceito_valor_dominio": "ENFERMEIRO PSIQUIATRICO"
    },
    {
      "codigo_valor_dominio": 1649,
      "codigo_referencia_valor_dominio": "223555",
      "nome_resumido_valor_dominio": "ENFERMEIRO PUERICULTOR E PEDIATRICO",
      "nome_completo_valor_dominio": "ENFERMEIRO PUERICULTOR E PEDIATRICO",
      "descricao_conceito_valor_dominio": "ENFERMEIRO PUERICULTOR E PEDIATRICO"
    },
    {
      "codigo_valor_dominio": 1650,
      "codigo_referencia_valor_dominio": "223560",
      "nome_resumido_valor_dominio": "ENFERMEIRO SANITARISTA",
      "nome_completo_valor_dominio": "ENFERMEIRO SANITARISTA",
      "descricao_conceito_valor_dominio": "ENFERMEIRO SANITARISTA"
    },
    {
      "codigo_valor_dominio": 1651,
      "codigo_referencia_valor_dominio": "763115",
      "nome_resumido_valor_dominio": "ENFESTADOR DE ROUPAS",
      "nome_completo_valor_dominio": "ENFESTADOR DE ROUPAS",
      "descricao_conceito_valor_dominio": "ENFESTADOR DE ROUPAS"
    },
    {
      "codigo_valor_dominio": 1652,
      "codigo_referencia_valor_dominio": "223515",
      "nome_resumido_valor_dominio": "ENFERMEIRO DE BORDO",
      "nome_completo_valor_dominio": "ENFERMEIRO DE BORDO",
      "descricao_conceito_valor_dominio": "ENFERMEIRO DE BORDO"
    },
    {
      "codigo_valor_dominio": 1653,
      "codigo_referencia_valor_dominio": "252215",
      "nome_resumido_valor_dominio": "PERITO CONTABIL",
      "nome_completo_valor_dominio": "PERITO CONTABIL",
      "descricao_conceito_valor_dominio": "PERITO CONTABIL"
    },
    {
      "codigo_valor_dominio": 1654,
      "codigo_referencia_valor_dominio": "223630",
      "nome_resumido_valor_dominio": "FISIOTERAPEUTA NEUROFUNCIONAL",
      "nome_completo_valor_dominio": "FISIOTERAPEUTA NEUROFUNCIONAL",
      "descricao_conceito_valor_dominio": "FISIOTERAPEUTA NEUROFUNCIONAL"
    },
    {
      "codigo_valor_dominio": 1655,
      "codigo_referencia_valor_dominio": "223635",
      "nome_resumido_valor_dominio": "FISIOTERAPEUTA TRAUMATO-ORTOPEDICA FUNCIONAL",
      "nome_completo_valor_dominio": "FISIOTERAPEUTA TRAUMATO-ORTOPEDICA FUNCIONAL",
      "descricao_conceito_valor_dominio": "FISIOTERAPEUTA TRAUMATO-ORTOPEDICA FUNCIONAL"
    },
    {
      "codigo_valor_dominio": 1656,
      "codigo_referencia_valor_dominio": "223640",
      "nome_resumido_valor_dominio": "FISIOTERAPEUTA OSTEOPATA",
      "nome_completo_valor_dominio": "FISIOTERAPEUTA OSTEOPATA",
      "descricao_conceito_valor_dominio": "FISIOTERAPEUTA OSTEOPATA"
    },
    {
      "codigo_valor_dominio": 1657,
      "codigo_referencia_valor_dominio": "415120",
      "nome_resumido_valor_dominio": "FITOTECARIO",
      "nome_completo_valor_dominio": "FITOTECARIO",
      "descricao_conceito_valor_dominio": "FITOTECARIO"
    },
    {
      "codigo_valor_dominio": 1658,
      "codigo_referencia_valor_dominio": "223645",
      "nome_resumido_valor_dominio": "FISIOTERAPEUTA QUIROPRAXISTA",
      "nome_completo_valor_dominio": "FISIOTERAPEUTA QUIROPRAXISTA",
      "descricao_conceito_valor_dominio": "FISIOTERAPEUTA QUIROPRAXISTA"
    },
    {
      "codigo_valor_dominio": 1659,
      "codigo_referencia_valor_dominio": "223625",
      "nome_resumido_valor_dominio": "FISIOTERAPEUTA RESPIRATORIA",
      "nome_completo_valor_dominio": "FISIOTERAPEUTA RESPIRATORIA",
      "descricao_conceito_valor_dominio": "FISIOTERAPEUTA RESPIRATORIA"
    },
    {
      "codigo_valor_dominio": 1660,
      "codigo_referencia_valor_dominio": "223655",
      "nome_resumido_valor_dominio": "FISIOTERAPEUTA ESPORTIVO",
      "nome_completo_valor_dominio": "FISIOTERAPEUTA ESPORTIVO",
      "descricao_conceito_valor_dominio": "FISIOTERAPEUTA ESPORTIVO"
    },
    {
      "codigo_valor_dominio": 1661,
      "codigo_referencia_valor_dominio": "223605",
      "nome_resumido_valor_dominio": "FISIOTERAPEUTA GERAL",
      "nome_completo_valor_dominio": "FISIOTERAPEUTA GERAL",
      "descricao_conceito_valor_dominio": "FISIOTERAPEUTA GERAL"
    },
    {
      "codigo_valor_dominio": 1662,
      "codigo_referencia_valor_dominio": "223650",
      "nome_resumido_valor_dominio": "FISIOTERAPEUTA ACUPUNTURISTA",
      "nome_completo_valor_dominio": "FISIOTERAPEUTA ACUPUNTURISTA",
      "descricao_conceito_valor_dominio": "FISIOTERAPEUTA ACUPUNTURISTA"
    },
    {
      "codigo_valor_dominio": 1663,
      "codigo_referencia_valor_dominio": "412110",
      "nome_resumido_valor_dominio": "DIGITADOR",
      "nome_completo_valor_dominio": "DIGITADOR",
      "descricao_conceito_valor_dominio": "DIGITADOR"
    },
    {
      "codigo_valor_dominio": 1664,
      "codigo_referencia_valor_dominio": "213440",
      "nome_resumido_valor_dominio": "OCEANOGRAFO",
      "nome_completo_valor_dominio": "OCEANOGRAFO",
      "descricao_conceito_valor_dominio": "OCEANOGRAFO"
    },
    {
      "codigo_valor_dominio": 1665,
      "codigo_referencia_valor_dominio": "722105",
      "nome_resumido_valor_dominio": "FORJADOR",
      "nome_completo_valor_dominio": "FORJADOR",
      "descricao_conceito_valor_dominio": "FORJADOR"
    },
    {
      "codigo_valor_dominio": 1666,
      "codigo_referencia_valor_dominio": "353230",
      "nome_resumido_valor_dominio": "TESOUREIRO DE BANCO",
      "nome_completo_valor_dominio": "TESOUREIRO DE BANCO",
      "descricao_conceito_valor_dominio": "TESOUREIRO DE BANCO"
    },
    {
      "codigo_valor_dominio": 1667,
      "codigo_referencia_valor_dominio": "751125",
      "nome_resumido_valor_dominio": "OURIVES",
      "nome_completo_valor_dominio": "OURIVES",
      "descricao_conceito_valor_dominio": "OURIVES"
    },
    {
      "codigo_valor_dominio": 1668,
      "codigo_referencia_valor_dominio": "261725",
      "nome_resumido_valor_dominio": "NARRADOR EM PROGRAMAS DE RADIO E TELEVISAO",
      "nome_completo_valor_dominio": "NARRADOR EM PROGRAMAS DE RADIO E TELEVISAO",
      "descricao_conceito_valor_dominio": "NARRADOR EM PROGRAMAS DE RADIO E TELEVISAO"
    },
    {
      "codigo_valor_dominio": 1669,
      "codigo_referencia_valor_dominio": "224105",
      "nome_resumido_valor_dominio": "AVALIADOR FISICO",
      "nome_completo_valor_dominio": "AVALIADOR FISICO",
      "descricao_conceito_valor_dominio": "AVALIADOR FISICO"
    },
    {
      "codigo_valor_dominio": 1670,
      "codigo_referencia_valor_dominio": "775115",
      "nome_resumido_valor_dominio": "LUSTRADOR DE PECAS DE MADEIRA",
      "nome_completo_valor_dominio": "LUSTRADOR DE PECAS DE MADEIRA",
      "descricao_conceito_valor_dominio": "LUSTRADOR DE PECAS DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 1671,
      "codigo_referencia_valor_dominio": "823120",
      "nome_resumido_valor_dominio": "PREPARADOR DE BARBOTINA",
      "nome_completo_valor_dominio": "PREPARADOR DE BARBOTINA",
      "descricao_conceito_valor_dominio": "PREPARADOR DE BARBOTINA"
    },
    {
      "codigo_valor_dominio": 1672,
      "codigo_referencia_valor_dominio": "111205",
      "nome_resumido_valor_dominio": "PRESIDENTE DA REPUBLICA",
      "nome_completo_valor_dominio": "PRESIDENTE DA REPUBLICA",
      "descricao_conceito_valor_dominio": "PRESIDENTE DA REPUBLICA"
    },
    {
      "codigo_valor_dominio": 1673,
      "codigo_referencia_valor_dominio": "322205",
      "nome_resumido_valor_dominio": "TECNICO DE ENFERMAGEM",
      "nome_completo_valor_dominio": "TECNICO DE ENFERMAGEM",
      "descricao_conceito_valor_dominio": "TECNICO DE ENFERMAGEM"
    },
    {
      "codigo_valor_dominio": 1674,
      "codigo_referencia_valor_dominio": "301105",
      "nome_resumido_valor_dominio": "TECNICO DE LABORATORIO INDUSTRIAL",
      "nome_completo_valor_dominio": "TECNICO DE LABORATORIO INDUSTRIAL",
      "descricao_conceito_valor_dominio": "TECNICO DE LABORATORIO INDUSTRIAL"
    },
    {
      "codigo_valor_dominio": 1675,
      "codigo_referencia_valor_dominio": "768115",
      "nome_resumido_valor_dominio": "TRICOTEIRO, A MAO",
      "nome_completo_valor_dominio": "TRICOTEIRO, A MAO",
      "descricao_conceito_valor_dominio": "TRICOTEIRO, A MAO"
    },
    {
      "codigo_valor_dominio": 1676,
      "codigo_referencia_valor_dominio": "225106",
      "nome_resumido_valor_dominio": "MEDICO LEGISTA",
      "nome_completo_valor_dominio": "MEDICO LEGISTA",
      "descricao_conceito_valor_dominio": "MEDICO LEGISTA"
    },
    {
      "codigo_valor_dominio": 1677,
      "codigo_referencia_valor_dominio": "225110",
      "nome_resumido_valor_dominio": "MEDICO ALERGISTA E IMUNOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO ALERGISTA E IMUNOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO ALERGISTA E IMUNOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1678,
      "codigo_referencia_valor_dominio": "225255",
      "nome_resumido_valor_dominio": "MEDICO MASTOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO MASTOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO MASTOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1679,
      "codigo_referencia_valor_dominio": "225260",
      "nome_resumido_valor_dominio": "MEDICO NEUROCIRURGIAO",
      "nome_completo_valor_dominio": "MEDICO NEUROCIRURGIAO",
      "descricao_conceito_valor_dominio": "MEDICO NEUROCIRURGIAO"
    },
    {
      "codigo_valor_dominio": 1680,
      "codigo_referencia_valor_dominio": "225148",
      "nome_resumido_valor_dominio": "MEDICO ANATOMOPATOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO ANATOMOPATOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO ANATOMOPATOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1681,
      "codigo_referencia_valor_dominio": "225118",
      "nome_resumido_valor_dominio": "MEDICO NUTROLOGISTA",
      "nome_completo_valor_dominio": "MEDICO NUTROLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO NUTROLOGISTA"
    },
    {
      "codigo_valor_dominio": 1682,
      "codigo_referencia_valor_dominio": "225290",
      "nome_resumido_valor_dominio": "MEDICO CANCEROLOGISTA CIRURGICO",
      "nome_completo_valor_dominio": "MEDICO CANCEROLOGISTA CIRURGICO",
      "descricao_conceito_valor_dominio": "MEDICO CANCEROLOGISTA CIRURGICO"
    },
    {
      "codigo_valor_dominio": 1683,
      "codigo_referencia_valor_dominio": "225265",
      "nome_resumido_valor_dominio": "MEDICO OFTALMOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO OFTALMOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO OFTALMOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1684,
      "codigo_referencia_valor_dominio": "225210",
      "nome_resumido_valor_dominio": "MEDICO CIRURGIAO CARDIOVASCULAR",
      "nome_completo_valor_dominio": "MEDICO CIRURGIAO CARDIOVASCULAR",
      "descricao_conceito_valor_dominio": "MEDICO CIRURGIAO CARDIOVASCULAR"
    },
    {
      "codigo_valor_dominio": 1685,
      "codigo_referencia_valor_dominio": "225270",
      "nome_resumido_valor_dominio": "MEDICO ORTOPEDISTA E TRAUMATOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO ORTOPEDISTA E TRAUMATOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO ORTOPEDISTA E TRAUMATOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1686,
      "codigo_referencia_valor_dominio": "225120",
      "nome_resumido_valor_dominio": "MEDICO CARDIOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO CARDIOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO CARDIOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1687,
      "codigo_referencia_valor_dominio": "225127",
      "nome_resumido_valor_dominio": "MEDICO PNEUMOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO PNEUMOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO PNEUMOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1688,
      "codigo_referencia_valor_dominio": "225280",
      "nome_resumido_valor_dominio": "MEDICO COLOPROCTOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO COLOPROCTOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO COLOPROCTOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1689,
      "codigo_referencia_valor_dominio": "225133",
      "nome_resumido_valor_dominio": "MEDICO PSIQUIATRA",
      "nome_completo_valor_dominio": "MEDICO PSIQUIATRA",
      "descricao_conceito_valor_dominio": "MEDICO PSIQUIATRA"
    },
    {
      "codigo_valor_dominio": 1690,
      "codigo_referencia_valor_dominio": "225135",
      "nome_resumido_valor_dominio": "MEDICO DERMATOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO DERMATOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO DERMATOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1691,
      "codigo_referencia_valor_dominio": "225330",
      "nome_resumido_valor_dominio": "MEDICO RADIOTERAPEUTA",
      "nome_completo_valor_dominio": "MEDICO RADIOTERAPEUTA",
      "descricao_conceito_valor_dominio": "MEDICO RADIOTERAPEUTA"
    },
    {
      "codigo_valor_dominio": 1692,
      "codigo_referencia_valor_dominio": "225140",
      "nome_resumido_valor_dominio": "MEDICO DO TRABALHO",
      "nome_completo_valor_dominio": "MEDICO DO TRABALHO",
      "descricao_conceito_valor_dominio": "MEDICO DO TRABALHO"
    },
    {
      "codigo_valor_dominio": 1693,
      "codigo_referencia_valor_dominio": "225139",
      "nome_resumido_valor_dominio": "MEDICO SANITARISTA",
      "nome_completo_valor_dominio": "MEDICO SANITARISTA",
      "descricao_conceito_valor_dominio": "MEDICO SANITARISTA"
    },
    {
      "codigo_valor_dominio": 1694,
      "codigo_referencia_valor_dominio": "225285",
      "nome_resumido_valor_dominio": "MEDICO UROLOGISTA",
      "nome_completo_valor_dominio": "MEDICO UROLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO UROLOGISTA"
    },
    {
      "codigo_valor_dominio": 1695,
      "codigo_referencia_valor_dominio": "225203",
      "nome_resumido_valor_dominio": "MEDICO EM CIRURGIA VASCULAR",
      "nome_completo_valor_dominio": "MEDICO EM CIRURGIA VASCULAR",
      "descricao_conceito_valor_dominio": "MEDICO EM CIRURGIA VASCULAR"
    },
    {
      "codigo_valor_dominio": 1696,
      "codigo_referencia_valor_dominio": "225130",
      "nome_resumido_valor_dominio": "MEDICO DE FAMILIA E COMUNIDADE",
      "nome_completo_valor_dominio": "MEDICO DE FAMILIA E COMUNIDADE",
      "descricao_conceito_valor_dominio": "MEDICO DE FAMILIA E COMUNIDADE"
    },
    {
      "codigo_valor_dominio": 1697,
      "codigo_referencia_valor_dominio": "225150",
      "nome_resumido_valor_dominio": "MEDICO EM MEDICINA INTENSIVA",
      "nome_completo_valor_dominio": "MEDICO EM MEDICINA INTENSIVA",
      "descricao_conceito_valor_dominio": "MEDICO EM MEDICINA INTENSIVA"
    },
    {
      "codigo_valor_dominio": 1698,
      "codigo_referencia_valor_dominio": "225151",
      "nome_resumido_valor_dominio": "MEDICO ANESTESIOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO ANESTESIOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO ANESTESIOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1699,
      "codigo_referencia_valor_dominio": "225315",
      "nome_resumido_valor_dominio": "MEDICO EM MEDICINA NUCLEAR",
      "nome_completo_valor_dominio": "MEDICO EM MEDICINA NUCLEAR",
      "descricao_conceito_valor_dominio": "MEDICO EM MEDICINA NUCLEAR"
    },
    {
      "codigo_valor_dominio": 1700,
      "codigo_referencia_valor_dominio": "225115",
      "nome_resumido_valor_dominio": "MEDICO ANGIOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO ANGIOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO ANGIOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1701,
      "codigo_referencia_valor_dominio": "225160",
      "nome_resumido_valor_dominio": "MEDICO FISIATRA",
      "nome_completo_valor_dominio": "MEDICO FISIATRA",
      "descricao_conceito_valor_dominio": "MEDICO FISIATRA"
    },
    {
      "codigo_valor_dominio": 1702,
      "codigo_referencia_valor_dominio": "225165",
      "nome_resumido_valor_dominio": "MEDICO GASTROENTEROLOGISTA",
      "nome_completo_valor_dominio": "MEDICO GASTROENTEROLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO GASTROENTEROLOGISTA"
    },
    {
      "codigo_valor_dominio": 1703,
      "codigo_referencia_valor_dominio": "225170",
      "nome_resumido_valor_dominio": "MEDICO GENERALISTA",
      "nome_completo_valor_dominio": "MEDICO GENERALISTA",
      "descricao_conceito_valor_dominio": "MEDICO GENERALISTA"
    },
    {
      "codigo_valor_dominio": 1704,
      "codigo_referencia_valor_dominio": "225175",
      "nome_resumido_valor_dominio": "MEDICO GENETICISTA",
      "nome_completo_valor_dominio": "MEDICO GENETICISTA",
      "descricao_conceito_valor_dominio": "MEDICO GENETICISTA"
    },
    {
      "codigo_valor_dominio": 1705,
      "codigo_referencia_valor_dominio": "225180",
      "nome_resumido_valor_dominio": "MEDICO GERIATRA",
      "nome_completo_valor_dominio": "MEDICO GERIATRA",
      "descricao_conceito_valor_dominio": "MEDICO GERIATRA"
    },
    {
      "codigo_valor_dominio": 1706,
      "codigo_referencia_valor_dominio": "225250",
      "nome_resumido_valor_dominio": "MEDICO GINECOLOGISTA E OBSTETRA",
      "nome_completo_valor_dominio": "MEDICO GINECOLOGISTA E OBSTETRA",
      "descricao_conceito_valor_dominio": "MEDICO GINECOLOGISTA E OBSTETRA"
    },
    {
      "codigo_valor_dominio": 1707,
      "codigo_referencia_valor_dominio": "225340",
      "nome_resumido_valor_dominio": "MEDICO HEMOTERAPEUTA",
      "nome_completo_valor_dominio": "MEDICO HEMOTERAPEUTA",
      "descricao_conceito_valor_dominio": "MEDICO HEMOTERAPEUTA"
    },
    {
      "codigo_valor_dominio": 1708,
      "codigo_referencia_valor_dominio": "225103",
      "nome_resumido_valor_dominio": "MEDICO INFECTOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO INFECTOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO INFECTOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1709,
      "codigo_referencia_valor_dominio": "225310",
      "nome_resumido_valor_dominio": "MEDICO EM ENDOSCOPIA",
      "nome_completo_valor_dominio": "MEDICO EM ENDOSCOPIA",
      "descricao_conceito_valor_dominio": "MEDICO EM ENDOSCOPIA"
    },
    {
      "codigo_valor_dominio": 1710,
      "codigo_referencia_valor_dominio": "225295",
      "nome_resumido_valor_dominio": "MEDICO CIRURGIAO DA MAO",
      "nome_completo_valor_dominio": "MEDICO CIRURGIAO DA MAO",
      "descricao_conceito_valor_dominio": "MEDICO CIRURGIAO DA MAO"
    },
    {
      "codigo_valor_dominio": 1711,
      "codigo_referencia_valor_dominio": "225220",
      "nome_resumido_valor_dominio": "MEDICO CIRURGIAO DO APARELHO DIGESTIVO",
      "nome_completo_valor_dominio": "MEDICO CIRURGIAO DO APARELHO DIGESTIVO",
      "descricao_conceito_valor_dominio": "MEDICO CIRURGIAO DO APARELHO DIGESTIVO"
    },
    {
      "codigo_valor_dominio": 1712,
      "codigo_referencia_valor_dominio": "225225",
      "nome_resumido_valor_dominio": "MEDICO CIRURGIAO GERAL",
      "nome_completo_valor_dominio": "MEDICO CIRURGIAO GERAL",
      "descricao_conceito_valor_dominio": "MEDICO CIRURGIAO GERAL"
    },
    {
      "codigo_valor_dominio": 1713,
      "codigo_referencia_valor_dominio": "225230",
      "nome_resumido_valor_dominio": "MEDICO CIRURGIAO PEDIATRICO",
      "nome_completo_valor_dominio": "MEDICO CIRURGIAO PEDIATRICO",
      "descricao_conceito_valor_dominio": "MEDICO CIRURGIAO PEDIATRICO"
    },
    {
      "codigo_valor_dominio": 1714,
      "codigo_referencia_valor_dominio": "225235",
      "nome_resumido_valor_dominio": "MEDICO CIRURGIAO PLASTICO",
      "nome_completo_valor_dominio": "MEDICO CIRURGIAO PLASTICO",
      "descricao_conceito_valor_dominio": "MEDICO CIRURGIAO PLASTICO"
    },
    {
      "codigo_valor_dominio": 1715,
      "codigo_referencia_valor_dominio": "225240",
      "nome_resumido_valor_dominio": "MEDICO CIRURGIAO TORACICO",
      "nome_completo_valor_dominio": "MEDICO CIRURGIAO TORACICO",
      "descricao_conceito_valor_dominio": "MEDICO CIRURGIAO TORACICO"
    },
    {
      "codigo_valor_dominio": 1716,
      "codigo_referencia_valor_dominio": "225305",
      "nome_resumido_valor_dominio": "MEDICO CITOPATOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO CITOPATOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO CITOPATOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1717,
      "codigo_referencia_valor_dominio": "225185",
      "nome_resumido_valor_dominio": "MEDICO HEMATOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO HEMATOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO HEMATOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1718,
      "codigo_referencia_valor_dominio": "225109",
      "nome_resumido_valor_dominio": "MEDICO NEFROLOGISTA",
      "nome_completo_valor_dominio": "MEDICO NEFROLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO NEFROLOGISTA"
    },
    {
      "codigo_valor_dominio": 1719,
      "codigo_referencia_valor_dominio": "225350",
      "nome_resumido_valor_dominio": "MEDICO NEUROFISIOLOGISTA CLINICO",
      "nome_completo_valor_dominio": "MEDICO NEUROFISIOLOGISTA CLINICO",
      "descricao_conceito_valor_dominio": "MEDICO NEUROFISIOLOGISTA CLINICO"
    },
    {
      "codigo_valor_dominio": 1720,
      "codigo_referencia_valor_dominio": "225121",
      "nome_resumido_valor_dominio": "MEDICO ONCOLOGISTA CLINICO",
      "nome_completo_valor_dominio": "MEDICO ONCOLOGISTA CLINICO",
      "descricao_conceito_valor_dominio": "MEDICO ONCOLOGISTA CLINICO"
    },
    {
      "codigo_valor_dominio": 1721,
      "codigo_referencia_valor_dominio": "225275",
      "nome_resumido_valor_dominio": "MEDICO OTORRINOLARINGOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO OTORRINOLARINGOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO OTORRINOLARINGOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1722,
      "codigo_referencia_valor_dominio": "225325",
      "nome_resumido_valor_dominio": "MEDICO PATOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO PATOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO PATOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1723,
      "codigo_referencia_valor_dominio": "225142",
      "nome_resumido_valor_dominio": "MEDICO DA ESTRATEGIA DE SAUDE DA FAMILIA",
      "nome_completo_valor_dominio": "MEDICO DA ESTRATEGIA DE SAUDE DA FAMILIA",
      "descricao_conceito_valor_dominio": "MEDICO DA ESTRATEGIA DE SAUDE DA FAMILIA"
    },
    {
      "codigo_valor_dominio": 1724,
      "codigo_referencia_valor_dominio": "223305",
      "nome_resumido_valor_dominio": "MEDICO VETERINARIO",
      "nome_completo_valor_dominio": "MEDICO VETERINARIO",
      "descricao_conceito_valor_dominio": "MEDICO VETERINARIO"
    },
    {
      "codigo_valor_dominio": 1725,
      "codigo_referencia_valor_dominio": "225122",
      "nome_resumido_valor_dominio": "MEDICO CANCEROLOGISTA PEDIATRICO",
      "nome_completo_valor_dominio": "MEDICO CANCEROLOGISTA PEDIATRICO",
      "descricao_conceito_valor_dominio": "MEDICO CANCEROLOGISTA PEDIATRICO"
    },
    {
      "codigo_valor_dominio": 1726,
      "codigo_referencia_valor_dominio": "225215",
      "nome_resumido_valor_dominio": "MEDICO CIRURGIAO DE CABECA E PESCOCO",
      "nome_completo_valor_dominio": "MEDICO CIRURGIAO DE CABECA E PESCOCO",
      "descricao_conceito_valor_dominio": "MEDICO CIRURGIAO DE CABECA E PESCOCO"
    },
    {
      "codigo_valor_dominio": 1727,
      "codigo_referencia_valor_dominio": "225125",
      "nome_resumido_valor_dominio": "MEDICO CLINICO",
      "nome_completo_valor_dominio": "MEDICO CLINICO",
      "descricao_conceito_valor_dominio": "MEDICO CLINICO"
    },
    {
      "codigo_valor_dominio": 1728,
      "codigo_referencia_valor_dominio": "225145",
      "nome_resumido_valor_dominio": "MEDICO EM MEDICINA DE TRAFEGO",
      "nome_completo_valor_dominio": "MEDICO EM MEDICINA DE TRAFEGO",
      "descricao_conceito_valor_dominio": "MEDICO EM MEDICINA DE TRAFEGO"
    },
    {
      "codigo_valor_dominio": 1729,
      "codigo_referencia_valor_dominio": "225320",
      "nome_resumido_valor_dominio": "MEDICO EM RADIOLOGIA E DIAGNOSTICO POR IMAGEM",
      "nome_completo_valor_dominio": "MEDICO EM RADIOLOGIA E DIAGNOSTICO POR IMAGEM",
      "descricao_conceito_valor_dominio": "MEDICO EM RADIOLOGIA E DIAGNOSTICO POR IMAGEM"
    },
    {
      "codigo_valor_dominio": 1730,
      "codigo_referencia_valor_dominio": "225155",
      "nome_resumido_valor_dominio": "MEDICO ENDOCRINOLOGISTA E METABOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO ENDOCRINOLOGISTA E METABOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO ENDOCRINOLOGISTA E METABOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1731,
      "codigo_referencia_valor_dominio": "225335",
      "nome_resumido_valor_dominio": "MEDICO PATOLOGISTA CLINICO / MEDICINA LABORATORIAL",
      "nome_completo_valor_dominio": "MEDICO PATOLOGISTA CLINICO / MEDICINA LABORATORIAL",
      "descricao_conceito_valor_dominio": "MEDICO PATOLOGISTA CLINICO / MEDICINA LABORATORIAL"
    },
    {
      "codigo_valor_dominio": 1732,
      "codigo_referencia_valor_dominio": "225136",
      "nome_resumido_valor_dominio": "MEDICO REUMATOLOGISTA",
      "nome_completo_valor_dominio": "MEDICO REUMATOLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO REUMATOLOGISTA"
    },
    {
      "codigo_valor_dominio": 1733,
      "codigo_referencia_valor_dominio": "225124",
      "nome_resumido_valor_dominio": "MEDICO PEDIATRA",
      "nome_completo_valor_dominio": "MEDICO PEDIATRA",
      "descricao_conceito_valor_dominio": "MEDICO PEDIATRA"
    },
    {
      "codigo_valor_dominio": 1734,
      "codigo_referencia_valor_dominio": "225345",
      "nome_resumido_valor_dominio": "MEDICO HIPERBARISTA",
      "nome_completo_valor_dominio": "MEDICO HIPERBARISTA",
      "descricao_conceito_valor_dominio": "MEDICO HIPERBARISTA"
    },
    {
      "codigo_valor_dominio": 1735,
      "codigo_referencia_valor_dominio": "225195",
      "nome_resumido_valor_dominio": "MEDICO HOMEOPATA",
      "nome_completo_valor_dominio": "MEDICO HOMEOPATA",
      "descricao_conceito_valor_dominio": "MEDICO HOMEOPATA"
    },
    {
      "codigo_valor_dominio": 1736,
      "codigo_referencia_valor_dominio": "225112",
      "nome_resumido_valor_dominio": "MEDICO NEUROLOGISTA",
      "nome_completo_valor_dominio": "MEDICO NEUROLOGISTA",
      "descricao_conceito_valor_dominio": "MEDICO NEUROLOGISTA"
    },
    {
      "codigo_valor_dominio": 1737,
      "codigo_referencia_valor_dominio": "231110",
      "nome_resumido_valor_dominio": "PROFESSOR DE NIVEL SUPERIOR NA EDUCACAO INFANTIL (ZERO A TRE",
      "nome_completo_valor_dominio": "PROFESSOR DE NIVEL SUPERIOR NA EDUCACAO INFANTIL (ZERO A TRES ANOS)",
      "descricao_conceito_valor_dominio": "PROFESSOR DE NIVEL SUPERIOR NA EDUCACAO INFANTIL (ZERO A TRES ANOS)"
    },
    {
      "codigo_valor_dominio": 1738,
      "codigo_referencia_valor_dominio": "234445",
      "nome_resumido_valor_dominio": "PROFESSOR DE NUTRICAO",
      "nome_completo_valor_dominio": "PROFESSOR DE NUTRICAO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE NUTRICAO"
    },
    {
      "codigo_valor_dominio": 1739,
      "codigo_referencia_valor_dominio": "233105",
      "nome_resumido_valor_dominio": "PROFESSOR DA AREA DE MEIO AMBIENTE",
      "nome_completo_valor_dominio": "PROFESSOR DA AREA DE MEIO AMBIENTE",
      "descricao_conceito_valor_dominio": "PROFESSOR DA AREA DE MEIO AMBIENTE"
    },
    {
      "codigo_valor_dominio": 1740,
      "codigo_referencia_valor_dominio": "231105",
      "nome_resumido_valor_dominio": "PROFESSOR DE NIVEL SUPERIOR NA EDUCACAO INFANTIL (QUATRO A S",
      "nome_completo_valor_dominio": "PROFESSOR DE NIVEL SUPERIOR NA EDUCACAO INFANTIL (QUATRO A SEIS ANOS)",
      "descricao_conceito_valor_dominio": "PROFESSOR DE NIVEL SUPERIOR NA EDUCACAO INFANTIL (QUATRO A SEIS ANOS)"
    },
    {
      "codigo_valor_dominio": 1741,
      "codigo_referencia_valor_dominio": "234120",
      "nome_resumido_valor_dominio": "PROFESSOR DE COMPUTACAO (NO ENSINO SUPERIOR)",
      "nome_completo_valor_dominio": "PROFESSOR DE COMPUTACAO (NO ENSINO SUPERIOR)",
      "descricao_conceito_valor_dominio": "PROFESSOR DE COMPUTACAO (NO ENSINO SUPERIOR)"
    },
    {
      "codigo_valor_dominio": 1742,
      "codigo_referencia_valor_dominio": "231315",
      "nome_resumido_valor_dominio": "PROFESSOR DE EDUCACAO FISICA DO ENSINO FUNDAMENTAL",
      "nome_completo_valor_dominio": "PROFESSOR DE EDUCACAO FISICA DO ENSINO FUNDAMENTAL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE EDUCACAO FISICA DO ENSINO FUNDAMENTAL"
    },
    {
      "codigo_valor_dominio": 1743,
      "codigo_referencia_valor_dominio": "232120",
      "nome_resumido_valor_dominio": "PROFESSOR DE EDUCACAO FISICA NO ENSINO MEDIO",
      "nome_completo_valor_dominio": "PROFESSOR DE EDUCACAO FISICA NO ENSINO MEDIO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE EDUCACAO FISICA NO ENSINO MEDIO"
    },
    {
      "codigo_valor_dominio": 1744,
      "codigo_referencia_valor_dominio": "234740",
      "nome_resumido_valor_dominio": "PROFESSOR DE GEOGRAFIA DO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE GEOGRAFIA DO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE GEOGRAFIA DO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1745,
      "codigo_referencia_valor_dominio": "234745",
      "nome_resumido_valor_dominio": "PROFESSOR DE HISTORIA DO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE HISTORIA DO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE HISTORIA DO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1746,
      "codigo_referencia_valor_dominio": "232150",
      "nome_resumido_valor_dominio": "PROFESSOR DE LINGUA ESTRANGEIRA MODERNA NO ENSINO MEDIO",
      "nome_completo_valor_dominio": "PROFESSOR DE LINGUA ESTRANGEIRA MODERNA NO ENSINO MEDIO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LINGUA ESTRANGEIRA MODERNA NO ENSINO MEDIO"
    },
    {
      "codigo_valor_dominio": 1747,
      "codigo_referencia_valor_dominio": "234668",
      "nome_resumido_valor_dominio": "PROFESSOR DE LINGUAS ESTRANGEIRAS MODERNAS",
      "nome_completo_valor_dominio": "PROFESSOR DE LINGUAS ESTRANGEIRAS MODERNAS",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LINGUAS ESTRANGEIRAS MODERNAS"
    },
    {
      "codigo_valor_dominio": 1748,
      "codigo_referencia_valor_dominio": "232155",
      "nome_resumido_valor_dominio": "PROFESSOR DE MATEMATICA NO ENSINO MEDIO",
      "nome_completo_valor_dominio": "PROFESSOR DE MATEMATICA NO ENSINO MEDIO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE MATEMATICA NO ENSINO MEDIO"
    },
    {
      "codigo_valor_dominio": 1749,
      "codigo_referencia_valor_dominio": "234910",
      "nome_resumido_valor_dominio": "PROFESSOR DE ARTES VISUAIS NO ENSINO SUPERIOR (ARTES PLASTIC",
      "nome_completo_valor_dominio": "PROFESSOR DE ARTES VISUAIS NO ENSINO SUPERIOR (ARTES PLASTICAS E MULTIMIDIA)",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ARTES VISUAIS NO ENSINO SUPERIOR (ARTES PLASTICAS E MULTIMIDIA)"
    },
    {
      "codigo_valor_dominio": 1750,
      "codigo_referencia_valor_dominio": "234720",
      "nome_resumido_valor_dominio": "PROFESSOR DE CIENCIA POLITICA DO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE CIENCIA POLITICA DO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE CIENCIA POLITICA DO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1751,
      "codigo_referencia_valor_dominio": "234805",
      "nome_resumido_valor_dominio": "PROFESSOR DE ECONOMIA",
      "nome_completo_valor_dominio": "PROFESSOR DE ECONOMIA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ECONOMIA"
    },
    {
      "codigo_valor_dominio": 1752,
      "codigo_referencia_valor_dominio": "234410",
      "nome_resumido_valor_dominio": "PROFESSOR DE EDUCACAO FISICA NO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE EDUCACAO FISICA NO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE EDUCACAO FISICA NO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1753,
      "codigo_referencia_valor_dominio": "234205",
      "nome_resumido_valor_dominio": "PROFESSOR DE FISICA (ENSINO SUPERIOR)",
      "nome_completo_valor_dominio": "PROFESSOR DE FISICA (ENSINO SUPERIOR)",
      "descricao_conceito_valor_dominio": "PROFESSOR DE FISICA (ENSINO SUPERIOR)"
    },
    {
      "codigo_valor_dominio": 1754,
      "codigo_referencia_valor_dominio": "234425",
      "nome_resumido_valor_dominio": "PROFESSOR DE FISIOTERAPIA",
      "nome_completo_valor_dominio": "PROFESSOR DE FISIOTERAPIA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE FISIOTERAPIA"
    },
    {
      "codigo_valor_dominio": 1755,
      "codigo_referencia_valor_dominio": "234320",
      "nome_resumido_valor_dominio": "PROFESSOR DE GEOLOGIA",
      "nome_completo_valor_dominio": "PROFESSOR DE GEOLOGIA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE GEOLOGIA"
    },
    {
      "codigo_valor_dominio": 1756,
      "codigo_referencia_valor_dominio": "234750",
      "nome_resumido_valor_dominio": "PROFESSOR DE JORNALISMO",
      "nome_completo_valor_dominio": "PROFESSOR DE JORNALISMO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE JORNALISMO"
    },
    {
      "codigo_valor_dominio": 1757,
      "codigo_referencia_valor_dominio": "234620",
      "nome_resumido_valor_dominio": "PROFESSOR DE LINGUA ESPANHOLA",
      "nome_completo_valor_dominio": "PROFESSOR DE LINGUA ESPANHOLA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LINGUA ESPANHOLA"
    },
    {
      "codigo_valor_dominio": 1758,
      "codigo_referencia_valor_dominio": "234612",
      "nome_resumido_valor_dominio": "PROFESSOR DE LINGUA FRANCESA",
      "nome_completo_valor_dominio": "PROFESSOR DE LINGUA FRANCESA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LINGUA FRANCESA"
    },
    {
      "codigo_valor_dominio": 1759,
      "codigo_referencia_valor_dominio": "234110",
      "nome_resumido_valor_dominio": "PROFESSOR DE MATEMATICA PURA (NO ENSINO SUPERIOR)",
      "nome_completo_valor_dominio": "PROFESSOR DE MATEMATICA PURA (NO ENSINO SUPERIOR)",
      "descricao_conceito_valor_dominio": "PROFESSOR DE MATEMATICA PURA (NO ENSINO SUPERIOR)"
    },
    {
      "codigo_valor_dominio": 1760,
      "codigo_referencia_valor_dominio": "234210",
      "nome_resumido_valor_dominio": "PROFESSOR DE QUIMICA (ENSINO SUPERIOR)",
      "nome_completo_valor_dominio": "PROFESSOR DE QUIMICA (ENSINO SUPERIOR)",
      "descricao_conceito_valor_dominio": "PROFESSOR DE QUIMICA (ENSINO SUPERIOR)"
    },
    {
      "codigo_valor_dominio": 1761,
      "codigo_referencia_valor_dominio": "234680",
      "nome_resumido_valor_dominio": "PROFESSOR DE SEMIOTICA",
      "nome_completo_valor_dominio": "PROFESSOR DE SEMIOTICA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE SEMIOTICA"
    },
    {
      "codigo_valor_dominio": 1762,
      "codigo_referencia_valor_dominio": "233115",
      "nome_resumido_valor_dominio": "PROFESSOR DE TECNICAS AGRICOLAS",
      "nome_completo_valor_dominio": "PROFESSOR DE TECNICAS AGRICOLAS",
      "descricao_conceito_valor_dominio": "PROFESSOR DE TECNICAS AGRICOLAS"
    },
    {
      "codigo_valor_dominio": 1763,
      "codigo_referencia_valor_dominio": "234810",
      "nome_resumido_valor_dominio": "PROFESSOR DE ADMINISTRACAO",
      "nome_completo_valor_dominio": "PROFESSOR DE ADMINISTRACAO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ADMINISTRACAO"
    },
    {
      "codigo_valor_dominio": 1764,
      "codigo_referencia_valor_dominio": "234730",
      "nome_resumido_valor_dominio": "PROFESSOR DE DIREITO DO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE DIREITO DO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE DIREITO DO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1765,
      "codigo_referencia_valor_dominio": "233120",
      "nome_resumido_valor_dominio": "PROFESSOR DE TECNICAS COMERCIAIS E SECRETARIAIS",
      "nome_completo_valor_dominio": "PROFESSOR DE TECNICAS COMERCIAIS E SECRETARIAIS",
      "descricao_conceito_valor_dominio": "PROFESSOR DE TECNICAS COMERCIAIS E SECRETARIAIS"
    },
    {
      "codigo_valor_dominio": 1766,
      "codigo_referencia_valor_dominio": "233125",
      "nome_resumido_valor_dominio": "PROFESSOR DE TECNICAS DE ENFERMAGEM",
      "nome_completo_valor_dominio": "PROFESSOR DE TECNICAS DE ENFERMAGEM",
      "descricao_conceito_valor_dominio": "PROFESSOR DE TECNICAS DE ENFERMAGEM"
    },
    {
      "codigo_valor_dominio": 1767,
      "codigo_referencia_valor_dominio": "239420",
      "nome_resumido_valor_dominio": "PROFESSOR DE TECNICAS E RECURSOS AUDIOVISUAIS",
      "nome_completo_valor_dominio": "PROFESSOR DE TECNICAS E RECURSOS AUDIOVISUAIS",
      "descricao_conceito_valor_dominio": "PROFESSOR DE TECNICAS E RECURSOS AUDIOVISUAIS"
    },
    {
      "codigo_valor_dominio": 1768,
      "codigo_referencia_valor_dominio": "233135",
      "nome_resumido_valor_dominio": "PROFESSOR DE TECNOLOGIA E CALCULO TECNICO",
      "nome_completo_valor_dominio": "PROFESSOR DE TECNOLOGIA E CALCULO TECNICO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE TECNOLOGIA E CALCULO TECNICO"
    },
    {
      "codigo_valor_dominio": 1769,
      "codigo_referencia_valor_dominio": "234684",
      "nome_resumido_valor_dominio": "PROFESSOR DE TEORIA DA LITERATURA",
      "nome_completo_valor_dominio": "PROFESSOR DE TEORIA DA LITERATURA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE TEORIA DA LITERATURA"
    },
    {
      "codigo_valor_dominio": 1770,
      "codigo_referencia_valor_dominio": "233210",
      "nome_resumido_valor_dominio": "INSTRUTOR DE APRENDIZAGEM E TREINAMENTO INDUSTRIAL",
      "nome_completo_valor_dominio": "INSTRUTOR DE APRENDIZAGEM E TREINAMENTO INDUSTRIAL",
      "descricao_conceito_valor_dominio": "INSTRUTOR DE APRENDIZAGEM E TREINAMENTO INDUSTRIAL"
    },
    {
      "codigo_valor_dominio": 1771,
      "codigo_referencia_valor_dominio": "333105",
      "nome_resumido_valor_dominio": "INSTRUTOR DE AUTO-ESCOLA",
      "nome_completo_valor_dominio": "INSTRUTOR DE AUTO-ESCOLA",
      "descricao_conceito_valor_dominio": "INSTRUTOR DE AUTO-ESCOLA"
    },
    {
      "codigo_valor_dominio": 1772,
      "codigo_referencia_valor_dominio": "234305",
      "nome_resumido_valor_dominio": "PROFESSOR DE ARQUITETURA",
      "nome_completo_valor_dominio": "PROFESSOR DE ARQUITETURA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ARQUITETURA"
    },
    {
      "codigo_valor_dominio": 1773,
      "codigo_referencia_valor_dominio": "233225",
      "nome_resumido_valor_dominio": "PROFESSOR INSTRUTOR DE ENSINO E APRENDIZAGEM EM SERVICOS",
      "nome_completo_valor_dominio": "PROFESSOR INSTRUTOR DE ENSINO E APRENDIZAGEM EM SERVICOS",
      "descricao_conceito_valor_dominio": "PROFESSOR INSTRUTOR DE ENSINO E APRENDIZAGEM EM SERVICOS"
    },
    {
      "codigo_valor_dominio": 1774,
      "codigo_referencia_valor_dominio": "332105",
      "nome_resumido_valor_dominio": "PROFESSOR LEIGO NO ENSINO FUNDAMENTAL",
      "nome_completo_valor_dominio": "PROFESSOR LEIGO NO ENSINO FUNDAMENTAL",
      "descricao_conceito_valor_dominio": "PROFESSOR LEIGO NO ENSINO FUNDAMENTAL"
    },
    {
      "codigo_valor_dominio": 1775,
      "codigo_referencia_valor_dominio": "231340",
      "nome_resumido_valor_dominio": "PROFESSOR DE MATEMATICA DO ENSINO FUNDAMENTAL",
      "nome_completo_valor_dominio": "PROFESSOR DE MATEMATICA DO ENSINO FUNDAMENTAL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE MATEMATICA DO ENSINO FUNDAMENTAL"
    },
    {
      "codigo_valor_dominio": 1776,
      "codigo_referencia_valor_dominio": "234435",
      "nome_resumido_valor_dominio": "PROFESSOR DE MEDICINA",
      "nome_completo_valor_dominio": "PROFESSOR DE MEDICINA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE MEDICINA"
    },
    {
      "codigo_valor_dominio": 1777,
      "codigo_referencia_valor_dominio": "234420",
      "nome_resumido_valor_dominio": "PROFESSOR DE FARMACIA E BIOQUIMICA",
      "nome_completo_valor_dominio": "PROFESSOR DE FARMACIA E BIOQUIMICA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE FARMACIA E BIOQUIMICA"
    },
    {
      "codigo_valor_dominio": 1778,
      "codigo_referencia_valor_dominio": "234725",
      "nome_resumido_valor_dominio": "PROFESSOR DE COMUNICACAO SOCIAL DO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE COMUNICACAO SOCIAL DO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE COMUNICACAO SOCIAL DO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1779,
      "codigo_referencia_valor_dominio": "234760",
      "nome_resumido_valor_dominio": "PROFESSOR DE PSICOLOGIA DO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE PSICOLOGIA DO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE PSICOLOGIA DO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1780,
      "codigo_referencia_valor_dominio": "232130",
      "nome_resumido_valor_dominio": "PROFESSOR DE FISICA NO ENSINO MEDIO",
      "nome_completo_valor_dominio": "PROFESSOR DE FISICA NO ENSINO MEDIO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE FISICA NO ENSINO MEDIO"
    },
    {
      "codigo_valor_dominio": 1781,
      "codigo_referencia_valor_dominio": "232165",
      "nome_resumido_valor_dominio": "PROFESSOR DE QUIMICA NO ENSINO MEDIO",
      "nome_completo_valor_dominio": "PROFESSOR DE QUIMICA NO ENSINO MEDIO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE QUIMICA NO ENSINO MEDIO"
    },
    {
      "codigo_valor_dominio": 1782,
      "codigo_referencia_valor_dominio": "234715",
      "nome_resumido_valor_dominio": "PROFESSOR DE BIBLIOTECONOMIA DO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE BIBLIOTECONOMIA DO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE BIBLIOTECONOMIA DO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1783,
      "codigo_referencia_valor_dominio": "234710",
      "nome_resumido_valor_dominio": "PROFESSOR DE ARQUIVOLOGIA DO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE ARQUIVOLOGIA DO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ARQUIVOLOGIA DO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1784,
      "codigo_referencia_valor_dominio": "234505",
      "nome_resumido_valor_dominio": "PROFESSOR DE ENSINO SUPERIOR NA AREA DE DIDATICA",
      "nome_completo_valor_dominio": "PROFESSOR DE ENSINO SUPERIOR NA AREA DE DIDATICA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ENSINO SUPERIOR NA AREA DE DIDATICA"
    },
    {
      "codigo_valor_dominio": 1785,
      "codigo_referencia_valor_dominio": "231320",
      "nome_resumido_valor_dominio": "PROFESSOR DE GEOGRAFIA DO ENSINO FUNDAMENTAL",
      "nome_completo_valor_dominio": "PROFESSOR DE GEOGRAFIA DO ENSINO FUNDAMENTAL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE GEOGRAFIA DO ENSINO FUNDAMENTAL"
    },
    {
      "codigo_valor_dominio": 1786,
      "codigo_referencia_valor_dominio": "231325",
      "nome_resumido_valor_dominio": "PROFESSOR DE HISTORIA DO ENSINO FUNDAMENTAL",
      "nome_completo_valor_dominio": "PROFESSOR DE HISTORIA DO ENSINO FUNDAMENTAL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE HISTORIA DO ENSINO FUNDAMENTAL"
    },
    {
      "codigo_valor_dominio": 1787,
      "codigo_referencia_valor_dominio": "231305",
      "nome_resumido_valor_dominio": "PROFESSOR DE CIENCIAS EXATAS E NATURAIS DO ENSINO FUNDAMENTA",
      "nome_completo_valor_dominio": "PROFESSOR DE CIENCIAS EXATAS E NATURAIS DO ENSINO FUNDAMENTAL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE CIENCIAS EXATAS E NATURAIS DO ENSINO FUNDAMENTAL"
    },
    {
      "codigo_valor_dominio": 1788,
      "codigo_referencia_valor_dominio": "234415",
      "nome_resumido_valor_dominio": "PROFESSOR DE ENFERMAGEM DO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE ENFERMAGEM DO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ENFERMAGEM DO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1789,
      "codigo_referencia_valor_dominio": "234310",
      "nome_resumido_valor_dominio": "PROFESSOR DE ENGENHARIA",
      "nome_completo_valor_dominio": "PROFESSOR DE ENGENHARIA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ENGENHARIA"
    },
    {
      "codigo_valor_dominio": 1790,
      "codigo_referencia_valor_dominio": "234676",
      "nome_resumido_valor_dominio": "PROFESSOR DE FILOLOGIA E CRITICA TEXTUAL",
      "nome_completo_valor_dominio": "PROFESSOR DE FILOLOGIA E CRITICA TEXTUAL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE FILOLOGIA E CRITICA TEXTUAL"
    },
    {
      "codigo_valor_dominio": 1791,
      "codigo_referencia_valor_dominio": "234430",
      "nome_resumido_valor_dominio": "PROFESSOR DE FONOAUDIOLOGIA",
      "nome_completo_valor_dominio": "PROFESSOR DE FONOAUDIOLOGIA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE FONOAUDIOLOGIA"
    },
    {
      "codigo_valor_dominio": 1792,
      "codigo_referencia_valor_dominio": "234315",
      "nome_resumido_valor_dominio": "PROFESSOR DE GEOFISICA",
      "nome_completo_valor_dominio": "PROFESSOR DE GEOFISICA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE GEOFISICA"
    },
    {
      "codigo_valor_dominio": 1793,
      "codigo_referencia_valor_dominio": "234440",
      "nome_resumido_valor_dominio": "PROFESSOR DE MEDICINA VETERINARIA",
      "nome_completo_valor_dominio": "PROFESSOR DE MEDICINA VETERINARIA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE MEDICINA VETERINARIA"
    },
    {
      "codigo_valor_dominio": 1794,
      "codigo_referencia_valor_dominio": "234755",
      "nome_resumido_valor_dominio": "PROFESSOR DE MUSEOLOGIA DO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE MUSEOLOGIA DO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE MUSEOLOGIA DO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1795,
      "codigo_referencia_valor_dominio": "234450",
      "nome_resumido_valor_dominio": "PROFESSOR DE ODONTOLOGIA",
      "nome_completo_valor_dominio": "PROFESSOR DE ODONTOLOGIA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ODONTOLOGIA"
    },
    {
      "codigo_valor_dominio": 1796,
      "codigo_referencia_valor_dominio": "234664",
      "nome_resumido_valor_dominio": "PROFESSOR DE OUTRAS LINGUAS E LITERATURAS",
      "nome_completo_valor_dominio": "PROFESSOR DE OUTRAS LINGUAS E LITERATURAS",
      "descricao_conceito_valor_dominio": "PROFESSOR DE OUTRAS LINGUAS E LITERATURAS"
    },
    {
      "codigo_valor_dominio": 1797,
      "codigo_referencia_valor_dominio": "234460",
      "nome_resumido_valor_dominio": "PROFESSOR DE ZOOTECNIA DO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE ZOOTECNIA DO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ZOOTECNIA DO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1798,
      "codigo_referencia_valor_dominio": "233220",
      "nome_resumido_valor_dominio": "PROFESSOR INSTRUTOR DE ENSINO E APRENDIZAGEM AGROFLORESTAL",
      "nome_completo_valor_dominio": "PROFESSOR INSTRUTOR DE ENSINO E APRENDIZAGEM AGROFLORESTAL",
      "descricao_conceito_valor_dominio": "PROFESSOR INSTRUTOR DE ENSINO E APRENDIZAGEM AGROFLORESTAL"
    },
    {
      "codigo_valor_dominio": 1799,
      "codigo_referencia_valor_dominio": "234510",
      "nome_resumido_valor_dominio": "PROFESSOR DE ENSINO SUPERIOR NA AREA DE ORIENTACAO EDUCACION",
      "nome_completo_valor_dominio": "PROFESSOR DE ENSINO SUPERIOR NA AREA DE ORIENTACAO EDUCACIONAL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ENSINO SUPERIOR NA AREA DE ORIENTACAO EDUCACIONAL"
    },
    {
      "codigo_valor_dominio": 1800,
      "codigo_referencia_valor_dominio": "234515",
      "nome_resumido_valor_dominio": "PROFESSOR DE ENSINO SUPERIOR NA AREA DE PESQUISA EDUCACIONAL",
      "nome_completo_valor_dominio": "PROFESSOR DE ENSINO SUPERIOR NA AREA DE PESQUISA EDUCACIONAL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ENSINO SUPERIOR NA AREA DE PESQUISA EDUCACIONAL"
    },
    {
      "codigo_valor_dominio": 1801,
      "codigo_referencia_valor_dominio": "234520",
      "nome_resumido_valor_dominio": "PROFESSOR DE ENSINO SUPERIOR NA AREA DE PRATICA DE ENSINO",
      "nome_completo_valor_dominio": "PROFESSOR DE ENSINO SUPERIOR NA AREA DE PRATICA DE ENSINO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ENSINO SUPERIOR NA AREA DE PRATICA DE ENSINO"
    },
    {
      "codigo_valor_dominio": 1802,
      "codigo_referencia_valor_dominio": "234115",
      "nome_resumido_valor_dominio": "PROFESSOR DE ESTATISTICA (NO ENSINO SUPERIOR)",
      "nome_completo_valor_dominio": "PROFESSOR DE ESTATISTICA (NO ENSINO SUPERIOR)",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ESTATISTICA (NO ENSINO SUPERIOR)"
    },
    {
      "codigo_valor_dominio": 1803,
      "codigo_referencia_valor_dominio": "232145",
      "nome_resumido_valor_dominio": "PROFESSOR DE LINGUA E LITERATURA BRASILEIRA NO ENSINO MEDIO",
      "nome_completo_valor_dominio": "PROFESSOR DE LINGUA E LITERATURA BRASILEIRA NO ENSINO MEDIO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LINGUA E LITERATURA BRASILEIRA NO ENSINO MEDIO"
    },
    {
      "codigo_valor_dominio": 1804,
      "codigo_referencia_valor_dominio": "234624",
      "nome_resumido_valor_dominio": "PROFESSOR DE LINGUA PORTUGUESA",
      "nome_completo_valor_dominio": "PROFESSOR DE LINGUA PORTUGUESA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LINGUA PORTUGUESA"
    },
    {
      "codigo_valor_dominio": 1805,
      "codigo_referencia_valor_dominio": "234616",
      "nome_resumido_valor_dominio": "PROFESSOR DE LINGUA INGLESA",
      "nome_completo_valor_dominio": "PROFESSOR DE LINGUA INGLESA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LINGUA INGLESA"
    },
    {
      "codigo_valor_dominio": 1806,
      "codigo_referencia_valor_dominio": "234608",
      "nome_resumido_valor_dominio": "PROFESSOR DE LINGUA ITALIANA",
      "nome_completo_valor_dominio": "PROFESSOR DE LINGUA ITALIANA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LINGUA ITALIANA"
    },
    {
      "codigo_valor_dominio": 1807,
      "codigo_referencia_valor_dominio": "231330",
      "nome_resumido_valor_dominio": "PROFESSOR DE LINGUA ESTRANGEIRA MODERNA DO ENSINO FUNDAMENTA",
      "nome_completo_valor_dominio": "PROFESSOR DE LINGUA ESTRANGEIRA MODERNA DO ENSINO FUNDAMENTAL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LINGUA ESTRANGEIRA MODERNA DO ENSINO FUNDAMENTAL"
    },
    {
      "codigo_valor_dominio": 1808,
      "codigo_referencia_valor_dominio": "231335",
      "nome_resumido_valor_dominio": "PROFESSOR DE LINGUA PORTUGUESA DO ENSINO FUNDAMENTAL",
      "nome_completo_valor_dominio": "PROFESSOR DE LINGUA PORTUGUESA DO ENSINO FUNDAMENTAL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LINGUA PORTUGUESA DO ENSINO FUNDAMENTAL"
    },
    {
      "codigo_valor_dominio": 1809,
      "codigo_referencia_valor_dominio": "234640",
      "nome_resumido_valor_dominio": "PROFESSOR DE LITERATURA COMPARADA",
      "nome_completo_valor_dominio": "PROFESSOR DE LITERATURA COMPARADA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LITERATURA COMPARADA"
    },
    {
      "codigo_valor_dominio": 1810,
      "codigo_referencia_valor_dominio": "234105",
      "nome_resumido_valor_dominio": "PROFESSOR DE MATEMATICA APLICADA (NO ENSINO SUPERIOR)",
      "nome_completo_valor_dominio": "PROFESSOR DE MATEMATICA APLICADA (NO ENSINO SUPERIOR)",
      "descricao_conceito_valor_dominio": "PROFESSOR DE MATEMATICA APLICADA (NO ENSINO SUPERIOR)"
    },
    {
      "codigo_valor_dominio": 1811,
      "codigo_referencia_valor_dominio": "234628",
      "nome_resumido_valor_dominio": "PROFESSOR DE LITERATURA BRASILEIRA",
      "nome_completo_valor_dominio": "PROFESSOR DE LITERATURA BRASILEIRA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LITERATURA BRASILEIRA"
    },
    {
      "codigo_valor_dominio": 1812,
      "codigo_referencia_valor_dominio": "234660",
      "nome_resumido_valor_dominio": "PROFESSOR DE LITERATURA DE LINGUAS ESTRANGEIRAS MODERNAS",
      "nome_completo_valor_dominio": "PROFESSOR DE LITERATURA DE LINGUAS ESTRANGEIRAS MODERNAS",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LITERATURA DE LINGUAS ESTRANGEIRAS MODERNAS"
    },
    {
      "codigo_valor_dominio": 1813,
      "codigo_referencia_valor_dominio": "234648",
      "nome_resumido_valor_dominio": "PROFESSOR DE LITERATURA FRANCESA",
      "nome_completo_valor_dominio": "PROFESSOR DE LITERATURA FRANCESA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LITERATURA FRANCESA"
    },
    {
      "codigo_valor_dominio": 1814,
      "codigo_referencia_valor_dominio": "234652",
      "nome_resumido_valor_dominio": "PROFESSOR DE LITERATURA INGLESA",
      "nome_completo_valor_dominio": "PROFESSOR DE LITERATURA INGLESA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LITERATURA INGLESA"
    },
    {
      "codigo_valor_dominio": 1815,
      "codigo_referencia_valor_dominio": "234656",
      "nome_resumido_valor_dominio": "PROFESSOR DE LITERATURA ITALIANA",
      "nome_completo_valor_dominio": "PROFESSOR DE LITERATURA ITALIANA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LITERATURA ITALIANA"
    },
    {
      "codigo_valor_dominio": 1816,
      "codigo_referencia_valor_dominio": "234632",
      "nome_resumido_valor_dominio": "PROFESSOR DE LITERATURA PORTUGUESA",
      "nome_completo_valor_dominio": "PROFESSOR DE LITERATURA PORTUGUESA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LITERATURA PORTUGUESA"
    },
    {
      "codigo_valor_dominio": 1817,
      "codigo_referencia_valor_dominio": "234644",
      "nome_resumido_valor_dominio": "PROFESSOR DE LITERATURA ESPANHOLA",
      "nome_completo_valor_dominio": "PROFESSOR DE LITERATURA ESPANHOLA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LITERATURA ESPANHOLA"
    },
    {
      "codigo_valor_dominio": 1818,
      "codigo_referencia_valor_dominio": "234125",
      "nome_resumido_valor_dominio": "PROFESSOR DE PESQUISA OPERACIONAL (NO ENSINO SUPERIOR)",
      "nome_completo_valor_dominio": "PROFESSOR DE PESQUISA OPERACIONAL (NO ENSINO SUPERIOR)",
      "descricao_conceito_valor_dominio": "PROFESSOR DE PESQUISA OPERACIONAL (NO ENSINO SUPERIOR)"
    },
    {
      "codigo_valor_dominio": 1819,
      "codigo_referencia_valor_dominio": "234672",
      "nome_resumido_valor_dominio": "PROFESSOR DE LINGUISTICA E LINGUISTICA APLICADA",
      "nome_completo_valor_dominio": "PROFESSOR DE LINGUISTICA E LINGUISTICA APLICADA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LINGUISTICA E LINGUISTICA APLICADA"
    },
    {
      "codigo_valor_dominio": 1820,
      "codigo_referencia_valor_dominio": "234636",
      "nome_resumido_valor_dominio": "PROFESSOR DE LITERATURA ALEMA",
      "nome_completo_valor_dominio": "PROFESSOR DE LITERATURA ALEMA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LITERATURA ALEMA"
    },
    {
      "codigo_valor_dominio": 1821,
      "codigo_referencia_valor_dominio": "234735",
      "nome_resumido_valor_dominio": "PROFESSOR DE FILOSOFIA DO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE FILOSOFIA DO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE FILOSOFIA DO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1822,
      "codigo_referencia_valor_dominio": "234765",
      "nome_resumido_valor_dominio": "PROFESSOR DE SERVICO SOCIAL DO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE SERVICO SOCIAL DO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE SERVICO SOCIAL DO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1823,
      "codigo_referencia_valor_dominio": "234455",
      "nome_resumido_valor_dominio": "PROFESSOR DE TERAPIA OCUPACIONAL",
      "nome_completo_valor_dominio": "PROFESSOR DE TERAPIA OCUPACIONAL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE TERAPIA OCUPACIONAL"
    },
    {
      "codigo_valor_dominio": 1824,
      "codigo_referencia_valor_dominio": "233215",
      "nome_resumido_valor_dominio": "PROFESSOR DE APRENDIZAGEM E TREINAMENTO COMERCIAL",
      "nome_completo_valor_dominio": "PROFESSOR DE APRENDIZAGEM E TREINAMENTO COMERCIAL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE APRENDIZAGEM E TREINAMENTO COMERCIAL"
    },
    {
      "codigo_valor_dominio": 1825,
      "codigo_referencia_valor_dominio": "234905",
      "nome_resumido_valor_dominio": "PROFESSOR DE ARTES DO ESPETACULO NO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE ARTES DO ESPETACULO NO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ARTES DO ESPETACULO NO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1826,
      "codigo_referencia_valor_dominio": "232110",
      "nome_resumido_valor_dominio": "PROFESSOR DE BIOLOGIA NO ENSINO MEDIO",
      "nome_completo_valor_dominio": "PROFESSOR DE BIOLOGIA NO ENSINO MEDIO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE BIOLOGIA NO ENSINO MEDIO"
    },
    {
      "codigo_valor_dominio": 1827,
      "codigo_referencia_valor_dominio": "234405",
      "nome_resumido_valor_dominio": "PROFESSOR DE CIENCIAS BIOLOGICAS DO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE CIENCIAS BIOLOGICAS DO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE CIENCIAS BIOLOGICAS DO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1828,
      "codigo_referencia_valor_dominio": "234815",
      "nome_resumido_valor_dominio": "PROFESSOR DE CONTABILIDADE",
      "nome_completo_valor_dominio": "PROFESSOR DE CONTABILIDADE",
      "descricao_conceito_valor_dominio": "PROFESSOR DE CONTABILIDADE"
    },
    {
      "codigo_valor_dominio": 1829,
      "codigo_referencia_valor_dominio": "232115",
      "nome_resumido_valor_dominio": "PROFESSOR DE DISCIPLINAS PEDAGOGICAS NO ENSINO MEDIO",
      "nome_completo_valor_dominio": "PROFESSOR DE DISCIPLINAS PEDAGOGICAS NO ENSINO MEDIO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE DISCIPLINAS PEDAGOGICAS NO ENSINO MEDIO"
    },
    {
      "codigo_valor_dominio": 1830,
      "codigo_referencia_valor_dominio": "232125",
      "nome_resumido_valor_dominio": "PROFESSOR DE FILOSOFIA NO ENSINO MEDIO",
      "nome_completo_valor_dominio": "PROFESSOR DE FILOSOFIA NO ENSINO MEDIO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE FILOSOFIA NO ENSINO MEDIO"
    },
    {
      "codigo_valor_dominio": 1831,
      "codigo_referencia_valor_dominio": "232135",
      "nome_resumido_valor_dominio": "PROFESSOR DE GEOGRAFIA NO ENSINO MEDIO",
      "nome_completo_valor_dominio": "PROFESSOR DE GEOGRAFIA NO ENSINO MEDIO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE GEOGRAFIA NO ENSINO MEDIO"
    },
    {
      "codigo_valor_dominio": 1832,
      "codigo_referencia_valor_dominio": "232140",
      "nome_resumido_valor_dominio": "PROFESSOR DE HISTORIA NO ENSINO MEDIO",
      "nome_completo_valor_dominio": "PROFESSOR DE HISTORIA NO ENSINO MEDIO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE HISTORIA NO ENSINO MEDIO"
    },
    {
      "codigo_valor_dominio": 1833,
      "codigo_referencia_valor_dominio": "234604",
      "nome_resumido_valor_dominio": "PROFESSOR DE LINGUA ALEMA",
      "nome_completo_valor_dominio": "PROFESSOR DE LINGUA ALEMA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE LINGUA ALEMA"
    },
    {
      "codigo_valor_dominio": 1834,
      "codigo_referencia_valor_dominio": "234915",
      "nome_resumido_valor_dominio": "PROFESSOR DE MUSICA NO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE MUSICA NO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE MUSICA NO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1835,
      "codigo_referencia_valor_dominio": "232160",
      "nome_resumido_valor_dominio": "PROFESSOR DE PSICOLOGIA NO ENSINO MEDIO",
      "nome_completo_valor_dominio": "PROFESSOR DE PSICOLOGIA NO ENSINO MEDIO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE PSICOLOGIA NO ENSINO MEDIO"
    },
    {
      "codigo_valor_dominio": 1836,
      "codigo_referencia_valor_dominio": "234770",
      "nome_resumido_valor_dominio": "PROFESSOR DE SOCIOLOGIA DO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE SOCIOLOGIA DO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE SOCIOLOGIA DO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1837,
      "codigo_referencia_valor_dominio": "232170",
      "nome_resumido_valor_dominio": "PROFESSOR DE SOCIOLOGIA NO ENSINO MEDIO",
      "nome_completo_valor_dominio": "PROFESSOR DE SOCIOLOGIA NO ENSINO MEDIO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE SOCIOLOGIA NO ENSINO MEDIO"
    },
    {
      "codigo_valor_dominio": 1838,
      "codigo_referencia_valor_dominio": "231310",
      "nome_resumido_valor_dominio": "PROFESSOR DE EDUCACAO ARTISTICA DO ENSINO FUNDAMENTAL",
      "nome_completo_valor_dominio": "PROFESSOR DE EDUCACAO ARTISTICA DO ENSINO FUNDAMENTAL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE EDUCACAO ARTISTICA DO ENSINO FUNDAMENTAL"
    },
    {
      "codigo_valor_dominio": 1839,
      "codigo_referencia_valor_dominio": "239205",
      "nome_resumido_valor_dominio": "PROFESSOR DE ALUNOS COM DEFICIENCIA AUDITIVA E SURDOS",
      "nome_completo_valor_dominio": "PROFESSOR DE ALUNOS COM DEFICIENCIA AUDITIVA E SURDOS",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ALUNOS COM DEFICIENCIA AUDITIVA E SURDOS"
    },
    {
      "codigo_valor_dominio": 1840,
      "codigo_referencia_valor_dominio": "262830",
      "nome_resumido_valor_dominio": "PROFESSOR DE DANCA",
      "nome_completo_valor_dominio": "PROFESSOR DE DANCA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE DANCA"
    },
    {
      "codigo_valor_dominio": 1841,
      "codigo_referencia_valor_dominio": "232105",
      "nome_resumido_valor_dominio": "PROFESSOR DE ARTES NO ENSINO MEDIO",
      "nome_completo_valor_dominio": "PROFESSOR DE ARTES NO ENSINO MEDIO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ARTES NO ENSINO MEDIO"
    },
    {
      "codigo_valor_dominio": 1842,
      "codigo_referencia_valor_dominio": "234215",
      "nome_resumido_valor_dominio": "PROFESSOR DE ASTRONOMIA (ENSINO SUPERIOR)",
      "nome_completo_valor_dominio": "PROFESSOR DE ASTRONOMIA (ENSINO SUPERIOR)",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ASTRONOMIA (ENSINO SUPERIOR)"
    },
    {
      "codigo_valor_dominio": 1843,
      "codigo_referencia_valor_dominio": "331105",
      "nome_resumido_valor_dominio": "PROFESSOR DE NIVEL MEDIO NA EDUCACAO INFANTIL",
      "nome_completo_valor_dominio": "PROFESSOR DE NIVEL MEDIO NA EDUCACAO INFANTIL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE NIVEL MEDIO NA EDUCACAO INFANTIL"
    },
    {
      "codigo_valor_dominio": 1844,
      "codigo_referencia_valor_dominio": "239210",
      "nome_resumido_valor_dominio": "PROFESSOR DE ALUNOS COM DEFICIENCIA FISICA",
      "nome_completo_valor_dominio": "PROFESSOR DE ALUNOS COM DEFICIENCIA FISICA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ALUNOS COM DEFICIENCIA FISICA"
    },
    {
      "codigo_valor_dominio": 1845,
      "codigo_referencia_valor_dominio": "239215",
      "nome_resumido_valor_dominio": "PROFESSOR DE ALUNOS COM DEFICIENCIA MENTAL",
      "nome_completo_valor_dominio": "PROFESSOR DE ALUNOS COM DEFICIENCIA MENTAL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ALUNOS COM DEFICIENCIA MENTAL"
    },
    {
      "codigo_valor_dominio": 1846,
      "codigo_referencia_valor_dominio": "239220",
      "nome_resumido_valor_dominio": "PROFESSOR DE ALUNOS COM DEFICIENCIA MULTIPLA",
      "nome_completo_valor_dominio": "PROFESSOR DE ALUNOS COM DEFICIENCIA MULTIPLA",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ALUNOS COM DEFICIENCIA MULTIPLA"
    },
    {
      "codigo_valor_dominio": 1847,
      "codigo_referencia_valor_dominio": "239225",
      "nome_resumido_valor_dominio": "PROFESSOR DE ALUNOS COM DEFICIENCIA VISUAL",
      "nome_completo_valor_dominio": "PROFESSOR DE ALUNOS COM DEFICIENCIA VISUAL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ALUNOS COM DEFICIENCIA VISUAL"
    },
    {
      "codigo_valor_dominio": 1848,
      "codigo_referencia_valor_dominio": "234705",
      "nome_resumido_valor_dominio": "PROFESSOR DE ANTROPOLOGIA DO ENSINO SUPERIOR",
      "nome_completo_valor_dominio": "PROFESSOR DE ANTROPOLOGIA DO ENSINO SUPERIOR",
      "descricao_conceito_valor_dominio": "PROFESSOR DE ANTROPOLOGIA DO ENSINO SUPERIOR"
    },
    {
      "codigo_valor_dominio": 1849,
      "codigo_referencia_valor_dominio": "513425",
      "nome_resumido_valor_dominio": "COPEIRO",
      "nome_completo_valor_dominio": "COPEIRO",
      "descricao_conceito_valor_dominio": "COPEIRO"
    },
    {
      "codigo_valor_dominio": 1850,
      "codigo_referencia_valor_dominio": "223910",
      "nome_resumido_valor_dominio": "ORTOPTISTA",
      "nome_completo_valor_dominio": "ORTOPTISTA",
      "descricao_conceito_valor_dominio": "ORTOPTISTA"
    },
    {
      "codigo_valor_dominio": 1851,
      "codigo_referencia_valor_dominio": "516140",
      "nome_resumido_valor_dominio": "PEDICURE",
      "nome_completo_valor_dominio": "PEDICURE",
      "descricao_conceito_valor_dominio": "PEDICURE"
    },
    {
      "codigo_valor_dominio": 1852,
      "codigo_referencia_valor_dominio": "233130",
      "nome_resumido_valor_dominio": "PROFESSOR DE TECNICAS INDUSTRIAIS",
      "nome_completo_valor_dominio": "PROFESSOR DE TECNICAS INDUSTRIAIS",
      "descricao_conceito_valor_dominio": "PROFESSOR DE TECNICAS INDUSTRIAIS"
    },
    {
      "codigo_valor_dominio": 1853,
      "codigo_referencia_valor_dominio": "377145",
      "nome_resumido_valor_dominio": "PUGILISTA",
      "nome_completo_valor_dominio": "PUGILISTA",
      "descricao_conceito_valor_dominio": "PUGILISTA"
    },
    {
      "codigo_valor_dominio": 1854,
      "codigo_referencia_valor_dominio": "420120",
      "nome_resumido_valor_dominio": "SUPERVISOR DE ENTREVISTADORES E RECENSEADORES",
      "nome_completo_valor_dominio": "SUPERVISOR DE ENTREVISTADORES E RECENSEADORES",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE ENTREVISTADORES E RECENSEADORES"
    },
    {
      "codigo_valor_dominio": 1855,
      "codigo_referencia_valor_dominio": "316335",
      "nome_resumido_valor_dominio": "DESINCRUSTADOR (POCOS DE PETROLEO)",
      "nome_completo_valor_dominio": "DESINCRUSTADOR (POCOS DE PETROLEO)",
      "descricao_conceito_valor_dominio": "DESINCRUSTADOR (POCOS DE PETROLEO)"
    },
    {
      "codigo_valor_dominio": 1856,
      "codigo_referencia_valor_dominio": "241005",
      "nome_resumido_valor_dominio": "ADVOGADO",
      "nome_completo_valor_dominio": "ADVOGADO",
      "descricao_conceito_valor_dominio": "ADVOGADO"
    },
    {
      "codigo_valor_dominio": 1857,
      "codigo_referencia_valor_dominio": "241010",
      "nome_resumido_valor_dominio": "ADVOGADO DE EMPRESA",
      "nome_completo_valor_dominio": "ADVOGADO DE EMPRESA",
      "descricao_conceito_valor_dominio": "ADVOGADO DE EMPRESA"
    },
    {
      "codigo_valor_dominio": 1858,
      "codigo_referencia_valor_dominio": "241015",
      "nome_resumido_valor_dominio": "ADVOGADO (DIREITO CIVIL)",
      "nome_completo_valor_dominio": "ADVOGADO (DIREITO CIVIL)",
      "descricao_conceito_valor_dominio": "ADVOGADO (DIREITO CIVIL)"
    },
    {
      "codigo_valor_dominio": 1859,
      "codigo_referencia_valor_dominio": "241020",
      "nome_resumido_valor_dominio": "ADVOGADO (DIREITO PUBLICO)",
      "nome_completo_valor_dominio": "ADVOGADO (DIREITO PUBLICO)",
      "descricao_conceito_valor_dominio": "ADVOGADO (DIREITO PUBLICO)"
    },
    {
      "codigo_valor_dominio": 1860,
      "codigo_referencia_valor_dominio": "241025",
      "nome_resumido_valor_dominio": "ADVOGADO (DIREITO PENAL)",
      "nome_completo_valor_dominio": "ADVOGADO (DIREITO PENAL)",
      "descricao_conceito_valor_dominio": "ADVOGADO (DIREITO PENAL)"
    },
    {
      "codigo_valor_dominio": 1861,
      "codigo_referencia_valor_dominio": "241030",
      "nome_resumido_valor_dominio": "ADVOGADO (AREAS ESPECIAIS)",
      "nome_completo_valor_dominio": "ADVOGADO (AREAS ESPECIAIS)",
      "descricao_conceito_valor_dominio": "ADVOGADO (AREAS ESPECIAIS)"
    },
    {
      "codigo_valor_dominio": 1862,
      "codigo_referencia_valor_dominio": "241035",
      "nome_resumido_valor_dominio": "ADVOGADO (DIREITO DO TRABALHO)",
      "nome_completo_valor_dominio": "ADVOGADO (DIREITO DO TRABALHO)",
      "descricao_conceito_valor_dominio": "ADVOGADO (DIREITO DO TRABALHO)"
    },
    {
      "codigo_valor_dominio": 1863,
      "codigo_referencia_valor_dominio": "252210",
      "nome_resumido_valor_dominio": "CONTADOR",
      "nome_completo_valor_dominio": "CONTADOR",
      "descricao_conceito_valor_dominio": "CONTADOR"
    },
    {
      "codigo_valor_dominio": 1864,
      "codigo_referencia_valor_dominio": "241205",
      "nome_resumido_valor_dominio": "ADVOGADO DA UNIAO",
      "nome_completo_valor_dominio": "ADVOGADO DA UNIAO",
      "descricao_conceito_valor_dominio": "ADVOGADO DA UNIAO"
    },
    {
      "codigo_valor_dominio": 1865,
      "codigo_referencia_valor_dominio": "242410",
      "nome_resumido_valor_dominio": "PROCURADOR DA ASSISTENCIA JUDICIARIA",
      "nome_completo_valor_dominio": "PROCURADOR DA ASSISTENCIA JUDICIARIA",
      "descricao_conceito_valor_dominio": "PROCURADOR DA ASSISTENCIA JUDICIARIA"
    },
    {
      "codigo_valor_dominio": 1866,
      "codigo_referencia_valor_dominio": "242205",
      "nome_resumido_valor_dominio": "PROCURADOR DA REPUBLICA",
      "nome_completo_valor_dominio": "PROCURADOR DA REPUBLICA",
      "descricao_conceito_valor_dominio": "PROCURADOR DA REPUBLICA"
    },
    {
      "codigo_valor_dominio": 1867,
      "codigo_referencia_valor_dominio": "241225",
      "nome_resumido_valor_dominio": "PROCURADOR DO MUNICIPIO",
      "nome_completo_valor_dominio": "PROCURADOR DO MUNICIPIO",
      "descricao_conceito_valor_dominio": "PROCURADOR DO MUNICIPIO"
    },
    {
      "codigo_valor_dominio": 1868,
      "codigo_referencia_valor_dominio": "242220",
      "nome_resumido_valor_dominio": "PROCURADOR DO TRABALHO",
      "nome_completo_valor_dominio": "PROCURADOR DO TRABALHO",
      "descricao_conceito_valor_dominio": "PROCURADOR DO TRABALHO"
    },
    {
      "codigo_valor_dominio": 1869,
      "codigo_referencia_valor_dominio": "241235",
      "nome_resumido_valor_dominio": "PROCURADOR FUNDACIONAL",
      "nome_completo_valor_dominio": "PROCURADOR FUNDACIONAL",
      "descricao_conceito_valor_dominio": "PROCURADOR FUNDACIONAL"
    },
    {
      "codigo_valor_dominio": 1870,
      "codigo_referencia_valor_dominio": "242225",
      "nome_resumido_valor_dominio": "PROCURADOR REGIONAL DA REPUBLICA",
      "nome_completo_valor_dominio": "PROCURADOR REGIONAL DA REPUBLICA",
      "descricao_conceito_valor_dominio": "PROCURADOR REGIONAL DA REPUBLICA"
    },
    {
      "codigo_valor_dominio": 1871,
      "codigo_referencia_valor_dominio": "010210",
      "nome_resumido_valor_dominio": "OFICIAL DO EXERCITO",
      "nome_completo_valor_dominio": "OFICIAL DO EXERCITO",
      "descricao_conceito_valor_dominio": "OFICIAL DO EXERCITO"
    },
    {
      "codigo_valor_dominio": 1872,
      "codigo_referencia_valor_dominio": "241315",
      "nome_resumido_valor_dominio": "OFICIAL DO REGISTRO CIVIL DE PESSOAS NATURAIS",
      "nome_completo_valor_dominio": "OFICIAL DO REGISTRO CIVIL DE PESSOAS NATURAIS",
      "descricao_conceito_valor_dominio": "OFICIAL DO REGISTRO CIVIL DE PESSOAS NATURAIS"
    },
    {
      "codigo_valor_dominio": 1873,
      "codigo_referencia_valor_dominio": "241320",
      "nome_resumido_valor_dominio": "OFICIAL DO REGISTRO DE DISTRIBUICOES",
      "nome_completo_valor_dominio": "OFICIAL DO REGISTRO DE DISTRIBUICOES",
      "descricao_conceito_valor_dominio": "OFICIAL DO REGISTRO DE DISTRIBUICOES"
    },
    {
      "codigo_valor_dominio": 1874,
      "codigo_referencia_valor_dominio": "241325",
      "nome_resumido_valor_dominio": "OFICIAL DO REGISTRO DE IMOVEIS",
      "nome_completo_valor_dominio": "OFICIAL DO REGISTRO DE IMOVEIS",
      "descricao_conceito_valor_dominio": "OFICIAL DO REGISTRO DE IMOVEIS"
    },
    {
      "codigo_valor_dominio": 1875,
      "codigo_referencia_valor_dominio": "241330",
      "nome_resumido_valor_dominio": "OFICIAL DO REGISTRO DE TITULOS E DOCUMENTOS",
      "nome_completo_valor_dominio": "OFICIAL DO REGISTRO DE TITULOS E DOCUMENTOS",
      "descricao_conceito_valor_dominio": "OFICIAL DO REGISTRO DE TITULOS E DOCUMENTOS"
    },
    {
      "codigo_valor_dominio": 1876,
      "codigo_referencia_valor_dominio": "010105",
      "nome_resumido_valor_dominio": "OFICIAL GENERAL DA AERONAUTICA",
      "nome_completo_valor_dominio": "OFICIAL GENERAL DA AERONAUTICA",
      "descricao_conceito_valor_dominio": "OFICIAL GENERAL DA AERONAUTICA"
    },
    {
      "codigo_valor_dominio": 1877,
      "codigo_referencia_valor_dominio": "241340",
      "nome_resumido_valor_dominio": "TABELIAO DE PROTESTOS",
      "nome_completo_valor_dominio": "TABELIAO DE PROTESTOS",
      "descricao_conceito_valor_dominio": "TABELIAO DE PROTESTOS"
    },
    {
      "codigo_valor_dominio": 1878,
      "codigo_referencia_valor_dominio": "511115",
      "nome_resumido_valor_dominio": "TAIFEIRO (EXCETO MILITARES)",
      "nome_completo_valor_dominio": "TAIFEIRO (EXCETO MILITARES)",
      "descricao_conceito_valor_dominio": "TAIFEIRO (EXCETO MILITARES)"
    },
    {
      "codigo_valor_dominio": 1879,
      "codigo_referencia_valor_dominio": "242210",
      "nome_resumido_valor_dominio": "PROCURADOR DE JUSTICA",
      "nome_completo_valor_dominio": "PROCURADOR DE JUSTICA",
      "descricao_conceito_valor_dominio": "PROCURADOR DE JUSTICA"
    },
    {
      "codigo_valor_dominio": 1880,
      "codigo_referencia_valor_dominio": "242215",
      "nome_resumido_valor_dominio": "PROCURADOR DE JUSTICA MILITAR",
      "nome_completo_valor_dominio": "PROCURADOR DE JUSTICA MILITAR",
      "descricao_conceito_valor_dominio": "PROCURADOR DE JUSTICA MILITAR"
    },
    {
      "codigo_valor_dominio": 1881,
      "codigo_referencia_valor_dominio": "241220",
      "nome_resumido_valor_dominio": "PROCURADOR DO ESTADO",
      "nome_completo_valor_dominio": "PROCURADOR DO ESTADO",
      "descricao_conceito_valor_dominio": "PROCURADOR DO ESTADO"
    },
    {
      "codigo_valor_dominio": 1882,
      "codigo_referencia_valor_dominio": "241230",
      "nome_resumido_valor_dominio": "PROCURADOR FEDERAL",
      "nome_completo_valor_dominio": "PROCURADOR FEDERAL",
      "descricao_conceito_valor_dominio": "PROCURADOR FEDERAL"
    },
    {
      "codigo_valor_dominio": 1883,
      "codigo_referencia_valor_dominio": "242230",
      "nome_resumido_valor_dominio": "PROCURADOR REGIONAL DO TRABALHO",
      "nome_completo_valor_dominio": "PROCURADOR REGIONAL DO TRABALHO",
      "descricao_conceito_valor_dominio": "PROCURADOR REGIONAL DO TRABALHO"
    },
    {
      "codigo_valor_dominio": 1884,
      "codigo_referencia_valor_dominio": "612005",
      "nome_resumido_valor_dominio": "PRODUTOR AGRICOLA POLIVALENTE",
      "nome_completo_valor_dominio": "PRODUTOR AGRICOLA POLIVALENTE",
      "descricao_conceito_valor_dominio": "PRODUTOR AGRICOLA POLIVALENTE"
    },
    {
      "codigo_valor_dominio": 1885,
      "codigo_referencia_valor_dominio": "521115",
      "nome_resumido_valor_dominio": "PROMOTOR DE VENDAS",
      "nome_completo_valor_dominio": "PROMOTOR DE VENDAS",
      "descricao_conceito_valor_dominio": "PROMOTOR DE VENDAS"
    },
    {
      "codigo_valor_dominio": 1886,
      "codigo_referencia_valor_dominio": "242245",
      "nome_resumido_valor_dominio": "SUBPROCURADOR-GERAL DA REPUBLICA",
      "nome_completo_valor_dominio": "SUBPROCURADOR-GERAL DA REPUBLICA",
      "descricao_conceito_valor_dominio": "SUBPROCURADOR-GERAL DA REPUBLICA"
    },
    {
      "codigo_valor_dominio": 1887,
      "codigo_referencia_valor_dominio": "242250",
      "nome_resumido_valor_dominio": "SUBPROCURADOR-GERAL DO TRABALHO",
      "nome_completo_valor_dominio": "SUBPROCURADOR-GERAL DO TRABALHO",
      "descricao_conceito_valor_dominio": "SUBPROCURADOR-GERAL DO TRABALHO"
    },
    {
      "codigo_valor_dominio": 1888,
      "codigo_referencia_valor_dominio": "031105",
      "nome_resumido_valor_dominio": "SUBTENENTE BOMBEIRO MILITAR",
      "nome_completo_valor_dominio": "SUBTENENTE BOMBEIRO MILITAR",
      "descricao_conceito_valor_dominio": "SUBTENENTE BOMBEIRO MILITAR"
    },
    {
      "codigo_valor_dominio": 1889,
      "codigo_referencia_valor_dominio": "717005",
      "nome_resumido_valor_dominio": "DEMOLIDOR DE EDIFICACOES",
      "nome_completo_valor_dominio": "DEMOLIDOR DE EDIFICACOES",
      "descricao_conceito_valor_dominio": "DEMOLIDOR DE EDIFICACOES"
    },
    {
      "codigo_valor_dominio": 1890,
      "codigo_referencia_valor_dominio": "848105",
      "nome_resumido_valor_dominio": "DEFUMADOR DE CARNES E PESCADOS",
      "nome_completo_valor_dominio": "DEFUMADOR DE CARNES E PESCADOS",
      "descricao_conceito_valor_dominio": "DEFUMADOR DE CARNES E PESCADOS"
    },
    {
      "codigo_valor_dominio": 1891,
      "codigo_referencia_valor_dominio": "241215",
      "nome_resumido_valor_dominio": "PROCURADOR DA FAZENDA NACIONAL",
      "nome_completo_valor_dominio": "PROCURADOR DA FAZENDA NACIONAL",
      "descricao_conceito_valor_dominio": "PROCURADOR DA FAZENDA NACIONAL"
    },
    {
      "codigo_valor_dominio": 1892,
      "codigo_referencia_valor_dominio": "351425",
      "nome_resumido_valor_dominio": "OFICIAL DE JUSTICA",
      "nome_completo_valor_dominio": "OFICIAL DE JUSTICA",
      "descricao_conceito_valor_dominio": "OFICIAL DE JUSTICA"
    },
    {
      "codigo_valor_dominio": 1893,
      "codigo_referencia_valor_dominio": "828105",
      "nome_resumido_valor_dominio": "OLEIRO (FABRICACAO DE TELHAS)",
      "nome_completo_valor_dominio": "OLEIRO (FABRICACAO DE TELHAS)",
      "descricao_conceito_valor_dominio": "OLEIRO (FABRICACAO DE TELHAS)"
    },
    {
      "codigo_valor_dominio": 1894,
      "codigo_referencia_valor_dominio": "251105",
      "nome_resumido_valor_dominio": "ANTROPOLOGO",
      "nome_completo_valor_dominio": "ANTROPOLOGO",
      "descricao_conceito_valor_dominio": "ANTROPOLOGO"
    },
    {
      "codigo_valor_dominio": 1895,
      "codigo_referencia_valor_dominio": "251110",
      "nome_resumido_valor_dominio": "ARQUEOLOGO",
      "nome_completo_valor_dominio": "ARQUEOLOGO",
      "descricao_conceito_valor_dominio": "ARQUEOLOGO"
    },
    {
      "codigo_valor_dominio": 1896,
      "codigo_referencia_valor_dominio": "251115",
      "nome_resumido_valor_dominio": "CIENTISTA POLITICO",
      "nome_completo_valor_dominio": "CIENTISTA POLITICO",
      "descricao_conceito_valor_dominio": "CIENTISTA POLITICO"
    },
    {
      "codigo_valor_dominio": 1897,
      "codigo_referencia_valor_dominio": "515135",
      "nome_resumido_valor_dominio": "SOCORRISTA (EXCETO MEDICOS E ENFERMEIROS)",
      "nome_completo_valor_dominio": "SOCORRISTA (EXCETO MEDICOS E ENFERMEIROS)",
      "descricao_conceito_valor_dominio": "SOCORRISTA (EXCETO MEDICOS E ENFERMEIROS)"
    },
    {
      "codigo_valor_dominio": 1898,
      "codigo_referencia_valor_dominio": "251210",
      "nome_resumido_valor_dominio": "ECONOMISTA AGROINDUSTRIAL",
      "nome_completo_valor_dominio": "ECONOMISTA AGROINDUSTRIAL",
      "descricao_conceito_valor_dominio": "ECONOMISTA AGROINDUSTRIAL"
    },
    {
      "codigo_valor_dominio": 1899,
      "codigo_referencia_valor_dominio": "251230",
      "nome_resumido_valor_dominio": "ECONOMISTA AMBIENTAL",
      "nome_completo_valor_dominio": "ECONOMISTA AMBIENTAL",
      "descricao_conceito_valor_dominio": "ECONOMISTA AMBIENTAL"
    },
    {
      "codigo_valor_dominio": 1900,
      "codigo_referencia_valor_dominio": "251220",
      "nome_resumido_valor_dominio": "ECONOMISTA INDUSTRIAL",
      "nome_completo_valor_dominio": "ECONOMISTA INDUSTRIAL",
      "descricao_conceito_valor_dominio": "ECONOMISTA INDUSTRIAL"
    },
    {
      "codigo_valor_dominio": 1901,
      "codigo_referencia_valor_dominio": "251235",
      "nome_resumido_valor_dominio": "ECONOMISTA REGIONAL E URBANO",
      "nome_completo_valor_dominio": "ECONOMISTA REGIONAL E URBANO",
      "descricao_conceito_valor_dominio": "ECONOMISTA REGIONAL E URBANO"
    },
    {
      "codigo_valor_dominio": 1902,
      "codigo_referencia_valor_dominio": "251610",
      "nome_resumido_valor_dominio": "ECONOMISTA DOMESTICO",
      "nome_completo_valor_dominio": "ECONOMISTA DOMESTICO",
      "descricao_conceito_valor_dominio": "ECONOMISTA DOMESTICO"
    },
    {
      "codigo_valor_dominio": 1903,
      "codigo_referencia_valor_dominio": "251225",
      "nome_resumido_valor_dominio": "ECONOMISTA DO SETOR PUBLICO",
      "nome_completo_valor_dominio": "ECONOMISTA DO SETOR PUBLICO",
      "descricao_conceito_valor_dominio": "ECONOMISTA DO SETOR PUBLICO"
    },
    {
      "codigo_valor_dominio": 1904,
      "codigo_referencia_valor_dominio": "261120",
      "nome_resumido_valor_dominio": "EDITOR",
      "nome_completo_valor_dominio": "EDITOR",
      "descricao_conceito_valor_dominio": "EDITOR"
    },
    {
      "codigo_valor_dominio": 1905,
      "codigo_referencia_valor_dominio": "213405",
      "nome_resumido_valor_dominio": "GEOLOGO",
      "nome_completo_valor_dominio": "GEOLOGO",
      "descricao_conceito_valor_dominio": "GEOLOGO"
    },
    {
      "codigo_valor_dominio": 1906,
      "codigo_referencia_valor_dominio": "841710",
      "nome_resumido_valor_dominio": "FILTRADOR DE CERVEJA",
      "nome_completo_valor_dominio": "FILTRADOR DE CERVEJA",
      "descricao_conceito_valor_dominio": "FILTRADOR DE CERVEJA"
    },
    {
      "codigo_valor_dominio": 1907,
      "codigo_referencia_valor_dominio": "251520",
      "nome_resumido_valor_dominio": "PSICOLOGO HOSPITALAR",
      "nome_completo_valor_dominio": "PSICOLOGO HOSPITALAR",
      "descricao_conceito_valor_dominio": "PSICOLOGO HOSPITALAR"
    },
    {
      "codigo_valor_dominio": 1908,
      "codigo_referencia_valor_dominio": "251515",
      "nome_resumido_valor_dominio": "PSICOLOGO DO ESPORTE",
      "nome_completo_valor_dominio": "PSICOLOGO DO ESPORTE",
      "descricao_conceito_valor_dominio": "PSICOLOGO DO ESPORTE"
    },
    {
      "codigo_valor_dominio": 1909,
      "codigo_referencia_valor_dominio": "251540",
      "nome_resumido_valor_dominio": "PSICOLOGO DO TRABALHO",
      "nome_completo_valor_dominio": "PSICOLOGO DO TRABALHO",
      "descricao_conceito_valor_dominio": "PSICOLOGO DO TRABALHO"
    },
    {
      "codigo_valor_dominio": 1910,
      "codigo_referencia_valor_dominio": "251525",
      "nome_resumido_valor_dominio": "PSICOLOGO JURIDICO",
      "nome_completo_valor_dominio": "PSICOLOGO JURIDICO",
      "descricao_conceito_valor_dominio": "PSICOLOGO JURIDICO"
    },
    {
      "codigo_valor_dominio": 1911,
      "codigo_referencia_valor_dominio": "251530",
      "nome_resumido_valor_dominio": "PSICOLOGO SOCIAL",
      "nome_completo_valor_dominio": "PSICOLOGO SOCIAL",
      "descricao_conceito_valor_dominio": "PSICOLOGO SOCIAL"
    },
    {
      "codigo_valor_dominio": 1912,
      "codigo_referencia_valor_dominio": "239425",
      "nome_resumido_valor_dominio": "PSICOPEDAGOGO",
      "nome_completo_valor_dominio": "PSICOPEDAGOGO",
      "descricao_conceito_valor_dominio": "PSICOPEDAGOGO"
    },
    {
      "codigo_valor_dominio": 1913,
      "codigo_referencia_valor_dominio": "251505",
      "nome_resumido_valor_dominio": "PSICOLOGO EDUCACIONAL",
      "nome_completo_valor_dominio": "PSICOLOGO EDUCACIONAL",
      "descricao_conceito_valor_dominio": "PSICOLOGO EDUCACIONAL"
    },
    {
      "codigo_valor_dominio": 1914,
      "codigo_referencia_valor_dominio": "251535",
      "nome_resumido_valor_dominio": "PSICOLOGO DO TRANSITO",
      "nome_completo_valor_dominio": "PSICOLOGO DO TRANSITO",
      "descricao_conceito_valor_dominio": "PSICOLOGO DO TRANSITO"
    },
    {
      "codigo_valor_dominio": 1915,
      "codigo_referencia_valor_dominio": "723110",
      "nome_resumido_valor_dominio": "NORMALIZADOR DE METAIS E DE COMPOSITOS",
      "nome_completo_valor_dominio": "NORMALIZADOR DE METAIS E DE COMPOSITOS",
      "descricao_conceito_valor_dominio": "NORMALIZADOR DE METAIS E DE COMPOSITOS"
    },
    {
      "codigo_valor_dominio": 1916,
      "codigo_referencia_valor_dominio": "251555",
      "nome_resumido_valor_dominio": "PSICOLOGO ACUPUNTURISTA",
      "nome_completo_valor_dominio": "PSICOLOGO ACUPUNTURISTA",
      "descricao_conceito_valor_dominio": "PSICOLOGO ACUPUNTURISTA"
    },
    {
      "codigo_valor_dominio": 1917,
      "codigo_referencia_valor_dominio": "251510",
      "nome_resumido_valor_dominio": "PSICOLOGO CLINICO",
      "nome_completo_valor_dominio": "PSICOLOGO CLINICO",
      "descricao_conceito_valor_dominio": "PSICOLOGO CLINICO"
    },
    {
      "codigo_valor_dominio": 1918,
      "codigo_referencia_valor_dominio": "251605",
      "nome_resumido_valor_dominio": "ASSISTENTE SOCIAL",
      "nome_completo_valor_dominio": "ASSISTENTE SOCIAL",
      "descricao_conceito_valor_dominio": "ASSISTENTE SOCIAL"
    },
    {
      "codigo_valor_dominio": 1919,
      "codigo_referencia_valor_dominio": "251215",
      "nome_resumido_valor_dominio": "ECONOMISTA FINANCEIRO",
      "nome_completo_valor_dominio": "ECONOMISTA FINANCEIRO",
      "descricao_conceito_valor_dominio": "ECONOMISTA FINANCEIRO"
    },
    {
      "codigo_valor_dominio": 1920,
      "codigo_referencia_valor_dominio": "252105",
      "nome_resumido_valor_dominio": "ADMINISTRADOR",
      "nome_completo_valor_dominio": "ADMINISTRADOR",
      "descricao_conceito_valor_dominio": "ADMINISTRADOR"
    },
    {
      "codigo_valor_dominio": 1921,
      "codigo_referencia_valor_dominio": "252205",
      "nome_resumido_valor_dominio": "AUDITOR (CONTADORES E AFINS)",
      "nome_completo_valor_dominio": "AUDITOR (CONTADORES E AFINS)",
      "descricao_conceito_valor_dominio": "AUDITOR (CONTADORES E AFINS)"
    },
    {
      "codigo_valor_dominio": 1922,
      "codigo_referencia_valor_dominio": "412205",
      "nome_resumido_valor_dominio": "CONTINUO",
      "nome_completo_valor_dominio": "CONTINUO",
      "descricao_conceito_valor_dominio": "CONTINUO"
    },
    {
      "codigo_valor_dominio": 1923,
      "codigo_referencia_valor_dominio": "204105",
      "nome_resumido_valor_dominio": "PERITO CRIMINAL",
      "nome_completo_valor_dominio": "PERITO CRIMINAL",
      "descricao_conceito_valor_dominio": "PERITO CRIMINAL"
    },
    {
      "codigo_valor_dominio": 1924,
      "codigo_referencia_valor_dominio": "252310",
      "nome_resumido_valor_dominio": "SECRETARIO BILINGUE",
      "nome_completo_valor_dominio": "SECRETARIO BILINGUE",
      "descricao_conceito_valor_dominio": "SECRETARIO BILINGUE"
    },
    {
      "codigo_valor_dominio": 1925,
      "codigo_referencia_valor_dominio": "111220",
      "nome_resumido_valor_dominio": "SECRETARIO - EXECUTIVO",
      "nome_completo_valor_dominio": "SECRETARIO - EXECUTIVO",
      "descricao_conceito_valor_dominio": "SECRETARIO - EXECUTIVO"
    },
    {
      "codigo_valor_dominio": 1926,
      "codigo_referencia_valor_dominio": "252305",
      "nome_resumido_valor_dominio": "SECRETARIA(O) EXECUTIVA(O)",
      "nome_completo_valor_dominio": "SECRETARIA(O) EXECUTIVA(O)",
      "descricao_conceito_valor_dominio": "SECRETARIA(O) EXECUTIVA(O)"
    },
    {
      "codigo_valor_dominio": 1927,
      "codigo_referencia_valor_dominio": "214935",
      "nome_resumido_valor_dominio": "TECNOLOGO EM SEGURANCA DO TRABALHO",
      "nome_completo_valor_dominio": "TECNOLOGO EM SEGURANCA DO TRABALHO",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM SEGURANCA DO TRABALHO"
    },
    {
      "codigo_valor_dominio": 1928,
      "codigo_referencia_valor_dominio": "252405",
      "nome_resumido_valor_dominio": "ANALISTA DE RECURSOS HUMANOS",
      "nome_completo_valor_dominio": "ANALISTA DE RECURSOS HUMANOS",
      "descricao_conceito_valor_dominio": "ANALISTA DE RECURSOS HUMANOS"
    },
    {
      "codigo_valor_dominio": 1929,
      "codigo_referencia_valor_dominio": "252505",
      "nome_resumido_valor_dominio": "ADMINISTRADOR DE FUNDOS E CARTEIRAS DE INVESTIMENTO",
      "nome_completo_valor_dominio": "ADMINISTRADOR DE FUNDOS E CARTEIRAS DE INVESTIMENTO",
      "descricao_conceito_valor_dominio": "ADMINISTRADOR DE FUNDOS E CARTEIRAS DE INVESTIMENTO"
    },
    {
      "codigo_valor_dominio": 1930,
      "codigo_referencia_valor_dominio": "252510",
      "nome_resumido_valor_dominio": "ANALISTA DE CAMBIO",
      "nome_completo_valor_dominio": "ANALISTA DE CAMBIO",
      "descricao_conceito_valor_dominio": "ANALISTA DE CAMBIO"
    },
    {
      "codigo_valor_dominio": 1931,
      "codigo_referencia_valor_dominio": "252515",
      "nome_resumido_valor_dominio": "ANALISTA DE COBRANCA (INSTITUICOES FINANCEIRAS)",
      "nome_completo_valor_dominio": "ANALISTA DE COBRANCA (INSTITUICOES FINANCEIRAS)",
      "descricao_conceito_valor_dominio": "ANALISTA DE COBRANCA (INSTITUICOES FINANCEIRAS)"
    },
    {
      "codigo_valor_dominio": 1932,
      "codigo_referencia_valor_dominio": "252525",
      "nome_resumido_valor_dominio": "ANALISTA DE CREDITO (INSTITUICOES FINANCEIRAS)",
      "nome_completo_valor_dominio": "ANALISTA DE CREDITO (INSTITUICOES FINANCEIRAS)",
      "descricao_conceito_valor_dominio": "ANALISTA DE CREDITO (INSTITUICOES FINANCEIRAS)"
    },
    {
      "codigo_valor_dominio": 1933,
      "codigo_referencia_valor_dominio": "252530",
      "nome_resumido_valor_dominio": "ANALISTA DE CREDITO RURAL",
      "nome_completo_valor_dominio": "ANALISTA DE CREDITO RURAL",
      "descricao_conceito_valor_dominio": "ANALISTA DE CREDITO RURAL"
    },
    {
      "codigo_valor_dominio": 1934,
      "codigo_referencia_valor_dominio": "252535",
      "nome_resumido_valor_dominio": "ANALISTA DE LEASING",
      "nome_completo_valor_dominio": "ANALISTA DE LEASING",
      "descricao_conceito_valor_dominio": "ANALISTA DE LEASING"
    },
    {
      "codigo_valor_dominio": 1935,
      "codigo_referencia_valor_dominio": "252540",
      "nome_resumido_valor_dominio": "ANALISTA DE PRODUTOS BANCARIOS",
      "nome_completo_valor_dominio": "ANALISTA DE PRODUTOS BANCARIOS",
      "descricao_conceito_valor_dominio": "ANALISTA DE PRODUTOS BANCARIOS"
    },
    {
      "codigo_valor_dominio": 1936,
      "codigo_referencia_valor_dominio": "252545",
      "nome_resumido_valor_dominio": "ANALISTA FINANCEIRO (INSTITUICOES FINANCEIRAS)",
      "nome_completo_valor_dominio": "ANALISTA FINANCEIRO (INSTITUICOES FINANCEIRAS)",
      "descricao_conceito_valor_dominio": "ANALISTA FINANCEIRO (INSTITUICOES FINANCEIRAS)"
    },
    {
      "codigo_valor_dominio": 1937,
      "codigo_referencia_valor_dominio": "111230",
      "nome_resumido_valor_dominio": "GOVERNADOR DE ESTADO",
      "nome_completo_valor_dominio": "GOVERNADOR DE ESTADO",
      "descricao_conceito_valor_dominio": "GOVERNADOR DE ESTADO"
    },
    {
      "codigo_valor_dominio": 1938,
      "codigo_referencia_valor_dominio": "741120",
      "nome_resumido_valor_dominio": "RELOJOEIRO (FABRICACAO)",
      "nome_completo_valor_dominio": "RELOJOEIRO (FABRICACAO)",
      "descricao_conceito_valor_dominio": "RELOJOEIRO (FABRICACAO)"
    },
    {
      "codigo_valor_dominio": 1939,
      "codigo_referencia_valor_dominio": "261530",
      "nome_resumido_valor_dominio": "REDATOR DE TEXTOS TECNICOS",
      "nome_completo_valor_dominio": "REDATOR DE TEXTOS TECNICOS",
      "descricao_conceito_valor_dominio": "REDATOR DE TEXTOS TECNICOS"
    },
    {
      "codigo_valor_dominio": 1940,
      "codigo_referencia_valor_dominio": "253115",
      "nome_resumido_valor_dominio": "AGENTE PUBLICITARIO",
      "nome_completo_valor_dominio": "AGENTE PUBLICITARIO",
      "descricao_conceito_valor_dominio": "AGENTE PUBLICITARIO"
    },
    {
      "codigo_valor_dominio": 1941,
      "codigo_referencia_valor_dominio": "253120",
      "nome_resumido_valor_dominio": "ANALISTA DE NEGOCIOS",
      "nome_completo_valor_dominio": "ANALISTA DE NEGOCIOS",
      "descricao_conceito_valor_dominio": "ANALISTA DE NEGOCIOS"
    },
    {
      "codigo_valor_dominio": 1942,
      "codigo_referencia_valor_dominio": "253125",
      "nome_resumido_valor_dominio": "ANALISTA DE PESQUISA DE MERCADO",
      "nome_completo_valor_dominio": "ANALISTA DE PESQUISA DE MERCADO",
      "descricao_conceito_valor_dominio": "ANALISTA DE PESQUISA DE MERCADO"
    },
    {
      "codigo_valor_dominio": 1943,
      "codigo_referencia_valor_dominio": "253210",
      "nome_resumido_valor_dominio": "GERENTE DE CLIENTES ESPECIAIS (PRIVATE)",
      "nome_completo_valor_dominio": "GERENTE DE CLIENTES ESPECIAIS (PRIVATE)",
      "descricao_conceito_valor_dominio": "GERENTE DE CLIENTES ESPECIAIS (PRIVATE)"
    },
    {
      "codigo_valor_dominio": 1944,
      "codigo_referencia_valor_dominio": "142405",
      "nome_resumido_valor_dominio": "GERENTE DE COMPRAS",
      "nome_completo_valor_dominio": "GERENTE DE COMPRAS",
      "descricao_conceito_valor_dominio": "GERENTE DE COMPRAS"
    },
    {
      "codigo_valor_dominio": 1945,
      "codigo_referencia_valor_dominio": "141720",
      "nome_resumido_valor_dominio": "GERENTE DE CREDITO E COBRANCA",
      "nome_completo_valor_dominio": "GERENTE DE CREDITO E COBRANCA",
      "descricao_conceito_valor_dominio": "GERENTE DE CREDITO E COBRANCA"
    },
    {
      "codigo_valor_dominio": 1946,
      "codigo_referencia_valor_dominio": "141505",
      "nome_resumido_valor_dominio": "GERENTE DE HOTEL",
      "nome_completo_valor_dominio": "GERENTE DE HOTEL",
      "descricao_conceito_valor_dominio": "GERENTE DE HOTEL"
    },
    {
      "codigo_valor_dominio": 1947,
      "codigo_referencia_valor_dominio": "761245",
      "nome_resumido_valor_dominio": "OPERADOR DE OPEN-END",
      "nome_completo_valor_dominio": "OPERADOR DE OPEN-END",
      "descricao_conceito_valor_dominio": "OPERADOR DE OPEN-END"
    },
    {
      "codigo_valor_dominio": 1948,
      "codigo_referencia_valor_dominio": "765105",
      "nome_resumido_valor_dominio": "CORTADOR DE ARTEFATOS DE COURO (EXCETO ROUPAS E CALCADOS)",
      "nome_completo_valor_dominio": "CORTADOR DE ARTEFATOS DE COURO (EXCETO ROUPAS E CALCADOS)",
      "descricao_conceito_valor_dominio": "CORTADOR DE ARTEFATOS DE COURO (EXCETO ROUPAS E CALCADOS)"
    },
    {
      "codigo_valor_dominio": 1949,
      "codigo_referencia_valor_dominio": "254105",
      "nome_resumido_valor_dominio": "AUDITOR-FISCAL DA RECEITA FEDERAL",
      "nome_completo_valor_dominio": "AUDITOR-FISCAL DA RECEITA FEDERAL",
      "descricao_conceito_valor_dominio": "AUDITOR-FISCAL DA RECEITA FEDERAL"
    },
    {
      "codigo_valor_dominio": 1950,
      "codigo_referencia_valor_dominio": "314705",
      "nome_resumido_valor_dominio": "TECNICO DE ACABAMENTO EM SIDERURGIA",
      "nome_completo_valor_dominio": "TECNICO DE ACABAMENTO EM SIDERURGIA",
      "descricao_conceito_valor_dominio": "TECNICO DE ACABAMENTO EM SIDERURGIA"
    },
    {
      "codigo_valor_dominio": 1951,
      "codigo_referencia_valor_dominio": "254205",
      "nome_resumido_valor_dominio": "AUDITOR-FISCAL DA PREVIDENCIA SOCIAL",
      "nome_completo_valor_dominio": "AUDITOR-FISCAL DA PREVIDENCIA SOCIAL",
      "descricao_conceito_valor_dominio": "AUDITOR-FISCAL DA PREVIDENCIA SOCIAL"
    },
    {
      "codigo_valor_dominio": 1952,
      "codigo_referencia_valor_dominio": "254305",
      "nome_resumido_valor_dominio": "AUDITOR-FISCAL DO TRABALHO",
      "nome_completo_valor_dominio": "AUDITOR-FISCAL DO TRABALHO",
      "descricao_conceito_valor_dominio": "AUDITOR-FISCAL DO TRABALHO"
    },
    {
      "codigo_valor_dominio": 1953,
      "codigo_referencia_valor_dominio": "254310",
      "nome_resumido_valor_dominio": "AGENTE DE HIGIENE E SEGURANCA",
      "nome_completo_valor_dominio": "AGENTE DE HIGIENE E SEGURANCA",
      "descricao_conceito_valor_dominio": "AGENTE DE HIGIENE E SEGURANCA"
    },
    {
      "codigo_valor_dominio": 1954,
      "codigo_referencia_valor_dominio": "254410",
      "nome_resumido_valor_dominio": "FISCAL DE TRIBUTOS MUNICIPAL",
      "nome_completo_valor_dominio": "FISCAL DE TRIBUTOS MUNICIPAL",
      "descricao_conceito_valor_dominio": "FISCAL DE TRIBUTOS MUNICIPAL"
    },
    {
      "codigo_valor_dominio": 1955,
      "codigo_referencia_valor_dominio": "213105",
      "nome_resumido_valor_dominio": "FISICO",
      "nome_completo_valor_dominio": "FISICO",
      "descricao_conceito_valor_dominio": "FISICO"
    },
    {
      "codigo_valor_dominio": 1956,
      "codigo_referencia_valor_dominio": "254420",
      "nome_resumido_valor_dominio": "TECNICO DE TRIBUTOS MUNICIPAL",
      "nome_completo_valor_dominio": "TECNICO DE TRIBUTOS MUNICIPAL",
      "descricao_conceito_valor_dominio": "TECNICO DE TRIBUTOS MUNICIPAL"
    },
    {
      "codigo_valor_dominio": 1957,
      "codigo_referencia_valor_dominio": "311515",
      "nome_resumido_valor_dominio": "TECNICO DE UTILIDADE (PRODUCAO E DISTRIBUICAO DE VAPOR, GASE",
      "nome_completo_valor_dominio": "TECNICO DE UTILIDADE (PRODUCAO E DISTRIBUICAO DE VAPOR, GASES, OLEOS, COMBUSTIVEIS, ENERGIA)",
      "descricao_conceito_valor_dominio": "TECNICO DE UTILIDADE (PRODUCAO E DISTRIBUICAO DE VAPOR, GASES, OLEOS, COMBUSTIVEIS, ENERGIA)"
    },
    {
      "codigo_valor_dominio": 1958,
      "codigo_referencia_valor_dominio": "261105",
      "nome_resumido_valor_dominio": "ARQUIVISTA PESQUISADOR (JORNALISMO)",
      "nome_completo_valor_dominio": "ARQUIVISTA PESQUISADOR (JORNALISMO)",
      "descricao_conceito_valor_dominio": "ARQUIVISTA PESQUISADOR (JORNALISMO)"
    },
    {
      "codigo_valor_dominio": 1959,
      "codigo_referencia_valor_dominio": "261110",
      "nome_resumido_valor_dominio": "ASSESSOR DE IMPRENSA",
      "nome_completo_valor_dominio": "ASSESSOR DE IMPRENSA",
      "descricao_conceito_valor_dominio": "ASSESSOR DE IMPRENSA"
    },
    {
      "codigo_valor_dominio": 1960,
      "codigo_referencia_valor_dominio": "123210",
      "nome_resumido_valor_dominio": "DIRETOR DE RELACOES DE TRABALHO",
      "nome_completo_valor_dominio": "DIRETOR DE RELACOES DE TRABALHO",
      "descricao_conceito_valor_dominio": "DIRETOR DE RELACOES DE TRABALHO"
    },
    {
      "codigo_valor_dominio": 1961,
      "codigo_referencia_valor_dominio": "261605",
      "nome_resumido_valor_dominio": "EDITOR DE JORNAL",
      "nome_completo_valor_dominio": "EDITOR DE JORNAL",
      "descricao_conceito_valor_dominio": "EDITOR DE JORNAL"
    },
    {
      "codigo_valor_dominio": 1962,
      "codigo_referencia_valor_dominio": "111340",
      "nome_resumido_valor_dominio": "JUIZ AUDITOR ESTADUAL - JUSTICA MILITAR",
      "nome_completo_valor_dominio": "JUIZ AUDITOR ESTADUAL - JUSTICA MILITAR",
      "descricao_conceito_valor_dominio": "JUIZ AUDITOR ESTADUAL - JUSTICA MILITAR"
    },
    {
      "codigo_valor_dominio": 1963,
      "codigo_referencia_valor_dominio": "612320",
      "nome_resumido_valor_dominio": "PRODUTOR NA OLERICULTURA DE FRUTOS E SEMENTES",
      "nome_completo_valor_dominio": "PRODUTOR NA OLERICULTURA DE FRUTOS E SEMENTES",
      "descricao_conceito_valor_dominio": "PRODUTOR NA OLERICULTURA DE FRUTOS E SEMENTES"
    },
    {
      "codigo_valor_dominio": 1964,
      "codigo_referencia_valor_dominio": "261730",
      "nome_resumido_valor_dominio": "REPORTER DE RADIO E TELEVISAO",
      "nome_completo_valor_dominio": "REPORTER DE RADIO E TELEVISAO",
      "descricao_conceito_valor_dominio": "REPORTER DE RADIO E TELEVISAO"
    },
    {
      "codigo_valor_dominio": 1965,
      "codigo_referencia_valor_dominio": "724225",
      "nome_resumido_valor_dominio": "RISCADOR DE ESTRUTURAS METALICAS",
      "nome_completo_valor_dominio": "RISCADOR DE ESTRUTURAS METALICAS",
      "descricao_conceito_valor_dominio": "RISCADOR DE ESTRUTURAS METALICAS"
    },
    {
      "codigo_valor_dominio": 1966,
      "codigo_referencia_valor_dominio": "261205",
      "nome_resumido_valor_dominio": "BIBLIOTECARIO",
      "nome_completo_valor_dominio": "BIBLIOTECARIO",
      "descricao_conceito_valor_dominio": "BIBLIOTECARIO"
    },
    {
      "codigo_valor_dominio": 1967,
      "codigo_referencia_valor_dominio": "376225",
      "nome_resumido_valor_dominio": "DOMADOR DE ANIMAIS (CIRCENSE)",
      "nome_completo_valor_dominio": "DOMADOR DE ANIMAIS (CIRCENSE)",
      "descricao_conceito_valor_dominio": "DOMADOR DE ANIMAIS (CIRCENSE)"
    },
    {
      "codigo_valor_dominio": 1968,
      "codigo_referencia_valor_dominio": "261215",
      "nome_resumido_valor_dominio": "ANALISTA DE INFORMACOES (PESQUISADOR DE INFORMACOES DE REDE)",
      "nome_completo_valor_dominio": "ANALISTA DE INFORMACOES (PESQUISADOR DE INFORMACOES DE REDE)",
      "descricao_conceito_valor_dominio": "ANALISTA DE INFORMACOES (PESQUISADOR DE INFORMACOES DE REDE)"
    },
    {
      "codigo_valor_dominio": 1969,
      "codigo_referencia_valor_dominio": "261305",
      "nome_resumido_valor_dominio": "ARQUIVISTA",
      "nome_completo_valor_dominio": "ARQUIVISTA",
      "descricao_conceito_valor_dominio": "ARQUIVISTA"
    },
    {
      "codigo_valor_dominio": 1970,
      "codigo_referencia_valor_dominio": "262610",
      "nome_resumido_valor_dominio": "MUSICO ARRANJADOR",
      "nome_completo_valor_dominio": "MUSICO ARRANJADOR",
      "descricao_conceito_valor_dominio": "MUSICO ARRANJADOR"
    },
    {
      "codigo_valor_dominio": 1971,
      "codigo_referencia_valor_dominio": "251405",
      "nome_resumido_valor_dominio": "FILOSOFO",
      "nome_completo_valor_dominio": "FILOSOFO",
      "descricao_conceito_valor_dominio": "FILOSOFO"
    },
    {
      "codigo_valor_dominio": 1972,
      "codigo_referencia_valor_dominio": "261425",
      "nome_resumido_valor_dominio": "INTERPRETE DE LINGUA DE SINAIS",
      "nome_completo_valor_dominio": "INTERPRETE DE LINGUA DE SINAIS",
      "descricao_conceito_valor_dominio": "INTERPRETE DE LINGUA DE SINAIS"
    },
    {
      "codigo_valor_dominio": 1973,
      "codigo_referencia_valor_dominio": "768610",
      "nome_resumido_valor_dominio": "LINOTIPISTA",
      "nome_completo_valor_dominio": "LINOTIPISTA",
      "descricao_conceito_valor_dominio": "LINOTIPISTA"
    },
    {
      "codigo_valor_dominio": 1974,
      "codigo_referencia_valor_dominio": "724610",
      "nome_resumido_valor_dominio": "TRANCADOR DE CABOS DE ACO",
      "nome_completo_valor_dominio": "TRANCADOR DE CABOS DE ACO",
      "descricao_conceito_valor_dominio": "TRANCADOR DE CABOS DE ACO"
    },
    {
      "codigo_valor_dominio": 1975,
      "codigo_referencia_valor_dominio": "351810",
      "nome_resumido_valor_dominio": "INVESTIGADOR DE POLICIA",
      "nome_completo_valor_dominio": "INVESTIGADOR DE POLICIA",
      "descricao_conceito_valor_dominio": "INVESTIGADOR DE POLICIA"
    },
    {
      "codigo_valor_dominio": 1976,
      "codigo_referencia_valor_dominio": "261505",
      "nome_resumido_valor_dominio": "AUTOR-ROTEIRISTA",
      "nome_completo_valor_dominio": "AUTOR-ROTEIRISTA",
      "descricao_conceito_valor_dominio": "AUTOR-ROTEIRISTA"
    },
    {
      "codigo_valor_dominio": 1977,
      "codigo_referencia_valor_dominio": "768130",
      "nome_resumido_valor_dominio": "CROCHETEIRO, A MAO",
      "nome_completo_valor_dominio": "CROCHETEIRO, A MAO",
      "descricao_conceito_valor_dominio": "CROCHETEIRO, A MAO"
    },
    {
      "codigo_valor_dominio": 1978,
      "codigo_referencia_valor_dominio": "261520",
      "nome_resumido_valor_dominio": "ESCRITOR DE NAO FICCAO",
      "nome_completo_valor_dominio": "ESCRITOR DE NAO FICCAO",
      "descricao_conceito_valor_dominio": "ESCRITOR DE NAO FICCAO"
    },
    {
      "codigo_valor_dominio": 1979,
      "codigo_referencia_valor_dominio": "424125",
      "nome_resumido_valor_dominio": "ESCRITURARIO EM ESTATISTICA",
      "nome_completo_valor_dominio": "ESCRITURARIO EM ESTATISTICA",
      "descricao_conceito_valor_dominio": "ESCRITURARIO EM ESTATISTICA"
    },
    {
      "codigo_valor_dominio": 1980,
      "codigo_referencia_valor_dominio": "517210",
      "nome_resumido_valor_dominio": "POLICIAL RODOVIARIO FEDERAL",
      "nome_completo_valor_dominio": "POLICIAL RODOVIARIO FEDERAL",
      "descricao_conceito_valor_dominio": "POLICIAL RODOVIARIO FEDERAL"
    },
    {
      "codigo_valor_dominio": 1981,
      "codigo_referencia_valor_dominio": "768120",
      "nome_resumido_valor_dominio": "REDEIRO",
      "nome_completo_valor_dominio": "REDEIRO",
      "descricao_conceito_valor_dominio": "REDEIRO"
    },
    {
      "codigo_valor_dominio": 1982,
      "codigo_referencia_valor_dominio": "261610",
      "nome_resumido_valor_dominio": "EDITOR DE LIVRO",
      "nome_completo_valor_dominio": "EDITOR DE LIVRO",
      "descricao_conceito_valor_dominio": "EDITOR DE LIVRO"
    },
    {
      "codigo_valor_dominio": 1983,
      "codigo_referencia_valor_dominio": "261615",
      "nome_resumido_valor_dominio": "EDITOR DE MIDIA ELETRONICA",
      "nome_completo_valor_dominio": "EDITOR DE MIDIA ELETRONICA",
      "descricao_conceito_valor_dominio": "EDITOR DE MIDIA ELETRONICA"
    },
    {
      "codigo_valor_dominio": 1984,
      "codigo_referencia_valor_dominio": "261620",
      "nome_resumido_valor_dominio": "EDITOR DE REVISTA",
      "nome_completo_valor_dominio": "EDITOR DE REVISTA",
      "descricao_conceito_valor_dominio": "EDITOR DE REVISTA"
    },
    {
      "codigo_valor_dominio": 1985,
      "codigo_referencia_valor_dominio": "261625",
      "nome_resumido_valor_dominio": "EDITOR DE REVISTA CIENTIFICA",
      "nome_completo_valor_dominio": "EDITOR DE REVISTA CIENTIFICA",
      "descricao_conceito_valor_dominio": "EDITOR DE REVISTA CIENTIFICA"
    },
    {
      "codigo_valor_dominio": 1986,
      "codigo_referencia_valor_dominio": "766120",
      "nome_resumido_valor_dominio": "EDITOR DE TEXTO E IMAGEM",
      "nome_completo_valor_dominio": "EDITOR DE TEXTO E IMAGEM",
      "descricao_conceito_valor_dominio": "EDITOR DE TEXTO E IMAGEM"
    },
    {
      "codigo_valor_dominio": 1987,
      "codigo_referencia_valor_dominio": "261705",
      "nome_resumido_valor_dominio": "ANCORA DE RADIO E TELEVISAO",
      "nome_completo_valor_dominio": "ANCORA DE RADIO E TELEVISAO",
      "descricao_conceito_valor_dominio": "ANCORA DE RADIO E TELEVISAO"
    },
    {
      "codigo_valor_dominio": 1988,
      "codigo_referencia_valor_dominio": "261710",
      "nome_resumido_valor_dominio": "COMENTARISTA DE RADIO E TELEVISAO",
      "nome_completo_valor_dominio": "COMENTARISTA DE RADIO E TELEVISAO",
      "descricao_conceito_valor_dominio": "COMENTARISTA DE RADIO E TELEVISAO"
    },
    {
      "codigo_valor_dominio": 1989,
      "codigo_referencia_valor_dominio": "261720",
      "nome_resumido_valor_dominio": "LOCUTOR PUBLICITARIO DE RADIO E TELEVISAO",
      "nome_completo_valor_dominio": "LOCUTOR PUBLICITARIO DE RADIO E TELEVISAO",
      "descricao_conceito_valor_dominio": "LOCUTOR PUBLICITARIO DE RADIO E TELEVISAO"
    },
    {
      "codigo_valor_dominio": 1990,
      "codigo_referencia_valor_dominio": "919115",
      "nome_resumido_valor_dominio": "LUBRIFICADOR DE EMBARCACOES",
      "nome_completo_valor_dominio": "LUBRIFICADOR DE EMBARCACOES",
      "descricao_conceito_valor_dominio": "LUBRIFICADOR DE EMBARCACOES"
    },
    {
      "codigo_valor_dominio": 1991,
      "codigo_referencia_valor_dominio": "251545",
      "nome_resumido_valor_dominio": "NEUROPSICOLOGO",
      "nome_completo_valor_dominio": "NEUROPSICOLOGO",
      "descricao_conceito_valor_dominio": "NEUROPSICOLOGO"
    },
    {
      "codigo_valor_dominio": 1992,
      "codigo_referencia_valor_dominio": "261820",
      "nome_resumido_valor_dominio": "REPORTER FOTOGRAFICO",
      "nome_completo_valor_dominio": "REPORTER FOTOGRAFICO",
      "descricao_conceito_valor_dominio": "REPORTER FOTOGRAFICO"
    },
    {
      "codigo_valor_dominio": 1993,
      "codigo_referencia_valor_dominio": "261810",
      "nome_resumido_valor_dominio": "FOTOGRAFO PUBLICITARIO",
      "nome_completo_valor_dominio": "FOTOGRAFO PUBLICITARIO",
      "descricao_conceito_valor_dominio": "FOTOGRAFO PUBLICITARIO"
    },
    {
      "codigo_valor_dominio": 1994,
      "codigo_referencia_valor_dominio": "261815",
      "nome_resumido_valor_dominio": "FOTOGRAFO RETRATISTA",
      "nome_completo_valor_dominio": "FOTOGRAFO RETRATISTA",
      "descricao_conceito_valor_dominio": "FOTOGRAFO RETRATISTA"
    },
    {
      "codigo_valor_dominio": 1995,
      "codigo_referencia_valor_dominio": "521135",
      "nome_resumido_valor_dominio": "FRENTISTA",
      "nome_completo_valor_dominio": "FRENTISTA",
      "descricao_conceito_valor_dominio": "FRENTISTA"
    },
    {
      "codigo_valor_dominio": 1996,
      "codigo_referencia_valor_dominio": "521125",
      "nome_resumido_valor_dominio": "REPOSITOR DE MERCADORIAS",
      "nome_completo_valor_dominio": "REPOSITOR DE MERCADORIAS",
      "descricao_conceito_valor_dominio": "REPOSITOR DE MERCADORIAS"
    },
    {
      "codigo_valor_dominio": 1997,
      "codigo_referencia_valor_dominio": "612705",
      "nome_resumido_valor_dominio": "PRODUTOR DA CULTURA DE AMENDOIM",
      "nome_completo_valor_dominio": "PRODUTOR DA CULTURA DE AMENDOIM",
      "descricao_conceito_valor_dominio": "PRODUTOR DA CULTURA DE AMENDOIM"
    },
    {
      "codigo_valor_dominio": 1998,
      "codigo_referencia_valor_dominio": "262105",
      "nome_resumido_valor_dominio": "PRODUTOR CULTURAL",
      "nome_completo_valor_dominio": "PRODUTOR CULTURAL",
      "descricao_conceito_valor_dominio": "PRODUTOR CULTURAL"
    },
    {
      "codigo_valor_dominio": 1999,
      "codigo_referencia_valor_dominio": "612220",
      "nome_resumido_valor_dominio": "PRODUTOR DE RAMI",
      "nome_completo_valor_dominio": "PRODUTOR DE RAMI",
      "descricao_conceito_valor_dominio": "PRODUTOR DE RAMI"
    },
    {
      "codigo_valor_dominio": 2000,
      "codigo_referencia_valor_dominio": "262125",
      "nome_resumido_valor_dominio": "PRODUTOR DE TELEVISAO",
      "nome_completo_valor_dominio": "PRODUTOR DE TELEVISAO",
      "descricao_conceito_valor_dominio": "PRODUTOR DE TELEVISAO"
    },
    {
      "codigo_valor_dominio": 2001,
      "codigo_referencia_valor_dominio": "261130",
      "nome_resumido_valor_dominio": "PRODUTOR DE TEXTO",
      "nome_completo_valor_dominio": "PRODUTOR DE TEXTO",
      "descricao_conceito_valor_dominio": "PRODUTOR DE TEXTO"
    },
    {
      "codigo_valor_dominio": 2002,
      "codigo_referencia_valor_dominio": "214930",
      "nome_resumido_valor_dominio": "TECNOLOGO EM PRODUCAO INDUSTRIAL",
      "nome_completo_valor_dominio": "TECNOLOGO EM PRODUCAO INDUSTRIAL",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM PRODUCAO INDUSTRIAL"
    },
    {
      "codigo_valor_dominio": 2003,
      "codigo_referencia_valor_dominio": "262130",
      "nome_resumido_valor_dominio": "TECNOLOGO EM PRODUCAO FONOGRAFICA",
      "nome_completo_valor_dominio": "TECNOLOGO EM PRODUCAO FONOGRAFICA",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM PRODUCAO FONOGRAFICA"
    },
    {
      "codigo_valor_dominio": 2004,
      "codigo_referencia_valor_dominio": "122725",
      "nome_resumido_valor_dominio": "DIRETOR DE COMPLIANCE",
      "nome_completo_valor_dominio": "DIRETOR DE COMPLIANCE",
      "descricao_conceito_valor_dominio": "DIRETOR DE COMPLIANCE"
    },
    {
      "codigo_valor_dominio": 2005,
      "codigo_referencia_valor_dominio": "262215",
      "nome_resumido_valor_dominio": "DIRETOR DE PROGRAMAS DE TELEVISAO",
      "nome_completo_valor_dominio": "DIRETOR DE PROGRAMAS DE TELEVISAO",
      "descricao_conceito_valor_dominio": "DIRETOR DE PROGRAMAS DE TELEVISAO"
    },
    {
      "codigo_valor_dominio": 2006,
      "codigo_referencia_valor_dominio": "122750",
      "nome_resumido_valor_dominio": "DIRETOR DE RECUPERACAO DE CREDITOS EM OPERACOES DE INTERMEDI",
      "nome_completo_valor_dominio": "DIRETOR DE RECUPERACAO DE CREDITOS EM OPERACOES DE INTERMEDIACAO FINANCEIRA",
      "descricao_conceito_valor_dominio": "DIRETOR DE RECUPERACAO DE CREDITOS EM OPERACOES DE INTERMEDIACAO FINANCEIRA"
    },
    {
      "codigo_valor_dominio": 2007,
      "codigo_referencia_valor_dominio": "114105",
      "nome_resumido_valor_dominio": "DIRIGENTE DE PARTIDO POLITICO",
      "nome_completo_valor_dominio": "DIRIGENTE DE PARTIDO POLITICO",
      "descricao_conceito_valor_dominio": "DIRIGENTE DE PARTIDO POLITICO"
    },
    {
      "codigo_valor_dominio": 2008,
      "codigo_referencia_valor_dominio": "262305",
      "nome_resumido_valor_dominio": "CENOGRAFO CARNAVALESCO E FESTAS POPULARES",
      "nome_completo_valor_dominio": "CENOGRAFO CARNAVALESCO E FESTAS POPULARES",
      "descricao_conceito_valor_dominio": "CENOGRAFO CARNAVALESCO E FESTAS POPULARES"
    },
    {
      "codigo_valor_dominio": 2009,
      "codigo_referencia_valor_dominio": "262310",
      "nome_resumido_valor_dominio": "CENOGRAFO DE CINEMA",
      "nome_completo_valor_dominio": "CENOGRAFO DE CINEMA",
      "descricao_conceito_valor_dominio": "CENOGRAFO DE CINEMA"
    },
    {
      "codigo_valor_dominio": 2010,
      "codigo_referencia_valor_dominio": "262315",
      "nome_resumido_valor_dominio": "CENOGRAFO DE EVENTOS",
      "nome_completo_valor_dominio": "CENOGRAFO DE EVENTOS",
      "descricao_conceito_valor_dominio": "CENOGRAFO DE EVENTOS"
    },
    {
      "codigo_valor_dominio": 2011,
      "codigo_referencia_valor_dominio": "262320",
      "nome_resumido_valor_dominio": "CENOGRAFO DE TEATRO",
      "nome_completo_valor_dominio": "CENOGRAFO DE TEATRO",
      "descricao_conceito_valor_dominio": "CENOGRAFO DE TEATRO"
    },
    {
      "codigo_valor_dominio": 2012,
      "codigo_referencia_valor_dominio": "262325",
      "nome_resumido_valor_dominio": "CENOGRAFO DE TV",
      "nome_completo_valor_dominio": "CENOGRAFO DE TV",
      "descricao_conceito_valor_dominio": "CENOGRAFO DE TV"
    },
    {
      "codigo_valor_dominio": 2013,
      "codigo_referencia_valor_dominio": "122720",
      "nome_resumido_valor_dominio": "DIRETOR DE CAMBIO E COMERCIO EXTERIOR",
      "nome_completo_valor_dominio": "DIRETOR DE CAMBIO E COMERCIO EXTERIOR",
      "descricao_conceito_valor_dominio": "DIRETOR DE CAMBIO E COMERCIO EXTERIOR"
    },
    {
      "codigo_valor_dominio": 2014,
      "codigo_referencia_valor_dominio": "262405",
      "nome_resumido_valor_dominio": "ARTISTA (ARTES VISUAIS)",
      "nome_completo_valor_dominio": "ARTISTA (ARTES VISUAIS)",
      "descricao_conceito_valor_dominio": "ARTISTA (ARTES VISUAIS)"
    },
    {
      "codigo_valor_dominio": 2015,
      "codigo_referencia_valor_dominio": "318505",
      "nome_resumido_valor_dominio": "DESENHISTA PROJETISTA DE ARQUITETURA",
      "nome_completo_valor_dominio": "DESENHISTA PROJETISTA DE ARQUITETURA",
      "descricao_conceito_valor_dominio": "DESENHISTA PROJETISTA DE ARQUITETURA"
    },
    {
      "codigo_valor_dominio": 2016,
      "codigo_referencia_valor_dominio": "351115",
      "nome_resumido_valor_dominio": "CONSULTOR CONTABIL (TECNICO)",
      "nome_completo_valor_dominio": "CONSULTOR CONTABIL (TECNICO)",
      "descricao_conceito_valor_dominio": "CONSULTOR CONTABIL (TECNICO)"
    },
    {
      "codigo_valor_dominio": 2017,
      "codigo_referencia_valor_dominio": "262425",
      "nome_resumido_valor_dominio": "DESENHISTA INDUSTRIAL DE PRODUTO DE MODA (DESIGNER DE MODA)",
      "nome_completo_valor_dominio": "DESENHISTA INDUSTRIAL DE PRODUTO DE MODA (DESIGNER DE MODA)",
      "descricao_conceito_valor_dominio": "DESENHISTA INDUSTRIAL DE PRODUTO DE MODA (DESIGNER DE MODA)"
    },
    {
      "codigo_valor_dominio": 2018,
      "codigo_referencia_valor_dominio": "262410",
      "nome_resumido_valor_dominio": "DESENHISTA INDUSTRIAL GRAFICO (DESIGNER GRAFICO)",
      "nome_completo_valor_dominio": "DESENHISTA INDUSTRIAL GRAFICO (DESIGNER GRAFICO)",
      "descricao_conceito_valor_dominio": "DESENHISTA INDUSTRIAL GRAFICO (DESIGNER GRAFICO)"
    },
    {
      "codigo_valor_dominio": 2019,
      "codigo_referencia_valor_dominio": "262505",
      "nome_resumido_valor_dominio": "ATOR",
      "nome_completo_valor_dominio": "ATOR",
      "descricao_conceito_valor_dominio": "ATOR"
    },
    {
      "codigo_valor_dominio": 2020,
      "codigo_referencia_valor_dominio": "262605",
      "nome_resumido_valor_dominio": "COMPOSITOR",
      "nome_completo_valor_dominio": "COMPOSITOR",
      "descricao_conceito_valor_dominio": "COMPOSITOR"
    },
    {
      "codigo_valor_dominio": 2021,
      "codigo_referencia_valor_dominio": "262705",
      "nome_resumido_valor_dominio": "MUSICO INTERPRETE CANTOR",
      "nome_completo_valor_dominio": "MUSICO INTERPRETE CANTOR",
      "descricao_conceito_valor_dominio": "MUSICO INTERPRETE CANTOR"
    },
    {
      "codigo_valor_dominio": 2022,
      "codigo_referencia_valor_dominio": "262620",
      "nome_resumido_valor_dominio": "MUSICOLOGO",
      "nome_completo_valor_dominio": "MUSICOLOGO",
      "descricao_conceito_valor_dominio": "MUSICOLOGO"
    },
    {
      "codigo_valor_dominio": 2023,
      "codigo_referencia_valor_dominio": "223915",
      "nome_resumido_valor_dominio": "MUSICOTERAPEUTA",
      "nome_completo_valor_dominio": "MUSICOTERAPEUTA",
      "descricao_conceito_valor_dominio": "MUSICOTERAPEUTA"
    },
    {
      "codigo_valor_dominio": 2024,
      "codigo_referencia_valor_dominio": "262710",
      "nome_resumido_valor_dominio": "MUSICO INTERPRETE INSTRUMENTISTA",
      "nome_completo_valor_dominio": "MUSICO INTERPRETE INSTRUMENTISTA",
      "descricao_conceito_valor_dominio": "MUSICO INTERPRETE INSTRUMENTISTA"
    },
    {
      "codigo_valor_dominio": 2025,
      "codigo_referencia_valor_dominio": "262615",
      "nome_resumido_valor_dominio": "MUSICO REGENTE",
      "nome_completo_valor_dominio": "MUSICO REGENTE",
      "descricao_conceito_valor_dominio": "MUSICO REGENTE"
    },
    {
      "codigo_valor_dominio": 2026,
      "codigo_referencia_valor_dominio": "262805",
      "nome_resumido_valor_dominio": "ASSISTENTE DE COREOGRAFIA",
      "nome_completo_valor_dominio": "ASSISTENTE DE COREOGRAFIA",
      "descricao_conceito_valor_dominio": "ASSISTENTE DE COREOGRAFIA"
    },
    {
      "codigo_valor_dominio": 2027,
      "codigo_referencia_valor_dominio": "262810",
      "nome_resumido_valor_dominio": "BAILARINO (EXCETO DANCAS POPULARES)",
      "nome_completo_valor_dominio": "BAILARINO (EXCETO DANCAS POPULARES)",
      "descricao_conceito_valor_dominio": "BAILARINO (EXCETO DANCAS POPULARES)"
    },
    {
      "codigo_valor_dominio": 2028,
      "codigo_referencia_valor_dominio": "030105",
      "nome_resumido_valor_dominio": "CORONEL BOMBEIRO MILITAR",
      "nome_completo_valor_dominio": "CORONEL BOMBEIRO MILITAR",
      "descricao_conceito_valor_dominio": "CORONEL BOMBEIRO MILITAR"
    },
    {
      "codigo_valor_dominio": 2029,
      "codigo_referencia_valor_dominio": "251205",
      "nome_resumido_valor_dominio": "ECONOMISTA",
      "nome_completo_valor_dominio": "ECONOMISTA",
      "descricao_conceito_valor_dominio": "ECONOMISTA"
    },
    {
      "codigo_valor_dominio": 2030,
      "codigo_referencia_valor_dominio": "775105",
      "nome_resumido_valor_dominio": "ENTALHADOR DE MADEIRA",
      "nome_completo_valor_dominio": "ENTALHADOR DE MADEIRA",
      "descricao_conceito_valor_dominio": "ENTALHADOR DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 2031,
      "codigo_referencia_valor_dominio": "233110",
      "nome_resumido_valor_dominio": "PROFESSOR DE DESENHO TECNICO",
      "nome_completo_valor_dominio": "PROFESSOR DE DESENHO TECNICO",
      "descricao_conceito_valor_dominio": "PROFESSOR DE DESENHO TECNICO"
    },
    {
      "codigo_valor_dominio": 2032,
      "codigo_referencia_valor_dominio": "752410",
      "nome_resumido_valor_dominio": "DECORADOR DE VIDRO",
      "nome_completo_valor_dominio": "DECORADOR DE VIDRO",
      "descricao_conceito_valor_dominio": "DECORADOR DE VIDRO"
    },
    {
      "codigo_valor_dominio": 2033,
      "codigo_referencia_valor_dominio": "111215",
      "nome_resumido_valor_dominio": "MINISTRO DE ESTADO",
      "nome_completo_valor_dominio": "MINISTRO DE ESTADO",
      "descricao_conceito_valor_dominio": "MINISTRO DE ESTADO"
    },
    {
      "codigo_valor_dominio": 2034,
      "codigo_referencia_valor_dominio": "841605",
      "nome_resumido_valor_dominio": "MISTURADOR DE CAFE",
      "nome_completo_valor_dominio": "MISTURADOR DE CAFE",
      "descricao_conceito_valor_dominio": "MISTURADOR DE CAFE"
    },
    {
      "codigo_valor_dominio": 2035,
      "codigo_referencia_valor_dominio": "322125",
      "nome_resumido_valor_dominio": "TERAPEUTA HOLISTICO",
      "nome_completo_valor_dominio": "TERAPEUTA HOLISTICO",
      "descricao_conceito_valor_dominio": "TERAPEUTA HOLISTICO"
    },
    {
      "codigo_valor_dominio": 2036,
      "codigo_referencia_valor_dominio": "271105",
      "nome_resumido_valor_dominio": "CHEFE DE COZINHA",
      "nome_completo_valor_dominio": "CHEFE DE COZINHA",
      "descricao_conceito_valor_dominio": "CHEFE DE COZINHA"
    },
    {
      "codigo_valor_dominio": 2037,
      "codigo_referencia_valor_dominio": "142120",
      "nome_resumido_valor_dominio": "TECNOLOGO EM GESTAO ADMINISTRATIVO- FINANCEIRA",
      "nome_completo_valor_dominio": "TECNOLOGO EM GESTAO ADMINISTRATIVO- FINANCEIRA",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM GESTAO ADMINISTRATIVO- FINANCEIRA"
    },
    {
      "codigo_valor_dominio": 2038,
      "codigo_referencia_valor_dominio": "300110",
      "nome_resumido_valor_dominio": "TECNICO EM MECATRONICA - ROBOTICA",
      "nome_completo_valor_dominio": "TECNICO EM MECATRONICA - ROBOTICA",
      "descricao_conceito_valor_dominio": "TECNICO EM MECATRONICA - ROBOTICA"
    },
    {
      "codigo_valor_dominio": 2039,
      "codigo_referencia_valor_dominio": "324105",
      "nome_resumido_valor_dominio": "TECNICO EM METODOS ELETROGRAFICOS EM ENCEFALOGRAFIA",
      "nome_completo_valor_dominio": "TECNICO EM METODOS ELETROGRAFICOS EM ENCEFALOGRAFIA",
      "descricao_conceito_valor_dominio": "TECNICO EM METODOS ELETROGRAFICOS EM ENCEFALOGRAFIA"
    },
    {
      "codigo_valor_dominio": 2040,
      "codigo_referencia_valor_dominio": "314615",
      "nome_resumido_valor_dominio": "TECNICO EM ESTRUTURAS METALICAS",
      "nome_completo_valor_dominio": "TECNICO EM ESTRUTURAS METALICAS",
      "descricao_conceito_valor_dominio": "TECNICO EM ESTRUTURAS METALICAS"
    },
    {
      "codigo_valor_dominio": 2041,
      "codigo_referencia_valor_dominio": "314720",
      "nome_resumido_valor_dominio": "TECNICO DE LAMINACAO EM SIDERURGIA",
      "nome_completo_valor_dominio": "TECNICO DE LAMINACAO EM SIDERURGIA",
      "descricao_conceito_valor_dominio": "TECNICO DE LAMINACAO EM SIDERURGIA"
    },
    {
      "codigo_valor_dominio": 2042,
      "codigo_referencia_valor_dominio": "224130",
      "nome_resumido_valor_dominio": "TECNICO DE LABORATORIO E FISCALIZACAO DESPORTIVA",
      "nome_completo_valor_dominio": "TECNICO DE LABORATORIO E FISCALIZACAO DESPORTIVA",
      "descricao_conceito_valor_dominio": "TECNICO DE LABORATORIO E FISCALIZACAO DESPORTIVA"
    },
    {
      "codigo_valor_dominio": 2043,
      "codigo_referencia_valor_dominio": "311605",
      "nome_resumido_valor_dominio": "TECNICO TEXTIL",
      "nome_completo_valor_dominio": "TECNICO TEXTIL",
      "descricao_conceito_valor_dominio": "TECNICO TEXTIL"
    },
    {
      "codigo_valor_dominio": 2044,
      "codigo_referencia_valor_dominio": "317210",
      "nome_resumido_valor_dominio": "TECNICO DE APOIO AO USUARIO DE INFORMATICA (HELPDESK)",
      "nome_completo_valor_dominio": "TECNICO DE APOIO AO USUARIO DE INFORMATICA (HELPDESK)",
      "descricao_conceito_valor_dominio": "TECNICO DE APOIO AO USUARIO DE INFORMATICA (HELPDESK)"
    },
    {
      "codigo_valor_dominio": 2045,
      "codigo_referencia_valor_dominio": "301115",
      "nome_resumido_valor_dominio": "TECNICO QUIMICO DE PETROLEO",
      "nome_completo_valor_dominio": "TECNICO QUIMICO DE PETROLEO",
      "descricao_conceito_valor_dominio": "TECNICO QUIMICO DE PETROLEO"
    },
    {
      "codigo_valor_dominio": 2046,
      "codigo_referencia_valor_dominio": "313305",
      "nome_resumido_valor_dominio": "TECNICO DE COMUNICACAO DE DADOS",
      "nome_completo_valor_dominio": "TECNICO DE COMUNICACAO DE DADOS",
      "descricao_conceito_valor_dominio": "TECNICO DE COMUNICACAO DE DADOS"
    },
    {
      "codigo_valor_dominio": 2047,
      "codigo_referencia_valor_dominio": "352420",
      "nome_resumido_valor_dominio": "TECNICO EM DIREITOS AUTORAIS",
      "nome_completo_valor_dominio": "TECNICO EM DIREITOS AUTORAIS",
      "descricao_conceito_valor_dominio": "TECNICO EM DIREITOS AUTORAIS"
    },
    {
      "codigo_valor_dominio": 2048,
      "codigo_referencia_valor_dominio": "321305",
      "nome_resumido_valor_dominio": "TECNICO EM PISCICULTURA",
      "nome_completo_valor_dominio": "TECNICO EM PISCICULTURA",
      "descricao_conceito_valor_dominio": "TECNICO EM PISCICULTURA"
    },
    {
      "codigo_valor_dominio": 2049,
      "codigo_referencia_valor_dominio": "314105",
      "nome_resumido_valor_dominio": "TECNICO EM MECANICA DE PRECISAO",
      "nome_completo_valor_dominio": "TECNICO EM MECANICA DE PRECISAO",
      "descricao_conceito_valor_dominio": "TECNICO EM MECANICA DE PRECISAO"
    },
    {
      "codigo_valor_dominio": 2050,
      "codigo_referencia_valor_dominio": "319105",
      "nome_resumido_valor_dominio": "TECNICO EM CALCADOS E ARTEFATOS DE COURO",
      "nome_completo_valor_dominio": "TECNICO EM CALCADOS E ARTEFATOS DE COURO",
      "descricao_conceito_valor_dominio": "TECNICO EM CALCADOS E ARTEFATOS DE COURO"
    },
    {
      "codigo_valor_dominio": 2051,
      "codigo_referencia_valor_dominio": "316315",
      "nome_resumido_valor_dominio": "TECNICO EM PROCESSAMENTO MINERAL (EXCETO PETROLEO)",
      "nome_completo_valor_dominio": "TECNICO EM PROCESSAMENTO MINERAL (EXCETO PETROLEO)",
      "descricao_conceito_valor_dominio": "TECNICO EM PROCESSAMENTO MINERAL (EXCETO PETROLEO)"
    },
    {
      "codigo_valor_dominio": 2052,
      "codigo_referencia_valor_dominio": "224125",
      "nome_resumido_valor_dominio": "TECNICO DE DESPORTO INDIVIDUAL E COLETIVO (EXCETO FUTEBOL",
      "nome_completo_valor_dominio": "TECNICO DE DESPORTO INDIVIDUAL E COLETIVO (EXCETO FUTEBOL",
      "descricao_conceito_valor_dominio": "TECNICO DE DESPORTO INDIVIDUAL E COLETIVO (EXCETO FUTEBOL)"
    },
    {
      "codigo_valor_dominio": 2053,
      "codigo_referencia_valor_dominio": "316305",
      "nome_resumido_valor_dominio": "TECNICO DE MINERACAO",
      "nome_completo_valor_dominio": "TECNICO DE MINERACAO",
      "descricao_conceito_valor_dominio": "TECNICO DE MINERACAO"
    },
    {
      "codigo_valor_dominio": 2054,
      "codigo_referencia_valor_dominio": "354135",
      "nome_resumido_valor_dominio": "TECNICO DE VENDAS",
      "nome_completo_valor_dominio": "TECNICO DE VENDAS",
      "descricao_conceito_valor_dominio": "TECNICO DE VENDAS"
    },
    {
      "codigo_valor_dominio": 2055,
      "codigo_referencia_valor_dominio": "354805",
      "nome_resumido_valor_dominio": "TECNICO EM TURISMO",
      "nome_completo_valor_dominio": "TECNICO EM TURISMO",
      "descricao_conceito_valor_dominio": "TECNICO EM TURISMO"
    },
    {
      "codigo_valor_dominio": 2056,
      "codigo_referencia_valor_dominio": "311610",
      "nome_resumido_valor_dominio": "TECNICO TEXTIL (TRATAMENTOS QUIMICOS)",
      "nome_completo_valor_dominio": "TECNICO TEXTIL (TRATAMENTOS QUIMICOS)",
      "descricao_conceito_valor_dominio": "TECNICO TEXTIL (TRATAMENTOS QUIMICOS)"
    },
    {
      "codigo_valor_dominio": 2057,
      "codigo_referencia_valor_dominio": "311615",
      "nome_resumido_valor_dominio": "TECNICO TEXTIL DE FIACAO",
      "nome_completo_valor_dominio": "TECNICO TEXTIL DE FIACAO",
      "descricao_conceito_valor_dominio": "TECNICO TEXTIL DE FIACAO"
    },
    {
      "codigo_valor_dominio": 2058,
      "codigo_referencia_valor_dominio": "311620",
      "nome_resumido_valor_dominio": "TECNICO TEXTIL DE MALHARIA",
      "nome_completo_valor_dominio": "TECNICO TEXTIL DE MALHARIA",
      "descricao_conceito_valor_dominio": "TECNICO TEXTIL DE MALHARIA"
    },
    {
      "codigo_valor_dominio": 2059,
      "codigo_referencia_valor_dominio": "311625",
      "nome_resumido_valor_dominio": "TECNICO TEXTIL DE TECELAGEM",
      "nome_completo_valor_dominio": "TECNICO TEXTIL DE TECELAGEM",
      "descricao_conceito_valor_dominio": "TECNICO TEXTIL DE TECELAGEM"
    },
    {
      "codigo_valor_dominio": 2060,
      "codigo_referencia_valor_dominio": "222215",
      "nome_resumido_valor_dominio": "TECNOLOGO EM ALIMENTOS",
      "nome_completo_valor_dominio": "TECNOLOGO EM ALIMENTOS",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM ALIMENTOS"
    },
    {
      "codigo_valor_dominio": 2061,
      "codigo_referencia_valor_dominio": "311705",
      "nome_resumido_valor_dominio": "COLORISTA DE PAPEL",
      "nome_completo_valor_dominio": "COLORISTA DE PAPEL",
      "descricao_conceito_valor_dominio": "COLORISTA DE PAPEL"
    },
    {
      "codigo_valor_dominio": 2062,
      "codigo_referencia_valor_dominio": "311710",
      "nome_resumido_valor_dominio": "COLORISTA TEXTIL",
      "nome_completo_valor_dominio": "COLORISTA TEXTIL",
      "descricao_conceito_valor_dominio": "COLORISTA TEXTIL"
    },
    {
      "codigo_valor_dominio": 2063,
      "codigo_referencia_valor_dominio": "311720",
      "nome_resumido_valor_dominio": "PREPARADOR DE TINTAS (FABRICA DE TECIDOS)",
      "nome_completo_valor_dominio": "PREPARADOR DE TINTAS (FABRICA DE TECIDOS)",
      "descricao_conceito_valor_dominio": "PREPARADOR DE TINTAS (FABRICA DE TECIDOS)"
    },
    {
      "codigo_valor_dominio": 2064,
      "codigo_referencia_valor_dominio": "224120",
      "nome_resumido_valor_dominio": "PREPARADOR FISICO",
      "nome_completo_valor_dominio": "PREPARADOR FISICO",
      "descricao_conceito_valor_dominio": "PREPARADOR FISICO"
    },
    {
      "codigo_valor_dominio": 2065,
      "codigo_referencia_valor_dominio": "516330",
      "nome_resumido_valor_dominio": "TINGIDOR DE ROUPAS",
      "nome_completo_valor_dominio": "TINGIDOR DE ROUPAS",
      "descricao_conceito_valor_dominio": "TINGIDOR DE ROUPAS"
    },
    {
      "codigo_valor_dominio": 2066,
      "codigo_referencia_valor_dominio": "813130",
      "nome_resumido_valor_dominio": "TECNICO DE OPERACAO (QUIMICA, PETROQUIMICA E AFINS)",
      "nome_completo_valor_dominio": "TECNICO DE OPERACAO (QUIMICA, PETROQUIMICA E AFINS)",
      "descricao_conceito_valor_dominio": "TECNICO DE OPERACAO (QUIMICA, PETROQUIMICA E AFINS)"
    },
    {
      "codigo_valor_dominio": 2067,
      "codigo_referencia_valor_dominio": "314715",
      "nome_resumido_valor_dominio": "TECNICO DE FUNDICAO EM SIDERURGIA",
      "nome_completo_valor_dominio": "TECNICO DE FUNDICAO EM SIDERURGIA",
      "descricao_conceito_valor_dominio": "TECNICO DE FUNDICAO EM SIDERURGIA"
    },
    {
      "codigo_valor_dominio": 2068,
      "codigo_referencia_valor_dominio": "351740",
      "nome_resumido_valor_dominio": "TECNICO DE SEGUROS",
      "nome_completo_valor_dominio": "TECNICO DE SEGUROS",
      "descricao_conceito_valor_dominio": "TECNICO DE SEGUROS"
    },
    {
      "codigo_valor_dominio": 2069,
      "codigo_referencia_valor_dominio": "354140",
      "nome_resumido_valor_dominio": "TECNICO EM ATENDIMENTO E VENDAS",
      "nome_completo_valor_dominio": "TECNICO EM ATENDIMENTO E VENDAS",
      "descricao_conceito_valor_dominio": "TECNICO EM ATENDIMENTO E VENDAS"
    },
    {
      "codigo_valor_dominio": 2070,
      "codigo_referencia_valor_dominio": "316105",
      "nome_resumido_valor_dominio": "TECNICO EM GEOFISICA",
      "nome_completo_valor_dominio": "TECNICO EM GEOFISICA",
      "descricao_conceito_valor_dominio": "TECNICO EM GEOFISICA"
    },
    {
      "codigo_valor_dominio": 2071,
      "codigo_referencia_valor_dominio": "320110",
      "nome_resumido_valor_dominio": "TECNICO EM HISTOLOGIA",
      "nome_completo_valor_dominio": "TECNICO EM HISTOLOGIA",
      "descricao_conceito_valor_dominio": "TECNICO EM HISTOLOGIA"
    },
    {
      "codigo_valor_dominio": 2072,
      "codigo_referencia_valor_dominio": "712225",
      "nome_resumido_valor_dominio": "TORNEIRO (LAVRA DE PEDRA)",
      "nome_completo_valor_dominio": "TORNEIRO (LAVRA DE PEDRA)",
      "descricao_conceito_valor_dominio": "TORNEIRO (LAVRA DE PEDRA)"
    },
    {
      "codigo_valor_dominio": 2073,
      "codigo_referencia_valor_dominio": "313110",
      "nome_resumido_valor_dominio": "ELETROTECNICO (PRODUCAO DE ENERGIA)",
      "nome_completo_valor_dominio": "ELETROTECNICO (PRODUCAO DE ENERGIA)",
      "descricao_conceito_valor_dominio": "ELETROTECNICO (PRODUCAO DE ENERGIA)"
    },
    {
      "codigo_valor_dominio": 2074,
      "codigo_referencia_valor_dominio": "313115",
      "nome_resumido_valor_dominio": "ELETROTECNICO NA FABRICACAO, MONTAGEM E INSTALACAO DE MAQUIN",
      "nome_completo_valor_dominio": "ELETROTECNICO NA FABRICACAO, MONTAGEM E INSTALACAO DE MAQUINAS E EQUIPAMENTOS",
      "descricao_conceito_valor_dominio": "ELETROTECNICO NA FABRICACAO, MONTAGEM E INSTALACAO DE MAQUINAS E EQUIPAMENTOS"
    },
    {
      "codigo_valor_dominio": 2075,
      "codigo_referencia_valor_dominio": "784105",
      "nome_resumido_valor_dominio": "EMBALADOR, A MAO",
      "nome_completo_valor_dominio": "EMBALADOR, A MAO",
      "descricao_conceito_valor_dominio": "EMBALADOR, A MAO"
    },
    {
      "codigo_valor_dominio": 2076,
      "codigo_referencia_valor_dominio": "313125",
      "nome_resumido_valor_dominio": "TECNICO DE MANUTENCAO ELETRICA DE MAQUINA",
      "nome_completo_valor_dominio": "TECNICO DE MANUTENCAO ELETRICA DE MAQUINA",
      "descricao_conceito_valor_dominio": "TECNICO DE MANUTENCAO ELETRICA DE MAQUINA"
    },
    {
      "codigo_valor_dominio": 2077,
      "codigo_referencia_valor_dominio": "313205",
      "nome_resumido_valor_dominio": "TECNICO DE MANUTENCAO ELETRONICA",
      "nome_completo_valor_dominio": "TECNICO DE MANUTENCAO ELETRONICA",
      "descricao_conceito_valor_dominio": "TECNICO DE MANUTENCAO ELETRONICA"
    },
    {
      "codigo_valor_dominio": 2078,
      "codigo_referencia_valor_dominio": "313215",
      "nome_resumido_valor_dominio": "TECNICO ELETRONICO",
      "nome_completo_valor_dominio": "TECNICO ELETRONICO",
      "descricao_conceito_valor_dominio": "TECNICO ELETRONICO"
    },
    {
      "codigo_valor_dominio": 2079,
      "codigo_referencia_valor_dominio": "313210",
      "nome_resumido_valor_dominio": "TECNICO DE MANUTENCAO ELETRONICA (CIRCUITOS DE MAQUINAS COM",
      "nome_completo_valor_dominio": "TECNICO DE MANUTENCAO ELETRONICA (CIRCUITOS DE MAQUINAS COM COMANDO NUMERICO)",
      "descricao_conceito_valor_dominio": "TECNICO DE MANUTENCAO ELETRONICA (CIRCUITOS DE MAQUINAS COM COMANDO NUMERICO)"
    },
    {
      "codigo_valor_dominio": 2080,
      "codigo_referencia_valor_dominio": "391135",
      "nome_resumido_valor_dominio": "TECNICO DE MATERIA-PRIMA E MATERIAL",
      "nome_completo_valor_dominio": "TECNICO DE MATERIA-PRIMA E MATERIAL",
      "descricao_conceito_valor_dominio": "TECNICO DE MATERIA-PRIMA E MATERIAL"
    },
    {
      "codigo_valor_dominio": 2081,
      "codigo_referencia_valor_dominio": "322105",
      "nome_resumido_valor_dominio": "TECNICO EM ACUPUNTURA",
      "nome_completo_valor_dominio": "TECNICO EM ACUPUNTURA",
      "descricao_conceito_valor_dominio": "TECNICO EM ACUPUNTURA"
    },
    {
      "codigo_valor_dominio": 2082,
      "codigo_referencia_valor_dominio": "915305",
      "nome_resumido_valor_dominio": "TECNICO EM MANUTENCAO DE EQUIPAMENTOS E INSTRUMENTOS MEDICO-",
      "nome_completo_valor_dominio": "TECNICO EM MANUTENCAO DE EQUIPAMENTOS E INSTRUMENTOS MEDICO-HOSPITALARES",
      "descricao_conceito_valor_dominio": "TECNICO EM MANUTENCAO DE EQUIPAMENTOS E INSTRUMENTOS MEDICO-HOSPITALARES"
    },
    {
      "codigo_valor_dominio": 2083,
      "codigo_referencia_valor_dominio": "351105",
      "nome_resumido_valor_dominio": "TECNICO DE CONTABILIDADE",
      "nome_completo_valor_dominio": "TECNICO DE CONTABILIDADE",
      "descricao_conceito_valor_dominio": "TECNICO DE CONTABILIDADE"
    },
    {
      "codigo_valor_dominio": 2084,
      "codigo_referencia_valor_dominio": "314725",
      "nome_resumido_valor_dominio": "TECNICO DE REDUCAO NA SIDERURGIA (PRIMEIRA FUSAO)",
      "nome_completo_valor_dominio": "TECNICO DE REDUCAO NA SIDERURGIA (PRIMEIRA FUSAO)",
      "descricao_conceito_valor_dominio": "TECNICO DE REDUCAO NA SIDERURGIA (PRIMEIRA FUSAO)"
    },
    {
      "codigo_valor_dominio": 2085,
      "codigo_referencia_valor_dominio": "313320",
      "nome_resumido_valor_dominio": "TECNICO DE TRANSMISSAO (TELECOMUNICACOES)",
      "nome_completo_valor_dominio": "TECNICO DE TRANSMISSAO (TELECOMUNICACOES)",
      "descricao_conceito_valor_dominio": "TECNICO DE TRANSMISSAO (TELECOMUNICACOES)"
    },
    {
      "codigo_valor_dominio": 2086,
      "codigo_referencia_valor_dominio": "254415",
      "nome_resumido_valor_dominio": "TECNICO DE TRIBUTOS ESTADUAL",
      "nome_completo_valor_dominio": "TECNICO DE TRIBUTOS ESTADUAL",
      "descricao_conceito_valor_dominio": "TECNICO DE TRIBUTOS ESTADUAL"
    },
    {
      "codigo_valor_dominio": 2087,
      "codigo_referencia_valor_dominio": "321310",
      "nome_resumido_valor_dominio": "TECNICO EM CARCINICULTURA",
      "nome_completo_valor_dominio": "TECNICO EM CARCINICULTURA",
      "descricao_conceito_valor_dominio": "TECNICO EM CARCINICULTURA"
    },
    {
      "codigo_valor_dominio": 2088,
      "codigo_referencia_valor_dominio": "325110",
      "nome_resumido_valor_dominio": "TECNICO EM LABORATORIO DE FARMACIA",
      "nome_completo_valor_dominio": "TECNICO EM LABORATORIO DE FARMACIA",
      "descricao_conceito_valor_dominio": "TECNICO EM LABORATORIO DE FARMACIA"
    },
    {
      "codigo_valor_dominio": 2089,
      "codigo_referencia_valor_dominio": "950205",
      "nome_resumido_valor_dominio": "ENCARREGADO DE MANUTENCAO ELETRICA DE VEICULOS",
      "nome_completo_valor_dominio": "ENCARREGADO DE MANUTENCAO ELETRICA DE VEICULOS",
      "descricao_conceito_valor_dominio": "ENCARREGADO DE MANUTENCAO ELETRICA DE VEICULOS"
    },
    {
      "codigo_valor_dominio": 2090,
      "codigo_referencia_valor_dominio": "312310",
      "nome_resumido_valor_dominio": "TECNICO EM GEODESIA E CARTOGRAFIA",
      "nome_completo_valor_dominio": "TECNICO EM GEODESIA E CARTOGRAFIA",
      "descricao_conceito_valor_dominio": "TECNICO EM GEODESIA E CARTOGRAFIA"
    },
    {
      "codigo_valor_dominio": 2091,
      "codigo_referencia_valor_dominio": "300105",
      "nome_resumido_valor_dominio": "TECNICO EM MECATRONICA - AUTOMACAO DA MANUFATURA",
      "nome_completo_valor_dominio": "TECNICO EM MECATRONICA - AUTOMACAO DA MANUFATURA",
      "descricao_conceito_valor_dominio": "TECNICO EM MECATRONICA - AUTOMACAO DA MANUFATURA"
    },
    {
      "codigo_valor_dominio": 2092,
      "codigo_referencia_valor_dominio": "314310",
      "nome_resumido_valor_dominio": "TECNICO MECANICO (AERONAVES)",
      "nome_completo_valor_dominio": "TECNICO MECANICO (AERONAVES)",
      "descricao_conceito_valor_dominio": "TECNICO MECANICO (AERONAVES)"
    },
    {
      "codigo_valor_dominio": 2093,
      "codigo_referencia_valor_dominio": "314315",
      "nome_resumido_valor_dominio": "TECNICO MECANICO (EMBARCACOES)",
      "nome_completo_valor_dominio": "TECNICO MECANICO (EMBARCACOES)",
      "descricao_conceito_valor_dominio": "TECNICO MECANICO (EMBARCACOES)"
    },
    {
      "codigo_valor_dominio": 2094,
      "codigo_referencia_valor_dominio": "314125",
      "nome_resumido_valor_dominio": "TECNICO MECANICO (MOTORES)",
      "nome_completo_valor_dominio": "TECNICO MECANICO (MOTORES)",
      "descricao_conceito_valor_dominio": "TECNICO MECANICO (MOTORES)"
    },
    {
      "codigo_valor_dominio": 2095,
      "codigo_referencia_valor_dominio": "314205",
      "nome_resumido_valor_dominio": "TECNICO MECANICO NA FABRICACAO DE FERRAMENTAS",
      "nome_completo_valor_dominio": "TECNICO MECANICO NA FABRICACAO DE FERRAMENTAS",
      "descricao_conceito_valor_dominio": "TECNICO MECANICO NA FABRICACAO DE FERRAMENTAS"
    },
    {
      "codigo_valor_dominio": 2096,
      "codigo_referencia_valor_dominio": "314210",
      "nome_resumido_valor_dominio": "TECNICO MECANICO NA MANUTENCAO DE FERRAMENTAS",
      "nome_completo_valor_dominio": "TECNICO MECANICO NA MANUTENCAO DE FERRAMENTAS",
      "descricao_conceito_valor_dominio": "TECNICO MECANICO NA MANUTENCAO DE FERRAMENTAS"
    },
    {
      "codigo_valor_dominio": 2097,
      "codigo_referencia_valor_dominio": "391230",
      "nome_resumido_valor_dominio": "TECNICO OPERACIONAL DE SERVICOS DE CORREIOS",
      "nome_completo_valor_dominio": "TECNICO OPERACIONAL DE SERVICOS DE CORREIOS",
      "descricao_conceito_valor_dominio": "TECNICO OPERACIONAL DE SERVICOS DE CORREIOS"
    },
    {
      "codigo_valor_dominio": 2098,
      "codigo_referencia_valor_dominio": "371110",
      "nome_resumido_valor_dominio": "TECNICO EM BIBLIOTECONOMIA",
      "nome_completo_valor_dominio": "TECNICO EM BIBLIOTECONOMIA",
      "descricao_conceito_valor_dominio": "TECNICO EM BIBLIOTECONOMIA"
    },
    {
      "codigo_valor_dominio": 2099,
      "codigo_referencia_valor_dominio": "314115",
      "nome_resumido_valor_dominio": "TECNICO MECANICO (CALEFACAO, VENTILACAO E REFRIGERACAO)",
      "nome_completo_valor_dominio": "TECNICO MECANICO (CALEFACAO, VENTILACAO E REFRIGERACAO)",
      "descricao_conceito_valor_dominio": "TECNICO MECANICO (CALEFACAO, VENTILACAO E REFRIGERACAO)"
    },
    {
      "codigo_valor_dominio": 2100,
      "codigo_referencia_valor_dominio": "314120",
      "nome_resumido_valor_dominio": "TECNICO MECANICO (MAQUINAS)",
      "nome_completo_valor_dominio": "TECNICO MECANICO (MAQUINAS)",
      "descricao_conceito_valor_dominio": "TECNICO MECANICO (MAQUINAS)"
    },
    {
      "codigo_valor_dominio": 2101,
      "codigo_referencia_valor_dominio": "313120",
      "nome_resumido_valor_dominio": "TECNICO DE MANUTENCAO ELETRICA",
      "nome_completo_valor_dominio": "TECNICO DE MANUTENCAO ELETRICA",
      "descricao_conceito_valor_dominio": "TECNICO DE MANUTENCAO ELETRICA"
    },
    {
      "codigo_valor_dominio": 2102,
      "codigo_referencia_valor_dominio": "374115",
      "nome_resumido_valor_dominio": "TECNICO EM MASTERIZACAO DE AUDIO",
      "nome_completo_valor_dominio": "TECNICO EM MASTERIZACAO DE AUDIO",
      "descricao_conceito_valor_dominio": "TECNICO EM MASTERIZACAO DE AUDIO"
    },
    {
      "codigo_valor_dominio": 2103,
      "codigo_referencia_valor_dominio": "215130",
      "nome_resumido_valor_dominio": "INSPETOR DE TERMINAL",
      "nome_completo_valor_dominio": "INSPETOR DE TERMINAL",
      "descricao_conceito_valor_dominio": "INSPETOR DE TERMINAL"
    },
    {
      "codigo_valor_dominio": 2104,
      "codigo_referencia_valor_dominio": "313405",
      "nome_resumido_valor_dominio": "TECNICO EM CALIBRACAO",
      "nome_completo_valor_dominio": "TECNICO EM CALIBRACAO",
      "descricao_conceito_valor_dominio": "TECNICO EM CALIBRACAO"
    },
    {
      "codigo_valor_dominio": 2105,
      "codigo_referencia_valor_dominio": "325115",
      "nome_resumido_valor_dominio": "TECNICO EM FARMACIA",
      "nome_completo_valor_dominio": "TECNICO EM FARMACIA",
      "descricao_conceito_valor_dominio": "TECNICO EM FARMACIA"
    },
    {
      "codigo_valor_dominio": 2106,
      "codigo_referencia_valor_dominio": "374125",
      "nome_resumido_valor_dominio": "TECNICO EM SONORIZACAO",
      "nome_completo_valor_dominio": "TECNICO EM SONORIZACAO",
      "descricao_conceito_valor_dominio": "TECNICO EM SONORIZACAO"
    },
    {
      "codigo_valor_dominio": 2107,
      "codigo_referencia_valor_dominio": "314710",
      "nome_resumido_valor_dominio": "TECNICO DE ACIARIA EM SIDERURGIA",
      "nome_completo_valor_dominio": "TECNICO DE ACIARIA EM SIDERURGIA",
      "descricao_conceito_valor_dominio": "TECNICO DE ACIARIA EM SIDERURGIA"
    },
    {
      "codigo_valor_dominio": 2108,
      "codigo_referencia_valor_dominio": "325205",
      "nome_resumido_valor_dominio": "TECNICO DE ALIMENTOS",
      "nome_completo_valor_dominio": "TECNICO DE ALIMENTOS",
      "descricao_conceito_valor_dominio": "TECNICO DE ALIMENTOS"
    },
    {
      "codigo_valor_dominio": 2109,
      "codigo_referencia_valor_dominio": "391210",
      "nome_resumido_valor_dominio": "TECNICO DE GARANTIA DA QUALIDADE",
      "nome_completo_valor_dominio": "TECNICO DE GARANTIA DA QUALIDADE",
      "descricao_conceito_valor_dominio": "TECNICO DE GARANTIA DA QUALIDADE"
    },
    {
      "codigo_valor_dominio": 2110,
      "codigo_referencia_valor_dominio": "314405",
      "nome_resumido_valor_dominio": "TECNICO DE MANUTENCAO DE SISTEMAS E INSTRUMENTOS",
      "nome_completo_valor_dominio": "TECNICO DE MANUTENCAO DE SISTEMAS E INSTRUMENTOS",
      "descricao_conceito_valor_dominio": "TECNICO DE MANUTENCAO DE SISTEMAS E INSTRUMENTOS"
    },
    {
      "codigo_valor_dominio": 2111,
      "codigo_referencia_valor_dominio": "314730",
      "nome_resumido_valor_dominio": "TECNICO DE REFRATARIO EM SIDERURGIA",
      "nome_completo_valor_dominio": "TECNICO DE REFRATARIO EM SIDERURGIA",
      "descricao_conceito_valor_dominio": "TECNICO DE REFRATARIO EM SIDERURGIA"
    },
    {
      "codigo_valor_dominio": 2112,
      "codigo_referencia_valor_dominio": "351735",
      "nome_resumido_valor_dominio": "TECNICO DE RESSEGUROS",
      "nome_completo_valor_dominio": "TECNICO DE RESSEGUROS",
      "descricao_conceito_valor_dominio": "TECNICO DE RESSEGUROS"
    },
    {
      "codigo_valor_dominio": 2113,
      "codigo_referencia_valor_dominio": "316110",
      "nome_resumido_valor_dominio": "TECNICO EM GEOLOGIA",
      "nome_completo_valor_dominio": "TECNICO EM GEOLOGIA",
      "descricao_conceito_valor_dominio": "TECNICO EM GEOLOGIA"
    },
    {
      "codigo_valor_dominio": 2114,
      "codigo_referencia_valor_dominio": "316115",
      "nome_resumido_valor_dominio": "TECNICO EM GEOQUIMICA",
      "nome_completo_valor_dominio": "TECNICO EM GEOQUIMICA",
      "descricao_conceito_valor_dominio": "TECNICO EM GEOQUIMICA"
    },
    {
      "codigo_valor_dominio": 2115,
      "codigo_referencia_valor_dominio": "316120",
      "nome_resumido_valor_dominio": "TECNICO EM GEOTECNIA",
      "nome_completo_valor_dominio": "TECNICO EM GEOTECNIA",
      "descricao_conceito_valor_dominio": "TECNICO EM GEOTECNIA"
    },
    {
      "codigo_valor_dominio": 2116,
      "codigo_referencia_valor_dominio": "374105",
      "nome_resumido_valor_dominio": "TECNICO EM GRAVACAO DE AUDIO",
      "nome_completo_valor_dominio": "TECNICO EM GRAVACAO DE AUDIO",
      "descricao_conceito_valor_dominio": "TECNICO EM GRAVACAO DE AUDIO"
    },
    {
      "codigo_valor_dominio": 2117,
      "codigo_referencia_valor_dominio": "316310",
      "nome_resumido_valor_dominio": "TECNICO DE MINERACAO (OLEO E PETROLEO)",
      "nome_completo_valor_dominio": "TECNICO DE MINERACAO (OLEO E PETROLEO)",
      "descricao_conceito_valor_dominio": "TECNICO DE MINERACAO (OLEO E PETROLEO)"
    },
    {
      "codigo_valor_dominio": 2118,
      "codigo_referencia_valor_dominio": "312105",
      "nome_resumido_valor_dominio": "TECNICO DE OBRAS CIVIS",
      "nome_completo_valor_dominio": "TECNICO DE OBRAS CIVIS",
      "descricao_conceito_valor_dominio": "TECNICO DE OBRAS CIVIS"
    },
    {
      "codigo_valor_dominio": 2119,
      "codigo_referencia_valor_dominio": "371305",
      "nome_resumido_valor_dominio": "TECNICO EM PROGRAMACAO VISUAL",
      "nome_completo_valor_dominio": "TECNICO EM PROGRAMACAO VISUAL",
      "descricao_conceito_valor_dominio": "TECNICO EM PROGRAMACAO VISUAL"
    },
    {
      "codigo_valor_dominio": 2120,
      "codigo_referencia_valor_dominio": "311205",
      "nome_resumido_valor_dominio": "TECNICO EM PETROQUIMICA",
      "nome_completo_valor_dominio": "TECNICO EM PETROQUIMICA",
      "descricao_conceito_valor_dominio": "TECNICO EM PETROQUIMICA"
    },
    {
      "codigo_valor_dominio": 2121,
      "codigo_referencia_valor_dominio": "313310",
      "nome_resumido_valor_dominio": "TECNICO DE REDE (TELECOMUNICACOES)",
      "nome_completo_valor_dominio": "TECNICO DE REDE (TELECOMUNICACOES)",
      "descricao_conceito_valor_dominio": "TECNICO DE REDE (TELECOMUNICACOES)"
    },
    {
      "codigo_valor_dominio": 2122,
      "codigo_referencia_valor_dominio": "311410",
      "nome_resumido_valor_dominio": "TECNICO EM PLASTICO",
      "nome_completo_valor_dominio": "TECNICO EM PLASTICO",
      "descricao_conceito_valor_dominio": "TECNICO EM PLASTICO"
    },
    {
      "codigo_valor_dominio": 2123,
      "codigo_referencia_valor_dominio": "848515",
      "nome_resumido_valor_dominio": "DESOSSADOR",
      "nome_completo_valor_dominio": "DESOSSADOR",
      "descricao_conceito_valor_dominio": "DESOSSADOR"
    },
    {
      "codigo_valor_dominio": 2124,
      "codigo_referencia_valor_dominio": "316340",
      "nome_resumido_valor_dominio": "CIMENTADOR (POCOS DE PETROLEO)",
      "nome_completo_valor_dominio": "CIMENTADOR (POCOS DE PETROLEO)",
      "descricao_conceito_valor_dominio": "CIMENTADOR (POCOS DE PETROLEO)"
    },
    {
      "codigo_valor_dominio": 2125,
      "codigo_referencia_valor_dominio": "317115",
      "nome_resumido_valor_dominio": "PROGRAMADOR DE MAQUINAS - FERRAMENTA COM COMANDO NUMERICO",
      "nome_completo_valor_dominio": "PROGRAMADOR DE MAQUINAS - FERRAMENTA COM COMANDO NUMERICO",
      "descricao_conceito_valor_dominio": "PROGRAMADOR DE MAQUINAS - FERRAMENTA COM COMANDO NUMERICO"
    },
    {
      "codigo_valor_dominio": 2126,
      "codigo_referencia_valor_dominio": "766155",
      "nome_resumido_valor_dominio": "PROGRAMADOR VISUAL GRAFICO",
      "nome_completo_valor_dominio": "PROGRAMADOR VISUAL GRAFICO",
      "descricao_conceito_valor_dominio": "PROGRAMADOR VISUAL GRAFICO"
    },
    {
      "codigo_valor_dominio": 2127,
      "codigo_referencia_valor_dominio": "317120",
      "nome_resumido_valor_dominio": "PROGRAMADOR DE MULTIMIDIA",
      "nome_completo_valor_dominio": "PROGRAMADOR DE MULTIMIDIA",
      "descricao_conceito_valor_dominio": "PROGRAMADOR DE MULTIMIDIA"
    },
    {
      "codigo_valor_dominio": 2128,
      "codigo_referencia_valor_dominio": "317110",
      "nome_resumido_valor_dominio": "PROGRAMADOR DE SISTEMAS DE INFORMACAO",
      "nome_completo_valor_dominio": "PROGRAMADOR DE SISTEMAS DE INFORMACAO",
      "descricao_conceito_valor_dominio": "PROGRAMADOR DE SISTEMAS DE INFORMACAO"
    },
    {
      "codigo_valor_dominio": 2129,
      "codigo_referencia_valor_dominio": "811120",
      "nome_resumido_valor_dominio": "OPERADOR DE CONCENTRACAO",
      "nome_completo_valor_dominio": "OPERADOR DE CONCENTRACAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE CONCENTRACAO"
    },
    {
      "codigo_valor_dominio": 2130,
      "codigo_referencia_valor_dominio": "395105",
      "nome_resumido_valor_dominio": "TECNICO DE APOIO EM PESQUISA E DESENVOLVIMENTO (EXCETO AGROP",
      "nome_completo_valor_dominio": "TECNICO DE APOIO EM PESQUISA E DESENVOLVIMENTO (EXCETO AGROPECUARIO E FLORESTAL)",
      "descricao_conceito_valor_dominio": "TECNICO DE APOIO EM PESQUISA E DESENVOLVIMENTO (EXCETO AGROPECUARIO E FLORESTAL)"
    },
    {
      "codigo_valor_dominio": 2131,
      "codigo_referencia_valor_dominio": "318105",
      "nome_resumido_valor_dominio": "DESENHISTA TECNICO (ARQUITETURA)",
      "nome_completo_valor_dominio": "DESENHISTA TECNICO (ARQUITETURA)",
      "descricao_conceito_valor_dominio": "DESENHISTA TECNICO (ARQUITETURA)"
    },
    {
      "codigo_valor_dominio": 2132,
      "codigo_referencia_valor_dominio": "318015",
      "nome_resumido_valor_dominio": "DESENHISTA DETALHISTA",
      "nome_completo_valor_dominio": "DESENHISTA DETALHISTA",
      "descricao_conceito_valor_dominio": "DESENHISTA DETALHISTA"
    },
    {
      "codigo_valor_dominio": 2133,
      "codigo_referencia_valor_dominio": "262420",
      "nome_resumido_valor_dominio": "DESENHISTA INDUSTRIAL DE PRODUTO (DESIGNER DE PRODUTO)",
      "nome_completo_valor_dominio": "DESENHISTA INDUSTRIAL DE PRODUTO (DESIGNER DE PRODUTO)",
      "descricao_conceito_valor_dominio": "DESENHISTA INDUSTRIAL DE PRODUTO (DESIGNER DE PRODUTO)"
    },
    {
      "codigo_valor_dominio": 2134,
      "codigo_referencia_valor_dominio": "318405",
      "nome_resumido_valor_dominio": "DESENHISTA TECNICO (ARTES GRAFICAS)",
      "nome_completo_valor_dominio": "DESENHISTA TECNICO (ARTES GRAFICAS)",
      "descricao_conceito_valor_dominio": "DESENHISTA TECNICO (ARTES GRAFICAS)"
    },
    {
      "codigo_valor_dominio": 2135,
      "codigo_referencia_valor_dominio": "318115",
      "nome_resumido_valor_dominio": "DESENHISTA TECNICO (CONSTRUCAO CIVIL)",
      "nome_completo_valor_dominio": "DESENHISTA TECNICO (CONSTRUCAO CIVIL)",
      "descricao_conceito_valor_dominio": "DESENHISTA TECNICO (CONSTRUCAO CIVIL)"
    },
    {
      "codigo_valor_dominio": 2136,
      "codigo_referencia_valor_dominio": "318305",
      "nome_resumido_valor_dominio": "DESENHISTA TECNICO (ELETRICIDADE E ELETRONICA)",
      "nome_completo_valor_dominio": "DESENHISTA TECNICO (ELETRICIDADE E ELETRONICA)",
      "descricao_conceito_valor_dominio": "DESENHISTA TECNICO (ELETRICIDADE E ELETRONICA)"
    },
    {
      "codigo_valor_dominio": 2137,
      "codigo_referencia_valor_dominio": "318425",
      "nome_resumido_valor_dominio": "DESENHISTA TECNICO (MOBILIARIO)",
      "nome_completo_valor_dominio": "DESENHISTA TECNICO (MOBILIARIO)",
      "descricao_conceito_valor_dominio": "DESENHISTA TECNICO (MOBILIARIO)"
    },
    {
      "codigo_valor_dominio": 2138,
      "codigo_referencia_valor_dominio": "318215",
      "nome_resumido_valor_dominio": "DESENHISTA TECNICO NAVAL",
      "nome_completo_valor_dominio": "DESENHISTA TECNICO NAVAL",
      "descricao_conceito_valor_dominio": "DESENHISTA TECNICO NAVAL"
    },
    {
      "codigo_valor_dominio": 2139,
      "codigo_referencia_valor_dominio": "318430",
      "nome_resumido_valor_dominio": "DESENHISTA TECNICO DE EMBALAGENS, MAQUETES E LEIAUTES",
      "nome_completo_valor_dominio": "DESENHISTA TECNICO DE EMBALAGENS, MAQUETES E LEIAUTES",
      "descricao_conceito_valor_dominio": "DESENHISTA TECNICO DE EMBALAGENS, MAQUETES E LEIAUTES"
    },
    {
      "codigo_valor_dominio": 2140,
      "codigo_referencia_valor_dominio": "841432",
      "nome_resumido_valor_dominio": "DESIDRATADOR DE ALIMENTOS",
      "nome_completo_valor_dominio": "DESIDRATADOR DE ALIMENTOS",
      "descricao_conceito_valor_dominio": "DESIDRATADOR DE ALIMENTOS"
    },
    {
      "codigo_valor_dominio": 2141,
      "codigo_referencia_valor_dominio": "318410",
      "nome_resumido_valor_dominio": "DESENHISTA TECNICO (ILUSTRACOES ARTISTICAS)",
      "nome_completo_valor_dominio": "DESENHISTA TECNICO (ILUSTRACOES ARTISTICAS)",
      "descricao_conceito_valor_dominio": "DESENHISTA TECNICO (ILUSTRACOES ARTISTICAS)"
    },
    {
      "codigo_valor_dominio": 2142,
      "codigo_referencia_valor_dominio": "318110",
      "nome_resumido_valor_dominio": "DESENHISTA TECNICO (CARTOGRAFIA)",
      "nome_completo_valor_dominio": "DESENHISTA TECNICO (CARTOGRAFIA)",
      "descricao_conceito_valor_dominio": "DESENHISTA TECNICO (CARTOGRAFIA)"
    },
    {
      "codigo_valor_dominio": 2143,
      "codigo_referencia_valor_dominio": "318310",
      "nome_resumido_valor_dominio": "DESENHISTA TECNICO (CALEFACAO, VENTILACAO E REFRIGERACAO)",
      "nome_completo_valor_dominio": "DESENHISTA TECNICO (CALEFACAO, VENTILACAO E REFRIGERACAO)",
      "descricao_conceito_valor_dominio": "DESENHISTA TECNICO (CALEFACAO, VENTILACAO E REFRIGERACAO)"
    },
    {
      "codigo_valor_dominio": 2144,
      "codigo_referencia_valor_dominio": "318415",
      "nome_resumido_valor_dominio": "DESENHISTA TECNICO (ILUSTRACOES TECNICAS)",
      "nome_completo_valor_dominio": "DESENHISTA TECNICO (ILUSTRACOES TECNICAS)",
      "descricao_conceito_valor_dominio": "DESENHISTA TECNICO (ILUSTRACOES TECNICAS)"
    },
    {
      "codigo_valor_dominio": 2145,
      "codigo_referencia_valor_dominio": "318420",
      "nome_resumido_valor_dominio": "DESENHISTA TECNICO (INDUSTRIA TEXTIL)",
      "nome_completo_valor_dominio": "DESENHISTA TECNICO (INDUSTRIA TEXTIL)",
      "descricao_conceito_valor_dominio": "DESENHISTA TECNICO (INDUSTRIA TEXTIL)"
    },
    {
      "codigo_valor_dominio": 2146,
      "codigo_referencia_valor_dominio": "318120",
      "nome_resumido_valor_dominio": "DESENHISTA TECNICO (INSTALACOES HIDROSSANITARIAS)",
      "nome_completo_valor_dominio": "DESENHISTA TECNICO (INSTALACOES HIDROSSANITARIAS)",
      "descricao_conceito_valor_dominio": "DESENHISTA TECNICO (INSTALACOES HIDROSSANITARIAS)"
    },
    {
      "codigo_valor_dominio": 2147,
      "codigo_referencia_valor_dominio": "318210",
      "nome_resumido_valor_dominio": "DESENHISTA TECNICO AERONAUTICO",
      "nome_completo_valor_dominio": "DESENHISTA TECNICO AERONAUTICO",
      "descricao_conceito_valor_dominio": "DESENHISTA TECNICO AERONAUTICO"
    },
    {
      "codigo_valor_dominio": 2148,
      "codigo_referencia_valor_dominio": "318205",
      "nome_resumido_valor_dominio": "DESENHISTA TECNICO MECANICO",
      "nome_completo_valor_dominio": "DESENHISTA TECNICO MECANICO",
      "descricao_conceito_valor_dominio": "DESENHISTA TECNICO MECANICO"
    },
    {
      "codigo_valor_dominio": 2149,
      "codigo_referencia_valor_dominio": "318510",
      "nome_resumido_valor_dominio": "DESENHISTA PROJETISTA DE CONSTRUCAO CIVIL",
      "nome_completo_valor_dominio": "DESENHISTA PROJETISTA DE CONSTRUCAO CIVIL",
      "descricao_conceito_valor_dominio": "DESENHISTA PROJETISTA DE CONSTRUCAO CIVIL"
    },
    {
      "codigo_valor_dominio": 2150,
      "codigo_referencia_valor_dominio": "318705",
      "nome_resumido_valor_dominio": "DESENHISTA PROJETISTA DE ELETRICIDADE",
      "nome_completo_valor_dominio": "DESENHISTA PROJETISTA DE ELETRICIDADE",
      "descricao_conceito_valor_dominio": "DESENHISTA PROJETISTA DE ELETRICIDADE"
    },
    {
      "codigo_valor_dominio": 2151,
      "codigo_referencia_valor_dominio": "318710",
      "nome_resumido_valor_dominio": "DESENHISTA PROJETISTA ELETRONICO",
      "nome_completo_valor_dominio": "DESENHISTA PROJETISTA ELETRONICO",
      "descricao_conceito_valor_dominio": "DESENHISTA PROJETISTA ELETRONICO"
    },
    {
      "codigo_valor_dominio": 2152,
      "codigo_referencia_valor_dominio": "318005",
      "nome_resumido_valor_dominio": "DESENHISTA TECNICO",
      "nome_completo_valor_dominio": "DESENHISTA TECNICO",
      "descricao_conceito_valor_dominio": "DESENHISTA TECNICO"
    },
    {
      "codigo_valor_dominio": 2153,
      "codigo_referencia_valor_dominio": "318605",
      "nome_resumido_valor_dominio": "DESENHISTA PROJETISTA DE MAQUINAS",
      "nome_completo_valor_dominio": "DESENHISTA PROJETISTA DE MAQUINAS",
      "descricao_conceito_valor_dominio": "DESENHISTA PROJETISTA DE MAQUINAS"
    },
    {
      "codigo_valor_dominio": 2154,
      "codigo_referencia_valor_dominio": "318610",
      "nome_resumido_valor_dominio": "DESENHISTA PROJETISTA MECANICO",
      "nome_completo_valor_dominio": "DESENHISTA PROJETISTA MECANICO",
      "descricao_conceito_valor_dominio": "DESENHISTA PROJETISTA MECANICO"
    },
    {
      "codigo_valor_dominio": 2155,
      "codigo_referencia_valor_dominio": "374135",
      "nome_resumido_valor_dominio": "PROJETISTA DE SISTEMAS DE AUDIO",
      "nome_completo_valor_dominio": "PROJETISTA DE SISTEMAS DE AUDIO",
      "descricao_conceito_valor_dominio": "PROJETISTA DE SISTEMAS DE AUDIO"
    },
    {
      "codigo_valor_dominio": 2156,
      "codigo_referencia_valor_dominio": "376405",
      "nome_resumido_valor_dominio": "MODELO ARTISTICO",
      "nome_completo_valor_dominio": "MODELO ARTISTICO",
      "descricao_conceito_valor_dominio": "MODELO ARTISTICO"
    },
    {
      "codigo_valor_dominio": 2157,
      "codigo_referencia_valor_dominio": "318810",
      "nome_resumido_valor_dominio": "MODELISTA DE ROUPAS",
      "nome_completo_valor_dominio": "MODELISTA DE ROUPAS",
      "descricao_conceito_valor_dominio": "MODELISTA DE ROUPAS"
    },
    {
      "codigo_valor_dominio": 2158,
      "codigo_referencia_valor_dominio": "314610",
      "nome_resumido_valor_dominio": "TECNICO EM CALDEIRARIA",
      "nome_completo_valor_dominio": "TECNICO EM CALDEIRARIA",
      "descricao_conceito_valor_dominio": "TECNICO EM CALDEIRARIA"
    },
    {
      "codigo_valor_dominio": 2159,
      "codigo_referencia_valor_dominio": "311115",
      "nome_resumido_valor_dominio": "TECNICO EM CURTIMENTO",
      "nome_completo_valor_dominio": "TECNICO EM CURTIMENTO",
      "descricao_conceito_valor_dominio": "TECNICO EM CURTIMENTO"
    },
    {
      "codigo_valor_dominio": 2160,
      "codigo_referencia_valor_dominio": "313130",
      "nome_resumido_valor_dominio": "TECNICO ELETRICISTA",
      "nome_completo_valor_dominio": "TECNICO ELETRICISTA",
      "descricao_conceito_valor_dominio": "TECNICO ELETRICISTA"
    },
    {
      "codigo_valor_dominio": 2161,
      "codigo_referencia_valor_dominio": "311405",
      "nome_resumido_valor_dominio": "TECNICO EM BORRACHA",
      "nome_completo_valor_dominio": "TECNICO EM BORRACHA",
      "descricao_conceito_valor_dominio": "TECNICO EM BORRACHA"
    },
    {
      "codigo_valor_dominio": 2162,
      "codigo_referencia_valor_dominio": "325310",
      "nome_resumido_valor_dominio": "TECNICO EM IMUNOBIOLOGICOS",
      "nome_completo_valor_dominio": "TECNICO EM IMUNOBIOLOGICOS",
      "descricao_conceito_valor_dominio": "TECNICO EM IMUNOBIOLOGICOS"
    },
    {
      "codigo_valor_dominio": 2163,
      "codigo_referencia_valor_dominio": "321110",
      "nome_resumido_valor_dominio": "TECNICO AGROPECUARIO",
      "nome_completo_valor_dominio": "TECNICO AGROPECUARIO",
      "descricao_conceito_valor_dominio": "TECNICO AGROPECUARIO"
    },
    {
      "codigo_valor_dominio": 2164,
      "codigo_referencia_valor_dominio": "254110",
      "nome_resumido_valor_dominio": "TECNICO DA RECEITA FEDERAL",
      "nome_completo_valor_dominio": "TECNICO DA RECEITA FEDERAL",
      "descricao_conceito_valor_dominio": "TECNICO DA RECEITA FEDERAL"
    },
    {
      "codigo_valor_dominio": 2165,
      "codigo_referencia_valor_dominio": "915115",
      "nome_resumido_valor_dominio": "TECNICO EM MANUTENCAO DE BALANCAS",
      "nome_completo_valor_dominio": "TECNICO EM MANUTENCAO DE BALANCAS",
      "descricao_conceito_valor_dominio": "TECNICO EM MANUTENCAO DE BALANCAS"
    },
    {
      "codigo_valor_dominio": 2166,
      "codigo_referencia_valor_dominio": "371310",
      "nome_resumido_valor_dominio": "TECNICO GRAFICO",
      "nome_completo_valor_dominio": "TECNICO GRAFICO",
      "descricao_conceito_valor_dominio": "TECNICO GRAFICO"
    },
    {
      "codigo_valor_dominio": 2167,
      "codigo_referencia_valor_dominio": "316330",
      "nome_resumido_valor_dominio": "TECNICO EM PLANEJAMENTO DE LAVRA DE MINAS",
      "nome_completo_valor_dominio": "TECNICO EM PLANEJAMENTO DE LAVRA DE MINAS",
      "descricao_conceito_valor_dominio": "TECNICO EM PLANEJAMENTO DE LAVRA DE MINAS"
    },
    {
      "codigo_valor_dominio": 2168,
      "codigo_referencia_valor_dominio": "319110",
      "nome_resumido_valor_dominio": "TECNICO EM CONFECCOES DO VESTUARIO",
      "nome_completo_valor_dominio": "TECNICO EM CONFECCOES DO VESTUARIO",
      "descricao_conceito_valor_dominio": "TECNICO EM CONFECCOES DO VESTUARIO"
    },
    {
      "codigo_valor_dominio": 2169,
      "codigo_referencia_valor_dominio": "374130",
      "nome_resumido_valor_dominio": "TECNICO EM MIXAGEM DE AUDIO",
      "nome_completo_valor_dominio": "TECNICO EM MIXAGEM DE AUDIO",
      "descricao_conceito_valor_dominio": "TECNICO EM MIXAGEM DE AUDIO"
    },
    {
      "codigo_valor_dominio": 2170,
      "codigo_referencia_valor_dominio": "322405",
      "nome_resumido_valor_dominio": "TECNICO EM SAUDE BUCAL",
      "nome_completo_valor_dominio": "TECNICO EM SAUDE BUCAL",
      "descricao_conceito_valor_dominio": "TECNICO EM SAUDE BUCAL"
    },
    {
      "codigo_valor_dominio": 2171,
      "codigo_referencia_valor_dominio": "351305",
      "nome_resumido_valor_dominio": "TECNICO EM ADMINISTRACAO",
      "nome_completo_valor_dominio": "TECNICO EM ADMINISTRACAO",
      "descricao_conceito_valor_dominio": "TECNICO EM ADMINISTRACAO"
    },
    {
      "codigo_valor_dominio": 2172,
      "codigo_referencia_valor_dominio": "261525",
      "nome_resumido_valor_dominio": "POETA",
      "nome_completo_valor_dominio": "POETA",
      "descricao_conceito_valor_dominio": "POETA"
    },
    {
      "codigo_valor_dominio": 2173,
      "codigo_referencia_valor_dominio": "324115",
      "nome_resumido_valor_dominio": "TECNICO EM RADIOLOGIA E IMAGENOLOGIA",
      "nome_completo_valor_dominio": "TECNICO EM RADIOLOGIA E IMAGENOLOGIA",
      "descricao_conceito_valor_dominio": "TECNICO EM RADIOLOGIA E IMAGENOLOGIA"
    },
    {
      "codigo_valor_dominio": 2174,
      "codigo_referencia_valor_dominio": "211115",
      "nome_resumido_valor_dominio": "MATEMATICO",
      "nome_completo_valor_dominio": "MATEMATICO",
      "descricao_conceito_valor_dominio": "MATEMATICO"
    },
    {
      "codigo_valor_dominio": 2175,
      "codigo_referencia_valor_dominio": "223905",
      "nome_resumido_valor_dominio": "TERAPEUTA OCUPACIONAL",
      "nome_completo_valor_dominio": "TERAPEUTA OCUPACIONAL",
      "descricao_conceito_valor_dominio": "TERAPEUTA OCUPACIONAL"
    },
    {
      "codigo_valor_dominio": 2176,
      "codigo_referencia_valor_dominio": "519310",
      "nome_resumido_valor_dominio": "ESTETICISTA DE ANIMAIS DOMESTICOS",
      "nome_completo_valor_dominio": "ESTETICISTA DE ANIMAIS DOMESTICOS",
      "descricao_conceito_valor_dominio": "ESTETICISTA DE ANIMAIS DOMESTICOS"
    },
    {
      "codigo_valor_dominio": 2177,
      "codigo_referencia_valor_dominio": "322245",
      "nome_resumido_valor_dominio": "TECNICO DE ENFERMAGEM DA ESTRATEGIA DE SAUDE DA FAMILIA",
      "nome_completo_valor_dominio": "TECNICO DE ENFERMAGEM DA ESTRATEGIA DE SAUDE DA FAMILIA",
      "descricao_conceito_valor_dominio": "TECNICO DE ENFERMAGEM DA ESTRATEGIA DE SAUDE DA FAMILIA"
    },
    {
      "codigo_valor_dominio": 2178,
      "codigo_referencia_valor_dominio": "322215",
      "nome_resumido_valor_dominio": "TECNICO DE ENFERMAGEM DO TRABALHO",
      "nome_completo_valor_dominio": "TECNICO DE ENFERMAGEM DO TRABALHO",
      "descricao_conceito_valor_dominio": "TECNICO DE ENFERMAGEM DO TRABALHO"
    },
    {
      "codigo_valor_dominio": 2179,
      "codigo_referencia_valor_dominio": "322220",
      "nome_resumido_valor_dominio": "TECNICO DE ENFERMAGEM PSIQUIATRICA",
      "nome_completo_valor_dominio": "TECNICO DE ENFERMAGEM PSIQUIATRICA",
      "descricao_conceito_valor_dominio": "TECNICO DE ENFERMAGEM PSIQUIATRICA"
    },
    {
      "codigo_valor_dominio": 2180,
      "codigo_referencia_valor_dominio": "312205",
      "nome_resumido_valor_dominio": "TECNICO DE ESTRADAS",
      "nome_completo_valor_dominio": "TECNICO DE ESTRADAS",
      "descricao_conceito_valor_dominio": "TECNICO DE ESTRADAS"
    },
    {
      "codigo_valor_dominio": 2181,
      "codigo_referencia_valor_dominio": "233205",
      "nome_resumido_valor_dominio": "INSTRUTOR DE APRENDIZAGEM E TREINAMENTO AGROPECUARIO",
      "nome_completo_valor_dominio": "INSTRUTOR DE APRENDIZAGEM E TREINAMENTO AGROPECUARIO",
      "descricao_conceito_valor_dominio": "INSTRUTOR DE APRENDIZAGEM E TREINAMENTO AGROPECUARIO"
    },
    {
      "codigo_valor_dominio": 2182,
      "codigo_referencia_valor_dominio": "322230",
      "nome_resumido_valor_dominio": "AUXILIAR DE ENFERMAGEM",
      "nome_completo_valor_dominio": "AUXILIAR DE ENFERMAGEM",
      "descricao_conceito_valor_dominio": "AUXILIAR DE ENFERMAGEM"
    },
    {
      "codigo_valor_dominio": 2183,
      "codigo_referencia_valor_dominio": "322235",
      "nome_resumido_valor_dominio": "AUXILIAR DE ENFERMAGEM DO TRABALHO",
      "nome_completo_valor_dominio": "AUXILIAR DE ENFERMAGEM DO TRABALHO",
      "descricao_conceito_valor_dominio": "AUXILIAR DE ENFERMAGEM DO TRABALHO"
    },
    {
      "codigo_valor_dominio": 2184,
      "codigo_referencia_valor_dominio": "322240",
      "nome_resumido_valor_dominio": "AUXILIAR DE SAUDE (NAVEGACAO MARITIMA)",
      "nome_completo_valor_dominio": "AUXILIAR DE SAUDE (NAVEGACAO MARITIMA)",
      "descricao_conceito_valor_dominio": "AUXILIAR DE SAUDE (NAVEGACAO MARITIMA)"
    },
    {
      "codigo_valor_dominio": 2185,
      "codigo_referencia_valor_dominio": "322210",
      "nome_resumido_valor_dominio": "TECNICO DE ENFERMAGEM DE TERAPIA INTENSIVA",
      "nome_completo_valor_dominio": "TECNICO DE ENFERMAGEM DE TERAPIA INTENSIVA",
      "descricao_conceito_valor_dominio": "TECNICO DE ENFERMAGEM DE TERAPIA INTENSIVA"
    },
    {
      "codigo_valor_dominio": 2186,
      "codigo_referencia_valor_dominio": "322250",
      "nome_resumido_valor_dominio": "AUXILIAR DE ENFERMAGEM DA ESTRATEGIA DE SAUDE DA FAMILIA",
      "nome_completo_valor_dominio": "AUXILIAR DE ENFERMAGEM DA ESTRATEGIA DE SAUDE DA FAMILIA",
      "descricao_conceito_valor_dominio": "AUXILIAR DE ENFERMAGEM DA ESTRATEGIA DE SAUDE DA FAMILIA"
    },
    {
      "codigo_valor_dominio": 2187,
      "codigo_referencia_valor_dominio": "324205",
      "nome_resumido_valor_dominio": "TECNICO EM PATOLOGIA CLINICA",
      "nome_completo_valor_dominio": "TECNICO EM PATOLOGIA CLINICA",
      "descricao_conceito_valor_dominio": "TECNICO EM PATOLOGIA CLINICA"
    },
    {
      "codigo_valor_dominio": 2188,
      "codigo_referencia_valor_dominio": "322425",
      "nome_resumido_valor_dominio": "TECNICO EM SAUDE BUCAL DA ESTRATEGIA DE SAUDE DA FAMILIA",
      "nome_completo_valor_dominio": "TECNICO EM SAUDE BUCAL DA ESTRATEGIA DE SAUDE DA FAMILIA",
      "descricao_conceito_valor_dominio": "TECNICO EM SAUDE BUCAL DA ESTRATEGIA DE SAUDE DA FAMILIA"
    },
    {
      "codigo_valor_dominio": 2189,
      "codigo_referencia_valor_dominio": "251550",
      "nome_resumido_valor_dominio": "PSICANALISTA",
      "nome_completo_valor_dominio": "PSICANALISTA",
      "descricao_conceito_valor_dominio": "PSICANALISTA"
    },
    {
      "codigo_valor_dominio": 2190,
      "codigo_referencia_valor_dominio": "322415",
      "nome_resumido_valor_dominio": "AUXILIAR EM SAUDE BUCAL",
      "nome_completo_valor_dominio": "AUXILIAR EM SAUDE BUCAL",
      "descricao_conceito_valor_dominio": "AUXILIAR EM SAUDE BUCAL"
    },
    {
      "codigo_valor_dominio": 2191,
      "codigo_referencia_valor_dominio": "322420",
      "nome_resumido_valor_dominio": "AUXILIAR DE PROTESE DENTARIA",
      "nome_completo_valor_dominio": "AUXILIAR DE PROTESE DENTARIA",
      "descricao_conceito_valor_dominio": "AUXILIAR DE PROTESE DENTARIA"
    },
    {
      "codigo_valor_dominio": 2192,
      "codigo_referencia_valor_dominio": "351505",
      "nome_resumido_valor_dominio": "TECNICO EM SECRETARIADO",
      "nome_completo_valor_dominio": "TECNICO EM SECRETARIADO",
      "descricao_conceito_valor_dominio": "TECNICO EM SECRETARIADO"
    },
    {
      "codigo_valor_dominio": 2193,
      "codigo_referencia_valor_dominio": "322430",
      "nome_resumido_valor_dominio": "AUXILIAR EM SAUDE BUCAL DA ESTRATEGIA DE SAUDE DA FAMILIA",
      "nome_completo_valor_dominio": "AUXILIAR EM SAUDE BUCAL DA ESTRATEGIA DE SAUDE DA FAMILIA",
      "descricao_conceito_valor_dominio": "AUXILIAR EM SAUDE BUCAL DA ESTRATEGIA DE SAUDE DA FAMILIA"
    },
    {
      "codigo_valor_dominio": 2194,
      "codigo_referencia_valor_dominio": "391220",
      "nome_resumido_valor_dominio": "TECNICO DE PAINEL DE CONTROLE",
      "nome_completo_valor_dominio": "TECNICO DE PAINEL DE CONTROLE",
      "descricao_conceito_valor_dominio": "TECNICO DE PAINEL DE CONTROLE"
    },
    {
      "codigo_valor_dominio": 2195,
      "codigo_referencia_valor_dominio": "301110",
      "nome_resumido_valor_dominio": "TECNICO DE LABORATORIO DE ANALISES FISICO-QUIMICAS (MATERIAI",
      "nome_completo_valor_dominio": "TECNICO DE LABORATORIO DE ANALISES FISICO-QUIMICAS (MATERIAIS DE CONSTRUCAO)",
      "descricao_conceito_valor_dominio": "TECNICO DE LABORATORIO DE ANALISES FISICO-QUIMICAS (MATERIAIS DE CONSTRUCAO)"
    },
    {
      "codigo_valor_dominio": 2196,
      "codigo_referencia_valor_dominio": "316320",
      "nome_resumido_valor_dominio": "TECNICO EM PESQUISA MINERAL",
      "nome_completo_valor_dominio": "TECNICO EM PESQUISA MINERAL",
      "descricao_conceito_valor_dominio": "TECNICO EM PESQUISA MINERAL"
    },
    {
      "codigo_valor_dominio": 2197,
      "codigo_referencia_valor_dominio": "324110",
      "nome_resumido_valor_dominio": "TECNICO EM METODOS GRAFICOS EM CARDIOLOGIA",
      "nome_completo_valor_dominio": "TECNICO EM METODOS GRAFICOS EM CARDIOLOGIA",
      "descricao_conceito_valor_dominio": "TECNICO EM METODOS GRAFICOS EM CARDIOLOGIA"
    },
    {
      "codigo_valor_dominio": 2198,
      "codigo_referencia_valor_dominio": "321315",
      "nome_resumido_valor_dominio": "TECNICO EM MITILICULTURA",
      "nome_completo_valor_dominio": "TECNICO EM MITILICULTURA",
      "descricao_conceito_valor_dominio": "TECNICO EM MITILICULTURA"
    },
    {
      "codigo_valor_dominio": 2199,
      "codigo_referencia_valor_dominio": "321320",
      "nome_resumido_valor_dominio": "TECNICO EM RANICULTURA",
      "nome_completo_valor_dominio": "TECNICO EM RANICULTURA",
      "descricao_conceito_valor_dominio": "TECNICO EM RANICULTURA"
    },
    {
      "codigo_valor_dominio": 2200,
      "codigo_referencia_valor_dominio": "214750",
      "nome_resumido_valor_dominio": "TECNOLOGO EM ROCHAS ORNAMENTAIS",
      "nome_completo_valor_dominio": "TECNOLOGO EM ROCHAS ORNAMENTAIS",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM ROCHAS ORNAMENTAIS"
    },
    {
      "codigo_valor_dominio": 2201,
      "codigo_referencia_valor_dominio": "323105",
      "nome_resumido_valor_dominio": "TECNICO EM PECUARIA",
      "nome_completo_valor_dominio": "TECNICO EM PECUARIA",
      "descricao_conceito_valor_dominio": "TECNICO EM PECUARIA"
    },
    {
      "codigo_valor_dominio": 2202,
      "codigo_referencia_valor_dominio": "324210",
      "nome_resumido_valor_dominio": "AUXILIAR TECNICO EM PATOLOGIA CLINICA",
      "nome_completo_valor_dominio": "AUXILIAR TECNICO EM PATOLOGIA CLINICA",
      "descricao_conceito_valor_dominio": "AUXILIAR TECNICO EM PATOLOGIA CLINICA"
    },
    {
      "codigo_valor_dominio": 2203,
      "codigo_referencia_valor_dominio": "262825",
      "nome_resumido_valor_dominio": "ENSAIADOR DE DANCA",
      "nome_completo_valor_dominio": "ENSAIADOR DE DANCA",
      "descricao_conceito_valor_dominio": "ENSAIADOR DE DANCA"
    },
    {
      "codigo_valor_dominio": 2204,
      "codigo_referencia_valor_dominio": "325010",
      "nome_resumido_valor_dominio": "AROMISTA",
      "nome_completo_valor_dominio": "AROMISTA",
      "descricao_conceito_valor_dominio": "AROMISTA"
    },
    {
      "codigo_valor_dominio": 2205,
      "codigo_referencia_valor_dominio": "223570",
      "nome_resumido_valor_dominio": "PERFUSIONISTA",
      "nome_completo_valor_dominio": "PERFUSIONISTA",
      "descricao_conceito_valor_dominio": "PERFUSIONISTA"
    },
    {
      "codigo_valor_dominio": 2206,
      "codigo_referencia_valor_dominio": "325105",
      "nome_resumido_valor_dominio": "AUXILIAR TECNICO EM LABORATORIO DE FARMACIA",
      "nome_completo_valor_dominio": "AUXILIAR TECNICO EM LABORATORIO DE FARMACIA",
      "descricao_conceito_valor_dominio": "AUXILIAR TECNICO EM LABORATORIO DE FARMACIA"
    },
    {
      "codigo_valor_dominio": 2207,
      "codigo_referencia_valor_dominio": "321205",
      "nome_resumido_valor_dominio": "TECNICO EM MADEIRA",
      "nome_completo_valor_dominio": "TECNICO EM MADEIRA",
      "descricao_conceito_valor_dominio": "TECNICO EM MADEIRA"
    },
    {
      "codigo_valor_dominio": 2208,
      "codigo_referencia_valor_dominio": "313505",
      "nome_resumido_valor_dominio": "TECNICO EM FOTONICA",
      "nome_completo_valor_dominio": "TECNICO EM FOTONICA",
      "descricao_conceito_valor_dominio": "TECNICO EM FOTONICA"
    },
    {
      "codigo_valor_dominio": 2209,
      "codigo_referencia_valor_dominio": "301205",
      "nome_resumido_valor_dominio": "TECNICO DE APOIO A BIOENGENHARIA",
      "nome_completo_valor_dominio": "TECNICO DE APOIO A BIOENGENHARIA",
      "descricao_conceito_valor_dominio": "TECNICO DE APOIO A BIOENGENHARIA"
    },
    {
      "codigo_valor_dominio": 2210,
      "codigo_referencia_valor_dominio": "373210",
      "nome_resumido_valor_dominio": "TECNICO EM OPERACAO DE EQUIPAMENTO DE EXIBICAO DE TELEVISAO",
      "nome_completo_valor_dominio": "TECNICO EM OPERACAO DE EQUIPAMENTO DE EXIBICAO DE TELEVISAO",
      "descricao_conceito_valor_dominio": "TECNICO EM OPERACAO DE EQUIPAMENTO DE EXIBICAO DE TELEVISAO"
    },
    {
      "codigo_valor_dominio": 2211,
      "codigo_referencia_valor_dominio": "320105",
      "nome_resumido_valor_dominio": "TECNICO EM BIOTERISMO",
      "nome_completo_valor_dominio": "TECNICO EM BIOTERISMO",
      "descricao_conceito_valor_dominio": "TECNICO EM BIOTERISMO"
    },
    {
      "codigo_valor_dominio": 2212,
      "codigo_referencia_valor_dominio": "374110",
      "nome_resumido_valor_dominio": "TECNICO EM INSTALACAO DE EQUIPAMENTOS DE AUDIO",
      "nome_completo_valor_dominio": "TECNICO EM INSTALACAO DE EQUIPAMENTOS DE AUDIO",
      "descricao_conceito_valor_dominio": "TECNICO EM INSTALACAO DE EQUIPAMENTOS DE AUDIO"
    },
    {
      "codigo_valor_dominio": 2213,
      "codigo_referencia_valor_dominio": "732110",
      "nome_resumido_valor_dominio": "EMENDADOR DE CABOS ELETRICOS E TELEFONICOS (AEREOS E SUBTERR",
      "nome_completo_valor_dominio": "EMENDADOR DE CABOS ELETRICOS E TELEFONICOS (AEREOS E SUBTERRANEOS)",
      "descricao_conceito_valor_dominio": "EMENDADOR DE CABOS ELETRICOS E TELEFONICOS (AEREOS E SUBTERRANEOS)"
    },
    {
      "codigo_valor_dominio": 2214,
      "codigo_referencia_valor_dominio": "761303",
      "nome_resumido_valor_dominio": "TECELAO (REDES)",
      "nome_completo_valor_dominio": "TECELAO (REDES)",
      "descricao_conceito_valor_dominio": "TECELAO (REDES)"
    },
    {
      "codigo_valor_dominio": 2215,
      "codigo_referencia_valor_dominio": "331205",
      "nome_resumido_valor_dominio": "PROFESSOR DE NIVEL MEDIO NO ENSINO FUNDAMENTAL",
      "nome_completo_valor_dominio": "PROFESSOR DE NIVEL MEDIO NO ENSINO FUNDAMENTAL",
      "descricao_conceito_valor_dominio": "PROFESSOR DE NIVEL MEDIO NO ENSINO FUNDAMENTAL"
    },
    {
      "codigo_valor_dominio": 2216,
      "codigo_referencia_valor_dominio": "331110",
      "nome_resumido_valor_dominio": "AUXILIAR DE DESENVOLVIMENTO INFANTIL",
      "nome_completo_valor_dominio": "AUXILIAR DE DESENVOLVIMENTO INFANTIL",
      "descricao_conceito_valor_dominio": "AUXILIAR DE DESENVOLVIMENTO INFANTIL"
    },
    {
      "codigo_valor_dominio": 2217,
      "codigo_referencia_valor_dominio": "331305",
      "nome_resumido_valor_dominio": "PROFESSOR DE NIVEL MEDIO NO ENSINO PROFISSIONALIZANTE",
      "nome_completo_valor_dominio": "PROFESSOR DE NIVEL MEDIO NO ENSINO PROFISSIONALIZANTE",
      "descricao_conceito_valor_dominio": "PROFESSOR DE NIVEL MEDIO NO ENSINO PROFISSIONALIZANTE"
    },
    {
      "codigo_valor_dominio": 2218,
      "codigo_referencia_valor_dominio": "231210",
      "nome_resumido_valor_dominio": "PROFESSOR DE NIVEL SUPERIOR DO ENSINO FUNDAMENTAL (PRIMEIRA",
      "nome_completo_valor_dominio": "PROFESSOR DE NIVEL SUPERIOR DO ENSINO FUNDAMENTAL (PRIMEIRA A QUARTA SERIE)",
      "descricao_conceito_valor_dominio": "PROFESSOR DE NIVEL SUPERIOR DO ENSINO FUNDAMENTAL (PRIMEIRA A QUARTA SERIE)"
    },
    {
      "codigo_valor_dominio": 2219,
      "codigo_referencia_valor_dominio": "332205",
      "nome_resumido_valor_dominio": "PROFESSOR PRATICO NO ENSINO PROFISSIONALIZANTE",
      "nome_completo_valor_dominio": "PROFESSOR PRATICO NO ENSINO PROFISSIONALIZANTE",
      "descricao_conceito_valor_dominio": "PROFESSOR PRATICO NO ENSINO PROFISSIONALIZANTE"
    },
    {
      "codigo_valor_dominio": 2220,
      "codigo_referencia_valor_dominio": "333115",
      "nome_resumido_valor_dominio": "PROFESSORES DE CURSOS LIVRES",
      "nome_completo_valor_dominio": "PROFESSORES DE CURSOS LIVRES",
      "descricao_conceito_valor_dominio": "PROFESSORES DE CURSOS LIVRES"
    },
    {
      "codigo_valor_dominio": 2221,
      "codigo_referencia_valor_dominio": "333110",
      "nome_resumido_valor_dominio": "INSTRUTOR DE CURSOS LIVRES",
      "nome_completo_valor_dominio": "INSTRUTOR DE CURSOS LIVRES",
      "descricao_conceito_valor_dominio": "INSTRUTOR DE CURSOS LIVRES"
    },
    {
      "codigo_valor_dominio": 2222,
      "codigo_referencia_valor_dominio": "215315",
      "nome_resumido_valor_dominio": "INSTRUTOR DE VOO",
      "nome_completo_valor_dominio": "INSTRUTOR DE VOO",
      "descricao_conceito_valor_dominio": "INSTRUTOR DE VOO"
    },
    {
      "codigo_valor_dominio": 2223,
      "codigo_referencia_valor_dominio": "377140",
      "nome_resumido_valor_dominio": "PROFISSIONAL DE ATLETISMO",
      "nome_completo_valor_dominio": "PROFISSIONAL DE ATLETISMO",
      "descricao_conceito_valor_dominio": "PROFISSIONAL DE ATLETISMO"
    },
    {
      "codigo_valor_dominio": 2224,
      "codigo_referencia_valor_dominio": "334110",
      "nome_resumido_valor_dominio": "INSPETOR DE ALUNOS DE ESCOLA PUBLICA",
      "nome_completo_valor_dominio": "INSPETOR DE ALUNOS DE ESCOLA PUBLICA",
      "descricao_conceito_valor_dominio": "INSPETOR DE ALUNOS DE ESCOLA PUBLICA"
    },
    {
      "codigo_valor_dominio": 2225,
      "codigo_referencia_valor_dominio": "342530",
      "nome_resumido_valor_dominio": "INSPETOR DE AVIACAO CIVIL",
      "nome_completo_valor_dominio": "INSPETOR DE AVIACAO CIVIL",
      "descricao_conceito_valor_dominio": "INSPETOR DE AVIACAO CIVIL"
    },
    {
      "codigo_valor_dominio": 2226,
      "codigo_referencia_valor_dominio": "768615",
      "nome_resumido_valor_dominio": "MONOTIPISTA",
      "nome_completo_valor_dominio": "MONOTIPISTA",
      "descricao_conceito_valor_dominio": "MONOTIPISTA"
    },
    {
      "codigo_valor_dominio": 2227,
      "codigo_referencia_valor_dominio": "341110",
      "nome_resumido_valor_dominio": "PILOTO COMERCIAL DE HELICOPTERO (EXCETO LINHAS AEREAS)",
      "nome_completo_valor_dominio": "PILOTO COMERCIAL DE HELICOPTERO (EXCETO LINHAS AEREAS)",
      "descricao_conceito_valor_dominio": "PILOTO COMERCIAL DE HELICOPTERO (EXCETO LINHAS AEREAS)"
    },
    {
      "codigo_valor_dominio": 2228,
      "codigo_referencia_valor_dominio": "215305",
      "nome_resumido_valor_dominio": "PILOTO DE AERONAVES",
      "nome_completo_valor_dominio": "PILOTO DE AERONAVES",
      "descricao_conceito_valor_dominio": "PILOTO DE AERONAVES"
    },
    {
      "codigo_valor_dominio": 2229,
      "codigo_referencia_valor_dominio": "725405",
      "nome_resumido_valor_dominio": "MECANICO MONTADOR DE MOTORES DE AERONAVES",
      "nome_completo_valor_dominio": "MECANICO MONTADOR DE MOTORES DE AERONAVES",
      "descricao_conceito_valor_dominio": "MECANICO MONTADOR DE MOTORES DE AERONAVES"
    },
    {
      "codigo_valor_dominio": 2230,
      "codigo_referencia_valor_dominio": "341105",
      "nome_resumido_valor_dominio": "PILOTO COMERCIAL (EXCETO LINHAS AEREAS)",
      "nome_completo_valor_dominio": "PILOTO COMERCIAL (EXCETO LINHAS AEREAS)",
      "descricao_conceito_valor_dominio": "PILOTO COMERCIAL (EXCETO LINHAS AEREAS)"
    },
    {
      "codigo_valor_dominio": 2231,
      "codigo_referencia_valor_dominio": "760110",
      "nome_resumido_valor_dominio": "CONTRAMESTRE DE FIACAO (INDUSTRIA TEXTIL)",
      "nome_completo_valor_dominio": "CONTRAMESTRE DE FIACAO (INDUSTRIA TEXTIL)",
      "descricao_conceito_valor_dominio": "CONTRAMESTRE DE FIACAO (INDUSTRIA TEXTIL)"
    },
    {
      "codigo_valor_dominio": 2232,
      "codigo_referencia_valor_dominio": "720110",
      "nome_resumido_valor_dominio": "MESTRE DE CALDEIRARIA",
      "nome_completo_valor_dominio": "MESTRE DE CALDEIRARIA",
      "descricao_conceito_valor_dominio": "MESTRE DE CALDEIRARIA"
    },
    {
      "codigo_valor_dominio": 2233,
      "codigo_referencia_valor_dominio": "720155",
      "nome_resumido_valor_dominio": "MESTRE SERRALHEIRO",
      "nome_completo_valor_dominio": "MESTRE SERRALHEIRO",
      "descricao_conceito_valor_dominio": "MESTRE SERRALHEIRO"
    },
    {
      "codigo_valor_dominio": 2234,
      "codigo_referencia_valor_dominio": "341225",
      "nome_resumido_valor_dominio": "PATRAO DE PESCA NA NAVEGACAO INTERIOR",
      "nome_completo_valor_dominio": "PATRAO DE PESCA NA NAVEGACAO INTERIOR",
      "descricao_conceito_valor_dominio": "PATRAO DE PESCA NA NAVEGACAO INTERIOR"
    },
    {
      "codigo_valor_dominio": 2235,
      "codigo_referencia_valor_dominio": "239415",
      "nome_resumido_valor_dominio": "PEDAGOGO",
      "nome_completo_valor_dominio": "PEDAGOGO",
      "descricao_conceito_valor_dominio": "PEDAGOGO"
    },
    {
      "codigo_valor_dominio": 2236,
      "codigo_referencia_valor_dominio": "723310",
      "nome_resumido_valor_dominio": "PINTOR A PINCEL E ROLO (EXCETO OBRAS E ESTRUTURAS METALICAS)",
      "nome_completo_valor_dominio": "PINTOR A PINCEL E ROLO (EXCETO OBRAS E ESTRUTURAS METALICAS)",
      "descricao_conceito_valor_dominio": "PINTOR A PINCEL E ROLO (EXCETO OBRAS E ESTRUTURAS METALICAS)"
    },
    {
      "codigo_valor_dominio": 2237,
      "codigo_referencia_valor_dominio": "341305",
      "nome_resumido_valor_dominio": "CONDUTOR MAQUINISTA FLUVIAL",
      "nome_completo_valor_dominio": "CONDUTOR MAQUINISTA FLUVIAL",
      "descricao_conceito_valor_dominio": "CONDUTOR MAQUINISTA FLUVIAL"
    },
    {
      "codigo_valor_dominio": 2238,
      "codigo_referencia_valor_dominio": "341310",
      "nome_resumido_valor_dominio": "CONDUTOR MAQUINISTA MARITIMO",
      "nome_completo_valor_dominio": "CONDUTOR MAQUINISTA MARITIMO",
      "descricao_conceito_valor_dominio": "CONDUTOR MAQUINISTA MARITIMO"
    },
    {
      "codigo_valor_dominio": 2239,
      "codigo_referencia_valor_dominio": "715615",
      "nome_resumido_valor_dominio": "ELETRICISTA DE INSTALACOES",
      "nome_completo_valor_dominio": "ELETRICISTA DE INSTALACOES",
      "descricao_conceito_valor_dominio": "ELETRICISTA DE INSTALACOES"
    },
    {
      "codigo_valor_dominio": 2240,
      "codigo_referencia_valor_dominio": "342105",
      "nome_resumido_valor_dominio": "ANALISTA DE TRANSPORTE EM COMERCIO EXTERIOR",
      "nome_completo_valor_dominio": "ANALISTA DE TRANSPORTE EM COMERCIO EXTERIOR",
      "descricao_conceito_valor_dominio": "ANALISTA DE TRANSPORTE EM COMERCIO EXTERIOR"
    },
    {
      "codigo_valor_dominio": 2241,
      "codigo_referencia_valor_dominio": "841320",
      "nome_resumido_valor_dominio": "OPERADOR DE TRATAMENTO DE CALDA NA REFINACAO DE ACUCAR",
      "nome_completo_valor_dominio": "OPERADOR DE TRATAMENTO DE CALDA NA REFINACAO DE ACUCAR",
      "descricao_conceito_valor_dominio": "OPERADOR DE TRATAMENTO DE CALDA NA REFINACAO DE ACUCAR"
    },
    {
      "codigo_valor_dominio": 2242,
      "codigo_referencia_valor_dominio": "342505",
      "nome_resumido_valor_dominio": "CONTROLADOR DE TRAFEGO AEREO",
      "nome_completo_valor_dominio": "CONTROLADOR DE TRAFEGO AEREO",
      "descricao_conceito_valor_dominio": "CONTROLADOR DE TRAFEGO AEREO"
    },
    {
      "codigo_valor_dominio": 2243,
      "codigo_referencia_valor_dominio": "342120",
      "nome_resumido_valor_dominio": "AFRETADOR",
      "nome_completo_valor_dominio": "AFRETADOR",
      "descricao_conceito_valor_dominio": "AFRETADOR"
    },
    {
      "codigo_valor_dominio": 2244,
      "codigo_referencia_valor_dominio": "214010",
      "nome_resumido_valor_dominio": "TECNOLOGO EM MEIO AMBIENTE",
      "nome_completo_valor_dominio": "TECNOLOGO EM MEIO AMBIENTE",
      "descricao_conceito_valor_dominio": "TECNOLOGO EM MEIO AMBIENTE"
    },
    {
      "codigo_valor_dominio": 2245,
      "codigo_referencia_valor_dominio": "342205",
      "nome_resumido_valor_dominio": "AJUDANTE DE DESPACHANTE ADUANEIRO",
      "nome_completo_valor_dominio": "AJUDANTE DE DESPACHANTE ADUANEIRO",
      "descricao_conceito_valor_dominio": "AJUDANTE DE DESPACHANTE ADUANEIRO"
    },
    {
      "codigo_valor_dominio": 2246,
      "codigo_referencia_valor_dominio": "423110",
      "nome_resumido_valor_dominio": "DESPACHANTE DE TRANSITO",
      "nome_completo_valor_dominio": "DESPACHANTE DE TRANSITO",
      "descricao_conceito_valor_dominio": "DESPACHANTE DE TRANSITO"
    },
    {
      "codigo_valor_dominio": 2247,
      "codigo_referencia_valor_dominio": "342305",
      "nome_resumido_valor_dominio": "CHEFE DE SERVICO DE TRANSPORTE RODOVIARIO (PASSAGEIROS E CAR",
      "nome_completo_valor_dominio": "CHEFE DE SERVICO DE TRANSPORTE RODOVIARIO (PASSAGEIROS E CARGAS)",
      "descricao_conceito_valor_dominio": "CHEFE DE SERVICO DE TRANSPORTE RODOVIARIO (PASSAGEIROS E CARGAS)"
    },
    {
      "codigo_valor_dominio": 2248,
      "codigo_referencia_valor_dominio": "351730",
      "nome_resumido_valor_dominio": "INSPETOR DE SINISTROS",
      "nome_completo_valor_dominio": "INSPETOR DE SINISTROS",
      "descricao_conceito_valor_dominio": "INSPETOR DE SINISTROS"
    },
    {
      "codigo_valor_dominio": 2249,
      "codigo_referencia_valor_dominio": "420110",
      "nome_resumido_valor_dominio": "SUPERVISOR DE COBRANCA",
      "nome_completo_valor_dominio": "SUPERVISOR DE COBRANCA",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE COBRANCA"
    },
    {
      "codigo_valor_dominio": 2250,
      "codigo_referencia_valor_dominio": "342405",
      "nome_resumido_valor_dominio": "AGENTE DE ESTACAO (FERROVIA E METRO)",
      "nome_completo_valor_dominio": "AGENTE DE ESTACAO (FERROVIA E METRO)",
      "descricao_conceito_valor_dominio": "AGENTE DE ESTACAO (FERROVIA E METRO)"
    },
    {
      "codigo_valor_dominio": 2251,
      "codigo_referencia_valor_dominio": "721405",
      "nome_resumido_valor_dominio": "OPERADOR DE CENTRO DE USINAGEM COM COMANDO NUMERICO",
      "nome_completo_valor_dominio": "OPERADOR DE CENTRO DE USINAGEM COM COMANDO NUMERICO",
      "descricao_conceito_valor_dominio": "OPERADOR DE CENTRO DE USINAGEM COM COMANDO NUMERICO"
    },
    {
      "codigo_valor_dominio": 2252,
      "codigo_referencia_valor_dominio": "215120",
      "nome_resumido_valor_dominio": "COORDENADOR DE OPERACOES DE COMBATE A POLUICAO NO MEIO AQUAV",
      "nome_completo_valor_dominio": "COORDENADOR DE OPERACOES DE COMBATE A POLUICAO NO MEIO AQUAVIARIO",
      "descricao_conceito_valor_dominio": "COORDENADOR DE OPERACOES DE COMBATE A POLUICAO NO MEIO AQUAVIARIO"
    },
    {
      "codigo_valor_dominio": 2253,
      "codigo_referencia_valor_dominio": "841735",
      "nome_resumido_valor_dominio": "DESSECADOR DE MALTE",
      "nome_completo_valor_dominio": "DESSECADOR DE MALTE",
      "descricao_conceito_valor_dominio": "DESSECADOR DE MALTE"
    },
    {
      "codigo_valor_dominio": 2254,
      "codigo_referencia_valor_dominio": "710225",
      "nome_resumido_valor_dominio": "FISCAL DE PATIO DE USINA DE CONCRETO",
      "nome_completo_valor_dominio": "FISCAL DE PATIO DE USINA DE CONCRETO",
      "descricao_conceito_valor_dominio": "FISCAL DE PATIO DE USINA DE CONCRETO"
    },
    {
      "codigo_valor_dominio": 2255,
      "codigo_referencia_valor_dominio": "141710",
      "nome_resumido_valor_dominio": "GERENTE DE AGENCIA",
      "nome_completo_valor_dominio": "GERENTE DE AGENCIA",
      "descricao_conceito_valor_dominio": "GERENTE DE AGENCIA"
    },
    {
      "codigo_valor_dominio": 2256,
      "codigo_referencia_valor_dominio": "253220",
      "nome_resumido_valor_dominio": "GERENTE DE GRANDES CONTAS (CORPORATE)",
      "nome_completo_valor_dominio": "GERENTE DE GRANDES CONTAS (CORPORATE)",
      "descricao_conceito_valor_dominio": "GERENTE DE GRANDES CONTAS (CORPORATE)"
    },
    {
      "codigo_valor_dominio": 2257,
      "codigo_referencia_valor_dominio": "761805",
      "nome_resumido_valor_dominio": "INSPETOR DE ESTAMPARIA (PRODUCAO TEXTIL)",
      "nome_completo_valor_dominio": "INSPETOR DE ESTAMPARIA (PRODUCAO TEXTIL)",
      "descricao_conceito_valor_dominio": "INSPETOR DE ESTAMPARIA (PRODUCAO TEXTIL)"
    },
    {
      "codigo_valor_dominio": 2258,
      "codigo_referencia_valor_dominio": "823135",
      "nome_resumido_valor_dominio": "OPERADOR DE ATOMIZADOR",
      "nome_completo_valor_dominio": "OPERADOR DE ATOMIZADOR",
      "descricao_conceito_valor_dominio": "OPERADOR DE ATOMIZADOR"
    },
    {
      "codigo_valor_dominio": 2259,
      "codigo_referencia_valor_dominio": "630105",
      "nome_resumido_valor_dominio": "SUPERVISOR DA AQUICULTURA",
      "nome_completo_valor_dominio": "SUPERVISOR DA AQUICULTURA",
      "descricao_conceito_valor_dominio": "SUPERVISOR DA AQUICULTURA"
    },
    {
      "codigo_valor_dominio": 2260,
      "codigo_referencia_valor_dominio": "239430",
      "nome_resumido_valor_dominio": "SUPERVISOR DE ENSINO",
      "nome_completo_valor_dominio": "SUPERVISOR DE ENSINO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE ENSINO"
    },
    {
      "codigo_valor_dominio": 2261,
      "codigo_referencia_valor_dominio": "342605",
      "nome_resumido_valor_dominio": "CHEFE DE ESTACAO PORTUARIA",
      "nome_completo_valor_dominio": "CHEFE DE ESTACAO PORTUARIA",
      "descricao_conceito_valor_dominio": "CHEFE DE ESTACAO PORTUARIA"
    },
    {
      "codigo_valor_dominio": 2262,
      "codigo_referencia_valor_dominio": "410230",
      "nome_resumido_valor_dominio": "SUPERVISOR DE ORCAMENTO",
      "nome_completo_valor_dominio": "SUPERVISOR DE ORCAMENTO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE ORCAMENTO"
    },
    {
      "codigo_valor_dominio": 2263,
      "codigo_referencia_valor_dominio": "311505",
      "nome_resumido_valor_dominio": "TECNICO DE CONTROLE DE MEIO AMBIENTE",
      "nome_completo_valor_dominio": "TECNICO DE CONTROLE DE MEIO AMBIENTE",
      "descricao_conceito_valor_dominio": "TECNICO DE CONTROLE DE MEIO AMBIENTE"
    },
    {
      "codigo_valor_dominio": 2264,
      "codigo_referencia_valor_dominio": "351110",
      "nome_resumido_valor_dominio": "CHEFE DE CONTABILIDADE (TECNICO)",
      "nome_completo_valor_dominio": "CHEFE DE CONTABILIDADE (TECNICO)",
      "descricao_conceito_valor_dominio": "CHEFE DE CONTABILIDADE (TECNICO)"
    },
    {
      "codigo_valor_dominio": 2265,
      "codigo_referencia_valor_dominio": "241040",
      "nome_resumido_valor_dominio": "CONSULTOR JURIDICO",
      "nome_completo_valor_dominio": "CONSULTOR JURIDICO",
      "descricao_conceito_valor_dominio": "CONSULTOR JURIDICO"
    },
    {
      "codigo_valor_dominio": 2266,
      "codigo_referencia_valor_dominio": "351310",
      "nome_resumido_valor_dominio": "TECNICO EM ADMINISTRACAO DE COMERCIO EXTERIOR",
      "nome_completo_valor_dominio": "TECNICO EM ADMINISTRACAO DE COMERCIO EXTERIOR",
      "descricao_conceito_valor_dominio": "TECNICO EM ADMINISTRACAO DE COMERCIO EXTERIOR"
    },
    {
      "codigo_valor_dominio": 2267,
      "codigo_referencia_valor_dominio": "312305",
      "nome_resumido_valor_dominio": "TECNICO EM AGRIMENSURA",
      "nome_completo_valor_dominio": "TECNICO EM AGRIMENSURA",
      "descricao_conceito_valor_dominio": "TECNICO EM AGRIMENSURA"
    },
    {
      "codigo_valor_dominio": 2268,
      "codigo_referencia_valor_dominio": "351315",
      "nome_resumido_valor_dominio": "AGENTE DE RECRUTAMENTO E SELECAO",
      "nome_completo_valor_dominio": "AGENTE DE RECRUTAMENTO E SELECAO",
      "descricao_conceito_valor_dominio": "AGENTE DE RECRUTAMENTO E SELECAO"
    },
    {
      "codigo_valor_dominio": 2269,
      "codigo_referencia_valor_dominio": "261515",
      "nome_resumido_valor_dominio": "ESCRITOR DE FICCAO",
      "nome_completo_valor_dominio": "ESCRITOR DE FICCAO",
      "descricao_conceito_valor_dominio": "ESCRITOR DE FICCAO"
    },
    {
      "codigo_valor_dominio": 2270,
      "codigo_referencia_valor_dominio": "516805",
      "nome_resumido_valor_dominio": "ESOTERICO",
      "nome_completo_valor_dominio": "ESOTERICO",
      "descricao_conceito_valor_dominio": "ESOTERICO"
    },
    {
      "codigo_valor_dominio": 2271,
      "codigo_referencia_valor_dominio": "351410",
      "nome_resumido_valor_dominio": "ESCRIVAO JUDICIAL",
      "nome_completo_valor_dominio": "ESCRIVAO JUDICIAL",
      "descricao_conceito_valor_dominio": "ESCRIVAO JUDICIAL"
    },
    {
      "codigo_valor_dominio": 2272,
      "codigo_referencia_valor_dominio": "351415",
      "nome_resumido_valor_dominio": "ESCRIVAO EXTRA - JUDICIAL",
      "nome_completo_valor_dominio": "ESCRIVAO EXTRA - JUDICIAL",
      "descricao_conceito_valor_dominio": "ESCRIVAO EXTRA - JUDICIAL"
    },
    {
      "codigo_valor_dominio": 2273,
      "codigo_referencia_valor_dominio": "215140",
      "nome_resumido_valor_dominio": "OFICIAL DE QUARTO DE NAVEGACAO DA MARINHA MERCANTE",
      "nome_completo_valor_dominio": "OFICIAL DE QUARTO DE NAVEGACAO DA MARINHA MERCANTE",
      "descricao_conceito_valor_dominio": "OFICIAL DE QUARTO DE NAVEGACAO DA MARINHA MERCANTE"
    },
    {
      "codigo_valor_dominio": 2274,
      "codigo_referencia_valor_dominio": "351430",
      "nome_resumido_valor_dominio": "AUXILIAR DE SERVICOS JURIDICOS",
      "nome_completo_valor_dominio": "AUXILIAR DE SERVICOS JURIDICOS",
      "descricao_conceito_valor_dominio": "AUXILIAR DE SERVICOS JURIDICOS"
    },
    {
      "codigo_valor_dominio": 2275,
      "codigo_referencia_valor_dominio": "351605",
      "nome_resumido_valor_dominio": "TECNICO EM SEGURANCA NO TRABALHO",
      "nome_completo_valor_dominio": "TECNICO EM SEGURANCA NO TRABALHO",
      "descricao_conceito_valor_dominio": "TECNICO EM SEGURANCA NO TRABALHO"
    },
    {
      "codigo_valor_dominio": 2276,
      "codigo_referencia_valor_dominio": "328110",
      "nome_resumido_valor_dominio": "TAXIDERMISTA",
      "nome_completo_valor_dominio": "TAXIDERMISTA",
      "descricao_conceito_valor_dominio": "TAXIDERMISTA"
    },
    {
      "codigo_valor_dominio": 2277,
      "codigo_referencia_valor_dominio": "841440",
      "nome_resumido_valor_dominio": "ESTERILIZADOR DE ALIMENTOS",
      "nome_completo_valor_dominio": "ESTERILIZADOR DE ALIMENTOS",
      "descricao_conceito_valor_dominio": "ESTERILIZADOR DE ALIMENTOS"
    },
    {
      "codigo_valor_dominio": 2278,
      "codigo_referencia_valor_dominio": "314620",
      "nome_resumido_valor_dominio": "TECNICO EM SOLDAGEM",
      "nome_completo_valor_dominio": "TECNICO EM SOLDAGEM",
      "descricao_conceito_valor_dominio": "TECNICO EM SOLDAGEM"
    },
    {
      "codigo_valor_dominio": 2279,
      "codigo_referencia_valor_dominio": "351705",
      "nome_resumido_valor_dominio": "ANALISTA DE SEGUROS (TECNICO)",
      "nome_completo_valor_dominio": "ANALISTA DE SEGUROS (TECNICO)",
      "descricao_conceito_valor_dominio": "ANALISTA DE SEGUROS (TECNICO)"
    },
    {
      "codigo_valor_dominio": 2280,
      "codigo_referencia_valor_dominio": "351710",
      "nome_resumido_valor_dominio": "ANALISTA DE SINISTROS",
      "nome_completo_valor_dominio": "ANALISTA DE SINISTROS",
      "descricao_conceito_valor_dominio": "ANALISTA DE SINISTROS"
    },
    {
      "codigo_valor_dominio": 2281,
      "codigo_referencia_valor_dominio": "351715",
      "nome_resumido_valor_dominio": "ASSISTENTE COMERCIAL DE SEGUROS",
      "nome_completo_valor_dominio": "ASSISTENTE COMERCIAL DE SEGUROS",
      "descricao_conceito_valor_dominio": "ASSISTENTE COMERCIAL DE SEGUROS"
    },
    {
      "codigo_valor_dominio": 2282,
      "codigo_referencia_valor_dominio": "351720",
      "nome_resumido_valor_dominio": "ASSISTENTE TECNICO DE SEGUROS",
      "nome_completo_valor_dominio": "ASSISTENTE TECNICO DE SEGUROS",
      "descricao_conceito_valor_dominio": "ASSISTENTE TECNICO DE SEGUROS"
    },
    {
      "codigo_valor_dominio": 2283,
      "codigo_referencia_valor_dominio": "342310",
      "nome_resumido_valor_dominio": "INSPETOR DE SERVICOS DE TRANSPORTES RODOVIARIOS (PASSAGEIROS",
      "nome_completo_valor_dominio": "INSPETOR DE SERVICOS DE TRANSPORTES RODOVIARIOS (PASSAGEIROS E CARGAS)",
      "descricao_conceito_valor_dominio": "INSPETOR DE SERVICOS DE TRANSPORTES RODOVIARIOS (PASSAGEIROS E CARGAS)"
    },
    {
      "codigo_valor_dominio": 2284,
      "codigo_referencia_valor_dominio": "314605",
      "nome_resumido_valor_dominio": "INSPETOR DE SOLDAGEM",
      "nome_completo_valor_dominio": "INSPETOR DE SOLDAGEM",
      "descricao_conceito_valor_dominio": "INSPETOR DE SOLDAGEM"
    },
    {
      "codigo_valor_dominio": 2285,
      "codigo_referencia_valor_dominio": "312210",
      "nome_resumido_valor_dominio": "TECNICO DE SANEAMENTO",
      "nome_completo_valor_dominio": "TECNICO DE SANEAMENTO",
      "descricao_conceito_valor_dominio": "TECNICO DE SANEAMENTO"
    },
    {
      "codigo_valor_dominio": 2286,
      "codigo_referencia_valor_dominio": "313315",
      "nome_resumido_valor_dominio": "TECNICO DE TELECOMUNICACOES (TELEFONIA)",
      "nome_completo_valor_dominio": "TECNICO DE TELECOMUNICACOES (TELEFONIA)",
      "descricao_conceito_valor_dominio": "TECNICO DE TELECOMUNICACOES (TELEFONIA)"
    },
    {
      "codigo_valor_dominio": 2287,
      "codigo_referencia_valor_dominio": "711120",
      "nome_resumido_valor_dominio": "DETONADOR",
      "nome_completo_valor_dominio": "DETONADOR",
      "descricao_conceito_valor_dominio": "DETONADOR"
    },
    {
      "codigo_valor_dominio": 2288,
      "codigo_referencia_valor_dominio": "622010",
      "nome_resumido_valor_dominio": "JARDINEIRO",
      "nome_completo_valor_dominio": "JARDINEIRO",
      "descricao_conceito_valor_dominio": "JARDINEIRO"
    },
    {
      "codigo_valor_dominio": 2289,
      "codigo_referencia_valor_dominio": "516810",
      "nome_resumido_valor_dominio": "PARANORMAL",
      "nome_completo_valor_dominio": "PARANORMAL",
      "descricao_conceito_valor_dominio": "PARANORMAL"
    },
    {
      "codigo_valor_dominio": 2290,
      "codigo_referencia_valor_dominio": "351905",
      "nome_resumido_valor_dominio": "AGENTE DE INTELIGENCIA",
      "nome_completo_valor_dominio": "AGENTE DE INTELIGENCIA",
      "descricao_conceito_valor_dominio": "AGENTE DE INTELIGENCIA"
    },
    {
      "codigo_valor_dominio": 2291,
      "codigo_referencia_valor_dominio": "351910",
      "nome_resumido_valor_dominio": "AGENTE TECNICO DE INTELIGENCIA",
      "nome_completo_valor_dominio": "AGENTE TECNICO DE INTELIGENCIA",
      "descricao_conceito_valor_dominio": "AGENTE TECNICO DE INTELIGENCIA"
    },
    {
      "codigo_valor_dominio": 2292,
      "codigo_referencia_valor_dominio": "352205",
      "nome_resumido_valor_dominio": "AGENTE DE DEFESA AMBIENTAL",
      "nome_completo_valor_dominio": "AGENTE DE DEFESA AMBIENTAL",
      "descricao_conceito_valor_dominio": "AGENTE DE DEFESA AMBIENTAL"
    },
    {
      "codigo_valor_dominio": 2293,
      "codigo_referencia_valor_dominio": "352210",
      "nome_resumido_valor_dominio": "AGENTE DE SAUDE PUBLICA",
      "nome_completo_valor_dominio": "AGENTE DE SAUDE PUBLICA",
      "descricao_conceito_valor_dominio": "AGENTE DE SAUDE PUBLICA"
    },
    {
      "codigo_valor_dominio": 2294,
      "codigo_referencia_valor_dominio": "374140",
      "nome_resumido_valor_dominio": "MICROFONISTA",
      "nome_completo_valor_dominio": "MICROFONISTA",
      "descricao_conceito_valor_dominio": "MICROFONISTA"
    },
    {
      "codigo_valor_dominio": 2295,
      "codigo_referencia_valor_dominio": "352310",
      "nome_resumido_valor_dominio": "AGENTE FISCAL DE QUALIDADE",
      "nome_completo_valor_dominio": "AGENTE FISCAL DE QUALIDADE",
      "descricao_conceito_valor_dominio": "AGENTE FISCAL DE QUALIDADE"
    },
    {
      "codigo_valor_dominio": 2296,
      "codigo_referencia_valor_dominio": "352315",
      "nome_resumido_valor_dominio": "AGENTE FISCAL METROLOGICO",
      "nome_completo_valor_dominio": "AGENTE FISCAL METROLOGICO",
      "descricao_conceito_valor_dominio": "AGENTE FISCAL METROLOGICO"
    },
    {
      "codigo_valor_dominio": 2297,
      "codigo_referencia_valor_dominio": "352320",
      "nome_resumido_valor_dominio": "AGENTE FISCAL TEXTIL",
      "nome_completo_valor_dominio": "AGENTE FISCAL TEXTIL",
      "descricao_conceito_valor_dominio": "AGENTE FISCAL TEXTIL"
    },
    {
      "codigo_valor_dominio": 2298,
      "codigo_referencia_valor_dominio": "352405",
      "nome_resumido_valor_dominio": "AGENTE DE DIREITOS AUTORAIS",
      "nome_completo_valor_dominio": "AGENTE DE DIREITOS AUTORAIS",
      "descricao_conceito_valor_dominio": "AGENTE DE DIREITOS AUTORAIS"
    },
    {
      "codigo_valor_dominio": 2299,
      "codigo_referencia_valor_dominio": "352410",
      "nome_resumido_valor_dominio": "AVALIADOR DE PRODUTOS DO MEIO DE COMUNICACAO",
      "nome_completo_valor_dominio": "AVALIADOR DE PRODUTOS DO MEIO DE COMUNICACAO",
      "descricao_conceito_valor_dominio": "AVALIADOR DE PRODUTOS DO MEIO DE COMUNICACAO"
    },
    {
      "codigo_valor_dominio": 2300,
      "codigo_referencia_valor_dominio": "724310",
      "nome_resumido_valor_dominio": "OXICORTADOR A MAO E A MAQUINA",
      "nome_completo_valor_dominio": "OXICORTADOR A MAO E A MAQUINA",
      "descricao_conceito_valor_dominio": "OXICORTADOR A MAO E A MAQUINA"
    },
    {
      "codigo_valor_dominio": 2301,
      "codigo_referencia_valor_dominio": "300305",
      "nome_resumido_valor_dominio": "TECNICO EM ELETROMECANICA",
      "nome_completo_valor_dominio": "TECNICO EM ELETROMECANICA",
      "descricao_conceito_valor_dominio": "TECNICO EM ELETROMECANICA"
    },
    {
      "codigo_valor_dominio": 2302,
      "codigo_referencia_valor_dominio": "353210",
      "nome_resumido_valor_dominio": "TECNICO DE OPERACOES E SERVICOS BANCARIOS - CREDITO IMOBILIA",
      "nome_completo_valor_dominio": "TECNICO DE OPERACOES E SERVICOS BANCARIOS - CREDITO IMOBILIARIO",
      "descricao_conceito_valor_dominio": "TECNICO DE OPERACOES E SERVICOS BANCARIOS - CREDITO IMOBILIARIO"
    },
    {
      "codigo_valor_dominio": 2303,
      "codigo_referencia_valor_dominio": "353215",
      "nome_resumido_valor_dominio": "TECNICO DE OPERACOES E SERVICOS BANCARIOS - CREDITO RURAL",
      "nome_completo_valor_dominio": "TECNICO DE OPERACOES E SERVICOS BANCARIOS - CREDITO RURAL",
      "descricao_conceito_valor_dominio": "TECNICO DE OPERACOES E SERVICOS BANCARIOS - CREDITO RURAL"
    },
    {
      "codigo_valor_dominio": 2304,
      "codigo_referencia_valor_dominio": "353220",
      "nome_resumido_valor_dominio": "TECNICO DE OPERACOES E SERVICOS BANCARIOS - LEASING",
      "nome_completo_valor_dominio": "TECNICO DE OPERACOES E SERVICOS BANCARIOS - LEASING",
      "descricao_conceito_valor_dominio": "TECNICO DE OPERACOES E SERVICOS BANCARIOS - LEASING"
    },
    {
      "codigo_valor_dominio": 2305,
      "codigo_referencia_valor_dominio": "353225",
      "nome_resumido_valor_dominio": "TECNICO DE OPERACOES E SERVICOS BANCARIOS - RENDA FIXA E VAR",
      "nome_completo_valor_dominio": "TECNICO DE OPERACOES E SERVICOS BANCARIOS - RENDA FIXA E VARIAVEL",
      "descricao_conceito_valor_dominio": "TECNICO DE OPERACOES E SERVICOS BANCARIOS - RENDA FIXA E VARIAVEL"
    },
    {
      "codigo_valor_dominio": 2306,
      "codigo_referencia_valor_dominio": "322505",
      "nome_resumido_valor_dominio": "TECNICO DE ORTOPEDIA",
      "nome_completo_valor_dominio": "TECNICO DE ORTOPEDIA",
      "descricao_conceito_valor_dominio": "TECNICO DE ORTOPEDIA"
    },
    {
      "codigo_valor_dominio": 2307,
      "codigo_referencia_valor_dominio": "311725",
      "nome_resumido_valor_dominio": "TINGIDOR DE COUROS E PELES",
      "nome_completo_valor_dominio": "TINGIDOR DE COUROS E PELES",
      "descricao_conceito_valor_dominio": "TINGIDOR DE COUROS E PELES"
    },
    {
      "codigo_valor_dominio": 2308,
      "codigo_referencia_valor_dominio": "353235",
      "nome_resumido_valor_dominio": "CHEFE DE SERVICOS BANCARIOS",
      "nome_completo_valor_dominio": "CHEFE DE SERVICOS BANCARIOS",
      "descricao_conceito_valor_dominio": "CHEFE DE SERVICOS BANCARIOS"
    },
    {
      "codigo_valor_dominio": 2309,
      "codigo_referencia_valor_dominio": "354110",
      "nome_resumido_valor_dominio": "AGENCIADOR DE PROPAGANDA",
      "nome_completo_valor_dominio": "AGENCIADOR DE PROPAGANDA",
      "descricao_conceito_valor_dominio": "AGENCIADOR DE PROPAGANDA"
    },
    {
      "codigo_valor_dominio": 2310,
      "codigo_referencia_valor_dominio": "354120",
      "nome_resumido_valor_dominio": "AGENTE DE VENDAS DE SERVICOS",
      "nome_completo_valor_dominio": "AGENTE DE VENDAS DE SERVICOS",
      "descricao_conceito_valor_dominio": "AGENTE DE VENDAS DE SERVICOS"
    },
    {
      "codigo_valor_dominio": 2311,
      "codigo_referencia_valor_dominio": "354125",
      "nome_resumido_valor_dominio": "ASSISTENTE DE VENDAS",
      "nome_completo_valor_dominio": "ASSISTENTE DE VENDAS",
      "descricao_conceito_valor_dominio": "ASSISTENTE DE VENDAS"
    },
    {
      "codigo_valor_dominio": 2312,
      "codigo_referencia_valor_dominio": "322410",
      "nome_resumido_valor_dominio": "PROTETICO DENTARIO",
      "nome_completo_valor_dominio": "PROTETICO DENTARIO",
      "descricao_conceito_valor_dominio": "PROTETICO DENTARIO"
    },
    {
      "codigo_valor_dominio": 2313,
      "codigo_referencia_valor_dominio": "319205",
      "nome_resumido_valor_dominio": "TECNICO DO MOBILIARIO",
      "nome_completo_valor_dominio": "TECNICO DO MOBILIARIO",
      "descricao_conceito_valor_dominio": "TECNICO DO MOBILIARIO"
    },
    {
      "codigo_valor_dominio": 2314,
      "codigo_referencia_valor_dominio": "314305",
      "nome_resumido_valor_dominio": "TECNICO EM AUTOMOBILISTICA",
      "nome_completo_valor_dominio": "TECNICO EM AUTOMOBILISTICA",
      "descricao_conceito_valor_dominio": "TECNICO EM AUTOMOBILISTICA"
    },
    {
      "codigo_valor_dominio": 2315,
      "codigo_referencia_valor_dominio": "111120",
      "nome_resumido_valor_dominio": "VEREADOR",
      "nome_completo_valor_dominio": "VEREADOR",
      "descricao_conceito_valor_dominio": "VEREADOR"
    },
    {
      "codigo_valor_dominio": 2316,
      "codigo_referencia_valor_dominio": "354205",
      "nome_resumido_valor_dominio": "COMPRADOR",
      "nome_completo_valor_dominio": "COMPRADOR",
      "descricao_conceito_valor_dominio": "COMPRADOR"
    },
    {
      "codigo_valor_dominio": 2317,
      "codigo_referencia_valor_dominio": "410215",
      "nome_resumido_valor_dominio": "SUPERVISOR DE CONTAS A PAGAR",
      "nome_completo_valor_dominio": "SUPERVISOR DE CONTAS A PAGAR",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE CONTAS A PAGAR"
    },
    {
      "codigo_valor_dominio": 2318,
      "codigo_referencia_valor_dominio": "354305",
      "nome_resumido_valor_dominio": "ANALISTA DE EXPORTACAO E IMPORTACAO",
      "nome_completo_valor_dominio": "ANALISTA DE EXPORTACAO E IMPORTACAO",
      "descricao_conceito_valor_dominio": "ANALISTA DE EXPORTACAO E IMPORTACAO"
    },
    {
      "codigo_valor_dominio": 2319,
      "codigo_referencia_valor_dominio": "519940",
      "nome_resumido_valor_dominio": "LEITURISTA",
      "nome_completo_valor_dominio": "LEITURISTA",
      "descricao_conceito_valor_dominio": "LEITURISTA"
    },
    {
      "codigo_valor_dominio": 2320,
      "codigo_referencia_valor_dominio": "354410",
      "nome_resumido_valor_dominio": "AVALIADOR DE IMOVEIS",
      "nome_completo_valor_dominio": "AVALIADOR DE IMOVEIS",
      "descricao_conceito_valor_dominio": "AVALIADOR DE IMOVEIS"
    },
    {
      "codigo_valor_dominio": 2321,
      "codigo_referencia_valor_dominio": "354415",
      "nome_resumido_valor_dominio": "AVALIADOR DE BENS MOVEIS",
      "nome_completo_valor_dominio": "AVALIADOR DE BENS MOVEIS",
      "descricao_conceito_valor_dominio": "AVALIADOR DE BENS MOVEIS"
    },
    {
      "codigo_valor_dominio": 2322,
      "codigo_referencia_valor_dominio": "253305",
      "nome_resumido_valor_dominio": "CORRETOR DE VALORES, ATIVOS FINANCEIROS, MERCADORIAS E DERIV",
      "nome_completo_valor_dominio": "CORRETOR DE VALORES, ATIVOS FINANCEIROS, MERCADORIAS E DERIVATIVOS",
      "descricao_conceito_valor_dominio": "CORRETOR DE VALORES, ATIVOS FINANCEIROS, MERCADORIAS E DERIVATIVOS"
    },
    {
      "codigo_valor_dominio": 2323,
      "codigo_referencia_valor_dominio": "354505",
      "nome_resumido_valor_dominio": "CORRETOR DE SEGUROS",
      "nome_completo_valor_dominio": "CORRETOR DE SEGUROS",
      "descricao_conceito_valor_dominio": "CORRETOR DE SEGUROS"
    },
    {
      "codigo_valor_dominio": 2324,
      "codigo_referencia_valor_dominio": "915205",
      "nome_resumido_valor_dominio": "RESTAURADOR DE INSTRUMENTOS MUSICAIS (EXCETO CORDAS ARCADAS)",
      "nome_completo_valor_dominio": "RESTAURADOR DE INSTRUMENTOS MUSICAIS (EXCETO CORDAS ARCADAS)",
      "descricao_conceito_valor_dominio": "RESTAURADOR DE INSTRUMENTOS MUSICAIS (EXCETO CORDAS ARCADAS)"
    },
    {
      "codigo_valor_dominio": 2325,
      "codigo_referencia_valor_dominio": "321210",
      "nome_resumido_valor_dominio": "TECNICO FLORESTAL",
      "nome_completo_valor_dominio": "TECNICO FLORESTAL",
      "descricao_conceito_valor_dominio": "TECNICO FLORESTAL"
    },
    {
      "codigo_valor_dominio": 2326,
      "codigo_referencia_valor_dominio": "761357",
      "nome_resumido_valor_dominio": "OPERADOR DE URDIDEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE URDIDEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE URDIDEIRA"
    },
    {
      "codigo_valor_dominio": 2327,
      "codigo_referencia_valor_dominio": "354815",
      "nome_resumido_valor_dominio": "AGENTE DE VIAGEM",
      "nome_completo_valor_dominio": "AGENTE DE VIAGEM",
      "descricao_conceito_valor_dominio": "AGENTE DE VIAGEM"
    },
    {
      "codigo_valor_dominio": 2328,
      "codigo_referencia_valor_dominio": "239410",
      "nome_resumido_valor_dominio": "ORIENTADOR EDUCACIONAL",
      "nome_completo_valor_dominio": "ORIENTADOR EDUCACIONAL",
      "descricao_conceito_valor_dominio": "ORIENTADOR EDUCACIONAL"
    },
    {
      "codigo_valor_dominio": 2329,
      "codigo_referencia_valor_dominio": "371105",
      "nome_resumido_valor_dominio": "AUXILIAR DE BIBLIOTECA",
      "nome_completo_valor_dominio": "AUXILIAR DE BIBLIOTECA",
      "descricao_conceito_valor_dominio": "AUXILIAR DE BIBLIOTECA"
    },
    {
      "codigo_valor_dominio": 2330,
      "codigo_referencia_valor_dominio": "325305",
      "nome_resumido_valor_dominio": "TECNICO EM BIOTECNOLOGIA",
      "nome_completo_valor_dominio": "TECNICO EM BIOTECNOLOGIA",
      "descricao_conceito_valor_dominio": "TECNICO EM BIOTECNOLOGIA"
    },
    {
      "codigo_valor_dominio": 2331,
      "codigo_referencia_valor_dominio": "371205",
      "nome_resumido_valor_dominio": "COLECIONADOR DE SELOS E MOEDAS",
      "nome_completo_valor_dominio": "COLECIONADOR DE SELOS E MOEDAS",
      "descricao_conceito_valor_dominio": "COLECIONADOR DE SELOS E MOEDAS"
    },
    {
      "codigo_valor_dominio": 2332,
      "codigo_referencia_valor_dominio": "325210",
      "nome_resumido_valor_dominio": "TECNICO EM NUTRICAO E DIETETICA",
      "nome_completo_valor_dominio": "TECNICO EM NUTRICAO E DIETETICA",
      "descricao_conceito_valor_dominio": "TECNICO EM NUTRICAO E DIETETICA"
    },
    {
      "codigo_valor_dominio": 2333,
      "codigo_referencia_valor_dominio": "322115",
      "nome_resumido_valor_dominio": "TECNICO EM QUIROPRAXIA",
      "nome_completo_valor_dominio": "TECNICO EM QUIROPRAXIA",
      "descricao_conceito_valor_dominio": "TECNICO EM QUIROPRAXIA"
    },
    {
      "codigo_valor_dominio": 2334,
      "codigo_referencia_valor_dominio": "314110",
      "nome_resumido_valor_dominio": "TECNICO MECANICO",
      "nome_completo_valor_dominio": "TECNICO MECANICO",
      "descricao_conceito_valor_dominio": "TECNICO MECANICO"
    },
    {
      "codigo_valor_dominio": 2335,
      "codigo_referencia_valor_dominio": "821335",
      "nome_resumido_valor_dominio": "RECUPERADOR DE GUIAS E CILINDROS",
      "nome_completo_valor_dominio": "RECUPERADOR DE GUIAS E CILINDROS",
      "descricao_conceito_valor_dominio": "RECUPERADOR DE GUIAS E CILINDROS"
    },
    {
      "codigo_valor_dominio": 2336,
      "codigo_referencia_valor_dominio": "371405",
      "nome_resumido_valor_dominio": "RECREADOR DE ACANTONAMENTO",
      "nome_completo_valor_dominio": "RECREADOR DE ACANTONAMENTO",
      "descricao_conceito_valor_dominio": "RECREADOR DE ACANTONAMENTO"
    },
    {
      "codigo_valor_dominio": 2337,
      "codigo_referencia_valor_dominio": "131305",
      "nome_resumido_valor_dominio": "DIRETOR DE INSTITUICAO EDUCACIONAL DA AREA PRIVADA",
      "nome_completo_valor_dominio": "DIRETOR DE INSTITUICAO EDUCACIONAL DA AREA PRIVADA",
      "descricao_conceito_valor_dominio": "DIRETOR DE INSTITUICAO EDUCACIONAL DA AREA PRIVADA"
    },
    {
      "codigo_valor_dominio": 2338,
      "codigo_referencia_valor_dominio": "215125",
      "nome_resumido_valor_dominio": "IMEDIATO DA MARINHA MERCANTE",
      "nome_completo_valor_dominio": "IMEDIATO DA MARINHA MERCANTE",
      "descricao_conceito_valor_dominio": "IMEDIATO DA MARINHA MERCANTE"
    },
    {
      "codigo_valor_dominio": 2339,
      "codigo_referencia_valor_dominio": "711205",
      "nome_resumido_valor_dominio": "OPERADOR DE CAMINHAO (MINAS E PEDREIRAS)",
      "nome_completo_valor_dominio": "OPERADOR DE CAMINHAO (MINAS E PEDREIRAS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE CAMINHAO (MINAS E PEDREIRAS)"
    },
    {
      "codigo_valor_dominio": 2340,
      "codigo_referencia_valor_dominio": "811645",
      "nome_resumido_valor_dominio": "OPERADOR DE REFRIGERACAO (COQUERIA)",
      "nome_completo_valor_dominio": "OPERADOR DE REFRIGERACAO (COQUERIA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE REFRIGERACAO (COQUERIA)"
    },
    {
      "codigo_valor_dominio": 2341,
      "codigo_referencia_valor_dominio": "632010",
      "nome_resumido_valor_dominio": "RAIZEIRO",
      "nome_completo_valor_dominio": "RAIZEIRO",
      "descricao_conceito_valor_dominio": "RAIZEIRO"
    },
    {
      "codigo_valor_dominio": 2342,
      "codigo_referencia_valor_dominio": "823235",
      "nome_resumido_valor_dominio": "OPERADOR DE BANHO METALICO DE VIDRO POR FLUTUACAO",
      "nome_completo_valor_dominio": "OPERADOR DE BANHO METALICO DE VIDRO POR FLUTUACAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE BANHO METALICO DE VIDRO POR FLUTUACAO"
    },
    {
      "codigo_valor_dominio": 2343,
      "codigo_referencia_valor_dominio": "861105",
      "nome_resumido_valor_dominio": "OPERADOR DE CENTRAL HIDRELETRICA",
      "nome_completo_valor_dominio": "OPERADOR DE CENTRAL HIDRELETRICA",
      "descricao_conceito_valor_dominio": "OPERADOR DE CENTRAL HIDRELETRICA"
    },
    {
      "codigo_valor_dominio": 2344,
      "codigo_referencia_valor_dominio": "841620",
      "nome_resumido_valor_dominio": "OPERADOR DE EXTRACAO DE CAFE SOLUVEL",
      "nome_completo_valor_dominio": "OPERADOR DE EXTRACAO DE CAFE SOLUVEL",
      "descricao_conceito_valor_dominio": "OPERADOR DE EXTRACAO DE CAFE SOLUVEL"
    },
    {
      "codigo_valor_dominio": 2345,
      "codigo_referencia_valor_dominio": "766320",
      "nome_resumido_valor_dominio": "OPERADOR DE GUILHOTINA (CORTE DE PAPEL)",
      "nome_completo_valor_dominio": "OPERADOR DE GUILHOTINA (CORTE DE PAPEL)",
      "descricao_conceito_valor_dominio": "OPERADOR DE GUILHOTINA (CORTE DE PAPEL)"
    },
    {
      "codigo_valor_dominio": 2346,
      "codigo_referencia_valor_dominio": "342110",
      "nome_resumido_valor_dominio": "OPERADOR DE TRANSPORTE MULTIMODAL",
      "nome_completo_valor_dominio": "OPERADOR DE TRANSPORTE MULTIMODAL",
      "descricao_conceito_valor_dominio": "OPERADOR DE TRANSPORTE MULTIMODAL"
    },
    {
      "codigo_valor_dominio": 2347,
      "codigo_referencia_valor_dominio": "373215",
      "nome_resumido_valor_dominio": "TECNICO EM OPERACAO DE EQUIPAMENTOS DE TRANSMISSAO/RECEPCAO",
      "nome_completo_valor_dominio": "TECNICO EM OPERACAO DE EQUIPAMENTOS DE TRANSMISSAO/RECEPCAO DE TELEVISAO",
      "descricao_conceito_valor_dominio": "TECNICO EM OPERACAO DE EQUIPAMENTOS DE TRANSMISSAO/RECEPCAO DE TELEVISAO"
    },
    {
      "codigo_valor_dominio": 2348,
      "codigo_referencia_valor_dominio": "373205",
      "nome_resumido_valor_dominio": "TECNICO EM OPERACAO DE EQUIPAMENTOS DE PRODUCAO PARA TELEVIS",
      "nome_completo_valor_dominio": "TECNICO EM OPERACAO DE EQUIPAMENTOS DE PRODUCAO PARA TELEVISAO E PRODUTORAS DE VIDEO",
      "descricao_conceito_valor_dominio": "TECNICO EM OPERACAO DE EQUIPAMENTOS DE PRODUCAO PARA TELEVISAO E PRODUTORAS DE VIDEO"
    },
    {
      "codigo_valor_dominio": 2349,
      "codigo_referencia_valor_dominio": "322305",
      "nome_resumido_valor_dominio": "TECNICO EM OPTICA E OPTOMETRIA",
      "nome_completo_valor_dominio": "TECNICO EM OPTICA E OPTOMETRIA",
      "descricao_conceito_valor_dominio": "TECNICO EM OPTICA E OPTOMETRIA"
    },
    {
      "codigo_valor_dominio": 2350,
      "codigo_referencia_valor_dominio": "752235",
      "nome_resumido_valor_dominio": "SURFASSAGISTA",
      "nome_completo_valor_dominio": "SURFASSAGISTA",
      "descricao_conceito_valor_dominio": "SURFASSAGISTA"
    },
    {
      "codigo_valor_dominio": 2351,
      "codigo_referencia_valor_dominio": "312315",
      "nome_resumido_valor_dominio": "TECNICO EM HIDROGRAFIA",
      "nome_completo_valor_dominio": "TECNICO EM HIDROGRAFIA",
      "descricao_conceito_valor_dominio": "TECNICO EM HIDROGRAFIA"
    },
    {
      "codigo_valor_dominio": 2352,
      "codigo_referencia_valor_dominio": "313410",
      "nome_resumido_valor_dominio": "TECNICO EM INSTRUMENTACAO",
      "nome_completo_valor_dominio": "TECNICO EM INSTRUMENTACAO",
      "descricao_conceito_valor_dominio": "TECNICO EM INSTRUMENTACAO"
    },
    {
      "codigo_valor_dominio": 2353,
      "codigo_referencia_valor_dominio": "311305",
      "nome_resumido_valor_dominio": "TECNICO EM MATERIAIS, PRODUTOS CERAMICOS E VIDROS",
      "nome_completo_valor_dominio": "TECNICO EM MATERIAIS, PRODUTOS CERAMICOS E VIDROS",
      "descricao_conceito_valor_dominio": "TECNICO EM MATERIAIS, PRODUTOS CERAMICOS E VIDROS"
    },
    {
      "codigo_valor_dominio": 2354,
      "codigo_referencia_valor_dominio": "242235",
      "nome_resumido_valor_dominio": "PROMOTOR DE JUSTICA",
      "nome_completo_valor_dominio": "PROMOTOR DE JUSTICA",
      "descricao_conceito_valor_dominio": "PROMOTOR DE JUSTICA"
    },
    {
      "codigo_valor_dominio": 2355,
      "codigo_referencia_valor_dominio": "311520",
      "nome_resumido_valor_dominio": "TECNICO EM TRATAMENTO DE EFLUENTES",
      "nome_completo_valor_dominio": "TECNICO EM TRATAMENTO DE EFLUENTES",
      "descricao_conceito_valor_dominio": "TECNICO EM TRATAMENTO DE EFLUENTES"
    },
    {
      "codigo_valor_dominio": 2356,
      "codigo_referencia_valor_dominio": "371210",
      "nome_resumido_valor_dominio": "TECNICO EM MUSEOLOGIA",
      "nome_completo_valor_dominio": "TECNICO EM MUSEOLOGIA",
      "descricao_conceito_valor_dominio": "TECNICO EM MUSEOLOGIA"
    },
    {
      "codigo_valor_dominio": 2357,
      "codigo_referencia_valor_dominio": "374120",
      "nome_resumido_valor_dominio": "PROJETISTA DE SOM",
      "nome_completo_valor_dominio": "PROJETISTA DE SOM",
      "descricao_conceito_valor_dominio": "PROJETISTA DE SOM"
    },
    {
      "codigo_valor_dominio": 2358,
      "codigo_referencia_valor_dominio": "711130",
      "nome_resumido_valor_dominio": "MINEIRO",
      "nome_completo_valor_dominio": "MINEIRO",
      "descricao_conceito_valor_dominio": "MINEIRO"
    },
    {
      "codigo_valor_dominio": 2359,
      "codigo_referencia_valor_dominio": "374205",
      "nome_resumido_valor_dominio": "CENOTECNICO (CINEMA, VIDEO, TELEVISAO, TEATRO E ESPETACULOS)",
      "nome_completo_valor_dominio": "CENOTECNICO (CINEMA, VIDEO, TELEVISAO, TEATRO E ESPETACULOS)",
      "descricao_conceito_valor_dominio": "CENOTECNICO (CINEMA, VIDEO, TELEVISAO, TEATRO E ESPETACULOS)"
    },
    {
      "codigo_valor_dominio": 2360,
      "codigo_referencia_valor_dominio": "862110",
      "nome_resumido_valor_dominio": "MAQUINISTA DE EMBARCACOES",
      "nome_completo_valor_dominio": "MAQUINISTA DE EMBARCACOES",
      "descricao_conceito_valor_dominio": "MAQUINISTA DE EMBARCACOES"
    },
    {
      "codigo_valor_dominio": 2361,
      "codigo_referencia_valor_dominio": "782610",
      "nome_resumido_valor_dominio": "MAQUINISTA DE TREM",
      "nome_completo_valor_dominio": "MAQUINISTA DE TREM",
      "descricao_conceito_valor_dominio": "MAQUINISTA DE TREM"
    },
    {
      "codigo_valor_dominio": 2362,
      "codigo_referencia_valor_dominio": "861110",
      "nome_resumido_valor_dominio": "OPERADOR DE QUADRO DE DISTRIBUICAO DE ENERGIA ELETRICA",
      "nome_completo_valor_dominio": "OPERADOR DE QUADRO DE DISTRIBUICAO DE ENERGIA ELETRICA",
      "descricao_conceito_valor_dominio": "OPERADOR DE QUADRO DE DISTRIBUICAO DE ENERGIA ELETRICA"
    },
    {
      "codigo_valor_dominio": 2363,
      "codigo_referencia_valor_dominio": "354820",
      "nome_resumido_valor_dominio": "ORGANIZADOR DE EVENTO",
      "nome_completo_valor_dominio": "ORGANIZADOR DE EVENTO",
      "descricao_conceito_valor_dominio": "ORGANIZADOR DE EVENTO"
    },
    {
      "codigo_valor_dominio": 2364,
      "codigo_referencia_valor_dominio": "515305",
      "nome_resumido_valor_dominio": "EDUCADOR SOCIAL",
      "nome_completo_valor_dominio": "EDUCADOR SOCIAL",
      "descricao_conceito_valor_dominio": "EDUCADOR SOCIAL"
    },
    {
      "codigo_valor_dominio": 2365,
      "codigo_referencia_valor_dominio": "374415",
      "nome_resumido_valor_dominio": "FINALIZADOR DE VIDEO",
      "nome_completo_valor_dominio": "FINALIZADOR DE VIDEO",
      "descricao_conceito_valor_dominio": "FINALIZADOR DE VIDEO"
    },
    {
      "codigo_valor_dominio": 2366,
      "codigo_referencia_valor_dominio": "342515",
      "nome_resumido_valor_dominio": "FISCAL DE AVIACAO CIVIL (FAC)",
      "nome_completo_valor_dominio": "FISCAL DE AVIACAO CIVIL (FAC)",
      "descricao_conceito_valor_dominio": "FISCAL DE AVIACAO CIVIL (FAC)"
    },
    {
      "codigo_valor_dominio": 2367,
      "codigo_referencia_valor_dominio": "766125",
      "nome_resumido_valor_dominio": "MONTADOR DE FOTOLITO (ANALOGICO E DIGITAL)",
      "nome_completo_valor_dominio": "MONTADOR DE FOTOLITO (ANALOGICO E DIGITAL)",
      "descricao_conceito_valor_dominio": "MONTADOR DE FOTOLITO (ANALOGICO E DIGITAL)"
    },
    {
      "codigo_valor_dominio": 2368,
      "codigo_referencia_valor_dominio": "375110",
      "nome_resumido_valor_dominio": "DESIGNER DE VITRINES",
      "nome_completo_valor_dominio": "DESIGNER DE VITRINES",
      "descricao_conceito_valor_dominio": "DESIGNER DE VITRINES"
    },
    {
      "codigo_valor_dominio": 2369,
      "codigo_referencia_valor_dominio": "239435",
      "nome_resumido_valor_dominio": "DESIGNER EDUCACIONAL",
      "nome_completo_valor_dominio": "DESIGNER EDUCACIONAL",
      "descricao_conceito_valor_dominio": "DESIGNER EDUCACIONAL"
    },
    {
      "codigo_valor_dominio": 2370,
      "codigo_referencia_valor_dominio": "632015",
      "nome_resumido_valor_dominio": "VIVEIRISTA FLORESTAL",
      "nome_completo_valor_dominio": "VIVEIRISTA FLORESTAL",
      "descricao_conceito_valor_dominio": "VIVEIRISTA FLORESTAL"
    },
    {
      "codigo_valor_dominio": 2371,
      "codigo_referencia_valor_dominio": "262905",
      "nome_resumido_valor_dominio": "DECORADOR DE INTERIORES DE NIVEL SUPERIOR",
      "nome_completo_valor_dominio": "DECORADOR DE INTERIORES DE NIVEL SUPERIOR",
      "descricao_conceito_valor_dominio": "DECORADOR DE INTERIORES DE NIVEL SUPERIOR"
    },
    {
      "codigo_valor_dominio": 2372,
      "codigo_referencia_valor_dominio": "412105",
      "nome_resumido_valor_dominio": "DATILOGRAFO",
      "nome_completo_valor_dominio": "DATILOGRAFO",
      "descricao_conceito_valor_dominio": "DATILOGRAFO"
    },
    {
      "codigo_valor_dominio": 2373,
      "codigo_referencia_valor_dominio": "376105",
      "nome_resumido_valor_dominio": "DANCARINO TRADICIONAL",
      "nome_completo_valor_dominio": "DANCARINO TRADICIONAL",
      "descricao_conceito_valor_dominio": "DANCARINO TRADICIONAL"
    },
    {
      "codigo_valor_dominio": 2374,
      "codigo_referencia_valor_dominio": "376205",
      "nome_resumido_valor_dominio": "ACROBATA",
      "nome_completo_valor_dominio": "ACROBATA",
      "descricao_conceito_valor_dominio": "ACROBATA"
    },
    {
      "codigo_valor_dominio": 2375,
      "codigo_referencia_valor_dominio": "376210",
      "nome_resumido_valor_dominio": "ARTISTA AEREO",
      "nome_completo_valor_dominio": "ARTISTA AEREO",
      "descricao_conceito_valor_dominio": "ARTISTA AEREO"
    },
    {
      "codigo_valor_dominio": 2376,
      "codigo_referencia_valor_dominio": "376215",
      "nome_resumido_valor_dominio": "ARTISTA DE CIRCO (OUTROS)",
      "nome_completo_valor_dominio": "ARTISTA DE CIRCO (OUTROS)",
      "descricao_conceito_valor_dominio": "ARTISTA DE CIRCO (OUTROS)"
    },
    {
      "codigo_valor_dominio": 2377,
      "codigo_referencia_valor_dominio": "760105",
      "nome_resumido_valor_dominio": "CONTRAMESTRE DE ACABAMENTO (INDUSTRIA TEXTIL)",
      "nome_completo_valor_dominio": "CONTRAMESTRE DE ACABAMENTO (INDUSTRIA TEXTIL)",
      "descricao_conceito_valor_dominio": "CONTRAMESTRE DE ACABAMENTO (INDUSTRIA TEXTIL)"
    },
    {
      "codigo_valor_dominio": 2378,
      "codigo_referencia_valor_dominio": "811810",
      "nome_resumido_valor_dominio": "DRAGEADOR (MEDICAMENTOS)",
      "nome_completo_valor_dominio": "DRAGEADOR (MEDICAMENTOS)",
      "descricao_conceito_valor_dominio": "DRAGEADOR (MEDICAMENTOS)"
    },
    {
      "codigo_valor_dominio": 2379,
      "codigo_referencia_valor_dominio": "821410",
      "nome_resumido_valor_dominio": "ESCARFADOR",
      "nome_completo_valor_dominio": "ESCARFADOR",
      "descricao_conceito_valor_dominio": "ESCARFADOR"
    },
    {
      "codigo_valor_dominio": 2380,
      "codigo_referencia_valor_dominio": "510135",
      "nome_resumido_valor_dominio": "MAITRE",
      "nome_completo_valor_dominio": "MAITRE",
      "descricao_conceito_valor_dominio": "MAITRE"
    },
    {
      "codigo_valor_dominio": 2381,
      "codigo_referencia_valor_dominio": "841725",
      "nome_resumido_valor_dominio": "MALTEIRO (GERMINACAO)",
      "nome_completo_valor_dominio": "MALTEIRO (GERMINACAO)",
      "descricao_conceito_valor_dominio": "MALTEIRO (GERMINACAO)"
    },
    {
      "codigo_valor_dominio": 2382,
      "codigo_referencia_valor_dominio": "351815",
      "nome_resumido_valor_dominio": "PAPILOSCOPISTA POLICIAL",
      "nome_completo_valor_dominio": "PAPILOSCOPISTA POLICIAL",
      "descricao_conceito_valor_dominio": "PAPILOSCOPISTA POLICIAL"
    },
    {
      "codigo_valor_dominio": 2383,
      "codigo_referencia_valor_dominio": "312320",
      "nome_resumido_valor_dominio": "TOPOGRAFO",
      "nome_completo_valor_dominio": "TOPOGRAFO",
      "descricao_conceito_valor_dominio": "TOPOGRAFO"
    },
    {
      "codigo_valor_dominio": 2384,
      "codigo_referencia_valor_dominio": "623020",
      "nome_resumido_valor_dominio": "TRATADOR DE ANIMAIS",
      "nome_completo_valor_dominio": "TRATADOR DE ANIMAIS",
      "descricao_conceito_valor_dominio": "TRATADOR DE ANIMAIS"
    },
    {
      "codigo_valor_dominio": 2385,
      "codigo_referencia_valor_dominio": "376305",
      "nome_resumido_valor_dominio": "APRESENTADOR DE EVENTOS",
      "nome_completo_valor_dominio": "APRESENTADOR DE EVENTOS",
      "descricao_conceito_valor_dominio": "APRESENTADOR DE EVENTOS"
    },
    {
      "codigo_valor_dominio": 2386,
      "codigo_referencia_valor_dominio": "376310",
      "nome_resumido_valor_dominio": "APRESENTADOR DE FESTAS POPULARES",
      "nome_completo_valor_dominio": "APRESENTADOR DE FESTAS POPULARES",
      "descricao_conceito_valor_dominio": "APRESENTADOR DE FESTAS POPULARES"
    },
    {
      "codigo_valor_dominio": 2387,
      "codigo_referencia_valor_dominio": "376315",
      "nome_resumido_valor_dominio": "APRESENTADOR DE PROGRAMAS DE RADIO",
      "nome_completo_valor_dominio": "APRESENTADOR DE PROGRAMAS DE RADIO",
      "descricao_conceito_valor_dominio": "APRESENTADOR DE PROGRAMAS DE RADIO"
    },
    {
      "codigo_valor_dominio": 2388,
      "codigo_referencia_valor_dominio": "376320",
      "nome_resumido_valor_dominio": "APRESENTADOR DE PROGRAMAS DE TELEVISAO",
      "nome_completo_valor_dominio": "APRESENTADOR DE PROGRAMAS DE TELEVISAO",
      "descricao_conceito_valor_dominio": "APRESENTADOR DE PROGRAMAS DE TELEVISAO"
    },
    {
      "codigo_valor_dominio": 2389,
      "codigo_referencia_valor_dominio": "376325",
      "nome_resumido_valor_dominio": "APRESENTADOR DE CIRCO",
      "nome_completo_valor_dominio": "APRESENTADOR DE CIRCO",
      "descricao_conceito_valor_dominio": "APRESENTADOR DE CIRCO"
    },
    {
      "codigo_valor_dominio": 2390,
      "codigo_referencia_valor_dominio": "376410",
      "nome_resumido_valor_dominio": "MODELO DE MODAS",
      "nome_completo_valor_dominio": "MODELO DE MODAS",
      "descricao_conceito_valor_dominio": "MODELO DE MODAS"
    },
    {
      "codigo_valor_dominio": 2391,
      "codigo_referencia_valor_dominio": "376415",
      "nome_resumido_valor_dominio": "MODELO PUBLICITARIO",
      "nome_completo_valor_dominio": "MODELO PUBLICITARIO",
      "descricao_conceito_valor_dominio": "MODELO PUBLICITARIO"
    },
    {
      "codigo_valor_dominio": 2392,
      "codigo_referencia_valor_dominio": "841615",
      "nome_resumido_valor_dominio": "MOEDOR DE CAFE",
      "nome_completo_valor_dominio": "MOEDOR DE CAFE",
      "descricao_conceito_valor_dominio": "MOEDOR DE CAFE"
    },
    {
      "codigo_valor_dominio": 2393,
      "codigo_referencia_valor_dominio": "377105",
      "nome_resumido_valor_dominio": "ATLETA PROFISSIONAL (OUTRAS MODALIDADES)",
      "nome_completo_valor_dominio": "ATLETA PROFISSIONAL (OUTRAS MODALIDADES)",
      "descricao_conceito_valor_dominio": "ATLETA PROFISSIONAL (OUTRAS MODALIDADES)"
    },
    {
      "codigo_valor_dominio": 2394,
      "codigo_referencia_valor_dominio": "377110",
      "nome_resumido_valor_dominio": "ATLETA PROFISSIONAL DE FUTEBOL",
      "nome_completo_valor_dominio": "ATLETA PROFISSIONAL DE FUTEBOL",
      "descricao_conceito_valor_dominio": "ATLETA PROFISSIONAL DE FUTEBOL"
    },
    {
      "codigo_valor_dominio": 2395,
      "codigo_referencia_valor_dominio": "377115",
      "nome_resumido_valor_dominio": "ATLETA PROFISSIONAL DE GOLFE",
      "nome_completo_valor_dominio": "ATLETA PROFISSIONAL DE GOLFE",
      "descricao_conceito_valor_dominio": "ATLETA PROFISSIONAL DE GOLFE"
    },
    {
      "codigo_valor_dominio": 2396,
      "codigo_referencia_valor_dominio": "377120",
      "nome_resumido_valor_dominio": "ATLETA PROFISSIONAL DE LUTA",
      "nome_completo_valor_dominio": "ATLETA PROFISSIONAL DE LUTA",
      "descricao_conceito_valor_dominio": "ATLETA PROFISSIONAL DE LUTA"
    },
    {
      "codigo_valor_dominio": 2397,
      "codigo_referencia_valor_dominio": "377125",
      "nome_resumido_valor_dominio": "ATLETA PROFISSIONAL DE TENIS",
      "nome_completo_valor_dominio": "ATLETA PROFISSIONAL DE TENIS",
      "descricao_conceito_valor_dominio": "ATLETA PROFISSIONAL DE TENIS"
    },
    {
      "codigo_valor_dominio": 2398,
      "codigo_referencia_valor_dominio": "524210",
      "nome_resumido_valor_dominio": "JORNALEIRO (EM BANCA DE JORNAL)",
      "nome_completo_valor_dominio": "JORNALEIRO (EM BANCA DE JORNAL)",
      "descricao_conceito_valor_dominio": "JORNALEIRO (EM BANCA DE JORNAL)"
    },
    {
      "codigo_valor_dominio": 2399,
      "codigo_referencia_valor_dominio": "215310",
      "nome_resumido_valor_dominio": "PILOTO DE ENSAIOS EM VOO",
      "nome_completo_valor_dominio": "PILOTO DE ENSAIOS EM VOO",
      "descricao_conceito_valor_dominio": "PILOTO DE ENSAIOS EM VOO"
    },
    {
      "codigo_valor_dominio": 2400,
      "codigo_referencia_valor_dominio": "519805",
      "nome_resumido_valor_dominio": "PROFISSIONAL DO SEXO",
      "nome_completo_valor_dominio": "PROFISSIONAL DO SEXO",
      "descricao_conceito_valor_dominio": "PROFISSIONAL DO SEXO"
    },
    {
      "codigo_valor_dominio": 2401,
      "codigo_referencia_valor_dominio": "848210",
      "nome_resumido_valor_dominio": "QUEIJEIRO NA FABRICACAO DE LATICINIO",
      "nome_completo_valor_dominio": "QUEIJEIRO NA FABRICACAO DE LATICINIO",
      "descricao_conceito_valor_dominio": "QUEIJEIRO NA FABRICACAO DE LATICINIO"
    },
    {
      "codigo_valor_dominio": 2402,
      "codigo_referencia_valor_dominio": "377205",
      "nome_resumido_valor_dominio": "ARBITRO DESPORTIVO",
      "nome_completo_valor_dominio": "ARBITRO DESPORTIVO",
      "descricao_conceito_valor_dominio": "ARBITRO DESPORTIVO"
    },
    {
      "codigo_valor_dominio": 2403,
      "codigo_referencia_valor_dominio": "377210",
      "nome_resumido_valor_dominio": "ARBITRO DE ATLETISMO",
      "nome_completo_valor_dominio": "ARBITRO DE ATLETISMO",
      "descricao_conceito_valor_dominio": "ARBITRO DE ATLETISMO"
    },
    {
      "codigo_valor_dominio": 2404,
      "codigo_referencia_valor_dominio": "377215",
      "nome_resumido_valor_dominio": "ARBITRO DE BASQUETE",
      "nome_completo_valor_dominio": "ARBITRO DE BASQUETE",
      "descricao_conceito_valor_dominio": "ARBITRO DE BASQUETE"
    },
    {
      "codigo_valor_dominio": 2405,
      "codigo_referencia_valor_dominio": "377220",
      "nome_resumido_valor_dominio": "ARBITRO DE FUTEBOL",
      "nome_completo_valor_dominio": "ARBITRO DE FUTEBOL",
      "descricao_conceito_valor_dominio": "ARBITRO DE FUTEBOL"
    },
    {
      "codigo_valor_dominio": 2406,
      "codigo_referencia_valor_dominio": "377225",
      "nome_resumido_valor_dominio": "ARBITRO DE FUTEBOL DE SALAO",
      "nome_completo_valor_dominio": "ARBITRO DE FUTEBOL DE SALAO",
      "descricao_conceito_valor_dominio": "ARBITRO DE FUTEBOL DE SALAO"
    },
    {
      "codigo_valor_dominio": 2407,
      "codigo_referencia_valor_dominio": "377230",
      "nome_resumido_valor_dominio": "ARBITRO DE JUDO",
      "nome_completo_valor_dominio": "ARBITRO DE JUDO",
      "descricao_conceito_valor_dominio": "ARBITRO DE JUDO"
    },
    {
      "codigo_valor_dominio": 2408,
      "codigo_referencia_valor_dominio": "377235",
      "nome_resumido_valor_dominio": "ARBITRO DE KARATE",
      "nome_completo_valor_dominio": "ARBITRO DE KARATE",
      "descricao_conceito_valor_dominio": "ARBITRO DE KARATE"
    },
    {
      "codigo_valor_dominio": 2409,
      "codigo_referencia_valor_dominio": "377240",
      "nome_resumido_valor_dominio": "ARBITRO DE POLO AQUATICO",
      "nome_completo_valor_dominio": "ARBITRO DE POLO AQUATICO",
      "descricao_conceito_valor_dominio": "ARBITRO DE POLO AQUATICO"
    },
    {
      "codigo_valor_dominio": 2410,
      "codigo_referencia_valor_dominio": "377245",
      "nome_resumido_valor_dominio": "ARBITRO DE VOLEI",
      "nome_completo_valor_dominio": "ARBITRO DE VOLEI",
      "descricao_conceito_valor_dominio": "ARBITRO DE VOLEI"
    },
    {
      "codigo_valor_dominio": 2411,
      "codigo_referencia_valor_dominio": "391110",
      "nome_resumido_valor_dominio": "CRONOMETRISTA",
      "nome_completo_valor_dominio": "CRONOMETRISTA",
      "descricao_conceito_valor_dominio": "CRONOMETRISTA"
    },
    {
      "codigo_valor_dominio": 2412,
      "codigo_referencia_valor_dominio": "632110",
      "nome_resumido_valor_dominio": "CUBADOR DE MADEIRA",
      "nome_completo_valor_dominio": "CUBADOR DE MADEIRA",
      "descricao_conceito_valor_dominio": "CUBADOR DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 2413,
      "codigo_referencia_valor_dominio": "391115",
      "nome_resumido_valor_dominio": "CONTROLADOR DE PRAGAS",
      "nome_completo_valor_dominio": "CONTROLADOR DE PRAGAS",
      "descricao_conceito_valor_dominio": "CONTROLADOR DE PRAGAS"
    },
    {
      "codigo_valor_dominio": 2414,
      "codigo_referencia_valor_dominio": "711325",
      "nome_resumido_valor_dominio": "PLATAFORMISTA (PETROLEO)",
      "nome_completo_valor_dominio": "PLATAFORMISTA (PETROLEO)",
      "descricao_conceito_valor_dominio": "PLATAFORMISTA (PETROLEO)"
    },
    {
      "codigo_valor_dominio": 2415,
      "codigo_referencia_valor_dominio": "391130",
      "nome_resumido_valor_dominio": "TECNICO DE PLANEJAMENTO E PROGRAMACAO DA MANUTENCAO",
      "nome_completo_valor_dominio": "TECNICO DE PLANEJAMENTO E PROGRAMACAO DA MANUTENCAO",
      "descricao_conceito_valor_dominio": "TECNICO DE PLANEJAMENTO E PROGRAMACAO DA MANUTENCAO"
    },
    {
      "codigo_valor_dominio": 2416,
      "codigo_referencia_valor_dominio": "316325",
      "nome_resumido_valor_dominio": "TECNICO DE PRODUCAO EM REFINO DE PETROLEO",
      "nome_completo_valor_dominio": "TECNICO DE PRODUCAO EM REFINO DE PETROLEO",
      "descricao_conceito_valor_dominio": "TECNICO DE PRODUCAO EM REFINO DE PETROLEO"
    },
    {
      "codigo_valor_dominio": 2417,
      "codigo_referencia_valor_dominio": "311510",
      "nome_resumido_valor_dominio": "TECNICO DE METEOROLOGIA",
      "nome_completo_valor_dominio": "TECNICO DE METEOROLOGIA",
      "descricao_conceito_valor_dominio": "TECNICO DE METEOROLOGIA"
    },
    {
      "codigo_valor_dominio": 2418,
      "codigo_referencia_valor_dominio": "351725",
      "nome_resumido_valor_dominio": "INSPETOR DE RISCO",
      "nome_completo_valor_dominio": "INSPETOR DE RISCO",
      "descricao_conceito_valor_dominio": "INSPETOR DE RISCO"
    },
    {
      "codigo_valor_dominio": 2419,
      "codigo_referencia_valor_dominio": "322605",
      "nome_resumido_valor_dominio": "TECNICO DE IMOBILIZACAO ORTOPEDICA",
      "nome_completo_valor_dominio": "TECNICO DE IMOBILIZACAO ORTOPEDICA",
      "descricao_conceito_valor_dominio": "TECNICO DE IMOBILIZACAO ORTOPEDICA"
    },
    {
      "codigo_valor_dominio": 2420,
      "codigo_referencia_valor_dominio": "862515",
      "nome_resumido_valor_dominio": "OPERADOR DE INSTALACAO DE AR-CONDICIONADO",
      "nome_completo_valor_dominio": "OPERADOR DE INSTALACAO DE AR-CONDICIONADO",
      "descricao_conceito_valor_dominio": "OPERADOR DE INSTALACAO DE AR-CONDICIONADO"
    },
    {
      "codigo_valor_dominio": 2421,
      "codigo_referencia_valor_dominio": "391125",
      "nome_resumido_valor_dominio": "TECNICO DE PLANEJAMENTO DE PRODUCAO",
      "nome_completo_valor_dominio": "TECNICO DE PLANEJAMENTO DE PRODUCAO",
      "descricao_conceito_valor_dominio": "TECNICO DE PLANEJAMENTO DE PRODUCAO"
    },
    {
      "codigo_valor_dominio": 2422,
      "codigo_referencia_valor_dominio": "711125",
      "nome_resumido_valor_dominio": "ESCORADOR DE MINAS",
      "nome_completo_valor_dominio": "ESCORADOR DE MINAS",
      "descricao_conceito_valor_dominio": "ESCORADOR DE MINAS"
    },
    {
      "codigo_valor_dominio": 2423,
      "codigo_referencia_valor_dominio": "311105",
      "nome_resumido_valor_dominio": "TECNICO QUIMICO",
      "nome_completo_valor_dominio": "TECNICO QUIMICO",
      "descricao_conceito_valor_dominio": "TECNICO QUIMICO"
    },
    {
      "codigo_valor_dominio": 2424,
      "codigo_referencia_valor_dominio": "395110",
      "nome_resumido_valor_dominio": "TECNICO DE APOIO EM PESQUISA E DESENVOLVIMENTO AGROPECUARIO",
      "nome_completo_valor_dominio": "TECNICO DE APOIO EM PESQUISA E DESENVOLVIMENTO AGROPECUARIO FLORESTAL",
      "descricao_conceito_valor_dominio": "TECNICO DE APOIO EM PESQUISA E DESENVOLVIMENTO AGROPECUARIO FLORESTAL"
    },
    {
      "codigo_valor_dominio": 2425,
      "codigo_referencia_valor_dominio": "311110",
      "nome_resumido_valor_dominio": "TECNICO DE CELULOSE E PAPEL",
      "nome_completo_valor_dominio": "TECNICO DE CELULOSE E PAPEL",
      "descricao_conceito_valor_dominio": "TECNICO DE CELULOSE E PAPEL"
    },
    {
      "codigo_valor_dominio": 2426,
      "codigo_referencia_valor_dominio": "342540",
      "nome_resumido_valor_dominio": "SUPERVISOR DA ADMINISTRACAO DE AEROPORTOS",
      "nome_completo_valor_dominio": "SUPERVISOR DA ADMINISTRACAO DE AEROPORTOS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DA ADMINISTRACAO DE AEROPORTOS"
    },
    {
      "codigo_valor_dominio": 2427,
      "codigo_referencia_valor_dominio": "510115",
      "nome_resumido_valor_dominio": "SUPERVISOR DE ANDAR",
      "nome_completo_valor_dominio": "SUPERVISOR DE ANDAR",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE ANDAR"
    },
    {
      "codigo_valor_dominio": 2428,
      "codigo_referencia_valor_dominio": "342315",
      "nome_resumido_valor_dominio": "SUPERVISOR DE CARGA E DESCARGA",
      "nome_completo_valor_dominio": "SUPERVISOR DE CARGA E DESCARGA",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE CARGA E DESCARGA"
    },
    {
      "codigo_valor_dominio": 2429,
      "codigo_referencia_valor_dominio": "720160",
      "nome_resumido_valor_dominio": "SUPERVISOR DE CONTROLE DE TRATAMENTO TERMICO",
      "nome_completo_valor_dominio": "SUPERVISOR DE CONTROLE DE TRATAMENTO TERMICO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE CONTROLE DE TRATAMENTO TERMICO"
    },
    {
      "codigo_valor_dominio": 2430,
      "codigo_referencia_valor_dominio": "410225",
      "nome_resumido_valor_dominio": "SUPERVISOR DE CREDITO E COBRANCA",
      "nome_completo_valor_dominio": "SUPERVISOR DE CREDITO E COBRANCA",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE CREDITO E COBRANCA"
    },
    {
      "codigo_valor_dominio": 2431,
      "codigo_referencia_valor_dominio": "760205",
      "nome_resumido_valor_dominio": "SUPERVISOR DE CURTIMENTO",
      "nome_completo_valor_dominio": "SUPERVISOR DE CURTIMENTO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE CURTIMENTO"
    },
    {
      "codigo_valor_dominio": 2432,
      "codigo_referencia_valor_dominio": "710115",
      "nome_resumido_valor_dominio": "SUPERVISOR DE PERFURACAO E DESMONTE",
      "nome_completo_valor_dominio": "SUPERVISOR DE PERFURACAO E DESMONTE",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE PERFURACAO E DESMONTE"
    },
    {
      "codigo_valor_dominio": 2433,
      "codigo_referencia_valor_dominio": "710125",
      "nome_resumido_valor_dominio": "SUPERVISOR DE TRANSPORTE NA MINERACAO",
      "nome_completo_valor_dominio": "SUPERVISOR DE TRANSPORTE NA MINERACAO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE TRANSPORTE NA MINERACAO"
    },
    {
      "codigo_valor_dominio": 2434,
      "codigo_referencia_valor_dominio": "411005",
      "nome_resumido_valor_dominio": "AUXILIAR DE ESCRITORIO, EM GERAL",
      "nome_completo_valor_dominio": "AUXILIAR DE ESCRITORIO, EM GERAL",
      "descricao_conceito_valor_dominio": "AUXILIAR DE ESCRITORIO, EM GERAL"
    },
    {
      "codigo_valor_dominio": 2435,
      "codigo_referencia_valor_dominio": "411010",
      "nome_resumido_valor_dominio": "ASSISTENTE ADMINISTRATIVO",
      "nome_completo_valor_dominio": "ASSISTENTE ADMINISTRATIVO",
      "descricao_conceito_valor_dominio": "ASSISTENTE ADMINISTRATIVO"
    },
    {
      "codigo_valor_dominio": 2436,
      "codigo_referencia_valor_dominio": "411015",
      "nome_resumido_valor_dominio": "ATENDENTE DE JUDICIARIO",
      "nome_completo_valor_dominio": "ATENDENTE DE JUDICIARIO",
      "descricao_conceito_valor_dominio": "ATENDENTE DE JUDICIARIO"
    },
    {
      "codigo_valor_dominio": 2437,
      "codigo_referencia_valor_dominio": "411020",
      "nome_resumido_valor_dominio": "AUXILIAR DE JUDICIARIO",
      "nome_completo_valor_dominio": "AUXILIAR DE JUDICIARIO",
      "descricao_conceito_valor_dominio": "AUXILIAR DE JUDICIARIO"
    },
    {
      "codigo_valor_dominio": 2438,
      "codigo_referencia_valor_dominio": "411025",
      "nome_resumido_valor_dominio": "AUXILIAR DE CARTORIO",
      "nome_completo_valor_dominio": "AUXILIAR DE CARTORIO",
      "descricao_conceito_valor_dominio": "AUXILIAR DE CARTORIO"
    },
    {
      "codigo_valor_dominio": 2439,
      "codigo_referencia_valor_dominio": "411030",
      "nome_resumido_valor_dominio": "AUXILIAR DE PESSOAL",
      "nome_completo_valor_dominio": "AUXILIAR DE PESSOAL",
      "descricao_conceito_valor_dominio": "AUXILIAR DE PESSOAL"
    },
    {
      "codigo_valor_dominio": 2440,
      "codigo_referencia_valor_dominio": "411035",
      "nome_resumido_valor_dominio": "AUXILIAR DE ESTATISTICA",
      "nome_completo_valor_dominio": "AUXILIAR DE ESTATISTICA",
      "descricao_conceito_valor_dominio": "AUXILIAR DE ESTATISTICA"
    },
    {
      "codigo_valor_dominio": 2441,
      "codigo_referencia_valor_dominio": "411040",
      "nome_resumido_valor_dominio": "AUXILIAR DE SEGUROS",
      "nome_completo_valor_dominio": "AUXILIAR DE SEGUROS",
      "descricao_conceito_valor_dominio": "AUXILIAR DE SEGUROS"
    },
    {
      "codigo_valor_dominio": 2442,
      "codigo_referencia_valor_dominio": "411045",
      "nome_resumido_valor_dominio": "AUXILIAR DE SERVICOS DE IMPORTACAO E EXPORTACAO",
      "nome_completo_valor_dominio": "AUXILIAR DE SERVICOS DE IMPORTACAO E EXPORTACAO",
      "descricao_conceito_valor_dominio": "AUXILIAR DE SERVICOS DE IMPORTACAO E EXPORTACAO"
    },
    {
      "codigo_valor_dominio": 2443,
      "codigo_referencia_valor_dominio": "411050",
      "nome_resumido_valor_dominio": "AGENTE DE MICROCREDITO",
      "nome_completo_valor_dominio": "AGENTE DE MICROCREDITO",
      "descricao_conceito_valor_dominio": "AGENTE DE MICROCREDITO"
    },
    {
      "codigo_valor_dominio": 2444,
      "codigo_referencia_valor_dominio": "723205",
      "nome_resumido_valor_dominio": "DECAPADOR",
      "nome_completo_valor_dominio": "DECAPADOR",
      "descricao_conceito_valor_dominio": "DECAPADOR"
    },
    {
      "codigo_valor_dominio": 2445,
      "codigo_referencia_valor_dominio": "123105",
      "nome_resumido_valor_dominio": "DIRETOR ADMINISTRATIVO",
      "nome_completo_valor_dominio": "DIRETOR ADMINISTRATIVO",
      "descricao_conceito_valor_dominio": "DIRETOR ADMINISTRATIVO"
    },
    {
      "codigo_valor_dominio": 2446,
      "codigo_referencia_valor_dominio": "841315",
      "nome_resumido_valor_dominio": "OPERADOR DE MOENDA NA FABRICACAO DE ACUCAR",
      "nome_completo_valor_dominio": "OPERADOR DE MOENDA NA FABRICACAO DE ACUCAR",
      "descricao_conceito_valor_dominio": "OPERADOR DE MOENDA NA FABRICACAO DE ACUCAR"
    },
    {
      "codigo_valor_dominio": 2447,
      "codigo_referencia_valor_dominio": "780105",
      "nome_resumido_valor_dominio": "SUPERVISOR DE EMBALAGEM E ETIQUETAGEM",
      "nome_completo_valor_dominio": "SUPERVISOR DE EMBALAGEM E ETIQUETAGEM",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE EMBALAGEM E ETIQUETAGEM"
    },
    {
      "codigo_valor_dominio": 2448,
      "codigo_referencia_valor_dominio": "376220",
      "nome_resumido_valor_dominio": "CONTORCIONISTA",
      "nome_completo_valor_dominio": "CONTORCIONISTA",
      "descricao_conceito_valor_dominio": "CONTORCIONISTA"
    },
    {
      "codigo_valor_dominio": 2449,
      "codigo_referencia_valor_dominio": "413105",
      "nome_resumido_valor_dominio": "ANALISTA DE FOLHA DE PAGAMENTO",
      "nome_completo_valor_dominio": "ANALISTA DE FOLHA DE PAGAMENTO",
      "descricao_conceito_valor_dominio": "ANALISTA DE FOLHA DE PAGAMENTO"
    },
    {
      "codigo_valor_dominio": 2450,
      "codigo_referencia_valor_dominio": "413110",
      "nome_resumido_valor_dominio": "AUXILIAR DE CONTABILIDADE",
      "nome_completo_valor_dominio": "AUXILIAR DE CONTABILIDADE",
      "descricao_conceito_valor_dominio": "AUXILIAR DE CONTABILIDADE"
    },
    {
      "codigo_valor_dominio": 2451,
      "codigo_referencia_valor_dominio": "413115",
      "nome_resumido_valor_dominio": "AUXILIAR DE FATURAMENTO",
      "nome_completo_valor_dominio": "AUXILIAR DE FATURAMENTO",
      "descricao_conceito_valor_dominio": "AUXILIAR DE FATURAMENTO"
    },
    {
      "codigo_valor_dominio": 2452,
      "codigo_referencia_valor_dominio": "413205",
      "nome_resumido_valor_dominio": "ATENDENTE DE AGENCIA",
      "nome_completo_valor_dominio": "ATENDENTE DE AGENCIA",
      "descricao_conceito_valor_dominio": "ATENDENTE DE AGENCIA"
    },
    {
      "codigo_valor_dominio": 2453,
      "codigo_referencia_valor_dominio": "413210",
      "nome_resumido_valor_dominio": "CAIXA DE BANCO",
      "nome_completo_valor_dominio": "CAIXA DE BANCO",
      "descricao_conceito_valor_dominio": "CAIXA DE BANCO"
    },
    {
      "codigo_valor_dominio": 2454,
      "codigo_referencia_valor_dominio": "413215",
      "nome_resumido_valor_dominio": "COMPENSADOR DE BANCO",
      "nome_completo_valor_dominio": "COMPENSADOR DE BANCO",
      "descricao_conceito_valor_dominio": "COMPENSADOR DE BANCO"
    },
    {
      "codigo_valor_dominio": 2455,
      "codigo_referencia_valor_dominio": "516335",
      "nome_resumido_valor_dominio": "CONFERENTE-EXPEDIDOR DE ROUPAS (LAVANDERIAS)",
      "nome_completo_valor_dominio": "CONFERENTE-EXPEDIDOR DE ROUPAS (LAVANDERIAS)",
      "descricao_conceito_valor_dominio": "CONFERENTE-EXPEDIDOR DE ROUPAS (LAVANDERIAS)"
    },
    {
      "codigo_valor_dominio": 2456,
      "codigo_referencia_valor_dominio": "351420",
      "nome_resumido_valor_dominio": "ESCRIVAO DE POLICIA",
      "nome_completo_valor_dominio": "ESCRIVAO DE POLICIA",
      "descricao_conceito_valor_dominio": "ESCRIVAO DE POLICIA"
    },
    {
      "codigo_valor_dominio": 2457,
      "codigo_referencia_valor_dominio": "642005",
      "nome_resumido_valor_dominio": "OPERADOR DE COLHEDOR FLORESTAL",
      "nome_completo_valor_dominio": "OPERADOR DE COLHEDOR FLORESTAL",
      "descricao_conceito_valor_dominio": "OPERADOR DE COLHEDOR FLORESTAL"
    },
    {
      "codigo_valor_dominio": 2458,
      "codigo_referencia_valor_dominio": "414105",
      "nome_resumido_valor_dominio": "ALMOXARIFE",
      "nome_completo_valor_dominio": "ALMOXARIFE",
      "descricao_conceito_valor_dominio": "ALMOXARIFE"
    },
    {
      "codigo_valor_dominio": 2459,
      "codigo_referencia_valor_dominio": "414110",
      "nome_resumido_valor_dominio": "ARMAZENISTA",
      "nome_completo_valor_dominio": "ARMAZENISTA",
      "descricao_conceito_valor_dominio": "ARMAZENISTA"
    },
    {
      "codigo_valor_dominio": 2460,
      "codigo_referencia_valor_dominio": "414115",
      "nome_resumido_valor_dominio": "BALANCEIRO",
      "nome_completo_valor_dominio": "BALANCEIRO",
      "descricao_conceito_valor_dominio": "BALANCEIRO"
    },
    {
      "codigo_valor_dominio": 2461,
      "codigo_referencia_valor_dominio": "414205",
      "nome_resumido_valor_dominio": "APONTADOR DE MAO-DE-OBRA",
      "nome_completo_valor_dominio": "APONTADOR DE MAO-DE-OBRA",
      "descricao_conceito_valor_dominio": "APONTADOR DE MAO-DE-OBRA"
    },
    {
      "codigo_valor_dominio": 2462,
      "codigo_referencia_valor_dominio": "414210",
      "nome_resumido_valor_dominio": "APONTADOR DE PRODUCAO",
      "nome_completo_valor_dominio": "APONTADOR DE PRODUCAO",
      "descricao_conceito_valor_dominio": "APONTADOR DE PRODUCAO"
    },
    {
      "codigo_valor_dominio": 2463,
      "codigo_referencia_valor_dominio": "413220",
      "nome_resumido_valor_dominio": "CONFERENTE DE SERVICOS BANCARIOS",
      "nome_completo_valor_dominio": "CONFERENTE DE SERVICOS BANCARIOS",
      "descricao_conceito_valor_dominio": "CONFERENTE DE SERVICOS BANCARIOS"
    },
    {
      "codigo_valor_dominio": 2464,
      "codigo_referencia_valor_dominio": "415105",
      "nome_resumido_valor_dominio": "ARQUIVISTA DE DOCUMENTOS",
      "nome_completo_valor_dominio": "ARQUIVISTA DE DOCUMENTOS",
      "descricao_conceito_valor_dominio": "ARQUIVISTA DE DOCUMENTOS"
    },
    {
      "codigo_valor_dominio": 2465,
      "codigo_referencia_valor_dominio": "415115",
      "nome_resumido_valor_dominio": "CODIFICADOR DE DADOS",
      "nome_completo_valor_dominio": "CODIFICADOR DE DADOS",
      "descricao_conceito_valor_dominio": "CODIFICADOR DE DADOS"
    },
    {
      "codigo_valor_dominio": 2466,
      "codigo_referencia_valor_dominio": "862105",
      "nome_resumido_valor_dominio": "FOGUISTA (LOCOMOTIVAS A VAPOR)",
      "nome_completo_valor_dominio": "FOGUISTA (LOCOMOTIVAS A VAPOR)",
      "descricao_conceito_valor_dominio": "FOGUISTA (LOCOMOTIVAS A VAPOR)"
    },
    {
      "codigo_valor_dominio": 2467,
      "codigo_referencia_valor_dominio": "766405",
      "nome_resumido_valor_dominio": "LABORATORISTA FOTOGRAFICO",
      "nome_completo_valor_dominio": "LABORATORISTA FOTOGRAFICO",
      "descricao_conceito_valor_dominio": "LABORATORISTA FOTOGRAFICO"
    },
    {
      "codigo_valor_dominio": 2468,
      "codigo_referencia_valor_dominio": "711215",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA CORTADORA (MINAS E PEDREIRAS)",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA CORTADORA (MINAS E PEDREIRAS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA CORTADORA (MINAS E PEDREIRAS)"
    },
    {
      "codigo_valor_dominio": 2469,
      "codigo_referencia_valor_dominio": "415205",
      "nome_resumido_valor_dominio": "CARTEIRO",
      "nome_completo_valor_dominio": "CARTEIRO",
      "descricao_conceito_valor_dominio": "CARTEIRO"
    },
    {
      "codigo_valor_dominio": 2470,
      "codigo_referencia_valor_dominio": "773350",
      "nome_resumido_valor_dominio": "OPERADOR DE TUPIA (USINAGEM DE MADEIRA)",
      "nome_completo_valor_dominio": "OPERADOR DE TUPIA (USINAGEM DE MADEIRA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE TUPIA (USINAGEM DE MADEIRA)"
    },
    {
      "codigo_valor_dominio": 2471,
      "codigo_referencia_valor_dominio": "410210",
      "nome_resumido_valor_dominio": "SUPERVISOR DE CAMBIO",
      "nome_completo_valor_dominio": "SUPERVISOR DE CAMBIO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE CAMBIO"
    },
    {
      "codigo_valor_dominio": 2472,
      "codigo_referencia_valor_dominio": "420115",
      "nome_resumido_valor_dominio": "SUPERVISOR DE COLETADORES DE APOSTAS E DE JOGOS",
      "nome_completo_valor_dominio": "SUPERVISOR DE COLETADORES DE APOSTAS E DE JOGOS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE COLETADORES DE APOSTAS E DE JOGOS"
    },
    {
      "codigo_valor_dominio": 2473,
      "codigo_referencia_valor_dominio": "354210",
      "nome_resumido_valor_dominio": "SUPERVISOR DE COMPRAS",
      "nome_completo_valor_dominio": "SUPERVISOR DE COMPRAS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE COMPRAS"
    },
    {
      "codigo_valor_dominio": 2474,
      "codigo_referencia_valor_dominio": "620105",
      "nome_resumido_valor_dominio": "SUPERVISOR DE EXPLORACAO AGRICOLA",
      "nome_completo_valor_dominio": "SUPERVISOR DE EXPLORACAO AGRICOLA",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE EXPLORACAO AGRICOLA"
    },
    {
      "codigo_valor_dominio": 2475,
      "codigo_referencia_valor_dominio": "910905",
      "nome_resumido_valor_dominio": "SUPERVISOR DE REPAROS LINHAS FERREAS",
      "nome_completo_valor_dominio": "SUPERVISOR DE REPAROS LINHAS FERREAS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE REPAROS LINHAS FERREAS"
    },
    {
      "codigo_valor_dominio": 2476,
      "codigo_referencia_valor_dominio": "420135",
      "nome_resumido_valor_dominio": "SUPERVISOR DE TELEMARKETING E ATENDIMENTO",
      "nome_completo_valor_dominio": "SUPERVISOR DE TELEMARKETING E ATENDIMENTO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE TELEMARKETING E ATENDIMENTO"
    },
    {
      "codigo_valor_dominio": 2477,
      "codigo_referencia_valor_dominio": "410235",
      "nome_resumido_valor_dominio": "SUPERVISOR DE TESOURARIA",
      "nome_completo_valor_dominio": "SUPERVISOR DE TESOURARIA",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE TESOURARIA"
    },
    {
      "codigo_valor_dominio": 2478,
      "codigo_referencia_valor_dominio": "421105",
      "nome_resumido_valor_dominio": "ATENDENTE COMERCIAL (AGENCIA POSTAL)",
      "nome_completo_valor_dominio": "ATENDENTE COMERCIAL (AGENCIA POSTAL)",
      "descricao_conceito_valor_dominio": "ATENDENTE COMERCIAL (AGENCIA POSTAL)"
    },
    {
      "codigo_valor_dominio": 2479,
      "codigo_referencia_valor_dominio": "421110",
      "nome_resumido_valor_dominio": "BILHETEIRO DE TRANSPORTES COLETIVOS",
      "nome_completo_valor_dominio": "BILHETEIRO DE TRANSPORTES COLETIVOS",
      "descricao_conceito_valor_dominio": "BILHETEIRO DE TRANSPORTES COLETIVOS"
    },
    {
      "codigo_valor_dominio": 2480,
      "codigo_referencia_valor_dominio": "421115",
      "nome_resumido_valor_dominio": "BILHETEIRO NO SERVICO DE DIVERSOES",
      "nome_completo_valor_dominio": "BILHETEIRO NO SERVICO DE DIVERSOES",
      "descricao_conceito_valor_dominio": "BILHETEIRO NO SERVICO DE DIVERSOES"
    },
    {
      "codigo_valor_dominio": 2481,
      "codigo_referencia_valor_dominio": "512105",
      "nome_resumido_valor_dominio": "EMPREGADO DOMESTICO NOS SERVICOS GERAIS",
      "nome_completo_valor_dominio": "EMPREGADO DOMESTICO NOS SERVICOS GERAIS",
      "descricao_conceito_valor_dominio": "EMPREGADO DOMESTICO NOS SERVICOS GERAIS"
    },
    {
      "codigo_valor_dominio": 2482,
      "codigo_referencia_valor_dominio": "813110",
      "nome_resumido_valor_dominio": "OPERADOR DE CALANDRA (QUIMICA, PETROQUIMICA E AFINS)",
      "nome_completo_valor_dominio": "OPERADOR DE CALANDRA (QUIMICA, PETROQUIMICA E AFINS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE CALANDRA (QUIMICA, PETROQUIMICA E AFINS)"
    },
    {
      "codigo_valor_dominio": 2483,
      "codigo_referencia_valor_dominio": "421210",
      "nome_resumido_valor_dominio": "RECEBEDOR DE APOSTAS (TURFE)",
      "nome_completo_valor_dominio": "RECEBEDOR DE APOSTAS (TURFE)",
      "descricao_conceito_valor_dominio": "RECEBEDOR DE APOSTAS (TURFE)"
    },
    {
      "codigo_valor_dominio": 2484,
      "codigo_referencia_valor_dominio": "422125",
      "nome_resumido_valor_dominio": "RECEPCIONISTA DE BANCO",
      "nome_completo_valor_dominio": "RECEPCIONISTA DE BANCO",
      "descricao_conceito_valor_dominio": "RECEPCIONISTA DE BANCO"
    },
    {
      "codigo_valor_dominio": 2485,
      "codigo_referencia_valor_dominio": "421305",
      "nome_resumido_valor_dominio": "COBRADOR EXTERNO",
      "nome_completo_valor_dominio": "COBRADOR EXTERNO",
      "descricao_conceito_valor_dominio": "COBRADOR EXTERNO"
    },
    {
      "codigo_valor_dominio": 2486,
      "codigo_referencia_valor_dominio": "421310",
      "nome_resumido_valor_dominio": "COBRADOR INTERNO",
      "nome_completo_valor_dominio": "COBRADOR INTERNO",
      "descricao_conceito_valor_dominio": "COBRADOR INTERNO"
    },
    {
      "codigo_valor_dominio": 2487,
      "codigo_referencia_valor_dominio": "261715",
      "nome_resumido_valor_dominio": "LOCUTOR DE RADIO E TELEVISAO",
      "nome_completo_valor_dominio": "LOCUTOR DE RADIO E TELEVISAO",
      "descricao_conceito_valor_dominio": "LOCUTOR DE RADIO E TELEVISAO"
    },
    {
      "codigo_valor_dominio": 2488,
      "codigo_referencia_valor_dominio": "371410",
      "nome_resumido_valor_dominio": "RECREADOR",
      "nome_completo_valor_dominio": "RECREADOR",
      "descricao_conceito_valor_dominio": "RECREADOR"
    },
    {
      "codigo_valor_dominio": 2489,
      "codigo_referencia_valor_dominio": "422120",
      "nome_resumido_valor_dominio": "RECEPCIONISTA DE HOTEL",
      "nome_completo_valor_dominio": "RECEPCIONISTA DE HOTEL",
      "descricao_conceito_valor_dominio": "RECEPCIONISTA DE HOTEL"
    },
    {
      "codigo_valor_dominio": 2490,
      "codigo_referencia_valor_dominio": "422105",
      "nome_resumido_valor_dominio": "RECEPCIONISTA, EM GERAL",
      "nome_completo_valor_dominio": "RECEPCIONISTA, EM GERAL",
      "descricao_conceito_valor_dominio": "RECEPCIONISTA, EM GERAL"
    },
    {
      "codigo_valor_dominio": 2491,
      "codigo_referencia_valor_dominio": "422115",
      "nome_resumido_valor_dominio": "RECEPCIONISTA DE SEGURO SAUDE",
      "nome_completo_valor_dominio": "RECEPCIONISTA DE SEGURO SAUDE",
      "descricao_conceito_valor_dominio": "RECEPCIONISTA DE SEGURO SAUDE"
    },
    {
      "codigo_valor_dominio": 2492,
      "codigo_referencia_valor_dominio": "519945",
      "nome_resumido_valor_dominio": "RECEPCIONISTA DE CASAS DE ESPETACULOS",
      "nome_completo_valor_dominio": "RECEPCIONISTA DE CASAS DE ESPETACULOS",
      "descricao_conceito_valor_dominio": "RECEPCIONISTA DE CASAS DE ESPETACULOS"
    },
    {
      "codigo_valor_dominio": 2493,
      "codigo_referencia_valor_dominio": "422210",
      "nome_resumido_valor_dominio": "TELEOPERADOR",
      "nome_completo_valor_dominio": "TELEOPERADOR",
      "descricao_conceito_valor_dominio": "TELEOPERADOR"
    },
    {
      "codigo_valor_dominio": 2494,
      "codigo_referencia_valor_dominio": "716205",
      "nome_resumido_valor_dominio": "TELHADOR (TELHAS DE ARGILA E MATERIAIS SIMILARES)",
      "nome_completo_valor_dominio": "TELHADOR (TELHAS DE ARGILA E MATERIAIS SIMILARES)",
      "descricao_conceito_valor_dominio": "TELHADOR (TELHAS DE ARGILA E MATERIAIS SIMILARES)"
    },
    {
      "codigo_valor_dominio": 2495,
      "codigo_referencia_valor_dominio": "334115",
      "nome_resumido_valor_dominio": "MONITOR DE TRANSPORTE ESCOLAR",
      "nome_completo_valor_dominio": "MONITOR DE TRANSPORTE ESCOLAR",
      "descricao_conceito_valor_dominio": "MONITOR DE TRANSPORTE ESCOLAR"
    },
    {
      "codigo_valor_dominio": 2496,
      "codigo_referencia_valor_dominio": "761435",
      "nome_resumido_valor_dominio": "OPERADOR DE RAMEUSE",
      "nome_completo_valor_dominio": "OPERADOR DE RAMEUSE",
      "descricao_conceito_valor_dominio": "OPERADOR DE RAMEUSE"
    },
    {
      "codigo_valor_dominio": 2497,
      "codigo_referencia_valor_dominio": "422310",
      "nome_resumido_valor_dominio": "OPERADOR DE TELEMARKETING ATIVO E RECEPTIVO",
      "nome_completo_valor_dominio": "OPERADOR DE TELEMARKETING ATIVO E RECEPTIVO",
      "descricao_conceito_valor_dominio": "OPERADOR DE TELEMARKETING ATIVO E RECEPTIVO"
    },
    {
      "codigo_valor_dominio": 2498,
      "codigo_referencia_valor_dominio": "422315",
      "nome_resumido_valor_dominio": "OPERADOR DE TELEMARKETING RECEPTIVO",
      "nome_completo_valor_dominio": "OPERADOR DE TELEMARKETING RECEPTIVO",
      "descricao_conceito_valor_dominio": "OPERADOR DE TELEMARKETING RECEPTIVO"
    },
    {
      "codigo_valor_dominio": 2499,
      "codigo_referencia_valor_dominio": "422320",
      "nome_resumido_valor_dominio": "OPERADOR DE TELEMARKETING TECNICO",
      "nome_completo_valor_dominio": "OPERADOR DE TELEMARKETING TECNICO",
      "descricao_conceito_valor_dominio": "OPERADOR DE TELEMARKETING TECNICO"
    },
    {
      "codigo_valor_dominio": 2500,
      "codigo_referencia_valor_dominio": "821440",
      "nome_resumido_valor_dominio": "OPERADOR DE TESOURA MECANICA E MAQUINA DE CORTE, NO ACABAMEN",
      "nome_completo_valor_dominio": "OPERADOR DE TESOURA MECANICA E MAQUINA DE CORTE, NO ACABAMENTO DE CHAPAS E METAIS",
      "descricao_conceito_valor_dominio": "OPERADOR DE TESOURA MECANICA E MAQUINA DE CORTE, NO ACABAMENTO DE CHAPAS E METAIS"
    },
    {
      "codigo_valor_dominio": 2501,
      "codigo_referencia_valor_dominio": "342510",
      "nome_resumido_valor_dominio": "DESPACHANTE OPERACIONAL DE VOO",
      "nome_completo_valor_dominio": "DESPACHANTE OPERACIONAL DE VOO",
      "descricao_conceito_valor_dominio": "DESPACHANTE OPERACIONAL DE VOO"
    },
    {
      "codigo_valor_dominio": 2502,
      "codigo_referencia_valor_dominio": "511210",
      "nome_resumido_valor_dominio": "DESPACHANTE DE TRANSPORTES COLETIVOS (EXCETO TREM)",
      "nome_completo_valor_dominio": "DESPACHANTE DE TRANSPORTES COLETIVOS (EXCETO TREM)",
      "descricao_conceito_valor_dominio": "DESPACHANTE DE TRANSPORTES COLETIVOS (EXCETO TREM)"
    },
    {
      "codigo_valor_dominio": 2503,
      "codigo_referencia_valor_dominio": "424110",
      "nome_resumido_valor_dominio": "ENTREVISTADOR DE PESQUISA DE OPINIAO E MIDIA",
      "nome_completo_valor_dominio": "ENTREVISTADOR DE PESQUISA DE OPINIAO E MIDIA",
      "descricao_conceito_valor_dominio": "ENTREVISTADOR DE PESQUISA DE OPINIAO E MIDIA"
    },
    {
      "codigo_valor_dominio": 2504,
      "codigo_referencia_valor_dominio": "424115",
      "nome_resumido_valor_dominio": "ENTREVISTADOR DE PESQUISAS DE MERCADO",
      "nome_completo_valor_dominio": "ENTREVISTADOR DE PESQUISAS DE MERCADO",
      "descricao_conceito_valor_dominio": "ENTREVISTADOR DE PESQUISAS DE MERCADO"
    },
    {
      "codigo_valor_dominio": 2505,
      "codigo_referencia_valor_dominio": "424120",
      "nome_resumido_valor_dominio": "ENTREVISTADOR DE PRECOS",
      "nome_completo_valor_dominio": "ENTREVISTADOR DE PRECOS",
      "descricao_conceito_valor_dominio": "ENTREVISTADOR DE PRECOS"
    },
    {
      "codigo_valor_dominio": 2506,
      "codigo_referencia_valor_dominio": "762215",
      "nome_resumido_valor_dominio": "ENXUGADOR DE COUROS",
      "nome_completo_valor_dominio": "ENXUGADOR DE COUROS",
      "descricao_conceito_valor_dominio": "ENXUGADOR DE COUROS"
    },
    {
      "codigo_valor_dominio": 2507,
      "codigo_referencia_valor_dominio": "413225",
      "nome_resumido_valor_dominio": "ESCRITURARIO DE BANCO",
      "nome_completo_valor_dominio": "ESCRITURARIO DE BANCO",
      "descricao_conceito_valor_dominio": "ESCRITURARIO DE BANCO"
    },
    {
      "codigo_valor_dominio": 2508,
      "codigo_referencia_valor_dominio": "710220",
      "nome_resumido_valor_dominio": "SUPERVISOR DE USINA DE CONCRETO",
      "nome_completo_valor_dominio": "SUPERVISOR DE USINA DE CONCRETO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE USINA DE CONCRETO"
    },
    {
      "codigo_valor_dominio": 2509,
      "codigo_referencia_valor_dominio": "510110",
      "nome_resumido_valor_dominio": "ADMINISTRADOR DE EDIFICIOS",
      "nome_completo_valor_dominio": "ADMINISTRADOR DE EDIFICIOS",
      "descricao_conceito_valor_dominio": "ADMINISTRADOR DE EDIFICIOS"
    },
    {
      "codigo_valor_dominio": 2510,
      "codigo_referencia_valor_dominio": "710105",
      "nome_resumido_valor_dominio": "SUPERVISOR DE APOIO OPERACIONAL NA MINERACAO",
      "nome_completo_valor_dominio": "SUPERVISOR DE APOIO OPERACIONAL NA MINERACAO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE APOIO OPERACIONAL NA MINERACAO"
    },
    {
      "codigo_valor_dominio": 2511,
      "codigo_referencia_valor_dominio": "510120",
      "nome_resumido_valor_dominio": "CHEFE DE PORTARIA DE HOTEL",
      "nome_completo_valor_dominio": "CHEFE DE PORTARIA DE HOTEL",
      "descricao_conceito_valor_dominio": "CHEFE DE PORTARIA DE HOTEL"
    },
    {
      "codigo_valor_dominio": 2512,
      "codigo_referencia_valor_dominio": "510130",
      "nome_resumido_valor_dominio": "CHEFE DE BAR",
      "nome_completo_valor_dominio": "CHEFE DE BAR",
      "descricao_conceito_valor_dominio": "CHEFE DE BAR"
    },
    {
      "codigo_valor_dominio": 2513,
      "codigo_referencia_valor_dominio": "030110",
      "nome_resumido_valor_dominio": "MAJOR BOMBEIRO MILITAR",
      "nome_completo_valor_dominio": "MAJOR BOMBEIRO MILITAR",
      "descricao_conceito_valor_dominio": "MAJOR BOMBEIRO MILITAR"
    },
    {
      "codigo_valor_dominio": 2514,
      "codigo_referencia_valor_dominio": "910110",
      "nome_resumido_valor_dominio": "SUPERVISOR DE MANUTENCAO DE APARELHOS TERMICOS, DE CLIMATIZA",
      "nome_completo_valor_dominio": "SUPERVISOR DE MANUTENCAO DE APARELHOS TERMICOS, DE CLIMATIZACAO E DE REFRIGERACAO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE MANUTENCAO DE APARELHOS TERMICOS, DE CLIMATIZACAO E DE REFRIGERACAO"
    },
    {
      "codigo_valor_dominio": 2515,
      "codigo_referencia_valor_dominio": "420105",
      "nome_resumido_valor_dominio": "SUPERVISOR DE CAIXAS E BILHETEIROS (EXCETO CAIXA DE BANCO)",
      "nome_completo_valor_dominio": "SUPERVISOR DE CAIXAS E BILHETEIROS (EXCETO CAIXA DE BANCO)",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE CAIXAS E BILHETEIROS (EXCETO CAIXA DE BANCO)"
    },
    {
      "codigo_valor_dominio": 2516,
      "codigo_referencia_valor_dominio": "373220",
      "nome_resumido_valor_dominio": "SUPERVISOR TECNICO OPERACIONAL DE SISTEMAS DE TELEVISAO E PR",
      "nome_completo_valor_dominio": "SUPERVISOR TECNICO OPERACIONAL DE SISTEMAS DE TELEVISAO E PRODUTORAS DE VIDEO",
      "descricao_conceito_valor_dominio": "SUPERVISOR TECNICO OPERACIONAL DE SISTEMAS DE TELEVISAO E PRODUTORAS DE VIDEO"
    },
    {
      "codigo_valor_dominio": 2517,
      "codigo_referencia_valor_dominio": "511105",
      "nome_resumido_valor_dominio": "COMISSARIO DE VOO",
      "nome_completo_valor_dominio": "COMISSARIO DE VOO",
      "descricao_conceito_valor_dominio": "COMISSARIO DE VOO"
    },
    {
      "codigo_valor_dominio": 2518,
      "codigo_referencia_valor_dominio": "511110",
      "nome_resumido_valor_dominio": "COMISSARIO DE TREM",
      "nome_completo_valor_dominio": "COMISSARIO DE TREM",
      "descricao_conceito_valor_dominio": "COMISSARIO DE TREM"
    },
    {
      "codigo_valor_dominio": 2519,
      "codigo_referencia_valor_dominio": "771120",
      "nome_resumido_valor_dominio": "TANOEIRO",
      "nome_completo_valor_dominio": "TANOEIRO",
      "descricao_conceito_valor_dominio": "TANOEIRO"
    },
    {
      "codigo_valor_dominio": 2520,
      "codigo_referencia_valor_dominio": "254405",
      "nome_resumido_valor_dominio": "FISCAL DE TRIBUTOS ESTADUAL",
      "nome_completo_valor_dominio": "FISCAL DE TRIBUTOS ESTADUAL",
      "descricao_conceito_valor_dominio": "FISCAL DE TRIBUTOS ESTADUAL"
    },
    {
      "codigo_valor_dominio": 2521,
      "codigo_referencia_valor_dominio": "423105",
      "nome_resumido_valor_dominio": "DESPACHANTE DOCUMENTALISTA",
      "nome_completo_valor_dominio": "DESPACHANTE DOCUMENTALISTA",
      "descricao_conceito_valor_dominio": "DESPACHANTE DOCUMENTALISTA"
    },
    {
      "codigo_valor_dominio": 2522,
      "codigo_referencia_valor_dominio": "511215",
      "nome_resumido_valor_dominio": "COBRADOR DE TRANSPORTES COLETIVOS (EXCETO TREM)",
      "nome_completo_valor_dominio": "COBRADOR DE TRANSPORTES COLETIVOS (EXCETO TREM)",
      "descricao_conceito_valor_dominio": "COBRADOR DE TRANSPORTES COLETIVOS (EXCETO TREM)"
    },
    {
      "codigo_valor_dominio": 2523,
      "codigo_referencia_valor_dominio": "511220",
      "nome_resumido_valor_dominio": "BILHETEIRO (ESTACOES DE METRO, FERROVIARIAS E ASSEMELHADAS)",
      "nome_completo_valor_dominio": "BILHETEIRO (ESTACOES DE METRO, FERROVIARIAS E ASSEMELHADAS)",
      "descricao_conceito_valor_dominio": "BILHETEIRO (ESTACOES DE METRO, FERROVIARIAS E ASSEMELHADAS)"
    },
    {
      "codigo_valor_dominio": 2524,
      "codigo_referencia_valor_dominio": "632005",
      "nome_resumido_valor_dominio": "GUIA FLORESTAL",
      "nome_completo_valor_dominio": "GUIA FLORESTAL",
      "descricao_conceito_valor_dominio": "GUIA FLORESTAL"
    },
    {
      "codigo_valor_dominio": 2525,
      "codigo_referencia_valor_dominio": "512110",
      "nome_resumido_valor_dominio": "EMPREGADO DOMESTICO ARRUMADOR",
      "nome_completo_valor_dominio": "EMPREGADO DOMESTICO ARRUMADOR",
      "descricao_conceito_valor_dominio": "EMPREGADO DOMESTICO ARRUMADOR"
    },
    {
      "codigo_valor_dominio": 2526,
      "codigo_referencia_valor_dominio": "512115",
      "nome_resumido_valor_dominio": "EMPREGADO DOMESTICO FAXINEIRO",
      "nome_completo_valor_dominio": "EMPREGADO DOMESTICO FAXINEIRO",
      "descricao_conceito_valor_dominio": "EMPREGADO DOMESTICO FAXINEIRO"
    },
    {
      "codigo_valor_dominio": 2527,
      "codigo_referencia_valor_dominio": "512120",
      "nome_resumido_valor_dominio": "EMPREGADO DOMESTICO DIARISTA",
      "nome_completo_valor_dominio": "EMPREGADO DOMESTICO DIARISTA",
      "descricao_conceito_valor_dominio": "EMPREGADO DOMESTICO DIARISTA"
    },
    {
      "codigo_valor_dominio": 2528,
      "codigo_referencia_valor_dominio": "724110",
      "nome_resumido_valor_dominio": "ENCANADOR",
      "nome_completo_valor_dominio": "ENCANADOR",
      "descricao_conceito_valor_dominio": "ENCANADOR"
    },
    {
      "codigo_valor_dominio": 2529,
      "codigo_referencia_valor_dominio": "716530",
      "nome_resumido_valor_dominio": "MOSAISTA",
      "nome_completo_valor_dominio": "MOSAISTA",
      "descricao_conceito_valor_dominio": "MOSAISTA"
    },
    {
      "codigo_valor_dominio": 2530,
      "codigo_referencia_valor_dominio": "513105",
      "nome_resumido_valor_dominio": "MORDOMO DE RESIDENCIA",
      "nome_completo_valor_dominio": "MORDOMO DE RESIDENCIA",
      "descricao_conceito_valor_dominio": "MORDOMO DE RESIDENCIA"
    },
    {
      "codigo_valor_dominio": 2531,
      "codigo_referencia_valor_dominio": "751115",
      "nome_resumido_valor_dominio": "GRAVADOR (JOALHERIA E OURIVESARIA)",
      "nome_completo_valor_dominio": "GRAVADOR (JOALHERIA E OURIVESARIA)",
      "descricao_conceito_valor_dominio": "GRAVADOR (JOALHERIA E OURIVESARIA)"
    },
    {
      "codigo_valor_dominio": 2532,
      "codigo_referencia_valor_dominio": "513215",
      "nome_resumido_valor_dominio": "COZINHEIRO INDUSTRIAL",
      "nome_completo_valor_dominio": "COZINHEIRO INDUSTRIAL",
      "descricao_conceito_valor_dominio": "COZINHEIRO INDUSTRIAL"
    },
    {
      "codigo_valor_dominio": 2533,
      "codigo_referencia_valor_dominio": "513205",
      "nome_resumido_valor_dominio": "COZINHEIRO GERAL",
      "nome_completo_valor_dominio": "COZINHEIRO GERAL",
      "descricao_conceito_valor_dominio": "COZINHEIRO GERAL"
    },
    {
      "codigo_valor_dominio": 2534,
      "codigo_referencia_valor_dominio": "613010",
      "nome_resumido_valor_dominio": "CRIADOR DE ANIMAIS DOMESTICOS",
      "nome_completo_valor_dominio": "CRIADOR DE ANIMAIS DOMESTICOS",
      "descricao_conceito_valor_dominio": "CRIADOR DE ANIMAIS DOMESTICOS"
    },
    {
      "codigo_valor_dominio": 2535,
      "codigo_referencia_valor_dominio": "513210",
      "nome_resumido_valor_dominio": "COZINHEIRO DO SERVICO DOMESTICO",
      "nome_completo_valor_dominio": "COZINHEIRO DO SERVICO DOMESTICO",
      "descricao_conceito_valor_dominio": "COZINHEIRO DO SERVICO DOMESTICO"
    },
    {
      "codigo_valor_dominio": 2536,
      "codigo_referencia_valor_dominio": "513220",
      "nome_resumido_valor_dominio": "COZINHEIRO DE HOSPITAL",
      "nome_completo_valor_dominio": "COZINHEIRO DE HOSPITAL",
      "descricao_conceito_valor_dominio": "COZINHEIRO DE HOSPITAL"
    },
    {
      "codigo_valor_dominio": 2537,
      "codigo_referencia_valor_dominio": "513305",
      "nome_resumido_valor_dominio": "CAMAREIRA DE TEATRO",
      "nome_completo_valor_dominio": "CAMAREIRA DE TEATRO",
      "descricao_conceito_valor_dominio": "CAMAREIRA DE TEATRO"
    },
    {
      "codigo_valor_dominio": 2538,
      "codigo_referencia_valor_dominio": "513310",
      "nome_resumido_valor_dominio": "CAMAREIRA DE TELEVISAO",
      "nome_completo_valor_dominio": "CAMAREIRA DE TELEVISAO",
      "descricao_conceito_valor_dominio": "CAMAREIRA DE TELEVISAO"
    },
    {
      "codigo_valor_dominio": 2539,
      "codigo_referencia_valor_dominio": "513315",
      "nome_resumido_valor_dominio": "CAMAREIRO DE HOTEL",
      "nome_completo_valor_dominio": "CAMAREIRO DE HOTEL",
      "descricao_conceito_valor_dominio": "CAMAREIRO DE HOTEL"
    },
    {
      "codigo_valor_dominio": 2540,
      "codigo_referencia_valor_dominio": "513320",
      "nome_resumido_valor_dominio": "CAMAREIRO DE EMBARCACOES",
      "nome_completo_valor_dominio": "CAMAREIRO DE EMBARCACOES",
      "descricao_conceito_valor_dominio": "CAMAREIRO DE EMBARCACOES"
    },
    {
      "codigo_valor_dominio": 2541,
      "codigo_referencia_valor_dominio": "519925",
      "nome_resumido_valor_dominio": "GUARDADOR DE VEICULOS",
      "nome_completo_valor_dominio": "GUARDADOR DE VEICULOS",
      "descricao_conceito_valor_dominio": "GUARDADOR DE VEICULOS"
    },
    {
      "codigo_valor_dominio": 2542,
      "codigo_referencia_valor_dominio": "513410",
      "nome_resumido_valor_dominio": "GARCOM (SERVICOS DE VINHOS)",
      "nome_completo_valor_dominio": "GARCOM (SERVICOS DE VINHOS)",
      "descricao_conceito_valor_dominio": "GARCOM (SERVICOS DE VINHOS)"
    },
    {
      "codigo_valor_dominio": 2543,
      "codigo_referencia_valor_dominio": "711405",
      "nome_resumido_valor_dominio": "GARIMPEIRO",
      "nome_completo_valor_dominio": "GARIMPEIRO",
      "descricao_conceito_valor_dominio": "GARIMPEIRO"
    },
    {
      "codigo_valor_dominio": 2544,
      "codigo_referencia_valor_dominio": "613310",
      "nome_resumido_valor_dominio": "CUNICULTOR",
      "nome_completo_valor_dominio": "CUNICULTOR",
      "descricao_conceito_valor_dominio": "CUNICULTOR"
    },
    {
      "codigo_valor_dominio": 2545,
      "codigo_referencia_valor_dominio": "513420",
      "nome_resumido_valor_dominio": "BARMAN",
      "nome_completo_valor_dominio": "BARMAN",
      "descricao_conceito_valor_dominio": "BARMAN"
    },
    {
      "codigo_valor_dominio": 2546,
      "codigo_referencia_valor_dominio": "513430",
      "nome_resumido_valor_dominio": "COPEIRO DE HOSPITAL",
      "nome_completo_valor_dominio": "COPEIRO DE HOSPITAL",
      "descricao_conceito_valor_dominio": "COPEIRO DE HOSPITAL"
    },
    {
      "codigo_valor_dominio": 2547,
      "codigo_referencia_valor_dominio": "766105",
      "nome_resumido_valor_dominio": "COPIADOR DE CHAPA",
      "nome_completo_valor_dominio": "COPIADOR DE CHAPA",
      "descricao_conceito_valor_dominio": "COPIADOR DE CHAPA"
    },
    {
      "codigo_valor_dominio": 2548,
      "codigo_referencia_valor_dominio": "513435",
      "nome_resumido_valor_dominio": "ATENDENTE DE LANCHONETE",
      "nome_completo_valor_dominio": "ATENDENTE DE LANCHONETE",
      "descricao_conceito_valor_dominio": "ATENDENTE DE LANCHONETE"
    },
    {
      "codigo_valor_dominio": 2549,
      "codigo_referencia_valor_dominio": "513505",
      "nome_resumido_valor_dominio": "AUXILIAR NOS SERVICOS DE ALIMENTACAO",
      "nome_completo_valor_dominio": "AUXILIAR NOS SERVICOS DE ALIMENTACAO",
      "descricao_conceito_valor_dominio": "AUXILIAR NOS SERVICOS DE ALIMENTACAO"
    },
    {
      "codigo_valor_dominio": 2550,
      "codigo_referencia_valor_dominio": "513605",
      "nome_resumido_valor_dominio": "CHURRASQUEIRO",
      "nome_completo_valor_dominio": "CHURRASQUEIRO",
      "descricao_conceito_valor_dominio": "CHURRASQUEIRO"
    },
    {
      "codigo_valor_dominio": 2551,
      "codigo_referencia_valor_dominio": "391120",
      "nome_resumido_valor_dominio": "PLANEJISTA",
      "nome_completo_valor_dominio": "PLANEJISTA",
      "descricao_conceito_valor_dominio": "PLANEJISTA"
    },
    {
      "codigo_valor_dominio": 2552,
      "codigo_referencia_valor_dominio": "241335",
      "nome_resumido_valor_dominio": "TABELIAO DE NOTAS",
      "nome_completo_valor_dominio": "TABELIAO DE NOTAS",
      "descricao_conceito_valor_dominio": "TABELIAO DE NOTAS"
    },
    {
      "codigo_valor_dominio": 2553,
      "codigo_referencia_valor_dominio": "514105",
      "nome_resumido_valor_dominio": "ASCENSORISTA",
      "nome_completo_valor_dominio": "ASCENSORISTA",
      "descricao_conceito_valor_dominio": "ASCENSORISTA"
    },
    {
      "codigo_valor_dominio": 2554,
      "codigo_referencia_valor_dominio": "513405",
      "nome_resumido_valor_dominio": "GARCOM",
      "nome_completo_valor_dominio": "GARCOM",
      "descricao_conceito_valor_dominio": "GARCOM"
    },
    {
      "codigo_valor_dominio": 2555,
      "codigo_referencia_valor_dominio": "848110",
      "nome_resumido_valor_dominio": "SALGADOR DE ALIMENTOS",
      "nome_completo_valor_dominio": "SALGADOR DE ALIMENTOS",
      "descricao_conceito_valor_dominio": "SALGADOR DE ALIMENTOS"
    },
    {
      "codigo_valor_dominio": 2556,
      "codigo_referencia_valor_dominio": "223310",
      "nome_resumido_valor_dominio": "ZOOTECNISTA",
      "nome_completo_valor_dominio": "ZOOTECNISTA",
      "descricao_conceito_valor_dominio": "ZOOTECNISTA"
    },
    {
      "codigo_valor_dominio": 2557,
      "codigo_referencia_valor_dominio": "514205",
      "nome_resumido_valor_dominio": "COLETOR DE LIXO DOMICILIAR",
      "nome_completo_valor_dominio": "COLETOR DE LIXO DOMICILIAR",
      "descricao_conceito_valor_dominio": "COLETOR DE LIXO DOMICILIAR"
    },
    {
      "codigo_valor_dominio": 2558,
      "codigo_referencia_valor_dominio": "776430",
      "nome_resumido_valor_dominio": "VASSOUREIRO",
      "nome_completo_valor_dominio": "VASSOUREIRO",
      "descricao_conceito_valor_dominio": "VASSOUREIRO"
    },
    {
      "codigo_valor_dominio": 2559,
      "codigo_referencia_valor_dominio": "841505",
      "nome_resumido_valor_dominio": "TRABALHADOR DE TRATAMENTO DO LEITE E FABRICACAO DE LATICINIO",
      "nome_completo_valor_dominio": "TRABALHADOR DE TRATAMENTO DO LEITE E FABRICACAO DE LATICINIOS E AFINS",
      "descricao_conceito_valor_dominio": "TRABALHADOR DE TRATAMENTO DO LEITE E FABRICACAO DE LATICINIOS E AFINS"
    },
    {
      "codigo_valor_dominio": 2560,
      "codigo_referencia_valor_dominio": "514230",
      "nome_resumido_valor_dominio": "COLETOR DE RESIDUOS SOLIDOS DE SERVICOS DE SAUDE",
      "nome_completo_valor_dominio": "COLETOR DE RESIDUOS SOLIDOS DE SERVICOS DE SAUDE",
      "descricao_conceito_valor_dominio": "COLETOR DE RESIDUOS SOLIDOS DE SERVICOS DE SAUDE"
    },
    {
      "codigo_valor_dominio": 2561,
      "codigo_referencia_valor_dominio": "722210",
      "nome_resumido_valor_dominio": "LINGOTADOR",
      "nome_completo_valor_dominio": "LINGOTADOR",
      "descricao_conceito_valor_dominio": "LINGOTADOR"
    },
    {
      "codigo_valor_dominio": 2562,
      "codigo_referencia_valor_dominio": "514310",
      "nome_resumido_valor_dominio": "AUXILIAR DE MANUTENCAO PREDIAL",
      "nome_completo_valor_dominio": "AUXILIAR DE MANUTENCAO PREDIAL",
      "descricao_conceito_valor_dominio": "AUXILIAR DE MANUTENCAO PREDIAL"
    },
    {
      "codigo_valor_dominio": 2563,
      "codigo_referencia_valor_dominio": "514330",
      "nome_resumido_valor_dominio": "LIMPADOR DE PISCINAS",
      "nome_completo_valor_dominio": "LIMPADOR DE PISCINAS",
      "descricao_conceito_valor_dominio": "LIMPADOR DE PISCINAS"
    },
    {
      "codigo_valor_dominio": 2564,
      "codigo_referencia_valor_dominio": "524205",
      "nome_resumido_valor_dominio": "FEIRANTE",
      "nome_completo_valor_dominio": "FEIRANTE",
      "descricao_conceito_valor_dominio": "FEIRANTE"
    },
    {
      "codigo_valor_dominio": 2565,
      "codigo_referencia_valor_dominio": "623210",
      "nome_resumido_valor_dominio": "TRABALHADOR DA OVINOCULTURA",
      "nome_completo_valor_dominio": "TRABALHADOR DA OVINOCULTURA",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA OVINOCULTURA"
    },
    {
      "codigo_valor_dominio": 2566,
      "codigo_referencia_valor_dominio": "516410",
      "nome_resumido_valor_dominio": "LIMPADOR DE ROUPAS A SECO, A MAO",
      "nome_completo_valor_dominio": "LIMPADOR DE ROUPAS A SECO, A MAO",
      "descricao_conceito_valor_dominio": "LIMPADOR DE ROUPAS A SECO, A MAO"
    },
    {
      "codigo_valor_dominio": 2567,
      "codigo_referencia_valor_dominio": "515105",
      "nome_resumido_valor_dominio": "AGENTE COMUNITARIO DE SAUDE",
      "nome_completo_valor_dominio": "AGENTE COMUNITARIO DE SAUDE",
      "descricao_conceito_valor_dominio": "AGENTE COMUNITARIO DE SAUDE"
    },
    {
      "codigo_valor_dominio": 2568,
      "codigo_referencia_valor_dominio": "515110",
      "nome_resumido_valor_dominio": "ATENDENTE DE ENFERMAGEM",
      "nome_completo_valor_dominio": "ATENDENTE DE ENFERMAGEM",
      "descricao_conceito_valor_dominio": "ATENDENTE DE ENFERMAGEM"
    },
    {
      "codigo_valor_dominio": 2569,
      "codigo_referencia_valor_dominio": "763325",
      "nome_resumido_valor_dominio": "PASSADEIRA DE PECAS CONFECCIONADAS",
      "nome_completo_valor_dominio": "PASSADEIRA DE PECAS CONFECCIONADAS",
      "descricao_conceito_valor_dominio": "PASSADEIRA DE PECAS CONFECCIONADAS"
    },
    {
      "codigo_valor_dominio": 2570,
      "codigo_referencia_valor_dominio": "215150",
      "nome_resumido_valor_dominio": "VISTORIADOR NAVAL",
      "nome_completo_valor_dominio": "VISTORIADOR NAVAL",
      "descricao_conceito_valor_dominio": "VISTORIADOR NAVAL"
    },
    {
      "codigo_valor_dominio": 2571,
      "codigo_referencia_valor_dominio": "515125",
      "nome_resumido_valor_dominio": "AGENTE INDIGENA DE SAUDE",
      "nome_completo_valor_dominio": "AGENTE INDIGENA DE SAUDE",
      "descricao_conceito_valor_dominio": "AGENTE INDIGENA DE SAUDE"
    },
    {
      "codigo_valor_dominio": 2572,
      "codigo_referencia_valor_dominio": "515130",
      "nome_resumido_valor_dominio": "AGENTE INDIGENA DE SANEAMENTO",
      "nome_completo_valor_dominio": "AGENTE INDIGENA DE SANEAMENTO",
      "descricao_conceito_valor_dominio": "AGENTE INDIGENA DE SANEAMENTO"
    },
    {
      "codigo_valor_dominio": 2573,
      "codigo_referencia_valor_dominio": "031210",
      "nome_resumido_valor_dominio": "SOLDADO BOMBEIRO MILITAR",
      "nome_completo_valor_dominio": "SOLDADO BOMBEIRO MILITAR",
      "descricao_conceito_valor_dominio": "SOLDADO BOMBEIRO MILITAR"
    },
    {
      "codigo_valor_dominio": 2574,
      "codigo_referencia_valor_dominio": "515205",
      "nome_resumido_valor_dominio": "AUXILIAR DE BANCO DE SANGUE",
      "nome_completo_valor_dominio": "AUXILIAR DE BANCO DE SANGUE",
      "descricao_conceito_valor_dominio": "AUXILIAR DE BANCO DE SANGUE"
    },
    {
      "codigo_valor_dominio": 2575,
      "codigo_referencia_valor_dominio": "515210",
      "nome_resumido_valor_dominio": "AUXILIAR DE FARMACIA DE MANIPULACAO",
      "nome_completo_valor_dominio": "AUXILIAR DE FARMACIA DE MANIPULACAO",
      "descricao_conceito_valor_dominio": "AUXILIAR DE FARMACIA DE MANIPULACAO"
    },
    {
      "codigo_valor_dominio": 2576,
      "codigo_referencia_valor_dominio": "515215",
      "nome_resumido_valor_dominio": "AUXILIAR DE LABORATORIO DE ANALISES CLINICAS",
      "nome_completo_valor_dominio": "AUXILIAR DE LABORATORIO DE ANALISES CLINICAS",
      "descricao_conceito_valor_dominio": "AUXILIAR DE LABORATORIO DE ANALISES CLINICAS"
    },
    {
      "codigo_valor_dominio": 2577,
      "codigo_referencia_valor_dominio": "515220",
      "nome_resumido_valor_dominio": "AUXILIAR DE LABORATORIO DE IMUNOBIOLOGICOS",
      "nome_completo_valor_dominio": "AUXILIAR DE LABORATORIO DE IMUNOBIOLOGICOS",
      "descricao_conceito_valor_dominio": "AUXILIAR DE LABORATORIO DE IMUNOBIOLOGICOS"
    },
    {
      "codigo_valor_dominio": 2578,
      "codigo_referencia_valor_dominio": "515225",
      "nome_resumido_valor_dominio": "AUXILIAR DE PRODUCAO FARMACEUTICA",
      "nome_completo_valor_dominio": "AUXILIAR DE PRODUCAO FARMACEUTICA",
      "descricao_conceito_valor_dominio": "AUXILIAR DE PRODUCAO FARMACEUTICA"
    },
    {
      "codigo_valor_dominio": 2579,
      "codigo_referencia_valor_dominio": "341315",
      "nome_resumido_valor_dominio": "ELETRICISTA DE BORDO",
      "nome_completo_valor_dominio": "ELETRICISTA DE BORDO",
      "descricao_conceito_valor_dominio": "ELETRICISTA DE BORDO"
    },
    {
      "codigo_valor_dominio": 2580,
      "codigo_referencia_valor_dominio": "515310",
      "nome_resumido_valor_dominio": "AGENTE DE ACAO SOCIAL",
      "nome_completo_valor_dominio": "AGENTE DE ACAO SOCIAL",
      "descricao_conceito_valor_dominio": "AGENTE DE ACAO SOCIAL"
    },
    {
      "codigo_valor_dominio": 2581,
      "codigo_referencia_valor_dominio": "422215",
      "nome_resumido_valor_dominio": "MONITOR DE TELEATENDIMENTO",
      "nome_completo_valor_dominio": "MONITOR DE TELEATENDIMENTO",
      "descricao_conceito_valor_dominio": "MONITOR DE TELEATENDIMENTO"
    },
    {
      "codigo_valor_dominio": 2582,
      "codigo_referencia_valor_dominio": "991105",
      "nome_resumido_valor_dominio": "CONSERVADOR DE VIA PERMANENTE (TRILHOS)",
      "nome_completo_valor_dominio": "CONSERVADOR DE VIA PERMANENTE (TRILHOS)",
      "descricao_conceito_valor_dominio": "CONSERVADOR DE VIA PERMANENTE (TRILHOS)"
    },
    {
      "codigo_valor_dominio": 2583,
      "codigo_referencia_valor_dominio": "516105",
      "nome_resumido_valor_dominio": "BARBEIRO",
      "nome_completo_valor_dominio": "BARBEIRO",
      "descricao_conceito_valor_dominio": "BARBEIRO"
    },
    {
      "codigo_valor_dominio": 2584,
      "codigo_referencia_valor_dominio": "516110",
      "nome_resumido_valor_dominio": "CABELEIREIRO",
      "nome_completo_valor_dominio": "CABELEIREIRO",
      "descricao_conceito_valor_dominio": "CABELEIREIRO"
    },
    {
      "codigo_valor_dominio": 2585,
      "codigo_referencia_valor_dominio": "783110",
      "nome_resumido_valor_dominio": "MANOBRADOR",
      "nome_completo_valor_dominio": "MANOBRADOR",
      "descricao_conceito_valor_dominio": "MANOBRADOR"
    },
    {
      "codigo_valor_dominio": 2586,
      "codigo_referencia_valor_dominio": "516130",
      "nome_resumido_valor_dominio": "MAQUIADOR DE CARACTERIZACAO",
      "nome_completo_valor_dominio": "MAQUIADOR DE CARACTERIZACAO",
      "descricao_conceito_valor_dominio": "MAQUIADOR DE CARACTERIZACAO"
    },
    {
      "codigo_valor_dominio": 2587,
      "codigo_referencia_valor_dominio": "374210",
      "nome_resumido_valor_dominio": "MAQUINISTA DE CINEMA E VIDEO",
      "nome_completo_valor_dominio": "MAQUINISTA DE CINEMA E VIDEO",
      "descricao_conceito_valor_dominio": "MAQUINISTA DE CINEMA E VIDEO"
    },
    {
      "codigo_valor_dominio": 2588,
      "codigo_referencia_valor_dominio": "715210",
      "nome_resumido_valor_dominio": "PEDREIRO",
      "nome_completo_valor_dominio": "PEDREIRO",
      "descricao_conceito_valor_dominio": "PEDREIRO"
    },
    {
      "codigo_valor_dominio": 2589,
      "codigo_referencia_valor_dominio": "516205",
      "nome_resumido_valor_dominio": "BABA",
      "nome_completo_valor_dominio": "BABA",
      "descricao_conceito_valor_dominio": "BABA"
    },
    {
      "codigo_valor_dominio": 2590,
      "codigo_referencia_valor_dominio": "516220",
      "nome_resumido_valor_dominio": "CUIDADOR EM SAUDE",
      "nome_completo_valor_dominio": "CUIDADOR EM SAUDE",
      "descricao_conceito_valor_dominio": "CUIDADOR EM SAUDE"
    },
    {
      "codigo_valor_dominio": 2591,
      "codigo_referencia_valor_dominio": "848520",
      "nome_resumido_valor_dominio": "MAGAREFE",
      "nome_completo_valor_dominio": "MAGAREFE",
      "descricao_conceito_valor_dominio": "MAGAREFE"
    },
    {
      "codigo_valor_dominio": 2592,
      "codigo_referencia_valor_dominio": "513415",
      "nome_resumido_valor_dominio": "CUMIM",
      "nome_completo_valor_dominio": "CUMIM",
      "descricao_conceito_valor_dominio": "CUMIM"
    },
    {
      "codigo_valor_dominio": 2593,
      "codigo_referencia_valor_dominio": "516315",
      "nome_resumido_valor_dominio": "LAVADOR DE ARTEFATOS DE TAPECARIA",
      "nome_completo_valor_dominio": "LAVADOR DE ARTEFATOS DE TAPECARIA",
      "descricao_conceito_valor_dominio": "LAVADOR DE ARTEFATOS DE TAPECARIA"
    },
    {
      "codigo_valor_dominio": 2594,
      "codigo_referencia_valor_dominio": "519935",
      "nome_resumido_valor_dominio": "LAVADOR DE VEICULOS",
      "nome_completo_valor_dominio": "LAVADOR DE VEICULOS",
      "descricao_conceito_valor_dominio": "LAVADOR DE VEICULOS"
    },
    {
      "codigo_valor_dominio": 2595,
      "codigo_referencia_valor_dominio": "519930",
      "nome_resumido_valor_dominio": "LAVADOR DE GARRAFAS, VIDROS E OUTROS UTENSILIOS",
      "nome_completo_valor_dominio": "LAVADOR DE GARRAFAS, VIDROS E OUTROS UTENSILIOS",
      "descricao_conceito_valor_dominio": "LAVADOR DE GARRAFAS, VIDROS E OUTROS UTENSILIOS"
    },
    {
      "codigo_valor_dominio": 2596,
      "codigo_referencia_valor_dominio": "514315",
      "nome_resumido_valor_dominio": "LIMPADOR DE FACHADAS",
      "nome_completo_valor_dominio": "LIMPADOR DE FACHADAS",
      "descricao_conceito_valor_dominio": "LIMPADOR DE FACHADAS"
    },
    {
      "codigo_valor_dominio": 2597,
      "codigo_referencia_valor_dominio": "516415",
      "nome_resumido_valor_dominio": "PASSADOR DE ROUPAS, A MAO",
      "nome_completo_valor_dominio": "PASSADOR DE ROUPAS, A MAO",
      "descricao_conceito_valor_dominio": "PASSADOR DE ROUPAS, A MAO"
    },
    {
      "codigo_valor_dominio": 2598,
      "codigo_referencia_valor_dominio": "768605",
      "nome_resumido_valor_dominio": "TIPOGRAFO",
      "nome_completo_valor_dominio": "TIPOGRAFO",
      "descricao_conceito_valor_dominio": "TIPOGRAFO"
    },
    {
      "codigo_valor_dominio": 2599,
      "codigo_referencia_valor_dominio": "515320",
      "nome_resumido_valor_dominio": "CONSELHEIRO TUTELAR",
      "nome_completo_valor_dominio": "CONSELHEIRO TUTELAR",
      "descricao_conceito_valor_dominio": "CONSELHEIRO TUTELAR"
    },
    {
      "codigo_valor_dominio": 2600,
      "codigo_referencia_valor_dominio": "516340",
      "nome_resumido_valor_dominio": "ATENDENTE DE LAVANDERIA",
      "nome_completo_valor_dominio": "ATENDENTE DE LAVANDERIA",
      "descricao_conceito_valor_dominio": "ATENDENTE DE LAVANDERIA"
    },
    {
      "codigo_valor_dominio": 2601,
      "codigo_referencia_valor_dominio": "516345",
      "nome_resumido_valor_dominio": "AUXILIAR DE LAVANDERIA",
      "nome_completo_valor_dominio": "AUXILIAR DE LAVANDERIA",
      "descricao_conceito_valor_dominio": "AUXILIAR DE LAVANDERIA"
    },
    {
      "codigo_valor_dominio": 2602,
      "codigo_referencia_valor_dominio": "516310",
      "nome_resumido_valor_dominio": "LAVADOR DE ROUPAS A MAQUINA",
      "nome_completo_valor_dominio": "LAVADOR DE ROUPAS A MAQUINA",
      "descricao_conceito_valor_dominio": "LAVADOR DE ROUPAS A MAQUINA"
    },
    {
      "codigo_valor_dominio": 2603,
      "codigo_referencia_valor_dominio": "514305",
      "nome_resumido_valor_dominio": "LIMPADOR DE VIDROS",
      "nome_completo_valor_dominio": "LIMPADOR DE VIDROS",
      "descricao_conceito_valor_dominio": "LIMPADOR DE VIDROS"
    },
    {
      "codigo_valor_dominio": 2604,
      "codigo_referencia_valor_dominio": "761360",
      "nome_resumido_valor_dominio": "PASSAMANEIRO A MAQUINA",
      "nome_completo_valor_dominio": "PASSAMANEIRO A MAQUINA",
      "descricao_conceito_valor_dominio": "PASSAMANEIRO A MAQUINA"
    },
    {
      "codigo_valor_dominio": 2605,
      "codigo_referencia_valor_dominio": "516505",
      "nome_resumido_valor_dominio": "AGENTE FUNERARIO",
      "nome_completo_valor_dominio": "AGENTE FUNERARIO",
      "descricao_conceito_valor_dominio": "AGENTE FUNERARIO"
    },
    {
      "codigo_valor_dominio": 2606,
      "codigo_referencia_valor_dominio": "862310",
      "nome_resumido_valor_dominio": "OPERADOR DE FORNO DE INCINERACAO NO TRATAMENTO DE AGUA, EFLU",
      "nome_completo_valor_dominio": "OPERADOR DE FORNO DE INCINERACAO NO TRATAMENTO DE AGUA, EFLUENTES E RESIDUOS INDUSTRIAIS",
      "descricao_conceito_valor_dominio": "OPERADOR DE FORNO DE INCINERACAO NO TRATAMENTO DE AGUA, EFLUENTES E RESIDUOS INDUSTRIAIS"
    },
    {
      "codigo_valor_dominio": 2607,
      "codigo_referencia_valor_dominio": "613420",
      "nome_resumido_valor_dominio": "SERICULTOR",
      "nome_completo_valor_dominio": "SERICULTOR",
      "descricao_conceito_valor_dominio": "SERICULTOR"
    },
    {
      "codigo_valor_dominio": 2608,
      "codigo_referencia_valor_dominio": "516705",
      "nome_resumido_valor_dominio": "ASTROLOGO",
      "nome_completo_valor_dominio": "ASTROLOGO",
      "descricao_conceito_valor_dominio": "ASTROLOGO"
    },
    {
      "codigo_valor_dominio": 2609,
      "codigo_referencia_valor_dominio": "223710",
      "nome_resumido_valor_dominio": "NUTRICIONISTA",
      "nome_completo_valor_dominio": "NUTRICIONISTA",
      "descricao_conceito_valor_dominio": "NUTRICIONISTA"
    },
    {
      "codigo_valor_dominio": 2610,
      "codigo_referencia_valor_dominio": "111505",
      "nome_resumido_valor_dominio": "ESPECIALISTA DE POLITICAS PUBLICAS E GESTAO GOVERNAMENTAL -",
      "nome_completo_valor_dominio": "ESPECIALISTA DE POLITICAS PUBLICAS E GESTAO GOVERNAMENTAL - EPPGG",
      "descricao_conceito_valor_dominio": "ESPECIALISTA DE POLITICAS PUBLICAS E GESTAO GOVERNAMENTAL - EPPGG"
    },
    {
      "codigo_valor_dominio": 2611,
      "codigo_referencia_valor_dominio": "515115",
      "nome_resumido_valor_dominio": "PARTEIRA LEIGA",
      "nome_completo_valor_dominio": "PARTEIRA LEIGA",
      "descricao_conceito_valor_dominio": "PARTEIRA LEIGA"
    },
    {
      "codigo_valor_dominio": 2612,
      "codigo_referencia_valor_dominio": "517105",
      "nome_resumido_valor_dominio": "BOMBEIRO DE AERODROMO",
      "nome_completo_valor_dominio": "BOMBEIRO DE AERODROMO",
      "descricao_conceito_valor_dominio": "BOMBEIRO DE AERODROMO"
    },
    {
      "codigo_valor_dominio": 2613,
      "codigo_referencia_valor_dominio": "517110",
      "nome_resumido_valor_dominio": "BOMBEIRO CIVIL",
      "nome_completo_valor_dominio": "BOMBEIRO CIVIL",
      "descricao_conceito_valor_dominio": "BOMBEIRO CIVIL"
    },
    {
      "codigo_valor_dominio": 2614,
      "codigo_referencia_valor_dominio": "768320",
      "nome_resumido_valor_dominio": "SAPATEIRO (CALCADOS SOB MEDIDA)",
      "nome_completo_valor_dominio": "SAPATEIRO (CALCADOS SOB MEDIDA)",
      "descricao_conceito_valor_dominio": "SAPATEIRO (CALCADOS SOB MEDIDA)"
    },
    {
      "codigo_valor_dominio": 2615,
      "codigo_referencia_valor_dominio": "517205",
      "nome_resumido_valor_dominio": "AGENTE DE POLICIA FEDERAL",
      "nome_completo_valor_dominio": "AGENTE DE POLICIA FEDERAL",
      "descricao_conceito_valor_dominio": "AGENTE DE POLICIA FEDERAL"
    },
    {
      "codigo_valor_dominio": 2616,
      "codigo_referencia_valor_dominio": "721325",
      "nome_resumido_valor_dominio": "POLIDOR DE METAIS",
      "nome_completo_valor_dominio": "POLIDOR DE METAIS",
      "descricao_conceito_valor_dominio": "POLIDOR DE METAIS"
    },
    {
      "codigo_valor_dominio": 2617,
      "codigo_referencia_valor_dominio": "513325",
      "nome_resumido_valor_dominio": "GUARDA-ROUPEIRA DE CINEMA",
      "nome_completo_valor_dominio": "GUARDA-ROUPEIRA DE CINEMA",
      "descricao_conceito_valor_dominio": "GUARDA-ROUPEIRA DE CINEMA"
    },
    {
      "codigo_valor_dominio": 2618,
      "codigo_referencia_valor_dominio": "517220",
      "nome_resumido_valor_dominio": "AGENTE DE TRANSITO",
      "nome_completo_valor_dominio": "AGENTE DE TRANSITO",
      "descricao_conceito_valor_dominio": "AGENTE DE TRANSITO"
    },
    {
      "codigo_valor_dominio": 2619,
      "codigo_referencia_valor_dominio": "517305",
      "nome_resumido_valor_dominio": "AGENTE DE PROTECAO DE AEROPORTO",
      "nome_completo_valor_dominio": "AGENTE DE PROTECAO DE AEROPORTO",
      "descricao_conceito_valor_dominio": "AGENTE DE PROTECAO DE AEROPORTO"
    },
    {
      "codigo_valor_dominio": 2620,
      "codigo_referencia_valor_dominio": "517310",
      "nome_resumido_valor_dominio": "AGENTE DE SEGURANCA",
      "nome_completo_valor_dominio": "AGENTE DE SEGURANCA",
      "descricao_conceito_valor_dominio": "AGENTE DE SEGURANCA"
    },
    {
      "codigo_valor_dominio": 2621,
      "codigo_referencia_valor_dominio": "517315",
      "nome_resumido_valor_dominio": "AGENTE DE SEGURANCA PENITENCIARIA",
      "nome_completo_valor_dominio": "AGENTE DE SEGURANCA PENITENCIARIA",
      "descricao_conceito_valor_dominio": "AGENTE DE SEGURANCA PENITENCIARIA"
    },
    {
      "codigo_valor_dominio": 2622,
      "codigo_referencia_valor_dominio": "517325",
      "nome_resumido_valor_dominio": "VIGIA PORTUARIO",
      "nome_completo_valor_dominio": "VIGIA PORTUARIO",
      "descricao_conceito_valor_dominio": "VIGIA PORTUARIO"
    },
    {
      "codigo_valor_dominio": 2623,
      "codigo_referencia_valor_dominio": "517330",
      "nome_resumido_valor_dominio": "VIGILANTE",
      "nome_completo_valor_dominio": "VIGILANTE",
      "descricao_conceito_valor_dominio": "VIGILANTE"
    },
    {
      "codigo_valor_dominio": 2624,
      "codigo_referencia_valor_dominio": "841740",
      "nome_resumido_valor_dominio": "VINAGREIRO",
      "nome_completo_valor_dominio": "VINAGREIRO",
      "descricao_conceito_valor_dominio": "VINAGREIRO"
    },
    {
      "codigo_valor_dominio": 2625,
      "codigo_referencia_valor_dominio": "517215",
      "nome_resumido_valor_dominio": "GUARDA-CIVIL MUNICIPAL",
      "nome_completo_valor_dominio": "GUARDA-CIVIL MUNICIPAL",
      "descricao_conceito_valor_dominio": "GUARDA-CIVIL MUNICIPAL"
    },
    {
      "codigo_valor_dominio": 2626,
      "codigo_referencia_valor_dominio": "517410",
      "nome_resumido_valor_dominio": "PORTEIRO DE EDIFICIOS",
      "nome_completo_valor_dominio": "PORTEIRO DE EDIFICIOS",
      "descricao_conceito_valor_dominio": "PORTEIRO DE EDIFICIOS"
    },
    {
      "codigo_valor_dominio": 2627,
      "codigo_referencia_valor_dominio": "517415",
      "nome_resumido_valor_dominio": "PORTEIRO DE LOCAIS DE DIVERSAO",
      "nome_completo_valor_dominio": "PORTEIRO DE LOCAIS DE DIVERSAO",
      "descricao_conceito_valor_dominio": "PORTEIRO DE LOCAIS DE DIVERSAO"
    },
    {
      "codigo_valor_dominio": 2628,
      "codigo_referencia_valor_dominio": "010305",
      "nome_resumido_valor_dominio": "PRACA DA AERONAUTICA",
      "nome_completo_valor_dominio": "PRACA DA AERONAUTICA",
      "descricao_conceito_valor_dominio": "PRACA DA AERONAUTICA"
    },
    {
      "codigo_valor_dominio": 2629,
      "codigo_referencia_valor_dominio": "517320",
      "nome_resumido_valor_dominio": "VIGIA FLORESTAL",
      "nome_completo_valor_dominio": "VIGIA FLORESTAL",
      "descricao_conceito_valor_dominio": "VIGIA FLORESTAL"
    },
    {
      "codigo_valor_dominio": 2630,
      "codigo_referencia_valor_dominio": "519105",
      "nome_resumido_valor_dominio": "CICLISTA MENSAGEIRO",
      "nome_completo_valor_dominio": "CICLISTA MENSAGEIRO",
      "descricao_conceito_valor_dominio": "CICLISTA MENSAGEIRO"
    },
    {
      "codigo_valor_dominio": 2631,
      "codigo_referencia_valor_dominio": "782510",
      "nome_resumido_valor_dominio": "MOTORISTA DE CAMINHAO (ROTAS REGIONAIS E INTERNACIONAIS)",
      "nome_completo_valor_dominio": "MOTORISTA DE CAMINHAO (ROTAS REGIONAIS E INTERNACIONAIS)",
      "descricao_conceito_valor_dominio": "MOTORISTA DE CAMINHAO (ROTAS REGIONAIS E INTERNACIONAIS)"
    },
    {
      "codigo_valor_dominio": 2632,
      "codigo_referencia_valor_dominio": "519205",
      "nome_resumido_valor_dominio": "CATADOR DE MATERIAL RECICLAVEL",
      "nome_completo_valor_dominio": "CATADOR DE MATERIAL RECICLAVEL",
      "descricao_conceito_valor_dominio": "CATADOR DE MATERIAL RECICLAVEL"
    },
    {
      "codigo_valor_dominio": 2633,
      "codigo_referencia_valor_dominio": "768325",
      "nome_resumido_valor_dominio": "SELEIRO",
      "nome_completo_valor_dominio": "SELEIRO",
      "descricao_conceito_valor_dominio": "SELEIRO"
    },
    {
      "codigo_valor_dominio": 2634,
      "codigo_referencia_valor_dominio": "823250",
      "nome_resumido_valor_dominio": "OPERADOR DE PRENSA DE MOLDAR VIDRO",
      "nome_completo_valor_dominio": "OPERADOR DE PRENSA DE MOLDAR VIDRO",
      "descricao_conceito_valor_dominio": "OPERADOR DE PRENSA DE MOLDAR VIDRO"
    },
    {
      "codigo_valor_dominio": 2635,
      "codigo_referencia_valor_dominio": "519305",
      "nome_resumido_valor_dominio": "AUXILIAR DE VETERINARIO",
      "nome_completo_valor_dominio": "AUXILIAR DE VETERINARIO",
      "descricao_conceito_valor_dominio": "AUXILIAR DE VETERINARIO"
    },
    {
      "codigo_valor_dominio": 2636,
      "codigo_referencia_valor_dominio": "762305",
      "nome_resumido_valor_dominio": "ESTIRADOR DE COUROS E PELES (ACABAMENTO)",
      "nome_completo_valor_dominio": "ESTIRADOR DE COUROS E PELES (ACABAMENTO)",
      "descricao_conceito_valor_dominio": "ESTIRADOR DE COUROS E PELES (ACABAMENTO)"
    },
    {
      "codigo_valor_dominio": 2637,
      "codigo_referencia_valor_dominio": "519315",
      "nome_resumido_valor_dominio": "BANHISTA DE ANIMAIS DOMESTICOS",
      "nome_completo_valor_dominio": "BANHISTA DE ANIMAIS DOMESTICOS",
      "descricao_conceito_valor_dominio": "BANHISTA DE ANIMAIS DOMESTICOS"
    },
    {
      "codigo_valor_dominio": 2638,
      "codigo_referencia_valor_dominio": "621005",
      "nome_resumido_valor_dominio": "TRABALHADOR AGROPECUARIO EM GERAL",
      "nome_completo_valor_dominio": "TRABALHADOR AGROPECUARIO EM GERAL",
      "descricao_conceito_valor_dominio": "TRABALHADOR AGROPECUARIO EM GERAL"
    },
    {
      "codigo_valor_dominio": 2639,
      "codigo_referencia_valor_dominio": "317105",
      "nome_resumido_valor_dominio": "PROGRAMADOR DE INTERNET",
      "nome_completo_valor_dominio": "PROGRAMADOR DE INTERNET",
      "descricao_conceito_valor_dominio": "PROGRAMADOR DE INTERNET"
    },
    {
      "codigo_valor_dominio": 2640,
      "codigo_referencia_valor_dominio": "519905",
      "nome_resumido_valor_dominio": "CARTAZEIRO",
      "nome_completo_valor_dominio": "CARTAZEIRO",
      "descricao_conceito_valor_dominio": "CARTAZEIRO"
    },
    {
      "codigo_valor_dominio": 2641,
      "codigo_referencia_valor_dominio": "342115",
      "nome_resumido_valor_dominio": "CONTROLADOR DE SERVICOS DE MAQUINAS E VEICULOS",
      "nome_completo_valor_dominio": "CONTROLADOR DE SERVICOS DE MAQUINAS E VEICULOS",
      "descricao_conceito_valor_dominio": "CONTROLADOR DE SERVICOS DE MAQUINAS E VEICULOS"
    },
    {
      "codigo_valor_dominio": 2642,
      "codigo_referencia_valor_dominio": "325005",
      "nome_resumido_valor_dominio": "ENOLOGO",
      "nome_completo_valor_dominio": "ENOLOGO",
      "descricao_conceito_valor_dominio": "ENOLOGO"
    },
    {
      "codigo_valor_dominio": 2643,
      "codigo_referencia_valor_dominio": "514110",
      "nome_resumido_valor_dominio": "GARAGISTA",
      "nome_completo_valor_dominio": "GARAGISTA",
      "descricao_conceito_valor_dominio": "GARAGISTA"
    },
    {
      "codigo_valor_dominio": 2644,
      "codigo_referencia_valor_dominio": "511405",
      "nome_resumido_valor_dominio": "GUIA DE TURISMO",
      "nome_completo_valor_dominio": "GUIA DE TURISMO",
      "descricao_conceito_valor_dominio": "GUIA DE TURISMO"
    },
    {
      "codigo_valor_dominio": 2645,
      "codigo_referencia_valor_dominio": "761110",
      "nome_resumido_valor_dominio": "LAVADOR DE LA",
      "nome_completo_valor_dominio": "LAVADOR DE LA",
      "descricao_conceito_valor_dominio": "LAVADOR DE LA"
    },
    {
      "codigo_valor_dominio": 2646,
      "codigo_referencia_valor_dominio": "354405",
      "nome_resumido_valor_dominio": "LEILOEIRO",
      "nome_completo_valor_dominio": "LEILOEIRO",
      "descricao_conceito_valor_dominio": "LEILOEIRO"
    },
    {
      "codigo_valor_dominio": 2647,
      "codigo_referencia_valor_dominio": "113010",
      "nome_resumido_valor_dominio": "LIDER DE COMUNIDADE CAICARA",
      "nome_completo_valor_dominio": "LIDER DE COMUNIDADE CAICARA",
      "descricao_conceito_valor_dominio": "LIDER DE COMUNIDADE CAICARA"
    },
    {
      "codigo_valor_dominio": 2648,
      "codigo_referencia_valor_dominio": "422110",
      "nome_resumido_valor_dominio": "RECEPCIONISTA DE CONSULTORIO MEDICO OU DENTARIO",
      "nome_completo_valor_dominio": "RECEPCIONISTA DE CONSULTORIO MEDICO OU DENTARIO",
      "descricao_conceito_valor_dominio": "RECEPCIONISTA DE CONSULTORIO MEDICO OU DENTARIO"
    },
    {
      "codigo_valor_dominio": 2649,
      "codigo_referencia_valor_dominio": "510310",
      "nome_resumido_valor_dominio": "SUPERVISOR DE VIGILANTES",
      "nome_completo_valor_dominio": "SUPERVISOR DE VIGILANTES",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE VIGILANTES"
    },
    {
      "codigo_valor_dominio": 2650,
      "codigo_referencia_valor_dominio": "520105",
      "nome_resumido_valor_dominio": "SUPERVISOR DE VENDAS DE SERVICOS",
      "nome_completo_valor_dominio": "SUPERVISOR DE VENDAS DE SERVICOS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE VENDAS DE SERVICOS"
    },
    {
      "codigo_valor_dominio": 2651,
      "codigo_referencia_valor_dominio": "524105",
      "nome_resumido_valor_dominio": "VENDEDOR EM DOMICILIO",
      "nome_completo_valor_dominio": "VENDEDOR EM DOMICILIO",
      "descricao_conceito_valor_dominio": "VENDEDOR EM DOMICILIO"
    },
    {
      "codigo_valor_dominio": 2652,
      "codigo_referencia_valor_dominio": "521105",
      "nome_resumido_valor_dominio": "VENDEDOR EM COMERCIO ATACADISTA",
      "nome_completo_valor_dominio": "VENDEDOR EM COMERCIO ATACADISTA",
      "descricao_conceito_valor_dominio": "VENDEDOR EM COMERCIO ATACADISTA"
    },
    {
      "codigo_valor_dominio": 2653,
      "codigo_referencia_valor_dominio": "354130",
      "nome_resumido_valor_dominio": "PROMOTOR DE VENDAS ESPECIALIZADO",
      "nome_completo_valor_dominio": "PROMOTOR DE VENDAS ESPECIALIZADO",
      "descricao_conceito_valor_dominio": "PROMOTOR DE VENDAS ESPECIALIZADO"
    },
    {
      "codigo_valor_dominio": 2654,
      "codigo_referencia_valor_dominio": "111115",
      "nome_resumido_valor_dominio": "DEPUTADO ESTADUAL E DISTRITAL",
      "nome_completo_valor_dominio": "DEPUTADO ESTADUAL E DISTRITAL",
      "descricao_conceito_valor_dominio": "DEPUTADO ESTADUAL E DISTRITAL"
    },
    {
      "codigo_valor_dominio": 2655,
      "codigo_referencia_valor_dominio": "354705",
      "nome_resumido_valor_dominio": "REPRESENTANTE COMERCIAL AUTONOMO",
      "nome_completo_valor_dominio": "REPRESENTANTE COMERCIAL AUTONOMO",
      "descricao_conceito_valor_dominio": "REPRESENTANTE COMERCIAL AUTONOMO"
    },
    {
      "codigo_valor_dominio": 2656,
      "codigo_referencia_valor_dominio": "521130",
      "nome_resumido_valor_dominio": "ATENDENTE DE FARMACIA - BALCONISTA",
      "nome_completo_valor_dominio": "ATENDENTE DE FARMACIA - BALCONISTA",
      "descricao_conceito_valor_dominio": "ATENDENTE DE FARMACIA - BALCONISTA"
    },
    {
      "codigo_valor_dominio": 2657,
      "codigo_referencia_valor_dominio": "762120",
      "nome_resumido_valor_dominio": "FULONEIRO",
      "nome_completo_valor_dominio": "FULONEIRO",
      "descricao_conceito_valor_dominio": "FULONEIRO"
    },
    {
      "codigo_valor_dominio": 2658,
      "codigo_referencia_valor_dominio": "715710",
      "nome_resumido_valor_dominio": "INSTALADOR DE ISOLANTES ACUSTICOS",
      "nome_completo_valor_dominio": "INSTALADOR DE ISOLANTES ACUSTICOS",
      "descricao_conceito_valor_dominio": "INSTALADOR DE ISOLANTES ACUSTICOS"
    },
    {
      "codigo_valor_dominio": 2659,
      "codigo_referencia_valor_dominio": "724115",
      "nome_resumido_valor_dominio": "INSTALADOR DE TUBULACOES",
      "nome_completo_valor_dominio": "INSTALADOR DE TUBULACOES",
      "descricao_conceito_valor_dominio": "INSTALADOR DE TUBULACOES"
    },
    {
      "codigo_valor_dominio": 2660,
      "codigo_referencia_valor_dominio": "523115",
      "nome_resumido_valor_dominio": "CHAVEIRO",
      "nome_completo_valor_dominio": "CHAVEIRO",
      "descricao_conceito_valor_dominio": "CHAVEIRO"
    },
    {
      "codigo_valor_dominio": 2661,
      "codigo_referencia_valor_dominio": "354145",
      "nome_resumido_valor_dominio": "VENDEDOR PRACISTA",
      "nome_completo_valor_dominio": "VENDEDOR PRACISTA",
      "descricao_conceito_valor_dominio": "VENDEDOR PRACISTA"
    },
    {
      "codigo_valor_dominio": 2662,
      "codigo_referencia_valor_dominio": "841715",
      "nome_resumido_valor_dominio": "FERMENTADOR",
      "nome_completo_valor_dominio": "FERMENTADOR",
      "descricao_conceito_valor_dominio": "FERMENTADOR"
    },
    {
      "codigo_valor_dominio": 2663,
      "codigo_referencia_valor_dominio": "261125",
      "nome_resumido_valor_dominio": "JORNALISTA",
      "nome_completo_valor_dominio": "JORNALISTA",
      "descricao_conceito_valor_dominio": "JORNALISTA"
    },
    {
      "codigo_valor_dominio": 2664,
      "codigo_referencia_valor_dominio": "524305",
      "nome_resumido_valor_dominio": "VENDEDOR AMBULANTE",
      "nome_completo_valor_dominio": "VENDEDOR AMBULANTE",
      "descricao_conceito_valor_dominio": "VENDEDOR AMBULANTE"
    },
    {
      "codigo_valor_dominio": 2665,
      "codigo_referencia_valor_dominio": "521110",
      "nome_resumido_valor_dominio": "VENDEDOR DE COMERCIO VAREJISTA",
      "nome_completo_valor_dominio": "VENDEDOR DE COMERCIO VAREJISTA",
      "descricao_conceito_valor_dominio": "VENDEDOR DE COMERCIO VAREJISTA"
    },
    {
      "codigo_valor_dominio": 2666,
      "codigo_referencia_valor_dominio": "812105",
      "nome_resumido_valor_dominio": "PIROTECNICO",
      "nome_completo_valor_dominio": "PIROTECNICO",
      "descricao_conceito_valor_dominio": "PIROTECNICO"
    },
    {
      "codigo_valor_dominio": 2667,
      "codigo_referencia_valor_dominio": "262110",
      "nome_resumido_valor_dominio": "PRODUTOR CINEMATOGRAFICO",
      "nome_completo_valor_dominio": "PRODUTOR CINEMATOGRAFICO",
      "descricao_conceito_valor_dominio": "PRODUTOR CINEMATOGRAFICO"
    },
    {
      "codigo_valor_dominio": 2668,
      "codigo_referencia_valor_dominio": "611005",
      "nome_resumido_valor_dominio": "PRODUTOR AGROPECUARIO, EM GERAL",
      "nome_completo_valor_dominio": "PRODUTOR AGROPECUARIO, EM GERAL",
      "descricao_conceito_valor_dominio": "PRODUTOR AGROPECUARIO, EM GERAL"
    },
    {
      "codigo_valor_dominio": 2669,
      "codigo_referencia_valor_dominio": "612505",
      "nome_resumido_valor_dominio": "PRODUTOR DE ARVORES FRUTIFERAS",
      "nome_completo_valor_dominio": "PRODUTOR DE ARVORES FRUTIFERAS",
      "descricao_conceito_valor_dominio": "PRODUTOR DE ARVORES FRUTIFERAS"
    },
    {
      "codigo_valor_dominio": 2670,
      "codigo_referencia_valor_dominio": "612115",
      "nome_resumido_valor_dominio": "PRODUTOR DE CEREAIS DE INVERNO",
      "nome_completo_valor_dominio": "PRODUTOR DE CEREAIS DE INVERNO",
      "descricao_conceito_valor_dominio": "PRODUTOR DE CEREAIS DE INVERNO"
    },
    {
      "codigo_valor_dominio": 2671,
      "codigo_referencia_valor_dominio": "612210",
      "nome_resumido_valor_dominio": "PRODUTOR DE CURAUA",
      "nome_completo_valor_dominio": "PRODUTOR DE CURAUA",
      "descricao_conceito_valor_dominio": "PRODUTOR DE CURAUA"
    },
    {
      "codigo_valor_dominio": 2672,
      "codigo_referencia_valor_dominio": "612625",
      "nome_resumido_valor_dominio": "PRODUTOR DE GUARANA",
      "nome_completo_valor_dominio": "PRODUTOR DE GUARANA",
      "descricao_conceito_valor_dominio": "PRODUTOR DE GUARANA"
    },
    {
      "codigo_valor_dominio": 2673,
      "codigo_referencia_valor_dominio": "612810",
      "nome_resumido_valor_dominio": "PRODUTOR DE PLANTAS AROMATICAS E MEDICINAIS",
      "nome_completo_valor_dominio": "PRODUTOR DE PLANTAS AROMATICAS E MEDICINAIS",
      "descricao_conceito_valor_dominio": "PRODUTOR DE PLANTAS AROMATICAS E MEDICINAIS"
    },
    {
      "codigo_valor_dominio": 2674,
      "codigo_referencia_valor_dominio": "612105",
      "nome_resumido_valor_dominio": "PRODUTOR DE ARROZ",
      "nome_completo_valor_dominio": "PRODUTOR DE ARROZ",
      "descricao_conceito_valor_dominio": "PRODUTOR DE ARROZ"
    },
    {
      "codigo_valor_dominio": 2675,
      "codigo_referencia_valor_dominio": "612615",
      "nome_resumido_valor_dominio": "PRODUTOR DE ERVA-MATE",
      "nome_completo_valor_dominio": "PRODUTOR DE ERVA-MATE",
      "descricao_conceito_valor_dominio": "PRODUTOR DE ERVA-MATE"
    },
    {
      "codigo_valor_dominio": 2676,
      "codigo_referencia_valor_dominio": "612125",
      "nome_resumido_valor_dominio": "PRODUTOR DE MILHO E SORGO",
      "nome_completo_valor_dominio": "PRODUTOR DE MILHO E SORGO",
      "descricao_conceito_valor_dominio": "PRODUTOR DE MILHO E SORGO"
    },
    {
      "codigo_valor_dominio": 2677,
      "codigo_referencia_valor_dominio": "612225",
      "nome_resumido_valor_dominio": "PRODUTOR DE SISAL",
      "nome_completo_valor_dominio": "PRODUTOR DE SISAL",
      "descricao_conceito_valor_dominio": "PRODUTOR DE SISAL"
    },
    {
      "codigo_valor_dominio": 2678,
      "codigo_referencia_valor_dominio": "262120",
      "nome_resumido_valor_dominio": "PRODUTOR DE TEATRO",
      "nome_completo_valor_dominio": "PRODUTOR DE TEATRO",
      "descricao_conceito_valor_dominio": "PRODUTOR DE TEATRO"
    },
    {
      "codigo_valor_dominio": 2679,
      "codigo_referencia_valor_dominio": "612310",
      "nome_resumido_valor_dominio": "PRODUTOR NA OLERICULTURA DE RAIZES, BULBOS E TUBERCULOS",
      "nome_completo_valor_dominio": "PRODUTOR NA OLERICULTURA DE RAIZES, BULBOS E TUBERCULOS",
      "descricao_conceito_valor_dominio": "PRODUTOR NA OLERICULTURA DE RAIZES, BULBOS E TUBERCULOS"
    },
    {
      "codigo_valor_dominio": 2680,
      "codigo_referencia_valor_dominio": "612315",
      "nome_resumido_valor_dominio": "PRODUTOR NA OLERICULTURA DE TALOS, FOLHAS E FLORES",
      "nome_completo_valor_dominio": "PRODUTOR NA OLERICULTURA DE TALOS, FOLHAS E FLORES",
      "descricao_conceito_valor_dominio": "PRODUTOR NA OLERICULTURA DE TALOS, FOLHAS E FLORES"
    },
    {
      "codigo_valor_dominio": 2681,
      "codigo_referencia_valor_dominio": "631415",
      "nome_resumido_valor_dominio": "PROEIRO",
      "nome_completo_valor_dominio": "PROEIRO",
      "descricao_conceito_valor_dominio": "PROEIRO"
    },
    {
      "codigo_valor_dominio": 2682,
      "codigo_referencia_valor_dominio": "612305",
      "nome_resumido_valor_dominio": "PRODUTOR NA OLERICULTURA DE LEGUMES",
      "nome_completo_valor_dominio": "PRODUTOR NA OLERICULTURA DE LEGUMES",
      "descricao_conceito_valor_dominio": "PRODUTOR NA OLERICULTURA DE LEGUMES"
    },
    {
      "codigo_valor_dominio": 2683,
      "codigo_referencia_valor_dominio": "612410",
      "nome_resumido_valor_dominio": "PRODUTOR DE FLORES EM VASO",
      "nome_completo_valor_dominio": "PRODUTOR DE FLORES EM VASO",
      "descricao_conceito_valor_dominio": "PRODUTOR DE FLORES EM VASO"
    },
    {
      "codigo_valor_dominio": 2684,
      "codigo_referencia_valor_dominio": "612415",
      "nome_resumido_valor_dominio": "PRODUTOR DE FORRACOES",
      "nome_completo_valor_dominio": "PRODUTOR DE FORRACOES",
      "descricao_conceito_valor_dominio": "PRODUTOR DE FORRACOES"
    },
    {
      "codigo_valor_dominio": 2685,
      "codigo_referencia_valor_dominio": "612620",
      "nome_resumido_valor_dominio": "PRODUTOR DE FUMO",
      "nome_completo_valor_dominio": "PRODUTOR DE FUMO",
      "descricao_conceito_valor_dominio": "PRODUTOR DE FUMO"
    },
    {
      "codigo_valor_dominio": 2686,
      "codigo_referencia_valor_dominio": "262115",
      "nome_resumido_valor_dominio": "PRODUTOR DE RADIO",
      "nome_completo_valor_dominio": "PRODUTOR DE RADIO",
      "descricao_conceito_valor_dominio": "PRODUTOR DE RADIO"
    },
    {
      "codigo_valor_dominio": 2687,
      "codigo_referencia_valor_dominio": "612610",
      "nome_resumido_valor_dominio": "PRODUTOR DE CACAU",
      "nome_completo_valor_dominio": "PRODUTOR DE CACAU",
      "descricao_conceito_valor_dominio": "PRODUTOR DE CACAU"
    },
    {
      "codigo_valor_dominio": 2688,
      "codigo_referencia_valor_dominio": "612515",
      "nome_resumido_valor_dominio": "PRODUTOR DE ESPECIES FRUTIFERAS TREPADEIRAS",
      "nome_completo_valor_dominio": "PRODUTOR DE ESPECIES FRUTIFERAS TREPADEIRAS",
      "descricao_conceito_valor_dominio": "PRODUTOR DE ESPECIES FRUTIFERAS TREPADEIRAS"
    },
    {
      "codigo_valor_dominio": 2689,
      "codigo_referencia_valor_dominio": "612405",
      "nome_resumido_valor_dominio": "PRODUTOR DE FLORES DE CORTE",
      "nome_completo_valor_dominio": "PRODUTOR DE FLORES DE CORTE",
      "descricao_conceito_valor_dominio": "PRODUTOR DE FLORES DE CORTE"
    },
    {
      "codigo_valor_dominio": 2690,
      "codigo_referencia_valor_dominio": "612605",
      "nome_resumido_valor_dominio": "CAFEICULTOR",
      "nome_completo_valor_dominio": "CAFEICULTOR",
      "descricao_conceito_valor_dominio": "CAFEICULTOR"
    },
    {
      "codigo_valor_dominio": 2691,
      "codigo_referencia_valor_dominio": "612110",
      "nome_resumido_valor_dominio": "PRODUTOR DE CANA-DE-ACUCAR",
      "nome_completo_valor_dominio": "PRODUTOR DE CANA-DE-ACUCAR",
      "descricao_conceito_valor_dominio": "PRODUTOR DE CANA-DE-ACUCAR"
    },
    {
      "codigo_valor_dominio": 2692,
      "codigo_referencia_valor_dominio": "612805",
      "nome_resumido_valor_dominio": "PRODUTOR DE ESPECIARIAS",
      "nome_completo_valor_dominio": "PRODUTOR DE ESPECIARIAS",
      "descricao_conceito_valor_dominio": "PRODUTOR DE ESPECIARIAS"
    },
    {
      "codigo_valor_dominio": 2693,
      "codigo_referencia_valor_dominio": "612120",
      "nome_resumido_valor_dominio": "PRODUTOR DE GRAMINEAS FORRAGEIRAS",
      "nome_completo_valor_dominio": "PRODUTOR DE GRAMINEAS FORRAGEIRAS",
      "descricao_conceito_valor_dominio": "PRODUTOR DE GRAMINEAS FORRAGEIRAS"
    },
    {
      "codigo_valor_dominio": 2694,
      "codigo_referencia_valor_dominio": "612215",
      "nome_resumido_valor_dominio": "PRODUTOR DE JUTA",
      "nome_completo_valor_dominio": "PRODUTOR DE JUTA",
      "descricao_conceito_valor_dominio": "PRODUTOR DE JUTA"
    },
    {
      "codigo_valor_dominio": 2695,
      "codigo_referencia_valor_dominio": "612710",
      "nome_resumido_valor_dominio": "PRODUTOR DA CULTURA DE CANOLA",
      "nome_completo_valor_dominio": "PRODUTOR DA CULTURA DE CANOLA",
      "descricao_conceito_valor_dominio": "PRODUTOR DA CULTURA DE CANOLA"
    },
    {
      "codigo_valor_dominio": 2696,
      "codigo_referencia_valor_dominio": "612715",
      "nome_resumido_valor_dominio": "PRODUTOR DA CULTURA DE COCO-DA-BAIA",
      "nome_completo_valor_dominio": "PRODUTOR DA CULTURA DE COCO-DA-BAIA",
      "descricao_conceito_valor_dominio": "PRODUTOR DA CULTURA DE COCO-DA-BAIA"
    },
    {
      "codigo_valor_dominio": 2697,
      "codigo_referencia_valor_dominio": "612720",
      "nome_resumido_valor_dominio": "PRODUTOR DA CULTURA DE DENDE",
      "nome_completo_valor_dominio": "PRODUTOR DA CULTURA DE DENDE",
      "descricao_conceito_valor_dominio": "PRODUTOR DA CULTURA DE DENDE"
    },
    {
      "codigo_valor_dominio": 2698,
      "codigo_referencia_valor_dominio": "612725",
      "nome_resumido_valor_dominio": "PRODUTOR DA CULTURA DE GIRASSOL",
      "nome_completo_valor_dominio": "PRODUTOR DA CULTURA DE GIRASSOL",
      "descricao_conceito_valor_dominio": "PRODUTOR DA CULTURA DE GIRASSOL"
    },
    {
      "codigo_valor_dominio": 2699,
      "codigo_referencia_valor_dominio": "612730",
      "nome_resumido_valor_dominio": "PRODUTOR DA CULTURA DE LINHO",
      "nome_completo_valor_dominio": "PRODUTOR DA CULTURA DE LINHO",
      "descricao_conceito_valor_dominio": "PRODUTOR DA CULTURA DE LINHO"
    },
    {
      "codigo_valor_dominio": 2700,
      "codigo_referencia_valor_dominio": "612735",
      "nome_resumido_valor_dominio": "PRODUTOR DA CULTURA DE MAMONA",
      "nome_completo_valor_dominio": "PRODUTOR DA CULTURA DE MAMONA",
      "descricao_conceito_valor_dominio": "PRODUTOR DA CULTURA DE MAMONA"
    },
    {
      "codigo_valor_dominio": 2701,
      "codigo_referencia_valor_dominio": "612740",
      "nome_resumido_valor_dominio": "PRODUTOR DA CULTURA DE SOJA",
      "nome_completo_valor_dominio": "PRODUTOR DA CULTURA DE SOJA",
      "descricao_conceito_valor_dominio": "PRODUTOR DA CULTURA DE SOJA"
    },
    {
      "codigo_valor_dominio": 2702,
      "codigo_referencia_valor_dominio": "612205",
      "nome_resumido_valor_dominio": "PRODUTOR DE ALGODAO",
      "nome_completo_valor_dominio": "PRODUTOR DE ALGODAO",
      "descricao_conceito_valor_dominio": "PRODUTOR DE ALGODAO"
    },
    {
      "codigo_valor_dominio": 2703,
      "codigo_referencia_valor_dominio": "612510",
      "nome_resumido_valor_dominio": "PRODUTOR DE ESPECIES FRUTIFERAS RASTEIRAS",
      "nome_completo_valor_dominio": "PRODUTOR DE ESPECIES FRUTIFERAS RASTEIRAS",
      "descricao_conceito_valor_dominio": "PRODUTOR DE ESPECIES FRUTIFERAS RASTEIRAS"
    },
    {
      "codigo_valor_dominio": 2704,
      "codigo_referencia_valor_dominio": "612420",
      "nome_resumido_valor_dominio": "PRODUTOR DE PLANTAS ORNAMENTAIS",
      "nome_completo_valor_dominio": "PRODUTOR DE PLANTAS ORNAMENTAIS",
      "descricao_conceito_valor_dominio": "PRODUTOR DE PLANTAS ORNAMENTAIS"
    },
    {
      "codigo_valor_dominio": 2705,
      "codigo_referencia_valor_dominio": "261510",
      "nome_resumido_valor_dominio": "CRITICO",
      "nome_completo_valor_dominio": "CRITICO",
      "descricao_conceito_valor_dominio": "CRITICO"
    },
    {
      "codigo_valor_dominio": 2706,
      "codigo_referencia_valor_dominio": "613410",
      "nome_resumido_valor_dominio": "CRIADOR DE ANIMAIS PRODUTORES DE VENENO",
      "nome_completo_valor_dominio": "CRIADOR DE ANIMAIS PRODUTORES DE VENENO",
      "descricao_conceito_valor_dominio": "CRIADOR DE ANIMAIS PRODUTORES DE VENENO"
    },
    {
      "codigo_valor_dominio": 2707,
      "codigo_referencia_valor_dominio": "613110",
      "nome_resumido_valor_dominio": "CRIADOR DE BOVINOS (CORTE)",
      "nome_completo_valor_dominio": "CRIADOR DE BOVINOS (CORTE)",
      "descricao_conceito_valor_dominio": "CRIADOR DE BOVINOS (CORTE)"
    },
    {
      "codigo_valor_dominio": 2708,
      "codigo_referencia_valor_dominio": "613115",
      "nome_resumido_valor_dominio": "CRIADOR DE BOVINOS (LEITE)",
      "nome_completo_valor_dominio": "CRIADOR DE BOVINOS (LEITE)",
      "descricao_conceito_valor_dominio": "CRIADOR DE BOVINOS (LEITE)"
    },
    {
      "codigo_valor_dominio": 2709,
      "codigo_referencia_valor_dominio": "613120",
      "nome_resumido_valor_dominio": "CRIADOR DE BUBALINOS (CORTE)",
      "nome_completo_valor_dominio": "CRIADOR DE BUBALINOS (CORTE)",
      "descricao_conceito_valor_dominio": "CRIADOR DE BUBALINOS (CORTE)"
    },
    {
      "codigo_valor_dominio": 2710,
      "codigo_referencia_valor_dominio": "613125",
      "nome_resumido_valor_dominio": "CRIADOR DE BUBALINOS (LEITE)",
      "nome_completo_valor_dominio": "CRIADOR DE BUBALINOS (LEITE)",
      "descricao_conceito_valor_dominio": "CRIADOR DE BUBALINOS (LEITE)"
    },
    {
      "codigo_valor_dominio": 2711,
      "codigo_referencia_valor_dominio": "631305",
      "nome_resumido_valor_dominio": "CRIADOR DE CAMAROES",
      "nome_completo_valor_dominio": "CRIADOR DE CAMAROES",
      "descricao_conceito_valor_dominio": "CRIADOR DE CAMAROES"
    },
    {
      "codigo_valor_dominio": 2712,
      "codigo_referencia_valor_dominio": "631310",
      "nome_resumido_valor_dominio": "CRIADOR DE JACARES",
      "nome_completo_valor_dominio": "CRIADOR DE JACARES",
      "descricao_conceito_valor_dominio": "CRIADOR DE JACARES"
    },
    {
      "codigo_valor_dominio": 2713,
      "codigo_referencia_valor_dominio": "613130",
      "nome_resumido_valor_dominio": "CRIADOR DE EQUINOS",
      "nome_completo_valor_dominio": "CRIADOR DE EQUINOS",
      "descricao_conceito_valor_dominio": "CRIADOR DE EQUINOS"
    },
    {
      "codigo_valor_dominio": 2714,
      "codigo_referencia_valor_dominio": "631325",
      "nome_resumido_valor_dominio": "CRIADOR DE PEIXES",
      "nome_completo_valor_dominio": "CRIADOR DE PEIXES",
      "descricao_conceito_valor_dominio": "CRIADOR DE PEIXES"
    },
    {
      "codigo_valor_dominio": 2715,
      "codigo_referencia_valor_dominio": "613005",
      "nome_resumido_valor_dominio": "CRIADOR EM PECUARIA POLIVALENTE",
      "nome_completo_valor_dominio": "CRIADOR EM PECUARIA POLIVALENTE",
      "descricao_conceito_valor_dominio": "CRIADOR EM PECUARIA POLIVALENTE"
    },
    {
      "codigo_valor_dominio": 2716,
      "codigo_referencia_valor_dominio": "613305",
      "nome_resumido_valor_dominio": "AVICULTOR",
      "nome_completo_valor_dominio": "AVICULTOR",
      "descricao_conceito_valor_dominio": "AVICULTOR"
    },
    {
      "codigo_valor_dominio": 2717,
      "codigo_referencia_valor_dominio": "762205",
      "nome_resumido_valor_dominio": "CURTIDOR (COUROS E PELES)",
      "nome_completo_valor_dominio": "CURTIDOR (COUROS E PELES)",
      "descricao_conceito_valor_dominio": "CURTIDOR (COUROS E PELES)"
    },
    {
      "codigo_valor_dominio": 2718,
      "codigo_referencia_valor_dominio": "613405",
      "nome_resumido_valor_dominio": "APICULTOR",
      "nome_completo_valor_dominio": "APICULTOR",
      "descricao_conceito_valor_dominio": "APICULTOR"
    },
    {
      "codigo_valor_dominio": 2719,
      "codigo_referencia_valor_dominio": "613105",
      "nome_resumido_valor_dominio": "CRIADOR DE ASININOS E MUARES",
      "nome_completo_valor_dominio": "CRIADOR DE ASININOS E MUARES",
      "descricao_conceito_valor_dominio": "CRIADOR DE ASININOS E MUARES"
    },
    {
      "codigo_valor_dominio": 2720,
      "codigo_referencia_valor_dominio": "263105",
      "nome_resumido_valor_dominio": "MINISTRO DE CULTO RELIGIOSO",
      "nome_completo_valor_dominio": "MINISTRO DE CULTO RELIGIOSO",
      "descricao_conceito_valor_dominio": "MINISTRO DE CULTO RELIGIOSO"
    },
    {
      "codigo_valor_dominio": 2721,
      "codigo_referencia_valor_dominio": "632205",
      "nome_resumido_valor_dominio": "SERINGUEIRO",
      "nome_completo_valor_dominio": "SERINGUEIRO",
      "descricao_conceito_valor_dominio": "SERINGUEIRO"
    },
    {
      "codigo_valor_dominio": 2722,
      "codigo_referencia_valor_dominio": "620110",
      "nome_resumido_valor_dominio": "SUPERVISOR DE EXPLORACAO AGROPECUARIA",
      "nome_completo_valor_dominio": "SUPERVISOR DE EXPLORACAO AGROPECUARIA",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE EXPLORACAO AGROPECUARIA"
    },
    {
      "codigo_valor_dominio": 2723,
      "codigo_referencia_valor_dominio": "620115",
      "nome_resumido_valor_dominio": "SUPERVISOR DE EXPLORACAO PECUARIA",
      "nome_completo_valor_dominio": "SUPERVISOR DE EXPLORACAO PECUARIA",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE EXPLORACAO PECUARIA"
    },
    {
      "codigo_valor_dominio": 2724,
      "codigo_referencia_valor_dominio": "710110",
      "nome_resumido_valor_dominio": "SUPERVISOR DE EXTRACAO DE SAL",
      "nome_completo_valor_dominio": "SUPERVISOR DE EXTRACAO DE SAL",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE EXTRACAO DE SAL"
    },
    {
      "codigo_valor_dominio": 2725,
      "codigo_referencia_valor_dominio": "623305",
      "nome_resumido_valor_dominio": "TRABALHADOR DA AVICULTURA DE CORTE",
      "nome_completo_valor_dominio": "TRABALHADOR DA AVICULTURA DE CORTE",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA AVICULTURA DE CORTE"
    },
    {
      "codigo_valor_dominio": 2726,
      "codigo_referencia_valor_dominio": "622005",
      "nome_resumido_valor_dominio": "CASEIRO (AGRICULTURA)",
      "nome_completo_valor_dominio": "CASEIRO (AGRICULTURA)",
      "descricao_conceito_valor_dominio": "CASEIRO (AGRICULTURA)"
    },
    {
      "codigo_valor_dominio": 2727,
      "codigo_referencia_valor_dominio": "751010",
      "nome_resumido_valor_dominio": "JOALHEIRO",
      "nome_completo_valor_dominio": "JOALHEIRO",
      "descricao_conceito_valor_dominio": "JOALHEIRO"
    },
    {
      "codigo_valor_dominio": 2728,
      "codigo_referencia_valor_dominio": "623420",
      "nome_resumido_valor_dominio": "TRABALHADOR NA SERICICULTURA",
      "nome_completo_valor_dominio": "TRABALHADOR NA SERICICULTURA",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA SERICICULTURA"
    },
    {
      "codigo_valor_dominio": 2729,
      "codigo_referencia_valor_dominio": "712230",
      "nome_resumido_valor_dominio": "TRACADOR DE PEDRAS",
      "nome_completo_valor_dominio": "TRACADOR DE PEDRAS",
      "descricao_conceito_valor_dominio": "TRACADOR DE PEDRAS"
    },
    {
      "codigo_valor_dominio": 2730,
      "codigo_referencia_valor_dominio": "622605",
      "nome_resumido_valor_dominio": "TRABALHADOR DA CULTURA DE CACAU",
      "nome_completo_valor_dominio": "TRABALHADOR DA CULTURA DE CACAU",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA CULTURA DE CACAU"
    },
    {
      "codigo_valor_dominio": 2731,
      "codigo_referencia_valor_dominio": "622615",
      "nome_resumido_valor_dominio": "TRABALHADOR DA CULTURA DE ERVA-MATE",
      "nome_completo_valor_dominio": "TRABALHADOR DA CULTURA DE ERVA-MATE",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA CULTURA DE ERVA-MATE"
    },
    {
      "codigo_valor_dominio": 2732,
      "codigo_referencia_valor_dominio": "622810",
      "nome_resumido_valor_dominio": "TRABALHADOR DA CULTURA DE PLANTAS AROMATICAS E MEDICINAIS",
      "nome_completo_valor_dominio": "TRABALHADOR DA CULTURA DE PLANTAS AROMATICAS E MEDICINAIS",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA CULTURA DE PLANTAS AROMATICAS E MEDICINAIS"
    },
    {
      "codigo_valor_dominio": 2733,
      "codigo_referencia_valor_dominio": "622215",
      "nome_resumido_valor_dominio": "TRABALHADOR DA CULTURA DO RAMI",
      "nome_completo_valor_dominio": "TRABALHADOR DA CULTURA DO RAMI",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA CULTURA DO RAMI"
    },
    {
      "codigo_valor_dominio": 2734,
      "codigo_referencia_valor_dominio": "622105",
      "nome_resumido_valor_dominio": "TRABALHADOR DA CULTURA DE ARROZ",
      "nome_completo_valor_dominio": "TRABALHADOR DA CULTURA DE ARROZ",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA CULTURA DE ARROZ"
    },
    {
      "codigo_valor_dominio": 2735,
      "codigo_referencia_valor_dominio": "622120",
      "nome_resumido_valor_dominio": "TRABALHADOR DA CULTURA DE TRIGO, AVEIA, CEVADA E TRITICALE",
      "nome_completo_valor_dominio": "TRABALHADOR DA CULTURA DE TRIGO, AVEIA, CEVADA E TRITICALE",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA CULTURA DE TRIGO, AVEIA, CEVADA E TRITICALE"
    },
    {
      "codigo_valor_dominio": 2736,
      "codigo_referencia_valor_dominio": "623320",
      "nome_resumido_valor_dominio": "TRABALHADOR DA CUNICULTURA",
      "nome_completo_valor_dominio": "TRABALHADOR DA CUNICULTURA",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA CUNICULTURA"
    },
    {
      "codigo_valor_dominio": 2737,
      "codigo_referencia_valor_dominio": "622310",
      "nome_resumido_valor_dominio": "TRABALHADOR NA OLERICULTURA (LEGUMES)",
      "nome_completo_valor_dominio": "TRABALHADOR NA OLERICULTURA (LEGUMES)",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA OLERICULTURA (LEGUMES)"
    },
    {
      "codigo_valor_dominio": 2738,
      "codigo_referencia_valor_dominio": "622315",
      "nome_resumido_valor_dominio": "TRABALHADOR NA OLERICULTURA (RAIZES, BULBOS E TUBERCULOS)",
      "nome_completo_valor_dominio": "TRABALHADOR NA OLERICULTURA (RAIZES, BULBOS E TUBERCULOS)",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA OLERICULTURA (RAIZES, BULBOS E TUBERCULOS)"
    },
    {
      "codigo_valor_dominio": 2739,
      "codigo_referencia_valor_dominio": "622320",
      "nome_resumido_valor_dominio": "TRABALHADOR NA OLERICULTURA (TALOS, FOLHAS E FLORES)",
      "nome_completo_valor_dominio": "TRABALHADOR NA OLERICULTURA (TALOS, FOLHAS E FLORES)",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA OLERICULTURA (TALOS, FOLHAS E FLORES)"
    },
    {
      "codigo_valor_dominio": 2740,
      "codigo_referencia_valor_dominio": "643005",
      "nome_resumido_valor_dominio": "TRABALHADOR NA OPERACAO DE SISTEMA DE IRRIGACAO LOCALIZADA (",
      "nome_completo_valor_dominio": "TRABALHADOR NA OPERACAO DE SISTEMA DE IRRIGACAO LOCALIZADA (MICROASPERSAO E GOTEJAMENTO)",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA OPERACAO DE SISTEMA DE IRRIGACAO LOCALIZADA (MICROASPERSAO E GOTEJAMENTO)"
    },
    {
      "codigo_valor_dominio": 2741,
      "codigo_referencia_valor_dominio": "622410",
      "nome_resumido_valor_dominio": "TRABALHADOR NO CULTIVO DE FLORES EM VASO",
      "nome_completo_valor_dominio": "TRABALHADOR NO CULTIVO DE FLORES EM VASO",
      "descricao_conceito_valor_dominio": "TRABALHADOR NO CULTIVO DE FLORES EM VASO"
    },
    {
      "codigo_valor_dominio": 2742,
      "codigo_referencia_valor_dominio": "622415",
      "nome_resumido_valor_dominio": "TRABALHADOR NO CULTIVO DE FORRACOES",
      "nome_completo_valor_dominio": "TRABALHADOR NO CULTIVO DE FORRACOES",
      "descricao_conceito_valor_dominio": "TRABALHADOR NO CULTIVO DE FORRACOES"
    },
    {
      "codigo_valor_dominio": 2743,
      "codigo_referencia_valor_dominio": "622420",
      "nome_resumido_valor_dominio": "TRABALHADOR NO CULTIVO DE MUDAS",
      "nome_completo_valor_dominio": "TRABALHADOR NO CULTIVO DE MUDAS",
      "descricao_conceito_valor_dominio": "TRABALHADOR NO CULTIVO DE MUDAS"
    },
    {
      "codigo_valor_dominio": 2744,
      "codigo_referencia_valor_dominio": "622425",
      "nome_resumido_valor_dominio": "TRABALHADOR NO CULTIVO DE PLANTAS ORNAMENTAIS",
      "nome_completo_valor_dominio": "TRABALHADOR NO CULTIVO DE PLANTAS ORNAMENTAIS",
      "descricao_conceito_valor_dominio": "TRABALHADOR NO CULTIVO DE PLANTAS ORNAMENTAIS"
    },
    {
      "codigo_valor_dominio": 2745,
      "codigo_referencia_valor_dominio": "622515",
      "nome_resumido_valor_dominio": "TRABALHADOR NO CULTIVO DE TREPADEIRAS FRUTIFERAS",
      "nome_completo_valor_dominio": "TRABALHADOR NO CULTIVO DE TREPADEIRAS FRUTIFERAS",
      "descricao_conceito_valor_dominio": "TRABALHADOR NO CULTIVO DE TREPADEIRAS FRUTIFERAS"
    },
    {
      "codigo_valor_dominio": 2746,
      "codigo_referencia_valor_dominio": "622510",
      "nome_resumido_valor_dominio": "TRABALHADOR NO CULTIVO DE ESPECIES FRUTIFERAS RASTEIRAS",
      "nome_completo_valor_dominio": "TRABALHADOR NO CULTIVO DE ESPECIES FRUTIFERAS RASTEIRAS",
      "descricao_conceito_valor_dominio": "TRABALHADOR NO CULTIVO DE ESPECIES FRUTIFERAS RASTEIRAS"
    },
    {
      "codigo_valor_dominio": 2747,
      "codigo_referencia_valor_dominio": "622405",
      "nome_resumido_valor_dominio": "TRABALHADOR NO CULTIVO DE FLORES E FOLHAGENS DE CORTE",
      "nome_completo_valor_dominio": "TRABALHADOR NO CULTIVO DE FLORES E FOLHAGENS DE CORTE",
      "descricao_conceito_valor_dominio": "TRABALHADOR NO CULTIVO DE FLORES E FOLHAGENS DE CORTE"
    },
    {
      "codigo_valor_dominio": 2748,
      "codigo_referencia_valor_dominio": "764005",
      "nome_resumido_valor_dominio": "TRABALHADOR POLIVALENTE DA CONFECCAO DE CALCADOS",
      "nome_completo_valor_dominio": "TRABALHADOR POLIVALENTE DA CONFECCAO DE CALCADOS",
      "descricao_conceito_valor_dominio": "TRABALHADOR POLIVALENTE DA CONFECCAO DE CALCADOS"
    },
    {
      "codigo_valor_dominio": 2749,
      "codigo_referencia_valor_dominio": "622610",
      "nome_resumido_valor_dominio": "TRABALHADOR DA CULTURA DE CAFE",
      "nome_completo_valor_dominio": "TRABALHADOR DA CULTURA DE CAFE",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA CULTURA DE CAFE"
    },
    {
      "codigo_valor_dominio": 2750,
      "codigo_referencia_valor_dominio": "622110",
      "nome_resumido_valor_dominio": "TRABALHADOR DA CULTURA DE CANA-DE-ACUCAR",
      "nome_completo_valor_dominio": "TRABALHADOR DA CULTURA DE CANA-DE-ACUCAR",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA CULTURA DE CANA-DE-ACUCAR"
    },
    {
      "codigo_valor_dominio": 2751,
      "codigo_referencia_valor_dominio": "622805",
      "nome_resumido_valor_dominio": "TRABALHADOR DA CULTURA DE ESPECIARIAS",
      "nome_completo_valor_dominio": "TRABALHADOR DA CULTURA DE ESPECIARIAS",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA CULTURA DE ESPECIARIAS"
    },
    {
      "codigo_valor_dominio": 2752,
      "codigo_referencia_valor_dominio": "622625",
      "nome_resumido_valor_dominio": "TRABALHADOR DA CULTURA DE GUARANA",
      "nome_completo_valor_dominio": "TRABALHADOR DA CULTURA DE GUARANA",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA CULTURA DE GUARANA"
    },
    {
      "codigo_valor_dominio": 2753,
      "codigo_referencia_valor_dominio": "622115",
      "nome_resumido_valor_dominio": "TRABALHADOR DA CULTURA DE MILHO E SORGO",
      "nome_completo_valor_dominio": "TRABALHADOR DA CULTURA DE MILHO E SORGO",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA CULTURA DE MILHO E SORGO"
    },
    {
      "codigo_valor_dominio": 2754,
      "codigo_referencia_valor_dominio": "622710",
      "nome_resumido_valor_dominio": "TRABALHADOR NA CULTURA DE CANOLA",
      "nome_completo_valor_dominio": "TRABALHADOR NA CULTURA DE CANOLA",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA CULTURA DE CANOLA"
    },
    {
      "codigo_valor_dominio": 2755,
      "codigo_referencia_valor_dominio": "622715",
      "nome_resumido_valor_dominio": "TRABALHADOR NA CULTURA DE COCO-DA-BAIA",
      "nome_completo_valor_dominio": "TRABALHADOR NA CULTURA DE COCO-DA-BAIA",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA CULTURA DE COCO-DA-BAIA"
    },
    {
      "codigo_valor_dominio": 2756,
      "codigo_referencia_valor_dominio": "622720",
      "nome_resumido_valor_dominio": "TRABALHADOR NA CULTURA DE DENDE",
      "nome_completo_valor_dominio": "TRABALHADOR NA CULTURA DE DENDE",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA CULTURA DE DENDE"
    },
    {
      "codigo_valor_dominio": 2757,
      "codigo_referencia_valor_dominio": "622725",
      "nome_resumido_valor_dominio": "TRABALHADOR NA CULTURA DE MAMONA",
      "nome_completo_valor_dominio": "TRABALHADOR NA CULTURA DE MAMONA",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA CULTURA DE MAMONA"
    },
    {
      "codigo_valor_dominio": 2758,
      "codigo_referencia_valor_dominio": "622730",
      "nome_resumido_valor_dominio": "TRABALHADOR NA CULTURA DE SOJA",
      "nome_completo_valor_dominio": "TRABALHADOR NA CULTURA DE SOJA",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA CULTURA DE SOJA"
    },
    {
      "codigo_valor_dominio": 2759,
      "codigo_referencia_valor_dominio": "622735",
      "nome_resumido_valor_dominio": "TRABALHADOR NA CULTURA DO GIRASSOL",
      "nome_completo_valor_dominio": "TRABALHADOR NA CULTURA DO GIRASSOL",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA CULTURA DO GIRASSOL"
    },
    {
      "codigo_valor_dominio": 2760,
      "codigo_referencia_valor_dominio": "622740",
      "nome_resumido_valor_dominio": "TRABALHADOR NA CULTURA DO LINHO",
      "nome_completo_valor_dominio": "TRABALHADOR NA CULTURA DO LINHO",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA CULTURA DO LINHO"
    },
    {
      "codigo_valor_dominio": 2761,
      "codigo_referencia_valor_dominio": "823265",
      "nome_resumido_valor_dominio": "TRABALHADOR NA FABRICACAO DE PRODUTOS ABRASIVOS",
      "nome_completo_valor_dominio": "TRABALHADOR NA FABRICACAO DE PRODUTOS ABRASIVOS",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA FABRICACAO DE PRODUTOS ABRASIVOS"
    },
    {
      "codigo_valor_dominio": 2762,
      "codigo_referencia_valor_dominio": "622620",
      "nome_resumido_valor_dominio": "TRABALHADOR DA CULTURA DE FUMO",
      "nome_completo_valor_dominio": "TRABALHADOR DA CULTURA DE FUMO",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA CULTURA DE FUMO"
    },
    {
      "codigo_valor_dominio": 2763,
      "codigo_referencia_valor_dominio": "622210",
      "nome_resumido_valor_dominio": "TRABALHADOR DA CULTURA DE SISAL",
      "nome_completo_valor_dominio": "TRABALHADOR DA CULTURA DE SISAL",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA CULTURA DE SISAL"
    },
    {
      "codigo_valor_dominio": 2764,
      "codigo_referencia_valor_dominio": "623005",
      "nome_resumido_valor_dominio": "ADESTRADOR DE ANIMAIS",
      "nome_completo_valor_dominio": "ADESTRADOR DE ANIMAIS",
      "descricao_conceito_valor_dominio": "ADESTRADOR DE ANIMAIS"
    },
    {
      "codigo_valor_dominio": 2765,
      "codigo_referencia_valor_dominio": "334105",
      "nome_resumido_valor_dominio": "INSPETOR DE ALUNOS DE ESCOLA PRIVADA",
      "nome_completo_valor_dominio": "INSPETOR DE ALUNOS DE ESCOLA PRIVADA",
      "descricao_conceito_valor_dominio": "INSPETOR DE ALUNOS DE ESCOLA PRIVADA"
    },
    {
      "codigo_valor_dominio": 2766,
      "codigo_referencia_valor_dominio": "841484",
      "nome_resumido_valor_dominio": "TRABALHADOR DE PREPARACAO DE PESCADOS (LIMPEZA)",
      "nome_completo_valor_dominio": "TRABALHADOR DE PREPARACAO DE PESCADOS (LIMPEZA)",
      "descricao_conceito_valor_dominio": "TRABALHADOR DE PREPARACAO DE PESCADOS (LIMPEZA)"
    },
    {
      "codigo_valor_dominio": 2767,
      "codigo_referencia_valor_dominio": "641015",
      "nome_resumido_valor_dominio": "TRATORISTA AGRICOLA",
      "nome_completo_valor_dominio": "TRATORISTA AGRICOLA",
      "descricao_conceito_valor_dominio": "TRATORISTA AGRICOLA"
    },
    {
      "codigo_valor_dominio": 2768,
      "codigo_referencia_valor_dominio": "623110",
      "nome_resumido_valor_dominio": "TRABALHADOR DA PECUARIA (BOVINOS CORTE)",
      "nome_completo_valor_dominio": "TRABALHADOR DA PECUARIA (BOVINOS CORTE)",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA PECUARIA (BOVINOS CORTE)"
    },
    {
      "codigo_valor_dominio": 2769,
      "codigo_referencia_valor_dominio": "623115",
      "nome_resumido_valor_dominio": "TRABALHADOR DA PECUARIA (BOVINOS LEITE)",
      "nome_completo_valor_dominio": "TRABALHADOR DA PECUARIA (BOVINOS LEITE)",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA PECUARIA (BOVINOS LEITE)"
    },
    {
      "codigo_valor_dominio": 2770,
      "codigo_referencia_valor_dominio": "623120",
      "nome_resumido_valor_dominio": "TRABALHADOR DA PECUARIA (BUBALINOS)",
      "nome_completo_valor_dominio": "TRABALHADOR DA PECUARIA (BUBALINOS)",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA PECUARIA (BUBALINOS)"
    },
    {
      "codigo_valor_dominio": 2771,
      "codigo_referencia_valor_dominio": "623125",
      "nome_resumido_valor_dominio": "TRABALHADOR DA PECUARIA (EQUINOS)",
      "nome_completo_valor_dominio": "TRABALHADOR DA PECUARIA (EQUINOS)",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA PECUARIA (EQUINOS)"
    },
    {
      "codigo_valor_dominio": 2772,
      "codigo_referencia_valor_dominio": "623215",
      "nome_resumido_valor_dominio": "TRABALHADOR DA SUINOCULTURA",
      "nome_completo_valor_dominio": "TRABALHADOR DA SUINOCULTURA",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA SUINOCULTURA"
    },
    {
      "codigo_valor_dominio": 2773,
      "codigo_referencia_valor_dominio": "622205",
      "nome_resumido_valor_dominio": "TRABALHADOR DA CULTURA DE ALGODAO",
      "nome_completo_valor_dominio": "TRABALHADOR DA CULTURA DE ALGODAO",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA CULTURA DE ALGODAO"
    },
    {
      "codigo_valor_dominio": 2774,
      "codigo_referencia_valor_dominio": "623105",
      "nome_resumido_valor_dominio": "TRABALHADOR DA PECUARIA (ASININOS E MUARES)",
      "nome_completo_valor_dominio": "TRABALHADOR DA PECUARIA (ASININOS E MUARES)",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA PECUARIA (ASININOS E MUARES)"
    },
    {
      "codigo_valor_dominio": 2775,
      "codigo_referencia_valor_dominio": "632125",
      "nome_resumido_valor_dominio": "TRABALHADOR DE EXTRACAO FLORESTAL, EM GERAL",
      "nome_completo_valor_dominio": "TRABALHADOR DE EXTRACAO FLORESTAL, EM GERAL",
      "descricao_conceito_valor_dominio": "TRABALHADOR DE EXTRACAO FLORESTAL, EM GERAL"
    },
    {
      "codigo_valor_dominio": 2776,
      "codigo_referencia_valor_dominio": "623310",
      "nome_resumido_valor_dominio": "TRABALHADOR DA AVICULTURA DE POSTURA",
      "nome_completo_valor_dominio": "TRABALHADOR DA AVICULTURA DE POSTURA",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA AVICULTURA DE POSTURA"
    },
    {
      "codigo_valor_dominio": 2777,
      "codigo_referencia_valor_dominio": "623205",
      "nome_resumido_valor_dominio": "TRABALHADOR DA CAPRINOCULTURA",
      "nome_completo_valor_dominio": "TRABALHADOR DA CAPRINOCULTURA",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA CAPRINOCULTURA"
    },
    {
      "codigo_valor_dominio": 2778,
      "codigo_referencia_valor_dominio": "391215",
      "nome_resumido_valor_dominio": "OPERADOR DE INSPECAO DE QUALIDADE",
      "nome_completo_valor_dominio": "OPERADOR DE INSPECAO DE QUALIDADE",
      "descricao_conceito_valor_dominio": "OPERADOR DE INSPECAO DE QUALIDADE"
    },
    {
      "codigo_valor_dominio": 2779,
      "codigo_referencia_valor_dominio": "823320",
      "nome_resumido_valor_dominio": "TRABALHADOR DA ELABORACAO DE PRE-FABRICADOS (CIMENTO AMIANTO",
      "nome_completo_valor_dominio": "TRABALHADOR DA ELABORACAO DE PRE-FABRICADOS (CIMENTO AMIANTO)",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA ELABORACAO DE PRE-FABRICADOS (CIMENTO AMIANTO)"
    },
    {
      "codigo_valor_dominio": 2780,
      "codigo_referencia_valor_dominio": "782145",
      "nome_resumido_valor_dominio": "SINALEIRO (PONTE-ROLANTE)",
      "nome_completo_valor_dominio": "SINALEIRO (PONTE-ROLANTE)",
      "descricao_conceito_valor_dominio": "SINALEIRO (PONTE-ROLANTE)"
    },
    {
      "codigo_valor_dominio": 2781,
      "codigo_referencia_valor_dominio": "623410",
      "nome_resumido_valor_dominio": "TRABALHADOR NA APICULTURA",
      "nome_completo_valor_dominio": "TRABALHADOR NA APICULTURA",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA APICULTURA"
    },
    {
      "codigo_valor_dominio": 2782,
      "codigo_referencia_valor_dominio": "622705",
      "nome_resumido_valor_dominio": "TRABALHADOR NA CULTURA DE AMENDOIM",
      "nome_completo_valor_dominio": "TRABALHADOR NA CULTURA DE AMENDOIM",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA CULTURA DE AMENDOIM"
    },
    {
      "codigo_valor_dominio": 2783,
      "codigo_referencia_valor_dominio": "622305",
      "nome_resumido_valor_dominio": "TRABALHADOR NA OLERICULTURA (FRUTOS E SEMENTES)",
      "nome_completo_valor_dominio": "TRABALHADOR NA OLERICULTURA (FRUTOS E SEMENTES)",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA OLERICULTURA (FRUTOS E SEMENTES)"
    },
    {
      "codigo_valor_dominio": 2784,
      "codigo_referencia_valor_dominio": "622505",
      "nome_resumido_valor_dominio": "TRABALHADOR NO CULTIVO DE ARVORES FRUTIFERAS",
      "nome_completo_valor_dominio": "TRABALHADOR NO CULTIVO DE ARVORES FRUTIFERAS",
      "descricao_conceito_valor_dominio": "TRABALHADOR NO CULTIVO DE ARVORES FRUTIFERAS"
    },
    {
      "codigo_valor_dominio": 2785,
      "codigo_referencia_valor_dominio": "630110",
      "nome_resumido_valor_dominio": "SUPERVISOR DA AREA FLORESTAL",
      "nome_completo_valor_dominio": "SUPERVISOR DA AREA FLORESTAL",
      "descricao_conceito_valor_dominio": "SUPERVISOR DA AREA FLORESTAL"
    },
    {
      "codigo_valor_dominio": 2786,
      "codigo_referencia_valor_dominio": "760505",
      "nome_resumido_valor_dominio": "SUPERVISOR DA CONFECCAO DE ARTEFATOS DE TECIDOS, COUROS E AF",
      "nome_completo_valor_dominio": "SUPERVISOR DA CONFECCAO DE ARTEFATOS DE TECIDOS, COUROS E AFINS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DA CONFECCAO DE ARTEFATOS DE TECIDOS, COUROS E AFINS"
    },
    {
      "codigo_valor_dominio": 2787,
      "codigo_referencia_valor_dominio": "631005",
      "nome_resumido_valor_dominio": "CATADOR DE CARANGUEJOS E SIRIS",
      "nome_completo_valor_dominio": "CATADOR DE CARANGUEJOS E SIRIS",
      "descricao_conceito_valor_dominio": "CATADOR DE CARANGUEJOS E SIRIS"
    },
    {
      "codigo_valor_dominio": 2788,
      "codigo_referencia_valor_dominio": "631010",
      "nome_resumido_valor_dominio": "CATADOR DE MARISCOS",
      "nome_completo_valor_dominio": "CATADOR DE MARISCOS",
      "descricao_conceito_valor_dominio": "CATADOR DE MARISCOS"
    },
    {
      "codigo_valor_dominio": 2789,
      "codigo_referencia_valor_dominio": "631020",
      "nome_resumido_valor_dominio": "PESCADOR ARTESANAL DE PEIXES E CAMAROES",
      "nome_completo_valor_dominio": "PESCADOR ARTESANAL DE PEIXES E CAMAROES",
      "descricao_conceito_valor_dominio": "PESCADOR ARTESANAL DE PEIXES E CAMAROES"
    },
    {
      "codigo_valor_dominio": 2790,
      "codigo_referencia_valor_dominio": "631205",
      "nome_resumido_valor_dominio": "PESCADOR INDUSTRIAL",
      "nome_completo_valor_dominio": "PESCADOR INDUSTRIAL",
      "descricao_conceito_valor_dominio": "PESCADOR INDUSTRIAL"
    },
    {
      "codigo_valor_dominio": 2791,
      "codigo_referencia_valor_dominio": "631015",
      "nome_resumido_valor_dominio": "PESCADOR ARTESANAL DE LAGOSTAS",
      "nome_completo_valor_dominio": "PESCADOR ARTESANAL DE LAGOSTAS",
      "descricao_conceito_valor_dominio": "PESCADOR ARTESANAL DE LAGOSTAS"
    },
    {
      "codigo_valor_dominio": 2792,
      "codigo_referencia_valor_dominio": "631210",
      "nome_resumido_valor_dominio": "PESCADOR PROFISSIONAL",
      "nome_completo_valor_dominio": "PESCADOR PROFISSIONAL",
      "descricao_conceito_valor_dominio": "PESCADOR PROFISSIONAL"
    },
    {
      "codigo_valor_dominio": 2793,
      "codigo_referencia_valor_dominio": "203305",
      "nome_resumido_valor_dominio": "PESQUISADOR DE CLINICA MEDICA",
      "nome_completo_valor_dominio": "PESQUISADOR DE CLINICA MEDICA",
      "descricao_conceito_valor_dominio": "PESQUISADOR DE CLINICA MEDICA"
    },
    {
      "codigo_valor_dominio": 2794,
      "codigo_referencia_valor_dominio": "613205",
      "nome_resumido_valor_dominio": "CRIADOR DE CAPRINOS",
      "nome_completo_valor_dominio": "CRIADOR DE CAPRINOS",
      "descricao_conceito_valor_dominio": "CRIADOR DE CAPRINOS"
    },
    {
      "codigo_valor_dominio": 2795,
      "codigo_referencia_valor_dominio": "631315",
      "nome_resumido_valor_dominio": "CRIADOR DE MEXILHOES",
      "nome_completo_valor_dominio": "CRIADOR DE MEXILHOES",
      "descricao_conceito_valor_dominio": "CRIADOR DE MEXILHOES"
    },
    {
      "codigo_valor_dominio": 2796,
      "codigo_referencia_valor_dominio": "631320",
      "nome_resumido_valor_dominio": "CRIADOR DE OSTRAS",
      "nome_completo_valor_dominio": "CRIADOR DE OSTRAS",
      "descricao_conceito_valor_dominio": "CRIADOR DE OSTRAS"
    },
    {
      "codigo_valor_dominio": 2797,
      "codigo_referencia_valor_dominio": "613210",
      "nome_resumido_valor_dominio": "CRIADOR DE OVINOS",
      "nome_completo_valor_dominio": "CRIADOR DE OVINOS",
      "descricao_conceito_valor_dominio": "CRIADOR DE OVINOS"
    },
    {
      "codigo_valor_dominio": 2798,
      "codigo_referencia_valor_dominio": "631330",
      "nome_resumido_valor_dominio": "CRIADOR DE QUELONIOS",
      "nome_completo_valor_dominio": "CRIADOR DE QUELONIOS",
      "descricao_conceito_valor_dominio": "CRIADOR DE QUELONIOS"
    },
    {
      "codigo_valor_dominio": 2799,
      "codigo_referencia_valor_dominio": "631335",
      "nome_resumido_valor_dominio": "CRIADOR DE RAS",
      "nome_completo_valor_dominio": "CRIADOR DE RAS",
      "descricao_conceito_valor_dominio": "CRIADOR DE RAS"
    },
    {
      "codigo_valor_dominio": 2800,
      "codigo_referencia_valor_dominio": "613215",
      "nome_resumido_valor_dominio": "CRIADOR DE SUINOS",
      "nome_completo_valor_dominio": "CRIADOR DE SUINOS",
      "descricao_conceito_valor_dominio": "CRIADOR DE SUINOS"
    },
    {
      "codigo_valor_dominio": 2801,
      "codigo_referencia_valor_dominio": "631410",
      "nome_resumido_valor_dominio": "GELADOR PROFISSIONAL",
      "nome_completo_valor_dominio": "GELADOR PROFISSIONAL",
      "descricao_conceito_valor_dominio": "GELADOR PROFISSIONAL"
    },
    {
      "codigo_valor_dominio": 2802,
      "codigo_referencia_valor_dominio": "201115",
      "nome_resumido_valor_dominio": "GENETICISTA",
      "nome_completo_valor_dominio": "GENETICISTA",
      "descricao_conceito_valor_dominio": "GENETICISTA"
    },
    {
      "codigo_valor_dominio": 2803,
      "codigo_referencia_valor_dominio": "231205",
      "nome_resumido_valor_dominio": "PROFESSOR DA EDUCACAO DE JOVENS E ADULTOS DO ENSINO FUNDAMEN",
      "nome_completo_valor_dominio": "PROFESSOR DA EDUCACAO DE JOVENS E ADULTOS DO ENSINO FUNDAMENTAL (PRIMEIRA A QUARTA SERIE)",
      "descricao_conceito_valor_dominio": "PROFESSOR DA EDUCACAO DE JOVENS E ADULTOS DO ENSINO FUNDAMENTAL (PRIMEIRA A QUARTA SERIE)"
    },
    {
      "codigo_valor_dominio": 2804,
      "codigo_referencia_valor_dominio": "841472",
      "nome_resumido_valor_dominio": "REFINADOR DE OLEO E GORDURA",
      "nome_completo_valor_dominio": "REFINADOR DE OLEO E GORDURA",
      "descricao_conceito_valor_dominio": "REFINADOR DE OLEO E GORDURA"
    },
    {
      "codigo_valor_dominio": 2805,
      "codigo_referencia_valor_dominio": "782205",
      "nome_resumido_valor_dominio": "GUINCHEIRO (CONSTRUCAO CIVIL)",
      "nome_completo_valor_dominio": "GUINCHEIRO (CONSTRUCAO CIVIL)",
      "descricao_conceito_valor_dominio": "GUINCHEIRO (CONSTRUCAO CIVIL)"
    },
    {
      "codigo_valor_dominio": 2806,
      "codigo_referencia_valor_dominio": "762220",
      "nome_resumido_valor_dominio": "REBAIXADOR DE COUROS",
      "nome_completo_valor_dominio": "REBAIXADOR DE COUROS",
      "descricao_conceito_valor_dominio": "REBAIXADOR DE COUROS"
    },
    {
      "codigo_valor_dominio": 2807,
      "codigo_referencia_valor_dominio": "841745",
      "nome_resumido_valor_dominio": "XAROPEIRO",
      "nome_completo_valor_dominio": "XAROPEIRO",
      "descricao_conceito_valor_dominio": "XAROPEIRO"
    },
    {
      "codigo_valor_dominio": 2808,
      "codigo_referencia_valor_dominio": "632105",
      "nome_resumido_valor_dominio": "CLASSIFICADOR DE TORAS",
      "nome_completo_valor_dominio": "CLASSIFICADOR DE TORAS",
      "descricao_conceito_valor_dominio": "CLASSIFICADOR DE TORAS"
    },
    {
      "codigo_valor_dominio": 2809,
      "codigo_referencia_valor_dominio": "516210",
      "nome_resumido_valor_dominio": "CUIDADOR DE IDOSOS",
      "nome_completo_valor_dominio": "CUIDADOR DE IDOSOS",
      "descricao_conceito_valor_dominio": "CUIDADOR DE IDOSOS"
    },
    {
      "codigo_valor_dominio": 2810,
      "codigo_referencia_valor_dominio": "372110",
      "nome_resumido_valor_dominio": "ILUMINADOR (TELEVISAO)",
      "nome_completo_valor_dominio": "ILUMINADOR (TELEVISAO)",
      "descricao_conceito_valor_dominio": "ILUMINADOR (TELEVISAO)"
    },
    {
      "codigo_valor_dominio": 2811,
      "codigo_referencia_valor_dominio": "253225",
      "nome_resumido_valor_dominio": "OPERADOR DE NEGOCIOS",
      "nome_completo_valor_dominio": "OPERADOR DE NEGOCIOS",
      "descricao_conceito_valor_dominio": "OPERADOR DE NEGOCIOS"
    },
    {
      "codigo_valor_dominio": 2812,
      "codigo_referencia_valor_dominio": "841476",
      "nome_resumido_valor_dominio": "TRABALHADOR DE FABRICACAO DE MARGARINA",
      "nome_completo_valor_dominio": "TRABALHADOR DE FABRICACAO DE MARGARINA",
      "descricao_conceito_valor_dominio": "TRABALHADOR DE FABRICACAO DE MARGARINA"
    },
    {
      "codigo_valor_dominio": 2813,
      "codigo_referencia_valor_dominio": "773115",
      "nome_resumido_valor_dominio": "SERRADOR DE BORDAS NO DESDOBRAMENTO DE MADEIRA",
      "nome_completo_valor_dominio": "SERRADOR DE BORDAS NO DESDOBRAMENTO DE MADEIRA",
      "descricao_conceito_valor_dominio": "SERRADOR DE BORDAS NO DESDOBRAMENTO DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 2814,
      "codigo_referencia_valor_dominio": "632515",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE MADEIRAS TANANTES",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE MADEIRAS TANANTES",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE MADEIRAS TANANTES"
    },
    {
      "codigo_valor_dominio": 2815,
      "codigo_referencia_valor_dominio": "632370",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE TUCUM",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE TUCUM",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE TUCUM"
    },
    {
      "codigo_valor_dominio": 2816,
      "codigo_referencia_valor_dominio": "632505",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE ARVORES E ARBUSTOS PRODUTORES D",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE ARVORES E ARBUSTOS PRODUTORES DE SUBSTANCIAS AROMAT., MEDIC. E TOXICAS",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE ARVORES E ARBUSTOS PRODUTORES DE SUBSTANCIAS AROMAT., MEDIC. E TOXICAS"
    },
    {
      "codigo_valor_dominio": 2817,
      "codigo_referencia_valor_dominio": "632315",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE BACABA",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE BACABA",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE BACABA"
    },
    {
      "codigo_valor_dominio": 2818,
      "codigo_referencia_valor_dominio": "632320",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE BURITI",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE BURITI",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE BURITI"
    },
    {
      "codigo_valor_dominio": 2819,
      "codigo_referencia_valor_dominio": "632325",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE CARNAUBA",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE CARNAUBA",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE CARNAUBA"
    },
    {
      "codigo_valor_dominio": 2820,
      "codigo_referencia_valor_dominio": "632410",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE CASTANHA",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE CASTANHA",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE CASTANHA"
    },
    {
      "codigo_valor_dominio": 2821,
      "codigo_referencia_valor_dominio": "632335",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE COPAIBA",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE COPAIBA",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE COPAIBA"
    },
    {
      "codigo_valor_dominio": 2822,
      "codigo_referencia_valor_dominio": "632210",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE ESPECIES PRODUTORAS DE GOMAS NA",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE ESPECIES PRODUTORAS DE GOMAS NAO ELASTICAS",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE ESPECIES PRODUTORAS DE GOMAS NAO ELASTICAS"
    },
    {
      "codigo_valor_dominio": 2823,
      "codigo_referencia_valor_dominio": "632345",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE MURUMURU",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE MURUMURU",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE MURUMURU"
    },
    {
      "codigo_valor_dominio": 2824,
      "codigo_referencia_valor_dominio": "632350",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE OITICICA",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE OITICICA",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE OITICICA"
    },
    {
      "codigo_valor_dominio": 2825,
      "codigo_referencia_valor_dominio": "632355",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE OURICURI",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE OURICURI",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE OURICURI"
    },
    {
      "codigo_valor_dominio": 2826,
      "codigo_referencia_valor_dominio": "632360",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE PEQUI",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE PEQUI",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE PEQUI"
    },
    {
      "codigo_valor_dominio": 2827,
      "codigo_referencia_valor_dominio": "632365",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE PIACAVA",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE PIACAVA",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE PIACAVA"
    },
    {
      "codigo_valor_dominio": 2828,
      "codigo_referencia_valor_dominio": "632415",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE PINHAO",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE PINHAO",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE PINHAO"
    },
    {
      "codigo_valor_dominio": 2829,
      "codigo_referencia_valor_dominio": "632525",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXTRACAO DE SUBSTANCIAS AROMATICAS, MEDICINAI",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXTRACAO DE SUBSTANCIAS AROMATICAS, MEDICINAIS E TOXICAS, EM GERAL",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXTRACAO DE SUBSTANCIAS AROMATICAS, MEDICINAIS E TOXICAS, EM GERAL"
    },
    {
      "codigo_valor_dominio": 2830,
      "codigo_referencia_valor_dominio": "632305",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE ANDIROBA",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE ANDIROBA",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE ANDIROBA"
    },
    {
      "codigo_valor_dominio": 2831,
      "codigo_referencia_valor_dominio": "632510",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE CIPOS PRODUTORES DE SUBSTANCIAS",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE CIPOS PRODUTORES DE SUBSTANCIAS AROMATICAS, MEDICINAIS E TOXICAS",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE CIPOS PRODUTORES DE SUBSTANCIAS AROMATICAS, MEDICINAIS E TOXICAS"
    },
    {
      "codigo_valor_dominio": 2832,
      "codigo_referencia_valor_dominio": "632420",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE PUPUNHA",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE PUPUNHA",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE PUPUNHA"
    },
    {
      "codigo_valor_dominio": 2833,
      "codigo_referencia_valor_dominio": "632520",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE RAIZES PRODUTORAS DE SUBSTANCIA",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE RAIZES PRODUTORAS DE SUBSTANCIAS AROMATICAS, MEDICINAIS E TOXICAS",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE RAIZES PRODUTORAS DE SUBSTANCIAS AROMATICAS, MEDICINAIS E TOXICAS"
    },
    {
      "codigo_valor_dominio": 2834,
      "codigo_referencia_valor_dominio": "632310",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE BABACU",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE BABACU",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE BABACU"
    },
    {
      "codigo_valor_dominio": 2835,
      "codigo_referencia_valor_dominio": "632330",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE COCO-DA-PRAIA",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE COCO-DA-PRAIA",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE COCO-DA-PRAIA"
    },
    {
      "codigo_valor_dominio": 2836,
      "codigo_referencia_valor_dominio": "632340",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE MALVA (PAINA)",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE MALVA (PAINA)",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE MALVA (PAINA)"
    },
    {
      "codigo_valor_dominio": 2837,
      "codigo_referencia_valor_dominio": "632215",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE RESINAS",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE RESINAS",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE RESINAS"
    },
    {
      "codigo_valor_dominio": 2838,
      "codigo_referencia_valor_dominio": "812110",
      "nome_resumido_valor_dominio": "TRABALHADOR DA FABRICACAO DE MUNICAO E EXPLOSIVOS",
      "nome_completo_valor_dominio": "TRABALHADOR DA FABRICACAO DE MUNICAO E EXPLOSIVOS",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA FABRICACAO DE MUNICAO E EXPLOSIVOS"
    },
    {
      "codigo_valor_dominio": 2839,
      "codigo_referencia_valor_dominio": "632605",
      "nome_resumido_valor_dominio": "CARVOEIRO",
      "nome_completo_valor_dominio": "CARVOEIRO",
      "descricao_conceito_valor_dominio": "CARVOEIRO"
    },
    {
      "codigo_valor_dominio": 2840,
      "codigo_referencia_valor_dominio": "632610",
      "nome_resumido_valor_dominio": "CARBONIZADOR",
      "nome_completo_valor_dominio": "CARBONIZADOR",
      "descricao_conceito_valor_dominio": "CARBONIZADOR"
    },
    {
      "codigo_valor_dominio": 2841,
      "codigo_referencia_valor_dominio": "632615",
      "nome_resumido_valor_dominio": "AJUDANTE DE CARVOARIA",
      "nome_completo_valor_dominio": "AJUDANTE DE CARVOARIA",
      "descricao_conceito_valor_dominio": "AJUDANTE DE CARVOARIA"
    },
    {
      "codigo_valor_dominio": 2842,
      "codigo_referencia_valor_dominio": "715110",
      "nome_resumido_valor_dominio": "OPERADOR DE COMPACTADORA DE SOLOS",
      "nome_completo_valor_dominio": "OPERADOR DE COMPACTADORA DE SOLOS",
      "descricao_conceito_valor_dominio": "OPERADOR DE COMPACTADORA DE SOLOS"
    },
    {
      "codigo_valor_dominio": 2843,
      "codigo_referencia_valor_dominio": "715125",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINAS DE CONSTRUCAO CIVIL E MINERACAO",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINAS DE CONSTRUCAO CIVIL E MINERACAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINAS DE CONSTRUCAO CIVIL E MINERACAO"
    },
    {
      "codigo_valor_dominio": 2844,
      "codigo_referencia_valor_dominio": "751130",
      "nome_resumido_valor_dominio": "TREFILADOR (JOALHERIA E OURIVESARIA)",
      "nome_completo_valor_dominio": "TREFILADOR (JOALHERIA E OURIVESARIA)",
      "descricao_conceito_valor_dominio": "TREFILADOR (JOALHERIA E OURIVESARIA)"
    },
    {
      "codigo_valor_dominio": 2845,
      "codigo_referencia_valor_dominio": "641005",
      "nome_resumido_valor_dominio": "OPERADOR DE COLHEITADEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE COLHEITADEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE COLHEITADEIRA"
    },
    {
      "codigo_valor_dominio": 2846,
      "codigo_referencia_valor_dominio": "721210",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINAS OPERATRIZES",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINAS OPERATRIZES",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINAS OPERATRIZES"
    },
    {
      "codigo_valor_dominio": 2847,
      "codigo_referencia_valor_dominio": "782605",
      "nome_resumido_valor_dominio": "OPERADOR DE TREM DE METRO",
      "nome_completo_valor_dominio": "OPERADOR DE TREM DE METRO",
      "descricao_conceito_valor_dominio": "OPERADOR DE TREM DE METRO"
    },
    {
      "codigo_valor_dominio": 2848,
      "codigo_referencia_valor_dominio": "643010",
      "nome_resumido_valor_dominio": "TRABALHADOR NA OPERACAO DE SISTEMA DE IRRIGACAO POR ASPERSAO",
      "nome_completo_valor_dominio": "TRABALHADOR NA OPERACAO DE SISTEMA DE IRRIGACAO POR ASPERSAO (PIVO CENTRAL)",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA OPERACAO DE SISTEMA DE IRRIGACAO POR ASPERSAO (PIVO CENTRAL)"
    },
    {
      "codigo_valor_dominio": 2849,
      "codigo_referencia_valor_dominio": "643015",
      "nome_resumido_valor_dominio": "TRABALHADOR NA OPERACAO DE SISTEMAS CONVENCIONAIS DE IRRIGAC",
      "nome_completo_valor_dominio": "TRABALHADOR NA OPERACAO DE SISTEMAS CONVENCIONAIS DE IRRIGACAO POR ASPERSAO",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA OPERACAO DE SISTEMAS CONVENCIONAIS DE IRRIGACAO POR ASPERSAO"
    },
    {
      "codigo_valor_dominio": 2850,
      "codigo_referencia_valor_dominio": "643020",
      "nome_resumido_valor_dominio": "TRABALHADOR NA OPERACAO DE SISTEMAS DE IRRIGACAO E ASPERSAO",
      "nome_completo_valor_dominio": "TRABALHADOR NA OPERACAO DE SISTEMAS DE IRRIGACAO E ASPERSAO (ALTO PROPELIDO)",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA OPERACAO DE SISTEMAS DE IRRIGACAO E ASPERSAO (ALTO PROPELIDO)"
    },
    {
      "codigo_valor_dominio": 2851,
      "codigo_referencia_valor_dominio": "643025",
      "nome_resumido_valor_dominio": "TRABALHADOR NA OPERACAO DE SISTEMAS DE IRRIGACAO POR SUPERFI",
      "nome_completo_valor_dominio": "TRABALHADOR NA OPERACAO DE SISTEMAS DE IRRIGACAO POR SUPERFICIE E DRENAGEM",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA OPERACAO DE SISTEMAS DE IRRIGACAO POR SUPERFICIE E DRENAGEM"
    },
    {
      "codigo_valor_dominio": 2852,
      "codigo_referencia_valor_dominio": "622015",
      "nome_resumido_valor_dominio": "TRABALHADOR NA PRODUCAO DE MUDAS E SEMENTES",
      "nome_completo_valor_dominio": "TRABALHADOR NA PRODUCAO DE MUDAS E SEMENTES",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA PRODUCAO DE MUDAS E SEMENTES"
    },
    {
      "codigo_valor_dominio": 2853,
      "codigo_referencia_valor_dominio": "510305",
      "nome_resumido_valor_dominio": "SUPERVISOR DE BOMBEIROS",
      "nome_completo_valor_dominio": "SUPERVISOR DE BOMBEIROS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE BOMBEIROS"
    },
    {
      "codigo_valor_dominio": 2854,
      "codigo_referencia_valor_dominio": "740110",
      "nome_resumido_valor_dominio": "SUPERVISOR DE FABRICACAO DE INSTRUMENTOS MUSICAIS",
      "nome_completo_valor_dominio": "SUPERVISOR DE FABRICACAO DE INSTRUMENTOS MUSICAIS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE FABRICACAO DE INSTRUMENTOS MUSICAIS"
    },
    {
      "codigo_valor_dominio": 2855,
      "codigo_referencia_valor_dominio": "840105",
      "nome_resumido_valor_dominio": "SUPERVISOR DE PRODUCAO DA INDUSTRIA ALIMENTICIA",
      "nome_completo_valor_dominio": "SUPERVISOR DE PRODUCAO DA INDUSTRIA ALIMENTICIA",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE PRODUCAO DA INDUSTRIA ALIMENTICIA"
    },
    {
      "codigo_valor_dominio": 2856,
      "codigo_referencia_valor_dominio": "420125",
      "nome_resumido_valor_dominio": "SUPERVISOR DE RECEPCIONISTAS",
      "nome_completo_valor_dominio": "SUPERVISOR DE RECEPCIONISTAS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE RECEPCIONISTAS"
    },
    {
      "codigo_valor_dominio": 2857,
      "codigo_referencia_valor_dominio": "510105",
      "nome_resumido_valor_dominio": "SUPERVISOR DE TRANSPORTES",
      "nome_completo_valor_dominio": "SUPERVISOR DE TRANSPORTES",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE TRANSPORTES"
    },
    {
      "codigo_valor_dominio": 2858,
      "codigo_referencia_valor_dominio": "720205",
      "nome_resumido_valor_dominio": "MESTRE (CONSTRUCAO NAVAL)",
      "nome_completo_valor_dominio": "MESTRE (CONSTRUCAO NAVAL)",
      "descricao_conceito_valor_dominio": "MESTRE (CONSTRUCAO NAVAL)"
    },
    {
      "codigo_valor_dominio": 2859,
      "codigo_referencia_valor_dominio": "720135",
      "nome_resumido_valor_dominio": "MESTRE DE PINTURA (TRATAMENTO DE SUPERFICIES)",
      "nome_completo_valor_dominio": "MESTRE DE PINTURA (TRATAMENTO DE SUPERFICIES)",
      "descricao_conceito_valor_dominio": "MESTRE DE PINTURA (TRATAMENTO DE SUPERFICIES)"
    },
    {
      "codigo_valor_dominio": 2860,
      "codigo_referencia_valor_dominio": "991110",
      "nome_resumido_valor_dominio": "INSPETOR DE VIA PERMANENTE (TRILHOS)",
      "nome_completo_valor_dominio": "INSPETOR DE VIA PERMANENTE (TRILHOS)",
      "descricao_conceito_valor_dominio": "INSPETOR DE VIA PERMANENTE (TRILHOS)"
    },
    {
      "codigo_valor_dominio": 2861,
      "codigo_referencia_valor_dominio": "520110",
      "nome_resumido_valor_dominio": "SUPERVISOR DE VENDAS COMERCIAL",
      "nome_completo_valor_dominio": "SUPERVISOR DE VENDAS COMERCIAL",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE VENDAS COMERCIAL"
    },
    {
      "codigo_valor_dominio": 2862,
      "codigo_referencia_valor_dominio": "511205",
      "nome_resumido_valor_dominio": "FISCAL DE TRANSPORTES COLETIVOS (EXCETO TREM)",
      "nome_completo_valor_dominio": "FISCAL DE TRANSPORTES COLETIVOS (EXCETO TREM)",
      "descricao_conceito_valor_dominio": "FISCAL DE TRANSPORTES COLETIVOS (EXCETO TREM)"
    },
    {
      "codigo_valor_dominio": 2863,
      "codigo_referencia_valor_dominio": "711105",
      "nome_resumido_valor_dominio": "AMOSTRADOR DE MINERIOS",
      "nome_completo_valor_dominio": "AMOSTRADOR DE MINERIOS",
      "descricao_conceito_valor_dominio": "AMOSTRADOR DE MINERIOS"
    },
    {
      "codigo_valor_dominio": 2864,
      "codigo_referencia_valor_dominio": "711110",
      "nome_resumido_valor_dominio": "CANTEIRO",
      "nome_completo_valor_dominio": "CANTEIRO",
      "descricao_conceito_valor_dominio": "CANTEIRO"
    },
    {
      "codigo_valor_dominio": 2865,
      "codigo_referencia_valor_dominio": "351805",
      "nome_resumido_valor_dominio": "DETETIVE PROFISSIONAL",
      "nome_completo_valor_dominio": "DETETIVE PROFISSIONAL",
      "descricao_conceito_valor_dominio": "DETETIVE PROFISSIONAL"
    },
    {
      "codigo_valor_dominio": 2866,
      "codigo_referencia_valor_dominio": "223705",
      "nome_resumido_valor_dominio": "DIETISTA",
      "nome_completo_valor_dominio": "DIETISTA",
      "descricao_conceito_valor_dominio": "DIETISTA"
    },
    {
      "codigo_valor_dominio": 2867,
      "codigo_referencia_valor_dominio": "351405",
      "nome_resumido_valor_dominio": "ESCREVENTE",
      "nome_completo_valor_dominio": "ESCREVENTE",
      "descricao_conceito_valor_dominio": "ESCREVENTE"
    },
    {
      "codigo_valor_dominio": 2868,
      "codigo_referencia_valor_dominio": "613415",
      "nome_resumido_valor_dominio": "MINHOCULTOR",
      "nome_completo_valor_dominio": "MINHOCULTOR",
      "descricao_conceito_valor_dominio": "MINHOCULTOR"
    },
    {
      "codigo_valor_dominio": 2869,
      "codigo_referencia_valor_dominio": "761220",
      "nome_resumido_valor_dominio": "OPERADOR DE CARDAS",
      "nome_completo_valor_dominio": "OPERADOR DE CARDAS",
      "descricao_conceito_valor_dominio": "OPERADOR DE CARDAS"
    },
    {
      "codigo_valor_dominio": 2870,
      "codigo_referencia_valor_dominio": "811610",
      "nome_resumido_valor_dominio": "OPERADOR DE CARRO DE APAGAMENTO E COQUE",
      "nome_completo_valor_dominio": "OPERADOR DE CARRO DE APAGAMENTO E COQUE",
      "descricao_conceito_valor_dominio": "OPERADOR DE CARRO DE APAGAMENTO E COQUE"
    },
    {
      "codigo_valor_dominio": 2871,
      "codigo_referencia_valor_dominio": "715120",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE ABRIR VALAS",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE ABRIR VALAS",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE ABRIR VALAS"
    },
    {
      "codigo_valor_dominio": 2872,
      "codigo_referencia_valor_dominio": "811815",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE FABRICACAO DE COSMETICOS",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE FABRICACAO DE COSMETICOS",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE FABRICACAO DE COSMETICOS"
    },
    {
      "codigo_valor_dominio": 2873,
      "codigo_referencia_valor_dominio": "711230",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA PERFURATRIZ",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA PERFURATRIZ",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA PERFURATRIZ"
    },
    {
      "codigo_valor_dominio": 2874,
      "codigo_referencia_valor_dominio": "723230",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA RECOBRIDORA DE ARAME",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA RECOBRIDORA DE ARAME",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA RECOBRIDORA DE ARAME"
    },
    {
      "codigo_valor_dominio": 2875,
      "codigo_referencia_valor_dominio": "632120",
      "nome_resumido_valor_dominio": "OPERADOR DE MOTOSSERRA",
      "nome_completo_valor_dominio": "OPERADOR DE MOTOSSERRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE MOTOSSERRA"
    },
    {
      "codigo_valor_dominio": 2876,
      "codigo_referencia_valor_dominio": "773340",
      "nome_resumido_valor_dominio": "OPERADOR DE SERRAS (USINAGEM DE MADEIRA)",
      "nome_completo_valor_dominio": "OPERADOR DE SERRAS (USINAGEM DE MADEIRA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE SERRAS (USINAGEM DE MADEIRA)"
    },
    {
      "codigo_valor_dominio": 2877,
      "codigo_referencia_valor_dominio": "715145",
      "nome_resumido_valor_dominio": "OPERADOR DE TRATOR DE LAMINA",
      "nome_completo_valor_dominio": "OPERADOR DE TRATOR DE LAMINA",
      "descricao_conceito_valor_dominio": "OPERADOR DE TRATOR DE LAMINA"
    },
    {
      "codigo_valor_dominio": 2878,
      "codigo_referencia_valor_dominio": "711310",
      "nome_resumido_valor_dominio": "OPERADOR DE SONDA ROTATIVA",
      "nome_completo_valor_dominio": "OPERADOR DE SONDA ROTATIVA",
      "descricao_conceito_valor_dominio": "OPERADOR DE SONDA ROTATIVA"
    },
    {
      "codigo_valor_dominio": 2879,
      "codigo_referencia_valor_dominio": "861205",
      "nome_resumido_valor_dominio": "OPERADOR DE SUBESTACAO",
      "nome_completo_valor_dominio": "OPERADOR DE SUBESTACAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE SUBESTACAO"
    },
    {
      "codigo_valor_dominio": 2880,
      "codigo_referencia_valor_dominio": "711320",
      "nome_resumido_valor_dominio": "SONDADOR DE POCOS (EXCETO DE PETROLEO E GAS)",
      "nome_completo_valor_dominio": "SONDADOR DE POCOS (EXCETO DE PETROLEO E GAS)",
      "descricao_conceito_valor_dominio": "SONDADOR DE POCOS (EXCETO DE PETROLEO E GAS)"
    },
    {
      "codigo_valor_dominio": 2881,
      "codigo_referencia_valor_dominio": "821255",
      "nome_resumido_valor_dominio": "SOPRADOR DE CONVERTEDOR",
      "nome_completo_valor_dominio": "SOPRADOR DE CONVERTEDOR",
      "descricao_conceito_valor_dominio": "SOPRADOR DE CONVERTEDOR"
    },
    {
      "codigo_valor_dominio": 2882,
      "codigo_referencia_valor_dominio": "717015",
      "nome_resumido_valor_dominio": "POCEIRO (EDIFICACOES)",
      "nome_completo_valor_dominio": "POCEIRO (EDIFICACOES)",
      "descricao_conceito_valor_dominio": "POCEIRO (EDIFICACOES)"
    },
    {
      "codigo_valor_dominio": 2883,
      "codigo_referencia_valor_dominio": "519320",
      "nome_resumido_valor_dominio": "TOSADOR DE ANIMAIS DOMESTICOS",
      "nome_completo_valor_dominio": "TOSADOR DE ANIMAIS DOMESTICOS",
      "descricao_conceito_valor_dominio": "TOSADOR DE ANIMAIS DOMESTICOS"
    },
    {
      "codigo_valor_dominio": 2884,
      "codigo_referencia_valor_dominio": "631405",
      "nome_resumido_valor_dominio": "GELADOR INDUSTRIAL",
      "nome_completo_valor_dominio": "GELADOR INDUSTRIAL",
      "descricao_conceito_valor_dominio": "GELADOR INDUSTRIAL"
    },
    {
      "codigo_valor_dominio": 2885,
      "codigo_referencia_valor_dominio": "711240",
      "nome_resumido_valor_dominio": "OPERADOR DE SCHUTTHECAR",
      "nome_completo_valor_dominio": "OPERADOR DE SCHUTTHECAR",
      "descricao_conceito_valor_dominio": "OPERADOR DE SCHUTTHECAR"
    },
    {
      "codigo_valor_dominio": 2886,
      "codigo_referencia_valor_dominio": "515315",
      "nome_resumido_valor_dominio": "MONITOR DE DEPENDENTE QUIMICO",
      "nome_completo_valor_dominio": "MONITOR DE DEPENDENTE QUIMICO",
      "descricao_conceito_valor_dominio": "MONITOR DE DEPENDENTE QUIMICO"
    },
    {
      "codigo_valor_dominio": 2887,
      "codigo_referencia_valor_dominio": "712115",
      "nome_resumido_valor_dominio": "OPERADOR DE APARELHO DE PRECIPITACAO (MINAS DE OURO OU PRATA",
      "nome_completo_valor_dominio": "OPERADOR DE APARELHO DE PRECIPITACAO (MINAS DE OURO OU PRATA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE APARELHO DE PRECIPITACAO (MINAS DE OURO OU PRATA)"
    },
    {
      "codigo_valor_dominio": 2888,
      "codigo_referencia_valor_dominio": "811420",
      "nome_resumido_valor_dominio": "OPERADOR DE APARELHO DE REACAO E CONVERSAO (PRODUTOS QUIMICO",
      "nome_completo_valor_dominio": "OPERADOR DE APARELHO DE REACAO E CONVERSAO (PRODUTOS QUIMICOS, EXCETO PETROLEO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE APARELHO DE REACAO E CONVERSAO (PRODUTOS QUIMICOS, EXCETO PETROLEO)"
    },
    {
      "codigo_valor_dominio": 2889,
      "codigo_referencia_valor_dominio": "821425",
      "nome_resumido_valor_dominio": "OPERADOR DE CABINE DE LAMINACAO (FIO-MAQUINA)",
      "nome_completo_valor_dominio": "OPERADOR DE CABINE DE LAMINACAO (FIO-MAQUINA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE CABINE DE LAMINACAO (FIO-MAQUINA)"
    },
    {
      "codigo_valor_dominio": 2890,
      "codigo_referencia_valor_dominio": "761351",
      "nome_resumido_valor_dominio": "OPERADOR DE ESPULADEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE ESPULADEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE ESPULADEIRA"
    },
    {
      "codigo_valor_dominio": 2891,
      "codigo_referencia_valor_dominio": "724605",
      "nome_resumido_valor_dominio": "OPERADOR DE LACOS DE CABOS DE ACO",
      "nome_completo_valor_dominio": "OPERADOR DE LACOS DE CABOS DE ACO",
      "descricao_conceito_valor_dominio": "OPERADOR DE LACOS DE CABOS DE ACO"
    },
    {
      "codigo_valor_dominio": 2892,
      "codigo_referencia_valor_dominio": "761255",
      "nome_resumido_valor_dominio": "OPERADOR DE PENTEADEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE PENTEADEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE PENTEADEIRA"
    },
    {
      "codigo_valor_dominio": 2893,
      "codigo_referencia_valor_dominio": "763110",
      "nome_resumido_valor_dominio": "CORTADOR DE ROUPAS",
      "nome_completo_valor_dominio": "CORTADOR DE ROUPAS",
      "descricao_conceito_valor_dominio": "CORTADOR DE ROUPAS"
    },
    {
      "codigo_valor_dominio": 2894,
      "codigo_referencia_valor_dominio": "766135",
      "nome_resumido_valor_dominio": "GRAVADOR DE MATRIZ CALCOGRAFICA",
      "nome_completo_valor_dominio": "GRAVADOR DE MATRIZ CALCOGRAFICA",
      "descricao_conceito_valor_dominio": "GRAVADOR DE MATRIZ CALCOGRAFICA"
    },
    {
      "codigo_valor_dominio": 2895,
      "codigo_referencia_valor_dominio": "752215",
      "nome_resumido_valor_dominio": "GRAVADOR DE VIDRO A AGUA-FORTE",
      "nome_completo_valor_dominio": "GRAVADOR DE VIDRO A AGUA-FORTE",
      "descricao_conceito_valor_dominio": "GRAVADOR DE VIDRO A AGUA-FORTE"
    },
    {
      "codigo_valor_dominio": 2896,
      "codigo_referencia_valor_dominio": "517405",
      "nome_resumido_valor_dominio": "PORTEIRO (HOTEL)",
      "nome_completo_valor_dominio": "PORTEIRO (HOTEL)",
      "descricao_conceito_valor_dominio": "PORTEIRO (HOTEL)"
    },
    {
      "codigo_valor_dominio": 2897,
      "codigo_referencia_valor_dominio": "773355",
      "nome_resumido_valor_dominio": "TORNEIRO NA USINAGEM CONVENCIONAL DE MADEIRA",
      "nome_completo_valor_dominio": "TORNEIRO NA USINAGEM CONVENCIONAL DE MADEIRA",
      "descricao_conceito_valor_dominio": "TORNEIRO NA USINAGEM CONVENCIONAL DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 2898,
      "codigo_referencia_valor_dominio": "261420",
      "nome_resumido_valor_dominio": "TRADUTOR",
      "nome_completo_valor_dominio": "TRADUTOR",
      "descricao_conceito_valor_dominio": "TRADUTOR"
    },
    {
      "codigo_valor_dominio": 2899,
      "codigo_referencia_valor_dominio": "862115",
      "nome_resumido_valor_dominio": "OPERADOR DE BATERIA DE GAS DE HULHA",
      "nome_completo_valor_dominio": "OPERADOR DE BATERIA DE GAS DE HULHA",
      "descricao_conceito_valor_dominio": "OPERADOR DE BATERIA DE GAS DE HULHA"
    },
    {
      "codigo_valor_dominio": 2900,
      "codigo_referencia_valor_dominio": "862130",
      "nome_resumido_valor_dominio": "OPERADOR DE COMPRESSOR DE AR",
      "nome_completo_valor_dominio": "OPERADOR DE COMPRESSOR DE AR",
      "descricao_conceito_valor_dominio": "OPERADOR DE COMPRESSOR DE AR"
    },
    {
      "codigo_valor_dominio": 2901,
      "codigo_referencia_valor_dominio": "821430",
      "nome_resumido_valor_dominio": "OPERADOR DE ESCORIA E SUCATA",
      "nome_completo_valor_dominio": "OPERADOR DE ESCORIA E SUCATA",
      "descricao_conceito_valor_dominio": "OPERADOR DE ESCORIA E SUCATA"
    },
    {
      "codigo_valor_dominio": 2902,
      "codigo_referencia_valor_dominio": "724505",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE CILINDRAR CHAPAS",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE CILINDRAR CHAPAS",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE CILINDRAR CHAPAS"
    },
    {
      "codigo_valor_dominio": 2903,
      "codigo_referencia_valor_dominio": "841815",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINAS DE FABRICACAO DE CHOCOLATES E ACHOCOLAT",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINAS DE FABRICACAO DE CHOCOLATES E ACHOCOLATADOS",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINAS DE FABRICACAO DE CHOCOLATES E ACHOCOLATADOS"
    },
    {
      "codigo_valor_dominio": 2904,
      "codigo_referencia_valor_dominio": "711235",
      "nome_resumido_valor_dominio": "OPERADOR DE MOTONIVELADORA (EXTRACAO DE MINERAIS SOLIDOS)",
      "nome_completo_valor_dominio": "OPERADOR DE MOTONIVELADORA (EXTRACAO DE MINERAIS SOLIDOS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE MOTONIVELADORA (EXTRACAO DE MINERAIS SOLIDOS)"
    },
    {
      "codigo_valor_dominio": 2905,
      "codigo_referencia_valor_dominio": "811630",
      "nome_resumido_valor_dominio": "OPERADOR DE PAINEL DE CONTROLE",
      "nome_completo_valor_dominio": "OPERADOR DE PAINEL DE CONTROLE",
      "descricao_conceito_valor_dominio": "OPERADOR DE PAINEL DE CONTROLE"
    },
    {
      "codigo_valor_dominio": 2906,
      "codigo_referencia_valor_dominio": "712135",
      "nome_resumido_valor_dominio": "OPERADOR DE PENEIRAS HIDRAULICAS",
      "nome_completo_valor_dominio": "OPERADOR DE PENEIRAS HIDRAULICAS",
      "descricao_conceito_valor_dominio": "OPERADOR DE PENEIRAS HIDRAULICAS"
    },
    {
      "codigo_valor_dominio": 2907,
      "codigo_referencia_valor_dominio": "642015",
      "nome_resumido_valor_dominio": "OPERADOR DE TRATOR FLORESTAL",
      "nome_completo_valor_dominio": "OPERADOR DE TRATOR FLORESTAL",
      "descricao_conceito_valor_dominio": "OPERADOR DE TRATOR FLORESTAL"
    },
    {
      "codigo_valor_dominio": 2908,
      "codigo_referencia_valor_dominio": "715205",
      "nome_resumido_valor_dominio": "CALCETEIRO",
      "nome_completo_valor_dominio": "CALCETEIRO",
      "descricao_conceito_valor_dominio": "CALCETEIRO"
    },
    {
      "codigo_valor_dominio": 2909,
      "codigo_referencia_valor_dominio": "715215",
      "nome_resumido_valor_dominio": "PEDREIRO (CHAMINES INDUSTRIAIS)",
      "nome_completo_valor_dominio": "PEDREIRO (CHAMINES INDUSTRIAIS)",
      "descricao_conceito_valor_dominio": "PEDREIRO (CHAMINES INDUSTRIAIS)"
    },
    {
      "codigo_valor_dominio": 2910,
      "codigo_referencia_valor_dominio": "715220",
      "nome_resumido_valor_dominio": "PEDREIRO (MATERIAL REFRATARIO)",
      "nome_completo_valor_dominio": "PEDREIRO (MATERIAL REFRATARIO)",
      "descricao_conceito_valor_dominio": "PEDREIRO (MATERIAL REFRATARIO)"
    },
    {
      "codigo_valor_dominio": 2911,
      "codigo_referencia_valor_dominio": "715225",
      "nome_resumido_valor_dominio": "PEDREIRO (MINERACAO)",
      "nome_completo_valor_dominio": "PEDREIRO (MINERACAO)",
      "descricao_conceito_valor_dominio": "PEDREIRO (MINERACAO)"
    },
    {
      "codigo_valor_dominio": 2912,
      "codigo_referencia_valor_dominio": "992220",
      "nome_resumido_valor_dominio": "PEDREIRO DE CONSERVACAO DE VIAS PERMANENTES (EXCETO TRILHOS)",
      "nome_completo_valor_dominio": "PEDREIRO DE CONSERVACAO DE VIAS PERMANENTES (EXCETO TRILHOS)",
      "descricao_conceito_valor_dominio": "PEDREIRO DE CONSERVACAO DE VIAS PERMANENTES (EXCETO TRILHOS)"
    },
    {
      "codigo_valor_dominio": 2913,
      "codigo_referencia_valor_dominio": "325015",
      "nome_resumido_valor_dominio": "PERFUMISTA",
      "nome_completo_valor_dominio": "PERFUMISTA",
      "descricao_conceito_valor_dominio": "PERFUMISTA"
    },
    {
      "codigo_valor_dominio": 2914,
      "codigo_referencia_valor_dominio": "715305",
      "nome_resumido_valor_dominio": "ARMADOR DE ESTRUTURA DE CONCRETO",
      "nome_completo_valor_dominio": "ARMADOR DE ESTRUTURA DE CONCRETO",
      "descricao_conceito_valor_dominio": "ARMADOR DE ESTRUTURA DE CONCRETO"
    },
    {
      "codigo_valor_dominio": 2915,
      "codigo_referencia_valor_dominio": "811760",
      "nome_resumido_valor_dominio": "MOLDADOR DE PLASTICO POR COMPRESSAO",
      "nome_completo_valor_dominio": "MOLDADOR DE PLASTICO POR COMPRESSAO",
      "descricao_conceito_valor_dominio": "MOLDADOR DE PLASTICO POR COMPRESSAO"
    },
    {
      "codigo_valor_dominio": 2916,
      "codigo_referencia_valor_dominio": "715315",
      "nome_resumido_valor_dominio": "ARMADOR DE ESTRUTURA DE CONCRETO ARMADO",
      "nome_completo_valor_dominio": "ARMADOR DE ESTRUTURA DE CONCRETO ARMADO",
      "descricao_conceito_valor_dominio": "ARMADOR DE ESTRUTURA DE CONCRETO ARMADO"
    },
    {
      "codigo_valor_dominio": 2917,
      "codigo_referencia_valor_dominio": "761210",
      "nome_resumido_valor_dominio": "OPERADOR DE BINADEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE BINADEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE BINADEIRA"
    },
    {
      "codigo_valor_dominio": 2918,
      "codigo_referencia_valor_dominio": "831110",
      "nome_resumido_valor_dominio": "OPERADOR DE BRANQUEADOR DE PASTA PARA FABRICACAO DE PAPEL",
      "nome_completo_valor_dominio": "OPERADOR DE BRANQUEADOR DE PASTA PARA FABRICACAO DE PAPEL",
      "descricao_conceito_valor_dominio": "OPERADOR DE BRANQUEADOR DE PASTA PARA FABRICACAO DE PAPEL"
    },
    {
      "codigo_valor_dominio": 2919,
      "codigo_referencia_valor_dominio": "373110",
      "nome_resumido_valor_dominio": "OPERADOR DE CENTRAL DE RADIO",
      "nome_completo_valor_dominio": "OPERADOR DE CENTRAL DE RADIO",
      "descricao_conceito_valor_dominio": "OPERADOR DE CENTRAL DE RADIO"
    },
    {
      "codigo_valor_dominio": 2920,
      "codigo_referencia_valor_dominio": "715505",
      "nome_resumido_valor_dominio": "CARPINTEIRO",
      "nome_completo_valor_dominio": "CARPINTEIRO",
      "descricao_conceito_valor_dominio": "CARPINTEIRO"
    },
    {
      "codigo_valor_dominio": 2921,
      "codigo_referencia_valor_dominio": "715510",
      "nome_resumido_valor_dominio": "CARPINTEIRO (ESQUADRIAS)",
      "nome_completo_valor_dominio": "CARPINTEIRO (ESQUADRIAS)",
      "descricao_conceito_valor_dominio": "CARPINTEIRO (ESQUADRIAS)"
    },
    {
      "codigo_valor_dominio": 2922,
      "codigo_referencia_valor_dominio": "715515",
      "nome_resumido_valor_dominio": "CARPINTEIRO (CENARIOS)",
      "nome_completo_valor_dominio": "CARPINTEIRO (CENARIOS)",
      "descricao_conceito_valor_dominio": "CARPINTEIRO (CENARIOS)"
    },
    {
      "codigo_valor_dominio": 2923,
      "codigo_referencia_valor_dominio": "715520",
      "nome_resumido_valor_dominio": "CARPINTEIRO (MINERACAO)",
      "nome_completo_valor_dominio": "CARPINTEIRO (MINERACAO)",
      "descricao_conceito_valor_dominio": "CARPINTEIRO (MINERACAO)"
    },
    {
      "codigo_valor_dominio": 2924,
      "codigo_referencia_valor_dominio": "715525",
      "nome_resumido_valor_dominio": "CARPINTEIRO DE OBRAS",
      "nome_completo_valor_dominio": "CARPINTEIRO DE OBRAS",
      "descricao_conceito_valor_dominio": "CARPINTEIRO DE OBRAS"
    },
    {
      "codigo_valor_dominio": 2925,
      "codigo_referencia_valor_dominio": "715530",
      "nome_resumido_valor_dominio": "CARPINTEIRO (TELHADOS)",
      "nome_completo_valor_dominio": "CARPINTEIRO (TELHADOS)",
      "descricao_conceito_valor_dominio": "CARPINTEIRO (TELHADOS)"
    },
    {
      "codigo_valor_dominio": 2926,
      "codigo_referencia_valor_dominio": "715535",
      "nome_resumido_valor_dominio": "CARPINTEIRO DE FORMAS PARA CONCRETO",
      "nome_completo_valor_dominio": "CARPINTEIRO DE FORMAS PARA CONCRETO",
      "descricao_conceito_valor_dominio": "CARPINTEIRO DE FORMAS PARA CONCRETO"
    },
    {
      "codigo_valor_dominio": 2927,
      "codigo_referencia_valor_dominio": "715540",
      "nome_resumido_valor_dominio": "CARPINTEIRO DE OBRAS CIVIS DE ARTE (PONTES, TUNEIS, BARRAGEN",
      "nome_completo_valor_dominio": "CARPINTEIRO DE OBRAS CIVIS DE ARTE (PONTES, TUNEIS, BARRAGEN",
      "descricao_conceito_valor_dominio": "CARPINTEIRO DE OBRAS CIVIS DE ARTE (PONTES, TUNEIS, BARRAGEN"
    },
    {
      "codigo_valor_dominio": 2928,
      "codigo_referencia_valor_dominio": "765315",
      "nome_resumido_valor_dominio": "MONTADOR DE ARTEFATOS DE COURO (EXCETO ROUPAS E CALCADOS)",
      "nome_completo_valor_dominio": "MONTADOR DE ARTEFATOS DE COURO (EXCETO ROUPAS E CALCADOS)",
      "descricao_conceito_valor_dominio": "MONTADOR DE ARTEFATOS DE COURO (EXCETO ROUPAS E CALCADOS)"
    },
    {
      "codigo_valor_dominio": 2929,
      "codigo_referencia_valor_dominio": "715610",
      "nome_resumido_valor_dominio": "ELETRICISTA DE INSTALACOES (EDIFICIOS)",
      "nome_completo_valor_dominio": "ELETRICISTA DE INSTALACOES (EDIFICIOS)",
      "descricao_conceito_valor_dominio": "ELETRICISTA DE INSTALACOES (EDIFICIOS)"
    },
    {
      "codigo_valor_dominio": 2930,
      "codigo_referencia_valor_dominio": "953110",
      "nome_resumido_valor_dominio": "ELETRICISTA DE INSTALACOES (EMBARCACOES)",
      "nome_completo_valor_dominio": "ELETRICISTA DE INSTALACOES (EMBARCACOES)",
      "descricao_conceito_valor_dominio": "ELETRICISTA DE INSTALACOES (EMBARCACOES)"
    },
    {
      "codigo_valor_dominio": 2931,
      "codigo_referencia_valor_dominio": "953105",
      "nome_resumido_valor_dominio": "ELETRICISTA DE INSTALACOES (AERONAVES)",
      "nome_completo_valor_dominio": "ELETRICISTA DE INSTALACOES (AERONAVES)",
      "descricao_conceito_valor_dominio": "ELETRICISTA DE INSTALACOES (AERONAVES)"
    },
    {
      "codigo_valor_dominio": 2932,
      "codigo_referencia_valor_dominio": "715705",
      "nome_resumido_valor_dominio": "APLICADOR DE ASFALTO IMPERMEABILIZANTE (COBERTURAS)",
      "nome_completo_valor_dominio": "APLICADOR DE ASFALTO IMPERMEABILIZANTE (COBERTURAS)",
      "descricao_conceito_valor_dominio": "APLICADOR DE ASFALTO IMPERMEABILIZANTE (COBERTURAS)"
    },
    {
      "codigo_valor_dominio": 2933,
      "codigo_referencia_valor_dominio": "715715",
      "nome_resumido_valor_dominio": "INSTALADOR DE ISOLANTES TERMICOS (REFRIGERACAO E CLIMATIZACA",
      "nome_completo_valor_dominio": "INSTALADOR DE ISOLANTES TERMICOS (REFRIGERACAO E CLIMATIZACAO)",
      "descricao_conceito_valor_dominio": "INSTALADOR DE ISOLANTES TERMICOS (REFRIGERACAO E CLIMATIZACAO)"
    },
    {
      "codigo_valor_dominio": 2934,
      "codigo_referencia_valor_dominio": "715720",
      "nome_resumido_valor_dominio": "INSTALADOR DE ISOLANTES TERMICOS DE CALDEIRA E TUBULACOES",
      "nome_completo_valor_dominio": "INSTALADOR DE ISOLANTES TERMICOS DE CALDEIRA E TUBULACOES",
      "descricao_conceito_valor_dominio": "INSTALADOR DE ISOLANTES TERMICOS DE CALDEIRA E TUBULACOES"
    },
    {
      "codigo_valor_dominio": 2935,
      "codigo_referencia_valor_dominio": "732120",
      "nome_resumido_valor_dominio": "INSTALADOR DE LINHAS ELETRICAS DE ALTA E BAIXA - TENSAO (RED",
      "nome_completo_valor_dominio": "INSTALADOR DE LINHAS ELETRICAS DE ALTA E BAIXA - TENSAO (REDE AEREA E SUBTERRANEA)",
      "descricao_conceito_valor_dominio": "INSTALADOR DE LINHAS ELETRICAS DE ALTA E BAIXA - TENSAO (REDE AEREA E SUBTERRANEA)"
    },
    {
      "codigo_valor_dominio": 2936,
      "codigo_referencia_valor_dominio": "715730",
      "nome_resumido_valor_dominio": "INSTALADOR DE MATERIAL ISOLANTE, A MAQUINA (EDIFICACOES)",
      "nome_completo_valor_dominio": "INSTALADOR DE MATERIAL ISOLANTE, A MAQUINA (EDIFICACOES)",
      "descricao_conceito_valor_dominio": "INSTALADOR DE MATERIAL ISOLANTE, A MAQUINA (EDIFICACOES)"
    },
    {
      "codigo_valor_dominio": 2937,
      "codigo_referencia_valor_dominio": "951305",
      "nome_resumido_valor_dominio": "INSTALADOR DE SISTEMAS ELETROELETRONICOS DE SEGURANCA",
      "nome_completo_valor_dominio": "INSTALADOR DE SISTEMAS ELETROELETRONICOS DE SEGURANCA",
      "descricao_conceito_valor_dominio": "INSTALADOR DE SISTEMAS ELETROELETRONICOS DE SEGURANCA"
    },
    {
      "codigo_valor_dominio": 2938,
      "codigo_referencia_valor_dominio": "716105",
      "nome_resumido_valor_dominio": "ACABADOR DE SUPERFICIES DE CONCRETO",
      "nome_completo_valor_dominio": "ACABADOR DE SUPERFICIES DE CONCRETO",
      "descricao_conceito_valor_dominio": "ACABADOR DE SUPERFICIES DE CONCRETO"
    },
    {
      "codigo_valor_dominio": 2939,
      "codigo_referencia_valor_dominio": "761810",
      "nome_resumido_valor_dominio": "REVISOR DE FIOS (PRODUCAO TEXTIL)",
      "nome_completo_valor_dominio": "REVISOR DE FIOS (PRODUCAO TEXTIL)",
      "descricao_conceito_valor_dominio": "REVISOR DE FIOS (PRODUCAO TEXTIL)"
    },
    {
      "codigo_valor_dominio": 2940,
      "codigo_referencia_valor_dominio": "716210",
      "nome_resumido_valor_dominio": "TELHADOR (TELHAS DE CIMENTO-AMIANTO)",
      "nome_completo_valor_dominio": "TELHADOR (TELHAS DE CIMENTO-AMIANTO)",
      "descricao_conceito_valor_dominio": "TELHADOR (TELHAS DE CIMENTO-AMIANTO)"
    },
    {
      "codigo_valor_dominio": 2941,
      "codigo_referencia_valor_dominio": "716215",
      "nome_resumido_valor_dominio": "TELHADOR (TELHAS METALICAS)",
      "nome_completo_valor_dominio": "TELHADOR (TELHAS METALICAS)",
      "descricao_conceito_valor_dominio": "TELHADOR (TELHAS METALICAS)"
    },
    {
      "codigo_valor_dominio": 2942,
      "codigo_referencia_valor_dominio": "716220",
      "nome_resumido_valor_dominio": "TELHADOR (TELHAS PLASTICAS)",
      "nome_completo_valor_dominio": "TELHADOR (TELHAS PLASTICAS)",
      "descricao_conceito_valor_dominio": "TELHADOR (TELHAS PLASTICAS)"
    },
    {
      "codigo_valor_dominio": 2943,
      "codigo_referencia_valor_dominio": "723125",
      "nome_resumido_valor_dominio": "TEMPERADOR DE METAIS E DE COMPOSITOS",
      "nome_completo_valor_dominio": "TEMPERADOR DE METAIS E DE COMPOSITOS",
      "descricao_conceito_valor_dominio": "TEMPERADOR DE METAIS E DE COMPOSITOS"
    },
    {
      "codigo_valor_dominio": 2944,
      "codigo_referencia_valor_dominio": "716310",
      "nome_resumido_valor_dominio": "VIDRACEIRO (EDIFICACOES)",
      "nome_completo_valor_dominio": "VIDRACEIRO (EDIFICACOES)",
      "descricao_conceito_valor_dominio": "VIDRACEIRO (EDIFICACOES)"
    },
    {
      "codigo_valor_dominio": 2945,
      "codigo_referencia_valor_dominio": "716315",
      "nome_resumido_valor_dominio": "VIDRACEIRO (VITRAIS)",
      "nome_completo_valor_dominio": "VIDRACEIRO (VITRAIS)",
      "descricao_conceito_valor_dominio": "VIDRACEIRO (VITRAIS)"
    },
    {
      "codigo_valor_dominio": 2946,
      "codigo_referencia_valor_dominio": "517420",
      "nome_resumido_valor_dominio": "VIGIA",
      "nome_completo_valor_dominio": "VIGIA",
      "descricao_conceito_valor_dominio": "VIGIA"
    },
    {
      "codigo_valor_dominio": 2947,
      "codigo_referencia_valor_dominio": "252605",
      "nome_resumido_valor_dominio": "GESTOR EM SEGURANCA",
      "nome_completo_valor_dominio": "GESTOR EM SEGURANCA",
      "descricao_conceito_valor_dominio": "GESTOR EM SEGURANCA"
    },
    {
      "codigo_valor_dominio": 2948,
      "codigo_referencia_valor_dominio": "716505",
      "nome_resumido_valor_dominio": "ASSOALHADOR",
      "nome_completo_valor_dominio": "ASSOALHADOR",
      "descricao_conceito_valor_dominio": "ASSOALHADOR"
    },
    {
      "codigo_valor_dominio": 2949,
      "codigo_referencia_valor_dominio": "841448",
      "nome_resumido_valor_dominio": "LAGAREIRO",
      "nome_completo_valor_dominio": "LAGAREIRO",
      "descricao_conceito_valor_dominio": "LAGAREIRO"
    },
    {
      "codigo_valor_dominio": 2950,
      "codigo_referencia_valor_dominio": "341220",
      "nome_resumido_valor_dominio": "PATRAO DE PESCA DE ALTO-MAR",
      "nome_completo_valor_dominio": "PATRAO DE PESCA DE ALTO-MAR",
      "descricao_conceito_valor_dominio": "PATRAO DE PESCA DE ALTO-MAR"
    },
    {
      "codigo_valor_dominio": 2951,
      "codigo_referencia_valor_dominio": "915215",
      "nome_resumido_valor_dominio": "LUTHIER (RESTAURACAO DE CORDAS ARCADAS)",
      "nome_completo_valor_dominio": "LUTHIER (RESTAURACAO DE CORDAS ARCADAS)",
      "descricao_conceito_valor_dominio": "LUTHIER (RESTAURACAO DE CORDAS ARCADAS)"
    },
    {
      "codigo_valor_dominio": 2952,
      "codigo_referencia_valor_dominio": "848315",
      "nome_resumido_valor_dominio": "MASSEIRO (MASSAS ALIMENTICIAS)",
      "nome_completo_valor_dominio": "MASSEIRO (MASSAS ALIMENTICIAS)",
      "descricao_conceito_valor_dominio": "MASSEIRO (MASSAS ALIMENTICIAS)"
    },
    {
      "codigo_valor_dominio": 2953,
      "codigo_referencia_valor_dominio": "519110",
      "nome_resumido_valor_dominio": "MOTOCICLISTA NO TRANSPORTE DE DOCUMENTOS E PEQUENOS VOLUMES",
      "nome_completo_valor_dominio": "MOTOCICLISTA NO TRANSPORTE DE DOCUMENTOS E PEQUENOS VOLUMES",
      "descricao_conceito_valor_dominio": "MOTOCICLISTA NO TRANSPORTE DE DOCUMENTOS E PEQUENOS VOLUMES"
    },
    {
      "codigo_valor_dominio": 2954,
      "codigo_referencia_valor_dominio": "351510",
      "nome_resumido_valor_dominio": "TAQUIGRAFO",
      "nome_completo_valor_dominio": "TAQUIGRAFO",
      "descricao_conceito_valor_dominio": "TAQUIGRAFO"
    },
    {
      "codigo_valor_dominio": 2955,
      "codigo_referencia_valor_dominio": "716605",
      "nome_resumido_valor_dominio": "CALAFETADOR",
      "nome_completo_valor_dominio": "CALAFETADOR",
      "descricao_conceito_valor_dominio": "CALAFETADOR"
    },
    {
      "codigo_valor_dominio": 2956,
      "codigo_referencia_valor_dominio": "723320",
      "nome_resumido_valor_dominio": "PINTOR DE VEICULOS (FABRICACAO)",
      "nome_completo_valor_dominio": "PINTOR DE VEICULOS (FABRICACAO)",
      "descricao_conceito_valor_dominio": "PINTOR DE VEICULOS (FABRICACAO)"
    },
    {
      "codigo_valor_dominio": 2957,
      "codigo_referencia_valor_dominio": "716110",
      "nome_resumido_valor_dominio": "REVESTIDOR DE SUPERFICIES DE CONCRETO",
      "nome_completo_valor_dominio": "REVESTIDOR DE SUPERFICIES DE CONCRETO",
      "descricao_conceito_valor_dominio": "REVESTIDOR DE SUPERFICIES DE CONCRETO"
    },
    {
      "codigo_valor_dominio": 2958,
      "codigo_referencia_valor_dominio": "521120",
      "nome_resumido_valor_dominio": "DEMONSTRADOR DE MERCADORIAS",
      "nome_completo_valor_dominio": "DEMONSTRADOR DE MERCADORIAS",
      "descricao_conceito_valor_dominio": "DEMONSTRADOR DE MERCADORIAS"
    },
    {
      "codigo_valor_dominio": 2959,
      "codigo_referencia_valor_dominio": "412115",
      "nome_resumido_valor_dominio": "OPERADOR DE MENSAGENS DE TELECOMUNICACOES (CORREIOS)",
      "nome_completo_valor_dominio": "OPERADOR DE MENSAGENS DE TELECOMUNICACOES (CORREIOS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE MENSAGENS DE TELECOMUNICACOES (CORREIOS)"
    },
    {
      "codigo_valor_dominio": 2960,
      "codigo_referencia_valor_dominio": "322110",
      "nome_resumido_valor_dominio": "PODOLOGO",
      "nome_completo_valor_dominio": "PODOLOGO",
      "descricao_conceito_valor_dominio": "PODOLOGO"
    },
    {
      "codigo_valor_dominio": 2961,
      "codigo_referencia_valor_dominio": "623325",
      "nome_resumido_valor_dominio": "SEXADOR",
      "nome_completo_valor_dominio": "SEXADOR",
      "descricao_conceito_valor_dominio": "SEXADOR"
    },
    {
      "codigo_valor_dominio": 2962,
      "codigo_referencia_valor_dominio": "111240",
      "nome_resumido_valor_dominio": "VICE-GOVERNADOR DE ESTADO",
      "nome_completo_valor_dominio": "VICE-GOVERNADOR DE ESTADO",
      "descricao_conceito_valor_dominio": "VICE-GOVERNADOR DE ESTADO"
    },
    {
      "codigo_valor_dominio": 2963,
      "codigo_referencia_valor_dominio": "710205",
      "nome_resumido_valor_dominio": "MESTRE (CONSTRUCAO CIVIL)",
      "nome_completo_valor_dominio": "MESTRE (CONSTRUCAO CIVIL)",
      "descricao_conceito_valor_dominio": "MESTRE (CONSTRUCAO CIVIL)"
    },
    {
      "codigo_valor_dominio": 2964,
      "codigo_referencia_valor_dominio": "720220",
      "nome_resumido_valor_dominio": "MESTRE DE CONSTRUCAO DE FORNOS",
      "nome_completo_valor_dominio": "MESTRE DE CONSTRUCAO DE FORNOS",
      "descricao_conceito_valor_dominio": "MESTRE DE CONSTRUCAO DE FORNOS"
    },
    {
      "codigo_valor_dominio": 2965,
      "codigo_referencia_valor_dominio": "720120",
      "nome_resumido_valor_dominio": "MESTRE DE FORJARIA",
      "nome_completo_valor_dominio": "MESTRE DE FORJARIA",
      "descricao_conceito_valor_dominio": "MESTRE DE FORJARIA"
    },
    {
      "codigo_valor_dominio": 2966,
      "codigo_referencia_valor_dominio": "820120",
      "nome_resumido_valor_dominio": "MESTRE DE FORNO ELETRICO",
      "nome_completo_valor_dominio": "MESTRE DE FORNO ELETRICO",
      "descricao_conceito_valor_dominio": "MESTRE DE FORNO ELETRICO"
    },
    {
      "codigo_valor_dominio": 2967,
      "codigo_referencia_valor_dominio": "720130",
      "nome_resumido_valor_dominio": "MESTRE DE GALVANOPLASTIA",
      "nome_completo_valor_dominio": "MESTRE DE GALVANOPLASTIA",
      "descricao_conceito_valor_dominio": "MESTRE DE GALVANOPLASTIA"
    },
    {
      "codigo_valor_dominio": 2968,
      "codigo_referencia_valor_dominio": "820125",
      "nome_resumido_valor_dominio": "MESTRE DE LAMINACAO",
      "nome_completo_valor_dominio": "MESTRE DE LAMINACAO",
      "descricao_conceito_valor_dominio": "MESTRE DE LAMINACAO"
    },
    {
      "codigo_valor_dominio": 2969,
      "codigo_referencia_valor_dominio": "810305",
      "nome_resumido_valor_dominio": "MESTRE DE PRODUCAO FARMACEUTICA",
      "nome_completo_valor_dominio": "MESTRE DE PRODUCAO FARMACEUTICA",
      "descricao_conceito_valor_dominio": "MESTRE DE PRODUCAO FARMACEUTICA"
    },
    {
      "codigo_valor_dominio": 2970,
      "codigo_referencia_valor_dominio": "720145",
      "nome_resumido_valor_dominio": "MESTRE DE TREFILACAO DE METAIS",
      "nome_completo_valor_dominio": "MESTRE DE TREFILACAO DE METAIS",
      "descricao_conceito_valor_dominio": "MESTRE DE TREFILACAO DE METAIS"
    },
    {
      "codigo_valor_dominio": 2971,
      "codigo_referencia_valor_dominio": "720150",
      "nome_resumido_valor_dominio": "MESTRE DE USINAGEM",
      "nome_completo_valor_dominio": "MESTRE DE USINAGEM",
      "descricao_conceito_valor_dominio": "MESTRE DE USINAGEM"
    },
    {
      "codigo_valor_dominio": 2972,
      "codigo_referencia_valor_dominio": "341215",
      "nome_resumido_valor_dominio": "MESTRE FLUVIAL",
      "nome_completo_valor_dominio": "MESTRE FLUVIAL",
      "descricao_conceito_valor_dominio": "MESTRE FLUVIAL"
    },
    {
      "codigo_valor_dominio": 2973,
      "codigo_referencia_valor_dominio": "723225",
      "nome_resumido_valor_dominio": "METALIZADOR (BANHO QUENTE)",
      "nome_completo_valor_dominio": "METALIZADOR (BANHO QUENTE)",
      "descricao_conceito_valor_dominio": "METALIZADOR (BANHO QUENTE)"
    },
    {
      "codigo_valor_dominio": 2974,
      "codigo_referencia_valor_dominio": "410220",
      "nome_resumido_valor_dominio": "SUPERVISOR DE CONTROLE PATRIMONIAL",
      "nome_completo_valor_dominio": "SUPERVISOR DE CONTROLE PATRIMONIAL",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE CONTROLE PATRIMONIAL"
    },
    {
      "codigo_valor_dominio": 2975,
      "codigo_referencia_valor_dominio": "720210",
      "nome_resumido_valor_dominio": "MESTRE (INDUSTRIA DE AUTOMOTORES E MATERIAL DE TRANSPORTES)",
      "nome_completo_valor_dominio": "MESTRE (INDUSTRIA DE AUTOMOTORES E MATERIAL DE TRANSPORTES)",
      "descricao_conceito_valor_dominio": "MESTRE (INDUSTRIA DE AUTOMOTORES E MATERIAL DE TRANSPORTES)"
    },
    {
      "codigo_valor_dominio": 2976,
      "codigo_referencia_valor_dominio": "810205",
      "nome_resumido_valor_dominio": "MESTRE (INDUSTRIA DE BORRACHA E PLASTICO)",
      "nome_completo_valor_dominio": "MESTRE (INDUSTRIA DE BORRACHA E PLASTICO)",
      "descricao_conceito_valor_dominio": "MESTRE (INDUSTRIA DE BORRACHA E PLASTICO)"
    },
    {
      "codigo_valor_dominio": 2977,
      "codigo_referencia_valor_dominio": "810105",
      "nome_resumido_valor_dominio": "MESTRE (INDUSTRIA PETROQUIMICA E CARBOQUIMICA)",
      "nome_completo_valor_dominio": "MESTRE (INDUSTRIA PETROQUIMICA E CARBOQUIMICA)",
      "descricao_conceito_valor_dominio": "MESTRE (INDUSTRIA PETROQUIMICA E CARBOQUIMICA)"
    },
    {
      "codigo_valor_dominio": 2978,
      "codigo_referencia_valor_dominio": "720115",
      "nome_resumido_valor_dominio": "MESTRE DE FERRAMENTARIA",
      "nome_completo_valor_dominio": "MESTRE DE FERRAMENTARIA",
      "descricao_conceito_valor_dominio": "MESTRE DE FERRAMENTARIA"
    },
    {
      "codigo_valor_dominio": 2979,
      "codigo_referencia_valor_dominio": "721110",
      "nome_resumido_valor_dominio": "FERRAMENTEIRO DE MANDRIS, CALIBRADORES E OUTROS DISPOSITIVOS",
      "nome_completo_valor_dominio": "FERRAMENTEIRO DE MANDRIS, CALIBRADORES E OUTROS DISPOSITIVOS",
      "descricao_conceito_valor_dominio": "FERRAMENTEIRO DE MANDRIS, CALIBRADORES E OUTROS DISPOSITIVOS"
    },
    {
      "codigo_valor_dominio": 2980,
      "codigo_referencia_valor_dominio": "261405",
      "nome_resumido_valor_dominio": "FILOLOGO",
      "nome_completo_valor_dominio": "FILOLOGO",
      "descricao_conceito_valor_dominio": "FILOLOGO"
    },
    {
      "codigo_valor_dominio": 2981,
      "codigo_referencia_valor_dominio": "318815",
      "nome_resumido_valor_dominio": "MODELISTA DE CALCADOS",
      "nome_completo_valor_dominio": "MODELISTA DE CALCADOS",
      "descricao_conceito_valor_dominio": "MODELISTA DE CALCADOS"
    },
    {
      "codigo_valor_dominio": 2982,
      "codigo_referencia_valor_dominio": "784120",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE ENVASAR LIQUIDOS",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE ENVASAR LIQUIDOS",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE ENVASAR LIQUIDOS"
    },
    {
      "codigo_valor_dominio": 2983,
      "codigo_referencia_valor_dominio": "721215",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINAS-FERRAMENTA CONVENCIONAIS",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINAS-FERRAMENTA CONVENCIONAIS",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINAS-FERRAMENTA CONVENCIONAIS"
    },
    {
      "codigo_valor_dominio": 2984,
      "codigo_referencia_valor_dominio": "717010",
      "nome_resumido_valor_dominio": "OPERADOR DE MARTELETE",
      "nome_completo_valor_dominio": "OPERADOR DE MARTELETE",
      "descricao_conceito_valor_dominio": "OPERADOR DE MARTELETE"
    },
    {
      "codigo_valor_dominio": 2985,
      "codigo_referencia_valor_dominio": "862155",
      "nome_resumido_valor_dominio": "OPERADOR DE UTILIDADE (PRODUCAO E DISTRIBUICAO DE VAPOR, GAS",
      "nome_completo_valor_dominio": "OPERADOR DE UTILIDADE (PRODUCAO E DISTRIBUICAO DE VAPOR, GAS, OLEO, COMBUSTIVEL, ENERGIA, OXIGENIO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE UTILIDADE (PRODUCAO E DISTRIBUICAO DE VAPOR, GAS, OLEO, COMBUSTIVEL, ENERGIA, OXIGENIO)"
    },
    {
      "codigo_valor_dominio": 2986,
      "codigo_referencia_valor_dominio": "823105",
      "nome_resumido_valor_dominio": "PREPARADOR DE MASSA (FABRICACAO DE ABRASIVOS)",
      "nome_completo_valor_dominio": "PREPARADOR DE MASSA (FABRICACAO DE ABRASIVOS)",
      "descricao_conceito_valor_dominio": "PREPARADOR DE MASSA (FABRICACAO DE ABRASIVOS)"
    },
    {
      "codigo_valor_dominio": 2987,
      "codigo_referencia_valor_dominio": "721305",
      "nome_resumido_valor_dominio": "AFIADOR DE CARDAS",
      "nome_completo_valor_dominio": "AFIADOR DE CARDAS",
      "descricao_conceito_valor_dominio": "AFIADOR DE CARDAS"
    },
    {
      "codigo_valor_dominio": 2988,
      "codigo_referencia_valor_dominio": "721310",
      "nome_resumido_valor_dominio": "AFIADOR DE CUTELARIA",
      "nome_completo_valor_dominio": "AFIADOR DE CUTELARIA",
      "descricao_conceito_valor_dominio": "AFIADOR DE CUTELARIA"
    },
    {
      "codigo_valor_dominio": 2989,
      "codigo_referencia_valor_dominio": "721315",
      "nome_resumido_valor_dominio": "AFIADOR DE FERRAMENTAS",
      "nome_completo_valor_dominio": "AFIADOR DE FERRAMENTAS",
      "descricao_conceito_valor_dominio": "AFIADOR DE FERRAMENTAS"
    },
    {
      "codigo_valor_dominio": 2990,
      "codigo_referencia_valor_dominio": "721320",
      "nome_resumido_valor_dominio": "AFIADOR DE SERRAS",
      "nome_completo_valor_dominio": "AFIADOR DE SERRAS",
      "descricao_conceito_valor_dominio": "AFIADOR DE SERRAS"
    },
    {
      "codigo_valor_dominio": 2991,
      "codigo_referencia_valor_dominio": "712220",
      "nome_resumido_valor_dominio": "POLIDOR DE PEDRAS",
      "nome_completo_valor_dominio": "POLIDOR DE PEDRAS",
      "descricao_conceito_valor_dominio": "POLIDOR DE PEDRAS"
    },
    {
      "codigo_valor_dominio": 2992,
      "codigo_referencia_valor_dominio": "773505",
      "nome_resumido_valor_dominio": "OPERADOR DE CENTRO DE USINAGEM DE MADEIRA (CNC)",
      "nome_completo_valor_dominio": "OPERADOR DE CENTRO DE USINAGEM DE MADEIRA (CNC)",
      "descricao_conceito_valor_dominio": "OPERADOR DE CENTRO DE USINAGEM DE MADEIRA (CNC)"
    },
    {
      "codigo_valor_dominio": 2993,
      "codigo_referencia_valor_dominio": "373120",
      "nome_resumido_valor_dominio": "OPERADOR DE GRAVACAO DE RADIO",
      "nome_completo_valor_dominio": "OPERADOR DE GRAVACAO DE RADIO",
      "descricao_conceito_valor_dominio": "OPERADOR DE GRAVACAO DE RADIO"
    },
    {
      "codigo_valor_dominio": 2994,
      "codigo_referencia_valor_dominio": "842125",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA (FABRICACAO DE CIGARROS)",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA (FABRICACAO DE CIGARROS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA (FABRICACAO DE CIGARROS)"
    },
    {
      "codigo_valor_dominio": 2995,
      "codigo_referencia_valor_dominio": "823245",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA EXTRUSORA DE VARETAS E TUBOS DE VIDRO",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA EXTRUSORA DE VARETAS E TUBOS DE VIDRO",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA EXTRUSORA DE VARETAS E TUBOS DE VIDRO"
    },
    {
      "codigo_valor_dominio": 2996,
      "codigo_referencia_valor_dominio": "761260",
      "nome_resumido_valor_dominio": "OPERADOR DE RETORCEDEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE RETORCEDEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE RETORCEDEIRA"
    },
    {
      "codigo_valor_dominio": 2997,
      "codigo_referencia_valor_dominio": "811510",
      "nome_resumido_valor_dominio": "OPERADOR DE TRANSFERENCIA E ESTOCAGEM - NA REFINACAO DO PETR",
      "nome_completo_valor_dominio": "OPERADOR DE TRANSFERENCIA E ESTOCAGEM - NA REFINACAO DO PETROLEO",
      "descricao_conceito_valor_dominio": "OPERADOR DE TRANSFERENCIA E ESTOCAGEM - NA REFINACAO DO PETROLEO"
    },
    {
      "codigo_valor_dominio": 2998,
      "codigo_referencia_valor_dominio": "722110",
      "nome_resumido_valor_dominio": "FORJADOR A MARTELO",
      "nome_completo_valor_dominio": "FORJADOR A MARTELO",
      "descricao_conceito_valor_dominio": "FORJADOR A MARTELO"
    },
    {
      "codigo_valor_dominio": 2999,
      "codigo_referencia_valor_dominio": "722115",
      "nome_resumido_valor_dominio": "FORJADOR PRENSISTA",
      "nome_completo_valor_dominio": "FORJADOR PRENSISTA",
      "descricao_conceito_valor_dominio": "FORJADOR PRENSISTA"
    },
    {
      "codigo_valor_dominio": 3000,
      "codigo_referencia_valor_dominio": "823315",
      "nome_resumido_valor_dominio": "FORNEIRO (MATERIAIS DE CONSTRUCAO)",
      "nome_completo_valor_dominio": "FORNEIRO (MATERIAIS DE CONSTRUCAO)",
      "descricao_conceito_valor_dominio": "FORNEIRO (MATERIAIS DE CONSTRUCAO)"
    },
    {
      "codigo_valor_dominio": 3001,
      "codigo_referencia_valor_dominio": "991305",
      "nome_resumido_valor_dominio": "FUNILEIRO DE VEICULOS (REPARACAO)",
      "nome_completo_valor_dominio": "FUNILEIRO DE VEICULOS (REPARACAO)",
      "descricao_conceito_valor_dominio": "FUNILEIRO DE VEICULOS (REPARACAO)"
    },
    {
      "codigo_valor_dominio": 3002,
      "codigo_referencia_valor_dominio": "261415",
      "nome_resumido_valor_dominio": "LINGUISTA",
      "nome_completo_valor_dominio": "LINGUISTA",
      "descricao_conceito_valor_dominio": "LINGUISTA"
    },
    {
      "codigo_valor_dominio": 3003,
      "codigo_referencia_valor_dominio": "821230",
      "nome_resumido_valor_dominio": "OPERADOR DE ACIARIA (BASCULAMENTO DE CONVERTEDOR)",
      "nome_completo_valor_dominio": "OPERADOR DE ACIARIA (BASCULAMENTO DE CONVERTEDOR)",
      "descricao_conceito_valor_dominio": "OPERADOR DE ACIARIA (BASCULAMENTO DE CONVERTEDOR)"
    },
    {
      "codigo_valor_dominio": 3004,
      "codigo_referencia_valor_dominio": "415130",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA COPIADORA (EXCETO OPERADOR DE GRAFICA RA",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA COPIADORA (EXCETO OPERADOR DE GRAFICA RAPIDA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA COPIADORA (EXCETO OPERADOR DE GRAFICA RAPIDA)"
    },
    {
      "codigo_valor_dominio": 3005,
      "codigo_referencia_valor_dominio": "761430",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE LAVAR FIOS E TECIDOS",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE LAVAR FIOS E TECIDOS",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE LAVAR FIOS E TECIDOS"
    },
    {
      "codigo_valor_dominio": 3006,
      "codigo_referencia_valor_dominio": "781305",
      "nome_resumido_valor_dominio": "OPERADOR DE VEICULOS SUBAQUATICOS CONTROLADOS REMOTAMENTE",
      "nome_completo_valor_dominio": "OPERADOR DE VEICULOS SUBAQUATICOS CONTROLADOS REMOTAMENTE",
      "descricao_conceito_valor_dominio": "OPERADOR DE VEICULOS SUBAQUATICOS CONTROLADOS REMOTAMENTE"
    },
    {
      "codigo_valor_dominio": 3007,
      "codigo_referencia_valor_dominio": "841468",
      "nome_resumido_valor_dominio": "PREPARADOR DE RACOES",
      "nome_completo_valor_dominio": "PREPARADOR DE RACOES",
      "descricao_conceito_valor_dominio": "PREPARADOR DE RACOES"
    },
    {
      "codigo_valor_dominio": 3008,
      "codigo_referencia_valor_dominio": "516215",
      "nome_resumido_valor_dominio": "MAE SOCIAL",
      "nome_completo_valor_dominio": "MAE SOCIAL",
      "descricao_conceito_valor_dominio": "MAE SOCIAL"
    },
    {
      "codigo_valor_dominio": 3009,
      "codigo_referencia_valor_dominio": "722305",
      "nome_resumido_valor_dominio": "MACHEIRO, A MAO",
      "nome_completo_valor_dominio": "MACHEIRO, A MAO",
      "descricao_conceito_valor_dominio": "MACHEIRO, A MAO"
    },
    {
      "codigo_valor_dominio": 3010,
      "codigo_referencia_valor_dominio": "722320",
      "nome_resumido_valor_dominio": "MOLDADOR, A MAQUINA",
      "nome_completo_valor_dominio": "MOLDADOR, A MAQUINA",
      "descricao_conceito_valor_dominio": "MOLDADOR, A MAQUINA"
    },
    {
      "codigo_valor_dominio": 3011,
      "codigo_referencia_valor_dominio": "811105",
      "nome_resumido_valor_dominio": "MOLEIRO (TRATAMENTOS QUIMICOS E AFINS)",
      "nome_completo_valor_dominio": "MOLEIRO (TRATAMENTOS QUIMICOS E AFINS)",
      "descricao_conceito_valor_dominio": "MOLEIRO (TRATAMENTOS QUIMICOS E AFINS)"
    },
    {
      "codigo_valor_dominio": 3012,
      "codigo_referencia_valor_dominio": "841310",
      "nome_resumido_valor_dominio": "OPERADOR DE EQUIPAMENTOS DE REFINACAO DE ACUCAR (PROCESSO CO",
      "nome_completo_valor_dominio": "OPERADOR DE EQUIPAMENTOS DE REFINACAO DE ACUCAR (PROCESSO CONTINUO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE EQUIPAMENTOS DE REFINACAO DE ACUCAR (PROCESSO CONTINUO)"
    },
    {
      "codigo_valor_dominio": 3013,
      "codigo_referencia_valor_dominio": "842135",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE PREPARACAO DE MATERIA PRIMA PARA PROD",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE PREPARACAO DE MATERIA PRIMA PARA PRODUCAO DE CIGARROS",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE PREPARACAO DE MATERIA PRIMA PARA PRODUCAO DE CIGARROS"
    },
    {
      "codigo_valor_dominio": 3014,
      "codigo_referencia_valor_dominio": "722405",
      "nome_resumido_valor_dominio": "CABLEADOR",
      "nome_completo_valor_dominio": "CABLEADOR",
      "descricao_conceito_valor_dominio": "CABLEADOR"
    },
    {
      "codigo_valor_dominio": 3015,
      "codigo_referencia_valor_dominio": "783220",
      "nome_resumido_valor_dominio": "ESTIVADOR",
      "nome_completo_valor_dominio": "ESTIVADOR",
      "descricao_conceito_valor_dominio": "ESTIVADOR"
    },
    {
      "codigo_valor_dominio": 3016,
      "codigo_referencia_valor_dominio": "224135",
      "nome_resumido_valor_dominio": "TREINADOR PROFISSIONAL DE FUTEBOL",
      "nome_completo_valor_dominio": "TREINADOR PROFISSIONAL DE FUTEBOL",
      "descricao_conceito_valor_dominio": "TREINADOR PROFISSIONAL DE FUTEBOL"
    },
    {
      "codigo_valor_dominio": 3017,
      "codigo_referencia_valor_dominio": "723105",
      "nome_resumido_valor_dominio": "CEMENTADOR DE METAIS",
      "nome_completo_valor_dominio": "CEMENTADOR DE METAIS",
      "descricao_conceito_valor_dominio": "CEMENTADOR DE METAIS"
    },
    {
      "codigo_valor_dominio": 3018,
      "codigo_referencia_valor_dominio": "516710",
      "nome_resumido_valor_dominio": "NUMEROLOGO",
      "nome_completo_valor_dominio": "NUMEROLOGO",
      "descricao_conceito_valor_dominio": "NUMEROLOGO"
    },
    {
      "codigo_valor_dominio": 3019,
      "codigo_referencia_valor_dominio": "722325",
      "nome_resumido_valor_dominio": "OPERADOR DE EQUIPAMENTOS DE PREPARACAO DE AREIA",
      "nome_completo_valor_dominio": "OPERADOR DE EQUIPAMENTOS DE PREPARACAO DE AREIA",
      "descricao_conceito_valor_dominio": "OPERADOR DE EQUIPAMENTOS DE PREPARACAO DE AREIA"
    },
    {
      "codigo_valor_dominio": 3020,
      "codigo_referencia_valor_dominio": "773315",
      "nome_resumido_valor_dominio": "OPERADOR DE FRESADORA (USINAGEM DE MADEIRA)",
      "nome_completo_valor_dominio": "OPERADOR DE FRESADORA (USINAGEM DE MADEIRA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE FRESADORA (USINAGEM DE MADEIRA)"
    },
    {
      "codigo_valor_dominio": 3021,
      "codigo_referencia_valor_dominio": "823255",
      "nome_resumido_valor_dominio": "TEMPERADOR DE VIDRO",
      "nome_completo_valor_dominio": "TEMPERADOR DE VIDRO",
      "descricao_conceito_valor_dominio": "TEMPERADOR DE VIDRO"
    },
    {
      "codigo_valor_dominio": 3022,
      "codigo_referencia_valor_dominio": "752405",
      "nome_resumido_valor_dominio": "DECORADOR DE CERAMICA",
      "nome_completo_valor_dominio": "DECORADOR DE CERAMICA",
      "descricao_conceito_valor_dominio": "DECORADOR DE CERAMICA"
    },
    {
      "codigo_valor_dominio": 3023,
      "codigo_referencia_valor_dominio": "261805",
      "nome_resumido_valor_dominio": "FOTOGRAFO",
      "nome_completo_valor_dominio": "FOTOGRAFO",
      "descricao_conceito_valor_dominio": "FOTOGRAFO"
    },
    {
      "codigo_valor_dominio": 3024,
      "codigo_referencia_valor_dominio": "519920",
      "nome_resumido_valor_dominio": "GANDULA",
      "nome_completo_valor_dominio": "GANDULA",
      "descricao_conceito_valor_dominio": "GANDULA"
    },
    {
      "codigo_valor_dominio": 3025,
      "codigo_referencia_valor_dominio": "213315",
      "nome_resumido_valor_dominio": "METEOROLOGISTA",
      "nome_completo_valor_dominio": "METEOROLOGISTA",
      "descricao_conceito_valor_dominio": "METEOROLOGISTA"
    },
    {
      "codigo_valor_dominio": 3026,
      "codigo_referencia_valor_dominio": "723220",
      "nome_resumido_valor_dominio": "METALIZADOR A PISTOLA",
      "nome_completo_valor_dominio": "METALIZADOR A PISTOLA",
      "descricao_conceito_valor_dominio": "METALIZADOR A PISTOLA"
    },
    {
      "codigo_valor_dominio": 3027,
      "codigo_referencia_valor_dominio": "782120",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA RODOFERROVIARIA",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA RODOFERROVIARIA",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA RODOFERROVIARIA"
    },
    {
      "codigo_valor_dominio": 3028,
      "codigo_referencia_valor_dominio": "954125",
      "nome_resumido_valor_dominio": "OPERADOR ELETROMECANICO",
      "nome_completo_valor_dominio": "OPERADOR ELETROMECANICO",
      "descricao_conceito_valor_dominio": "OPERADOR ELETROMECANICO"
    },
    {
      "codigo_valor_dominio": 3029,
      "codigo_referencia_valor_dominio": "848305",
      "nome_resumido_valor_dominio": "PADEIRO",
      "nome_completo_valor_dominio": "PADEIRO",
      "descricao_conceito_valor_dominio": "PADEIRO"
    },
    {
      "codigo_valor_dominio": 3030,
      "codigo_referencia_valor_dominio": "723115",
      "nome_resumido_valor_dominio": "OPERADOR DE EQUIPAMENTO PARA RESFRIAMENTO",
      "nome_completo_valor_dominio": "OPERADOR DE EQUIPAMENTO PARA RESFRIAMENTO",
      "descricao_conceito_valor_dominio": "OPERADOR DE EQUIPAMENTO PARA RESFRIAMENTO"
    },
    {
      "codigo_valor_dominio": 3031,
      "codigo_referencia_valor_dominio": "752430",
      "nome_resumido_valor_dominio": "PINTOR DE CERAMICA, A PINCEL",
      "nome_completo_valor_dominio": "PINTOR DE CERAMICA, A PINCEL",
      "descricao_conceito_valor_dominio": "PINTOR DE CERAMICA, A PINCEL"
    },
    {
      "codigo_valor_dominio": 3032,
      "codigo_referencia_valor_dominio": "768625",
      "nome_resumido_valor_dominio": "PINTOR DE LETREIROS",
      "nome_completo_valor_dominio": "PINTOR DE LETREIROS",
      "descricao_conceito_valor_dominio": "PINTOR DE LETREIROS"
    },
    {
      "codigo_valor_dominio": 3033,
      "codigo_referencia_valor_dominio": "991315",
      "nome_resumido_valor_dominio": "PINTOR DE VEICULOS (REPARACAO)",
      "nome_completo_valor_dominio": "PINTOR DE VEICULOS (REPARACAO)",
      "descricao_conceito_valor_dominio": "PINTOR DE VEICULOS (REPARACAO)"
    },
    {
      "codigo_valor_dominio": 3034,
      "codigo_referencia_valor_dominio": "723330",
      "nome_resumido_valor_dominio": "PINTOR, A PISTOLA (EXCETO OBRAS E ESTRUTURAS METALICAS)",
      "nome_completo_valor_dominio": "PINTOR, A PISTOLA (EXCETO OBRAS E ESTRUTURAS METALICAS)",
      "descricao_conceito_valor_dominio": "PINTOR, A PISTOLA (EXCETO OBRAS E ESTRUTURAS METALICAS)"
    },
    {
      "codigo_valor_dominio": 3035,
      "codigo_referencia_valor_dominio": "524310",
      "nome_resumido_valor_dominio": "PIPOQUEIRO AMBULANTE",
      "nome_completo_valor_dominio": "PIPOQUEIRO AMBULANTE",
      "descricao_conceito_valor_dominio": "PIPOQUEIRO AMBULANTE"
    },
    {
      "codigo_valor_dominio": 3036,
      "codigo_referencia_valor_dominio": "724105",
      "nome_resumido_valor_dominio": "ASSENTADOR DE CANALIZACAO (EDIFICACOES)",
      "nome_completo_valor_dominio": "ASSENTADOR DE CANALIZACAO (EDIFICACOES)",
      "descricao_conceito_valor_dominio": "ASSENTADOR DE CANALIZACAO (EDIFICACOES)"
    },
    {
      "codigo_valor_dominio": 3037,
      "codigo_referencia_valor_dominio": "821405",
      "nome_resumido_valor_dominio": "ENCARREGADO DE ACABAMENTO DE CHAPAS E METAIS (TEMPERA)",
      "nome_completo_valor_dominio": "ENCARREGADO DE ACABAMENTO DE CHAPAS E METAIS (TEMPERA)",
      "descricao_conceito_valor_dominio": "ENCARREGADO DE ACABAMENTO DE CHAPAS E METAIS (TEMPERA)"
    },
    {
      "codigo_valor_dominio": 3038,
      "codigo_referencia_valor_dominio": "724120",
      "nome_resumido_valor_dominio": "INSTALADOR DE TUBULACOES (AERONAVES)",
      "nome_completo_valor_dominio": "INSTALADOR DE TUBULACOES (AERONAVES)",
      "descricao_conceito_valor_dominio": "INSTALADOR DE TUBULACOES (AERONAVES)"
    },
    {
      "codigo_valor_dominio": 3039,
      "codigo_referencia_valor_dominio": "724125",
      "nome_resumido_valor_dominio": "INSTALADOR DE TUBULACOES (EMBARCACOES)",
      "nome_completo_valor_dominio": "INSTALADOR DE TUBULACOES (EMBARCACOES)",
      "descricao_conceito_valor_dominio": "INSTALADOR DE TUBULACOES (EMBARCACOES)"
    },
    {
      "codigo_valor_dominio": 3040,
      "codigo_referencia_valor_dominio": "724130",
      "nome_resumido_valor_dominio": "INSTALADOR DE TUBULACOES DE GAS COMBUSTIVEL (PRODUCAO E DIST",
      "nome_completo_valor_dominio": "INSTALADOR DE TUBULACOES DE GAS COMBUSTIVEL (PRODUCAO E DISTRIBUICAO)",
      "descricao_conceito_valor_dominio": "INSTALADOR DE TUBULACOES DE GAS COMBUSTIVEL (PRODUCAO E DISTRIBUICAO) DIST"
    },
    {
      "codigo_valor_dominio": 3041,
      "codigo_referencia_valor_dominio": "724135",
      "nome_resumido_valor_dominio": "INSTALADOR DE TUBULACOES DE VAPOR (PRODUCAO E DISTRIBUICAO)",
      "nome_completo_valor_dominio": "INSTALADOR DE TUBULACOES DE VAPOR (PRODUCAO E DISTRIBUICAO)",
      "descricao_conceito_valor_dominio": "INSTALADOR DE TUBULACOES DE VAPOR (PRODUCAO E DISTRIBUICAO)"
    },
    {
      "codigo_valor_dominio": 3042,
      "codigo_referencia_valor_dominio": "732125",
      "nome_resumido_valor_dominio": "INSTALADOR ELETRICISTA (TRACAO DE VEICULOS)",
      "nome_completo_valor_dominio": "INSTALADOR ELETRICISTA (TRACAO DE VEICULOS)",
      "descricao_conceito_valor_dominio": "INSTALADOR ELETRICISTA (TRACAO DE VEICULOS)"
    },
    {
      "codigo_valor_dominio": 3043,
      "codigo_referencia_valor_dominio": "724205",
      "nome_resumido_valor_dominio": "MONTADOR DE ESTRUTURAS METALICAS DE EMBARCACOES",
      "nome_completo_valor_dominio": "MONTADOR DE ESTRUTURAS METALICAS DE EMBARCACOES",
      "descricao_conceito_valor_dominio": "MONTADOR DE ESTRUTURAS METALICAS DE EMBARCACOES"
    },
    {
      "codigo_valor_dominio": 3044,
      "codigo_referencia_valor_dominio": "374420",
      "nome_resumido_valor_dominio": "MONTADOR DE FILMES",
      "nome_completo_valor_dominio": "MONTADOR DE FILMES",
      "descricao_conceito_valor_dominio": "MONTADOR DE FILMES"
    },
    {
      "codigo_valor_dominio": 3045,
      "codigo_referencia_valor_dominio": "724230",
      "nome_resumido_valor_dominio": "REBITADOR, A MAO",
      "nome_completo_valor_dominio": "REBITADOR, A MAO",
      "descricao_conceito_valor_dominio": "REBITADOR, A MAO"
    },
    {
      "codigo_valor_dominio": 3046,
      "codigo_referencia_valor_dominio": "842205",
      "nome_resumido_valor_dominio": "PREPARADOR DE FUMO NA FABRICACAO DE CHARUTOS",
      "nome_completo_valor_dominio": "PREPARADOR DE FUMO NA FABRICACAO DE CHARUTOS",
      "descricao_conceito_valor_dominio": "PREPARADOR DE FUMO NA FABRICACAO DE CHARUTOS"
    },
    {
      "codigo_valor_dominio": 3047,
      "codigo_referencia_valor_dominio": "763120",
      "nome_resumido_valor_dominio": "RISCADOR DE ROUPAS",
      "nome_completo_valor_dominio": "RISCADOR DE ROUPAS",
      "descricao_conceito_valor_dominio": "RISCADOR DE ROUPAS"
    },
    {
      "codigo_valor_dominio": 3048,
      "codigo_referencia_valor_dominio": "421205",
      "nome_resumido_valor_dominio": "RECEBEDOR DE APOSTAS (LOTERIA)",
      "nome_completo_valor_dominio": "RECEBEDOR DE APOSTAS (LOTERIA)",
      "descricao_conceito_valor_dominio": "RECEBEDOR DE APOSTAS (LOTERIA)"
    },
    {
      "codigo_valor_dominio": 3049,
      "codigo_referencia_valor_dominio": "724305",
      "nome_resumido_valor_dominio": "BRASADOR",
      "nome_completo_valor_dominio": "BRASADOR",
      "descricao_conceito_valor_dominio": "BRASADOR"
    },
    {
      "codigo_valor_dominio": 3050,
      "codigo_referencia_valor_dominio": "723240",
      "nome_resumido_valor_dominio": "OXIDADOR",
      "nome_completo_valor_dominio": "OXIDADOR",
      "descricao_conceito_valor_dominio": "OXIDADOR"
    },
    {
      "codigo_valor_dominio": 3051,
      "codigo_referencia_valor_dominio": "724320",
      "nome_resumido_valor_dominio": "SOLDADOR A OXIGAS",
      "nome_completo_valor_dominio": "SOLDADOR A OXIGAS",
      "descricao_conceito_valor_dominio": "SOLDADOR A OXIGAS"
    },
    {
      "codigo_valor_dominio": 3052,
      "codigo_referencia_valor_dominio": "991120",
      "nome_resumido_valor_dominio": "SOLDADOR ALUMINOTERMICO EM CONSERVACAO DE TRILHOS",
      "nome_completo_valor_dominio": "SOLDADOR ALUMINOTERMICO EM CONSERVACAO DE TRILHOS",
      "descricao_conceito_valor_dominio": "SOLDADOR ALUMINOTERMICO EM CONSERVACAO DE TRILHOS"
    },
    {
      "codigo_valor_dominio": 3053,
      "codigo_referencia_valor_dominio": "711315",
      "nome_resumido_valor_dominio": "SONDADOR (POCOS DE PETROLEO E GAS)",
      "nome_completo_valor_dominio": "SONDADOR (POCOS DE PETROLEO E GAS)",
      "descricao_conceito_valor_dominio": "SONDADOR (POCOS DE PETROLEO E GAS)"
    },
    {
      "codigo_valor_dominio": 3054,
      "codigo_referencia_valor_dominio": "724405",
      "nome_resumido_valor_dominio": "CALDEIREIRO (CHAPAS DE COBRE)",
      "nome_completo_valor_dominio": "CALDEIREIRO (CHAPAS DE COBRE)",
      "descricao_conceito_valor_dominio": "CALDEIREIRO (CHAPAS DE COBRE)"
    },
    {
      "codigo_valor_dominio": 3055,
      "codigo_referencia_valor_dominio": "724410",
      "nome_resumido_valor_dominio": "CALDEIREIRO (CHAPAS DE FERRO E ACO)",
      "nome_completo_valor_dominio": "CALDEIREIRO (CHAPAS DE FERRO E ACO)",
      "descricao_conceito_valor_dominio": "CALDEIREIRO (CHAPAS DE FERRO E ACO)"
    },
    {
      "codigo_valor_dominio": 3056,
      "codigo_referencia_valor_dominio": "724415",
      "nome_resumido_valor_dominio": "CHAPEADOR",
      "nome_completo_valor_dominio": "CHAPEADOR",
      "descricao_conceito_valor_dominio": "CHAPEADOR"
    },
    {
      "codigo_valor_dominio": 3057,
      "codigo_referencia_valor_dominio": "724420",
      "nome_resumido_valor_dominio": "CHAPEADOR DE CARROCERIAS METALICAS (FABRICACAO)",
      "nome_completo_valor_dominio": "CHAPEADOR DE CARROCERIAS METALICAS (FABRICACAO)",
      "descricao_conceito_valor_dominio": "CHAPEADOR DE CARROCERIAS METALICAS (FABRICACAO)"
    },
    {
      "codigo_valor_dominio": 3058,
      "codigo_referencia_valor_dominio": "724425",
      "nome_resumido_valor_dominio": "CHAPEADOR NAVAL",
      "nome_completo_valor_dominio": "CHAPEADOR NAVAL",
      "descricao_conceito_valor_dominio": "CHAPEADOR NAVAL"
    },
    {
      "codigo_valor_dominio": 3059,
      "codigo_referencia_valor_dominio": "724430",
      "nome_resumido_valor_dominio": "CHAPEADOR DE AERONAVES",
      "nome_completo_valor_dominio": "CHAPEADOR DE AERONAVES",
      "descricao_conceito_valor_dominio": "CHAPEADOR DE AERONAVES"
    },
    {
      "codigo_valor_dominio": 3060,
      "codigo_referencia_valor_dominio": "723215",
      "nome_resumido_valor_dominio": "GALVANIZADOR",
      "nome_completo_valor_dominio": "GALVANIZADOR",
      "descricao_conceito_valor_dominio": "GALVANIZADOR"
    },
    {
      "codigo_valor_dominio": 3061,
      "codigo_referencia_valor_dominio": "717020",
      "nome_resumido_valor_dominio": "SERVENTE DE OBRAS",
      "nome_completo_valor_dominio": "SERVENTE DE OBRAS",
      "descricao_conceito_valor_dominio": "SERVENTE DE OBRAS"
    },
    {
      "codigo_valor_dominio": 3062,
      "codigo_referencia_valor_dominio": "761354",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE CORDOALHA",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE CORDOALHA",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE CORDOALHA"
    },
    {
      "codigo_valor_dominio": 3063,
      "codigo_referencia_valor_dominio": "721205",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE ELETROEROSAO",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE ELETROEROSAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE ELETROEROSAO"
    },
    {
      "codigo_valor_dominio": 3064,
      "codigo_referencia_valor_dominio": "773210",
      "nome_resumido_valor_dominio": "PRENSISTA DE AGLOMERADOS",
      "nome_completo_valor_dominio": "PRENSISTA DE AGLOMERADOS",
      "descricao_conceito_valor_dominio": "PRENSISTA DE AGLOMERADOS"
    },
    {
      "codigo_valor_dominio": 3065,
      "codigo_referencia_valor_dominio": "761235",
      "nome_resumido_valor_dominio": "OPERADOR DE LAMINADEIRA E REUNIDEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE LAMINADEIRA E REUNIDEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE LAMINADEIRA E REUNIDEIRA"
    },
    {
      "codigo_valor_dominio": 3066,
      "codigo_referencia_valor_dominio": "752120",
      "nome_resumido_valor_dominio": "TRANSFORMADOR DE TUBOS DE VIDRO",
      "nome_completo_valor_dominio": "TRANSFORMADOR DE TUBOS DE VIDRO",
      "descricao_conceito_valor_dominio": "TRANSFORMADOR DE TUBOS DE VIDRO"
    },
    {
      "codigo_valor_dominio": 3067,
      "codigo_referencia_valor_dominio": "725005",
      "nome_resumido_valor_dominio": "AJUSTADOR FERRAMENTEIRO",
      "nome_completo_valor_dominio": "AJUSTADOR FERRAMENTEIRO",
      "descricao_conceito_valor_dominio": "AJUSTADOR FERRAMENTEIRO"
    },
    {
      "codigo_valor_dominio": 3068,
      "codigo_referencia_valor_dominio": "725010",
      "nome_resumido_valor_dominio": "AJUSTADOR MECANICO",
      "nome_completo_valor_dominio": "AJUSTADOR MECANICO",
      "descricao_conceito_valor_dominio": "AJUSTADOR MECANICO"
    },
    {
      "codigo_valor_dominio": 3069,
      "codigo_referencia_valor_dominio": "725015",
      "nome_resumido_valor_dominio": "AJUSTADOR MECANICO (USINAGEM EM BANCADA E EM MAQUINAS-FERRAM",
      "nome_completo_valor_dominio": "AJUSTADOR MECANICO (USINAGEM EM BANCADA E EM MAQUINAS-FERRAMENTAS)",
      "descricao_conceito_valor_dominio": "AJUSTADOR MECANICO (USINAGEM EM BANCADA E EM MAQUINAS-FERRAMENTAS)"
    },
    {
      "codigo_valor_dominio": 3070,
      "codigo_referencia_valor_dominio": "725020",
      "nome_resumido_valor_dominio": "AJUSTADOR MECANICO EM BANCADA",
      "nome_completo_valor_dominio": "AJUSTADOR MECANICO EM BANCADA",
      "descricao_conceito_valor_dominio": "AJUSTADOR MECANICO EM BANCADA"
    },
    {
      "codigo_valor_dominio": 3071,
      "codigo_referencia_valor_dominio": "725025",
      "nome_resumido_valor_dominio": "AJUSTADOR NAVAL (REPARO E CONSTRUCAO)",
      "nome_completo_valor_dominio": "AJUSTADOR NAVAL (REPARO E CONSTRUCAO)",
      "descricao_conceito_valor_dominio": "AJUSTADOR NAVAL (REPARO E CONSTRUCAO)"
    },
    {
      "codigo_valor_dominio": 3072,
      "codigo_referencia_valor_dominio": "725225",
      "nome_resumido_valor_dominio": "MONTADOR DE MAQUINAS-FERRAMENTAS (USINAGEM DE METAIS)",
      "nome_completo_valor_dominio": "MONTADOR DE MAQUINAS-FERRAMENTAS (USINAGEM DE METAIS)",
      "descricao_conceito_valor_dominio": "MONTADOR DE MAQUINAS-FERRAMENTAS (USINAGEM DE METAIS)"
    },
    {
      "codigo_valor_dominio": 3073,
      "codigo_referencia_valor_dominio": "725310",
      "nome_resumido_valor_dominio": "MONTADOR DE MAQUINAS AGRICOLAS",
      "nome_completo_valor_dominio": "MONTADOR DE MAQUINAS AGRICOLAS",
      "descricao_conceito_valor_dominio": "MONTADOR DE MAQUINAS AGRICOLAS"
    },
    {
      "codigo_valor_dominio": 3074,
      "codigo_referencia_valor_dominio": "725215",
      "nome_resumido_valor_dominio": "MONTADOR DE MAQUINAS OPERATRIZES PARA MADEIRA",
      "nome_completo_valor_dominio": "MONTADOR DE MAQUINAS OPERATRIZES PARA MADEIRA",
      "descricao_conceito_valor_dominio": "MONTADOR DE MAQUINAS OPERATRIZES PARA MADEIRA"
    },
    {
      "codigo_valor_dominio": 3075,
      "codigo_referencia_valor_dominio": "725220",
      "nome_resumido_valor_dominio": "MONTADOR DE MAQUINAS TEXTEIS",
      "nome_completo_valor_dominio": "MONTADOR DE MAQUINAS TEXTEIS",
      "descricao_conceito_valor_dominio": "MONTADOR DE MAQUINAS TEXTEIS"
    },
    {
      "codigo_valor_dominio": 3076,
      "codigo_referencia_valor_dominio": "725105",
      "nome_resumido_valor_dominio": "MONTADOR DE MAQUINAS, MOTORES E ACESSORIOS (MONTAGEM EM SERI",
      "nome_completo_valor_dominio": "MONTADOR DE MAQUINAS, MOTORES E ACESSORIOS (MONTAGEM EM SERIE)",
      "descricao_conceito_valor_dominio": "MONTADOR DE MAQUINAS, MOTORES E ACESSORIOS (MONTAGEM EM SERIE)"
    },
    {
      "codigo_valor_dominio": 3077,
      "codigo_referencia_valor_dominio": "774105",
      "nome_resumido_valor_dominio": "MONTADOR DE MOVEIS E ARTEFATOS DE MADEIRA",
      "nome_completo_valor_dominio": "MONTADOR DE MOVEIS E ARTEFATOS DE MADEIRA",
      "descricao_conceito_valor_dominio": "MONTADOR DE MOVEIS E ARTEFATOS DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 3078,
      "codigo_referencia_valor_dominio": "731135",
      "nome_resumido_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS",
      "nome_completo_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS",
      "descricao_conceito_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS"
    },
    {
      "codigo_valor_dominio": 3079,
      "codigo_referencia_valor_dominio": "725315",
      "nome_resumido_valor_dominio": "MONTADOR DE MAQUINAS DE MINAS E PEDREIRAS",
      "nome_completo_valor_dominio": "MONTADOR DE MAQUINAS DE MINAS E PEDREIRAS",
      "descricao_conceito_valor_dominio": "MONTADOR DE MAQUINAS DE MINAS E PEDREIRAS"
    },
    {
      "codigo_valor_dominio": 3080,
      "codigo_referencia_valor_dominio": "725320",
      "nome_resumido_valor_dominio": "MONTADOR DE MAQUINAS DE TERRAPLENAGEM",
      "nome_completo_valor_dominio": "MONTADOR DE MAQUINAS DE TERRAPLENAGEM",
      "descricao_conceito_valor_dominio": "MONTADOR DE MAQUINAS DE TERRAPLENAGEM"
    },
    {
      "codigo_valor_dominio": 3081,
      "codigo_referencia_valor_dominio": "725210",
      "nome_resumido_valor_dominio": "MONTADOR DE MAQUINAS GRAFICAS",
      "nome_completo_valor_dominio": "MONTADOR DE MAQUINAS GRAFICAS",
      "descricao_conceito_valor_dominio": "MONTADOR DE MAQUINAS GRAFICAS"
    },
    {
      "codigo_valor_dominio": 3082,
      "codigo_referencia_valor_dominio": "725410",
      "nome_resumido_valor_dominio": "MECANICO MONTADOR DE MOTORES DE EMBARCACOES",
      "nome_completo_valor_dominio": "MECANICO MONTADOR DE MOTORES DE EMBARCACOES",
      "descricao_conceito_valor_dominio": "MECANICO MONTADOR DE MOTORES DE EMBARCACOES"
    },
    {
      "codigo_valor_dominio": 3083,
      "codigo_referencia_valor_dominio": "725415",
      "nome_resumido_valor_dominio": "MECANICO MONTADOR DE MOTORES DE EXPLOSAO E DIESEL",
      "nome_completo_valor_dominio": "MECANICO MONTADOR DE MOTORES DE EXPLOSAO E DIESEL",
      "descricao_conceito_valor_dominio": "MECANICO MONTADOR DE MOTORES DE EXPLOSAO E DIESEL"
    },
    {
      "codigo_valor_dominio": 3084,
      "codigo_referencia_valor_dominio": "725420",
      "nome_resumido_valor_dominio": "MECANICO MONTADOR DE TURBOALIMENTADORES",
      "nome_completo_valor_dominio": "MECANICO MONTADOR DE TURBOALIMENTADORES",
      "descricao_conceito_valor_dominio": "MECANICO MONTADOR DE TURBOALIMENTADORES"
    },
    {
      "codigo_valor_dominio": 3085,
      "codigo_referencia_valor_dominio": "225105",
      "nome_resumido_valor_dominio": "MEDICO ACUPUNTURISTA",
      "nome_completo_valor_dominio": "MEDICO ACUPUNTURISTA",
      "descricao_conceito_valor_dominio": "MEDICO ACUPUNTURISTA"
    },
    {
      "codigo_valor_dominio": 3086,
      "codigo_referencia_valor_dominio": "991310",
      "nome_resumido_valor_dominio": "MONTADOR DE VEICULOS (REPARACAO)",
      "nome_completo_valor_dominio": "MONTADOR DE VEICULOS (REPARACAO)",
      "descricao_conceito_valor_dominio": "MONTADOR DE VEICULOS (REPARACAO)"
    },
    {
      "codigo_valor_dominio": 3087,
      "codigo_referencia_valor_dominio": "773345",
      "nome_resumido_valor_dominio": "OPERADOR DE TORNO AUTOMATICO (USINAGEM DE MADEIRA)",
      "nome_completo_valor_dominio": "OPERADOR DE TORNO AUTOMATICO (USINAGEM DE MADEIRA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE TORNO AUTOMATICO (USINAGEM DE MADEIRA)"
    },
    {
      "codigo_valor_dominio": 3088,
      "codigo_referencia_valor_dominio": "724210",
      "nome_resumido_valor_dominio": "MONTADOR DE ESTRUTURAS METALICAS",
      "nome_completo_valor_dominio": "MONTADOR DE ESTRUTURAS METALICAS",
      "descricao_conceito_valor_dominio": "MONTADOR DE ESTRUTURAS METALICAS"
    },
    {
      "codigo_valor_dominio": 3089,
      "codigo_referencia_valor_dominio": "725505",
      "nome_resumido_valor_dominio": "MONTADOR DE VEICULOS (LINHA DE MONTAGEM)",
      "nome_completo_valor_dominio": "MONTADOR DE VEICULOS (LINHA DE MONTAGEM)",
      "descricao_conceito_valor_dominio": "MONTADOR DE VEICULOS (LINHA DE MONTAGEM)"
    },
    {
      "codigo_valor_dominio": 3090,
      "codigo_referencia_valor_dominio": "914425",
      "nome_resumido_valor_dominio": "MECANICO DE VEICULOS AUTOMOTORES A DIESEL (EXCETO TRATORES)",
      "nome_completo_valor_dominio": "MECANICO DE VEICULOS AUTOMOTORES A DIESEL (EXCETO TRATORES)",
      "descricao_conceito_valor_dominio": "MECANICO DE VEICULOS AUTOMOTORES A DIESEL (EXCETO TRATORES)"
    },
    {
      "codigo_valor_dominio": 3091,
      "codigo_referencia_valor_dominio": "860110",
      "nome_resumido_valor_dominio": "SUPERVISOR DE OPERACAO DE FLUIDOS (DISTRIBUICAO, CAPTACAO, T",
      "nome_completo_valor_dominio": "SUPERVISOR DE OPERACAO DE FLUIDOS (DISTRIBUICAO, CAPTACAO, TRATAMENTO DE AGUA, GASES, VAPOR)",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE OPERACAO DE FLUIDOS (DISTRIBUICAO, CAPTACAO, TRATAMENTO DE AGUA, GASES, VAPOR)"
    },
    {
      "codigo_valor_dominio": 3092,
      "codigo_referencia_valor_dominio": "731110",
      "nome_resumido_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS (COMPUTADORES E EQUIPAM",
      "nome_completo_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS (COMPUTADORES E EQUIPAMENTOS AUXILIARES)",
      "descricao_conceito_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS (COMPUTADORES E EQUIPAMENTOS AUXILIARES)"
    },
    {
      "codigo_valor_dominio": 3093,
      "codigo_referencia_valor_dominio": "731205",
      "nome_resumido_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS (ESTACAO DE RADIO, TV E",
      "nome_completo_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS (ESTACAO DE RADIO, TV E EQUIPAMENTOS DE RADAR)",
      "descricao_conceito_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS (ESTACAO DE RADIO, TV E EQUIPAMENTOS DE RADAR)"
    },
    {
      "codigo_valor_dominio": 3094,
      "codigo_referencia_valor_dominio": "731130",
      "nome_resumido_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (MOTORES E DINAMOS)",
      "nome_completo_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (MOTORES E DINAMOS)",
      "descricao_conceito_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (MOTORES E DINAMOS)"
    },
    {
      "codigo_valor_dominio": 3095,
      "codigo_referencia_valor_dominio": "731125",
      "nome_resumido_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (CENTRAIS ELETRICAS)",
      "nome_completo_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (CENTRAIS ELETRICAS)",
      "descricao_conceito_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (CENTRAIS ELETRICAS)"
    },
    {
      "codigo_valor_dominio": 3096,
      "codigo_referencia_valor_dominio": "731155",
      "nome_resumido_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (ELEVADORES E EQUIPAMENTO",
      "nome_completo_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (ELEVADORES E EQUIPAMENTOS SIMILARES)",
      "descricao_conceito_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (ELEVADORES E EQUIPAMENTOS SIMILARES)"
    },
    {
      "codigo_valor_dominio": 3097,
      "codigo_referencia_valor_dominio": "731160",
      "nome_resumido_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (TRANSFORMADORES)",
      "nome_completo_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (TRANSFORMADORES)",
      "descricao_conceito_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (TRANSFORMADORES)"
    },
    {
      "codigo_valor_dominio": 3098,
      "codigo_referencia_valor_dominio": "731120",
      "nome_resumido_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (APARELHOS ELETRODOMESTIC",
      "nome_completo_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (APARELHOS ELETRODOMESTICOS)",
      "descricao_conceito_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (APARELHOS ELETRODOMESTICOS)"
    },
    {
      "codigo_valor_dominio": 3099,
      "codigo_referencia_valor_dominio": "731145",
      "nome_resumido_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS (MAQUINAS INDUSTRIAIS)",
      "nome_completo_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS (MAQUINAS INDUSTRIAIS)",
      "descricao_conceito_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS (MAQUINAS INDUSTRIAIS)"
    },
    {
      "codigo_valor_dominio": 3100,
      "codigo_referencia_valor_dominio": "725605",
      "nome_resumido_valor_dominio": "MONTADOR DE ESTRUTURAS DE AERONAVES",
      "nome_completo_valor_dominio": "MONTADOR DE ESTRUTURAS DE AERONAVES",
      "descricao_conceito_valor_dominio": "MONTADOR DE ESTRUTURAS DE AERONAVES"
    },
    {
      "codigo_valor_dominio": 3101,
      "codigo_referencia_valor_dominio": "731105",
      "nome_resumido_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS (APARELHOS MEDICOS)",
      "nome_completo_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS (APARELHOS MEDICOS)",
      "descricao_conceito_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS (APARELHOS MEDICOS)"
    },
    {
      "codigo_valor_dominio": 3102,
      "codigo_referencia_valor_dominio": "731115",
      "nome_resumido_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (INSTRUMENTOS DE MEDICAO)",
      "nome_completo_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (INSTRUMENTOS DE MEDICAO)",
      "descricao_conceito_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRICOS (INSTRUMENTOS DE MEDICAO)"
    },
    {
      "codigo_valor_dominio": 3103,
      "codigo_referencia_valor_dominio": "731150",
      "nome_resumido_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS",
      "nome_completo_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS",
      "descricao_conceito_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS"
    },
    {
      "codigo_valor_dominio": 3104,
      "codigo_referencia_valor_dominio": "731165",
      "nome_resumido_valor_dominio": "BOBINADOR ELETRICISTA, A MAO",
      "nome_completo_valor_dominio": "BOBINADOR ELETRICISTA, A MAO",
      "descricao_conceito_valor_dominio": "BOBINADOR ELETRICISTA, A MAO"
    },
    {
      "codigo_valor_dominio": 3105,
      "codigo_referencia_valor_dominio": "731170",
      "nome_resumido_valor_dominio": "BOBINADOR ELETRICISTA, A MAQUINA",
      "nome_completo_valor_dominio": "BOBINADOR ELETRICISTA, A MAQUINA",
      "descricao_conceito_valor_dominio": "BOBINADOR ELETRICISTA, A MAQUINA"
    },
    {
      "codigo_valor_dominio": 3106,
      "codigo_referencia_valor_dominio": "731180",
      "nome_resumido_valor_dominio": "OPERADOR DE LINHA DE MONTAGEM (APARELHOS ELETRONICOS)",
      "nome_completo_valor_dominio": "OPERADOR DE LINHA DE MONTAGEM (APARELHOS ELETRONICOS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE LINHA DE MONTAGEM (APARELHOS ELETRONICOS)"
    },
    {
      "codigo_valor_dominio": 3107,
      "codigo_referencia_valor_dominio": "773320",
      "nome_resumido_valor_dominio": "OPERADOR DE LIXADEIRA (USINAGEM DE MADEIRA)",
      "nome_completo_valor_dominio": "OPERADOR DE LIXADEIRA (USINAGEM DE MADEIRA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE LIXADEIRA (USINAGEM DE MADEIRA)"
    },
    {
      "codigo_valor_dominio": 3108,
      "codigo_referencia_valor_dominio": "731140",
      "nome_resumido_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS (INSTALACOES DE SINALIZ",
      "nome_completo_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS (INSTALACOES DE SINALIZACAO)",
      "descricao_conceito_valor_dominio": "MONTADOR DE EQUIPAMENTOS ELETRONICOS (INSTALACOES DE SINALIZACAO)"
    },
    {
      "codigo_valor_dominio": 3109,
      "codigo_referencia_valor_dominio": "731310",
      "nome_resumido_valor_dominio": "INSTALADOR-REPARADOR DE EQUIPAMENTOS DE ENERGIA EM TELEFONIA",
      "nome_completo_valor_dominio": "INSTALADOR-REPARADOR DE EQUIPAMENTOS DE ENERGIA EM TELEFONIA",
      "descricao_conceito_valor_dominio": "INSTALADOR-REPARADOR DE EQUIPAMENTOS DE ENERGIA EM TELEFONIA"
    },
    {
      "codigo_valor_dominio": 3110,
      "codigo_referencia_valor_dominio": "731315",
      "nome_resumido_valor_dominio": "INSTALADOR-REPARADOR DE EQUIPAMENTOS DE TRANSMISSAO EM TELEF",
      "nome_completo_valor_dominio": "INSTALADOR-REPARADOR DE EQUIPAMENTOS DE TRANSMISSAO EM TELEFONIA",
      "descricao_conceito_valor_dominio": "INSTALADOR-REPARADOR DE EQUIPAMENTOS DE TRANSMISSAO EM TELEFONIA"
    },
    {
      "codigo_valor_dominio": 3111,
      "codigo_referencia_valor_dominio": "731320",
      "nome_resumido_valor_dominio": "INSTALADOR-REPARADOR DE LINHAS E APARELHOS DE TELECOMUNICACO",
      "nome_completo_valor_dominio": "INSTALADOR-REPARADOR DE LINHAS E APARELHOS DE TELECOMUNICACOES",
      "descricao_conceito_valor_dominio": "INSTALADOR-REPARADOR DE LINHAS E APARELHOS DE TELECOMUNICACOES"
    },
    {
      "codigo_valor_dominio": 3112,
      "codigo_referencia_valor_dominio": "731325",
      "nome_resumido_valor_dominio": "INSTALADOR-REPARADOR DE REDES E CABOS TELEFONICOS",
      "nome_completo_valor_dominio": "INSTALADOR-REPARADOR DE REDES E CABOS TELEFONICOS",
      "descricao_conceito_valor_dominio": "INSTALADOR-REPARADOR DE REDES E CABOS TELEFONICOS"
    },
    {
      "codigo_valor_dominio": 3113,
      "codigo_referencia_valor_dominio": "732130",
      "nome_resumido_valor_dominio": "INSTALADOR-REPARADOR DE REDES TELEFONICAS E DE COMUNICACAO D",
      "nome_completo_valor_dominio": "INSTALADOR-REPARADOR DE REDES TELEFONICAS E DE COMUNICACAO DE DADOS",
      "descricao_conceito_valor_dominio": "INSTALADOR-REPARADOR DE REDES TELEFONICAS E DE COMUNICACAO DE DADOS"
    },
    {
      "codigo_valor_dominio": 3114,
      "codigo_referencia_valor_dominio": "954205",
      "nome_resumido_valor_dominio": "REPARADOR DE APARELHOS ELETRODOMESTICOS (EXCETO IMAGEM E SOM",
      "nome_completo_valor_dominio": "REPARADOR DE APARELHOS ELETRODOMESTICOS (EXCETO IMAGEM E SOM)",
      "descricao_conceito_valor_dominio": "REPARADOR DE APARELHOS ELETRODOMESTICOS (EXCETO IMAGEM E SOM)"
    },
    {
      "codigo_valor_dominio": 3115,
      "codigo_referencia_valor_dominio": "951105",
      "nome_resumido_valor_dominio": "ELETRICISTA DE MANUTENCAO ELETROELETRONICA",
      "nome_completo_valor_dominio": "ELETRICISTA DE MANUTENCAO ELETROELETRONICA",
      "descricao_conceito_valor_dominio": "ELETRICISTA DE MANUTENCAO ELETROELETRONICA"
    },
    {
      "codigo_valor_dominio": 3116,
      "codigo_referencia_valor_dominio": "421120",
      "nome_resumido_valor_dominio": "EMISSOR DE PASSAGENS",
      "nome_completo_valor_dominio": "EMISSOR DE PASSAGENS",
      "descricao_conceito_valor_dominio": "EMISSOR DE PASSAGENS"
    },
    {
      "codigo_valor_dominio": 3117,
      "codigo_referencia_valor_dominio": "823210",
      "nome_resumido_valor_dominio": "EXTRUSOR DE FIOS OU FIBRAS DE VIDRO",
      "nome_completo_valor_dominio": "EXTRUSOR DE FIOS OU FIBRAS DE VIDRO",
      "descricao_conceito_valor_dominio": "EXTRUSOR DE FIOS OU FIBRAS DE VIDRO"
    },
    {
      "codigo_valor_dominio": 3118,
      "codigo_referencia_valor_dominio": "715725",
      "nome_resumido_valor_dominio": "INSTALADOR DE MATERIAL ISOLANTE, A MAO (EDIFICACOES)",
      "nome_completo_valor_dominio": "INSTALADOR DE MATERIAL ISOLANTE, A MAO (EDIFICACOES)",
      "descricao_conceito_valor_dominio": "INSTALADOR DE MATERIAL ISOLANTE, A MAO (EDIFICACOES)"
    },
    {
      "codigo_valor_dominio": 3119,
      "codigo_referencia_valor_dominio": "731305",
      "nome_resumido_valor_dominio": "INSTALADOR-REPARADOR DE EQUIPAMENTOS DE COMUTACAO EM TELEFON",
      "nome_completo_valor_dominio": "INSTALADOR-REPARADOR DE EQUIPAMENTOS DE COMUTACAO EM TELEFONIA",
      "descricao_conceito_valor_dominio": "INSTALADOR-REPARADOR DE EQUIPAMENTOS DE COMUTACAO EM TELEFONIA"
    },
    {
      "codigo_valor_dominio": 3120,
      "codigo_referencia_valor_dominio": "322225",
      "nome_resumido_valor_dominio": "INSTRUMENTADOR CIRURGICO",
      "nome_completo_valor_dominio": "INSTRUMENTADOR CIRURGICO",
      "descricao_conceito_valor_dominio": "INSTRUMENTADOR CIRURGICO"
    },
    {
      "codigo_valor_dominio": 3121,
      "codigo_referencia_valor_dominio": "516320",
      "nome_resumido_valor_dominio": "LIMPADOR A SECO, A MAQUINA",
      "nome_completo_valor_dominio": "LIMPADOR A SECO, A MAQUINA",
      "descricao_conceito_valor_dominio": "LIMPADOR A SECO, A MAQUINA"
    },
    {
      "codigo_valor_dominio": 3122,
      "codigo_referencia_valor_dominio": "760605",
      "nome_resumido_valor_dominio": "SUPERVISOR DAS ARTES GRAFICAS (INDUSTRIA EDITORIAL E GRAFICA",
      "nome_completo_valor_dominio": "SUPERVISOR DAS ARTES GRAFICAS (INDUSTRIA EDITORIAL E GRAFICA)",
      "descricao_conceito_valor_dominio": "SUPERVISOR DAS ARTES GRAFICAS (INDUSTRIA EDITORIAL E GRAFICA)"
    },
    {
      "codigo_valor_dominio": 3123,
      "codigo_referencia_valor_dominio": "820205",
      "nome_resumido_valor_dominio": "SUPERVISOR DE FABRICACAO DE PRODUTOS CERAMICOS, PORCELANATOS",
      "nome_completo_valor_dominio": "SUPERVISOR DE FABRICACAO DE PRODUTOS CERAMICOS, PORCELANATOS E AFINS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE FABRICACAO DE PRODUTOS CERAMICOS, PORCELANATOS E AFINS"
    },
    {
      "codigo_valor_dominio": 3124,
      "codigo_referencia_valor_dominio": "741105",
      "nome_resumido_valor_dominio": "AJUSTADOR DE INSTRUMENTOS DE PRECISAO",
      "nome_completo_valor_dominio": "AJUSTADOR DE INSTRUMENTOS DE PRECISAO",
      "descricao_conceito_valor_dominio": "AJUSTADOR DE INSTRUMENTOS DE PRECISAO"
    },
    {
      "codigo_valor_dominio": 3125,
      "codigo_referencia_valor_dominio": "741115",
      "nome_resumido_valor_dominio": "MONTADOR DE INSTRUMENTOS DE PRECISAO",
      "nome_completo_valor_dominio": "MONTADOR DE INSTRUMENTOS DE PRECISAO",
      "descricao_conceito_valor_dominio": "MONTADOR DE INSTRUMENTOS DE PRECISAO"
    },
    {
      "codigo_valor_dominio": 3126,
      "codigo_referencia_valor_dominio": "725205",
      "nome_resumido_valor_dominio": "MONTADOR DE MAQUINAS",
      "nome_completo_valor_dominio": "MONTADOR DE MAQUINAS",
      "descricao_conceito_valor_dominio": "MONTADOR DE MAQUINAS"
    },
    {
      "codigo_valor_dominio": 3127,
      "codigo_referencia_valor_dominio": "741125",
      "nome_resumido_valor_dominio": "RELOJOEIRO (REPARACAO)",
      "nome_completo_valor_dominio": "RELOJOEIRO (REPARACAO)",
      "descricao_conceito_valor_dominio": "RELOJOEIRO (REPARACAO)"
    },
    {
      "codigo_valor_dominio": 3128,
      "codigo_referencia_valor_dominio": "761363",
      "nome_resumido_valor_dominio": "REMETEDOR DE FIOS",
      "nome_completo_valor_dominio": "REMETEDOR DE FIOS",
      "descricao_conceito_valor_dominio": "REMETEDOR DE FIOS"
    },
    {
      "codigo_valor_dominio": 3129,
      "codigo_referencia_valor_dominio": "742105",
      "nome_resumido_valor_dominio": "AFINADOR DE INSTRUMENTOS MUSICAIS",
      "nome_completo_valor_dominio": "AFINADOR DE INSTRUMENTOS MUSICAIS",
      "descricao_conceito_valor_dominio": "AFINADOR DE INSTRUMENTOS MUSICAIS"
    },
    {
      "codigo_valor_dominio": 3130,
      "codigo_referencia_valor_dominio": "742110",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE ACORDEAO",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE ACORDEAO",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE ACORDEAO"
    },
    {
      "codigo_valor_dominio": 3131,
      "codigo_referencia_valor_dominio": "742120",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE INSTRUMENTOS DE PERCUSSAO (PELE, COURO OU",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE INSTRUMENTOS DE PERCUSSAO (PELE, COURO OU PLASTICO)",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE INSTRUMENTOS DE PERCUSSAO (PELE, COURO OU PLASTICO)"
    },
    {
      "codigo_valor_dominio": 3132,
      "codigo_referencia_valor_dominio": "742125",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE INSTRUMENTOS DE SOPRO (MADEIRA)",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE INSTRUMENTOS DE SOPRO (MADEIRA)",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE INSTRUMENTOS DE SOPRO (MADEIRA)"
    },
    {
      "codigo_valor_dominio": 3133,
      "codigo_referencia_valor_dominio": "742130",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE INSTRUMENTOS DE SOPRO (METAL)",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE INSTRUMENTOS DE SOPRO (METAL)",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE INSTRUMENTOS DE SOPRO (METAL)"
    },
    {
      "codigo_valor_dominio": 3134,
      "codigo_referencia_valor_dominio": "776420",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE MOVEIS DE VIME, JUNCO E BAMBU",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE MOVEIS DE VIME, JUNCO E BAMBU",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE MOVEIS DE VIME, JUNCO E BAMBU"
    },
    {
      "codigo_valor_dominio": 3135,
      "codigo_referencia_valor_dominio": "742140",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE PIANO",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE PIANO",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE PIANO"
    },
    {
      "codigo_valor_dominio": 3136,
      "codigo_referencia_valor_dominio": "811715",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE PNEUMATICOS",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE PNEUMATICOS",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE PNEUMATICOS"
    },
    {
      "codigo_valor_dominio": 3137,
      "codigo_referencia_valor_dominio": "510205",
      "nome_resumido_valor_dominio": "SUPERVISOR DE LAVANDERIA",
      "nome_completo_valor_dominio": "SUPERVISOR DE LAVANDERIA",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE LAVANDERIA"
    },
    {
      "codigo_valor_dominio": 3138,
      "codigo_referencia_valor_dominio": "910205",
      "nome_resumido_valor_dominio": "SUPERVISOR DA MANUTENCAO E REPARACAO DE VEICULOS LEVES",
      "nome_completo_valor_dominio": "SUPERVISOR DA MANUTENCAO E REPARACAO DE VEICULOS LEVES",
      "descricao_conceito_valor_dominio": "SUPERVISOR DA MANUTENCAO E REPARACAO DE VEICULOS LEVES"
    },
    {
      "codigo_valor_dominio": 3139,
      "codigo_referencia_valor_dominio": "214425",
      "nome_resumido_valor_dominio": "ENGENHEIRO AERONAUTICO",
      "nome_completo_valor_dominio": "ENGENHEIRO AERONAUTICO",
      "descricao_conceito_valor_dominio": "ENGENHEIRO AERONAUTICO"
    },
    {
      "codigo_valor_dominio": 3140,
      "codigo_referencia_valor_dominio": "751015",
      "nome_resumido_valor_dominio": "JOALHEIRO (REPARACOES)",
      "nome_completo_valor_dominio": "JOALHEIRO (REPARACOES)",
      "descricao_conceito_valor_dominio": "JOALHEIRO (REPARACOES)"
    },
    {
      "codigo_valor_dominio": 3141,
      "codigo_referencia_valor_dominio": "377130",
      "nome_resumido_valor_dominio": "JOQUEI",
      "nome_completo_valor_dominio": "JOQUEI",
      "descricao_conceito_valor_dominio": "JOQUEI"
    },
    {
      "codigo_valor_dominio": 3142,
      "codigo_referencia_valor_dominio": "752230",
      "nome_resumido_valor_dominio": "LAPIDADOR DE VIDROS E CRISTAIS",
      "nome_completo_valor_dominio": "LAPIDADOR DE VIDROS E CRISTAIS",
      "descricao_conceito_valor_dominio": "LAPIDADOR DE VIDROS E CRISTAIS"
    },
    {
      "codigo_valor_dominio": 3143,
      "codigo_referencia_valor_dominio": "751105",
      "nome_resumido_valor_dominio": "BATE-FOLHA A MAQUINA",
      "nome_completo_valor_dominio": "BATE-FOLHA A MAQUINA",
      "descricao_conceito_valor_dominio": "BATE-FOLHA A MAQUINA"
    },
    {
      "codigo_valor_dominio": 3144,
      "codigo_referencia_valor_dominio": "722205",
      "nome_resumido_valor_dominio": "FUNDIDOR DE METAIS",
      "nome_completo_valor_dominio": "FUNDIDOR DE METAIS",
      "descricao_conceito_valor_dominio": "FUNDIDOR DE METAIS"
    },
    {
      "codigo_valor_dominio": 3145,
      "codigo_referencia_valor_dominio": "712210",
      "nome_resumido_valor_dominio": "GRAVADOR DE INSCRICOES EM PEDRA",
      "nome_completo_valor_dominio": "GRAVADOR DE INSCRICOES EM PEDRA",
      "descricao_conceito_valor_dominio": "GRAVADOR DE INSCRICOES EM PEDRA"
    },
    {
      "codigo_valor_dominio": 3146,
      "codigo_referencia_valor_dominio": "811745",
      "nome_resumido_valor_dominio": "LAMINADOR DE PLASTICO",
      "nome_completo_valor_dominio": "LAMINADOR DE PLASTICO",
      "descricao_conceito_valor_dominio": "LAMINADOR DE PLASTICO"
    },
    {
      "codigo_valor_dominio": 3147,
      "codigo_referencia_valor_dominio": "352415",
      "nome_resumido_valor_dominio": "OUVIDOR (OMBUDSMAN) DO MEIO DE COMUNICACAO",
      "nome_completo_valor_dominio": "OUVIDOR (OMBUDSMAN) DO MEIO DE COMUNICACAO",
      "descricao_conceito_valor_dominio": "OUVIDOR (OMBUDSMAN) DO MEIO DE COMUNICACAO"
    },
    {
      "codigo_valor_dominio": 3148,
      "codigo_referencia_valor_dominio": "811775",
      "nome_resumido_valor_dominio": "TREFILADOR DE BORRACHA",
      "nome_completo_valor_dominio": "TREFILADOR DE BORRACHA",
      "descricao_conceito_valor_dominio": "TREFILADOR DE BORRACHA"
    },
    {
      "codigo_valor_dominio": 3149,
      "codigo_referencia_valor_dominio": "752105",
      "nome_resumido_valor_dominio": "ARTESAO MODELADOR (VIDROS)",
      "nome_completo_valor_dominio": "ARTESAO MODELADOR (VIDROS)",
      "descricao_conceito_valor_dominio": "ARTESAO MODELADOR (VIDROS)"
    },
    {
      "codigo_valor_dominio": 3150,
      "codigo_referencia_valor_dominio": "823230",
      "nome_resumido_valor_dominio": "MOLDADOR DE ABRASIVOS NA FABRICACAO DE CERAMICA, VIDRO E POR",
      "nome_completo_valor_dominio": "MOLDADOR DE ABRASIVOS NA FABRICACAO DE CERAMICA, VIDRO E PORCELANA",
      "descricao_conceito_valor_dominio": "MOLDADOR DE ABRASIVOS NA FABRICACAO DE CERAMICA, VIDRO E PORCELANA"
    },
    {
      "codigo_valor_dominio": 3151,
      "codigo_referencia_valor_dominio": "242240",
      "nome_resumido_valor_dominio": "SUBPROCURADOR DE JUSTICA MILITAR",
      "nome_completo_valor_dominio": "SUBPROCURADOR DE JUSTICA MILITAR",
      "descricao_conceito_valor_dominio": "SUBPROCURADOR DE JUSTICA MILITAR"
    },
    {
      "codigo_valor_dominio": 3152,
      "codigo_referencia_valor_dominio": "376255",
      "nome_resumido_valor_dominio": "TRAPEZISTA",
      "nome_completo_valor_dominio": "TRAPEZISTA",
      "descricao_conceito_valor_dominio": "TRAPEZISTA"
    },
    {
      "codigo_valor_dominio": 3153,
      "codigo_referencia_valor_dominio": "752205",
      "nome_resumido_valor_dominio": "APLICADOR SERIGRAFICO EM VIDROS",
      "nome_completo_valor_dominio": "APLICADOR SERIGRAFICO EM VIDROS",
      "descricao_conceito_valor_dominio": "APLICADOR SERIGRAFICO EM VIDROS"
    },
    {
      "codigo_valor_dominio": 3154,
      "codigo_referencia_valor_dominio": "768315",
      "nome_resumido_valor_dominio": "COSTURADOR DE ARTEFATOS DE COURO, A MAO (EXCETO ROUPAS E CAL",
      "nome_completo_valor_dominio": "COSTURADOR DE ARTEFATOS DE COURO, A MAO (EXCETO ROUPAS E CALCADOS)",
      "descricao_conceito_valor_dominio": "COSTURADOR DE ARTEFATOS DE COURO, A MAO (EXCETO ROUPAS E CALCADOS)"
    },
    {
      "codigo_valor_dominio": 3155,
      "codigo_referencia_valor_dominio": "752220",
      "nome_resumido_valor_dominio": "GRAVADOR DE VIDRO A ESMERIL",
      "nome_completo_valor_dominio": "GRAVADOR DE VIDRO A ESMERIL",
      "descricao_conceito_valor_dominio": "GRAVADOR DE VIDRO A ESMERIL"
    },
    {
      "codigo_valor_dominio": 3156,
      "codigo_referencia_valor_dominio": "752225",
      "nome_resumido_valor_dominio": "GRAVADOR DE VIDRO A JATO DE AREIA",
      "nome_completo_valor_dominio": "GRAVADOR DE VIDRO A JATO DE AREIA",
      "descricao_conceito_valor_dominio": "GRAVADOR DE VIDRO A JATO DE AREIA"
    },
    {
      "codigo_valor_dominio": 3157,
      "codigo_referencia_valor_dominio": "768705",
      "nome_resumido_valor_dominio": "GRAVADOR, A MAO (ENCADERNACAO)",
      "nome_completo_valor_dominio": "GRAVADOR, A MAO (ENCADERNACAO)",
      "descricao_conceito_valor_dominio": "GRAVADOR, A MAO (ENCADERNACAO)"
    },
    {
      "codigo_valor_dominio": 3158,
      "codigo_referencia_valor_dominio": "516305",
      "nome_resumido_valor_dominio": "LAVADEIRO, EM GERAL",
      "nome_completo_valor_dominio": "LAVADEIRO, EM GERAL",
      "descricao_conceito_valor_dominio": "LAVADEIRO, EM GERAL"
    },
    {
      "codigo_valor_dominio": 3159,
      "codigo_referencia_valor_dominio": "513615",
      "nome_resumido_valor_dominio": "SUSHIMAN",
      "nome_completo_valor_dominio": "SUSHIMAN",
      "descricao_conceito_valor_dominio": "SUSHIMAN"
    },
    {
      "codigo_valor_dominio": 3160,
      "codigo_referencia_valor_dominio": "752305",
      "nome_resumido_valor_dominio": "CERAMISTA",
      "nome_completo_valor_dominio": "CERAMISTA",
      "descricao_conceito_valor_dominio": "CERAMISTA"
    },
    {
      "codigo_valor_dominio": 3161,
      "codigo_referencia_valor_dominio": "752310",
      "nome_resumido_valor_dominio": "CERAMISTA (TORNO DE PEDAL E MOTOR)",
      "nome_completo_valor_dominio": "CERAMISTA (TORNO DE PEDAL E MOTOR)",
      "descricao_conceito_valor_dominio": "CERAMISTA (TORNO DE PEDAL E MOTOR)"
    },
    {
      "codigo_valor_dominio": 3162,
      "codigo_referencia_valor_dominio": "752315",
      "nome_resumido_valor_dominio": "CERAMISTA (TORNO SEMI-AUTOMATICO)",
      "nome_completo_valor_dominio": "CERAMISTA (TORNO SEMI-AUTOMATICO)",
      "descricao_conceito_valor_dominio": "CERAMISTA (TORNO SEMI-AUTOMATICO)"
    },
    {
      "codigo_valor_dominio": 3163,
      "codigo_referencia_valor_dominio": "752320",
      "nome_resumido_valor_dominio": "CERAMISTA MODELADOR",
      "nome_completo_valor_dominio": "CERAMISTA MODELADOR",
      "descricao_conceito_valor_dominio": "CERAMISTA MODELADOR"
    },
    {
      "codigo_valor_dominio": 3164,
      "codigo_referencia_valor_dominio": "752325",
      "nome_resumido_valor_dominio": "CERAMISTA MOLDADOR",
      "nome_completo_valor_dominio": "CERAMISTA MOLDADOR",
      "descricao_conceito_valor_dominio": "CERAMISTA MOLDADOR"
    },
    {
      "codigo_valor_dominio": 3165,
      "codigo_referencia_valor_dominio": "752330",
      "nome_resumido_valor_dominio": "CERAMISTA PRENSADOR",
      "nome_completo_valor_dominio": "CERAMISTA PRENSADOR",
      "descricao_conceito_valor_dominio": "CERAMISTA PRENSADOR"
    },
    {
      "codigo_valor_dominio": 3166,
      "codigo_referencia_valor_dominio": "375120",
      "nome_resumido_valor_dominio": "DECORADOR DE EVENTOS",
      "nome_completo_valor_dominio": "DECORADOR DE EVENTOS",
      "descricao_conceito_valor_dominio": "DECORADOR DE EVENTOS"
    },
    {
      "codigo_valor_dominio": 3167,
      "codigo_referencia_valor_dominio": "752415",
      "nome_resumido_valor_dominio": "DECORADOR DE VIDRO A PINCEL",
      "nome_completo_valor_dominio": "DECORADOR DE VIDRO A PINCEL",
      "descricao_conceito_valor_dominio": "DECORADOR DE VIDRO A PINCEL"
    },
    {
      "codigo_valor_dominio": 3168,
      "codigo_referencia_valor_dominio": "242405",
      "nome_resumido_valor_dominio": "DEFENSOR PUBLICO",
      "nome_completo_valor_dominio": "DEFENSOR PUBLICO",
      "descricao_conceito_valor_dominio": "DEFENSOR PUBLICO"
    },
    {
      "codigo_valor_dominio": 3169,
      "codigo_referencia_valor_dominio": "752425",
      "nome_resumido_valor_dominio": "OPERADOR DE ESPELHAMENTO",
      "nome_completo_valor_dominio": "OPERADOR DE ESPELHAMENTO",
      "descricao_conceito_valor_dominio": "OPERADOR DE ESPELHAMENTO"
    },
    {
      "codigo_valor_dominio": 3170,
      "codigo_referencia_valor_dominio": "712125",
      "nome_resumido_valor_dominio": "OPERADOR DE ESPESSADOR",
      "nome_completo_valor_dominio": "OPERADOR DE ESPESSADOR",
      "descricao_conceito_valor_dominio": "OPERADOR DE ESPESSADOR"
    },
    {
      "codigo_valor_dominio": 3171,
      "codigo_referencia_valor_dominio": "723315",
      "nome_resumido_valor_dominio": "PINTOR DE ESTRUTURAS METALICAS",
      "nome_completo_valor_dominio": "PINTOR DE ESTRUTURAS METALICAS",
      "descricao_conceito_valor_dominio": "PINTOR DE ESTRUTURAS METALICAS"
    },
    {
      "codigo_valor_dominio": 3172,
      "codigo_referencia_valor_dominio": "341205",
      "nome_resumido_valor_dominio": "CONTRAMESTRE DE CABOTAGEM",
      "nome_completo_valor_dominio": "CONTRAMESTRE DE CABOTAGEM",
      "descricao_conceito_valor_dominio": "CONTRAMESTRE DE CABOTAGEM"
    },
    {
      "codigo_valor_dominio": 3173,
      "codigo_referencia_valor_dominio": "760115",
      "nome_resumido_valor_dominio": "CONTRAMESTRE DE MALHARIA (INDUSTRIA TEXTIL)",
      "nome_completo_valor_dominio": "CONTRAMESTRE DE MALHARIA (INDUSTRIA TEXTIL)",
      "descricao_conceito_valor_dominio": "CONTRAMESTRE DE MALHARIA (INDUSTRIA TEXTIL)"
    },
    {
      "codigo_valor_dominio": 3174,
      "codigo_referencia_valor_dominio": "760120",
      "nome_resumido_valor_dominio": "CONTRAMESTRE DE TECELAGEM (INDUSTRIA TEXTIL)",
      "nome_completo_valor_dominio": "CONTRAMESTRE DE TECELAGEM (INDUSTRIA TEXTIL)",
      "descricao_conceito_valor_dominio": "CONTRAMESTRE DE TECELAGEM (INDUSTRIA TEXTIL)"
    },
    {
      "codigo_valor_dominio": 3175,
      "codigo_referencia_valor_dominio": "519910",
      "nome_resumido_valor_dominio": "CONTROLADOR DE ENTRADA E SAIDA",
      "nome_completo_valor_dominio": "CONTROLADOR DE ENTRADA E SAIDA",
      "descricao_conceito_valor_dominio": "CONTROLADOR DE ENTRADA E SAIDA"
    },
    {
      "codigo_valor_dominio": 3176,
      "codigo_referencia_valor_dominio": "770110",
      "nome_resumido_valor_dominio": "MESTRE CARPINTEIRO",
      "nome_completo_valor_dominio": "MESTRE CARPINTEIRO",
      "descricao_conceito_valor_dominio": "MESTRE CARPINTEIRO"
    },
    {
      "codigo_valor_dominio": 3177,
      "codigo_referencia_valor_dominio": "412120",
      "nome_resumido_valor_dominio": "SUPERVISOR DE DIGITACAO E OPERACAO",
      "nome_completo_valor_dominio": "SUPERVISOR DE DIGITACAO E OPERACAO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE DIGITACAO E OPERACAO"
    },
    {
      "codigo_valor_dominio": 3178,
      "codigo_referencia_valor_dominio": "760310",
      "nome_resumido_valor_dominio": "ENCARREGADO DE COSTURA NA CONFECCAO DO VESTUARIO",
      "nome_completo_valor_dominio": "ENCARREGADO DE COSTURA NA CONFECCAO DO VESTUARIO",
      "descricao_conceito_valor_dominio": "ENCARREGADO DE COSTURA NA CONFECCAO DO VESTUARIO"
    },
    {
      "codigo_valor_dominio": 3179,
      "codigo_referencia_valor_dominio": "992210",
      "nome_resumido_valor_dominio": "ENCARREGADO DE EQUIPE DE CONSERVACAO DE VIAS PERMANENTES (EX",
      "nome_completo_valor_dominio": "ENCARREGADO DE EQUIPE DE CONSERVACAO DE VIAS PERMANENTES (EXCETO TRILHOS)",
      "descricao_conceito_valor_dominio": "ENCARREGADO DE EQUIPE DE CONSERVACAO DE VIAS PERMANENTES (EXCETO TRILHOS)"
    },
    {
      "codigo_valor_dominio": 3180,
      "codigo_referencia_valor_dominio": "410105",
      "nome_resumido_valor_dominio": "SUPERVISOR ADMINISTRATIVO",
      "nome_completo_valor_dominio": "SUPERVISOR ADMINISTRATIVO",
      "descricao_conceito_valor_dominio": "SUPERVISOR ADMINISTRATIVO"
    },
    {
      "codigo_valor_dominio": 3181,
      "codigo_referencia_valor_dominio": "840110",
      "nome_resumido_valor_dominio": "SUPERVISOR DA INDUSTRIA DE BEBIDAS",
      "nome_completo_valor_dominio": "SUPERVISOR DA INDUSTRIA DE BEBIDAS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DA INDUSTRIA DE BEBIDAS"
    },
    {
      "codigo_valor_dominio": 3182,
      "codigo_referencia_valor_dominio": "410205",
      "nome_resumido_valor_dominio": "SUPERVISOR DE ALMOXARIFADO",
      "nome_completo_valor_dominio": "SUPERVISOR DE ALMOXARIFADO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE ALMOXARIFADO"
    },
    {
      "codigo_valor_dominio": 3183,
      "codigo_referencia_valor_dominio": "374310",
      "nome_resumido_valor_dominio": "OPERADOR-MANTENEDOR DE PROJETOR CINEMATOGRAFICO",
      "nome_completo_valor_dominio": "OPERADOR-MANTENEDOR DE PROJETOR CINEMATOGRAFICO",
      "descricao_conceito_valor_dominio": "OPERADOR-MANTENEDOR DE PROJETOR CINEMATOGRAFICO"
    },
    {
      "codigo_valor_dominio": 3184,
      "codigo_referencia_valor_dominio": "761105",
      "nome_resumido_valor_dominio": "CLASSIFICADOR DE FIBRAS TEXTEIS",
      "nome_completo_valor_dominio": "CLASSIFICADOR DE FIBRAS TEXTEIS",
      "descricao_conceito_valor_dominio": "CLASSIFICADOR DE FIBRAS TEXTEIS"
    },
    {
      "codigo_valor_dominio": 3185,
      "codigo_referencia_valor_dominio": "992120",
      "nome_resumido_valor_dominio": "LAVADOR DE PECAS",
      "nome_completo_valor_dominio": "LAVADOR DE PECAS",
      "descricao_conceito_valor_dominio": "LAVADOR DE PECAS"
    },
    {
      "codigo_valor_dominio": 3186,
      "codigo_referencia_valor_dominio": "766315",
      "nome_resumido_valor_dominio": "OPERADOR DE ACABAMENTO (INDUSTRIA GRAFICA)",
      "nome_completo_valor_dominio": "OPERADOR DE ACABAMENTO (INDUSTRIA GRAFICA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE ACABAMENTO (INDUSTRIA GRAFICA)"
    },
    {
      "codigo_valor_dominio": 3187,
      "codigo_referencia_valor_dominio": "761215",
      "nome_resumido_valor_dominio": "OPERADOR DE BOBINADEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE BOBINADEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE BOBINADEIRA"
    },
    {
      "codigo_valor_dominio": 3188,
      "codigo_referencia_valor_dominio": "821420",
      "nome_resumido_valor_dominio": "OPERADOR DE BOBINADEIRA DE TIRAS A QUENTE, NO ACABAMENTO DE",
      "nome_completo_valor_dominio": "OPERADOR DE BOBINADEIRA DE TIRAS A QUENTE, NO ACABAMENTO DE CHAPAS E METAIS",
      "descricao_conceito_valor_dominio": "OPERADOR DE BOBINADEIRA DE TIRAS A QUENTE, NO ACABAMENTO DE CHAPAS E METAIS"
    },
    {
      "codigo_valor_dominio": 3189,
      "codigo_referencia_valor_dominio": "711210",
      "nome_resumido_valor_dominio": "OPERADOR DE CARREGADEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE CARREGADEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE CARREGADEIRA"
    },
    {
      "codigo_valor_dominio": 3190,
      "codigo_referencia_valor_dominio": "832110",
      "nome_resumido_valor_dominio": "OPERADOR DE CORTADEIRA DE PAPEL",
      "nome_completo_valor_dominio": "OPERADOR DE CORTADEIRA DE PAPEL",
      "descricao_conceito_valor_dominio": "OPERADOR DE CORTADEIRA DE PAPEL"
    },
    {
      "codigo_valor_dominio": 3191,
      "codigo_referencia_valor_dominio": "811315",
      "nome_resumido_valor_dominio": "OPERADOR DE FILTRO DE SECAGEM (MINERACAO)",
      "nome_completo_valor_dominio": "OPERADOR DE FILTRO DE SECAGEM (MINERACAO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE FILTRO DE SECAGEM (MINERACAO)"
    },
    {
      "codigo_valor_dominio": 3192,
      "codigo_referencia_valor_dominio": "821305",
      "nome_resumido_valor_dominio": "OPERADOR DE LAMINADOR",
      "nome_completo_valor_dominio": "OPERADOR DE LAMINADOR",
      "descricao_conceito_valor_dominio": "OPERADOR DE LAMINADOR"
    },
    {
      "codigo_valor_dominio": 3193,
      "codigo_referencia_valor_dominio": "721415",
      "nome_resumido_valor_dominio": "OPERADOR DE MANDRILADORA COM COMANDO NUMERICO",
      "nome_completo_valor_dominio": "OPERADOR DE MANDRILADORA COM COMANDO NUMERICO",
      "descricao_conceito_valor_dominio": "OPERADOR DE MANDRILADORA COM COMANDO NUMERICO"
    },
    {
      "codigo_valor_dominio": 3194,
      "codigo_referencia_valor_dominio": "715135",
      "nome_resumido_valor_dominio": "OPERADOR DE PA CARREGADEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE PA CARREGADEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE PA CARREGADEIRA"
    },
    {
      "codigo_valor_dominio": 3195,
      "codigo_referencia_valor_dominio": "715140",
      "nome_resumido_valor_dominio": "OPERADOR DE PAVIMENTADORA (ASFALTO, CONCRETO E MATERIAIS SIM",
      "nome_completo_valor_dominio": "OPERADOR DE PAVIMENTADORA (ASFALTO, CONCRETO E MATERIAIS SIMILARES)",
      "descricao_conceito_valor_dominio": "OPERADOR DE PAVIMENTADORA (ASFALTO, CONCRETO E MATERIAIS SIMILARES)"
    },
    {
      "codigo_valor_dominio": 3196,
      "codigo_referencia_valor_dominio": "773335",
      "nome_resumido_valor_dominio": "OPERADOR DE PLAINA DESENGROSSADEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE PLAINA DESENGROSSADEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE PLAINA DESENGROSSADEIRA"
    },
    {
      "codigo_valor_dominio": 3197,
      "codigo_referencia_valor_dominio": "811010",
      "nome_resumido_valor_dominio": "OPERADOR DE SALA DE CONTROLE DE INSTALACOES QUIMICAS, PETROQ",
      "nome_completo_valor_dominio": "OPERADOR DE SALA DE CONTROLE DE INSTALACOES QUIMICAS, PETROQUIMICAS E AFINS",
      "descricao_conceito_valor_dominio": "OPERADOR DE SALA DE CONTROLE DE INSTALACOES QUIMICAS, PETROQUIMICAS E AFINS"
    },
    {
      "codigo_valor_dominio": 3198,
      "codigo_referencia_valor_dominio": "761306",
      "nome_resumido_valor_dominio": "TECELAO (RENDAS E BORDADOS)",
      "nome_completo_valor_dominio": "TECELAO (RENDAS E BORDADOS)",
      "descricao_conceito_valor_dominio": "TECELAO (RENDAS E BORDADOS)"
    },
    {
      "codigo_valor_dominio": 3199,
      "codigo_referencia_valor_dominio": "761309",
      "nome_resumido_valor_dominio": "TECELAO (TEAR AUTOMATICO)",
      "nome_completo_valor_dominio": "TECELAO (TEAR AUTOMATICO)",
      "descricao_conceito_valor_dominio": "TECELAO (TEAR AUTOMATICO)"
    },
    {
      "codigo_valor_dominio": 3200,
      "codigo_referencia_valor_dominio": "761312",
      "nome_resumido_valor_dominio": "TECELAO (TEAR JACQUARD)",
      "nome_completo_valor_dominio": "TECELAO (TEAR JACQUARD)",
      "descricao_conceito_valor_dominio": "TECELAO (TEAR JACQUARD)"
    },
    {
      "codigo_valor_dominio": 3201,
      "codigo_referencia_valor_dominio": "768105",
      "nome_resumido_valor_dominio": "TECELAO (TEAR MANUAL)",
      "nome_completo_valor_dominio": "TECELAO (TEAR MANUAL)",
      "descricao_conceito_valor_dominio": "TECELAO (TEAR MANUAL)"
    },
    {
      "codigo_valor_dominio": 3202,
      "codigo_referencia_valor_dominio": "761318",
      "nome_resumido_valor_dominio": "TECELAO (TEAR MECANICO DE XADREZ)",
      "nome_completo_valor_dominio": "TECELAO (TEAR MECANICO DE XADREZ)",
      "descricao_conceito_valor_dominio": "TECELAO (TEAR MECANICO DE XADREZ)"
    },
    {
      "codigo_valor_dominio": 3203,
      "codigo_referencia_valor_dominio": "761321",
      "nome_resumido_valor_dominio": "TECELAO (TEAR MECANICO LISO)",
      "nome_completo_valor_dominio": "TECELAO (TEAR MECANICO LISO)",
      "descricao_conceito_valor_dominio": "TECELAO (TEAR MECANICO LISO)"
    },
    {
      "codigo_valor_dominio": 3204,
      "codigo_referencia_valor_dominio": "761324",
      "nome_resumido_valor_dominio": "TECELAO (TEAR MECANICO, EXCETO JACQUARD)",
      "nome_completo_valor_dominio": "TECELAO (TEAR MECANICO, EXCETO JACQUARD)",
      "descricao_conceito_valor_dominio": "TECELAO (TEAR MECANICO, EXCETO JACQUARD)"
    },
    {
      "codigo_valor_dominio": 3205,
      "codigo_referencia_valor_dominio": "761330",
      "nome_resumido_valor_dominio": "TECELAO DE MALHAS (MAQUINA CIRCULAR)",
      "nome_completo_valor_dominio": "TECELAO DE MALHAS (MAQUINA CIRCULAR)",
      "descricao_conceito_valor_dominio": "TECELAO DE MALHAS (MAQUINA CIRCULAR)"
    },
    {
      "codigo_valor_dominio": 3206,
      "codigo_referencia_valor_dominio": "761339",
      "nome_resumido_valor_dominio": "TECELAO DE MEIAS (MAQUINA CIRCULAR)",
      "nome_completo_valor_dominio": "TECELAO DE MEIAS (MAQUINA CIRCULAR)",
      "descricao_conceito_valor_dominio": "TECELAO DE MEIAS (MAQUINA CIRCULAR)"
    },
    {
      "codigo_valor_dominio": 3207,
      "codigo_referencia_valor_dominio": "761333",
      "nome_resumido_valor_dominio": "TECELAO DE MALHAS (MAQUINA RETILINEA)",
      "nome_completo_valor_dominio": "TECELAO DE MALHAS (MAQUINA RETILINEA)",
      "descricao_conceito_valor_dominio": "TECELAO DE MALHAS (MAQUINA RETILINEA)"
    },
    {
      "codigo_valor_dominio": 3208,
      "codigo_referencia_valor_dominio": "761327",
      "nome_resumido_valor_dominio": "TECELAO DE MALHAS, A MAQUINA",
      "nome_completo_valor_dominio": "TECELAO DE MALHAS, A MAQUINA",
      "descricao_conceito_valor_dominio": "TECELAO DE MALHAS, A MAQUINA"
    },
    {
      "codigo_valor_dominio": 3209,
      "codigo_referencia_valor_dominio": "768110",
      "nome_resumido_valor_dominio": "TECELAO DE TAPETES, A MAO",
      "nome_completo_valor_dominio": "TECELAO DE TAPETES, A MAO",
      "descricao_conceito_valor_dominio": "TECELAO DE TAPETES, A MAO"
    },
    {
      "codigo_valor_dominio": 3210,
      "codigo_referencia_valor_dominio": "761342",
      "nome_resumido_valor_dominio": "TECELAO DE MEIAS (MAQUINA RETILINEA)",
      "nome_completo_valor_dominio": "TECELAO DE MEIAS (MAQUINA RETILINEA)",
      "descricao_conceito_valor_dominio": "TECELAO DE MEIAS (MAQUINA RETILINEA)"
    },
    {
      "codigo_valor_dominio": 3211,
      "codigo_referencia_valor_dominio": "761336",
      "nome_resumido_valor_dominio": "TECELAO DE MEIAS, A MAQUINA",
      "nome_completo_valor_dominio": "TECELAO DE MEIAS, A MAQUINA",
      "descricao_conceito_valor_dominio": "TECELAO DE MEIAS, A MAQUINA"
    },
    {
      "codigo_valor_dominio": 3212,
      "codigo_referencia_valor_dominio": "321105",
      "nome_resumido_valor_dominio": "TECNICO AGRICOLA",
      "nome_completo_valor_dominio": "TECNICO AGRICOLA",
      "descricao_conceito_valor_dominio": "TECNICO AGRICOLA"
    },
    {
      "codigo_valor_dominio": 3213,
      "codigo_referencia_valor_dominio": "773310",
      "nome_resumido_valor_dominio": "OPERADOR DE ENTALHADEIRA (USINAGEM DE MADEIRA)",
      "nome_completo_valor_dominio": "OPERADOR DE ENTALHADEIRA (USINAGEM DE MADEIRA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE ENTALHADEIRA (USINAGEM DE MADEIRA)"
    },
    {
      "codigo_valor_dominio": 3214,
      "codigo_referencia_valor_dominio": "862140",
      "nome_resumido_valor_dominio": "OPERADOR DE ESTACAO DE BOMBEAMENTO",
      "nome_completo_valor_dominio": "OPERADOR DE ESTACAO DE BOMBEAMENTO",
      "descricao_conceito_valor_dominio": "OPERADOR DE ESTACAO DE BOMBEAMENTO"
    },
    {
      "codigo_valor_dominio": 3215,
      "codigo_referencia_valor_dominio": "833120",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE CORTAR E DOBRAR PAPELAO",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE CORTAR E DOBRAR PAPELAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE CORTAR E DOBRAR PAPELAO"
    },
    {
      "codigo_valor_dominio": 3216,
      "codigo_referencia_valor_dominio": "721220",
      "nome_resumido_valor_dominio": "OPERADOR DE USINAGEM CONVENCIONAL POR ABRASAO",
      "nome_completo_valor_dominio": "OPERADOR DE USINAGEM CONVENCIONAL POR ABRASAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE USINAGEM CONVENCIONAL POR ABRASAO"
    },
    {
      "codigo_valor_dominio": 3217,
      "codigo_referencia_valor_dominio": "848205",
      "nome_resumido_valor_dominio": "PASTEURIZADOR",
      "nome_completo_valor_dominio": "PASTEURIZADOR",
      "descricao_conceito_valor_dominio": "PASTEURIZADOR"
    },
    {
      "codigo_valor_dominio": 3218,
      "codigo_referencia_valor_dominio": "731330",
      "nome_resumido_valor_dominio": "REPARADOR DE APARELHOS DE TELECOMUNICACOES EM LABORATORIO",
      "nome_completo_valor_dominio": "REPARADOR DE APARELHOS DE TELECOMUNICACOES EM LABORATORIO",
      "descricao_conceito_valor_dominio": "REPARADOR DE APARELHOS DE TELECOMUNICACOES EM LABORATORIO"
    },
    {
      "codigo_valor_dominio": 3219,
      "codigo_referencia_valor_dominio": "341120",
      "nome_resumido_valor_dominio": "PILOTO AGRICOLA",
      "nome_completo_valor_dominio": "PILOTO AGRICOLA",
      "descricao_conceito_valor_dominio": "PILOTO AGRICOLA"
    },
    {
      "codigo_valor_dominio": 3220,
      "codigo_referencia_valor_dominio": "761405",
      "nome_resumido_valor_dominio": "ALVEJADOR (TECIDOS)",
      "nome_completo_valor_dominio": "ALVEJADOR (TECIDOS)",
      "descricao_conceito_valor_dominio": "ALVEJADOR (TECIDOS)"
    },
    {
      "codigo_valor_dominio": 3221,
      "codigo_referencia_valor_dominio": "211205",
      "nome_resumido_valor_dominio": "ESTATISTICO",
      "nome_completo_valor_dominio": "ESTATISTICO",
      "descricao_conceito_valor_dominio": "ESTATISTICO"
    },
    {
      "codigo_valor_dominio": 3222,
      "codigo_referencia_valor_dominio": "811205",
      "nome_resumido_valor_dominio": "OPERADOR DE CALCINACAO (TRATAMENTO QUIMICO E AFINS)",
      "nome_completo_valor_dominio": "OPERADOR DE CALCINACAO (TRATAMENTO QUIMICO E AFINS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE CALCINACAO (TRATAMENTO QUIMICO E AFINS)"
    },
    {
      "codigo_valor_dominio": 3223,
      "codigo_referencia_valor_dominio": "413230",
      "nome_resumido_valor_dominio": "OPERADOR DE COBRANCA BANCARIA",
      "nome_completo_valor_dominio": "OPERADOR DE COBRANCA BANCARIA",
      "descricao_conceito_valor_dominio": "OPERADOR DE COBRANCA BANCARIA"
    },
    {
      "codigo_valor_dominio": 3224,
      "codigo_referencia_valor_dominio": "623315",
      "nome_resumido_valor_dominio": "OPERADOR DE INCUBADORA",
      "nome_completo_valor_dominio": "OPERADOR DE INCUBADORA",
      "descricao_conceito_valor_dominio": "OPERADOR DE INCUBADORA"
    },
    {
      "codigo_valor_dominio": 3225,
      "codigo_referencia_valor_dominio": "722330",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE MOLDAR AUTOMATIZADA",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE MOLDAR AUTOMATIZADA",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE MOLDAR AUTOMATIZADA"
    },
    {
      "codigo_valor_dominio": 3226,
      "codigo_referencia_valor_dominio": "811640",
      "nome_resumido_valor_dominio": "OPERADOR DE REATOR DE COQUE DE PETROLEO",
      "nome_completo_valor_dominio": "OPERADOR DE REATOR DE COQUE DE PETROLEO",
      "descricao_conceito_valor_dominio": "OPERADOR DE REATOR DE COQUE DE PETROLEO"
    },
    {
      "codigo_valor_dominio": 3227,
      "codigo_referencia_valor_dominio": "391205",
      "nome_resumido_valor_dominio": "INSPETOR DE QUALIDADE",
      "nome_completo_valor_dominio": "INSPETOR DE QUALIDADE",
      "descricao_conceito_valor_dominio": "INSPETOR DE QUALIDADE"
    },
    {
      "codigo_valor_dominio": 3228,
      "codigo_referencia_valor_dominio": "761815",
      "nome_resumido_valor_dominio": "REVISOR DE TECIDOS ACABADOS",
      "nome_completo_valor_dominio": "REVISOR DE TECIDOS ACABADOS",
      "descricao_conceito_valor_dominio": "REVISOR DE TECIDOS ACABADOS"
    },
    {
      "codigo_valor_dominio": 3229,
      "codigo_referencia_valor_dominio": "761820",
      "nome_resumido_valor_dominio": "REVISOR DE TECIDOS CRUS",
      "nome_completo_valor_dominio": "REVISOR DE TECIDOS CRUS",
      "descricao_conceito_valor_dominio": "REVISOR DE TECIDOS CRUS"
    },
    {
      "codigo_valor_dominio": 3230,
      "codigo_referencia_valor_dominio": "261140",
      "nome_resumido_valor_dominio": "REVISOR DE TEXTO",
      "nome_completo_valor_dominio": "REVISOR DE TEXTO",
      "descricao_conceito_valor_dominio": "REVISOR DE TEXTO"
    },
    {
      "codigo_valor_dominio": 3231,
      "codigo_referencia_valor_dominio": "622020",
      "nome_resumido_valor_dominio": "TRABALHADOR VOLANTE DA AGRICULTURA",
      "nome_completo_valor_dominio": "TRABALHADOR VOLANTE DA AGRICULTURA",
      "descricao_conceito_valor_dominio": "TRABALHADOR VOLANTE DA AGRICULTURA"
    },
    {
      "codigo_valor_dominio": 3232,
      "codigo_referencia_valor_dominio": "762105",
      "nome_resumido_valor_dominio": "CLASSIFICADOR DE PELES",
      "nome_completo_valor_dominio": "CLASSIFICADOR DE PELES",
      "descricao_conceito_valor_dominio": "CLASSIFICADOR DE PELES"
    },
    {
      "codigo_valor_dominio": 3233,
      "codigo_referencia_valor_dominio": "318010",
      "nome_resumido_valor_dominio": "DESENHISTA COPISTA",
      "nome_completo_valor_dominio": "DESENHISTA COPISTA",
      "descricao_conceito_valor_dominio": "DESENHISTA COPISTA"
    },
    {
      "codigo_valor_dominio": 3234,
      "codigo_referencia_valor_dominio": "722410",
      "nome_resumido_valor_dominio": "ESTIRADOR DE TUBOS DE METAL SEM COSTURA",
      "nome_completo_valor_dominio": "ESTIRADOR DE TUBOS DE METAL SEM COSTURA",
      "descricao_conceito_valor_dominio": "ESTIRADOR DE TUBOS DE METAL SEM COSTURA"
    },
    {
      "codigo_valor_dominio": 3235,
      "codigo_referencia_valor_dominio": "762310",
      "nome_resumido_valor_dominio": "FULONEIRO NO ACABAMENTO DE COUROS E PELES",
      "nome_completo_valor_dominio": "FULONEIRO NO ACABAMENTO DE COUROS E PELES",
      "descricao_conceito_valor_dominio": "FULONEIRO NO ACABAMENTO DE COUROS E PELES"
    },
    {
      "codigo_valor_dominio": 3236,
      "codigo_referencia_valor_dominio": "372210",
      "nome_resumido_valor_dominio": "RADIOTELEGRAFISTA",
      "nome_completo_valor_dominio": "RADIOTELEGRAFISTA",
      "descricao_conceito_valor_dominio": "RADIOTELEGRAFISTA"
    },
    {
      "codigo_valor_dominio": 3237,
      "codigo_referencia_valor_dominio": "376110",
      "nome_resumido_valor_dominio": "DANCARINO POPULAR",
      "nome_completo_valor_dominio": "DANCARINO POPULAR",
      "descricao_conceito_valor_dominio": "DANCARINO POPULAR"
    },
    {
      "codigo_valor_dominio": 3238,
      "codigo_referencia_valor_dominio": "762210",
      "nome_resumido_valor_dominio": "CLASSIFICADOR DE COUROS",
      "nome_completo_valor_dominio": "CLASSIFICADOR DE COUROS",
      "descricao_conceito_valor_dominio": "CLASSIFICADOR DE COUROS"
    },
    {
      "codigo_valor_dominio": 3239,
      "codigo_referencia_valor_dominio": "376230",
      "nome_resumido_valor_dominio": "EQUILIBRISTA",
      "nome_completo_valor_dominio": "EQUILIBRISTA",
      "descricao_conceito_valor_dominio": "EQUILIBRISTA"
    },
    {
      "codigo_valor_dominio": 3240,
      "codigo_referencia_valor_dominio": "821450",
      "nome_resumido_valor_dominio": "REBARBADOR DE METAL",
      "nome_completo_valor_dominio": "REBARBADOR DE METAL",
      "descricao_conceito_valor_dominio": "REBARBADOR DE METAL"
    },
    {
      "codigo_valor_dominio": 3241,
      "codigo_referencia_valor_dominio": "762115",
      "nome_resumido_valor_dominio": "ESTIRADOR DE COUROS E PELES (PREPARACAO)",
      "nome_completo_valor_dominio": "ESTIRADOR DE COUROS E PELES (PREPARACAO)",
      "descricao_conceito_valor_dominio": "ESTIRADOR DE COUROS E PELES (PREPARACAO)"
    },
    {
      "codigo_valor_dominio": 3242,
      "codigo_referencia_valor_dominio": "751110",
      "nome_resumido_valor_dominio": "FUNDIDOR (JOALHERIA E OURIVESARIA)",
      "nome_completo_valor_dominio": "FUNDIDOR (JOALHERIA E OURIVESARIA)",
      "descricao_conceito_valor_dominio": "FUNDIDOR (JOALHERIA E OURIVESARIA)"
    },
    {
      "codigo_valor_dominio": 3243,
      "codigo_referencia_valor_dominio": "421315",
      "nome_resumido_valor_dominio": "LOCALIZADOR (COBRADOR)",
      "nome_completo_valor_dominio": "LOCALIZADOR (COBRADOR)",
      "descricao_conceito_valor_dominio": "LOCALIZADOR (COBRADOR)"
    },
    {
      "codigo_valor_dominio": 3244,
      "codigo_referencia_valor_dominio": "914105",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE AERONAVES, EM GERAL",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE AERONAVES, EM GERAL",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE AERONAVES, EM GERAL"
    },
    {
      "codigo_valor_dominio": 3245,
      "codigo_referencia_valor_dominio": "991115",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINAS ESPECIAIS EM CONSERVACAO DE VIA PERMANE",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINAS ESPECIAIS EM CONSERVACAO DE VIA PERMANENTE (TRILHOS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINAS ESPECIAIS EM CONSERVACAO DE VIA PERMANENTE (TRILHOS)"
    },
    {
      "codigo_valor_dominio": 3246,
      "codigo_referencia_valor_dominio": "841464",
      "nome_resumido_valor_dominio": "PRENSADOR DE FRUTAS (EXCETO OLEAGINOSAS)",
      "nome_completo_valor_dominio": "PRENSADOR DE FRUTAS (EXCETO OLEAGINOSAS)",
      "descricao_conceito_valor_dominio": "PRENSADOR DE FRUTAS (EXCETO OLEAGINOSAS)"
    },
    {
      "codigo_valor_dominio": 3247,
      "codigo_referencia_valor_dominio": "213430",
      "nome_resumido_valor_dominio": "PALEONTOLOGO",
      "nome_completo_valor_dominio": "PALEONTOLOGO",
      "descricao_conceito_valor_dominio": "PALEONTOLOGO"
    },
    {
      "codigo_valor_dominio": 3248,
      "codigo_referencia_valor_dominio": "823125",
      "nome_resumido_valor_dominio": "PREPARADOR DE ESMALTES (CERAMICA)",
      "nome_completo_valor_dominio": "PREPARADOR DE ESMALTES (CERAMICA)",
      "descricao_conceito_valor_dominio": "PREPARADOR DE ESMALTES (CERAMICA)"
    },
    {
      "codigo_valor_dominio": 3249,
      "codigo_referencia_valor_dominio": "514215",
      "nome_resumido_valor_dominio": "VARREDOR DE RUA",
      "nome_completo_valor_dominio": "VARREDOR DE RUA",
      "descricao_conceito_valor_dominio": "VARREDOR DE RUA"
    },
    {
      "codigo_valor_dominio": 3250,
      "codigo_referencia_valor_dominio": "763005",
      "nome_resumido_valor_dominio": "ALFAIATE",
      "nome_completo_valor_dominio": "ALFAIATE",
      "descricao_conceito_valor_dominio": "ALFAIATE"
    },
    {
      "codigo_valor_dominio": 3251,
      "codigo_referencia_valor_dominio": "763015",
      "nome_resumido_valor_dominio": "COSTUREIRA DE REPARACAO DE ROUPAS",
      "nome_completo_valor_dominio": "COSTUREIRA DE REPARACAO DE ROUPAS",
      "descricao_conceito_valor_dominio": "COSTUREIRA DE REPARACAO DE ROUPAS"
    },
    {
      "codigo_valor_dominio": 3252,
      "codigo_referencia_valor_dominio": "763020",
      "nome_resumido_valor_dominio": "COSTUREIRO DE ROUPA DE COURO E PELE",
      "nome_completo_valor_dominio": "COSTUREIRO DE ROUPA DE COURO E PELE",
      "descricao_conceito_valor_dominio": "COSTUREIRO DE ROUPA DE COURO E PELE"
    },
    {
      "codigo_valor_dominio": 3253,
      "codigo_referencia_valor_dominio": "763205",
      "nome_resumido_valor_dominio": "COSTUREIRO DE ROUPAS DE COURO E PELE, A MAQUINA NA CONFECCAO",
      "nome_completo_valor_dominio": "COSTUREIRO DE ROUPAS DE COURO E PELE, A MAQUINA NA CONFECCAO EM SERIE",
      "descricao_conceito_valor_dominio": "COSTUREIRO DE ROUPAS DE COURO E PELE, A MAQUINA NA CONFECCAO EM SERIE"
    },
    {
      "codigo_valor_dominio": 3254,
      "codigo_referencia_valor_dominio": "763105",
      "nome_resumido_valor_dominio": "AUXILIAR DE CORTE (PREPARACAO DA CONFECCAO DE ROUPAS)",
      "nome_completo_valor_dominio": "AUXILIAR DE CORTE (PREPARACAO DA CONFECCAO DE ROUPAS)",
      "descricao_conceito_valor_dominio": "AUXILIAR DE CORTE (PREPARACAO DA CONFECCAO DE ROUPAS)"
    },
    {
      "codigo_valor_dominio": 3255,
      "codigo_referencia_valor_dominio": "764110",
      "nome_resumido_valor_dominio": "CORTADOR DE SOLAS E PALMILHAS, A MAQUINA",
      "nome_completo_valor_dominio": "CORTADOR DE SOLAS E PALMILHAS, A MAQUINA",
      "descricao_conceito_valor_dominio": "CORTADOR DE SOLAS E PALMILHAS, A MAQUINA"
    },
    {
      "codigo_valor_dominio": 3256,
      "codigo_referencia_valor_dominio": "751005",
      "nome_resumido_valor_dominio": "ENGASTADOR (JOIAS)",
      "nome_completo_valor_dominio": "ENGASTADOR (JOIAS)",
      "descricao_conceito_valor_dominio": "ENGASTADOR (JOIAS)"
    },
    {
      "codigo_valor_dominio": 3257,
      "codigo_referencia_valor_dominio": "514115",
      "nome_resumido_valor_dominio": "SACRISTAO",
      "nome_completo_valor_dominio": "SACRISTAO",
      "descricao_conceito_valor_dominio": "SACRISTAO"
    },
    {
      "codigo_valor_dominio": 3258,
      "codigo_referencia_valor_dominio": "763125",
      "nome_resumido_valor_dominio": "AJUDANTE DE CONFECCAO",
      "nome_completo_valor_dominio": "AJUDANTE DE CONFECCAO",
      "descricao_conceito_valor_dominio": "AJUDANTE DE CONFECCAO"
    },
    {
      "codigo_valor_dominio": 3259,
      "codigo_referencia_valor_dominio": "763210",
      "nome_resumido_valor_dominio": "COSTUREIRO NA CONFECCAO EM SERIE",
      "nome_completo_valor_dominio": "COSTUREIRO NA CONFECCAO EM SERIE",
      "descricao_conceito_valor_dominio": "COSTUREIRO NA CONFECCAO EM SERIE"
    },
    {
      "codigo_valor_dominio": 3260,
      "codigo_referencia_valor_dominio": "763215",
      "nome_resumido_valor_dominio": "COSTUREIRO, A MAQUINA NA CONFECCAO EM SERIE",
      "nome_completo_valor_dominio": "COSTUREIRO, A MAQUINA NA CONFECCAO EM SERIE",
      "descricao_conceito_valor_dominio": "COSTUREIRO, A MAQUINA NA CONFECCAO EM SERIE"
    },
    {
      "codigo_valor_dominio": 3261,
      "codigo_referencia_valor_dominio": "841408",
      "nome_resumido_valor_dominio": "COZINHADOR (CONSERVACAO DE ALIMENTOS)",
      "nome_completo_valor_dominio": "COZINHADOR (CONSERVACAO DE ALIMENTOS)",
      "descricao_conceito_valor_dominio": "COZINHADOR (CONSERVACAO DE ALIMENTOS)"
    },
    {
      "codigo_valor_dominio": 3262,
      "codigo_referencia_valor_dominio": "763305",
      "nome_resumido_valor_dominio": "ARREMATADEIRA",
      "nome_completo_valor_dominio": "ARREMATADEIRA",
      "descricao_conceito_valor_dominio": "ARREMATADEIRA"
    },
    {
      "codigo_valor_dominio": 3263,
      "codigo_referencia_valor_dominio": "763310",
      "nome_resumido_valor_dominio": "BORDADOR, A MAQUINA",
      "nome_completo_valor_dominio": "BORDADOR, A MAQUINA",
      "descricao_conceito_valor_dominio": "BORDADOR, A MAQUINA"
    },
    {
      "codigo_valor_dominio": 3264,
      "codigo_referencia_valor_dominio": "821415",
      "nome_resumido_valor_dominio": "MARCADOR DE PRODUTOS (SIDERURGICO E METALURGICO)",
      "nome_completo_valor_dominio": "MARCADOR DE PRODUTOS (SIDERURGICO E METALURGICO)",
      "descricao_conceito_valor_dominio": "MARCADOR DE PRODUTOS (SIDERURGICO E METALURGICO)"
    },
    {
      "codigo_valor_dominio": 3265,
      "codigo_referencia_valor_dominio": "724510",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE DOBRAR CHAPAS",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE DOBRAR CHAPAS",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE DOBRAR CHAPAS"
    },
    {
      "codigo_valor_dominio": 3266,
      "codigo_referencia_valor_dominio": "516325",
      "nome_resumido_valor_dominio": "PASSADOR DE ROUPAS EM GERAL",
      "nome_completo_valor_dominio": "PASSADOR DE ROUPAS EM GERAL",
      "descricao_conceito_valor_dominio": "PASSADOR DE ROUPAS EM GERAL"
    },
    {
      "codigo_valor_dominio": 3267,
      "codigo_referencia_valor_dominio": "762005",
      "nome_resumido_valor_dominio": "TRABALHADOR POLIVALENTE DO CURTIMENTO DE COUROS E PELES",
      "nome_completo_valor_dominio": "TRABALHADOR POLIVALENTE DO CURTIMENTO DE COUROS E PELES",
      "descricao_conceito_valor_dominio": "TRABALHADOR POLIVALENTE DO CURTIMENTO DE COUROS E PELES"
    },
    {
      "codigo_valor_dominio": 3268,
      "codigo_referencia_valor_dominio": "842220",
      "nome_resumido_valor_dominio": "CORTADOR DE CHARUTOS",
      "nome_completo_valor_dominio": "CORTADOR DE CHARUTOS",
      "descricao_conceito_valor_dominio": "CORTADOR DE CHARUTOS"
    },
    {
      "codigo_valor_dominio": 3269,
      "codigo_referencia_valor_dominio": "765110",
      "nome_resumido_valor_dominio": "CORTADOR DE TAPECARIA",
      "nome_completo_valor_dominio": "CORTADOR DE TAPECARIA",
      "descricao_conceito_valor_dominio": "CORTADOR DE TAPECARIA"
    },
    {
      "codigo_valor_dominio": 3270,
      "codigo_referencia_valor_dominio": "762340",
      "nome_resumido_valor_dominio": "PREPARADOR DE COUROS CURTIDOS",
      "nome_completo_valor_dominio": "PREPARADOR DE COUROS CURTIDOS",
      "descricao_conceito_valor_dominio": "PREPARADOR DE COUROS CURTIDOS"
    },
    {
      "codigo_valor_dominio": 3271,
      "codigo_referencia_valor_dominio": "821445",
      "nome_resumido_valor_dominio": "PREPARADOR DE SUCATA E APARAS",
      "nome_completo_valor_dominio": "PREPARADOR DE SUCATA E APARAS",
      "descricao_conceito_valor_dominio": "PREPARADOR DE SUCATA E APARAS"
    },
    {
      "codigo_valor_dominio": 3272,
      "codigo_referencia_valor_dominio": "763010",
      "nome_resumido_valor_dominio": "COSTUREIRA DE PECAS SOB ENCOMENDA",
      "nome_completo_valor_dominio": "COSTUREIRA DE PECAS SOB ENCOMENDA",
      "descricao_conceito_valor_dominio": "COSTUREIRA DE PECAS SOB ENCOMENDA"
    },
    {
      "codigo_valor_dominio": 3273,
      "codigo_referencia_valor_dominio": "725305",
      "nome_resumido_valor_dominio": "MONTADOR DE EQUIPAMENTO DE LEVANTAMENTO",
      "nome_completo_valor_dominio": "MONTADOR DE EQUIPAMENTO DE LEVANTAMENTO",
      "descricao_conceito_valor_dominio": "MONTADOR DE EQUIPAMENTO DE LEVANTAMENTO"
    },
    {
      "codigo_valor_dominio": 3274,
      "codigo_referencia_valor_dominio": "764305",
      "nome_resumido_valor_dominio": "ACABADOR DE CALCADOS",
      "nome_completo_valor_dominio": "ACABADOR DE CALCADOS",
      "descricao_conceito_valor_dominio": "ACABADOR DE CALCADOS"
    },
    {
      "codigo_valor_dominio": 3275,
      "codigo_referencia_valor_dominio": "765005",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE ARTEFATOS DE COURO (EXCETO SAPATOS)",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE ARTEFATOS DE COURO (EXCETO SAPATOS)",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE ARTEFATOS DE COURO (EXCETO SAPATOS)"
    },
    {
      "codigo_valor_dominio": 3276,
      "codigo_referencia_valor_dominio": "765010",
      "nome_resumido_valor_dominio": "CHAPELEIRO DE SENHORAS",
      "nome_completo_valor_dominio": "CHAPELEIRO DE SENHORAS",
      "descricao_conceito_valor_dominio": "CHAPELEIRO DE SENHORAS"
    },
    {
      "codigo_valor_dominio": 3277,
      "codigo_referencia_valor_dominio": "765015",
      "nome_resumido_valor_dominio": "BONELEIRO",
      "nome_completo_valor_dominio": "BONELEIRO",
      "descricao_conceito_valor_dominio": "BONELEIRO"
    },
    {
      "codigo_valor_dominio": 3278,
      "codigo_referencia_valor_dominio": "768310",
      "nome_resumido_valor_dominio": "CORTADOR DE CALCADOS, A MAO (EXCETO SOLAS)",
      "nome_completo_valor_dominio": "CORTADOR DE CALCADOS, A MAO (EXCETO SOLAS)",
      "descricao_conceito_valor_dominio": "CORTADOR DE CALCADOS, A MAO (EXCETO SOLAS)"
    },
    {
      "codigo_valor_dominio": 3279,
      "codigo_referencia_valor_dominio": "752210",
      "nome_resumido_valor_dominio": "CORTADOR DE VIDRO",
      "nome_completo_valor_dominio": "CORTADOR DE VIDRO",
      "descricao_conceito_valor_dominio": "CORTADOR DE VIDRO"
    },
    {
      "codigo_valor_dominio": 3280,
      "codigo_referencia_valor_dominio": "765205",
      "nome_resumido_valor_dominio": "COLCHOEIRO (CONFECCAO DE COLCHOES)",
      "nome_completo_valor_dominio": "COLCHOEIRO (CONFECCAO DE COLCHOES)",
      "descricao_conceito_valor_dominio": "COLCHOEIRO (CONFECCAO DE COLCHOES)"
    },
    {
      "codigo_valor_dominio": 3281,
      "codigo_referencia_valor_dominio": "765215",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE BRINQUEDOS DE PANO",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE BRINQUEDOS DE PANO",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE BRINQUEDOS DE PANO"
    },
    {
      "codigo_valor_dominio": 3282,
      "codigo_referencia_valor_dominio": "811725",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE VELAS POR IMERSAO",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE VELAS POR IMERSAO",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE VELAS POR IMERSAO"
    },
    {
      "codigo_valor_dominio": 3283,
      "codigo_referencia_valor_dominio": "765235",
      "nome_resumido_valor_dominio": "ESTOFADOR DE MOVEIS",
      "nome_completo_valor_dominio": "ESTOFADOR DE MOVEIS",
      "descricao_conceito_valor_dominio": "ESTOFADOR DE MOVEIS"
    },
    {
      "codigo_valor_dominio": 3284,
      "codigo_referencia_valor_dominio": "732115",
      "nome_resumido_valor_dominio": "EXAMINADOR DE CABOS, LINHAS ELETRICAS E TELEFONICAS",
      "nome_completo_valor_dominio": "EXAMINADOR DE CABOS, LINHAS ELETRICAS E TELEFONICAS",
      "descricao_conceito_valor_dominio": "EXAMINADOR DE CABOS, LINHAS ELETRICAS E TELEFONICAS"
    },
    {
      "codigo_valor_dominio": 3285,
      "codigo_referencia_valor_dominio": "764205",
      "nome_resumido_valor_dominio": "COSTURADOR DE CALCADOS, A MAQUINA",
      "nome_completo_valor_dominio": "COSTURADOR DE CALCADOS, A MAQUINA",
      "descricao_conceito_valor_dominio": "COSTURADOR DE CALCADOS, A MAQUINA"
    },
    {
      "codigo_valor_dominio": 3286,
      "codigo_referencia_valor_dominio": "919315",
      "nome_resumido_valor_dominio": "MONTADOR DE BICICLETAS",
      "nome_completo_valor_dominio": "MONTADOR DE BICICLETAS",
      "descricao_conceito_valor_dominio": "MONTADOR DE BICICLETAS"
    },
    {
      "codigo_valor_dominio": 3287,
      "codigo_referencia_valor_dominio": "848605",
      "nome_resumido_valor_dominio": "TRABALHADOR DO BENEFICIAMENTO DE FUMO",
      "nome_completo_valor_dominio": "TRABALHADOR DO BENEFICIAMENTO DE FUMO",
      "descricao_conceito_valor_dominio": "TRABALHADOR DO BENEFICIAMENTO DE FUMO"
    },
    {
      "codigo_valor_dominio": 3288,
      "codigo_referencia_valor_dominio": "262815",
      "nome_resumido_valor_dominio": "COREOGRAFO",
      "nome_completo_valor_dominio": "COREOGRAFO",
      "descricao_conceito_valor_dominio": "COREOGRAFO"
    },
    {
      "codigo_valor_dominio": 3289,
      "codigo_referencia_valor_dominio": "766130",
      "nome_resumido_valor_dominio": "GRAVADOR DE MATRIZ PARA ROTOGRAVURA (ELETROMECANICO E QUIMIC",
      "nome_completo_valor_dominio": "GRAVADOR DE MATRIZ PARA ROTOGRAVURA (ELETROMECANICO E QUIMICO)",
      "descricao_conceito_valor_dominio": "GRAVADOR DE MATRIZ PARA ROTOGRAVURA (ELETROMECANICO E QUIMICO)"
    },
    {
      "codigo_valor_dominio": 3290,
      "codigo_referencia_valor_dominio": "374405",
      "nome_resumido_valor_dominio": "EDITOR DE TV E VIDEO",
      "nome_completo_valor_dominio": "EDITOR DE TV E VIDEO",
      "descricao_conceito_valor_dominio": "EDITOR DE TV E VIDEO"
    },
    {
      "codigo_valor_dominio": 3291,
      "codigo_referencia_valor_dominio": "741110",
      "nome_resumido_valor_dominio": "MONTADOR DE INSTRUMENTOS DE OPTICA",
      "nome_completo_valor_dominio": "MONTADOR DE INSTRUMENTOS DE OPTICA",
      "descricao_conceito_valor_dominio": "MONTADOR DE INSTRUMENTOS DE OPTICA"
    },
    {
      "codigo_valor_dominio": 3292,
      "codigo_referencia_valor_dominio": "766140",
      "nome_resumido_valor_dominio": "GRAVADOR DE MATRIZ SERIGRAFICA",
      "nome_completo_valor_dominio": "GRAVADOR DE MATRIZ SERIGRAFICA",
      "descricao_conceito_valor_dominio": "GRAVADOR DE MATRIZ SERIGRAFICA"
    },
    {
      "codigo_valor_dominio": 3293,
      "codigo_referencia_valor_dominio": "766115",
      "nome_resumido_valor_dominio": "GRAVADOR DE MATRIZ PARA FLEXOGRAFIA (CLICHERISTA)",
      "nome_completo_valor_dominio": "GRAVADOR DE MATRIZ PARA FLEXOGRAFIA (CLICHERISTA)",
      "descricao_conceito_valor_dominio": "GRAVADOR DE MATRIZ PARA FLEXOGRAFIA (CLICHERISTA)"
    },
    {
      "codigo_valor_dominio": 3294,
      "codigo_referencia_valor_dominio": "712215",
      "nome_resumido_valor_dominio": "GRAVADOR DE RELEVOS EM PEDRA",
      "nome_completo_valor_dominio": "GRAVADOR DE RELEVOS EM PEDRA",
      "descricao_conceito_valor_dominio": "GRAVADOR DE RELEVOS EM PEDRA"
    },
    {
      "codigo_valor_dominio": 3295,
      "codigo_referencia_valor_dominio": "711305",
      "nome_resumido_valor_dominio": "OPERADOR DE SONDA DE PERCUSSAO",
      "nome_completo_valor_dominio": "OPERADOR DE SONDA DE PERCUSSAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE SONDA DE PERCUSSAO"
    },
    {
      "codigo_valor_dominio": 3296,
      "codigo_referencia_valor_dominio": "811005",
      "nome_resumido_valor_dominio": "OPERADOR DE PROCESSOS QUIMICOS E PETROQUIMICOS",
      "nome_completo_valor_dominio": "OPERADOR DE PROCESSOS QUIMICOS E PETROQUIMICOS",
      "descricao_conceito_valor_dominio": "OPERADOR DE PROCESSOS QUIMICOS E PETROQUIMICOS"
    },
    {
      "codigo_valor_dominio": 3297,
      "codigo_referencia_valor_dominio": "318805",
      "nome_resumido_valor_dominio": "PROJETISTA DE MOVEIS",
      "nome_completo_valor_dominio": "PROJETISTA DE MOVEIS",
      "descricao_conceito_valor_dominio": "PROJETISTA DE MOVEIS"
    },
    {
      "codigo_valor_dominio": 3298,
      "codigo_referencia_valor_dominio": "766210",
      "nome_resumido_valor_dominio": "IMPRESSOR CALCOGRAFICO",
      "nome_completo_valor_dominio": "IMPRESSOR CALCOGRAFICO",
      "descricao_conceito_valor_dominio": "IMPRESSOR CALCOGRAFICO"
    },
    {
      "codigo_valor_dominio": 3299,
      "codigo_referencia_valor_dominio": "766310",
      "nome_resumido_valor_dominio": "IMPRESSOR DE CORTE E VINCO",
      "nome_completo_valor_dominio": "IMPRESSOR DE CORTE E VINCO",
      "descricao_conceito_valor_dominio": "IMPRESSOR DE CORTE E VINCO"
    },
    {
      "codigo_valor_dominio": 3300,
      "codigo_referencia_valor_dominio": "766220",
      "nome_resumido_valor_dominio": "IMPRESSOR DE ROTATIVA",
      "nome_completo_valor_dominio": "IMPRESSOR DE ROTATIVA",
      "descricao_conceito_valor_dominio": "IMPRESSOR DE ROTATIVA"
    },
    {
      "codigo_valor_dominio": 3301,
      "codigo_referencia_valor_dominio": "766225",
      "nome_resumido_valor_dominio": "IMPRESSOR DE ROTOGRAVURA",
      "nome_completo_valor_dominio": "IMPRESSOR DE ROTOGRAVURA",
      "descricao_conceito_valor_dominio": "IMPRESSOR DE ROTOGRAVURA"
    },
    {
      "codigo_valor_dominio": 3302,
      "codigo_referencia_valor_dominio": "766230",
      "nome_resumido_valor_dominio": "IMPRESSOR DIGITAL",
      "nome_completo_valor_dominio": "IMPRESSOR DIGITAL",
      "descricao_conceito_valor_dominio": "IMPRESSOR DIGITAL"
    },
    {
      "codigo_valor_dominio": 3303,
      "codigo_referencia_valor_dominio": "766235",
      "nome_resumido_valor_dominio": "IMPRESSOR FLEXOGRAFICO",
      "nome_completo_valor_dominio": "IMPRESSOR FLEXOGRAFICO",
      "descricao_conceito_valor_dominio": "IMPRESSOR FLEXOGRAFICO"
    },
    {
      "codigo_valor_dominio": 3304,
      "codigo_referencia_valor_dominio": "766240",
      "nome_resumido_valor_dominio": "IMPRESSOR LETTERSET",
      "nome_completo_valor_dominio": "IMPRESSOR LETTERSET",
      "descricao_conceito_valor_dominio": "IMPRESSOR LETTERSET"
    },
    {
      "codigo_valor_dominio": 3305,
      "codigo_referencia_valor_dominio": "766245",
      "nome_resumido_valor_dominio": "IMPRESSOR TAMPOGRAFICO",
      "nome_completo_valor_dominio": "IMPRESSOR TAMPOGRAFICO",
      "descricao_conceito_valor_dominio": "IMPRESSOR TAMPOGRAFICO"
    },
    {
      "codigo_valor_dominio": 3306,
      "codigo_referencia_valor_dominio": "766250",
      "nome_resumido_valor_dominio": "IMPRESSOR TIPOGRAFICO",
      "nome_completo_valor_dominio": "IMPRESSOR TIPOGRAFICO",
      "descricao_conceito_valor_dominio": "IMPRESSOR TIPOGRAFICO"
    },
    {
      "codigo_valor_dominio": 3307,
      "codigo_referencia_valor_dominio": "623010",
      "nome_resumido_valor_dominio": "INSEMINADOR",
      "nome_completo_valor_dominio": "INSEMINADOR",
      "descricao_conceito_valor_dominio": "INSEMINADOR"
    },
    {
      "codigo_valor_dominio": 3308,
      "codigo_referencia_valor_dominio": "766305",
      "nome_resumido_valor_dominio": "ACABADOR DE EMBALAGENS (FLEXIVEIS E CARTOTECNICAS)",
      "nome_completo_valor_dominio": "ACABADOR DE EMBALAGENS (FLEXIVEIS E CARTOTECNICAS)",
      "descricao_conceito_valor_dominio": "ACABADOR DE EMBALAGENS (FLEXIVEIS E CARTOTECNICAS)"
    },
    {
      "codigo_valor_dominio": 3309,
      "codigo_referencia_valor_dominio": "766215",
      "nome_resumido_valor_dominio": "IMPRESSOR DE OFSETE (PLANO E ROTATIVO)",
      "nome_completo_valor_dominio": "IMPRESSOR DE OFSETE (PLANO E ROTATIVO)",
      "descricao_conceito_valor_dominio": "IMPRESSOR DE OFSETE (PLANO E ROTATIVO)"
    },
    {
      "codigo_valor_dominio": 3310,
      "codigo_referencia_valor_dominio": "722215",
      "nome_resumido_valor_dominio": "OPERADOR DE ACABAMENTO DE PECAS FUNDIDAS",
      "nome_completo_valor_dominio": "OPERADOR DE ACABAMENTO DE PECAS FUNDIDAS",
      "descricao_conceito_valor_dominio": "OPERADOR DE ACABAMENTO DE PECAS FUNDIDAS"
    },
    {
      "codigo_valor_dominio": 3311,
      "codigo_referencia_valor_dominio": "782110",
      "nome_resumido_valor_dominio": "OPERADOR DE GUINDASTE (FIXO)",
      "nome_completo_valor_dominio": "OPERADOR DE GUINDASTE (FIXO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE GUINDASTE (FIXO)"
    },
    {
      "codigo_valor_dominio": 3312,
      "codigo_referencia_valor_dominio": "842105",
      "nome_resumido_valor_dominio": "PREPARADOR DE MELADO E ESSENCIA DE FUMO",
      "nome_completo_valor_dominio": "PREPARADOR DE MELADO E ESSENCIA DE FUMO",
      "descricao_conceito_valor_dominio": "PREPARADOR DE MELADO E ESSENCIA DE FUMO"
    },
    {
      "codigo_valor_dominio": 3313,
      "codigo_referencia_valor_dominio": "716510",
      "nome_resumido_valor_dominio": "LADRILHEIRO",
      "nome_completo_valor_dominio": "LADRILHEIRO",
      "descricao_conceito_valor_dominio": "LADRILHEIRO"
    },
    {
      "codigo_valor_dominio": 3314,
      "codigo_referencia_valor_dominio": "716615",
      "nome_resumido_valor_dominio": "REVESTIDOR DE INTERIORES (PAPEL, MATERIAL PLASTICO E EMBORRA",
      "nome_completo_valor_dominio": "REVESTIDOR DE INTERIORES (PAPEL, MATERIAL PLASTICO E EMBORRACHADOS)",
      "descricao_conceito_valor_dominio": "REVESTIDOR DE INTERIORES (PAPEL, MATERIAL PLASTICO E EMBORRACHADOS)"
    },
    {
      "codigo_valor_dominio": 3315,
      "codigo_referencia_valor_dominio": "766410",
      "nome_resumido_valor_dominio": "REVELADOR DE FILMES FOTOGRAFICOS, EM PRETO E BRANCO",
      "nome_completo_valor_dominio": "REVELADOR DE FILMES FOTOGRAFICOS, EM PRETO E BRANCO",
      "descricao_conceito_valor_dominio": "REVELADOR DE FILMES FOTOGRAFICOS, EM PRETO E BRANCO"
    },
    {
      "codigo_valor_dominio": 3316,
      "codigo_referencia_valor_dominio": "766420",
      "nome_resumido_valor_dominio": "AUXILIAR DE RADIOLOGIA (REVELACAO FOTOGRAFICA)",
      "nome_completo_valor_dominio": "AUXILIAR DE RADIOLOGIA (REVELACAO FOTOGRAFICA)",
      "descricao_conceito_valor_dominio": "AUXILIAR DE RADIOLOGIA (REVELACAO FOTOGRAFICA)"
    },
    {
      "codigo_valor_dominio": 3317,
      "codigo_referencia_valor_dominio": "761315",
      "nome_resumido_valor_dominio": "TECELAO (TEAR MECANICO DE MAQUINETA)",
      "nome_completo_valor_dominio": "TECELAO (TEAR MECANICO DE MAQUINETA)",
      "descricao_conceito_valor_dominio": "TECELAO (TEAR MECANICO DE MAQUINETA)"
    },
    {
      "codigo_valor_dominio": 3318,
      "codigo_referencia_valor_dominio": "761345",
      "nome_resumido_valor_dominio": "TECELAO DE TAPETES, A MAQUINA",
      "nome_completo_valor_dominio": "TECELAO DE TAPETES, A MAQUINA",
      "descricao_conceito_valor_dominio": "TECELAO DE TAPETES, A MAQUINA"
    },
    {
      "codigo_valor_dominio": 3319,
      "codigo_referencia_valor_dominio": "782810",
      "nome_resumido_valor_dominio": "TROPEIRO",
      "nome_completo_valor_dominio": "TROPEIRO",
      "descricao_conceito_valor_dominio": "TROPEIRO"
    },
    {
      "codigo_valor_dominio": 3320,
      "codigo_referencia_valor_dominio": "631420",
      "nome_resumido_valor_dominio": "REDEIRO (PESCA)",
      "nome_completo_valor_dominio": "REDEIRO (PESCA)",
      "descricao_conceito_valor_dominio": "REDEIRO (PESCA)"
    },
    {
      "codigo_valor_dominio": 3321,
      "codigo_referencia_valor_dominio": "768125",
      "nome_resumido_valor_dominio": "CHAPELEIRO (CHAPEUS DE PALHA)",
      "nome_completo_valor_dominio": "CHAPELEIRO (CHAPEUS DE PALHA)",
      "descricao_conceito_valor_dominio": "CHAPELEIRO (CHAPEUS DE PALHA)"
    },
    {
      "codigo_valor_dominio": 3322,
      "codigo_referencia_valor_dominio": "391105",
      "nome_resumido_valor_dominio": "CRONOANALISTA",
      "nome_completo_valor_dominio": "CRONOANALISTA",
      "descricao_conceito_valor_dominio": "CRONOANALISTA"
    },
    {
      "codigo_valor_dominio": 3323,
      "codigo_referencia_valor_dominio": "768205",
      "nome_resumido_valor_dominio": "BORDADOR, A MAO",
      "nome_completo_valor_dominio": "BORDADOR, A MAO",
      "descricao_conceito_valor_dominio": "BORDADOR, A MAO"
    },
    {
      "codigo_valor_dominio": 3324,
      "codigo_referencia_valor_dominio": "768210",
      "nome_resumido_valor_dominio": "CERZIDOR",
      "nome_completo_valor_dominio": "CERZIDOR",
      "descricao_conceito_valor_dominio": "CERZIDOR"
    },
    {
      "codigo_valor_dominio": 3325,
      "codigo_referencia_valor_dominio": "768305",
      "nome_resumido_valor_dominio": "ARTIFICE DO COURO",
      "nome_completo_valor_dominio": "ARTIFICE DO COURO",
      "descricao_conceito_valor_dominio": "ARTIFICE DO COURO"
    },
    {
      "codigo_valor_dominio": 3326,
      "codigo_referencia_valor_dominio": "764105",
      "nome_resumido_valor_dominio": "CORTADOR DE CALCADOS, A MAQUINA (EXCETO SOLAS E PALMILHAS)",
      "nome_completo_valor_dominio": "CORTADOR DE CALCADOS, A MAQUINA (EXCETO SOLAS E PALMILHAS)",
      "descricao_conceito_valor_dominio": "CORTADOR DE CALCADOS, A MAQUINA (EXCETO SOLAS E PALMILHAS)"
    },
    {
      "codigo_valor_dominio": 3327,
      "codigo_referencia_valor_dominio": "765310",
      "nome_resumido_valor_dominio": "COSTURADOR DE ARTEFATOS DE COURO, A MAQUINA (EXCETO ROUPAS E",
      "nome_completo_valor_dominio": "COSTURADOR DE ARTEFATOS DE COURO, A MAQUINA (EXCETO ROUPAS E CALCADOS)",
      "descricao_conceito_valor_dominio": "COSTURADOR DE ARTEFATOS DE COURO, A MAQUINA (EXCETO ROUPAS E CALCADOS)"
    },
    {
      "codigo_valor_dominio": 3328,
      "codigo_referencia_valor_dominio": "031110",
      "nome_resumido_valor_dominio": "SARGENTO BOMBEIRO MILITAR",
      "nome_completo_valor_dominio": "SARGENTO BOMBEIRO MILITAR",
      "descricao_conceito_valor_dominio": "SARGENTO BOMBEIRO MILITAR"
    },
    {
      "codigo_valor_dominio": 3329,
      "codigo_referencia_valor_dominio": "111105",
      "nome_resumido_valor_dominio": "SENADOR",
      "nome_completo_valor_dominio": "SENADOR",
      "descricao_conceito_valor_dominio": "SENADOR"
    },
    {
      "codigo_valor_dominio": 3330,
      "codigo_referencia_valor_dominio": "376250",
      "nome_resumido_valor_dominio": "TITERITEIRO",
      "nome_completo_valor_dominio": "TITERITEIRO",
      "descricao_conceito_valor_dominio": "TITERITEIRO"
    },
    {
      "codigo_valor_dominio": 3331,
      "codigo_referencia_valor_dominio": "762315",
      "nome_resumido_valor_dominio": "LIXADOR DE COUROS E PELES",
      "nome_completo_valor_dominio": "LIXADOR DE COUROS E PELES",
      "descricao_conceito_valor_dominio": "LIXADOR DE COUROS E PELES"
    },
    {
      "codigo_valor_dominio": 3332,
      "codigo_referencia_valor_dominio": "715545",
      "nome_resumido_valor_dominio": "MONTADOR DE ANDAIMES (EDIFICACOES)",
      "nome_completo_valor_dominio": "MONTADOR DE ANDAIMES (EDIFICACOES)",
      "descricao_conceito_valor_dominio": "MONTADOR DE ANDAIMES (EDIFICACOES)"
    },
    {
      "codigo_valor_dominio": 3333,
      "codigo_referencia_valor_dominio": "762335",
      "nome_resumido_valor_dominio": "PALECIONADOR DE COUROS E PELES",
      "nome_completo_valor_dominio": "PALECIONADOR DE COUROS E PELES",
      "descricao_conceito_valor_dominio": "PALECIONADOR DE COUROS E PELES"
    },
    {
      "codigo_valor_dominio": 3334,
      "codigo_referencia_valor_dominio": "716610",
      "nome_resumido_valor_dominio": "PINTOR DE OBRAS",
      "nome_completo_valor_dominio": "PINTOR DE OBRAS",
      "descricao_conceito_valor_dominio": "PINTOR DE OBRAS"
    },
    {
      "codigo_valor_dominio": 3335,
      "codigo_referencia_valor_dominio": "768630",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE CARIMBOS DE BORRACHA",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE CARIMBOS DE BORRACHA",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE CARIMBOS DE BORRACHA"
    },
    {
      "codigo_valor_dominio": 3336,
      "codigo_referencia_valor_dominio": "517335",
      "nome_resumido_valor_dominio": "GUARDA PORTUARIO",
      "nome_completo_valor_dominio": "GUARDA PORTUARIO",
      "descricao_conceito_valor_dominio": "GUARDA PORTUARIO"
    },
    {
      "codigo_valor_dominio": 3337,
      "codigo_referencia_valor_dominio": "848525",
      "nome_resumido_valor_dominio": "RETALHADOR DE CARNE",
      "nome_completo_valor_dominio": "RETALHADOR DE CARNE",
      "descricao_conceito_valor_dominio": "RETALHADOR DE CARNE"
    },
    {
      "codigo_valor_dominio": 3338,
      "codigo_referencia_valor_dominio": "720215",
      "nome_resumido_valor_dominio": "MESTRE (INDUSTRIA DE MAQUINAS E OUTROS EQUIPAMENTOS MECANICO",
      "nome_completo_valor_dominio": "MESTRE (INDUSTRIA DE MAQUINAS E OUTROS EQUIPAMENTOS MECANICO)",
      "descricao_conceito_valor_dominio": "MESTRE (INDUSTRIA DE MAQUINAS E OUTROS EQUIPAMENTOS MECANICO)"
    },
    {
      "codigo_valor_dominio": 3339,
      "codigo_referencia_valor_dominio": "820110",
      "nome_resumido_valor_dominio": "MESTRE DE ACIARIA",
      "nome_completo_valor_dominio": "MESTRE DE ACIARIA",
      "descricao_conceito_valor_dominio": "MESTRE DE ACIARIA"
    },
    {
      "codigo_valor_dominio": 3340,
      "codigo_referencia_valor_dominio": "775120",
      "nome_resumido_valor_dominio": "MARCHETEIRO",
      "nome_completo_valor_dominio": "MARCHETEIRO",
      "descricao_conceito_valor_dominio": "MARCHETEIRO"
    },
    {
      "codigo_valor_dominio": 3341,
      "codigo_referencia_valor_dominio": "721115",
      "nome_resumido_valor_dominio": "MODELADOR DE METAIS (FUNDICAO)",
      "nome_completo_valor_dominio": "MODELADOR DE METAIS (FUNDICAO)",
      "descricao_conceito_valor_dominio": "MODELADOR DE METAIS (FUNDICAO)"
    },
    {
      "codigo_valor_dominio": 3342,
      "codigo_referencia_valor_dominio": "516125",
      "nome_resumido_valor_dominio": "MAQUIADOR",
      "nome_completo_valor_dominio": "MAQUIADOR",
      "descricao_conceito_valor_dominio": "MAQUIADOR"
    },
    {
      "codigo_valor_dominio": 3343,
      "codigo_referencia_valor_dominio": "716535",
      "nome_resumido_valor_dominio": "TAQUEIRO",
      "nome_completo_valor_dominio": "TAQUEIRO",
      "descricao_conceito_valor_dominio": "TAQUEIRO"
    },
    {
      "codigo_valor_dominio": 3344,
      "codigo_referencia_valor_dominio": "772105",
      "nome_resumido_valor_dominio": "CLASSIFICADOR DE MADEIRA",
      "nome_completo_valor_dominio": "CLASSIFICADOR DE MADEIRA",
      "descricao_conceito_valor_dominio": "CLASSIFICADOR DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 3345,
      "codigo_referencia_valor_dominio": "766205",
      "nome_resumido_valor_dominio": "IMPRESSOR (SERIGRAFIA)",
      "nome_completo_valor_dominio": "IMPRESSOR (SERIGRAFIA)",
      "descricao_conceito_valor_dominio": "IMPRESSOR (SERIGRAFIA)"
    },
    {
      "codigo_valor_dominio": 3346,
      "codigo_referencia_valor_dominio": "252315",
      "nome_resumido_valor_dominio": "SECRETARIA TRILINGUE",
      "nome_completo_valor_dominio": "SECRETARIA TRILINGUE",
      "descricao_conceito_valor_dominio": "SECRETARIA TRILINGUE"
    },
    {
      "codigo_valor_dominio": 3347,
      "codigo_referencia_valor_dominio": "712205",
      "nome_resumido_valor_dominio": "CORTADOR DE PEDRAS",
      "nome_completo_valor_dominio": "CORTADOR DE PEDRAS",
      "descricao_conceito_valor_dominio": "CORTADOR DE PEDRAS"
    },
    {
      "codigo_valor_dominio": 3348,
      "codigo_referencia_valor_dominio": "811650",
      "nome_resumido_valor_dominio": "OPERADOR DE SISTEMA DE REVERSAO (COQUERIA)",
      "nome_completo_valor_dominio": "OPERADOR DE SISTEMA DE REVERSAO (COQUERIA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE SISTEMA DE REVERSAO (COQUERIA)"
    },
    {
      "codigo_valor_dominio": 3349,
      "codigo_referencia_valor_dominio": "773120",
      "nome_resumido_valor_dominio": "SERRADOR DE MADEIRA",
      "nome_completo_valor_dominio": "SERRADOR DE MADEIRA",
      "descricao_conceito_valor_dominio": "SERRADOR DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 3350,
      "codigo_referencia_valor_dominio": "773125",
      "nome_resumido_valor_dominio": "SERRADOR DE MADEIRA (SERRA CIRCULAR MULTIPLA)",
      "nome_completo_valor_dominio": "SERRADOR DE MADEIRA (SERRA CIRCULAR MULTIPLA)",
      "descricao_conceito_valor_dominio": "SERRADOR DE MADEIRA (SERRA CIRCULAR MULTIPLA)"
    },
    {
      "codigo_valor_dominio": 3351,
      "codigo_referencia_valor_dominio": "773130",
      "nome_resumido_valor_dominio": "SERRADOR DE MADEIRA (SERRA DE FITA MULTIPLA)",
      "nome_completo_valor_dominio": "SERRADOR DE MADEIRA (SERRA DE FITA MULTIPLA)",
      "descricao_conceito_valor_dominio": "SERRADOR DE MADEIRA (SERRA DE FITA MULTIPLA)"
    },
    {
      "codigo_valor_dominio": 3352,
      "codigo_referencia_valor_dominio": "724440",
      "nome_resumido_valor_dominio": "SERRALHEIRO",
      "nome_completo_valor_dominio": "SERRALHEIRO",
      "descricao_conceito_valor_dominio": "SERRALHEIRO"
    },
    {
      "codigo_valor_dominio": 3353,
      "codigo_referencia_valor_dominio": "811110",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA MISTURADEIRA (TRATAMENTOS QUIMICOS E AFI",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA MISTURADEIRA (TRATAMENTOS QUIMICOS E AFINS",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA MISTURADEIRA (TRATAMENTOS QUIMICOS E AFINS"
    },
    {
      "codigo_valor_dominio": 3354,
      "codigo_referencia_valor_dominio": "773215",
      "nome_resumido_valor_dominio": "PRENSISTA DE COMPENSADOS",
      "nome_completo_valor_dominio": "PRENSISTA DE COMPENSADOS",
      "descricao_conceito_valor_dominio": "PRENSISTA DE COMPENSADOS"
    },
    {
      "codigo_valor_dominio": 3355,
      "codigo_referencia_valor_dominio": "823130",
      "nome_resumido_valor_dominio": "PREPARADOR DE ADITIVOS",
      "nome_completo_valor_dominio": "PREPARADOR DE ADITIVOS",
      "descricao_conceito_valor_dominio": "PREPARADOR DE ADITIVOS"
    },
    {
      "codigo_valor_dominio": 3356,
      "codigo_referencia_valor_dominio": "224115",
      "nome_resumido_valor_dominio": "PREPARADOR DE ATLETA",
      "nome_completo_valor_dominio": "PREPARADOR DE ATLETA",
      "descricao_conceito_valor_dominio": "PREPARADOR DE ATLETA"
    },
    {
      "codigo_valor_dominio": 3357,
      "codigo_referencia_valor_dominio": "821250",
      "nome_resumido_valor_dominio": "OPERADOR DE DESGASEIFICACAO",
      "nome_completo_valor_dominio": "OPERADOR DE DESGASEIFICACAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE DESGASEIFICACAO"
    },
    {
      "codigo_valor_dominio": 3358,
      "codigo_referencia_valor_dominio": "811425",
      "nome_resumido_valor_dominio": "OPERADOR DE EQUIPAMENTO DE DESTILACAO DE ALCOOL",
      "nome_completo_valor_dominio": "OPERADOR DE EQUIPAMENTO DE DESTILACAO DE ALCOOL",
      "descricao_conceito_valor_dominio": "OPERADOR DE EQUIPAMENTO DE DESTILACAO DE ALCOOL"
    },
    {
      "codigo_valor_dominio": 3359,
      "codigo_referencia_valor_dominio": "721410",
      "nome_resumido_valor_dominio": "OPERADOR DE FRESADORA COM COMANDO NUMERICO",
      "nome_completo_valor_dominio": "OPERADOR DE FRESADORA COM COMANDO NUMERICO",
      "descricao_conceito_valor_dominio": "OPERADOR DE FRESADORA COM COMANDO NUMERICO"
    },
    {
      "codigo_valor_dominio": 3360,
      "codigo_referencia_valor_dominio": "761240",
      "nome_resumido_valor_dominio": "OPERADOR DE MACAROQUEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE MACAROQUEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE MACAROQUEIRA"
    },
    {
      "codigo_valor_dominio": 3361,
      "codigo_referencia_valor_dominio": "721420",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA ELETROEROSAO, A FIO, COM COMANDO NUMERIC",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA ELETROEROSAO, A FIO, COM COMANDO NUMERICO",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA ELETROEROSAO, A FIO, COM COMANDO NUMERICO"
    },
    {
      "codigo_valor_dominio": 3362,
      "codigo_referencia_valor_dominio": "782125",
      "nome_resumido_valor_dominio": "OPERADOR DE MONTA-CARGAS (CONSTRUCAO CIVIL)",
      "nome_completo_valor_dominio": "OPERADOR DE MONTA-CARGAS (CONSTRUCAO CIVIL)",
      "descricao_conceito_valor_dominio": "OPERADOR DE MONTA-CARGAS (CONSTRUCAO CIVIL)"
    },
    {
      "codigo_valor_dominio": 3363,
      "codigo_referencia_valor_dominio": "782130",
      "nome_resumido_valor_dominio": "OPERADOR DE PONTE ROLANTE",
      "nome_completo_valor_dominio": "OPERADOR DE PONTE ROLANTE",
      "descricao_conceito_valor_dominio": "OPERADOR DE PONTE ROLANTE"
    },
    {
      "codigo_valor_dominio": 3364,
      "codigo_referencia_valor_dominio": "773110",
      "nome_resumido_valor_dominio": "OPERADOR DE SERRAS NO DESDOBRAMENTO DE MADEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE SERRAS NO DESDOBRAMENTO DE MADEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE SERRAS NO DESDOBRAMENTO DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 3365,
      "codigo_referencia_valor_dominio": "721430",
      "nome_resumido_valor_dominio": "OPERADOR DE TORNO COM COMANDO NUMERICO",
      "nome_completo_valor_dominio": "OPERADOR DE TORNO COM COMANDO NUMERICO",
      "descricao_conceito_valor_dominio": "OPERADOR DE TORNO COM COMANDO NUMERICO"
    },
    {
      "codigo_valor_dominio": 3366,
      "codigo_referencia_valor_dominio": "354810",
      "nome_resumido_valor_dominio": "OPERADOR DE TURISMO",
      "nome_completo_valor_dominio": "OPERADOR DE TURISMO",
      "descricao_conceito_valor_dominio": "OPERADOR DE TURISMO"
    },
    {
      "codigo_valor_dominio": 3367,
      "codigo_referencia_valor_dominio": "841625",
      "nome_resumido_valor_dominio": "TORRADOR DE CACAU",
      "nome_completo_valor_dominio": "TORRADOR DE CACAU",
      "descricao_conceito_valor_dominio": "TORRADOR DE CACAU"
    },
    {
      "codigo_valor_dominio": 3368,
      "codigo_referencia_valor_dominio": "722220",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA CENTRIFUGADORA DE FUNDICAO",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA CENTRIFUGADORA DE FUNDICAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA CENTRIFUGADORA DE FUNDICAO"
    },
    {
      "codigo_valor_dominio": 3369,
      "codigo_referencia_valor_dominio": "763320",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE COSTURA DE ACABAMENTO",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE COSTURA DE ACABAMENTO",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE COSTURA DE ACABAMENTO"
    },
    {
      "codigo_valor_dominio": 3370,
      "codigo_referencia_valor_dominio": "773325",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE USINAGEM MADEIRA, EM GERAL",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE USINAGEM MADEIRA, EM GERAL",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE USINAGEM MADEIRA, EM GERAL"
    },
    {
      "codigo_valor_dominio": 3371,
      "codigo_referencia_valor_dominio": "833125",
      "nome_resumido_valor_dominio": "OPERADOR DE PRENSA DE EMBUTIR PAPELAO",
      "nome_completo_valor_dominio": "OPERADOR DE PRENSA DE EMBUTIR PAPELAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE PRENSA DE EMBUTIR PAPELAO"
    },
    {
      "codigo_valor_dominio": 3372,
      "codigo_referencia_valor_dominio": "761420",
      "nome_resumido_valor_dominio": "OPERADOR DE CHAMUSCADEIRA DE TECIDOS",
      "nome_completo_valor_dominio": "OPERADOR DE CHAMUSCADEIRA DE TECIDOS",
      "descricao_conceito_valor_dominio": "OPERADOR DE CHAMUSCADEIRA DE TECIDOS"
    },
    {
      "codigo_valor_dominio": 3373,
      "codigo_referencia_valor_dominio": "762325",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINAS DO ACABAMENTO DE COUROS E PELES",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINAS DO ACABAMENTO DE COUROS E PELES",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINAS DO ACABAMENTO DE COUROS E PELES"
    },
    {
      "codigo_valor_dominio": 3374,
      "codigo_referencia_valor_dominio": "725610",
      "nome_resumido_valor_dominio": "MONTADOR DE SISTEMAS DE COMBUSTIVEL DE AERONAVES",
      "nome_completo_valor_dominio": "MONTADOR DE SISTEMAS DE COMBUSTIVEL DE AERONAVES",
      "descricao_conceito_valor_dominio": "MONTADOR DE SISTEMAS DE COMBUSTIVEL DE AERONAVES"
    },
    {
      "codigo_valor_dominio": 3375,
      "codigo_referencia_valor_dominio": "424105",
      "nome_resumido_valor_dominio": "ENTREVISTADOR CENSITARIO E DE PESQUISAS AMOSTRAIS",
      "nome_completo_valor_dominio": "ENTREVISTADOR CENSITARIO E DE PESQUISAS AMOSTRAIS",
      "descricao_conceito_valor_dominio": "ENTREVISTADOR CENSITARIO E DE PESQUISAS AMOSTRAIS"
    },
    {
      "codigo_valor_dominio": 3376,
      "codigo_referencia_valor_dominio": "223810",
      "nome_resumido_valor_dominio": "FONOAUDIOLOGO",
      "nome_completo_valor_dominio": "FONOAUDIOLOGO",
      "descricao_conceito_valor_dominio": "FONOAUDIOLOGO"
    },
    {
      "codigo_valor_dominio": 3377,
      "codigo_referencia_valor_dominio": "716520",
      "nome_resumido_valor_dominio": "LUSTRADOR DE PISO",
      "nome_completo_valor_dominio": "LUSTRADOR DE PISO",
      "descricao_conceito_valor_dominio": "LUSTRADOR DE PISO"
    },
    {
      "codigo_valor_dominio": 3378,
      "codigo_referencia_valor_dominio": "782705",
      "nome_resumido_valor_dominio": "MARINHEIRO DE CONVES (MARITIMO E FLUVIARIO)",
      "nome_completo_valor_dominio": "MARINHEIRO DE CONVES (MARITIMO E FLUVIARIO)",
      "descricao_conceito_valor_dominio": "MARINHEIRO DE CONVES (MARITIMO E FLUVIARIO)"
    },
    {
      "codigo_valor_dominio": 3379,
      "codigo_referencia_valor_dominio": "776405",
      "nome_resumido_valor_dominio": "CESTEIRO",
      "nome_completo_valor_dominio": "CESTEIRO",
      "descricao_conceito_valor_dominio": "CESTEIRO"
    },
    {
      "codigo_valor_dominio": 3380,
      "codigo_referencia_valor_dominio": "776410",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE ESCOVAS, PINCEIS E PRODUTOS SIMILARES (A M",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE ESCOVAS, PINCEIS E PRODUTOS SIMILARES (A MAO)",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE ESCOVAS, PINCEIS E PRODUTOS SIMILARES (A MAO)"
    },
    {
      "codigo_valor_dominio": 3381,
      "codigo_referencia_valor_dominio": "742115",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE INSTRUMENTOS DE CORDA",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE INSTRUMENTOS DE CORDA",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE INSTRUMENTOS DE CORDA"
    },
    {
      "codigo_valor_dominio": 3382,
      "codigo_referencia_valor_dominio": "742135",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE ORGAO",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE ORGAO",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE ORGAO"
    },
    {
      "codigo_valor_dominio": 3383,
      "codigo_referencia_valor_dominio": "351515",
      "nome_resumido_valor_dominio": "ESTENOTIPISTA",
      "nome_completo_valor_dominio": "ESTENOTIPISTA",
      "descricao_conceito_valor_dominio": "ESTENOTIPISTA"
    },
    {
      "codigo_valor_dominio": 3384,
      "codigo_referencia_valor_dominio": "524215",
      "nome_resumido_valor_dominio": "VENDEDOR PERMISSIONARIO",
      "nome_completo_valor_dominio": "VENDEDOR PERMISSIONARIO",
      "descricao_conceito_valor_dominio": "VENDEDOR PERMISSIONARIO"
    },
    {
      "codigo_valor_dominio": 3385,
      "codigo_referencia_valor_dominio": "777105",
      "nome_resumido_valor_dominio": "CARPINTEIRO NAVAL (CONSTRUCAO DE PEQUENAS EMBARCACOES)",
      "nome_completo_valor_dominio": "CARPINTEIRO NAVAL (CONSTRUCAO DE PEQUENAS EMBARCACOES)",
      "descricao_conceito_valor_dominio": "CARPINTEIRO NAVAL (CONSTRUCAO DE PEQUENAS EMBARCACOES)"
    },
    {
      "codigo_valor_dominio": 3386,
      "codigo_referencia_valor_dominio": "777110",
      "nome_resumido_valor_dominio": "CARPINTEIRO NAVAL (EMBARCACOES)",
      "nome_completo_valor_dominio": "CARPINTEIRO NAVAL (EMBARCACOES)",
      "descricao_conceito_valor_dominio": "CARPINTEIRO NAVAL (EMBARCACOES)"
    },
    {
      "codigo_valor_dominio": 3387,
      "codigo_referencia_valor_dominio": "777115",
      "nome_resumido_valor_dominio": "CARPINTEIRO NAVAL (ESTALEIROS)",
      "nome_completo_valor_dominio": "CARPINTEIRO NAVAL (ESTALEIROS)",
      "descricao_conceito_valor_dominio": "CARPINTEIRO NAVAL (ESTALEIROS)"
    },
    {
      "codigo_valor_dominio": 3388,
      "codigo_referencia_valor_dominio": "777205",
      "nome_resumido_valor_dominio": "CARPINTEIRO DE CARRETAS",
      "nome_completo_valor_dominio": "CARPINTEIRO DE CARRETAS",
      "descricao_conceito_valor_dominio": "CARPINTEIRO DE CARRETAS"
    },
    {
      "codigo_valor_dominio": 3389,
      "codigo_referencia_valor_dominio": "777210",
      "nome_resumido_valor_dominio": "CARPINTEIRO DE CARROCERIAS",
      "nome_completo_valor_dominio": "CARPINTEIRO DE CARROCERIAS",
      "descricao_conceito_valor_dominio": "CARPINTEIRO DE CARROCERIAS"
    },
    {
      "codigo_valor_dominio": 3390,
      "codigo_referencia_valor_dominio": "342545",
      "nome_resumido_valor_dominio": "SUPERVISOR DE EMPRESA AEREA EM AEROPORTOS",
      "nome_completo_valor_dominio": "SUPERVISOR DE EMPRESA AEREA EM AEROPORTOS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE EMPRESA AEREA EM AEROPORTOS"
    },
    {
      "codigo_valor_dominio": 3391,
      "codigo_referencia_valor_dominio": "781105",
      "nome_resumido_valor_dominio": "CONDUTOR DE PROCESSOS ROBOTIZADOS DE PINTURA",
      "nome_completo_valor_dominio": "CONDUTOR DE PROCESSOS ROBOTIZADOS DE PINTURA",
      "descricao_conceito_valor_dominio": "CONDUTOR DE PROCESSOS ROBOTIZADOS DE PINTURA"
    },
    {
      "codigo_valor_dominio": 3392,
      "codigo_referencia_valor_dominio": "781110",
      "nome_resumido_valor_dominio": "CONDUTOR DE PROCESSOS ROBOTIZADOS DE SOLDAGEM",
      "nome_completo_valor_dominio": "CONDUTOR DE PROCESSOS ROBOTIZADOS DE SOLDAGEM",
      "descricao_conceito_valor_dominio": "CONDUTOR DE PROCESSOS ROBOTIZADOS DE SOLDAGEM"
    },
    {
      "codigo_valor_dominio": 3393,
      "codigo_referencia_valor_dominio": "723235",
      "nome_resumido_valor_dominio": "OPERADOR DE ZINCAGEM (PROCESSO ELETROLITICO)",
      "nome_completo_valor_dominio": "OPERADOR DE ZINCAGEM (PROCESSO ELETROLITICO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE ZINCAGEM (PROCESSO ELETROLITICO)"
    },
    {
      "codigo_valor_dominio": 3394,
      "codigo_referencia_valor_dominio": "720105",
      "nome_resumido_valor_dominio": "MESTRE (AFIADOR DE FERRAMENTAS)",
      "nome_completo_valor_dominio": "MESTRE (AFIADOR DE FERRAMENTAS)",
      "descricao_conceito_valor_dominio": "MESTRE (AFIADOR DE FERRAMENTAS)"
    },
    {
      "codigo_valor_dominio": 3395,
      "codigo_referencia_valor_dominio": "782220",
      "nome_resumido_valor_dominio": "OPERADOR DE EMPILHADEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE EMPILHADEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE EMPILHADEIRA"
    },
    {
      "codigo_valor_dominio": 3396,
      "codigo_referencia_valor_dominio": "782115",
      "nome_resumido_valor_dominio": "OPERADOR DE GUINDASTE MOVEL",
      "nome_completo_valor_dominio": "OPERADOR DE GUINDASTE MOVEL",
      "descricao_conceito_valor_dominio": "OPERADOR DE GUINDASTE MOVEL"
    },
    {
      "codigo_valor_dominio": 3397,
      "codigo_referencia_valor_dominio": "761425",
      "nome_resumido_valor_dominio": "OPERADOR DE IMPERMEABILIZADOR DE TECIDOS",
      "nome_completo_valor_dominio": "OPERADOR DE IMPERMEABILIZADOR DE TECIDOS",
      "descricao_conceito_valor_dominio": "OPERADOR DE IMPERMEABILIZADOR DE TECIDOS"
    },
    {
      "codigo_valor_dominio": 3398,
      "codigo_referencia_valor_dominio": "641010",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINAS DE BENEFICIAMENTO DE PRODUTOS AGRICOLAS",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINAS DE BENEFICIAMENTO DE PRODUTOS AGRICOLAS",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINAS DE BENEFICIAMENTO DE PRODUTOS AGRICOLAS"
    },
    {
      "codigo_valor_dominio": 3399,
      "codigo_referencia_valor_dominio": "821330",
      "nome_resumido_valor_dominio": "OPERADOR DE MONTAGEM DE CILINDROS E MANCAIS",
      "nome_completo_valor_dominio": "OPERADOR DE MONTAGEM DE CILINDROS E MANCAIS",
      "descricao_conceito_valor_dominio": "OPERADOR DE MONTAGEM DE CILINDROS E MANCAIS"
    },
    {
      "codigo_valor_dominio": 3400,
      "codigo_referencia_valor_dominio": "782135",
      "nome_resumido_valor_dominio": "OPERADOR DE PORTICO ROLANTE",
      "nome_completo_valor_dominio": "OPERADOR DE PORTICO ROLANTE",
      "descricao_conceito_valor_dominio": "OPERADOR DE PORTICO ROLANTE"
    },
    {
      "codigo_valor_dominio": 3401,
      "codigo_referencia_valor_dominio": "773420",
      "nome_resumido_valor_dominio": "OPERADOR DE PRENSA DE ALTA FREQUENCIA NA USINAGEM DE MADEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE PRENSA DE ALTA FREQUENCIA NA USINAGEM DE MADEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE PRENSA DE ALTA FREQUENCIA NA USINAGEM DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 3402,
      "codigo_referencia_valor_dominio": "782630",
      "nome_resumido_valor_dominio": "OPERADOR DE TELEFERICO (PASSAGEIROS)",
      "nome_completo_valor_dominio": "OPERADOR DE TELEFERICO (PASSAGEIROS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE TELEFERICO (PASSAGEIROS)"
    },
    {
      "codigo_valor_dominio": 3403,
      "codigo_referencia_valor_dominio": "251120",
      "nome_resumido_valor_dominio": "SOCIOLOGO",
      "nome_completo_valor_dominio": "SOCIOLOGO",
      "descricao_conceito_valor_dominio": "SOCIOLOGO"
    },
    {
      "codigo_valor_dominio": 3404,
      "codigo_referencia_valor_dominio": "841444",
      "nome_resumido_valor_dominio": "HIDROGENADOR DE OLEOS E GORDURAS",
      "nome_completo_valor_dominio": "HIDROGENADOR DE OLEOS E GORDURAS",
      "descricao_conceito_valor_dominio": "HIDROGENADOR DE OLEOS E GORDURAS"
    },
    {
      "codigo_valor_dominio": 3405,
      "codigo_referencia_valor_dominio": "782105",
      "nome_resumido_valor_dominio": "OPERADOR DE DRAGA",
      "nome_completo_valor_dominio": "OPERADOR DE DRAGA",
      "descricao_conceito_valor_dominio": "OPERADOR DE DRAGA"
    },
    {
      "codigo_valor_dominio": 3406,
      "codigo_referencia_valor_dominio": "811620",
      "nome_resumido_valor_dominio": "OPERADOR DE ENFORNAMENTO E DESENFORNAMENTO DE COQUE",
      "nome_completo_valor_dominio": "OPERADOR DE ENFORNAMENTO E DESENFORNAMENTO DE COQUE",
      "descricao_conceito_valor_dominio": "OPERADOR DE ENFORNAMENTO E DESENFORNAMENTO DE COQUE"
    },
    {
      "codigo_valor_dominio": 3407,
      "codigo_referencia_valor_dominio": "782310",
      "nome_resumido_valor_dominio": "MOTORISTA DE FURGAO OU VEICULO SIMILAR",
      "nome_completo_valor_dominio": "MOTORISTA DE FURGAO OU VEICULO SIMILAR",
      "descricao_conceito_valor_dominio": "MOTORISTA DE FURGAO OU VEICULO SIMILAR"
    },
    {
      "codigo_valor_dominio": 3408,
      "codigo_referencia_valor_dominio": "782405",
      "nome_resumido_valor_dominio": "MOTORISTA DE ONIBUS RODOVIARIO",
      "nome_completo_valor_dominio": "MOTORISTA DE ONIBUS RODOVIARIO",
      "descricao_conceito_valor_dominio": "MOTORISTA DE ONIBUS RODOVIARIO"
    },
    {
      "codigo_valor_dominio": 3409,
      "codigo_referencia_valor_dominio": "782415",
      "nome_resumido_valor_dominio": "MOTORISTA DE TROLEBUS",
      "nome_completo_valor_dominio": "MOTORISTA DE TROLEBUS",
      "descricao_conceito_valor_dominio": "MOTORISTA DE TROLEBUS"
    },
    {
      "codigo_valor_dominio": 3410,
      "codigo_referencia_valor_dominio": "782410",
      "nome_resumido_valor_dominio": "MOTORISTA DE ONIBUS URBANO",
      "nome_completo_valor_dominio": "MOTORISTA DE ONIBUS URBANO",
      "descricao_conceito_valor_dominio": "MOTORISTA DE ONIBUS URBANO"
    },
    {
      "codigo_valor_dominio": 3411,
      "codigo_referencia_valor_dominio": "782315",
      "nome_resumido_valor_dominio": "MOTORISTA DE TAXI",
      "nome_completo_valor_dominio": "MOTORISTA DE TAXI",
      "descricao_conceito_valor_dominio": "MOTORISTA DE TAXI"
    },
    {
      "codigo_valor_dominio": 3412,
      "codigo_referencia_valor_dominio": "782515",
      "nome_resumido_valor_dominio": "MOTORISTA OPERACIONAL DE GUINCHO",
      "nome_completo_valor_dominio": "MOTORISTA OPERACIONAL DE GUINCHO",
      "descricao_conceito_valor_dominio": "MOTORISTA OPERACIONAL DE GUINCHO"
    },
    {
      "codigo_valor_dominio": 3413,
      "codigo_referencia_valor_dominio": "782505",
      "nome_resumido_valor_dominio": "CAMINHONEIRO AUTONOMO (ROTAS REGIONAIS E INTERNACIONAIS)",
      "nome_completo_valor_dominio": "CAMINHONEIRO AUTONOMO (ROTAS REGIONAIS E INTERNACIONAIS)",
      "descricao_conceito_valor_dominio": "CAMINHONEIRO AUTONOMO (ROTAS REGIONAIS E INTERNACIONAIS)"
    },
    {
      "codigo_valor_dominio": 3414,
      "codigo_referencia_valor_dominio": "782305",
      "nome_resumido_valor_dominio": "MOTORISTA DE CARRO DE PASSEIO",
      "nome_completo_valor_dominio": "MOTORISTA DE CARRO DE PASSEIO",
      "descricao_conceito_valor_dominio": "MOTORISTA DE CARRO DE PASSEIO"
    },
    {
      "codigo_valor_dominio": 3415,
      "codigo_referencia_valor_dominio": "782620",
      "nome_resumido_valor_dominio": "MOTORNEIRO",
      "nome_completo_valor_dominio": "MOTORNEIRO",
      "descricao_conceito_valor_dominio": "MOTORNEIRO"
    },
    {
      "codigo_valor_dominio": 3416,
      "codigo_referencia_valor_dominio": "415210",
      "nome_resumido_valor_dominio": "OPERADOR DE TRIAGEM E TRANSBORDO",
      "nome_completo_valor_dominio": "OPERADOR DE TRIAGEM E TRANSBORDO",
      "descricao_conceito_valor_dominio": "OPERADOR DE TRIAGEM E TRANSBORDO"
    },
    {
      "codigo_valor_dominio": 3417,
      "codigo_referencia_valor_dominio": "782615",
      "nome_resumido_valor_dominio": "MAQUINISTA DE TREM METROPOLITANO",
      "nome_completo_valor_dominio": "MAQUINISTA DE TREM METROPOLITANO",
      "descricao_conceito_valor_dominio": "MAQUINISTA DE TREM METROPOLITANO"
    },
    {
      "codigo_valor_dominio": 3418,
      "codigo_referencia_valor_dominio": "763315",
      "nome_resumido_valor_dominio": "MARCADOR DE PECAS CONFECCIONADAS PARA BORDAR",
      "nome_completo_valor_dominio": "MARCADOR DE PECAS CONFECCIONADAS PARA BORDAR",
      "descricao_conceito_valor_dominio": "MARCADOR DE PECAS CONFECCIONADAS PARA BORDAR"
    },
    {
      "codigo_valor_dominio": 3419,
      "codigo_referencia_valor_dominio": "261310",
      "nome_resumido_valor_dominio": "MUSEOLOGO",
      "nome_completo_valor_dominio": "MUSEOLOGO",
      "descricao_conceito_valor_dominio": "MUSEOLOGO"
    },
    {
      "codigo_valor_dominio": 3420,
      "codigo_referencia_valor_dominio": "782625",
      "nome_resumido_valor_dominio": "AUXILIAR DE MAQUINISTA DE TREM",
      "nome_completo_valor_dominio": "AUXILIAR DE MAQUINISTA DE TREM",
      "descricao_conceito_valor_dominio": "AUXILIAR DE MAQUINISTA DE TREM"
    },
    {
      "codigo_valor_dominio": 3421,
      "codigo_referencia_valor_dominio": "422305",
      "nome_resumido_valor_dominio": "OPERADOR DE TELEMARKETING ATIVO",
      "nome_completo_valor_dominio": "OPERADOR DE TELEMARKETING ATIVO",
      "descricao_conceito_valor_dominio": "OPERADOR DE TELEMARKETING ATIVO"
    },
    {
      "codigo_valor_dominio": 3422,
      "codigo_referencia_valor_dominio": "782725",
      "nome_resumido_valor_dominio": "MARINHEIRO DE ESPORTE E RECREIO",
      "nome_completo_valor_dominio": "MARINHEIRO DE ESPORTE E RECREIO",
      "descricao_conceito_valor_dominio": "MARINHEIRO DE ESPORTE E RECREIO"
    },
    {
      "codigo_valor_dominio": 3423,
      "codigo_referencia_valor_dominio": "716525",
      "nome_resumido_valor_dominio": "MARMORISTA (CONSTRUCAO)",
      "nome_completo_valor_dominio": "MARMORISTA (CONSTRUCAO)",
      "descricao_conceito_valor_dominio": "MARMORISTA (CONSTRUCAO)"
    },
    {
      "codigo_valor_dominio": 3424,
      "codigo_referencia_valor_dominio": "782720",
      "nome_resumido_valor_dominio": "MOCO DE MAQUINAS (MARITIMO E FLUVIARIO)",
      "nome_completo_valor_dominio": "MOCO DE MAQUINAS (MARITIMO E FLUVIARIO)",
      "descricao_conceito_valor_dominio": "MOCO DE MAQUINAS (MARITIMO E FLUVIARIO)"
    },
    {
      "codigo_valor_dominio": 3425,
      "codigo_referencia_valor_dominio": "771110",
      "nome_resumido_valor_dominio": "MODELADOR DE MADEIRA",
      "nome_completo_valor_dominio": "MODELADOR DE MADEIRA",
      "descricao_conceito_valor_dominio": "MODELADOR DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 3426,
      "codigo_referencia_valor_dominio": "782710",
      "nome_resumido_valor_dominio": "MARINHEIRO DE MAQUINAS",
      "nome_completo_valor_dominio": "MARINHEIRO DE MAQUINAS",
      "descricao_conceito_valor_dominio": "MARINHEIRO DE MAQUINAS"
    },
    {
      "codigo_valor_dominio": 3427,
      "codigo_referencia_valor_dominio": "782805",
      "nome_resumido_valor_dominio": "CONDUTOR DE VEICULOS DE TRACAO ANIMAL (RUAS E ESTRADAS)",
      "nome_completo_valor_dominio": "CONDUTOR DE VEICULOS DE TRACAO ANIMAL (RUAS E ESTRADAS)",
      "descricao_conceito_valor_dominio": "CONDUTOR DE VEICULOS DE TRACAO ANIMAL (RUAS E ESTRADAS)"
    },
    {
      "codigo_valor_dominio": 3428,
      "codigo_referencia_valor_dominio": "122520",
      "nome_resumido_valor_dominio": "TURISMOLOGO",
      "nome_completo_valor_dominio": "TURISMOLOGO",
      "descricao_conceito_valor_dominio": "TURISMOLOGO"
    },
    {
      "codigo_valor_dominio": 3429,
      "codigo_referencia_valor_dominio": "782815",
      "nome_resumido_valor_dominio": "BOIADEIRO",
      "nome_completo_valor_dominio": "BOIADEIRO",
      "descricao_conceito_valor_dominio": "BOIADEIRO"
    },
    {
      "codigo_valor_dominio": 3430,
      "codigo_referencia_valor_dominio": "782820",
      "nome_resumido_valor_dominio": "CONDUTOR DE VEICULOS A PEDAIS",
      "nome_completo_valor_dominio": "CONDUTOR DE VEICULOS A PEDAIS",
      "descricao_conceito_valor_dominio": "CONDUTOR DE VEICULOS A PEDAIS"
    },
    {
      "codigo_valor_dominio": 3431,
      "codigo_referencia_valor_dominio": "783105",
      "nome_resumido_valor_dominio": "AGENTE DE PATIO",
      "nome_completo_valor_dominio": "AGENTE DE PATIO",
      "descricao_conceito_valor_dominio": "AGENTE DE PATIO"
    },
    {
      "codigo_valor_dominio": 3432,
      "codigo_referencia_valor_dominio": "848215",
      "nome_resumido_valor_dominio": "MANTEIGUEIRO NA FABRICACAO DE LATICINIO",
      "nome_completo_valor_dominio": "MANTEIGUEIRO NA FABRICACAO DE LATICINIO",
      "descricao_conceito_valor_dominio": "MANTEIGUEIRO NA FABRICACAO DE LATICINIO"
    },
    {
      "codigo_valor_dominio": 3433,
      "codigo_referencia_valor_dominio": "783205",
      "nome_resumido_valor_dominio": "CARREGADOR (AERONAVES)",
      "nome_completo_valor_dominio": "CARREGADOR (AERONAVES)",
      "descricao_conceito_valor_dominio": "CARREGADOR (AERONAVES)"
    },
    {
      "codigo_valor_dominio": 3434,
      "codigo_referencia_valor_dominio": "783210",
      "nome_resumido_valor_dominio": "CARREGADOR (ARMAZEM)",
      "nome_completo_valor_dominio": "CARREGADOR (ARMAZEM)",
      "descricao_conceito_valor_dominio": "CARREGADOR (ARMAZEM)"
    },
    {
      "codigo_valor_dominio": 3435,
      "codigo_referencia_valor_dominio": "783215",
      "nome_resumido_valor_dominio": "CARREGADOR (VEICULOS DE TRANSPORTES TERRESTRES)",
      "nome_completo_valor_dominio": "CARREGADOR (VEICULOS DE TRANSPORTES TERRESTRES)",
      "descricao_conceito_valor_dominio": "CARREGADOR (VEICULOS DE TRANSPORTES TERRESTRES)"
    },
    {
      "codigo_valor_dominio": 3436,
      "codigo_referencia_valor_dominio": "765230",
      "nome_resumido_valor_dominio": "ESTOFADOR DE AVIOES",
      "nome_completo_valor_dominio": "ESTOFADOR DE AVIOES",
      "descricao_conceito_valor_dominio": "ESTOFADOR DE AVIOES"
    },
    {
      "codigo_valor_dominio": 3437,
      "codigo_referencia_valor_dominio": "783225",
      "nome_resumido_valor_dominio": "AJUDANTE DE MOTORISTA",
      "nome_completo_valor_dominio": "AJUDANTE DE MOTORISTA",
      "descricao_conceito_valor_dominio": "AJUDANTE DE MOTORISTA"
    },
    {
      "codigo_valor_dominio": 3438,
      "codigo_referencia_valor_dominio": "784110",
      "nome_resumido_valor_dominio": "EMBALADOR, A MAQUINA",
      "nome_completo_valor_dominio": "EMBALADOR, A MAQUINA",
      "descricao_conceito_valor_dominio": "EMBALADOR, A MAQUINA"
    },
    {
      "codigo_valor_dominio": 3439,
      "codigo_referencia_valor_dominio": "328105",
      "nome_resumido_valor_dominio": "EMBALSAMADOR",
      "nome_completo_valor_dominio": "EMBALSAMADOR",
      "descricao_conceito_valor_dominio": "EMBALSAMADOR"
    },
    {
      "codigo_valor_dominio": 3440,
      "codigo_referencia_valor_dominio": "711220",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE EXTRACAO CONTINUA (MINAS DE CARVAO)",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE EXTRACAO CONTINUA (MINAS DE CARVAO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE EXTRACAO CONTINUA (MINAS DE CARVAO)"
    },
    {
      "codigo_valor_dominio": 3441,
      "codigo_referencia_valor_dominio": "784115",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE ETIQUETAR",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE ETIQUETAR",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE ETIQUETAR"
    },
    {
      "codigo_valor_dominio": 3442,
      "codigo_referencia_valor_dominio": "519215",
      "nome_resumido_valor_dominio": "OPERADOR DE PRENSA DE MATERIAL RECICLAVEL",
      "nome_completo_valor_dominio": "OPERADOR DE PRENSA DE MATERIAL RECICLAVEL",
      "descricao_conceito_valor_dominio": "OPERADOR DE PRENSA DE MATERIAL RECICLAVEL"
    },
    {
      "codigo_valor_dominio": 3443,
      "codigo_referencia_valor_dominio": "784205",
      "nome_resumido_valor_dominio": "ALIMENTADOR DE LINHA DE PRODUCAO",
      "nome_completo_valor_dominio": "ALIMENTADOR DE LINHA DE PRODUCAO",
      "descricao_conceito_valor_dominio": "ALIMENTADOR DE LINHA DE PRODUCAO"
    },
    {
      "codigo_valor_dominio": 3444,
      "codigo_referencia_valor_dominio": "791105",
      "nome_resumido_valor_dominio": "ARTESAO BORDADOR",
      "nome_completo_valor_dominio": "ARTESAO BORDADOR",
      "descricao_conceito_valor_dominio": "ARTESAO BORDADOR"
    },
    {
      "codigo_valor_dominio": 3445,
      "codigo_referencia_valor_dominio": "791110",
      "nome_resumido_valor_dominio": "ARTESAO CERAMISTA",
      "nome_completo_valor_dominio": "ARTESAO CERAMISTA",
      "descricao_conceito_valor_dominio": "ARTESAO CERAMISTA"
    },
    {
      "codigo_valor_dominio": 3446,
      "codigo_referencia_valor_dominio": "791115",
      "nome_resumido_valor_dominio": "ARTESAO COM MATERIAL RECICLAVEL",
      "nome_completo_valor_dominio": "ARTESAO COM MATERIAL RECICLAVEL",
      "descricao_conceito_valor_dominio": "ARTESAO COM MATERIAL RECICLAVEL"
    },
    {
      "codigo_valor_dominio": 3447,
      "codigo_referencia_valor_dominio": "791120",
      "nome_resumido_valor_dominio": "ARTESAO CONFECCIONADOR DE BIOJOIAS E ECOJOIAS",
      "nome_completo_valor_dominio": "ARTESAO CONFECCIONADOR DE BIOJOIAS E ECOJOIAS",
      "descricao_conceito_valor_dominio": "ARTESAO CONFECCIONADOR DE BIOJOIAS E ECOJOIAS"
    },
    {
      "codigo_valor_dominio": 3448,
      "codigo_referencia_valor_dominio": "791125",
      "nome_resumido_valor_dominio": "ARTESAO DO COURO",
      "nome_completo_valor_dominio": "ARTESAO DO COURO",
      "descricao_conceito_valor_dominio": "ARTESAO DO COURO"
    },
    {
      "codigo_valor_dominio": 3449,
      "codigo_referencia_valor_dominio": "791130",
      "nome_resumido_valor_dominio": "ARTESAO ESCULTOR",
      "nome_completo_valor_dominio": "ARTESAO ESCULTOR",
      "descricao_conceito_valor_dominio": "ARTESAO ESCULTOR"
    },
    {
      "codigo_valor_dominio": 3450,
      "codigo_referencia_valor_dominio": "791135",
      "nome_resumido_valor_dominio": "ARTESAO MOVELEIRO (EXCETO RECICLADO)",
      "nome_completo_valor_dominio": "ARTESAO MOVELEIRO (EXCETO RECICLADO)",
      "descricao_conceito_valor_dominio": "ARTESAO MOVELEIRO (EXCETO RECICLADO)"
    },
    {
      "codigo_valor_dominio": 3451,
      "codigo_referencia_valor_dominio": "791140",
      "nome_resumido_valor_dominio": "ARTESAO TECELAO",
      "nome_completo_valor_dominio": "ARTESAO TECELAO",
      "descricao_conceito_valor_dominio": "ARTESAO TECELAO"
    },
    {
      "codigo_valor_dominio": 3452,
      "codigo_referencia_valor_dominio": "791145",
      "nome_resumido_valor_dominio": "ARTESAO TRANCADOR",
      "nome_completo_valor_dominio": "ARTESAO TRANCADOR",
      "descricao_conceito_valor_dominio": "ARTESAO TRANCADOR"
    },
    {
      "codigo_valor_dominio": 3453,
      "codigo_referencia_valor_dominio": "791150",
      "nome_resumido_valor_dominio": "ARTESAO CROCHETEIRO",
      "nome_completo_valor_dominio": "ARTESAO CROCHETEIRO",
      "descricao_conceito_valor_dominio": "ARTESAO CROCHETEIRO"
    },
    {
      "codigo_valor_dominio": 3454,
      "codigo_referencia_valor_dominio": "791155",
      "nome_resumido_valor_dominio": "ARTESAO TRICOTEIRO",
      "nome_completo_valor_dominio": "ARTESAO TRICOTEIRO",
      "descricao_conceito_valor_dominio": "ARTESAO TRICOTEIRO"
    },
    {
      "codigo_valor_dominio": 3455,
      "codigo_referencia_valor_dominio": "791160",
      "nome_resumido_valor_dominio": "ARTESAO RENDEIRO",
      "nome_completo_valor_dominio": "ARTESAO RENDEIRO",
      "descricao_conceito_valor_dominio": "ARTESAO RENDEIRO"
    },
    {
      "codigo_valor_dominio": 3456,
      "codigo_referencia_valor_dominio": "760125",
      "nome_resumido_valor_dominio": "MESTRE (INDUSTRIA TEXTIL E DE CONFECCOES)",
      "nome_completo_valor_dominio": "MESTRE (INDUSTRIA TEXTIL E DE CONFECCOES)",
      "descricao_conceito_valor_dominio": "MESTRE (INDUSTRIA TEXTIL E DE CONFECCOES)"
    },
    {
      "codigo_valor_dominio": 3457,
      "codigo_referencia_valor_dominio": "820105",
      "nome_resumido_valor_dominio": "MESTRE DE SIDERURGIA",
      "nome_completo_valor_dominio": "MESTRE DE SIDERURGIA",
      "descricao_conceito_valor_dominio": "MESTRE DE SIDERURGIA"
    },
    {
      "codigo_valor_dominio": 3458,
      "codigo_referencia_valor_dominio": "830105",
      "nome_resumido_valor_dominio": "MESTRE (INDUSTRIA DE CELULOSE, PAPEL E PAPELAO)",
      "nome_completo_valor_dominio": "MESTRE (INDUSTRIA DE CELULOSE, PAPEL E PAPELAO)",
      "descricao_conceito_valor_dominio": "MESTRE (INDUSTRIA DE CELULOSE, PAPEL E PAPELAO)"
    },
    {
      "codigo_valor_dominio": 3459,
      "codigo_referencia_valor_dominio": "810110",
      "nome_resumido_valor_dominio": "MESTRE DE PRODUCAO QUIMICA",
      "nome_completo_valor_dominio": "MESTRE DE PRODUCAO QUIMICA",
      "descricao_conceito_valor_dominio": "MESTRE DE PRODUCAO QUIMICA"
    },
    {
      "codigo_valor_dominio": 3460,
      "codigo_referencia_valor_dominio": "813125",
      "nome_resumido_valor_dominio": "OPERADOR DE PRODUCAO (QUIMICA, PETROQUIMICA E AFINS)",
      "nome_completo_valor_dominio": "OPERADOR DE PRODUCAO (QUIMICA, PETROQUIMICA E AFINS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE PRODUCAO (QUIMICA, PETROQUIMICA E AFINS)"
    },
    {
      "codigo_valor_dominio": 3461,
      "codigo_referencia_valor_dominio": "711410",
      "nome_resumido_valor_dominio": "OPERADOR DE SALINA (SAL MARINHO)",
      "nome_completo_valor_dominio": "OPERADOR DE SALINA (SAL MARINHO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE SALINA (SAL MARINHO)"
    },
    {
      "codigo_valor_dominio": 3462,
      "codigo_referencia_valor_dominio": "841105",
      "nome_resumido_valor_dominio": "MOLEIRO DE CEREAIS (EXCETO ARROZ)",
      "nome_completo_valor_dominio": "MOLEIRO DE CEREAIS (EXCETO ARROZ)",
      "descricao_conceito_valor_dominio": "MOLEIRO DE CEREAIS (EXCETO ARROZ)"
    },
    {
      "codigo_valor_dominio": 3463,
      "codigo_referencia_valor_dominio": "711225",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA PERFURADORA (MINAS E PEDREIRAS)",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA PERFURADORA (MINAS E PEDREIRAS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA PERFURADORA (MINAS E PEDREIRAS)"
    },
    {
      "codigo_valor_dominio": 3464,
      "codigo_referencia_valor_dominio": "811605",
      "nome_resumido_valor_dominio": "OPERADOR DE BRITADOR DE COQUE",
      "nome_completo_valor_dominio": "OPERADOR DE BRITADOR DE COQUE",
      "descricao_conceito_valor_dominio": "OPERADOR DE BRITADOR DE COQUE"
    },
    {
      "codigo_valor_dominio": 3465,
      "codigo_referencia_valor_dominio": "761225",
      "nome_resumido_valor_dominio": "OPERADOR DE CONICALEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE CONICALEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE CONICALEIRA"
    },
    {
      "codigo_valor_dominio": 3466,
      "codigo_referencia_valor_dominio": "514325",
      "nome_resumido_valor_dominio": "TRABALHADOR DA MANUTENCAO DE EDIFICACOES",
      "nome_completo_valor_dominio": "TRABALHADOR DA MANUTENCAO DE EDIFICACOES",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA MANUTENCAO DE EDIFICACOES"
    },
    {
      "codigo_valor_dominio": 3467,
      "codigo_referencia_valor_dominio": "841720",
      "nome_resumido_valor_dominio": "TRABALHADOR DE FABRICACAO DE VINHOS",
      "nome_completo_valor_dominio": "TRABALHADOR DE FABRICACAO DE VINHOS",
      "descricao_conceito_valor_dominio": "TRABALHADOR DE FABRICACAO DE VINHOS"
    },
    {
      "codigo_valor_dominio": 3468,
      "codigo_referencia_valor_dominio": "862120",
      "nome_resumido_valor_dominio": "OPERADOR DE CALDEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE CALDEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE CALDEIRA"
    },
    {
      "codigo_valor_dominio": 3469,
      "codigo_referencia_valor_dominio": "711245",
      "nome_resumido_valor_dominio": "OPERADOR DE TRATOR (MINAS E PEDREIRAS)",
      "nome_completo_valor_dominio": "OPERADOR DE TRATOR (MINAS E PEDREIRAS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE TRATOR (MINAS E PEDREIRAS)"
    },
    {
      "codigo_valor_dominio": 3470,
      "codigo_referencia_valor_dominio": "821105",
      "nome_resumido_valor_dominio": "OPERADOR DE CENTRO DE CONTROLE",
      "nome_completo_valor_dominio": "OPERADOR DE CENTRO DE CONTROLE",
      "descricao_conceito_valor_dominio": "OPERADOR DE CENTRO DE CONTROLE"
    },
    {
      "codigo_valor_dominio": 3471,
      "codigo_referencia_valor_dominio": "373115",
      "nome_resumido_valor_dominio": "OPERADOR DE EXTERNA (RADIO)",
      "nome_completo_valor_dominio": "OPERADOR DE EXTERNA (RADIO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE EXTERNA (RADIO)"
    },
    {
      "codigo_valor_dominio": 3472,
      "codigo_referencia_valor_dominio": "811320",
      "nome_resumido_valor_dominio": "OPERADOR DE FILTRO DE TAMBOR ROTATIVO (TRATAMENTOS QUIMICOS",
      "nome_completo_valor_dominio": "OPERADOR DE FILTRO DE TAMBOR ROTATIVO (TRATAMENTOS QUIMICOS E AFINS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE FILTRO DE TAMBOR ROTATIVO (TRATAMENTOS QUIMICOS E AFINS)"
    },
    {
      "codigo_valor_dominio": 3473,
      "codigo_referencia_valor_dominio": "811325",
      "nome_resumido_valor_dominio": "OPERADOR DE FILTRO-ESTEIRA (MINERACAO)",
      "nome_completo_valor_dominio": "OPERADOR DE FILTRO-ESTEIRA (MINERACAO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE FILTRO-ESTEIRA (MINERACAO)"
    },
    {
      "codigo_valor_dominio": 3474,
      "codigo_referencia_valor_dominio": "811330",
      "nome_resumido_valor_dominio": "OPERADOR DE FILTRO-PRENSA (TRATAMENTOS QUIMICOS E AFINS)",
      "nome_completo_valor_dominio": "OPERADOR DE FILTRO-PRENSA (TRATAMENTOS QUIMICOS E AFINS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE FILTRO-PRENSA (TRATAMENTOS QUIMICOS E AFINS)"
    },
    {
      "codigo_valor_dominio": 3475,
      "codigo_referencia_valor_dominio": "811335",
      "nome_resumido_valor_dominio": "OPERADOR DE FILTROS DE PARAFINA (TRATAMENTOS QUIMICOS E AFIN",
      "nome_completo_valor_dominio": "OPERADOR DE FILTROS DE PARAFINA (TRATAMENTOS QUIMICOS E AFINS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE FILTROS DE PARAFINA (TRATAMENTOS QUIMICOS E AFINS)"
    },
    {
      "codigo_valor_dominio": 3476,
      "codigo_referencia_valor_dominio": "841805",
      "nome_resumido_valor_dominio": "OPERADOR DE FORNO (FABRICACAO DE PAES, BISCOITOS E SIMILARES",
      "nome_completo_valor_dominio": "OPERADOR DE FORNO (FABRICACAO DE PAES, BISCOITOS E SIMILARES)",
      "descricao_conceito_valor_dominio": "OPERADOR DE FORNO (FABRICACAO DE PAES, BISCOITOS E SIMILARES)"
    },
    {
      "codigo_valor_dominio": 3477,
      "codigo_referencia_valor_dominio": "811410",
      "nome_resumido_valor_dominio": "DESTILADOR DE PRODUTOS QUIMICOS (EXCETO PETROLEO)",
      "nome_completo_valor_dominio": "DESTILADOR DE PRODUTOS QUIMICOS (EXCETO PETROLEO)",
      "descricao_conceito_valor_dominio": "DESTILADOR DE PRODUTOS QUIMICOS (EXCETO PETROLEO)"
    },
    {
      "codigo_valor_dominio": 3478,
      "codigo_referencia_valor_dominio": "711115",
      "nome_resumido_valor_dominio": "DESTROCADOR DE PEDRA",
      "nome_completo_valor_dominio": "DESTROCADOR DE PEDRA",
      "descricao_conceito_valor_dominio": "DESTROCADOR DE PEDRA"
    },
    {
      "codigo_valor_dominio": 3479,
      "codigo_referencia_valor_dominio": "712110",
      "nome_resumido_valor_dominio": "OPERADOR DE APARELHO DE FLOTACAO",
      "nome_completo_valor_dominio": "OPERADOR DE APARELHO DE FLOTACAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE APARELHO DE FLOTACAO"
    },
    {
      "codigo_valor_dominio": 3480,
      "codigo_referencia_valor_dominio": "821245",
      "nome_resumido_valor_dominio": "OPERADOR DE AREA DE CORRIDA",
      "nome_completo_valor_dominio": "OPERADOR DE AREA DE CORRIDA",
      "descricao_conceito_valor_dominio": "OPERADOR DE AREA DE CORRIDA"
    },
    {
      "codigo_valor_dominio": 3481,
      "codigo_referencia_valor_dominio": "723305",
      "nome_resumido_valor_dominio": "OPERADOR DE EQUIPAMENTO DE SECAGEM DE PINTURA",
      "nome_completo_valor_dominio": "OPERADOR DE EQUIPAMENTO DE SECAGEM DE PINTURA",
      "descricao_conceito_valor_dominio": "OPERADOR DE EQUIPAMENTO DE SECAGEM DE PINTURA"
    },
    {
      "codigo_valor_dominio": 3482,
      "codigo_referencia_valor_dominio": "811625",
      "nome_resumido_valor_dominio": "OPERADOR DE EXAUSTOR (COQUERIA)",
      "nome_completo_valor_dominio": "OPERADOR DE EXAUSTOR (COQUERIA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE EXAUSTOR (COQUERIA)"
    },
    {
      "codigo_valor_dominio": 3483,
      "codigo_referencia_valor_dominio": "761250",
      "nome_resumido_valor_dominio": "OPERADOR DE PASSADOR (FIACAO)",
      "nome_completo_valor_dominio": "OPERADOR DE PASSADOR (FIACAO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE PASSADOR (FIACAO)"
    },
    {
      "codigo_valor_dominio": 3484,
      "codigo_referencia_valor_dominio": "373125",
      "nome_resumido_valor_dominio": "OPERADOR DE TRANSMISSOR DE RADIO",
      "nome_completo_valor_dominio": "OPERADOR DE TRANSMISSOR DE RADIO",
      "descricao_conceito_valor_dominio": "OPERADOR DE TRANSMISSOR DE RADIO"
    },
    {
      "codigo_valor_dominio": 3485,
      "codigo_referencia_valor_dominio": "712120",
      "nome_resumido_valor_dominio": "OPERADOR DE BRITADOR DE MANDIBULAS",
      "nome_completo_valor_dominio": "OPERADOR DE BRITADOR DE MANDIBULAS",
      "descricao_conceito_valor_dominio": "OPERADOR DE BRITADOR DE MANDIBULAS"
    },
    {
      "codigo_valor_dominio": 3486,
      "codigo_referencia_valor_dominio": "992215",
      "nome_resumido_valor_dominio": "OPERADOR DE CEIFADEIRA NA CONSERVACAO DE VIAS PERMANENTES",
      "nome_completo_valor_dominio": "OPERADOR DE CEIFADEIRA NA CONSERVACAO DE VIAS PERMANENTES",
      "descricao_conceito_valor_dominio": "OPERADOR DE CEIFADEIRA NA CONSERVACAO DE VIAS PERMANENTES"
    },
    {
      "codigo_valor_dominio": 3487,
      "codigo_referencia_valor_dominio": "831115",
      "nome_resumido_valor_dominio": "OPERADOR DE DIGESTOR DE PASTA PARA FABRICACAO DE PAPEL",
      "nome_completo_valor_dominio": "OPERADOR DE DIGESTOR DE PASTA PARA FABRICACAO DE PAPEL",
      "descricao_conceito_valor_dominio": "OPERADOR DE DIGESTOR DE PASTA PARA FABRICACAO DE PAPEL"
    },
    {
      "codigo_valor_dominio": 3488,
      "codigo_referencia_valor_dominio": "761348",
      "nome_resumido_valor_dominio": "OPERADOR DE ENGOMADEIRA DE URDUME",
      "nome_completo_valor_dominio": "OPERADOR DE ENGOMADEIRA DE URDUME",
      "descricao_conceito_valor_dominio": "OPERADOR DE ENGOMADEIRA DE URDUME"
    },
    {
      "codigo_valor_dominio": 3489,
      "codigo_referencia_valor_dominio": "811310",
      "nome_resumido_valor_dominio": "OPERADOR DE EXPLORACAO DE PETROLEO",
      "nome_completo_valor_dominio": "OPERADOR DE EXPLORACAO DE PETROLEO",
      "descricao_conceito_valor_dominio": "OPERADOR DE EXPLORACAO DE PETROLEO"
    },
    {
      "codigo_valor_dominio": 3490,
      "codigo_referencia_valor_dominio": "811505",
      "nome_resumido_valor_dominio": "OPERADOR DE PAINEL DE CONTROLE (REFINACAO DE PETROLEO)",
      "nome_completo_valor_dominio": "OPERADOR DE PAINEL DE CONTROLE (REFINACAO DE PETROLEO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE PAINEL DE CONTROLE (REFINACAO DE PETROLEO)"
    },
    {
      "codigo_valor_dominio": 3491,
      "codigo_referencia_valor_dominio": "813120",
      "nome_resumido_valor_dominio": "OPERADOR DE PROCESSO (QUIMICA, PETROQUIMICA E AFINS)",
      "nome_completo_valor_dominio": "OPERADOR DE PROCESSO (QUIMICA, PETROQUIMICA E AFINS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE PROCESSO (QUIMICA, PETROQUIMICA E AFINS)"
    },
    {
      "codigo_valor_dominio": 3492,
      "codigo_referencia_valor_dominio": "861120",
      "nome_resumido_valor_dominio": "OPERADOR DE REATOR NUCLEAR",
      "nome_completo_valor_dominio": "OPERADOR DE REATOR NUCLEAR",
      "descricao_conceito_valor_dominio": "OPERADOR DE REATOR NUCLEAR"
    },
    {
      "codigo_valor_dominio": 3493,
      "codigo_referencia_valor_dominio": "862510",
      "nome_resumido_valor_dominio": "OPERADOR DE REFRIGERACAO COM AMONIA",
      "nome_completo_valor_dominio": "OPERADOR DE REFRIGERACAO COM AMONIA",
      "descricao_conceito_valor_dominio": "OPERADOR DE REFRIGERACAO COM AMONIA"
    },
    {
      "codigo_valor_dominio": 3494,
      "codigo_referencia_valor_dominio": "766145",
      "nome_resumido_valor_dominio": "OPERADOR DE SISTEMAS DE PROVA (ANALOGICO E DIGITAL)",
      "nome_completo_valor_dominio": "OPERADOR DE SISTEMAS DE PROVA (ANALOGICO E DIGITAL)",
      "descricao_conceito_valor_dominio": "OPERADOR DE SISTEMAS DE PROVA (ANALOGICO E DIGITAL)"
    },
    {
      "codigo_valor_dominio": 3495,
      "codigo_referencia_valor_dominio": "811705",
      "nome_resumido_valor_dominio": "BAMBURISTA",
      "nome_completo_valor_dominio": "BAMBURISTA",
      "descricao_conceito_valor_dominio": "BAMBURISTA"
    },
    {
      "codigo_valor_dominio": 3496,
      "codigo_referencia_valor_dominio": "811710",
      "nome_resumido_valor_dominio": "CALANDRISTA DE BORRACHA",
      "nome_completo_valor_dominio": "CALANDRISTA DE BORRACHA",
      "descricao_conceito_valor_dominio": "CALANDRISTA DE BORRACHA"
    },
    {
      "codigo_valor_dominio": 3497,
      "codigo_referencia_valor_dominio": "833115",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE SACOS DE CELOFANE, A MAQUINA",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE SACOS DE CELOFANE, A MAQUINA",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE SACOS DE CELOFANE, A MAQUINA"
    },
    {
      "codigo_valor_dominio": 3498,
      "codigo_referencia_valor_dominio": "811735",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE VELAS POR MOLDAGEM",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE VELAS POR MOLDAGEM",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE VELAS POR MOLDAGEM"
    },
    {
      "codigo_valor_dominio": 3499,
      "codigo_referencia_valor_dominio": "848310",
      "nome_resumido_valor_dominio": "CONFEITEIRO",
      "nome_completo_valor_dominio": "CONFEITEIRO",
      "descricao_conceito_valor_dominio": "CONFEITEIRO"
    },
    {
      "codigo_valor_dominio": 3500,
      "codigo_referencia_valor_dominio": "751020",
      "nome_resumido_valor_dominio": "LAPIDADOR (JOIAS)",
      "nome_completo_valor_dominio": "LAPIDADOR (JOIAS)",
      "descricao_conceito_valor_dominio": "LAPIDADOR (JOIAS)"
    },
    {
      "codigo_valor_dominio": 3501,
      "codigo_referencia_valor_dominio": "715310",
      "nome_resumido_valor_dominio": "MOLDADOR DE CORPOS DE PROVA EM USINAS DE CONCRETO",
      "nome_completo_valor_dominio": "MOLDADOR DE CORPOS DE PROVA EM USINAS DE CONCRETO",
      "descricao_conceito_valor_dominio": "MOLDADOR DE CORPOS DE PROVA EM USINAS DE CONCRETO"
    },
    {
      "codigo_valor_dominio": 3502,
      "codigo_referencia_valor_dominio": "811770",
      "nome_resumido_valor_dominio": "MOLDADOR DE PLASTICO POR INJECAO",
      "nome_completo_valor_dominio": "MOLDADOR DE PLASTICO POR INJECAO",
      "descricao_conceito_valor_dominio": "MOLDADOR DE PLASTICO POR INJECAO"
    },
    {
      "codigo_valor_dominio": 3503,
      "codigo_referencia_valor_dominio": "722315",
      "nome_resumido_valor_dominio": "MOLDADOR, A MAO",
      "nome_completo_valor_dominio": "MOLDADOR, A MAO",
      "descricao_conceito_valor_dominio": "MOLDADOR, A MAO"
    },
    {
      "codigo_valor_dominio": 3504,
      "codigo_referencia_valor_dominio": "722415",
      "nome_resumido_valor_dominio": "TREFILADOR DE METAIS, A MAQUINA",
      "nome_completo_valor_dominio": "TREFILADOR DE METAIS, A MAQUINA",
      "descricao_conceito_valor_dominio": "TREFILADOR DE METAIS, A MAQUINA"
    },
    {
      "codigo_valor_dominio": 3505,
      "codigo_referencia_valor_dominio": "831125",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE SECAR CELULOSE",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE SECAR CELULOSE",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE SECAR CELULOSE"
    },
    {
      "codigo_valor_dominio": 3506,
      "codigo_referencia_valor_dominio": "262820",
      "nome_resumido_valor_dominio": "DRAMATURGO DE DANCA",
      "nome_completo_valor_dominio": "DRAMATURGO DE DANCA",
      "descricao_conceito_valor_dominio": "DRAMATURGO DE DANCA"
    },
    {
      "codigo_valor_dominio": 3507,
      "codigo_referencia_valor_dominio": "811820",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE FABRICACAO DE PRODUTOS DE HIGIENE E L",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE FABRICACAO DE PRODUTOS DE HIGIENE E LIMPEZA (SABAO, SABONETE, DETERGENTE,",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE FABRICACAO DE PRODUTOS DE HIGIENE E LIMPEZA (SABAO, SABONETE, DETERGENTE,"
    },
    {
      "codigo_valor_dominio": 3508,
      "codigo_referencia_valor_dominio": "842210",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE FABRICAR CHARUTOS E CIGARRILHAS",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE FABRICAR CHARUTOS E CIGARRILHAS",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE FABRICAR CHARUTOS E CIGARRILHAS"
    },
    {
      "codigo_valor_dominio": 3509,
      "codigo_referencia_valor_dominio": "513610",
      "nome_resumido_valor_dominio": "PIZZAIOLO",
      "nome_completo_valor_dominio": "PIZZAIOLO",
      "descricao_conceito_valor_dominio": "PIZZAIOLO"
    },
    {
      "codigo_valor_dominio": 3510,
      "codigo_referencia_valor_dominio": "823330",
      "nome_resumido_valor_dominio": "TRABALHADOR DA FABRICACAO DE PEDRAS ARTIFICIAIS",
      "nome_completo_valor_dominio": "TRABALHADOR DA FABRICACAO DE PEDRAS ARTIFICIAIS",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA FABRICACAO DE PEDRAS ARTIFICIAIS"
    },
    {
      "codigo_valor_dominio": 3511,
      "codigo_referencia_valor_dominio": "813105",
      "nome_resumido_valor_dominio": "CILINDRISTA (PETROQUIMICA E AFINS)",
      "nome_completo_valor_dominio": "CILINDRISTA (PETROQUIMICA E AFINS)",
      "descricao_conceito_valor_dominio": "CILINDRISTA (PETROQUIMICA E AFINS)"
    },
    {
      "codigo_valor_dominio": 3512,
      "codigo_referencia_valor_dominio": "761415",
      "nome_resumido_valor_dominio": "OPERADOR DE CALANDRAS (TECIDOS)",
      "nome_completo_valor_dominio": "OPERADOR DE CALANDRAS (TECIDOS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE CALANDRAS (TECIDOS)"
    },
    {
      "codigo_valor_dominio": 3513,
      "codigo_referencia_valor_dominio": "761230",
      "nome_resumido_valor_dominio": "OPERADOR DE FILATORIO",
      "nome_completo_valor_dominio": "OPERADOR DE FILATORIO",
      "descricao_conceito_valor_dominio": "OPERADOR DE FILATORIO"
    },
    {
      "codigo_valor_dominio": 3514,
      "codigo_referencia_valor_dominio": "841115",
      "nome_resumido_valor_dominio": "OPERADOR DE PROCESSO DE MOAGEM",
      "nome_completo_valor_dominio": "OPERADOR DE PROCESSO DE MOAGEM",
      "descricao_conceito_valor_dominio": "OPERADOR DE PROCESSO DE MOAGEM"
    },
    {
      "codigo_valor_dominio": 3515,
      "codigo_referencia_valor_dominio": "374305",
      "nome_resumido_valor_dominio": "OPERADOR DE PROJETOR CINEMATOGRAFICO",
      "nome_completo_valor_dominio": "OPERADOR DE PROJETOR CINEMATOGRAFICO",
      "descricao_conceito_valor_dominio": "OPERADOR DE PROJETOR CINEMATOGRAFICO"
    },
    {
      "codigo_valor_dominio": 3516,
      "codigo_referencia_valor_dominio": "353205",
      "nome_resumido_valor_dominio": "TECNICO DE OPERACOES E SERVICOS BANCARIOS - CAMBIO",
      "nome_completo_valor_dominio": "TECNICO DE OPERACOES E SERVICOS BANCARIOS - CAMBIO",
      "descricao_conceito_valor_dominio": "TECNICO DE OPERACOES E SERVICOS BANCARIOS - CAMBIO"
    },
    {
      "codigo_valor_dominio": 3517,
      "codigo_referencia_valor_dominio": "818105",
      "nome_resumido_valor_dominio": "ASSISTENTE DE LABORATORIO INDUSTRIAL",
      "nome_completo_valor_dominio": "ASSISTENTE DE LABORATORIO INDUSTRIAL",
      "descricao_conceito_valor_dominio": "ASSISTENTE DE LABORATORIO INDUSTRIAL"
    },
    {
      "codigo_valor_dominio": 3518,
      "codigo_referencia_valor_dominio": "818110",
      "nome_resumido_valor_dominio": "AUXILIAR DE LABORATORIO DE ANALISES FISICO-QUIMICAS",
      "nome_completo_valor_dominio": "AUXILIAR DE LABORATORIO DE ANALISES FISICO-QUIMICAS",
      "descricao_conceito_valor_dominio": "AUXILIAR DE LABORATORIO DE ANALISES FISICO-QUIMICAS"
    },
    {
      "codigo_valor_dominio": 3519,
      "codigo_referencia_valor_dominio": "720140",
      "nome_resumido_valor_dominio": "MESTRE DE SOLDAGEM",
      "nome_completo_valor_dominio": "MESTRE DE SOLDAGEM",
      "descricao_conceito_valor_dominio": "MESTRE DE SOLDAGEM"
    },
    {
      "codigo_valor_dominio": 3520,
      "codigo_referencia_valor_dominio": "820115",
      "nome_resumido_valor_dominio": "MESTRE DE ALTO-FORNO",
      "nome_completo_valor_dominio": "MESTRE DE ALTO-FORNO",
      "descricao_conceito_valor_dominio": "MESTRE DE ALTO-FORNO"
    },
    {
      "codigo_valor_dominio": 3521,
      "codigo_referencia_valor_dominio": "341210",
      "nome_resumido_valor_dominio": "MESTRE DE CABOTAGEM",
      "nome_completo_valor_dominio": "MESTRE DE CABOTAGEM",
      "descricao_conceito_valor_dominio": "MESTRE DE CABOTAGEM"
    },
    {
      "codigo_valor_dominio": 3522,
      "codigo_referencia_valor_dominio": "720125",
      "nome_resumido_valor_dominio": "MESTRE DE FUNDICAO",
      "nome_completo_valor_dominio": "MESTRE DE FUNDICAO",
      "descricao_conceito_valor_dominio": "MESTRE DE FUNDICAO"
    },
    {
      "codigo_valor_dominio": 3523,
      "codigo_referencia_valor_dominio": "710210",
      "nome_resumido_valor_dominio": "MESTRE DE LINHAS (FERROVIAS)",
      "nome_completo_valor_dominio": "MESTRE DE LINHAS (FERROVIAS)",
      "descricao_conceito_valor_dominio": "MESTRE DE LINHAS (FERROVIAS)"
    },
    {
      "codigo_valor_dominio": 3524,
      "codigo_referencia_valor_dominio": "820210",
      "nome_resumido_valor_dominio": "SUPERVISOR DE FABRICACAO DE PRODUTOS DE VIDRO",
      "nome_completo_valor_dominio": "SUPERVISOR DE FABRICACAO DE PRODUTOS DE VIDRO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE FABRICACAO DE PRODUTOS DE VIDRO"
    },
    {
      "codigo_valor_dominio": 3525,
      "codigo_referencia_valor_dominio": "750105",
      "nome_resumido_valor_dominio": "SUPERVISOR DE JOALHERIA",
      "nome_completo_valor_dominio": "SUPERVISOR DE JOALHERIA",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE JOALHERIA"
    },
    {
      "codigo_valor_dominio": 3526,
      "codigo_referencia_valor_dominio": "342410",
      "nome_resumido_valor_dominio": "OPERADOR DE CENTRO DE CONTROLE (FERROVIA E METRO)",
      "nome_completo_valor_dominio": "OPERADOR DE CENTRO DE CONTROLE (FERROVIA E METRO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE CENTRO DE CONTROLE (FERROVIA E METRO)"
    },
    {
      "codigo_valor_dominio": 3527,
      "codigo_referencia_valor_dominio": "823240",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE SOPRAR VIDRO",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE SOPRAR VIDRO",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE SOPRAR VIDRO"
    },
    {
      "codigo_valor_dominio": 3528,
      "codigo_referencia_valor_dominio": "821210",
      "nome_resumido_valor_dominio": "FORNEIRO E OPERADOR (CONVERSOR A OXIGENIO)",
      "nome_completo_valor_dominio": "FORNEIRO E OPERADOR (CONVERSOR A OXIGENIO)",
      "descricao_conceito_valor_dominio": "FORNEIRO E OPERADOR (CONVERSOR A OXIGENIO)"
    },
    {
      "codigo_valor_dominio": 3529,
      "codigo_referencia_valor_dominio": "821215",
      "nome_resumido_valor_dominio": "FORNEIRO E OPERADOR (FORNO ELETRICO)",
      "nome_completo_valor_dominio": "FORNEIRO E OPERADOR (FORNO ELETRICO)",
      "descricao_conceito_valor_dominio": "FORNEIRO E OPERADOR (FORNO ELETRICO)"
    },
    {
      "codigo_valor_dominio": 3530,
      "codigo_referencia_valor_dominio": "821220",
      "nome_resumido_valor_dominio": "FORNEIRO E OPERADOR (REFINO DE METAIS NAO-FERROSOS)",
      "nome_completo_valor_dominio": "FORNEIRO E OPERADOR (REFINO DE METAIS NAO-FERROSOS)",
      "descricao_conceito_valor_dominio": "FORNEIRO E OPERADOR (REFINO DE METAIS NAO-FERROSOS)"
    },
    {
      "codigo_valor_dominio": 3531,
      "codigo_referencia_valor_dominio": "821225",
      "nome_resumido_valor_dominio": "FORNEIRO E OPERADOR DE FORNO DE REDUCAO DIRETA",
      "nome_completo_valor_dominio": "FORNEIRO E OPERADOR DE FORNO DE REDUCAO DIRETA",
      "descricao_conceito_valor_dominio": "FORNEIRO E OPERADOR DE FORNO DE REDUCAO DIRETA"
    },
    {
      "codigo_valor_dominio": 3532,
      "codigo_referencia_valor_dominio": "823215",
      "nome_resumido_valor_dominio": "FORNEIRO NA FUNDICAO DE VIDRO",
      "nome_completo_valor_dominio": "FORNEIRO NA FUNDICAO DE VIDRO",
      "descricao_conceito_valor_dominio": "FORNEIRO NA FUNDICAO DE VIDRO"
    },
    {
      "codigo_valor_dominio": 3533,
      "codigo_referencia_valor_dominio": "821235",
      "nome_resumido_valor_dominio": "OPERADOR DE ACIARIA (DESSULFURACAO DE GUSA)",
      "nome_completo_valor_dominio": "OPERADOR DE ACIARIA (DESSULFURACAO DE GUSA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE ACIARIA (DESSULFURACAO DE GUSA)"
    },
    {
      "codigo_valor_dominio": 3534,
      "codigo_referencia_valor_dominio": "821240",
      "nome_resumido_valor_dominio": "OPERADOR DE ACIARIA (RECEBIMENTO DE GUSA)",
      "nome_completo_valor_dominio": "OPERADOR DE ACIARIA (RECEBIMENTO DE GUSA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE ACIARIA (RECEBIMENTO DE GUSA)"
    },
    {
      "codigo_valor_dominio": 3535,
      "codigo_referencia_valor_dominio": "811415",
      "nome_resumido_valor_dominio": "OPERADOR DE ALAMBIQUE DE FUNCIONAMENTO CONTINUO (PRODUTOS QU",
      "nome_completo_valor_dominio": "OPERADOR DE ALAMBIQUE DE FUNCIONAMENTO CONTINUO (PRODUTOS QUIMICOS, EXCETO PETROLEO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE ALAMBIQUE DE FUNCIONAMENTO CONTINUO (PRODUTOS QUIMICOS, EXCETO PETROLEO)"
    },
    {
      "codigo_valor_dominio": 3536,
      "codigo_referencia_valor_dominio": "342535",
      "nome_resumido_valor_dominio": "OPERADOR DE ATENDIMENTO AEROVIARIO",
      "nome_completo_valor_dominio": "OPERADOR DE ATENDIMENTO AEROVIARIO",
      "descricao_conceito_valor_dominio": "OPERADOR DE ATENDIMENTO AEROVIARIO"
    },
    {
      "codigo_valor_dominio": 3537,
      "codigo_referencia_valor_dominio": "811615",
      "nome_resumido_valor_dominio": "OPERADOR DE DESTILACAO E SUBPRODUTOS DE COQUE",
      "nome_completo_valor_dominio": "OPERADOR DE DESTILACAO E SUBPRODUTOS DE COQUE",
      "descricao_conceito_valor_dominio": "OPERADOR DE DESTILACAO E SUBPRODUTOS DE COQUE"
    },
    {
      "codigo_valor_dominio": 3538,
      "codigo_referencia_valor_dominio": "752115",
      "nome_resumido_valor_dominio": "SOPRADOR DE VIDRO",
      "nome_completo_valor_dominio": "SOPRADOR DE VIDRO",
      "descricao_conceito_valor_dominio": "SOPRADOR DE VIDRO"
    },
    {
      "codigo_valor_dominio": 3539,
      "codigo_referencia_valor_dominio": "821310",
      "nome_resumido_valor_dominio": "OPERADOR DE LAMINADOR DE BARRAS A FRIO",
      "nome_completo_valor_dominio": "OPERADOR DE LAMINADOR DE BARRAS A FRIO",
      "descricao_conceito_valor_dominio": "OPERADOR DE LAMINADOR DE BARRAS A FRIO"
    },
    {
      "codigo_valor_dominio": 3540,
      "codigo_referencia_valor_dominio": "821315",
      "nome_resumido_valor_dominio": "OPERADOR DE LAMINADOR DE BARRAS A QUENTE",
      "nome_completo_valor_dominio": "OPERADOR DE LAMINADOR DE BARRAS A QUENTE",
      "descricao_conceito_valor_dominio": "OPERADOR DE LAMINADOR DE BARRAS A QUENTE"
    },
    {
      "codigo_valor_dominio": 3541,
      "codigo_referencia_valor_dominio": "821320",
      "nome_resumido_valor_dominio": "OPERADOR DE LAMINADOR DE METAIS NAO-FERROSOS",
      "nome_completo_valor_dominio": "OPERADOR DE LAMINADOR DE METAIS NAO-FERROSOS",
      "descricao_conceito_valor_dominio": "OPERADOR DE LAMINADOR DE METAIS NAO-FERROSOS"
    },
    {
      "codigo_valor_dominio": 3542,
      "codigo_referencia_valor_dominio": "821325",
      "nome_resumido_valor_dominio": "OPERADOR DE LAMINADOR DE TUBOS",
      "nome_completo_valor_dominio": "OPERADOR DE LAMINADOR DE TUBOS",
      "descricao_conceito_valor_dominio": "OPERADOR DE LAMINADOR DE TUBOS"
    },
    {
      "codigo_valor_dominio": 3543,
      "codigo_referencia_valor_dominio": "831120",
      "nome_resumido_valor_dominio": "OPERADOR DE LAVAGEM E DEPURACAO DE PASTA PARA FABRICACAO DE",
      "nome_completo_valor_dominio": "OPERADOR DE LAVAGEM E DEPURACAO DE PASTA PARA FABRICACAO DE PAPEL",
      "descricao_conceito_valor_dominio": "OPERADOR DE LAVAGEM E DEPURACAO DE PASTA PARA FABRICACAO DE PAPEL"
    },
    {
      "codigo_valor_dominio": 3544,
      "codigo_referencia_valor_dominio": "715130",
      "nome_resumido_valor_dominio": "OPERADOR DE MOTONIVELADORA",
      "nome_completo_valor_dominio": "OPERADOR DE MOTONIVELADORA",
      "descricao_conceito_valor_dominio": "OPERADOR DE MOTONIVELADORA"
    },
    {
      "codigo_valor_dominio": 3545,
      "codigo_referencia_valor_dominio": "253110",
      "nome_resumido_valor_dominio": "REDATOR DE PUBLICIDADE",
      "nome_completo_valor_dominio": "REDATOR DE PUBLICIDADE",
      "descricao_conceito_valor_dominio": "REDATOR DE PUBLICIDADE"
    },
    {
      "codigo_valor_dominio": 3546,
      "codigo_referencia_valor_dominio": "760305",
      "nome_resumido_valor_dominio": "ENCARREGADO DE CORTE NA CONFECCAO DO VESTUARIO",
      "nome_completo_valor_dominio": "ENCARREGADO DE CORTE NA CONFECCAO DO VESTUARIO",
      "descricao_conceito_valor_dominio": "ENCARREGADO DE CORTE NA CONFECCAO DO VESTUARIO"
    },
    {
      "codigo_valor_dominio": 3547,
      "codigo_referencia_valor_dominio": "391225",
      "nome_resumido_valor_dominio": "ESCOLHEDOR DE PAPEL",
      "nome_completo_valor_dominio": "ESCOLHEDOR DE PAPEL",
      "descricao_conceito_valor_dominio": "ESCOLHEDOR DE PAPEL"
    },
    {
      "codigo_valor_dominio": 3548,
      "codigo_referencia_valor_dominio": "771105",
      "nome_resumido_valor_dominio": "MARCENEIRO",
      "nome_completo_valor_dominio": "MARCENEIRO",
      "descricao_conceito_valor_dominio": "MARCENEIRO"
    },
    {
      "codigo_valor_dominio": 3549,
      "codigo_referencia_valor_dominio": "715410",
      "nome_resumido_valor_dominio": "OPERADOR DE BOMBA DE CONCRETO",
      "nome_completo_valor_dominio": "OPERADOR DE BOMBA DE CONCRETO",
      "descricao_conceito_valor_dominio": "OPERADOR DE BOMBA DE CONCRETO"
    },
    {
      "codigo_valor_dominio": 3550,
      "codigo_referencia_valor_dominio": "421125",
      "nome_resumido_valor_dominio": "OPERADOR DE CAIXA",
      "nome_completo_valor_dominio": "OPERADOR DE CAIXA",
      "descricao_conceito_valor_dominio": "OPERADOR DE CAIXA"
    },
    {
      "codigo_valor_dominio": 3551,
      "codigo_referencia_valor_dominio": "752420",
      "nome_resumido_valor_dominio": "OPERADOR DE ESMALTADEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE ESMALTADEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE ESMALTADEIRA"
    },
    {
      "codigo_valor_dominio": 3552,
      "codigo_referencia_valor_dominio": "712130",
      "nome_resumido_valor_dominio": "OPERADOR DE JIG (MINAS)",
      "nome_completo_valor_dominio": "OPERADOR DE JIG (MINAS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE JIG (MINAS)"
    },
    {
      "codigo_valor_dominio": 3553,
      "codigo_referencia_valor_dominio": "725510",
      "nome_resumido_valor_dominio": "OPERADOR DE TIME DE MONTAGEM",
      "nome_completo_valor_dominio": "OPERADOR DE TIME DE MONTAGEM",
      "descricao_conceito_valor_dominio": "OPERADOR DE TIME DE MONTAGEM"
    },
    {
      "codigo_valor_dominio": 3554,
      "codigo_referencia_valor_dominio": "311715",
      "nome_resumido_valor_dominio": "PREPARADOR DE TINTAS",
      "nome_completo_valor_dominio": "PREPARADOR DE TINTAS",
      "descricao_conceito_valor_dominio": "PREPARADOR DE TINTAS"
    },
    {
      "codigo_valor_dominio": 3555,
      "codigo_referencia_valor_dominio": "724215",
      "nome_resumido_valor_dominio": "REBITADOR A MARTELO PNEUMATICO",
      "nome_completo_valor_dominio": "REBITADOR A MARTELO PNEUMATICO",
      "descricao_conceito_valor_dominio": "REBITADOR A MARTELO PNEUMATICO"
    },
    {
      "codigo_valor_dominio": 3556,
      "codigo_referencia_valor_dominio": "822110",
      "nome_resumido_valor_dominio": "FORNEIRO DE FORNO-POCO",
      "nome_completo_valor_dominio": "FORNEIRO DE FORNO-POCO",
      "descricao_conceito_valor_dominio": "FORNEIRO DE FORNO-POCO"
    },
    {
      "codigo_valor_dominio": 3557,
      "codigo_referencia_valor_dominio": "822115",
      "nome_resumido_valor_dominio": "FORNEIRO DE FUNDICAO (FORNO DE REDUCAO)",
      "nome_completo_valor_dominio": "FORNEIRO DE FUNDICAO (FORNO DE REDUCAO)",
      "descricao_conceito_valor_dominio": "FORNEIRO DE FUNDICAO (FORNO DE REDUCAO)"
    },
    {
      "codigo_valor_dominio": 3558,
      "codigo_referencia_valor_dominio": "822120",
      "nome_resumido_valor_dominio": "FORNEIRO DE REAQUECIMENTO E TRATAMENTO TERMICO NA METALURGIA",
      "nome_completo_valor_dominio": "FORNEIRO DE REAQUECIMENTO E TRATAMENTO TERMICO NA METALURGIA",
      "descricao_conceito_valor_dominio": "FORNEIRO DE REAQUECIMENTO E TRATAMENTO TERMICO NA METALURGIA"
    },
    {
      "codigo_valor_dominio": 3559,
      "codigo_referencia_valor_dominio": "822125",
      "nome_resumido_valor_dominio": "FORNEIRO DE REVERBERO",
      "nome_completo_valor_dominio": "FORNEIRO DE REVERBERO",
      "descricao_conceito_valor_dominio": "FORNEIRO DE REVERBERO"
    },
    {
      "codigo_valor_dominio": 3560,
      "codigo_referencia_valor_dominio": "821205",
      "nome_resumido_valor_dominio": "FORNEIRO E OPERADOR (ALTO-FORNO)",
      "nome_completo_valor_dominio": "FORNEIRO E OPERADOR (ALTO-FORNO)",
      "descricao_conceito_valor_dominio": "FORNEIRO E OPERADOR (ALTO-FORNO)"
    },
    {
      "codigo_valor_dominio": 3561,
      "codigo_referencia_valor_dominio": "823110",
      "nome_resumido_valor_dominio": "PREPARADOR DE MASSA (FABRICACAO DE VIDRO)",
      "nome_completo_valor_dominio": "PREPARADOR DE MASSA (FABRICACAO DE VIDRO)",
      "descricao_conceito_valor_dominio": "PREPARADOR DE MASSA (FABRICACAO DE VIDRO)"
    },
    {
      "codigo_valor_dominio": 3562,
      "codigo_referencia_valor_dominio": "823115",
      "nome_resumido_valor_dominio": "PREPARADOR DE MASSA DE ARGILA",
      "nome_completo_valor_dominio": "PREPARADOR DE MASSA DE ARGILA",
      "descricao_conceito_valor_dominio": "PREPARADOR DE MASSA DE ARGILA"
    },
    {
      "codigo_valor_dominio": 3563,
      "codigo_referencia_valor_dominio": "766325",
      "nome_resumido_valor_dominio": "PREPARADOR DE MATRIZES DE CORTE E VINCO",
      "nome_completo_valor_dominio": "PREPARADOR DE MATRIZES DE CORTE E VINCO",
      "descricao_conceito_valor_dominio": "PREPARADOR DE MATRIZES DE CORTE E VINCO"
    },
    {
      "codigo_valor_dominio": 3564,
      "codigo_referencia_valor_dominio": "764115",
      "nome_resumido_valor_dominio": "PREPARADOR DE CALCADOS",
      "nome_completo_valor_dominio": "PREPARADOR DE CALCADOS",
      "descricao_conceito_valor_dominio": "PREPARADOR DE CALCADOS"
    },
    {
      "codigo_valor_dominio": 3565,
      "codigo_referencia_valor_dominio": "724220",
      "nome_resumido_valor_dominio": "PREPARADOR DE ESTRUTURAS METALICAS",
      "nome_completo_valor_dominio": "PREPARADOR DE ESTRUTURAS METALICAS",
      "descricao_conceito_valor_dominio": "PREPARADOR DE ESTRUTURAS METALICAS"
    },
    {
      "codigo_valor_dominio": 3566,
      "codigo_referencia_valor_dominio": "773220",
      "nome_resumido_valor_dominio": "PREPARADOR DE AGLOMERANTES",
      "nome_completo_valor_dominio": "PREPARADOR DE AGLOMERANTES",
      "descricao_conceito_valor_dominio": "PREPARADOR DE AGLOMERANTES"
    },
    {
      "codigo_valor_dominio": 3567,
      "codigo_referencia_valor_dominio": "373105",
      "nome_resumido_valor_dominio": "OPERADOR DE AUDIO DE CONTINUIDADE (RADIO)",
      "nome_completo_valor_dominio": "OPERADOR DE AUDIO DE CONTINUIDADE (RADIO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE AUDIO DE CONTINUIDADE (RADIO)"
    },
    {
      "codigo_valor_dominio": 3568,
      "codigo_referencia_valor_dominio": "223405",
      "nome_resumido_valor_dominio": "FARMACEUTICO",
      "nome_completo_valor_dominio": "FARMACEUTICO",
      "descricao_conceito_valor_dominio": "FARMACEUTICO"
    },
    {
      "codigo_valor_dominio": 3569,
      "codigo_referencia_valor_dominio": "823220",
      "nome_resumido_valor_dominio": "FORNEIRO NO RECOZIMENTO DE VIDRO",
      "nome_completo_valor_dominio": "FORNEIRO NO RECOZIMENTO DE VIDRO",
      "descricao_conceito_valor_dominio": "FORNEIRO NO RECOZIMENTO DE VIDRO"
    },
    {
      "codigo_valor_dominio": 3570,
      "codigo_referencia_valor_dominio": "723210",
      "nome_resumido_valor_dominio": "FOSFATIZADOR",
      "nome_completo_valor_dominio": "FOSFATIZADOR",
      "descricao_conceito_valor_dominio": "FOSFATIZADOR"
    },
    {
      "codigo_valor_dominio": 3571,
      "codigo_referencia_valor_dominio": "811750",
      "nome_resumido_valor_dominio": "MOLDADOR DE BORRACHA POR COMPRESSAO",
      "nome_completo_valor_dominio": "MOLDADOR DE BORRACHA POR COMPRESSAO",
      "descricao_conceito_valor_dominio": "MOLDADOR DE BORRACHA POR COMPRESSAO"
    },
    {
      "codigo_valor_dominio": 3572,
      "codigo_referencia_valor_dominio": "715105",
      "nome_resumido_valor_dominio": "OPERADOR DE BATE-ESTACAS",
      "nome_completo_valor_dominio": "OPERADOR DE BATE-ESTACAS",
      "descricao_conceito_valor_dominio": "OPERADOR DE BATE-ESTACAS"
    },
    {
      "codigo_valor_dominio": 3573,
      "codigo_referencia_valor_dominio": "773415",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE USINAGEM DE MADEIRA (PRODUCAO EM SERI",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE USINAGEM DE MADEIRA (PRODUCAO EM SERIE)",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE USINAGEM DE MADEIRA (PRODUCAO EM SERIE)"
    },
    {
      "codigo_valor_dominio": 3574,
      "codigo_referencia_valor_dominio": "773205",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA INTERCALADORA E PLACAS (COMPENSADOS)",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA INTERCALADORA E PLACAS (COMPENSADOS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA INTERCALADORA E PLACAS (COMPENSADOS)"
    },
    {
      "codigo_valor_dominio": 3575,
      "codigo_referencia_valor_dominio": "841460",
      "nome_resumido_valor_dominio": "OPERADOR DE PREPARACAO DE GRAOS VEGETAIS (OLEOS E GORDURAS)",
      "nome_completo_valor_dominio": "OPERADOR DE PREPARACAO DE GRAOS VEGETAIS (OLEOS E GORDURAS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE PREPARACAO DE GRAOS VEGETAIS (OLEOS E GORDURAS)"
    },
    {
      "codigo_valor_dominio": 3576,
      "codigo_referencia_valor_dominio": "030305",
      "nome_resumido_valor_dominio": "TENENTE DO CORPO DE BOMBEIROS MILITAR",
      "nome_completo_valor_dominio": "TENENTE DO CORPO DE BOMBEIROS MILITAR",
      "descricao_conceito_valor_dominio": "TENENTE DO CORPO DE BOMBEIROS MILITAR"
    },
    {
      "codigo_valor_dominio": 3577,
      "codigo_referencia_valor_dominio": "623415",
      "nome_resumido_valor_dominio": "TRABALHADOR NA MINHOCULTURA",
      "nome_completo_valor_dominio": "TRABALHADOR NA MINHOCULTURA",
      "descricao_conceito_valor_dominio": "TRABALHADOR NA MINHOCULTURA"
    },
    {
      "codigo_valor_dominio": 3578,
      "codigo_referencia_valor_dominio": "823305",
      "nome_resumido_valor_dominio": "CLASSIFICADOR E EMPILHADOR DE TIJOLOS REFRATARIOS",
      "nome_completo_valor_dominio": "CLASSIFICADOR E EMPILHADOR DE TIJOLOS REFRATARIOS",
      "descricao_conceito_valor_dominio": "CLASSIFICADOR E EMPILHADOR DE TIJOLOS REFRATARIOS"
    },
    {
      "codigo_valor_dominio": 3579,
      "codigo_referencia_valor_dominio": "822105",
      "nome_resumido_valor_dominio": "FORNEIRO DE CUBILO",
      "nome_completo_valor_dominio": "FORNEIRO DE CUBILO",
      "descricao_conceito_valor_dominio": "FORNEIRO DE CUBILO"
    },
    {
      "codigo_valor_dominio": 3580,
      "codigo_referencia_valor_dominio": "823325",
      "nome_resumido_valor_dominio": "TRABALHADOR DA ELABORACAO DE PRE-FABRICADOS (CONCRETO ARMADO",
      "nome_completo_valor_dominio": "TRABALHADOR DA ELABORACAO DE PRE-FABRICADOS (CONCRETO ARMADO",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA ELABORACAO DE PRE-FABRICADOS (CONCRETO ARMADO"
    },
    {
      "codigo_valor_dominio": 3581,
      "codigo_referencia_valor_dominio": "632405",
      "nome_resumido_valor_dominio": "TRABALHADOR DA EXPLORACAO DE ACAI",
      "nome_completo_valor_dominio": "TRABALHADOR DA EXPLORACAO DE ACAI",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA EXPLORACAO DE ACAI"
    },
    {
      "codigo_valor_dominio": 3582,
      "codigo_referencia_valor_dominio": "811125",
      "nome_resumido_valor_dominio": "TRABALHADOR DA FABRICACAO DE RESINAS E VERNIZES",
      "nome_completo_valor_dominio": "TRABALHADOR DA FABRICACAO DE RESINAS E VERNIZES",
      "descricao_conceito_valor_dominio": "TRABALHADOR DA FABRICACAO DE RESINAS E VERNIZES"
    },
    {
      "codigo_valor_dominio": 3583,
      "codigo_referencia_valor_dominio": "828110",
      "nome_resumido_valor_dominio": "OLEIRO (FABRICACAO DE TIJOLOS)",
      "nome_completo_valor_dominio": "OLEIRO (FABRICACAO DE TIJOLOS)",
      "descricao_conceito_valor_dominio": "OLEIRO (FABRICACAO DE TIJOLOS)"
    },
    {
      "codigo_valor_dominio": 3584,
      "codigo_referencia_valor_dominio": "761205",
      "nome_resumido_valor_dominio": "OPERADOR DE ABERTURA (FIACAO)",
      "nome_completo_valor_dominio": "OPERADOR DE ABERTURA (FIACAO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE ABERTURA (FIACAO)"
    },
    {
      "codigo_valor_dominio": 3585,
      "codigo_referencia_valor_dominio": "770105",
      "nome_resumido_valor_dominio": "MESTRE (INDUSTRIA DE MADEIRA E MOBILIARIO)",
      "nome_completo_valor_dominio": "MESTRE (INDUSTRIA DE MADEIRA E MOBILIARIO)",
      "descricao_conceito_valor_dominio": "MESTRE (INDUSTRIA DE MADEIRA E MOBILIARIO)"
    },
    {
      "codigo_valor_dominio": 3586,
      "codigo_referencia_valor_dominio": "831105",
      "nome_resumido_valor_dominio": "CILINDREIRO NA PREPARACAO DE PASTA PARA FABRICACAO DE PAPEL",
      "nome_completo_valor_dominio": "CILINDREIRO NA PREPARACAO DE PASTA PARA FABRICACAO DE PAPEL",
      "descricao_conceito_valor_dominio": "CILINDREIRO NA PREPARACAO DE PASTA PARA FABRICACAO DE PAPEL"
    },
    {
      "codigo_valor_dominio": 3587,
      "codigo_referencia_valor_dominio": "811115",
      "nome_resumido_valor_dominio": "OPERADOR DE BRITADEIRA (TRATAMENTOS QUIMICOS E AFINS)",
      "nome_completo_valor_dominio": "OPERADOR DE BRITADEIRA (TRATAMENTOS QUIMICOS E AFINS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE BRITADEIRA (TRATAMENTOS QUIMICOS E AFINS)"
    },
    {
      "codigo_valor_dominio": 3588,
      "codigo_referencia_valor_dominio": "782210",
      "nome_resumido_valor_dominio": "OPERADOR DE DOCAGEM",
      "nome_completo_valor_dominio": "OPERADOR DE DOCAGEM",
      "descricao_conceito_valor_dominio": "OPERADOR DE DOCAGEM"
    },
    {
      "codigo_valor_dominio": 3589,
      "codigo_referencia_valor_dominio": "731175",
      "nome_resumido_valor_dominio": "OPERADOR DE LINHA DE MONTAGEM (APARELHOS ELETRICOS)",
      "nome_completo_valor_dominio": "OPERADOR DE LINHA DE MONTAGEM (APARELHOS ELETRICOS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE LINHA DE MONTAGEM (APARELHOS ELETRICOS)"
    },
    {
      "codigo_valor_dominio": 3590,
      "codigo_referencia_valor_dominio": "821110",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE SINTERIZAR",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE SINTERIZAR",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE SINTERIZAR"
    },
    {
      "codigo_valor_dominio": 3591,
      "codigo_referencia_valor_dominio": "832105",
      "nome_resumido_valor_dominio": "CALANDRISTA DE PAPEL",
      "nome_completo_valor_dominio": "CALANDRISTA DE PAPEL",
      "descricao_conceito_valor_dominio": "CALANDRISTA DE PAPEL"
    },
    {
      "codigo_valor_dominio": 3592,
      "codigo_referencia_valor_dominio": "841305",
      "nome_resumido_valor_dominio": "OPERADOR DE CRISTALIZACAO NA REFINACAO DE ACUCAR",
      "nome_completo_valor_dominio": "OPERADOR DE CRISTALIZACAO NA REFINACAO DE ACUCAR",
      "descricao_conceito_valor_dominio": "OPERADOR DE CRISTALIZACAO NA REFINACAO DE ACUCAR"
    },
    {
      "codigo_valor_dominio": 3593,
      "codigo_referencia_valor_dominio": "832120",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE FABRICAR PAPEL (FASE SECA)",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE FABRICAR PAPEL (FASE SECA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE FABRICAR PAPEL (FASE SECA)"
    },
    {
      "codigo_valor_dominio": 3594,
      "codigo_referencia_valor_dominio": "832125",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE FABRICAR PAPEL E PAPELAO",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE FABRICAR PAPEL E PAPELAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE FABRICAR PAPEL E PAPELAO"
    },
    {
      "codigo_valor_dominio": 3595,
      "codigo_referencia_valor_dominio": "722225",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE FUNDIR SOB PRESSAO",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE FUNDIR SOB PRESSAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE FUNDIR SOB PRESSAO"
    },
    {
      "codigo_valor_dominio": 3596,
      "codigo_referencia_valor_dominio": "372205",
      "nome_resumido_valor_dominio": "OPERADOR DE REDE DE TELEPROCESSAMENTO",
      "nome_completo_valor_dominio": "OPERADOR DE REDE DE TELEPROCESSAMENTO",
      "descricao_conceito_valor_dominio": "OPERADOR DE REDE DE TELEPROCESSAMENTO"
    },
    {
      "codigo_valor_dominio": 3597,
      "codigo_referencia_valor_dominio": "833105",
      "nome_resumido_valor_dominio": "CARTONAGEIRO, A MAQUINA",
      "nome_completo_valor_dominio": "CARTONAGEIRO, A MAQUINA",
      "descricao_conceito_valor_dominio": "CARTONAGEIRO, A MAQUINA"
    },
    {
      "codigo_valor_dominio": 3598,
      "codigo_referencia_valor_dominio": "833110",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE BOLSAS, SACOS E SACOLAS E PAPEL, A MAQUINA",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE BOLSAS, SACOS E SACOLAS E PAPEL, A MAQUINA",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE BOLSAS, SACOS E SACOLAS E PAPEL, A MAQUINA"
    },
    {
      "codigo_valor_dominio": 3599,
      "codigo_referencia_valor_dominio": "765225",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE VELAS NAUTICAS, BARRACAS E TOLDOS",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE VELAS NAUTICAS, BARRACAS E TOLDOS",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE VELAS NAUTICAS, BARRACAS E TOLDOS"
    },
    {
      "codigo_valor_dominio": 3600,
      "codigo_referencia_valor_dominio": "773410",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE CORTINA D AGUA (PRODUCAO DE MOVEIS)",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE CORTINA D AGUA (PRODUCAO DE MOVEIS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE CORTINA D AGUA (PRODUCAO DE MOVEIS)"
    },
    {
      "codigo_valor_dominio": 3601,
      "codigo_referencia_valor_dominio": "784125",
      "nome_resumido_valor_dominio": "OPERADOR DE PRENSA DE ENFARDAMENTO",
      "nome_completo_valor_dominio": "OPERADOR DE PRENSA DE ENFARDAMENTO",
      "descricao_conceito_valor_dominio": "OPERADOR DE PRENSA DE ENFARDAMENTO"
    },
    {
      "codigo_valor_dominio": 3602,
      "codigo_referencia_valor_dominio": "833205",
      "nome_resumido_valor_dominio": "CARTONAGEIRO, A MAO (CAIXAS DE PAPELAO)",
      "nome_completo_valor_dominio": "CARTONAGEIRO, A MAO (CAIXAS DE PAPELAO)",
      "descricao_conceito_valor_dominio": "CARTONAGEIRO, A MAO (CAIXAS DE PAPELAO)"
    },
    {
      "codigo_valor_dominio": 3603,
      "codigo_referencia_valor_dominio": "710120",
      "nome_resumido_valor_dominio": "SUPERVISOR DE PRODUCAO NA MINERACAO",
      "nome_completo_valor_dominio": "SUPERVISOR DE PRODUCAO NA MINERACAO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE PRODUCAO NA MINERACAO"
    },
    {
      "codigo_valor_dominio": 3604,
      "codigo_referencia_valor_dominio": "840115",
      "nome_resumido_valor_dominio": "SUPERVISOR DA INDUSTRIA DE FUMO",
      "nome_completo_valor_dominio": "SUPERVISOR DA INDUSTRIA DE FUMO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DA INDUSTRIA DE FUMO"
    },
    {
      "codigo_valor_dominio": 3605,
      "codigo_referencia_valor_dominio": "750205",
      "nome_resumido_valor_dominio": "SUPERVISOR DA INDUSTRIA DE MINERAIS NAO METALICOS (EXCETO OS",
      "nome_completo_valor_dominio": "SUPERVISOR DA INDUSTRIA DE MINERAIS NAO METALICOS (EXCETO OS DERIVADOS DE PETROLEO E CARVAO)",
      "descricao_conceito_valor_dominio": "SUPERVISOR DA INDUSTRIA DE MINERAIS NAO METALICOS (EXCETO OS DERIVADOS DE PETROLEO E CARVAO)"
    },
    {
      "codigo_valor_dominio": 3606,
      "codigo_referencia_valor_dominio": "840120",
      "nome_resumido_valor_dominio": "CHEFE DE CONFEITARIA",
      "nome_completo_valor_dominio": "CHEFE DE CONFEITARIA",
      "descricao_conceito_valor_dominio": "CHEFE DE CONFEITARIA"
    },
    {
      "codigo_valor_dominio": 3607,
      "codigo_referencia_valor_dominio": "841110",
      "nome_resumido_valor_dominio": "MOLEIRO DE ESPECIARIAS",
      "nome_completo_valor_dominio": "MOLEIRO DE ESPECIARIAS",
      "descricao_conceito_valor_dominio": "MOLEIRO DE ESPECIARIAS"
    },
    {
      "codigo_valor_dominio": 3608,
      "codigo_referencia_valor_dominio": "712105",
      "nome_resumido_valor_dominio": "MOLEIRO DE MINERIOS",
      "nome_completo_valor_dominio": "MOLEIRO DE MINERIOS",
      "descricao_conceito_valor_dominio": "MOLEIRO DE MINERIOS"
    },
    {
      "codigo_valor_dominio": 3609,
      "codigo_referencia_valor_dominio": "766150",
      "nome_resumido_valor_dominio": "OPERADOR DE PROCESSO DE TRATAMENTO DE IMAGEM",
      "nome_completo_valor_dominio": "OPERADOR DE PROCESSO DE TRATAMENTO DE IMAGEM",
      "descricao_conceito_valor_dominio": "OPERADOR DE PROCESSO DE TRATAMENTO DE IMAGEM"
    },
    {
      "codigo_valor_dominio": 3610,
      "codigo_referencia_valor_dominio": "752110",
      "nome_resumido_valor_dominio": "MOLDADOR (VIDROS)",
      "nome_completo_valor_dominio": "MOLDADOR (VIDROS)",
      "descricao_conceito_valor_dominio": "MOLDADOR (VIDROS)"
    },
    {
      "codigo_valor_dominio": 3611,
      "codigo_referencia_valor_dominio": "253105",
      "nome_resumido_valor_dominio": "RELACOES PUBLICAS",
      "nome_completo_valor_dominio": "RELACOES PUBLICAS",
      "descricao_conceito_valor_dominio": "RELACOES PUBLICAS"
    },
    {
      "codigo_valor_dominio": 3612,
      "codigo_referencia_valor_dominio": "773305",
      "nome_resumido_valor_dominio": "OPERADOR DE DESEMPENADEIRA NA USINAGEM CONVENCIONAL DE MADEI",
      "nome_completo_valor_dominio": "OPERADOR DE DESEMPENADEIRA NA USINAGEM CONVENCIONAL DE MADEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE DESEMPENADEIRA NA USINAGEM CONVENCIONAL DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 3613,
      "codigo_referencia_valor_dominio": "715115",
      "nome_resumido_valor_dominio": "OPERADOR DE ESCAVADEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE ESCAVADEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE ESCAVADEIRA"
    },
    {
      "codigo_valor_dominio": 3614,
      "codigo_referencia_valor_dominio": "773330",
      "nome_resumido_valor_dominio": "OPERADOR DE MOLDURADORA (USINAGEM DE MADEIRA)",
      "nome_completo_valor_dominio": "OPERADOR DE MOLDURADORA (USINAGEM DE MADEIRA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE MOLDURADORA (USINAGEM DE MADEIRA)"
    },
    {
      "codigo_valor_dominio": 3615,
      "codigo_referencia_valor_dominio": "811215",
      "nome_resumido_valor_dominio": "OPERADOR DE TRATAMENTO QUIMICO DE MATERIAIS RADIOATIVOS",
      "nome_completo_valor_dominio": "OPERADOR DE TRATAMENTO QUIMICO DE MATERIAIS RADIOATIVOS",
      "descricao_conceito_valor_dominio": "OPERADOR DE TRATAMENTO QUIMICO DE MATERIAIS RADIOATIVOS"
    },
    {
      "codigo_valor_dominio": 3616,
      "codigo_referencia_valor_dominio": "841416",
      "nome_resumido_valor_dominio": "COZINHADOR DE CARNES",
      "nome_completo_valor_dominio": "COZINHADOR DE CARNES",
      "descricao_conceito_valor_dominio": "COZINHADOR DE CARNES"
    },
    {
      "codigo_valor_dominio": 3617,
      "codigo_referencia_valor_dominio": "841420",
      "nome_resumido_valor_dominio": "COZINHADOR DE FRUTAS E LEGUMES",
      "nome_completo_valor_dominio": "COZINHADOR DE FRUTAS E LEGUMES",
      "descricao_conceito_valor_dominio": "COZINHADOR DE FRUTAS E LEGUMES"
    },
    {
      "codigo_valor_dominio": 3618,
      "codigo_referencia_valor_dominio": "841730",
      "nome_resumido_valor_dominio": "COZINHADOR DE MALTE",
      "nome_completo_valor_dominio": "COZINHADOR DE MALTE",
      "descricao_conceito_valor_dominio": "COZINHADOR DE MALTE"
    },
    {
      "codigo_valor_dominio": 3619,
      "codigo_referencia_valor_dominio": "513225",
      "nome_resumido_valor_dominio": "COZINHEIRO DE EMBARCACOES",
      "nome_completo_valor_dominio": "COZINHEIRO DE EMBARCACOES",
      "descricao_conceito_valor_dominio": "COZINHEIRO DE EMBARCACOES"
    },
    {
      "codigo_valor_dominio": 3620,
      "codigo_referencia_valor_dominio": "375105",
      "nome_resumido_valor_dominio": "DESIGNER DE INTERIORES",
      "nome_completo_valor_dominio": "DESIGNER DE INTERIORES",
      "descricao_conceito_valor_dominio": "DESIGNER DE INTERIORES"
    },
    {
      "codigo_valor_dominio": 3621,
      "codigo_referencia_valor_dominio": "322130",
      "nome_resumido_valor_dominio": "ESTETICISTA",
      "nome_completo_valor_dominio": "ESTETICISTA",
      "descricao_conceito_valor_dominio": "ESTETICISTA"
    },
    {
      "codigo_valor_dominio": 3622,
      "codigo_referencia_valor_dominio": "213425",
      "nome_resumido_valor_dominio": "HIDROGEOLOGO",
      "nome_completo_valor_dominio": "HIDROGEOLOGO",
      "descricao_conceito_valor_dominio": "HIDROGEOLOGO"
    },
    {
      "codigo_valor_dominio": 3623,
      "codigo_referencia_valor_dominio": "751120",
      "nome_resumido_valor_dominio": "LAMINADOR DE METAIS PRECIOSOS A MAO",
      "nome_completo_valor_dominio": "LAMINADOR DE METAIS PRECIOSOS A MAO",
      "descricao_conceito_valor_dominio": "LAMINADOR DE METAIS PRECIOSOS A MAO"
    },
    {
      "codigo_valor_dominio": 3624,
      "codigo_referencia_valor_dominio": "372115",
      "nome_resumido_valor_dominio": "OPERADOR DE CAMERA DE TELEVISAO",
      "nome_completo_valor_dominio": "OPERADOR DE CAMERA DE TELEVISAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE CAMERA DE TELEVISAO"
    },
    {
      "codigo_valor_dominio": 3625,
      "codigo_referencia_valor_dominio": "811635",
      "nome_resumido_valor_dominio": "OPERADOR DE PRESERVACAO E CONTROLE TERMICO",
      "nome_completo_valor_dominio": "OPERADOR DE PRESERVACAO E CONTROLE TERMICO",
      "descricao_conceito_valor_dominio": "OPERADOR DE PRESERVACAO E CONTROLE TERMICO"
    },
    {
      "codigo_valor_dominio": 3626,
      "codigo_referencia_valor_dominio": "724515",
      "nome_resumido_valor_dominio": "PRENSISTA (OPERADOR DE PRENSA)",
      "nome_completo_valor_dominio": "PRENSISTA (OPERADOR DE PRENSA)",
      "descricao_conceito_valor_dominio": "PRENSISTA (OPERADOR DE PRENSA)"
    },
    {
      "codigo_valor_dominio": 3627,
      "codigo_referencia_valor_dominio": "764120",
      "nome_resumido_valor_dominio": "PREPARADOR DE SOLAS E PALMILHAS",
      "nome_completo_valor_dominio": "PREPARADOR DE SOLAS E PALMILHAS",
      "descricao_conceito_valor_dominio": "PREPARADOR DE SOLAS E PALMILHAS"
    },
    {
      "codigo_valor_dominio": 3628,
      "codigo_referencia_valor_dominio": "841210",
      "nome_resumido_valor_dominio": "REFINADOR DE SAL",
      "nome_completo_valor_dominio": "REFINADOR DE SAL",
      "descricao_conceito_valor_dominio": "REFINADOR DE SAL"
    },
    {
      "codigo_valor_dominio": 3629,
      "codigo_referencia_valor_dominio": "848325",
      "nome_resumido_valor_dominio": "TRABALHADOR DE FABRICACAO DE SORVETE",
      "nome_completo_valor_dominio": "TRABALHADOR DE FABRICACAO DE SORVETE",
      "descricao_conceito_valor_dominio": "TRABALHADOR DE FABRICACAO DE SORVETE"
    },
    {
      "codigo_valor_dominio": 3630,
      "codigo_referencia_valor_dominio": "514225",
      "nome_resumido_valor_dominio": "TRABALHADOR DE SERVICOS DE LIMPEZA E CONSERVACAO DE AREAS PU",
      "nome_completo_valor_dominio": "TRABALHADOR DE SERVICOS DE LIMPEZA E CONSERVACAO DE AREAS PUBLICAS",
      "descricao_conceito_valor_dominio": "TRABALHADOR DE SERVICOS DE LIMPEZA E CONSERVACAO DE AREAS PUBLICAS"
    },
    {
      "codigo_valor_dominio": 3631,
      "codigo_referencia_valor_dominio": "765405",
      "nome_resumido_valor_dominio": "TRABALHADOR DO ACABAMENTO DE ARTEFATOS DE TECIDOS E COUROS",
      "nome_completo_valor_dominio": "TRABALHADOR DO ACABAMENTO DE ARTEFATOS DE TECIDOS E COUROS",
      "descricao_conceito_valor_dominio": "TRABALHADOR DO ACABAMENTO DE ARTEFATOS DE TECIDOS E COUROS"
    },
    {
      "codigo_valor_dominio": 3632,
      "codigo_referencia_valor_dominio": "841630",
      "nome_resumido_valor_dominio": "MISTURADOR DE CHA OU MATE",
      "nome_completo_valor_dominio": "MISTURADOR DE CHA OU MATE",
      "descricao_conceito_valor_dominio": "MISTURADOR DE CHA OU MATE"
    },
    {
      "codigo_valor_dominio": 3633,
      "codigo_referencia_valor_dominio": "711330",
      "nome_resumido_valor_dominio": "TORRISTA (PETROLEO)",
      "nome_completo_valor_dominio": "TORRISTA (PETROLEO)",
      "descricao_conceito_valor_dominio": "TORRISTA (PETROLEO)"
    },
    {
      "codigo_valor_dominio": 3634,
      "codigo_referencia_valor_dominio": "841205",
      "nome_resumido_valor_dominio": "MOEDOR DE SAL",
      "nome_completo_valor_dominio": "MOEDOR DE SAL",
      "descricao_conceito_valor_dominio": "MOEDOR DE SAL"
    },
    {
      "codigo_valor_dominio": 3635,
      "codigo_referencia_valor_dominio": "813115",
      "nome_resumido_valor_dominio": "OPERADOR DE EXTRUSORA (QUIMICA, PETROQUIMICA E AFINS)",
      "nome_completo_valor_dominio": "OPERADOR DE EXTRUSORA (QUIMICA, PETROQUIMICA E AFINS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE EXTRUSORA (QUIMICA, PETROQUIMICA E AFINS)"
    },
    {
      "codigo_valor_dominio": 3636,
      "codigo_referencia_valor_dominio": "841610",
      "nome_resumido_valor_dominio": "TORRADOR DE CAFE",
      "nome_completo_valor_dominio": "TORRADOR DE CAFE",
      "descricao_conceito_valor_dominio": "TORRADOR DE CAFE"
    },
    {
      "codigo_valor_dominio": 3637,
      "codigo_referencia_valor_dominio": "782715",
      "nome_resumido_valor_dominio": "MOCO DE CONVES (MARITIMO E FLUVIARIO)",
      "nome_completo_valor_dominio": "MOCO DE CONVES (MARITIMO E FLUVIARIO)",
      "descricao_conceito_valor_dominio": "MOCO DE CONVES (MARITIMO E FLUVIARIO)"
    },
    {
      "codigo_valor_dominio": 3638,
      "codigo_referencia_valor_dominio": "841705",
      "nome_resumido_valor_dominio": "ALAMBIQUEIRO",
      "nome_completo_valor_dominio": "ALAMBIQUEIRO",
      "descricao_conceito_valor_dominio": "ALAMBIQUEIRO"
    },
    {
      "codigo_valor_dominio": 3639,
      "codigo_referencia_valor_dominio": "374410",
      "nome_resumido_valor_dominio": "FINALIZADOR DE FILMES",
      "nome_completo_valor_dominio": "FINALIZADOR DE FILMES",
      "descricao_conceito_valor_dominio": "FINALIZADOR DE FILMES"
    },
    {
      "codigo_valor_dominio": 3640,
      "codigo_referencia_valor_dominio": "721105",
      "nome_resumido_valor_dominio": "FERRAMENTEIRO",
      "nome_completo_valor_dominio": "FERRAMENTEIRO",
      "descricao_conceito_valor_dominio": "FERRAMENTEIRO"
    },
    {
      "codigo_valor_dominio": 3641,
      "codigo_referencia_valor_dominio": "623015",
      "nome_resumido_valor_dominio": "TRABALHADOR DE PECUARIA POLIVALENTE",
      "nome_completo_valor_dominio": "TRABALHADOR DE PECUARIA POLIVALENTE",
      "descricao_conceito_valor_dominio": "TRABALHADOR DE PECUARIA POLIVALENTE"
    },
    {
      "codigo_valor_dominio": 3642,
      "codigo_referencia_valor_dominio": "516120",
      "nome_resumido_valor_dominio": "MANICURE",
      "nome_completo_valor_dominio": "MANICURE",
      "descricao_conceito_valor_dominio": "MANICURE"
    },
    {
      "codigo_valor_dominio": 3643,
      "codigo_referencia_valor_dominio": "841428",
      "nome_resumido_valor_dominio": "COZINHADOR DE PESCADO",
      "nome_completo_valor_dominio": "COZINHADOR DE PESCADO",
      "descricao_conceito_valor_dominio": "COZINHADOR DE PESCADO"
    },
    {
      "codigo_valor_dominio": 3644,
      "codigo_referencia_valor_dominio": "811405",
      "nome_resumido_valor_dominio": "DESTILADOR DE MADEIRA",
      "nome_completo_valor_dominio": "DESTILADOR DE MADEIRA",
      "descricao_conceito_valor_dominio": "DESTILADOR DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 3645,
      "codigo_referencia_valor_dominio": "515120",
      "nome_resumido_valor_dominio": "VISITADOR SANITARIO",
      "nome_completo_valor_dominio": "VISITADOR SANITARIO",
      "descricao_conceito_valor_dominio": "VISITADOR SANITARIO"
    },
    {
      "codigo_valor_dominio": 3646,
      "codigo_referencia_valor_dominio": "514120",
      "nome_resumido_valor_dominio": "ZELADOR DE EDIFICIO",
      "nome_completo_valor_dominio": "ZELADOR DE EDIFICIO",
      "descricao_conceito_valor_dominio": "ZELADOR DE EDIFICIO"
    },
    {
      "codigo_valor_dominio": 3647,
      "codigo_referencia_valor_dominio": "516605",
      "nome_resumido_valor_dominio": "OPERADOR DE FORNO (SERVICOS FUNERARIOS)",
      "nome_completo_valor_dominio": "OPERADOR DE FORNO (SERVICOS FUNERARIOS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE FORNO (SERVICOS FUNERARIOS)"
    },
    {
      "codigo_valor_dominio": 3648,
      "codigo_referencia_valor_dominio": "773510",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINAS DE USINAR MADEIRA (CNC)",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINAS DE USINAR MADEIRA (CNC)",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINAS DE USINAR MADEIRA (CNC)"
    },
    {
      "codigo_valor_dominio": 3649,
      "codigo_referencia_valor_dominio": "841810",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINAS DE FABRICACAO DE DOCES, SALGADOS E MASS",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINAS DE FABRICACAO DE DOCES, SALGADOS E MASS",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINAS DE FABRICACAO DE DOCES, SALGADOS E MASS"
    },
    {
      "codigo_valor_dominio": 3650,
      "codigo_referencia_valor_dominio": "722235",
      "nome_resumido_valor_dominio": "PREPARADOR DE PANELAS (LINGOTAMENTO)",
      "nome_completo_valor_dominio": "PREPARADOR DE PANELAS (LINGOTAMENTO)",
      "descricao_conceito_valor_dominio": "PREPARADOR DE PANELAS (LINGOTAMENTO)"
    },
    {
      "codigo_valor_dominio": 3651,
      "codigo_referencia_valor_dominio": "241210",
      "nome_resumido_valor_dominio": "PROCURADOR AUTARQUICO",
      "nome_completo_valor_dominio": "PROCURADOR AUTARQUICO",
      "descricao_conceito_valor_dominio": "PROCURADOR AUTARQUICO"
    },
    {
      "codigo_valor_dominio": 3652,
      "codigo_referencia_valor_dominio": "842115",
      "nome_resumido_valor_dominio": "CLASSIFICADOR DE FUMO",
      "nome_completo_valor_dominio": "CLASSIFICADOR DE FUMO",
      "descricao_conceito_valor_dominio": "CLASSIFICADOR DE FUMO"
    },
    {
      "codigo_valor_dominio": 3653,
      "codigo_referencia_valor_dominio": "842120",
      "nome_resumido_valor_dominio": "AUXILIAR DE PROCESSAMENTO DE FUMO",
      "nome_completo_valor_dominio": "AUXILIAR DE PROCESSAMENTO DE FUMO",
      "descricao_conceito_valor_dominio": "AUXILIAR DE PROCESSAMENTO DE FUMO"
    },
    {
      "codigo_valor_dominio": 3654,
      "codigo_referencia_valor_dominio": "773405",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA BORDATRIZ",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA BORDATRIZ",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA BORDATRIZ"
    },
    {
      "codigo_valor_dominio": 3655,
      "codigo_referencia_valor_dominio": "811805",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE PRODUTOS FARMACEUTICOS",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE PRODUTOS FARMACEUTICOS",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE PRODUTOS FARMACEUTICOS"
    },
    {
      "codigo_valor_dominio": 3656,
      "codigo_referencia_valor_dominio": "721225",
      "nome_resumido_valor_dominio": "PREPARADOR DE MAQUINAS-FERRAMENTA",
      "nome_completo_valor_dominio": "PREPARADOR DE MAQUINAS-FERRAMENTA",
      "descricao_conceito_valor_dominio": "PREPARADOR DE MAQUINAS-FERRAMENTA"
    },
    {
      "codigo_valor_dominio": 3657,
      "codigo_referencia_valor_dominio": "832115",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINA DE FABRICAR PAPEL (FASE UMIDA)",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINA DE FABRICAR PAPEL (FASE UMIDA)",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINA DE FABRICAR PAPEL (FASE UMIDA)"
    },
    {
      "codigo_valor_dominio": 3658,
      "codigo_referencia_valor_dominio": "842215",
      "nome_resumido_valor_dominio": "CLASSIFICADOR DE CHARUTOS",
      "nome_completo_valor_dominio": "CLASSIFICADOR DE CHARUTOS",
      "descricao_conceito_valor_dominio": "CLASSIFICADOR DE CHARUTOS"
    },
    {
      "codigo_valor_dominio": 3659,
      "codigo_referencia_valor_dominio": "773105",
      "nome_resumido_valor_dominio": "CORTADOR DE LAMINADOS DE MADEIRA",
      "nome_completo_valor_dominio": "CORTADOR DE LAMINADOS DE MADEIRA",
      "descricao_conceito_valor_dominio": "CORTADOR DE LAMINADOS DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 3660,
      "codigo_referencia_valor_dominio": "842225",
      "nome_resumido_valor_dominio": "CELOFANISTA NA FABRICACAO DE CHARUTOS",
      "nome_completo_valor_dominio": "CELOFANISTA NA FABRICACAO DE CHARUTOS",
      "descricao_conceito_valor_dominio": "CELOFANISTA NA FABRICACAO DE CHARUTOS"
    },
    {
      "codigo_valor_dominio": 3661,
      "codigo_referencia_valor_dominio": "842230",
      "nome_resumido_valor_dominio": "CHARUTEIRO A MAO",
      "nome_completo_valor_dominio": "CHARUTEIRO A MAO",
      "descricao_conceito_valor_dominio": "CHARUTEIRO A MAO"
    },
    {
      "codigo_valor_dominio": 3662,
      "codigo_referencia_valor_dominio": "848415",
      "nome_resumido_valor_dominio": "DEGUSTADOR DE DERIVADOS DE CACAU",
      "nome_completo_valor_dominio": "DEGUSTADOR DE DERIVADOS DE CACAU",
      "descricao_conceito_valor_dominio": "DEGUSTADOR DE DERIVADOS DE CACAU"
    },
    {
      "codigo_valor_dominio": 3663,
      "codigo_referencia_valor_dominio": "848405",
      "nome_resumido_valor_dominio": "DEGUSTADOR DE CAFE",
      "nome_completo_valor_dominio": "DEGUSTADOR DE CAFE",
      "descricao_conceito_valor_dominio": "DEGUSTADOR DE CAFE"
    },
    {
      "codigo_valor_dominio": 3664,
      "codigo_referencia_valor_dominio": "848115",
      "nome_resumido_valor_dominio": "SALSICHEIRO (FABRICACAO DE LINGUICA, SALSICHA E PRODUTOS SIM",
      "nome_completo_valor_dominio": "SALSICHEIRO (FABRICACAO DE LINGUICA, SALSICHA E PRODUTOS SIMILARES)",
      "descricao_conceito_valor_dominio": "SALSICHEIRO (FABRICACAO DE LINGUICA, SALSICHA E PRODUTOS SIMILARES)"
    },
    {
      "codigo_valor_dominio": 3665,
      "codigo_referencia_valor_dominio": "517115",
      "nome_resumido_valor_dominio": "SALVA-VIDAS",
      "nome_completo_valor_dominio": "SALVA-VIDAS",
      "descricao_conceito_valor_dominio": "SALVA-VIDAS"
    },
    {
      "codigo_valor_dominio": 3666,
      "codigo_referencia_valor_dominio": "716515",
      "nome_resumido_valor_dominio": "PASTILHEIRO",
      "nome_completo_valor_dominio": "PASTILHEIRO",
      "descricao_conceito_valor_dominio": "PASTILHEIRO"
    },
    {
      "codigo_valor_dominio": 3667,
      "codigo_referencia_valor_dominio": "213205",
      "nome_resumido_valor_dominio": "QUIMICO",
      "nome_completo_valor_dominio": "QUIMICO",
      "descricao_conceito_valor_dominio": "QUIMICO"
    },
    {
      "codigo_valor_dominio": 3668,
      "codigo_referencia_valor_dominio": "991205",
      "nome_resumido_valor_dominio": "MANTENEDOR DE EQUIPAMENTOS DE PARQUES DE DIVERSOES E SIMILAR",
      "nome_completo_valor_dominio": "MANTENEDOR DE EQUIPAMENTOS DE PARQUES DE DIVERSOES E SIMILARES",
      "descricao_conceito_valor_dominio": "MANTENEDOR DE EQUIPAMENTOS DE PARQUES DE DIVERSOES E SIMILARES"
    },
    {
      "codigo_valor_dominio": 3669,
      "codigo_referencia_valor_dominio": "768620",
      "nome_resumido_valor_dominio": "PAGINADOR",
      "nome_completo_valor_dominio": "PAGINADOR",
      "descricao_conceito_valor_dominio": "PAGINADOR"
    },
    {
      "codigo_valor_dominio": 3670,
      "codigo_referencia_valor_dominio": "414215",
      "nome_resumido_valor_dominio": "CONFERENTE DE CARGA E DESCARGA",
      "nome_completo_valor_dominio": "CONFERENTE DE CARGA E DESCARGA",
      "descricao_conceito_valor_dominio": "CONFERENTE DE CARGA E DESCARGA"
    },
    {
      "codigo_valor_dominio": 3671,
      "codigo_referencia_valor_dominio": "322120",
      "nome_resumido_valor_dominio": "MASSOTERAPEUTA",
      "nome_completo_valor_dominio": "MASSOTERAPEUTA",
      "descricao_conceito_valor_dominio": "MASSOTERAPEUTA"
    },
    {
      "codigo_valor_dominio": 3672,
      "codigo_referencia_valor_dominio": "811130",
      "nome_resumido_valor_dominio": "TRABALHADOR DE FABRICACAO DE TINTAS",
      "nome_completo_valor_dominio": "TRABALHADOR DE FABRICACAO DE TINTAS",
      "descricao_conceito_valor_dominio": "TRABALHADOR DE FABRICACAO DE TINTAS"
    },
    {
      "codigo_valor_dominio": 3673,
      "codigo_referencia_valor_dominio": "848410",
      "nome_resumido_valor_dominio": "DEGUSTADOR DE CHA",
      "nome_completo_valor_dominio": "DEGUSTADOR DE CHA",
      "descricao_conceito_valor_dominio": "DEGUSTADOR DE CHA"
    },
    {
      "codigo_valor_dominio": 3674,
      "codigo_referencia_valor_dominio": "842235",
      "nome_resumido_valor_dominio": "DEGUSTADOR DE CHARUTOS",
      "nome_completo_valor_dominio": "DEGUSTADOR DE CHARUTOS",
      "descricao_conceito_valor_dominio": "DEGUSTADOR DE CHARUTOS"
    },
    {
      "codigo_valor_dominio": 3675,
      "codigo_referencia_valor_dominio": "848420",
      "nome_resumido_valor_dominio": "DEGUSTADOR DE VINHOS OU LICORES",
      "nome_completo_valor_dominio": "DEGUSTADOR DE VINHOS OU LICORES",
      "descricao_conceito_valor_dominio": "DEGUSTADOR DE VINHOS OU LICORES"
    },
    {
      "codigo_valor_dominio": 3676,
      "codigo_referencia_valor_dominio": "242305",
      "nome_resumido_valor_dominio": "DELEGADO DE POLICIA",
      "nome_completo_valor_dominio": "DELEGADO DE POLICIA",
      "descricao_conceito_valor_dominio": "DELEGADO DE POLICIA"
    },
    {
      "codigo_valor_dominio": 3677,
      "codigo_referencia_valor_dominio": "848425",
      "nome_resumido_valor_dominio": "CLASSIFICADOR DE GRAOS",
      "nome_completo_valor_dominio": "CLASSIFICADOR DE GRAOS",
      "descricao_conceito_valor_dominio": "CLASSIFICADOR DE GRAOS"
    },
    {
      "codigo_valor_dominio": 3678,
      "codigo_referencia_valor_dominio": "848505",
      "nome_resumido_valor_dominio": "ABATEDOR",
      "nome_completo_valor_dominio": "ABATEDOR",
      "descricao_conceito_valor_dominio": "ABATEDOR"
    },
    {
      "codigo_valor_dominio": 3679,
      "codigo_referencia_valor_dominio": "848510",
      "nome_resumido_valor_dominio": "ACOUGUEIRO",
      "nome_completo_valor_dominio": "ACOUGUEIRO",
      "descricao_conceito_valor_dominio": "ACOUGUEIRO"
    },
    {
      "codigo_valor_dominio": 3680,
      "codigo_referencia_valor_dominio": "342210",
      "nome_resumido_valor_dominio": "DESPACHANTE ADUANEIRO",
      "nome_completo_valor_dominio": "DESPACHANTE ADUANEIRO",
      "descricao_conceito_valor_dominio": "DESPACHANTE ADUANEIRO"
    },
    {
      "codigo_valor_dominio": 3681,
      "codigo_referencia_valor_dominio": "376235",
      "nome_resumido_valor_dominio": "MAGICO",
      "nome_completo_valor_dominio": "MAGICO",
      "descricao_conceito_valor_dominio": "MAGICO"
    },
    {
      "codigo_valor_dominio": 3682,
      "codigo_referencia_valor_dominio": "766415",
      "nome_resumido_valor_dominio": "REVELADOR DE FILMES FOTOGRAFICOS, EM CORES",
      "nome_completo_valor_dominio": "REVELADOR DE FILMES FOTOGRAFICOS, EM CORES",
      "descricao_conceito_valor_dominio": "REVELADOR DE FILMES FOTOGRAFICOS, EM CORES"
    },
    {
      "codigo_valor_dominio": 3683,
      "codigo_referencia_valor_dominio": "623405",
      "nome_resumido_valor_dominio": "TRABALHADOR EM CRIATORIOS DE ANIMAIS PRODUTORES DE VENENO",
      "nome_completo_valor_dominio": "TRABALHADOR EM CRIATORIOS DE ANIMAIS PRODUTORES DE VENENO",
      "descricao_conceito_valor_dominio": "TRABALHADOR EM CRIATORIOS DE ANIMAIS PRODUTORES DE VENENO"
    },
    {
      "codigo_valor_dominio": 3684,
      "codigo_referencia_valor_dominio": "950110",
      "nome_resumido_valor_dominio": "SUPERVISOR DE MANUTENCAO ELETROMECANICA INDUSTRIAL, COMERCIA",
      "nome_completo_valor_dominio": "SUPERVISOR DE MANUTENCAO ELETROMECANICA INDUSTRIAL, COMERCIAL E PREDIAL",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE MANUTENCAO ELETROMECANICA INDUSTRIAL, COMERCIAL E PREDIAL"
    },
    {
      "codigo_valor_dominio": 3685,
      "codigo_referencia_valor_dominio": "860115",
      "nome_resumido_valor_dominio": "SUPERVISOR DE OPERACAO ELETRICA (GERACAO, TRANSMISSAO E DIST",
      "nome_completo_valor_dominio": "SUPERVISOR DE OPERACAO ELETRICA (GERACAO, TRANSMISSAO E DISTRIBUICAO DE ENERGIA ELETRICA)",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE OPERACAO ELETRICA (GERACAO, TRANSMISSAO E DISTRIBUICAO DE ENERGIA ELETRICA)"
    },
    {
      "codigo_valor_dominio": 3686,
      "codigo_referencia_valor_dominio": "342610",
      "nome_resumido_valor_dominio": "SUPERVISOR DE OPERACOES PORTUARIAS",
      "nome_completo_valor_dominio": "SUPERVISOR DE OPERACOES PORTUARIAS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE OPERACOES PORTUARIAS"
    },
    {
      "codigo_valor_dominio": 3687,
      "codigo_referencia_valor_dominio": "861115",
      "nome_resumido_valor_dominio": "OPERADOR DE CENTRAL TERMOELETRICA",
      "nome_completo_valor_dominio": "OPERADOR DE CENTRAL TERMOELETRICA",
      "descricao_conceito_valor_dominio": "OPERADOR DE CENTRAL TERMOELETRICA"
    },
    {
      "codigo_valor_dominio": 3688,
      "codigo_referencia_valor_dominio": "422220",
      "nome_resumido_valor_dominio": "OPERADOR DE RADIO-CHAMADA",
      "nome_completo_valor_dominio": "OPERADOR DE RADIO-CHAMADA",
      "descricao_conceito_valor_dominio": "OPERADOR DE RADIO-CHAMADA"
    },
    {
      "codigo_valor_dominio": 3689,
      "codigo_referencia_valor_dominio": "811305",
      "nome_resumido_valor_dominio": "OPERADOR DE CENTRIFUGADORA (TRATAMENTOS QUIMICOS E AFINS)",
      "nome_completo_valor_dominio": "OPERADOR DE CENTRIFUGADORA (TRATAMENTOS QUIMICOS E AFINS)",
      "descricao_conceito_valor_dominio": "OPERADOR DE CENTRIFUGADORA (TRATAMENTOS QUIMICOS E AFINS)"
    },
    {
      "codigo_valor_dominio": 3690,
      "codigo_referencia_valor_dominio": "832135",
      "nome_resumido_valor_dominio": "OPERADOR DE REBOBINADEIRA NA FABRICACAO DE PAPEL E PAPELAO",
      "nome_completo_valor_dominio": "OPERADOR DE REBOBINADEIRA NA FABRICACAO DE PAPEL E PAPELAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE REBOBINADEIRA NA FABRICACAO DE PAPEL E PAPELAO"
    },
    {
      "codigo_valor_dominio": 3691,
      "codigo_referencia_valor_dominio": "782140",
      "nome_resumido_valor_dominio": "OPERADOR DE TALHA ELETRICA",
      "nome_completo_valor_dominio": "OPERADOR DE TALHA ELETRICA",
      "descricao_conceito_valor_dominio": "OPERADOR DE TALHA ELETRICA"
    },
    {
      "codigo_valor_dominio": 3692,
      "codigo_referencia_valor_dominio": "775110",
      "nome_resumido_valor_dominio": "FOLHEADOR DE MOVEIS DE MADEIRA",
      "nome_completo_valor_dominio": "FOLHEADOR DE MOVEIS DE MADEIRA",
      "descricao_conceito_valor_dominio": "FOLHEADOR DE MOVEIS DE MADEIRA"
    },
    {
      "codigo_valor_dominio": 3693,
      "codigo_referencia_valor_dominio": "374215",
      "nome_resumido_valor_dominio": "MAQUINISTA DE TEATRO E ESPETACULOS",
      "nome_completo_valor_dominio": "MAQUINISTA DE TEATRO E ESPETACULOS",
      "descricao_conceito_valor_dominio": "MAQUINISTA DE TEATRO E ESPETACULOS"
    },
    {
      "codigo_valor_dominio": 3694,
      "codigo_referencia_valor_dominio": "715405",
      "nome_resumido_valor_dominio": "OPERADOR DE BETONEIRA",
      "nome_completo_valor_dominio": "OPERADOR DE BETONEIRA",
      "descricao_conceito_valor_dominio": "OPERADOR DE BETONEIRA"
    },
    {
      "codigo_valor_dominio": 3695,
      "codigo_referencia_valor_dominio": "841456",
      "nome_resumido_valor_dominio": "OPERADOR DE CAMARAS FRIAS",
      "nome_completo_valor_dominio": "OPERADOR DE CAMARAS FRIAS",
      "descricao_conceito_valor_dominio": "OPERADOR DE CAMARAS FRIAS"
    },
    {
      "codigo_valor_dominio": 3696,
      "codigo_referencia_valor_dominio": "317205",
      "nome_resumido_valor_dominio": "OPERADOR DE COMPUTADOR (INCLUSIVE MICROCOMPUTADOR)",
      "nome_completo_valor_dominio": "OPERADOR DE COMPUTADOR (INCLUSIVE MICROCOMPUTADOR)",
      "descricao_conceito_valor_dominio": "OPERADOR DE COMPUTADOR (INCLUSIVE MICROCOMPUTADOR)"
    },
    {
      "codigo_valor_dominio": 3697,
      "codigo_referencia_valor_dominio": "862205",
      "nome_resumido_valor_dominio": "OPERADOR DE ESTACAO DE CAPTACAO, TRATAMENTO E DISTRIBUICAO D",
      "nome_completo_valor_dominio": "OPERADOR DE ESTACAO DE CAPTACAO, TRATAMENTO E DISTRIBUICAO DE AGUA",
      "descricao_conceito_valor_dominio": "OPERADOR DE ESTACAO DE CAPTACAO, TRATAMENTO E DISTRIBUICAO DE AGUA"
    },
    {
      "codigo_valor_dominio": 3698,
      "codigo_referencia_valor_dominio": "642010",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINAS FLORESTAIS ESTATICAS",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINAS FLORESTAIS ESTATICAS",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINAS FLORESTAIS ESTATICAS"
    },
    {
      "codigo_valor_dominio": 3699,
      "codigo_referencia_valor_dominio": "722230",
      "nome_resumido_valor_dominio": "OPERADOR DE VAZAMENTO (LINGOTAMENTO)",
      "nome_completo_valor_dominio": "OPERADOR DE VAZAMENTO (LINGOTAMENTO)",
      "descricao_conceito_valor_dominio": "OPERADOR DE VAZAMENTO (LINGOTAMENTO)"
    },
    {
      "codigo_valor_dominio": 3700,
      "codigo_referencia_valor_dominio": "862305",
      "nome_resumido_valor_dominio": "OPERADOR DE ESTACAO DE TRATAMENTO DE AGUA E EFLUENTES",
      "nome_completo_valor_dominio": "OPERADOR DE ESTACAO DE TRATAMENTO DE AGUA E EFLUENTES",
      "descricao_conceito_valor_dominio": "OPERADOR DE ESTACAO DE TRATAMENTO DE AGUA E EFLUENTES"
    },
    {
      "codigo_valor_dominio": 3701,
      "codigo_referencia_valor_dominio": "811430",
      "nome_resumido_valor_dominio": "OPERADOR DE EVAPORADOR NA DESTILACAO",
      "nome_completo_valor_dominio": "OPERADOR DE EVAPORADOR NA DESTILACAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE EVAPORADOR NA DESTILACAO"
    },
    {
      "codigo_valor_dominio": 3702,
      "codigo_referencia_valor_dominio": "723120",
      "nome_resumido_valor_dominio": "OPERADOR DE FORNO DE TRATAMENTO TERMICO DE METAIS",
      "nome_completo_valor_dominio": "OPERADOR DE FORNO DE TRATAMENTO TERMICO DE METAIS",
      "descricao_conceito_valor_dominio": "OPERADOR DE FORNO DE TRATAMENTO TERMICO DE METAIS"
    },
    {
      "codigo_valor_dominio": 3703,
      "codigo_referencia_valor_dominio": "862505",
      "nome_resumido_valor_dominio": "OPERADOR DE INSTALACAO DE REFRIGERACAO",
      "nome_completo_valor_dominio": "OPERADOR DE INSTALACAO DE REFRIGERACAO",
      "descricao_conceito_valor_dominio": "OPERADOR DE INSTALACAO DE REFRIGERACAO"
    },
    {
      "codigo_valor_dominio": 3704,
      "codigo_referencia_valor_dominio": "821435",
      "nome_resumido_valor_dominio": "OPERADOR DE JATO ABRASIVO",
      "nome_completo_valor_dominio": "OPERADOR DE JATO ABRASIVO",
      "descricao_conceito_valor_dominio": "OPERADOR DE JATO ABRASIVO"
    },
    {
      "codigo_valor_dominio": 3705,
      "codigo_referencia_valor_dominio": "721425",
      "nome_resumido_valor_dominio": "OPERADOR DE RETIFICADORA COM COMANDO NUMERICO",
      "nome_completo_valor_dominio": "OPERADOR DE RETIFICADORA COM COMANDO NUMERICO",
      "descricao_conceito_valor_dominio": "OPERADOR DE RETIFICADORA COM COMANDO NUMERICO"
    },
    {
      "codigo_valor_dominio": 3706,
      "codigo_referencia_valor_dominio": "862405",
      "nome_resumido_valor_dominio": "OPERADOR DE INSTALACAO DE EXTRACAO, PROCESSAMENTO, ENVASAMEN",
      "nome_completo_valor_dominio": "OPERADOR DE INSTALACAO DE EXTRACAO, PROCESSAMENTO, ENVASAMENTO E DISTRIBUICAO DE GASES",
      "descricao_conceito_valor_dominio": "OPERADOR DE INSTALACAO DE EXTRACAO, PROCESSAMENTO, ENVASAMENTO E DISTRIBUICAO DE GASES"
    },
    {
      "codigo_valor_dominio": 3707,
      "codigo_referencia_valor_dominio": "992205",
      "nome_resumido_valor_dominio": "ENCARREGADO GERAL DE OPERACOES DE CONSERVACAO DE VIAS PERMAN",
      "nome_completo_valor_dominio": "ENCARREGADO GERAL DE OPERACOES DE CONSERVACAO DE VIAS PERMANENTES (EXCETO TRILHOS)",
      "descricao_conceito_valor_dominio": "ENCARREGADO GERAL DE OPERACOES DE CONSERVACAO DE VIAS PERMANENTES (EXCETO TRILHOS)"
    },
    {
      "codigo_valor_dominio": 3708,
      "codigo_referencia_valor_dominio": "910115",
      "nome_resumido_valor_dominio": "SUPERVISOR DE MANUTENCAO DE BOMBAS, MOTORES, COMPRESSORES E",
      "nome_completo_valor_dominio": "SUPERVISOR DE MANUTENCAO DE BOMBAS, MOTORES, COMPRESSORES E EQUIPAMENTOS DE TRANSMISSAO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE MANUTENCAO DE BOMBAS, MOTORES, COMPRESSORES E EQUIPAMENTOS DE TRANSMISSAO"
    },
    {
      "codigo_valor_dominio": 3709,
      "codigo_referencia_valor_dominio": "910120",
      "nome_resumido_valor_dominio": "SUPERVISOR DE MANUTENCAO DE MAQUINAS GRAFICAS",
      "nome_completo_valor_dominio": "SUPERVISOR DE MANUTENCAO DE MAQUINAS GRAFICAS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE MANUTENCAO DE MAQUINAS GRAFICAS"
    },
    {
      "codigo_valor_dominio": 3710,
      "codigo_referencia_valor_dominio": "910125",
      "nome_resumido_valor_dominio": "SUPERVISOR DE MANUTENCAO DE MAQUINAS INDUSTRIAIS TEXTEIS",
      "nome_completo_valor_dominio": "SUPERVISOR DE MANUTENCAO DE MAQUINAS INDUSTRIAIS TEXTEIS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE MANUTENCAO DE MAQUINAS INDUSTRIAIS TEXTEIS"
    },
    {
      "codigo_valor_dominio": 3711,
      "codigo_referencia_valor_dominio": "910130",
      "nome_resumido_valor_dominio": "SUPERVISOR DE MANUTENCAO DE MAQUINAS OPERATRIZES E DE USINAG",
      "nome_completo_valor_dominio": "SUPERVISOR DE MANUTENCAO DE MAQUINAS OPERATRIZES E DE USINAGEM",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE MANUTENCAO DE MAQUINAS OPERATRIZES E DE USINAGEM"
    },
    {
      "codigo_valor_dominio": 3712,
      "codigo_referencia_valor_dominio": "910910",
      "nome_resumido_valor_dominio": "SUPERVISOR DE MANUTENCAO DE VIAS FERREAS",
      "nome_completo_valor_dominio": "SUPERVISOR DE MANUTENCAO DE VIAS FERREAS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE MANUTENCAO DE VIAS FERREAS"
    },
    {
      "codigo_valor_dominio": 3713,
      "codigo_referencia_valor_dominio": "910210",
      "nome_resumido_valor_dominio": "SUPERVISOR DA MANUTENCAO E REPARACAO DE VEICULOS PESADOS",
      "nome_completo_valor_dominio": "SUPERVISOR DA MANUTENCAO E REPARACAO DE VEICULOS PESADOS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DA MANUTENCAO E REPARACAO DE VEICULOS PESADOS"
    },
    {
      "codigo_valor_dominio": 3714,
      "codigo_referencia_valor_dominio": "740105",
      "nome_resumido_valor_dominio": "SUPERVISOR DA MECANICA DE PRECISAO",
      "nome_completo_valor_dominio": "SUPERVISOR DA MECANICA DE PRECISAO",
      "descricao_conceito_valor_dominio": "SUPERVISOR DA MECANICA DE PRECISAO"
    },
    {
      "codigo_valor_dominio": 3715,
      "codigo_referencia_valor_dominio": "420130",
      "nome_resumido_valor_dominio": "SUPERVISOR DE TELEFONISTAS",
      "nome_completo_valor_dominio": "SUPERVISOR DE TELEFONISTAS",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE TELEFONISTAS"
    },
    {
      "codigo_valor_dominio": 3716,
      "codigo_referencia_valor_dominio": "950105",
      "nome_resumido_valor_dominio": "SUPERVISOR DE MANUTENCAO ELETRICA DE ALTA TENSAO INDUSTRIAL",
      "nome_completo_valor_dominio": "SUPERVISOR DE MANUTENCAO ELETRICA DE ALTA TENSAO INDUSTRIAL",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE MANUTENCAO ELETRICA DE ALTA TENSAO INDUSTRIAL"
    },
    {
      "codigo_valor_dominio": 3717,
      "codigo_referencia_valor_dominio": "911110",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE BOMBAS",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE BOMBAS",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE BOMBAS"
    },
    {
      "codigo_valor_dominio": 3718,
      "codigo_referencia_valor_dominio": "911115",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE COMPRESSORES DE AR",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE COMPRESSORES DE AR",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE COMPRESSORES DE AR"
    },
    {
      "codigo_valor_dominio": 3719,
      "codigo_referencia_valor_dominio": "914410",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE EMPILHADEIRAS E OUTROS VEICULOS DE",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE EMPILHADEIRAS E OUTROS VEICULOS DE CARGAS LEVES",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE EMPILHADEIRAS E OUTROS VEICULOS DE CARGAS LEVES"
    },
    {
      "codigo_valor_dominio": 3720,
      "codigo_referencia_valor_dominio": "914205",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE MOTORES E EQUIPAMENTOS NAVAIS",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE MOTORES E EQUIPAMENTOS NAVAIS",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE MOTORES E EQUIPAMENTOS NAVAIS"
    },
    {
      "codigo_valor_dominio": 3721,
      "codigo_referencia_valor_dominio": "914110",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE SISTEMA HIDRAULICO DE AERONAVES (S",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE SISTEMA HIDRAULICO DE AERONAVES (SERVICOS DE PISTA E HANGAR)",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE SISTEMA HIDRAULICO DE AERONAVES (SERVICOS DE PISTA E HANGAR)"
    },
    {
      "codigo_valor_dominio": 3722,
      "codigo_referencia_valor_dominio": "911135",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE TURBOCOMPRESSORES",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE TURBOCOMPRESSORES",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE TURBOCOMPRESSORES"
    },
    {
      "codigo_valor_dominio": 3723,
      "codigo_referencia_valor_dominio": "914305",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE VEICULOS FERROVIARIOS",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE VEICULOS FERROVIARIOS",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE VEICULOS FERROVIARIOS"
    },
    {
      "codigo_valor_dominio": 3724,
      "codigo_referencia_valor_dominio": "725705",
      "nome_resumido_valor_dominio": "MECANICO DE REFRIGERACAO",
      "nome_completo_valor_dominio": "MECANICO DE REFRIGERACAO",
      "descricao_conceito_valor_dominio": "MECANICO DE REFRIGERACAO"
    },
    {
      "codigo_valor_dominio": 3725,
      "codigo_referencia_valor_dominio": "911325",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS-FERRAMENTAS (USINAGEM DE",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS-FERRAMENTAS (USINAGEM DE METAIS)",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS-FERRAMENTAS (USINAGEM DE METAIS)"
    },
    {
      "codigo_valor_dominio": 3726,
      "codigo_referencia_valor_dominio": "911315",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS OPERATRIZES (LAVRA DE MAD",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS OPERATRIZES (LAVRA DE MADEIRA)",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS OPERATRIZES (LAVRA DE MADEIRA)"
    },
    {
      "codigo_valor_dominio": 3727,
      "codigo_referencia_valor_dominio": "911320",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS TEXTEIS",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS TEXTEIS",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS TEXTEIS"
    },
    {
      "codigo_valor_dominio": 3728,
      "codigo_referencia_valor_dominio": "911305",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS, EM GERAL",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS, EM GERAL",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS, EM GERAL"
    },
    {
      "codigo_valor_dominio": 3729,
      "codigo_referencia_valor_dominio": "914415",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE MOTOCICLETAS",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE MOTOCICLETAS",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE MOTOCICLETAS"
    },
    {
      "codigo_valor_dominio": 3730,
      "codigo_referencia_valor_dominio": "919305",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE APARELHOS ESPORTIVOS E DE GINASTIC",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE APARELHOS ESPORTIVOS E DE GINASTICA",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE APARELHOS ESPORTIVOS E DE GINASTICA"
    },
    {
      "codigo_valor_dominio": 3731,
      "codigo_referencia_valor_dominio": "954120",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE INSTALACOES MECANICAS DE EDIFICIOS",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE INSTALACOES MECANICAS DE EDIFICIOS",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE INSTALACOES MECANICAS DE EDIFICIOS"
    },
    {
      "codigo_valor_dominio": 3732,
      "codigo_referencia_valor_dominio": "919205",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS CORTADORAS DE GRAMA, ROCA",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS CORTADORAS DE GRAMA, ROCADEIRAS, MOTOSSERRAS E SIMILARES",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS CORTADORAS DE GRAMA, ROCADEIRAS, MOTOSSERRAS E SIMILARES"
    },
    {
      "codigo_valor_dominio": 3733,
      "codigo_referencia_valor_dominio": "911310",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS GRAFICAS",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS GRAFICAS",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS GRAFICAS"
    },
    {
      "codigo_valor_dominio": 3734,
      "codigo_referencia_valor_dominio": "913105",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE APARELHOS DE LEVANTAMENTO",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE APARELHOS DE LEVANTAMENTO",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE APARELHOS DE LEVANTAMENTO"
    },
    {
      "codigo_valor_dominio": 3735,
      "codigo_referencia_valor_dominio": "914420",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE TRATORES",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE TRATORES",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE TRATORES"
    },
    {
      "codigo_valor_dominio": 3736,
      "codigo_referencia_valor_dominio": "911125",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE REDUTORES",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE REDUTORES",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE REDUTORES"
    },
    {
      "codigo_valor_dominio": 3737,
      "codigo_referencia_valor_dominio": "911205",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO E INSTALACAO DE APARELHOS DE CLIMATIZ",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO E INSTALACAO DE APARELHOS DE CLIMATIZACAO E REFRIGERACAO",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO E INSTALACAO DE APARELHOS DE CLIMATIZACAO E REFRIGERACAO"
    },
    {
      "codigo_valor_dominio": 3738,
      "codigo_referencia_valor_dominio": "919310",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE BICICLETAS E VEICULOS SIMILARES",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE BICICLETAS E VEICULOS SIMILARES",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE BICICLETAS E VEICULOS SIMILARES"
    },
    {
      "codigo_valor_dominio": 3739,
      "codigo_referencia_valor_dominio": "913110",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE EQUIPAMENTO DE MINERACAO",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE EQUIPAMENTO DE MINERACAO",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE EQUIPAMENTO DE MINERACAO"
    },
    {
      "codigo_valor_dominio": 3740,
      "codigo_referencia_valor_dominio": "911120",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE MOTORES DIESEL (EXCETO DE VEICULOS",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE MOTORES DIESEL (EXCETO DE VEICULOS AUTOMOTORES)",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE MOTORES DIESEL (EXCETO DE VEICULOS AUTOMOTORES)"
    },
    {
      "codigo_valor_dominio": 3741,
      "codigo_referencia_valor_dominio": "911130",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE TURBINAS (EXCETO DE AERONAVES)",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE TURBINAS (EXCETO DE AERONAVES)",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE TURBINAS (EXCETO DE AERONAVES)"
    },
    {
      "codigo_valor_dominio": 3742,
      "codigo_referencia_valor_dominio": "341115",
      "nome_resumido_valor_dominio": "MECANICO DE VOO",
      "nome_completo_valor_dominio": "MECANICO DE VOO",
      "descricao_conceito_valor_dominio": "MECANICO DE VOO"
    },
    {
      "codigo_valor_dominio": 3743,
      "codigo_referencia_valor_dominio": "314410",
      "nome_resumido_valor_dominio": "TECNICO EM MANUTENCAO DE MAQUINAS",
      "nome_completo_valor_dominio": "TECNICO EM MANUTENCAO DE MAQUINAS",
      "descricao_conceito_valor_dominio": "TECNICO EM MANUTENCAO DE MAQUINAS"
    },
    {
      "codigo_valor_dominio": 3744,
      "codigo_referencia_valor_dominio": "915105",
      "nome_resumido_valor_dominio": "TECNICO EM MANUTENCAO DE INSTRUMENTOS DE MEDICAO E PRECISAO",
      "nome_completo_valor_dominio": "TECNICO EM MANUTENCAO DE INSTRUMENTOS DE MEDICAO E PRECISAO",
      "descricao_conceito_valor_dominio": "TECNICO EM MANUTENCAO DE INSTRUMENTOS DE MEDICAO E PRECISAO"
    },
    {
      "codigo_valor_dominio": 3745,
      "codigo_referencia_valor_dominio": "313220",
      "nome_resumido_valor_dominio": "TECNICO EM MANUTENCAO DE EQUIPAMENTOS DE INFORMATICA",
      "nome_completo_valor_dominio": "TECNICO EM MANUTENCAO DE EQUIPAMENTOS DE INFORMATICA",
      "descricao_conceito_valor_dominio": "TECNICO EM MANUTENCAO DE EQUIPAMENTOS DE INFORMATICA"
    },
    {
      "codigo_valor_dominio": 3746,
      "codigo_referencia_valor_dominio": "768710",
      "nome_resumido_valor_dominio": "RESTAURADOR DE LIVROS",
      "nome_completo_valor_dominio": "RESTAURADOR DE LIVROS",
      "descricao_conceito_valor_dominio": "RESTAURADOR DE LIVROS"
    },
    {
      "codigo_valor_dominio": 3747,
      "codigo_referencia_valor_dominio": "954210",
      "nome_resumido_valor_dominio": "REPARADOR DE RADIO, TV E SOM",
      "nome_completo_valor_dominio": "REPARADOR DE RADIO, TV E SOM",
      "descricao_conceito_valor_dominio": "REPARADOR DE RADIO, TV E SOM"
    },
    {
      "codigo_valor_dominio": 3748,
      "codigo_referencia_valor_dominio": "722310",
      "nome_resumido_valor_dominio": "MACHEIRO, A MAQUINA",
      "nome_completo_valor_dominio": "MACHEIRO, A MAQUINA",
      "descricao_conceito_valor_dominio": "MACHEIRO, A MAQUINA"
    },
    {
      "codigo_valor_dominio": 3749,
      "codigo_referencia_valor_dominio": "915110",
      "nome_resumido_valor_dominio": "TECNICO EM MANUTENCAO DE HIDROMETROS",
      "nome_completo_valor_dominio": "TECNICO EM MANUTENCAO DE HIDROMETROS",
      "descricao_conceito_valor_dominio": "TECNICO EM MANUTENCAO DE HIDROMETROS"
    },
    {
      "codigo_valor_dominio": 3750,
      "codigo_referencia_valor_dominio": "915210",
      "nome_resumido_valor_dominio": "REPARADOR DE INSTRUMENTOS MUSICAIS",
      "nome_completo_valor_dominio": "REPARADOR DE INSTRUMENTOS MUSICAIS",
      "descricao_conceito_valor_dominio": "REPARADOR DE INSTRUMENTOS MUSICAIS"
    },
    {
      "codigo_valor_dominio": 3751,
      "codigo_referencia_valor_dominio": "224110",
      "nome_resumido_valor_dominio": "LUDOMOTRICISTA",
      "nome_completo_valor_dominio": "LUDOMOTRICISTA",
      "descricao_conceito_valor_dominio": "LUDOMOTRICISTA"
    },
    {
      "codigo_valor_dominio": 3752,
      "codigo_referencia_valor_dominio": "919105",
      "nome_resumido_valor_dominio": "LUBRIFICADOR INDUSTRIAL",
      "nome_completo_valor_dominio": "LUBRIFICADOR INDUSTRIAL",
      "descricao_conceito_valor_dominio": "LUBRIFICADOR INDUSTRIAL"
    },
    {
      "codigo_valor_dominio": 3753,
      "codigo_referencia_valor_dominio": "919110",
      "nome_resumido_valor_dominio": "LUBRIFICADOR DE VEICULOS AUTOMOTORES (EXCETO EMBARCACOES)",
      "nome_completo_valor_dominio": "LUBRIFICADOR DE VEICULOS AUTOMOTORES (EXCETO EMBARCACOES)",
      "descricao_conceito_valor_dominio": "LUBRIFICADOR DE VEICULOS AUTOMOTORES (EXCETO EMBARCACOES)"
    },
    {
      "codigo_valor_dominio": 3754,
      "codigo_referencia_valor_dominio": "913120",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS DE CONSTRUCAO E TERRAPLEN",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS DE CONSTRUCAO E TERRAPLENAGEM",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS DE CONSTRUCAO E TERRAPLENAGEM"
    },
    {
      "codigo_valor_dominio": 3755,
      "codigo_referencia_valor_dominio": "914405",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE AUTOMOVEIS, MOTOCICLETAS E VEICULO",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE AUTOMOVEIS, MOTOCICLETAS E VEICULOS SIMILARES",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE AUTOMOVEIS, MOTOCICLETAS E VEICULOS SIMILARES"
    },
    {
      "codigo_valor_dominio": 3756,
      "codigo_referencia_valor_dominio": "911105",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE BOMBA INJETORA (EXCETO DE VEICULOS",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE BOMBA INJETORA (EXCETO DE VEICULOS AUTOMOTORES)",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE BOMBA INJETORA (EXCETO DE VEICULOS AUTOMOTORES)"
    },
    {
      "codigo_valor_dominio": 3757,
      "codigo_referencia_valor_dominio": "764210",
      "nome_resumido_valor_dominio": "MONTADOR DE CALCADOS",
      "nome_completo_valor_dominio": "MONTADOR DE CALCADOS",
      "descricao_conceito_valor_dominio": "MONTADOR DE CALCADOS"
    },
    {
      "codigo_valor_dominio": 3758,
      "codigo_referencia_valor_dominio": "950305",
      "nome_resumido_valor_dominio": "SUPERVISOR DE MANUTENCAO ELETROMECANICA",
      "nome_completo_valor_dominio": "SUPERVISOR DE MANUTENCAO ELETROMECANICA",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE MANUTENCAO ELETROMECANICA"
    },
    {
      "codigo_valor_dominio": 3759,
      "codigo_referencia_valor_dominio": "730105",
      "nome_resumido_valor_dominio": "SUPERVISOR DE MONTAGEM E INSTALACAO ELETROELETRONICA",
      "nome_completo_valor_dominio": "SUPERVISOR DE MONTAGEM E INSTALACAO ELETROELETRONICA",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE MONTAGEM E INSTALACAO ELETROELETRONICA"
    },
    {
      "codigo_valor_dominio": 3760,
      "codigo_referencia_valor_dominio": "910105",
      "nome_resumido_valor_dominio": "ENCARREGADO DE MANUTENCAO MECANICA DE SISTEMAS OPERACIONAIS",
      "nome_completo_valor_dominio": "ENCARREGADO DE MANUTENCAO MECANICA DE SISTEMAS OPERACIONAIS",
      "descricao_conceito_valor_dominio": "ENCARREGADO DE MANUTENCAO MECANICA DE SISTEMAS OPERACIONAIS"
    },
    {
      "codigo_valor_dominio": 3761,
      "codigo_referencia_valor_dominio": "860105",
      "nome_resumido_valor_dominio": "SUPERVISOR DE MANUTENCAO ELETROMECANICA (UTILIDADES)",
      "nome_completo_valor_dominio": "SUPERVISOR DE MANUTENCAO ELETROMECANICA (UTILIDADES)",
      "descricao_conceito_valor_dominio": "SUPERVISOR DE MANUTENCAO ELETROMECANICA (UTILIDADES)"
    },
    {
      "codigo_valor_dominio": 3762,
      "codigo_referencia_valor_dominio": "954105",
      "nome_resumido_valor_dominio": "ELETROMECANICO DE MANUTENCAO DE ELEVADORES",
      "nome_completo_valor_dominio": "ELETROMECANICO DE MANUTENCAO DE ELEVADORES",
      "descricao_conceito_valor_dominio": "ELETROMECANICO DE MANUTENCAO DE ELEVADORES"
    },
    {
      "codigo_valor_dominio": 3763,
      "codigo_referencia_valor_dominio": "523110",
      "nome_resumido_valor_dominio": "INSTALADOR DE SOM E ACESSORIOS DE VEICULOS",
      "nome_completo_valor_dominio": "INSTALADOR DE SOM E ACESSORIOS DE VEICULOS",
      "descricao_conceito_valor_dominio": "INSTALADOR DE SOM E ACESSORIOS DE VEICULOS"
    },
    {
      "codigo_valor_dominio": 3764,
      "codigo_referencia_valor_dominio": "771115",
      "nome_resumido_valor_dominio": "MAQUETISTA NA MARCENARIA",
      "nome_completo_valor_dominio": "MAQUETISTA NA MARCENARIA",
      "descricao_conceito_valor_dominio": "MAQUETISTA NA MARCENARIA"
    },
    {
      "codigo_valor_dominio": 3765,
      "codigo_referencia_valor_dominio": "715605",
      "nome_resumido_valor_dominio": "ELETRICISTA DE INSTALACOES (CENARIOS)",
      "nome_completo_valor_dominio": "ELETRICISTA DE INSTALACOES (CENARIOS)",
      "descricao_conceito_valor_dominio": "ELETRICISTA DE INSTALACOES (CENARIOS)"
    },
    {
      "codigo_valor_dominio": 3766,
      "codigo_referencia_valor_dominio": "953115",
      "nome_resumido_valor_dominio": "ELETRICISTA DE INSTALACOES (VEICULOS AUTOMOTORES E MAQUINAS",
      "nome_completo_valor_dominio": "ELETRICISTA DE INSTALACOES (VEICULOS AUTOMOTORES E MAQUINAS OPERATRIZES, EXCETO AERONAVES E SIMILARES)",
      "descricao_conceito_valor_dominio": "ELETRICISTA DE INSTALACOES (VEICULOS AUTOMOTORES E MAQUINAS OPERATRIZES, EXCETO AERONAVES E SIMILARES)"
    },
    {
      "codigo_valor_dominio": 3767,
      "codigo_referencia_valor_dominio": "732105",
      "nome_resumido_valor_dominio": "ELETRICISTA DE MANUTENCAO DE LINHAS ELETRICAS, TELEFONICAS E",
      "nome_completo_valor_dominio": "ELETRICISTA DE MANUTENCAO DE LINHAS ELETRICAS, TELEFONICAS E DE COMUNICACAO DE DADOS",
      "descricao_conceito_valor_dominio": "ELETRICISTA DE MANUTENCAO DE LINHAS ELETRICAS, TELEFONICAS E DE COMUNICACAO DE DADOS"
    },
    {
      "codigo_valor_dominio": 3768,
      "codigo_referencia_valor_dominio": "954110",
      "nome_resumido_valor_dominio": "ELETROMECANICO DE MANUTENCAO DE ESCADAS ROLANTES",
      "nome_completo_valor_dominio": "ELETROMECANICO DE MANUTENCAO DE ESCADAS ROLANTES",
      "descricao_conceito_valor_dominio": "ELETROMECANICO DE MANUTENCAO DE ESCADAS ROLANTES"
    },
    {
      "codigo_valor_dominio": 3769,
      "codigo_referencia_valor_dominio": "954115",
      "nome_resumido_valor_dominio": "ELETROMECANICO DE MANUTENCAO DE PORTAS AUTOMATICAS",
      "nome_completo_valor_dominio": "ELETROMECANICO DE MANUTENCAO DE PORTAS AUTOMATICAS",
      "descricao_conceito_valor_dominio": "ELETROMECANICO DE MANUTENCAO DE PORTAS AUTOMATICAS"
    },
    {
      "codigo_valor_dominio": 3770,
      "codigo_referencia_valor_dominio": "313105",
      "nome_resumido_valor_dominio": "ELETROTECNICO",
      "nome_completo_valor_dominio": "ELETROTECNICO",
      "descricao_conceito_valor_dominio": "ELETROTECNICO"
    },
    {
      "codigo_valor_dominio": 3771,
      "codigo_referencia_valor_dominio": "913115",
      "nome_resumido_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS AGRICOLAS",
      "nome_completo_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS AGRICOLAS",
      "descricao_conceito_valor_dominio": "MECANICO DE MANUTENCAO DE MAQUINAS AGRICOLAS"
    },
    {
      "codigo_valor_dominio": 3772,
      "codigo_referencia_valor_dominio": "761005",
      "nome_resumido_valor_dominio": "OPERADOR POLIVALENTE DA INDUSTRIA TEXTIL",
      "nome_completo_valor_dominio": "OPERADOR POLIVALENTE DA INDUSTRIA TEXTIL",
      "descricao_conceito_valor_dominio": "OPERADOR POLIVALENTE DA INDUSTRIA TEXTIL"
    },
    {
      "codigo_valor_dominio": 3773,
      "codigo_referencia_valor_dominio": "954305",
      "nome_resumido_valor_dominio": "REPARADOR DE EQUIPAMENTOS DE ESCRITORIO",
      "nome_completo_valor_dominio": "REPARADOR DE EQUIPAMENTOS DE ESCRITORIO",
      "descricao_conceito_valor_dominio": "REPARADOR DE EQUIPAMENTOS DE ESCRITORIO"
    },
    {
      "codigo_valor_dominio": 3774,
      "codigo_referencia_valor_dominio": "261135",
      "nome_resumido_valor_dominio": "REPORTER (EXCLUSIVE RADIO E TELEVISAO)",
      "nome_completo_valor_dominio": "REPORTER (EXCLUSIVE RADIO E TELEVISAO)",
      "descricao_conceito_valor_dominio": "REPORTER (EXCLUSIVE RADIO E TELEVISAO)"
    },
    {
      "codigo_valor_dominio": 3775,
      "codigo_referencia_valor_dominio": "915405",
      "nome_resumido_valor_dominio": "REPARADOR DE EQUIPAMENTOS FOTOGRAFICOS",
      "nome_completo_valor_dominio": "REPARADOR DE EQUIPAMENTOS FOTOGRAFICOS",
      "descricao_conceito_valor_dominio": "REPARADOR DE EQUIPAMENTOS FOTOGRAFICOS"
    },
    {
      "codigo_valor_dominio": 3776,
      "codigo_referencia_valor_dominio": "262415",
      "nome_resumido_valor_dominio": "CONSERVADOR-RESTAURADOR DE BENS CULTURAIS",
      "nome_completo_valor_dominio": "CONSERVADOR-RESTAURADOR DE BENS CULTURAIS",
      "descricao_conceito_valor_dominio": "CONSERVADOR-RESTAURADOR DE BENS CULTURAIS"
    },
    {
      "codigo_valor_dominio": 3777,
      "codigo_referencia_valor_dominio": "215135",
      "nome_resumido_valor_dominio": "INSPETOR NAVAL",
      "nome_completo_valor_dominio": "INSPETOR NAVAL",
      "descricao_conceito_valor_dominio": "INSPETOR NAVAL"
    },
    {
      "codigo_valor_dominio": 3778,
      "codigo_referencia_valor_dominio": "862150",
      "nome_resumido_valor_dominio": "OPERADOR DE MAQUINAS FIXAS, EM GERAL",
      "nome_completo_valor_dominio": "OPERADOR DE MAQUINAS FIXAS, EM GERAL",
      "descricao_conceito_valor_dominio": "OPERADOR DE MAQUINAS FIXAS, EM GERAL"
    },
    {
      "codigo_valor_dominio": 3779,
      "codigo_referencia_valor_dominio": "724325",
      "nome_resumido_valor_dominio": "SOLDADOR ELETRICO",
      "nome_completo_valor_dominio": "SOLDADOR ELETRICO",
      "descricao_conceito_valor_dominio": "SOLDADOR ELETRICO"
    },
    {
      "codigo_valor_dominio": 3780,
      "codigo_referencia_valor_dominio": "951310",
      "nome_resumido_valor_dominio": "MANTENEDOR DE SISTEMAS ELETROELETRONICOS DE SEGURANCA",
      "nome_completo_valor_dominio": "MANTENEDOR DE SISTEMAS ELETROELETRONICOS DE SEGURANCA",
      "descricao_conceito_valor_dominio": "MANTENEDOR DE SISTEMAS ELETROELETRONICOS DE SEGURANCA"
    },
    {
      "codigo_valor_dominio": 3781,
      "codigo_referencia_valor_dominio": "724435",
      "nome_resumido_valor_dominio": "FUNILEIRO INDUSTRIAL",
      "nome_completo_valor_dominio": "FUNILEIRO INDUSTRIAL",
      "descricao_conceito_valor_dominio": "FUNILEIRO INDUSTRIAL"
    },
    {
      "codigo_valor_dominio": 3782,
      "codigo_referencia_valor_dominio": "513110",
      "nome_resumido_valor_dominio": "MORDOMO DE HOTELARIA",
      "nome_completo_valor_dominio": "MORDOMO DE HOTELARIA",
      "descricao_conceito_valor_dominio": "MORDOMO DE HOTELARIA"
    },
    {
      "codigo_valor_dominio": 3783,
      "codigo_referencia_valor_dominio": "723325",
      "nome_resumido_valor_dominio": "PINTOR POR IMERSAO",
      "nome_completo_valor_dominio": "PINTOR POR IMERSAO",
      "descricao_conceito_valor_dominio": "PINTOR POR IMERSAO"
    },
    {
      "codigo_valor_dominio": 3784,
      "codigo_referencia_valor_dominio": "992105",
      "nome_resumido_valor_dominio": "ALINHADOR DE PNEUS",
      "nome_completo_valor_dominio": "ALINHADOR DE PNEUS",
      "descricao_conceito_valor_dominio": "ALINHADOR DE PNEUS"
    },
    {
      "codigo_valor_dominio": 3785,
      "codigo_referencia_valor_dominio": "992110",
      "nome_resumido_valor_dominio": "BALANCEADOR",
      "nome_completo_valor_dominio": "BALANCEADOR",
      "descricao_conceito_valor_dominio": "BALANCEADOR"
    },
    {
      "codigo_valor_dominio": 3786,
      "codigo_referencia_valor_dominio": "992115",
      "nome_resumido_valor_dominio": "BORRACHEIRO",
      "nome_completo_valor_dominio": "BORRACHEIRO",
      "descricao_conceito_valor_dominio": "BORRACHEIRO"
    },
    {
      "codigo_valor_dominio": 3787,
      "codigo_referencia_valor_dominio": "516405",
      "nome_resumido_valor_dominio": "LAVADOR DE ROUPAS",
      "nome_completo_valor_dominio": "LAVADOR DE ROUPAS",
      "descricao_conceito_valor_dominio": "LAVADOR DE ROUPAS"
    },
    {
      "codigo_valor_dominio": 3788,
      "codigo_referencia_valor_dominio": "223505",
      "nome_resumido_valor_dominio": "ENFERMEIRO",
      "nome_completo_valor_dominio": "ENFERMEIRO",
      "descricao_conceito_valor_dominio": "ENFERMEIRO"
    },
    {
      "codigo_valor_dominio": 3789,
      "codigo_referencia_valor_dominio": "313415",
      "nome_resumido_valor_dominio": "ENCARREGADO DE MANUTENCAO DE INSTRUMENTOS DE CONTROLE, MEDIC",
      "nome_completo_valor_dominio": "ENCARREGADO DE MANUTENCAO DE INSTRUMENTOS DE CONTROLE, MEDICAO E SIMILARES",
      "descricao_conceito_valor_dominio": "ENCARREGADO DE MANUTENCAO DE INSTRUMENTOS DE CONTROLE, MEDICAO E SIMILARES"
    },
    {
      "codigo_valor_dominio": 3790,
      "codigo_referencia_valor_dominio": "715415",
      "nome_resumido_valor_dominio": "OPERADOR DE CENTRAL DE CONCRETO",
      "nome_completo_valor_dominio": "OPERADOR DE CENTRAL DE CONCRETO",
      "descricao_conceito_valor_dominio": "OPERADOR DE CENTRAL DE CONCRETO"
    },
    {
      "codigo_valor_dominio": 3791,
      "codigo_referencia_valor_dominio": "715230",
      "nome_resumido_valor_dominio": "PEDREIRO DE EDIFICACOES",
      "nome_completo_valor_dominio": "PEDREIRO DE EDIFICACOES",
      "descricao_conceito_valor_dominio": "PEDREIRO DE EDIFICACOES"
    },
    {
      "codigo_valor_dominio": 3792,
      "codigo_referencia_valor_dominio": "992225",
      "nome_resumido_valor_dominio": "AUXILIAR GERAL DE CONSERVACAO DE VIAS PERMANENTES (EXCETO TR",
      "nome_completo_valor_dominio": "AUXILIAR GERAL DE CONSERVACAO DE VIAS PERMANENTES (EXCETO TRILHOS)",
      "descricao_conceito_valor_dominio": "AUXILIAR GERAL DE CONSERVACAO DE VIAS PERMANENTES (EXCETO TRILHOS)"
    },
    {
      "codigo_valor_dominio": 9654,
      "codigo_referencia_valor_dominio": "776415",
      "nome_resumido_valor_dominio": "CONFECCIONADOR DE ESCOVAS, PINCEIS E PRODUTOS SIMILARES (A",
      "nome_completo_valor_dominio": "CONFECCIONADOR DE ESCOVAS, PINCEIS E PRODUTOS SIMILARES (A MAQUINA)",
      "descricao_conceito_valor_dominio": "CONFECCIONADOR DE ESCOVAS, PINCEIS E PRODUTOS SIMILARES (A MAQUINA)"
    }
  ]
}